import zIndexMUI from '@material-ui/core/styles/zIndex';
import styled, { css, createGlobalStyle, keyframes } from 'styled-components';
import * as React from 'react';
import React__default, { Children, isValidElement, useState, useEffect, forwardRef, cloneElement, useRef, useCallback, memo, useReducer, useLayoutEffect, createElement, Component, createRef, useMemo, useImperativeHandle, Fragment as Fragment$2 } from 'react';
import Tooltip$1 from '@material-ui/core/Tooltip';
import { makeStyles as makeStyles$1, Popper as Popper$1, ClickAwayListener as ClickAwayListener$1, Grow, Fade, withStyles as withStyles$1, createStyles as createStyles$1, Switch as Switch$2, Tabs as Tabs$1, Tab, Avatar as Avatar$1 } from '@material-ui/core';
import { makeStyles, createStyles, withStyles as withStyles$2, fade, useTheme } from '@material-ui/core/styles';
import { space, color, typography, layout, flexbox } from 'styled-system';
import ClickAwayListener from '@material-ui/core/ClickAwayListener';
import Collapse from '@material-ui/core/Collapse';
import * as ReactDOM from 'react-dom';
import ReactDOM__default, { findDOMNode } from 'react-dom';
import MaterialModal from '@material-ui/core/Modal';
import Backdrop from '@material-ui/core/Backdrop';
import Menu$1 from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import withStyles from '@material-ui/core/styles/withStyles';
import { renderToString } from 'react-dom/server';
import { unstable_useId, useControlled, useEventCallback, setRef as setRef$1, createSvgIcon, capitalize } from '@material-ui/core/utils';
import Popper$2 from '@material-ui/core/Popper';
import ButtonBase from '@material-ui/core/ButtonBase';
import Slider$3 from '@material-ui/core/Slider';
import Avatar from '@material-ui/core/Avatar';
import SwipeableDrawer$1 from '@material-ui/core/SwipeableDrawer';

// eslint-disable-next-line no-shadow
var Colors;
(function (Colors) {
    Colors["purple100"] = "#F5F0F9";
    Colors["purple200"] = "#decfec";
    Colors["purple300"] = "#c4a9dc";
    Colors["purple400"] = "#a881cc";
    Colors["purple500"] = "#8e5bbd";
    Colors["purple600"] = "#7537ae";
    Colors["purple700"] = "#632f94";
    Colors["purple800"] = "#53277c";
    Colors["purple900"] = "#431f63";
    Colors["purple1000"] = "#35194e";
    Colors["blue100"] = "#EFF7FF";
    Colors["blue200"] = "#D8EAFE";
    Colors["blue400"] = "#97BDE6";
    Colors["blue500"] = "#9773CF";
    Colors["blue700"] = "#3972B2";
    Colors["blue800"] = "#224ca0";
    Colors["green100"] = "#F0FFF3";
    Colors["green200"] = "#CEEFD7";
    Colors["green400"] = "#7FCB96";
    Colors["green500"] = "#49AB6B";
    Colors["green700"] = "#348A56";
    Colors["yellow100"] = "#FFFAEF";
    Colors["yellow200"] = "#FAECD5";
    Colors["yellow400"] = "#EBC087";
    Colors["yellow500"] = "#E59C53";
    Colors["yellow700"] = "#CF7E38";
    Colors["red100"] = "#FFF5F5";
    Colors["red400"] = "#E69293";
    Colors["red700"] = "#CB404C";
    Colors["red800"] = "#A8242F";
    Colors["grey100"] = "#F6F6F8";
    Colors["grey200"] = "#E9E7EF";
    Colors["grey400"] = "#CAC8D2";
    Colors["grey700"] = "#7A7388";
    Colors["grey800"] = "#595066";
    Colors["grey900"] = "#413A4F";
    Colors["white"] = "#FFFFFF";
})(Colors || (Colors = {}));

function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function (n) {
    for (var e = 1; e < arguments.length; e++) {
      var t = arguments[e];
      for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]);
    }
    return n;
  }, _extends.apply(null, arguments);
}

function _assertThisInitialized$2(e) {
  if (void 0 === e) throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  return e;
}

function _setPrototypeOf$2(t, e) {
  return _setPrototypeOf$2 = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function (t, e) {
    return t.__proto__ = e, t;
  }, _setPrototypeOf$2(t, e);
}

function _inheritsLoose$1(t, o) {
  t.prototype = Object.create(o.prototype), t.prototype.constructor = t, _setPrototypeOf$2(t, o);
}

function _getPrototypeOf$1(t) {
  return _getPrototypeOf$1 = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function (t) {
    return t.__proto__ || Object.getPrototypeOf(t);
  }, _getPrototypeOf$1(t);
}

function _isNativeFunction(t) {
  try {
    return -1 !== Function.toString.call(t).indexOf("[native code]");
  } catch (n) {
    return "function" == typeof t;
  }
}

function _isNativeReflectConstruct$1() {
  try {
    var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {}));
  } catch (t) {}
  return (_isNativeReflectConstruct$1 = function _isNativeReflectConstruct() {
    return !!t;
  })();
}

function _construct(t, e, r) {
  if (_isNativeReflectConstruct$1()) return Reflect.construct.apply(null, arguments);
  var o = [null];
  o.push.apply(o, e);
  var p = new (t.bind.apply(t, o))();
  return r && _setPrototypeOf$2(p, r.prototype), p;
}

function _wrapNativeSuper(t) {
  var r = "function" == typeof Map ? new Map() : void 0;
  return _wrapNativeSuper = function _wrapNativeSuper(t) {
    if (null === t || !_isNativeFunction(t)) return t;
    if ("function" != typeof t) throw new TypeError("Super expression must either be null or a function");
    if (void 0 !== r) {
      if (r.has(t)) return r.get(t);
      r.set(t, Wrapper);
    }
    function Wrapper() {
      return _construct(t, arguments, _getPrototypeOf$1(this).constructor);
    }
    return Wrapper.prototype = Object.create(t.prototype, {
      constructor: {
        value: Wrapper,
        enumerable: !1,
        writable: !0,
        configurable: !0
      }
    }), _setPrototypeOf$2(Wrapper, t);
  }, _wrapNativeSuper(t);
}

function last() {
  var _ref;
  return _ref = arguments.length - 1, _ref < 0 || arguments.length <= _ref ? undefined : arguments[_ref];
}
function negation(a) {
  return -a;
}
function addition(a, b) {
  return a + b;
}
function subtraction(a, b) {
  return a - b;
}
function multiplication(a, b) {
  return a * b;
}
function division(a, b) {
  return a / b;
}
function max$2() {
  return Math.max.apply(Math, arguments);
}
function min$2() {
  return Math.min.apply(Math, arguments);
}
function comma() {
  return Array.of.apply(Array, arguments);
}
var defaultSymbols = {
  symbols: {
    '*': {
      infix: {
        symbol: '*',
        f: multiplication,
        notation: 'infix',
        precedence: 4,
        rightToLeft: 0,
        argCount: 2
      },
      symbol: '*',
      regSymbol: '\\*'
    },
    '/': {
      infix: {
        symbol: '/',
        f: division,
        notation: 'infix',
        precedence: 4,
        rightToLeft: 0,
        argCount: 2
      },
      symbol: '/',
      regSymbol: '/'
    },
    '+': {
      infix: {
        symbol: '+',
        f: addition,
        notation: 'infix',
        precedence: 2,
        rightToLeft: 0,
        argCount: 2
      },
      prefix: {
        symbol: '+',
        f: last,
        notation: 'prefix',
        precedence: 3,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: '+',
      regSymbol: '\\+'
    },
    '-': {
      infix: {
        symbol: '-',
        f: subtraction,
        notation: 'infix',
        precedence: 2,
        rightToLeft: 0,
        argCount: 2
      },
      prefix: {
        symbol: '-',
        f: negation,
        notation: 'prefix',
        precedence: 3,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: '-',
      regSymbol: '-'
    },
    ',': {
      infix: {
        symbol: ',',
        f: comma,
        notation: 'infix',
        precedence: 1,
        rightToLeft: 0,
        argCount: 2
      },
      symbol: ',',
      regSymbol: ','
    },
    '(': {
      prefix: {
        symbol: '(',
        f: last,
        notation: 'prefix',
        precedence: 0,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: '(',
      regSymbol: '\\('
    },
    ')': {
      postfix: {
        symbol: ')',
        f: undefined,
        notation: 'postfix',
        precedence: 0,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: ')',
      regSymbol: '\\)'
    },
    min: {
      func: {
        symbol: 'min',
        f: min$2,
        notation: 'func',
        precedence: 0,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: 'min',
      regSymbol: 'min\\b'
    },
    max: {
      func: {
        symbol: 'max',
        f: max$2,
        notation: 'func',
        precedence: 0,
        rightToLeft: 0,
        argCount: 1
      },
      symbol: 'max',
      regSymbol: 'max\\b'
    }
  }
};
var defaultSymbolMap = defaultSymbols;

// based on https://github.com/styled-components/styled-components/blob/fcf6f3804c57a14dd7984dfab7bc06ee2edca044/src/utils/error.js
/**
 * Parse errors.md and turn it into a simple hash of code: message
 * @private
 */
var ERRORS = {
  "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
  "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
  "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
  "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
  "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
  "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
  "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
  "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
  "9": "Please provide a number of steps to the modularScale helper.\n\n",
  "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "11": "Invalid value passed as base to modularScale, expected number or em string but got \"%s\"\n\n",
  "12": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got \"%s\" instead.\n\n",
  "13": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got \"%s\" instead.\n\n",
  "14": "Passed invalid pixel value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "15": "Passed invalid base value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "16": "You must provide a template to this method.\n\n",
  "17": "You passed an unsupported selector state to this method.\n\n",
  "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "23": "fontFace expects a name of a font-family.\n\n",
  "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "25": "fontFace expects localFonts to be an array.\n\n",
  "26": "fontFace expects fileFormats to be an array.\n\n",
  "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
  "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
  "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
  "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "35": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "36": "Property must be a string value.\n\n",
  "37": "Syntax Error at %s.\n\n",
  "38": "Formula contains a function that needs parentheses at %s.\n\n",
  "39": "Formula is missing closing parenthesis at %s.\n\n",
  "40": "Formula has too many closing parentheses at %s.\n\n",
  "41": "All values in a formula must have the same unit or be unitless.\n\n",
  "42": "Please provide a number of steps to the modularScale helper.\n\n",
  "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
  "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
  "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
  "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
  "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
  "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "53": "fontFace expects localFonts to be an array.\n\n",
  "54": "fontFace expects fileFormats to be an array.\n\n",
  "55": "fontFace expects a name of a font-family.\n\n",
  "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
  "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "61": "Property must be a string value.\n\n",
  "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "63": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
  "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
  "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
  "67": "You must provide a template to this method.\n\n",
  "68": "You passed an unsupported selector state to this method.\n\n",
  "69": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got %s instead.\n\n",
  "70": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got %s instead.\n\n",
  "71": "Passed invalid pixel value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
  "72": "Passed invalid base value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
  "73": "Please provide a valid CSS variable.\n\n",
  "74": "CSS variable not found and no default was provided.\n\n",
  "75": "important requires a valid style object, got a %s instead.\n\n",
  "76": "fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.\n\n",
  "77": "remToPx expects a value in \"rem\" but you provided it in \"%s\".\n\n",
  "78": "base must be set in \"px\" or \"%\" but you set it in \"%s\".\n"
};

/**
 * super basic version of sprintf
 * @private
 */
function format$1() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var a = args[0];
  var b = [];
  var c;
  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }
  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });
  return a;
}

/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 * @private
 */
var PolishedError = /*#__PURE__*/function (_Error) {
  _inheritsLoose$1(PolishedError, _Error);
  function PolishedError(code) {
    var _this;
    if (process.env.NODE_ENV === 'production') {
      _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
    } else {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      _this = _Error.call(this, format$1.apply(void 0, [ERRORS[code]].concat(args))) || this;
    }
    return _assertThisInitialized$2(_this);
  }
  return PolishedError;
}( /*#__PURE__*/_wrapNativeSuper(Error));

var unitRegExp = /((?!\w)a|na|hc|mc|dg|me[r]?|xe|ni(?![a-zA-Z])|mm|cp|tp|xp|q(?!s)|hv|xamv|nimv|wv|sm|s(?!\D|$)|ged|darg?|nrut)/g;

// Merges additional math functionality into the defaults.
function mergeSymbolMaps(additionalSymbols) {
  var symbolMap = {};
  symbolMap.symbols = additionalSymbols ? _extends({}, defaultSymbolMap.symbols, additionalSymbols.symbols) : _extends({}, defaultSymbolMap.symbols);
  return symbolMap;
}
function exec(operators, values) {
  var _ref;
  var op = operators.pop();
  values.push(op.f.apply(op, (_ref = []).concat.apply(_ref, values.splice(-op.argCount))));
  return op.precedence;
}
function calculate(expression, additionalSymbols) {
  var symbolMap = mergeSymbolMaps(additionalSymbols);
  var match;
  var operators = [symbolMap.symbols['('].prefix];
  var values = [];
  var pattern = new RegExp( // Pattern for numbers
  "\\d+(?:\\.\\d+)?|" +
  // ...and patterns for individual operators/function names
  Object.keys(symbolMap.symbols).map(function (key) {
    return symbolMap.symbols[key];
  })
  // longer symbols should be listed first
  // $FlowFixMe
  .sort(function (a, b) {
    return b.symbol.length - a.symbol.length;
  })
  // $FlowFixMe
  .map(function (val) {
    return val.regSymbol;
  }).join('|') + "|(\\S)", 'g');
  pattern.lastIndex = 0; // Reset regular expression object

  var afterValue = false;
  do {
    match = pattern.exec(expression);
    var _ref2 = match || [')', undefined],
      token = _ref2[0],
      bad = _ref2[1];
    var notNumber = symbolMap.symbols[token];
    var notNewValue = notNumber && !notNumber.prefix && !notNumber.func;
    var notAfterValue = !notNumber || !notNumber.postfix && !notNumber.infix;

    // Check for syntax errors:
    if (bad || (afterValue ? notAfterValue : notNewValue)) {
      throw new PolishedError(37, match ? match.index : expression.length, expression);
    }
    if (afterValue) {
      // We either have an infix or postfix operator (they should be mutually exclusive)
      var curr = notNumber.postfix || notNumber.infix;
      do {
        var prev = operators[operators.length - 1];
        if ((curr.precedence - prev.precedence || prev.rightToLeft) > 0) break;
        // Apply previous operator, since it has precedence over current one
      } while (exec(operators, values)); // Exit loop after executing an opening parenthesis or function
      afterValue = curr.notation === 'postfix';
      if (curr.symbol !== ')') {
        operators.push(curr);
        // Postfix always has precedence over any operator that follows after it
        if (afterValue) exec(operators, values);
      }
    } else if (notNumber) {
      // prefix operator or function
      operators.push(notNumber.prefix || notNumber.func);
      if (notNumber.func) {
        // Require an opening parenthesis
        match = pattern.exec(expression);
        if (!match || match[0] !== '(') {
          throw new PolishedError(38, match ? match.index : expression.length, expression);
        }
      }
    } else {
      // number
      values.push(+token);
      afterValue = true;
    }
  } while (match && operators.length);
  if (operators.length) {
    throw new PolishedError(39, match ? match.index : expression.length, expression);
  } else if (match) {
    throw new PolishedError(40, match ? match.index : expression.length, expression);
  } else {
    return values.pop();
  }
}
function reverseString(str) {
  return str.split('').reverse().join('');
}

/**
 * Helper for doing math with CSS Units. Accepts a formula as a string. All values in the formula must have the same unit (or be unitless). Supports complex formulas utliziing addition, subtraction, multiplication, division, square root, powers, factorial, min, max, as well as parentheses for order of operation.
 *
 *In cases where you need to do calculations with mixed units where one unit is a [relative length unit](https://developer.mozilla.org/en-US/docs/Web/CSS/length#Relative_length_units), you will want to use [CSS Calc](https://developer.mozilla.org/en-US/docs/Web/CSS/calc).
 *
 * *warning* While we've done everything possible to ensure math safely evalutes formulas expressed as strings, you should always use extreme caution when passing `math` user provided values.
 * @example
 * // Styles as object usage
 * const styles = {
 *   fontSize: math('12rem + 8rem'),
 *   fontSize: math('(12px + 2px) * 3'),
 *   fontSize: math('3px^2 + sqrt(4)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   fontSize: ${math('12rem + 8rem')};
 *   fontSize: ${math('(12px + 2px) * 3')};
 *   fontSize: ${math('3px^2 + sqrt(4)')};
 * `
 *
 * // CSS as JS Output
 *
 * div: {
 *   fontSize: '20rem',
 *   fontSize: '42px',
 *   fontSize: '11px',
 * }
 */
function math(formula, additionalSymbols) {
  var reversedFormula = reverseString(formula);
  var formulaMatch = reversedFormula.match(unitRegExp);

  // Check that all units are the same
  if (formulaMatch && !formulaMatch.every(function (unit) {
    return unit === formulaMatch[0];
  })) {
    throw new PolishedError(41);
  }
  var cleanFormula = reverseString(reversedFormula.replace(unitRegExp, ''));
  return "" + calculate(cleanFormula, additionalSymbols) + (formulaMatch ? reverseString(formulaMatch[0]) : '');
}

function colorToInt(color) {
  return Math.round(color * 255);
}
function convertToInt(red, green, blue) {
  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}
function hslToRgb(hue, saturation, lightness, convert) {
  if (convert === void 0) {
    convert = convertToInt;
  }
  if (saturation === 0) {
    // achromatic
    return convert(lightness, lightness, lightness);
  }

  // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV
  var huePrime = (hue % 360 + 360) % 360 / 60;
  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
  var red = 0;
  var green = 0;
  var blue = 0;
  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }
  var lightnessModification = lightness - chroma / 2;
  var finalRed = red + lightnessModification;
  var finalGreen = green + lightnessModification;
  var finalBlue = blue + lightnessModification;
  return convert(finalRed, finalGreen, finalBlue);
}

var namedColorMap = {
  aliceblue: 'f0f8ff',
  antiquewhite: 'faebd7',
  aqua: '00ffff',
  aquamarine: '7fffd4',
  azure: 'f0ffff',
  beige: 'f5f5dc',
  bisque: 'ffe4c4',
  black: '000',
  blanchedalmond: 'ffebcd',
  blue: '0000ff',
  blueviolet: '8a2be2',
  brown: 'a52a2a',
  burlywood: 'deb887',
  cadetblue: '5f9ea0',
  chartreuse: '7fff00',
  chocolate: 'd2691e',
  coral: 'ff7f50',
  cornflowerblue: '6495ed',
  cornsilk: 'fff8dc',
  crimson: 'dc143c',
  cyan: '00ffff',
  darkblue: '00008b',
  darkcyan: '008b8b',
  darkgoldenrod: 'b8860b',
  darkgray: 'a9a9a9',
  darkgreen: '006400',
  darkgrey: 'a9a9a9',
  darkkhaki: 'bdb76b',
  darkmagenta: '8b008b',
  darkolivegreen: '556b2f',
  darkorange: 'ff8c00',
  darkorchid: '9932cc',
  darkred: '8b0000',
  darksalmon: 'e9967a',
  darkseagreen: '8fbc8f',
  darkslateblue: '483d8b',
  darkslategray: '2f4f4f',
  darkslategrey: '2f4f4f',
  darkturquoise: '00ced1',
  darkviolet: '9400d3',
  deeppink: 'ff1493',
  deepskyblue: '00bfff',
  dimgray: '696969',
  dimgrey: '696969',
  dodgerblue: '1e90ff',
  firebrick: 'b22222',
  floralwhite: 'fffaf0',
  forestgreen: '228b22',
  fuchsia: 'ff00ff',
  gainsboro: 'dcdcdc',
  ghostwhite: 'f8f8ff',
  gold: 'ffd700',
  goldenrod: 'daa520',
  gray: '808080',
  green: '008000',
  greenyellow: 'adff2f',
  grey: '808080',
  honeydew: 'f0fff0',
  hotpink: 'ff69b4',
  indianred: 'cd5c5c',
  indigo: '4b0082',
  ivory: 'fffff0',
  khaki: 'f0e68c',
  lavender: 'e6e6fa',
  lavenderblush: 'fff0f5',
  lawngreen: '7cfc00',
  lemonchiffon: 'fffacd',
  lightblue: 'add8e6',
  lightcoral: 'f08080',
  lightcyan: 'e0ffff',
  lightgoldenrodyellow: 'fafad2',
  lightgray: 'd3d3d3',
  lightgreen: '90ee90',
  lightgrey: 'd3d3d3',
  lightpink: 'ffb6c1',
  lightsalmon: 'ffa07a',
  lightseagreen: '20b2aa',
  lightskyblue: '87cefa',
  lightslategray: '789',
  lightslategrey: '789',
  lightsteelblue: 'b0c4de',
  lightyellow: 'ffffe0',
  lime: '0f0',
  limegreen: '32cd32',
  linen: 'faf0e6',
  magenta: 'f0f',
  maroon: '800000',
  mediumaquamarine: '66cdaa',
  mediumblue: '0000cd',
  mediumorchid: 'ba55d3',
  mediumpurple: '9370db',
  mediumseagreen: '3cb371',
  mediumslateblue: '7b68ee',
  mediumspringgreen: '00fa9a',
  mediumturquoise: '48d1cc',
  mediumvioletred: 'c71585',
  midnightblue: '191970',
  mintcream: 'f5fffa',
  mistyrose: 'ffe4e1',
  moccasin: 'ffe4b5',
  navajowhite: 'ffdead',
  navy: '000080',
  oldlace: 'fdf5e6',
  olive: '808000',
  olivedrab: '6b8e23',
  orange: 'ffa500',
  orangered: 'ff4500',
  orchid: 'da70d6',
  palegoldenrod: 'eee8aa',
  palegreen: '98fb98',
  paleturquoise: 'afeeee',
  palevioletred: 'db7093',
  papayawhip: 'ffefd5',
  peachpuff: 'ffdab9',
  peru: 'cd853f',
  pink: 'ffc0cb',
  plum: 'dda0dd',
  powderblue: 'b0e0e6',
  purple: '800080',
  rebeccapurple: '639',
  red: 'f00',
  rosybrown: 'bc8f8f',
  royalblue: '4169e1',
  saddlebrown: '8b4513',
  salmon: 'fa8072',
  sandybrown: 'f4a460',
  seagreen: '2e8b57',
  seashell: 'fff5ee',
  sienna: 'a0522d',
  silver: 'c0c0c0',
  skyblue: '87ceeb',
  slateblue: '6a5acd',
  slategray: '708090',
  slategrey: '708090',
  snow: 'fffafa',
  springgreen: '00ff7f',
  steelblue: '4682b4',
  tan: 'd2b48c',
  teal: '008080',
  thistle: 'd8bfd8',
  tomato: 'ff6347',
  turquoise: '40e0d0',
  violet: 'ee82ee',
  wheat: 'f5deb3',
  white: 'fff',
  whitesmoke: 'f5f5f5',
  yellow: 'ff0',
  yellowgreen: '9acd32'
};

/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 * @private
 */
function nameToHex(color) {
  if (typeof color !== 'string') return color;
  var normalizedColorName = color.toLowerCase();
  return namedColorMap[normalizedColorName] ? "#" + namedColorMap[normalizedColorName] : color;
}

var hexRegex = /^#[a-fA-F0-9]{6}$/;
var hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i;
var rgbaRegex = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
var hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var hslaRegex = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;

/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */
function parseToRgb(color) {
  if (typeof color !== 'string') {
    throw new PolishedError(3);
  }
  var normalizedColor = nameToHex(color);
  if (normalizedColor.match(hexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
  }
  if (normalizedColor.match(hexRgbaRegex)) {
    var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
      alpha: alpha
    };
  }
  if (normalizedColor.match(reducedHexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
  }
  if (normalizedColor.match(reducedRgbaHexRegex)) {
    var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
      alpha: _alpha
    };
  }
  var rgbMatched = rgbRegex.exec(normalizedColor);
  if (rgbMatched) {
    return {
      red: parseInt("" + rgbMatched[1], 10),
      green: parseInt("" + rgbMatched[2], 10),
      blue: parseInt("" + rgbMatched[3], 10)
    };
  }
  var rgbaMatched = rgbaRegex.exec(normalizedColor.substring(0, 50));
  if (rgbaMatched) {
    return {
      red: parseInt("" + rgbaMatched[1], 10),
      green: parseInt("" + rgbaMatched[2], 10),
      blue: parseInt("" + rgbaMatched[3], 10),
      alpha: parseFloat("" + rgbaMatched[4]) > 1 ? parseFloat("" + rgbaMatched[4]) / 100 : parseFloat("" + rgbaMatched[4])
    };
  }
  var hslMatched = hslRegex.exec(normalizedColor);
  if (hslMatched) {
    var hue = parseInt("" + hslMatched[1], 10);
    var saturation = parseInt("" + hslMatched[2], 10) / 100;
    var lightness = parseInt("" + hslMatched[3], 10) / 100;
    var rgbColorString = "rgb(" + hslToRgb(hue, saturation, lightness) + ")";
    var hslRgbMatched = rgbRegex.exec(rgbColorString);
    if (!hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, rgbColorString);
    }
    return {
      red: parseInt("" + hslRgbMatched[1], 10),
      green: parseInt("" + hslRgbMatched[2], 10),
      blue: parseInt("" + hslRgbMatched[3], 10)
    };
  }
  var hslaMatched = hslaRegex.exec(normalizedColor.substring(0, 50));
  if (hslaMatched) {
    var _hue = parseInt("" + hslaMatched[1], 10);
    var _saturation = parseInt("" + hslaMatched[2], 10) / 100;
    var _lightness = parseInt("" + hslaMatched[3], 10) / 100;
    var _rgbColorString = "rgb(" + hslToRgb(_hue, _saturation, _lightness) + ")";
    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);
    if (!_hslRgbMatched) {
      throw new PolishedError(4, normalizedColor, _rgbColorString);
    }
    return {
      red: parseInt("" + _hslRgbMatched[1], 10),
      green: parseInt("" + _hslRgbMatched[2], 10),
      blue: parseInt("" + _hslRgbMatched[3], 10),
      alpha: parseFloat("" + hslaMatched[4]) > 1 ? parseFloat("" + hslaMatched[4]) / 100 : parseFloat("" + hslaMatched[4])
    };
  }
  throw new PolishedError(5);
}

function rgbToHsl(color) {
  // make sure rgb are contained in a set of [0, 255]
  var red = color.red / 255;
  var green = color.green / 255;
  var blue = color.blue / 255;
  var max = Math.max(red, green, blue);
  var min = Math.min(red, green, blue);
  var lightness = (max + min) / 2;
  if (max === min) {
    // achromatic
    if (color.alpha !== undefined) {
      return {
        hue: 0,
        saturation: 0,
        lightness: lightness,
        alpha: color.alpha
      };
    } else {
      return {
        hue: 0,
        saturation: 0,
        lightness: lightness
      };
    }
  }
  var hue;
  var delta = max - min;
  var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
  switch (max) {
    case red:
      hue = (green - blue) / delta + (green < blue ? 6 : 0);
      break;
    case green:
      hue = (blue - red) / delta + 2;
      break;
    default:
      // blue case
      hue = (red - green) / delta + 4;
      break;
  }
  hue *= 60;
  if (color.alpha !== undefined) {
    return {
      hue: hue,
      saturation: saturation,
      lightness: lightness,
      alpha: color.alpha
    };
  }
  return {
    hue: hue,
    saturation: saturation,
    lightness: lightness
  };
}

/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ hue: 0, saturation: 1, lightness: 0.5 }` to color1
 * const color1 = parseToHsl('rgb(255, 0, 0)');
 * // Assigns `{ hue: 128, saturation: 1, lightness: 0.5, alpha: 0.75 }` to color2
 * const color2 = parseToHsl('hsla(128, 100%, 50%, 0.75)');
 */
function parseToHsl(color) {
  // Note: At a later stage we can optimize this function as right now a hsl
  // color would be parsed converted to rgb values and converted back to hsl.
  return rgbToHsl(parseToRgb(color));
}

/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */
var reduceHexValue = function reduceHexValue(value) {
  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
    return "#" + value[1] + value[3] + value[5];
  }
  return value;
};
var reduceHexValue$1 = reduceHexValue;

function numberToHex(value) {
  var hex = value.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}

function colorToHex(color) {
  return numberToHex(Math.round(color * 255));
}
function convertToHex(red, green, blue) {
  return reduceHexValue$1("#" + colorToHex(red) + colorToHex(green) + colorToHex(blue));
}
function hslToHex(hue, saturation, lightness) {
  return hslToRgb(hue, saturation, lightness, convertToHex);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */
function hsl(value, saturation, lightness) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') {
    return hslToHex(value, saturation, lightness);
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined) {
    return hslToHex(value.hue, value.saturation, value.lightness);
  }
  throw new PolishedError(1);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */
function hsla(value, saturation, lightness, alpha) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') {
    return alpha >= 1 ? hslToHex(value, saturation, lightness) : "rgba(" + hslToRgb(value, saturation, lightness) + "," + alpha + ")";
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) {
    return value.alpha >= 1 ? hslToHex(value.hue, value.saturation, value.lightness) : "rgba(" + hslToRgb(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
  }
  throw new PolishedError(2);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */
function rgb(value, green, blue) {
  if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') {
    return reduceHexValue$1("#" + numberToHex(value) + numberToHex(green) + numberToHex(blue));
  } else if (typeof value === 'object' && green === undefined && blue === undefined) {
    return reduceHexValue$1("#" + numberToHex(value.red) + numberToHex(value.green) + numberToHex(value.blue));
  }
  throw new PolishedError(6);
}

/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */
function rgba(firstValue, secondValue, thirdValue, fourthValue) {
  if (typeof firstValue === 'string' && typeof secondValue === 'number') {
    var rgbValue = parseToRgb(firstValue);
    return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
  } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') {
    return fourthValue >= 1 ? rgb(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
  } else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) {
    return firstValue.alpha >= 1 ? rgb(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
  }
  throw new PolishedError(7);
}

var isRgb = function isRgb(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var isRgba = function isRgba(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
};
var isHsl = function isHsl(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var isHsla = function isHsla(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
};

/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */

function toColorString(color) {
  if (typeof color !== 'object') throw new PolishedError(8);
  if (isRgba(color)) return rgba(color);
  if (isRgb(color)) return rgb(color);
  if (isHsla(color)) return hsla(color);
  if (isHsl(color)) return hsl(color);
  throw new PolishedError(8);
}

// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function curried(f, length, acc) {
  return function fn() {
    // eslint-disable-next-line prefer-rest-params
    var combined = acc.concat(Array.prototype.slice.call(arguments));
    return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
  };
}

// eslint-disable-next-line no-redeclare
function curry(f) {
  // eslint-disable-line no-redeclare
  return curried(f, f.length, []);
}

/**
 * Changes the hue of the color. Hue is a number between 0 to 360. The first
 * argument for adjustHue is the amount of degrees the color is rotated around
 * the color wheel, always producing a positive hue value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: adjustHue(180, '#448'),
 *   background: adjustHue('180', 'rgba(101,100,205,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${adjustHue(180, '#448')};
 *   background: ${adjustHue('180', 'rgba(101,100,205,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#888844";
 *   background: "rgba(136,136,68,0.7)";
 * }
 */
function adjustHue(degree, color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    hue: hslColor.hue + parseFloat(degree)
  }));
}

// prettier-ignore
curry /* ::<number | string, string, string> */(adjustHue);

function guard(lowerBoundary, upperBoundary, value) {
  return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}

/**
 * Returns a string value for the darkened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: darken(0.2, '#FFCD64'),
 *   background: darken('0.2', 'rgba(255,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${darken(0.2, '#FFCD64')};
 *   background: ${darken('0.2', 'rgba(255,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffbd31";
 *   background: "rgba(255,189,49,0.7)";
 * }
 */
function darken(amount, color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness - parseFloat(amount))
  }));
}

// prettier-ignore
var curriedDarken = curry /* ::<number | string, string, string> */(darken);
var curriedDarken$1 = curriedDarken;

/**
 * Decreases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the desaturate function is the amount by how much the color
 * intensity should be decreased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: desaturate(0.2, '#CCCD64'),
 *   background: desaturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${desaturate(0.2, '#CCCD64')};
 *   background: ${desaturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#b8b979";
 *   background: "rgba(184,185,121,0.7)";
 * }
 */
function desaturate(amount, color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    saturation: guard(0, 1, hslColor.saturation - parseFloat(amount))
  }));
}

// prettier-ignore
curry /* ::<number | string, string, string> */(desaturate);

/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */
function lighten$1(amount, color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    lightness: guard(0, 1, hslColor.lightness + parseFloat(amount))
  }));
}

// prettier-ignore
var curriedLighten = curry /* ::<number | string, string, string> */(lighten$1);
var curriedLighten$1 = curriedLighten;

/**
 * Mixes the two provided colors together by calculating the average of each of the RGB components weighted to the first color by the provided weight.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: mix(0.5, '#f00', '#00f')
 *   background: mix(0.25, '#f00', '#00f')
 *   background: mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${mix(0.5, '#f00', '#00f')};
 *   background: ${mix(0.25, '#f00', '#00f')};
 *   background: ${mix('0.5', 'rgba(255, 0, 0, 0.5)', '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#7f007f";
 *   background: "#3f00bf";
 *   background: "rgba(63, 0, 191, 0.75)";
 * }
 */
function mix(weight, color, otherColor) {
  if (color === 'transparent') return otherColor;
  if (otherColor === 'transparent') return color;
  if (weight === 0) return otherColor;
  var parsedColor1 = parseToRgb(color);
  var color1 = _extends({}, parsedColor1, {
    alpha: typeof parsedColor1.alpha === 'number' ? parsedColor1.alpha : 1
  });
  var parsedColor2 = parseToRgb(otherColor);
  var color2 = _extends({}, parsedColor2, {
    alpha: typeof parsedColor2.alpha === 'number' ? parsedColor2.alpha : 1
  });

  // The formula is copied from the original Sass implementation:
  // http://sass-lang.com/documentation/Sass/Script/Functions.html#mix-instance_method
  var alphaDelta = color1.alpha - color2.alpha;
  var x = parseFloat(weight) * 2 - 1;
  var y = x * alphaDelta === -1 ? x : x + alphaDelta;
  var z = 1 + x * alphaDelta;
  var weight1 = (y / z + 1) / 2.0;
  var weight2 = 1 - weight1;
  var mixedColor = {
    red: Math.floor(color1.red * weight1 + color2.red * weight2),
    green: Math.floor(color1.green * weight1 + color2.green * weight2),
    blue: Math.floor(color1.blue * weight1 + color2.blue * weight2),
    alpha: color1.alpha * parseFloat(weight) + color2.alpha * (1 - parseFloat(weight))
  };
  return rgba(mixedColor);
}

// prettier-ignore
var curriedMix = curry /* ::<number | string, string, string, string> */(mix);
var mix$1 = curriedMix;

/**
 * Increases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: opacify(0.1, 'rgba(255, 255, 255, 0.9)');
 *   background: opacify(0.2, 'hsla(0, 0%, 100%, 0.5)'),
 *   background: opacify('0.5', 'rgba(255, 0, 0, 0.2)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${opacify(0.1, 'rgba(255, 255, 255, 0.9)')};
 *   background: ${opacify(0.2, 'hsla(0, 0%, 100%, 0.5)')},
 *   background: ${opacify('0.5', 'rgba(255, 0, 0, 0.2)')},
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#fff";
 *   background: "rgba(255,255,255,0.7)";
 *   background: "rgba(255,0,0,0.7)";
 * }
 */
function opacify(amount, color) {
  if (color === 'transparent') return color;
  var parsedColor = parseToRgb(color);
  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
  var colorWithAlpha = _extends({}, parsedColor, {
    alpha: guard(0, 1, (alpha * 100 + parseFloat(amount) * 100) / 100)
  });
  return rgba(colorWithAlpha);
}

// prettier-ignore
curry /* ::<number | string, string, string> */(opacify);

/**
 * Increases the intensity of a color. Its range is between 0 to 1. The first
 * argument of the saturate function is the amount by how much the color
 * intensity should be increased.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: saturate(0.2, '#CCCD64'),
 *   background: saturate('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${saturate(0.2, '#FFCD64')};
 *   background: ${saturate('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e0e250";
 *   background: "rgba(224,226,80,0.7)";
 * }
 */
function saturate(amount, color) {
  if (color === 'transparent') return color;
  var hslColor = parseToHsl(color);
  return toColorString(_extends({}, hslColor, {
    saturation: guard(0, 1, hslColor.saturation + parseFloat(amount))
  }));
}

// prettier-ignore
curry /* ::<number | string, string, string> */(saturate);

/**
 * Sets the hue of a color to the provided value. The hue range can be
 * from 0 and 359.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setHue(42, '#CCCD64'),
 *   background: setHue('244', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setHue(42, '#CCCD64')};
 *   background: ${setHue('244', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#cdae64";
 *   background: "rgba(107,100,205,0.7)";
 * }
 */
function setHue(hue, color) {
  if (color === 'transparent') return color;
  return toColorString(_extends({}, parseToHsl(color), {
    hue: parseFloat(hue)
  }));
}

// prettier-ignore
curry /* ::<number | string, string, string> */(setHue);

/**
 * Sets the lightness of a color to the provided value. The lightness range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setLightness(0.2, '#CCCD64'),
 *   background: setLightness('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setLightness(0.2, '#CCCD64')};
 *   background: ${setLightness('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#4d4d19";
 *   background: "rgba(223,224,159,0.7)";
 * }
 */
function setLightness(lightness, color) {
  if (color === 'transparent') return color;
  return toColorString(_extends({}, parseToHsl(color), {
    lightness: parseFloat(lightness)
  }));
}

// prettier-ignore
curry /* ::<number | string, string, string> */(setLightness);

/**
 * Sets the saturation of a color to the provided value. The saturation range can be
 * from 0 and 1.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: setSaturation(0.2, '#CCCD64'),
 *   background: setSaturation('0.75', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${setSaturation(0.2, '#CCCD64')};
 *   background: ${setSaturation('0.75', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#adad84";
 *   background: "rgba(228,229,76,0.7)";
 * }
 */
function setSaturation(saturation, color) {
  if (color === 'transparent') return color;
  return toColorString(_extends({}, parseToHsl(color), {
    saturation: parseFloat(saturation)
  }));
}

// prettier-ignore
curry /* ::<number | string, string, string> */(setSaturation);

/**
 * Shades a color by mixing it with black. `shade` can produce
 * hue shifts, where as `darken` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: shade(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${shade(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#00003f";
 * }
 */

function shade(percentage, color) {
  if (color === 'transparent') return color;
  return mix$1(parseFloat(percentage), 'rgb(0, 0, 0)', color);
}

// prettier-ignore
curry /* ::<number | string, string, string> */(shade);

/**
 * Tints a color by mixing it with white. `tint` can produce
 * hue shifts, where as `lighten` manipulates the luminance channel and therefore
 * doesn't produce hue shifts.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: tint(0.25, '#00f')
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${tint(0.25, '#00f')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#bfbfff";
 * }
 */

function tint(percentage, color) {
  if (color === 'transparent') return color;
  return mix$1(parseFloat(percentage), 'rgb(255, 255, 255)', color);
}

// prettier-ignore
curry /* ::<number | string, string, string> */(tint);

/**
 * Decreases the opacity of a color. Its range for the amount is between 0 to 1.
 *
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: transparentize(0.1, '#fff'),
 *   background: transparentize(0.2, 'hsl(0, 0%, 100%)'),
 *   background: transparentize('0.5', 'rgba(255, 0, 0, 0.8)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${transparentize(0.1, '#fff')};
 *   background: ${transparentize(0.2, 'hsl(0, 0%, 100%)')};
 *   background: ${transparentize('0.5', 'rgba(255, 0, 0, 0.8)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,255,255,0.9)";
 *   background: "rgba(255,255,255,0.8)";
 *   background: "rgba(255,0,0,0.3)";
 * }
 */
function transparentize(amount, color) {
  if (color === 'transparent') return color;
  var parsedColor = parseToRgb(color);
  var alpha = typeof parsedColor.alpha === 'number' ? parsedColor.alpha : 1;
  var colorWithAlpha = _extends({}, parsedColor, {
    alpha: guard(0, 1, +(alpha * 100 - parseFloat(amount) * 100).toFixed(2) / 100)
  });
  return rgba(colorWithAlpha);
}

// prettier-ignore
curry /* ::<number | string, string, string> */(transparentize);

var fontInter = "'Inter', sans-serif";

var sideNav = {
    width: 70,
    expandedWidth: 220,
    backgroundColor: Colors.purple600,
    backgroundColorHeader: Colors.purple600,
    animation: 'cubic-bezier(.27,.83,.42,1.02)',
    animationDuration: '300ms',
    iconLogoWidth: 22,
};

var menu = {
    height: 40,
    minHeight: 32,
    paddingLeft: 32,
};

var breakpoints = ['768px', '1024px', '1200px', '1440px'];
var device = {
    mobile: "@media screen and (max-width: " + math(breakpoints[0] + " - 1px") + ")",
    tablet: "@media screen and (min-width: " + breakpoints[0] + ") and (max-width: " + breakpoints[1] + ")",
    desktop: "@media screen and (min-width: " + math(breakpoints[1] + " + 1px") + ")",
    desktopMedium: "@media screen and (max-width: " + math(breakpoints[2] + " + 1px") + ")",
    desktopLarge: "@media screen and (min-width: " + math(breakpoints[3] + " + 1px") + ")",
};

var modal = {
    size: {
        small: 400,
        smedium: 500,
        medium: 600,
        slarge: 700,
        large: 800,
    },
};

var zIndex = {
    highPriority: 9999,
    modal: zIndexMUI.modal,
    dropList: 5,
    dropdownList: 4,
    inputIcon: 3,
};

var theme = {
    colors: Colors,
    space: [0, 8, 16, 32, 48, 64, 92],
    fontSizes: ['1rem', '1.2rem', '1.4rem', '1.6rem', '1.9rem', '2.4rem', '3rem'],
    global: {
        defaultFont: fontInter,
        secondaryFont: fontInter,
        gutterSpace: 16,
        headerSize: 48,
        defaultShadow: "0px 2px 6px " + rgba(Colors.grey700, 0.3),
    },
    forms: {
        defaultFontSize: '1.4rem',
        defaultHeight: 40,
        borderRadius: 8,
        paddingY: 12,
        paddingX: 13,
    },
    behavior: {
        information: { primary: Colors.purple600, secondary: Colors.purple100, tertiary: Colors.purple400 },
        warning: { primary: Colors.yellow700, secondary: Colors.yellow100, tertiary: Colors.yellow400 },
        error: { primary: Colors.red700, secondary: Colors.red100, tertiary: Colors.red400 },
        confirmation: { primary: Colors.green700, secondary: Colors.green100, tertiary: Colors.green400 },
        support: { primary: Colors.blue700, secondary: Colors.blue100, tertiary: Colors.blue400 },
        default: { primary: Colors.grey700, secondary: Colors.grey100, tertiary: Colors.grey400 },
    },
    zIndex: zIndex,
    sideNav: sideNav,
    menu: menu,
    breakpoints: breakpoints,
    device: device,
    modal: modal,
};

/*! *****************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */
/* global Reflect, Promise */

var extendStatics = function(d, b) {
    extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return extendStatics(d, b);
};

function __extends$1(d, b) {
    extendStatics(d, b);
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
}

var __assign$2 = function() {
    __assign$2 = Object.assign || function __assign(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return __assign$2.apply(this, arguments);
};

function __rest(s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
}

function __values(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
}

function __read$4(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

function __spread$1() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read$4(arguments[i]));
    return ar;
}

function __spreadArrays() {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
}
function __makeTemplateObject(cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
}

var reactDatepickerStyles = function () { return css(templateObject_1$V || (templateObject_1$V = __makeTemplateObject(["\n  .react-datepicker__aria-live {\n    display: none;\n  }\n  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle,\n  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle,\n  .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__month-read-view--down-arrow,\n  .react-datepicker__month-year-read-view--down-arrow {\n    margin-left: -8px;\n    position: absolute;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle,\n  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle,\n  .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__month-read-view--down-arrow,\n  .react-datepicker__month-year-read-view--down-arrow,\n  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before,\n  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::before,\n  .react-datepicker__year-read-view--down-arrow::before,\n  .react-datepicker__month-read-view--down-arrow::before,\n  .react-datepicker__month-year-read-view--down-arrow::before {\n    box-sizing: content-box;\n    position: absolute;\n    border: 8px solid transparent;\n    height: 0;\n    width: 1px;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before,\n  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::before,\n  .react-datepicker__year-read-view--down-arrow::before,\n  .react-datepicker__month-read-view--down-arrow::before,\n  .react-datepicker__month-year-read-view--down-arrow::before {\n    content: '';\n    z-index: -1;\n    border-width: 8px;\n    left: -8px;\n    border-bottom-color: #e9e7ef;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle {\n    top: 0;\n    margin-top: -8px;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle,\n  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before {\n    border-top: none;\n    border-bottom-color: ", ";\n  }\n\n  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before {\n    top: -1px;\n    border-bottom-color: #e9e7ef;\n  }\n\n  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle,\n  .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__month-read-view--down-arrow,\n  .react-datepicker__month-year-read-view--down-arrow {\n    bottom: 0;\n    margin-bottom: -8px;\n  }\n\n  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle,\n  .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__month-read-view--down-arrow,\n  .react-datepicker__month-year-read-view--down-arrow,\n  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::before,\n  .react-datepicker__year-read-view--down-arrow::before,\n  .react-datepicker__month-read-view--down-arrow::before,\n  .react-datepicker__month-year-read-view--down-arrow::before {\n    border-bottom: none;\n    border-top-color: ", ";\n  }\n\n  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::before,\n  .react-datepicker__year-read-view--down-arrow::before,\n  .react-datepicker__month-read-view--down-arrow::before,\n  .react-datepicker__month-year-read-view--down-arrow::before {\n    bottom: -1px;\n    border-top-color: #e9e7ef;\n  }\n\n  .react-datepicker-wrapper {\n    display: inline-block;\n    padding: 0;\n    border: 0;\n  }\n\n  .react-datepicker {\n    font-family: ", ";\n    font-size: 0.8rem;\n    background-color: ", ";\n    color: ", ";\n    border: 1px solid ", ";\n    border-radius: 0.3rem;\n    display: inline-block;\n    position: relative;\n  }\n\n  .react-datepicker--time-only .react-datepicker__triangle {\n    left: 35px;\n  }\n\n  .react-datepicker--time-only .react-datepicker__time-container {\n    border-left: 0;\n  }\n\n  .react-datepicker--time-only .react-datepicker__time {\n    border-radius: 0.3rem;\n  }\n\n  .react-datepicker--time-only .react-datepicker__time-box {\n    border-radius: 0.3rem;\n  }\n\n  .react-datepicker__triangle {\n    position: absolute;\n    left: 50px;\n  }\n\n  .react-datepicker-popper {\n    z-index: 1;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom'] {\n    margin-top: 10px;\n  }\n\n  .react-datepicker-popper[data-placement='bottom-end'] .react-datepicker__triangle,\n  .react-datepicker-popper[data-placement='top-end'] .react-datepicker__triangle {\n    left: auto;\n    right: 50px;\n  }\n\n  .react-datepicker-popper[data-placement^='top'] {\n    margin-bottom: 10px;\n  }\n\n  .react-datepicker-popper[data-placement^='right'] {\n    margin-left: 8px;\n  }\n\n  .react-datepicker-popper[data-placement^='right'] .react-datepicker__triangle {\n    left: auto;\n    right: 42px;\n  }\n\n  .react-datepicker-popper[data-placement^='left'] {\n    margin-right: 8px;\n  }\n\n  .react-datepicker-popper[data-placement^='left'] .react-datepicker__triangle {\n    left: 42px;\n    right: auto;\n  }\n\n  .react-datepicker__header {\n    text-align: center;\n    background-color: ", ";\n    border-bottom: 1px solid ", ";\n    border-top-left-radius: 0.3rem;\n    border-top-right-radius: 0.3rem;\n    padding-top: 8px;\n    position: relative;\n  }\n\n  .react-datepicker__header--time {\n    padding-bottom: 8px;\n    padding-left: 5px;\n    padding-right: 5px;\n  }\n\n  .react-datepicker__year-dropdown-container--select,\n  .react-datepicker__month-dropdown-container--select,\n  .react-datepicker__month-year-dropdown-container--select,\n  .react-datepicker__year-dropdown-container--scroll,\n  .react-datepicker__month-dropdown-container--scroll,\n  .react-datepicker__month-year-dropdown-container--scroll {\n    display: inline-block;\n    margin: 0 2px;\n  }\n\n  .react-datepicker__current-month,\n  .react-datepicker-time__header,\n  .react-datepicker-year-header {\n    margin-top: 0;\n    color: ", ";\n    font-weight: bold;\n    font-size: 0.944rem;\n  }\n\n  .react-datepicker-time__header {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n  }\n\n  .react-datepicker__navigation {\n    background: none;\n    line-height: 1.7rem;\n    text-align: center;\n    cursor: pointer;\n    position: absolute;\n    top: 10px;\n    width: 0;\n    padding: 0;\n    border: 0.45rem solid transparent;\n    z-index: 1;\n    height: 10px;\n    width: 10px;\n    text-indent: -999em;\n    overflow: hidden;\n  }\n\n  .react-datepicker__navigation--previous {\n    left: 10px;\n    border-right-color: ", ";\n  }\n\n  .react-datepicker__navigation--previous:hover {\n    border-right-color: ", ";\n  }\n\n  .react-datepicker__navigation--previous--disabled,\n  .react-datepicker__navigation--previous--disabled:hover {\n    border-right-color: ", ";\n    cursor: default;\n  }\n\n  .react-datepicker__navigation--next {\n    right: 10px;\n    border-left-color: ", ";\n  }\n\n  .react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {\n    right: 80px;\n  }\n\n  .react-datepicker__navigation--next:hover {\n    border-left-color: ", ";\n  }\n\n  .react-datepicker__navigation--next--disabled,\n  .react-datepicker__navigation--next--disabled:hover {\n    border-left-color: ", ";\n    cursor: default;\n  }\n\n  .react-datepicker__navigation--years {\n    position: relative;\n    top: 0;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .react-datepicker__navigation--years-previous {\n    top: 4px;\n    border-top-color: ", ";\n  }\n\n  .react-datepicker__navigation--years-previous:hover {\n    border-top-color: ", ";\n  }\n\n  .react-datepicker__navigation--years-upcoming {\n    top: -4px;\n    border-bottom-color: ", ";\n  }\n\n  .react-datepicker__navigation--years-upcoming:hover {\n    border-bottom-color: ", ";\n  }\n\n  .react-datepicker__month-container {\n    float: left;\n  }\n\n  .react-datepicker__year-container {\n    margin: 0.4rem;\n    text-align: center;\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  .react-datepicker__year-container-text {\n    display: inline-block;\n    cursor: pointer;\n    flex: 1 0 30%;\n    width: 12px;\n    padding: 2px;\n  }\n\n  .react-datepicker__month {\n    margin: 0.4rem;\n    text-align: center;\n  }\n\n  .react-datepicker__month .react-datepicker__month-text,\n  .react-datepicker__month .react-datepicker__quarter-text {\n    display: inline-block;\n    width: 4rem;\n    margin: 2px;\n  }\n\n  .react-datepicker__input-time-container {\n    clear: both;\n    width: 100%;\n    float: left;\n    margin: 5px 0 10px 15px;\n    text-align: left;\n  }\n\n  .react-datepicker__input-time-container .react-datepicker-time__caption {\n    display: inline-block;\n  }\n\n  .react-datepicker__input-time-container .react-datepicker-time__input-container {\n    display: inline-block;\n  }\n\n  .react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input {\n    display: inline-block;\n    margin-left: 10px;\n  }\n\n  .react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input {\n    width: 85px;\n  }\n\n  .react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type='time']::-webkit-inner-spin-button,\n  .react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type='time']::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  .react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type='time'] {\n    -moz-appearance: textfield;\n  }\n\n  .react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__delimiter {\n    margin-left: 5px;\n    display: inline-block;\n  }\n\n  .react-datepicker__time-container {\n    float: right;\n    border-left: 1px solid ", ";\n    width: 85px;\n  }\n\n  .react-datepicker__time-container--with-today-button {\n    display: inline;\n    border: 1px solid ", ";\n    border-radius: 0.3rem;\n    position: absolute;\n    right: -72px;\n    top: 0;\n  }\n\n  .react-datepicker__time-container .react-datepicker__time {\n    position: relative;\n    background: white;\n  }\n\n  .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {\n    width: 85px;\n    overflow-x: hidden;\n    margin: 0 auto;\n    text-align: center;\n  }\n\n  .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {\n    list-style: none;\n    margin: 0;\n    height: calc(195px + (1.7rem / 2));\n    overflow-y: scroll;\n    padding-right: 0px;\n    padding-left: 0px;\n    width: 100%;\n    box-sizing: content-box;\n  }\n\n  .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {\n    height: 30px;\n    padding: 5px 10px;\n    white-space: nowrap;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item:hover {\n    cursor: pointer;\n    background-color: ", ";\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item--selected {\n    background-color: ", ";\n    color: white;\n    font-weight: bold;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item--selected:hover {\n    background-color: ", ";\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item--disabled {\n    color: ", ";\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item--disabled:hover {\n    cursor: default;\n    background-color: transparent;\n  }\n\n  .react-datepicker__week-number {\n    color: ", ";\n    display: inline-block;\n    width: 1.7rem;\n    line-height: 1.7rem;\n    text-align: center;\n    margin: 0.166rem;\n  }\n\n  .react-datepicker__week-number.react-datepicker__week-number--clickable {\n    cursor: pointer;\n  }\n\n  .react-datepicker__week-number.react-datepicker__week-number--clickable:hover {\n    border-radius: 0.3rem;\n    background-color: ", ";\n  }\n\n  .react-datepicker__day-names,\n  .react-datepicker__week {\n    white-space: nowrap;\n  }\n\n  .react-datepicker__day-name,\n  .react-datepicker__day,\n  .react-datepicker__time-name {\n    color: ", ";\n    display: inline-block;\n    text-align: center;\n    margin: 0.166rem;\n  }\n\n  .react-datepicker__month--selected,\n  .react-datepicker__month--in-selecting-range,\n  .react-datepicker__month--in-range,\n  .react-datepicker__quarter--selected,\n  .react-datepicker__quarter--in-selecting-range,\n  .react-datepicker__quarter--in-range {\n    border-radius: 0.3rem;\n    background-color: ", ";\n    color: ", ";\n  }\n\n  .react-datepicker__month--selected:hover,\n  .react-datepicker__month--in-selecting-range:hover,\n  .react-datepicker__month--in-range:hover,\n  .react-datepicker__quarter--selected:hover,\n  .react-datepicker__quarter--in-selecting-range:hover,\n  .react-datepicker__quarter--in-range:hover {\n    background-color: ", ";\n  }\n\n  .react-datepicker__month--disabled,\n  .react-datepicker__quarter--disabled {\n    color: ", ";\n    pointer-events: none;\n  }\n\n  .react-datepicker__month--disabled:hover,\n  .react-datepicker__quarter--disabled:hover {\n    cursor: default;\n    background-color: transparent;\n  }\n\n  .react-datepicker__day,\n  .react-datepicker__month-text,\n  .react-datepicker__quarter-text {\n    cursor: pointer;\n  }\n\n  .react-datepicker__day:hover,\n  .react-datepicker__month-text:hover,\n  .react-datepicker__quarter-text:hover {\n    border-radius: 0.3rem;\n    background-color: ", ";\n  }\n\n  .react-datepicker__day--today,\n  .react-datepicker__month-text--today,\n  .react-datepicker__quarter-text--today {\n    font-weight: bold;\n  }\n\n  .react-datepicker__day--highlighted,\n  .react-datepicker__month-text--highlighted,\n  .react-datepicker__quarter-text--highlighted {\n    border-radius: 0.3rem;\n    background-color: ", ";\n    color: ", ";\n  }\n\n  .react-datepicker__day--highlighted:hover,\n  .react-datepicker__month-text--highlighted:hover,\n  .react-datepicker__quarter-text--highlighted:hover {\n    background-color: ", ";\n  }\n\n  .react-datepicker__day--highlighted-custom-1,\n  .react-datepicker__month-text--highlighted-custom-1,\n  .react-datepicker__quarter-text--highlighted-custom-1 {\n    color: magenta;\n  }\n\n  .react-datepicker__day--highlighted-custom-2,\n  .react-datepicker__month-text--highlighted-custom-2,\n  .react-datepicker__quarter-text--highlighted-custom-2 {\n    color: green400;\n  }\n\n  .react-datepicker__day--selected,\n  .react-datepicker__day--in-selecting-range,\n  .react-datepicker__day--in-range,\n  .react-datepicker__month-text--selected,\n  .react-datepicker__month-text--in-selecting-range,\n  .react-datepicker__month-text--in-range,\n  .react-datepicker__quarter-text--selected,\n  .react-datepicker__quarter-text--in-selecting-range,\n  .react-datepicker__quarter-text--in-range {\n    border-radius: 0.3rem;\n    background-color: ", ";\n    color: ", ";\n  }\n\n  .react-datepicker__day--selected:hover,\n  .react-datepicker__day--in-selecting-range:hover,\n  .react-datepicker__day--in-range:hover,\n  .react-datepicker__month-text--selected:hover,\n  .react-datepicker__month-text--in-selecting-range:hover,\n  .react-datepicker__month-text--in-range:hover,\n  .react-datepicker__quarter-text--selected:hover,\n  .react-datepicker__quarter-text--in-selecting-range:hover,\n  .react-datepicker__quarter-text--in-range:hover {\n    background-color: ", ";\n  }\n\n  .react-datepicker__day--keyboard-selected,\n  .react-datepicker__month-text--keyboard-selected,\n  .react-datepicker__quarter-text--keyboard-selected {\n    border-radius: 0.3rem;\n    background-color: ", ";\n    color: ", ";\n  }\n\n  .react-datepicker__day--keyboard-selected:hover,\n  .react-datepicker__month-text--keyboard-selected:hover,\n  .react-datepicker__quarter-text--keyboard-selected:hover {\n    background-color: ", ";\n  }\n\n  .react-datepicker__day--in-selecting-range,\n  .react-datepicker__month-text--in-selecting-range,\n  .react-datepicker__quarter-text--in-selecting-range {\n    background-color: rgba(33, 107, 165, 0.5);\n  }\n\n  .react-datepicker__month--selecting-range .react-datepicker__day--in-range,\n  .react-datepicker__month--selecting-range .react-datepicker__month-text--in-range,\n  .react-datepicker__month--selecting-range .react-datepicker__quarter-text--in-range {\n    background-color: ", ";\n    color: ", ";\n  }\n\n  .react-datepicker__day--disabled,\n  .react-datepicker__month-text--disabled,\n  .react-datepicker__quarter-text--disabled {\n    cursor: default;\n    color: ", ";\n    background-color: ", ";\n  }\n\n  .react-datepicker__day--disabled:hover,\n  .react-datepicker__month-text--disabled:hover,\n  .react-datepicker__quarter-text--disabled:hover {\n    background-color: ", ";\n  }\n\n  .react-datepicker__month-text.react-datepicker__month--selected:hover,\n  .react-datepicker__month-text.react-datepicker__month--in-range:hover,\n  .react-datepicker__month-text.react-datepicker__quarter--selected:hover,\n  .react-datepicker__month-text.react-datepicker__quarter--in-range:hover,\n  .react-datepicker__quarter-text.react-datepicker__month--selected:hover,\n  .react-datepicker__quarter-text.react-datepicker__month--in-range:hover,\n  .react-datepicker__quarter-text.react-datepicker__quarter--selected:hover,\n  .react-datepicker__quarter-text.react-datepicker__quarter--in-range:hover {\n    background-color: ", ";\n  }\n\n  .react-datepicker__month-text:hover,\n  .react-datepicker__quarter-text:hover {\n    background-color: ", ";\n  }\n\n  .react-datepicker__input-container {\n    position: relative;\n    display: inline-block;\n    width: 100%;\n  }\n\n  .react-datepicker__year-read-view,\n  .react-datepicker__month-read-view,\n  .react-datepicker__month-year-read-view {\n    border: 1px solid transparent;\n    border-radius: 0.3rem;\n  }\n\n  .react-datepicker__year-read-view:hover,\n  .react-datepicker__month-read-view:hover,\n  .react-datepicker__month-year-read-view:hover {\n    cursor: pointer;\n  }\n\n  .react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,\n  .react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,\n  .react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow {\n    border-top-color: ", ";\n  }\n\n  .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__month-read-view--down-arrow,\n  .react-datepicker__month-year-read-view--down-arrow {\n    border-top-color: ", ";\n    float: right;\n    margin-left: 20px;\n    top: 8px;\n    position: relative;\n    border-width: 0.45rem;\n  }\n\n  .react-datepicker__year-dropdown,\n  .react-datepicker__month-dropdown,\n  .react-datepicker__month-year-dropdown {\n    background-color: ", ";\n    position: absolute;\n    width: 50%;\n    left: 25%;\n    top: 30px;\n    z-index: 1;\n    text-align: center;\n    border-radius: 0.3rem;\n    border: 1px solid ", ";\n  }\n\n  .react-datepicker__year-dropdown:hover,\n  .react-datepicker__month-dropdown:hover,\n  .react-datepicker__month-year-dropdown:hover {\n    cursor: pointer;\n  }\n\n  .react-datepicker__year-dropdown--scrollable,\n  .react-datepicker__month-dropdown--scrollable,\n  .react-datepicker__month-year-dropdown--scrollable {\n    height: 150px;\n    overflow-y: scroll;\n  }\n\n  .react-datepicker__year-option,\n  .react-datepicker__month-option,\n  .react-datepicker__month-year-option {\n    line-height: 20px;\n    width: 100%;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .react-datepicker__year-option:first-of-type,\n  .react-datepicker__month-option:first-of-type,\n  .react-datepicker__month-year-option:first-of-type {\n    border-top-left-radius: 0.3rem;\n    border-top-right-radius: 0.3rem;\n  }\n\n  .react-datepicker__year-option:last-of-type,\n  .react-datepicker__month-option:last-of-type,\n  .react-datepicker__month-year-option:last-of-type {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    border-bottom-left-radius: 0.3rem;\n    border-bottom-right-radius: 0.3rem;\n  }\n\n  .react-datepicker__year-option:hover,\n  .react-datepicker__month-option:hover,\n  .react-datepicker__month-year-option:hover {\n    background-color: ", ";\n  }\n\n  .react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,\n  .react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,\n  .react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming {\n    border-bottom-color: ", ";\n  }\n\n  .react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,\n  .react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,\n  .react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous {\n    border-top-color: ", ";\n  }\n\n  .react-datepicker__year-option--selected,\n  .react-datepicker__month-option--selected,\n  .react-datepicker__month-year-option--selected {\n    position: absolute;\n    left: 15px;\n  }\n\n  .react-datepicker__close-icon {\n    cursor: pointer;\n    background-color: transparent;\n    border: 0;\n    outline: 0;\n    padding: 0px 6px 0px 0px;\n    position: absolute;\n    top: 0;\n    right: 0;\n    height: 100%;\n    display: table-cell;\n    vertical-align: middle;\n  }\n\n  .react-datepicker__close-icon::after {\n    cursor: pointer;\n    background-color: ", ";\n    color: ", ";\n    border-radius: 50%;\n    height: 16px;\n    width: 16px;\n    padding: 2px;\n    font-size: 12px;\n    line-height: 1;\n    text-align: center;\n    display: table-cell;\n    vertical-align: middle;\n    content: '\\00d7';\n  }\n\n  .react-datepicker__today-button {\n    background: ", ";\n    border-top: 1px solid ", ";\n    cursor: pointer;\n    text-align: center;\n    font-weight: bold;\n    padding: 5px 0;\n    clear: left;\n  }\n\n  .react-datepicker__portal {\n    position: fixed;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.8);\n    left: 0;\n    top: 0;\n    justify-content: center;\n    align-items: center;\n    display: flex;\n    z-index: 2147483647;\n  }\n\n  .react-datepicker__portal .react-datepicker__day-name,\n  .react-datepicker__portal .react-datepicker__day,\n  .react-datepicker__portal .react-datepicker__time-name {\n    width: 3rem;\n    line-height: 3rem;\n  }\n\n  @media (max-width: 400px), (max-height: 550px) {\n    .react-datepicker__portal .react-datepicker__day-name,\n    .react-datepicker__portal .react-datepicker__day,\n    .react-datepicker__portal .react-datepicker__time-name {\n      width: 20px;\n      line-height: 20px;\n    }\n  }\n\n  .react-datepicker__portal .react-datepicker__current-month,\n  .react-datepicker__portal .react-datepicker-time__header {\n    font-size: 1.44rem;\n  }\n\n  .react-datepicker__portal .react-datepicker__navigation {\n    border: 0.81rem solid transparent;\n  }\n\n  .react-datepicker__portal .react-datepicker__navigation--previous {\n    border-right-color: ", ";\n  }\n\n  .react-datepicker__portal .react-datepicker__navigation--previous:hover {\n    border-right-color: ", ";\n  }\n\n  .react-datepicker__portal .react-datepicker__navigation--previous--disabled,\n  .react-datepicker__portal .react-datepicker__navigation--previous--disabled:hover {\n    border-right-color: ", ";\n    cursor: default;\n  }\n\n  .react-datepicker__portal .react-datepicker__navigation--next {\n    border-left-color: ", ";\n  }\n\n  .react-datepicker__portal .react-datepicker__navigation--next:hover {\n    border-left-color: ", ";\n  }\n\n  .react-datepicker__portal .react-datepicker__navigation--next--disabled,\n  .react-datepicker__portal .react-datepicker__navigation--next--disabled:hover {\n    border-left-color: ", ";\n    cursor: default;\n  }\n\n  .react-datepicker-wrapper {\n    width: 100%;\n  }\n\n  .datepicker-calendar {\n    font-family: ", ";\n    border: none;\n    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.05), 0px 0px 0px 1px rgba(0, 0, 0, 0.07);\n    border-radius: 4px;\n    padding: ", "px;\n\n    .react-datepicker__triangle {\n      &::before {\n        border-bottom-color: ", ";\n      }\n    }\n    .react-datepicker__navigation {\n      top: unset;\n      &--previous {\n        left: unset;\n      }\n    }\n    .react-datepicker__header {\n      margin-top: -5px;\n      padding-top: 0px;\n      background-color: ", ";\n      border-bottom: none;\n      .react-datepicker__current-month {\n        font-size: 1.8rem;\n        margin-bottom: ", "px;\n        text-transform: capitalize;\n      }\n    }\n\n    .react-datepicker__day-name {\n      font-size: 1rem;\n      color: ", ";\n      width: 3.9rem;\n      margin: 0;\n      text-transform: capitalize;\n    }\n    .react-datepicker__day,\n    .react-datepicker__month-text {\n      margin: 0;\n      font-size: 1.3rem;\n    }\n\n    .react-datepicker__week:last-child {\n      .react-datepicker__day {\n        border-bottom: 1px solid ", ";\n      }\n    }\n\n    .react-datepicker__day {\n      width: 3.9rem;\n      height: 3.6rem;\n      padding: ", "px;\n      border-top: 1px solid ", ";\n      border-right: 1px solid ", ";\n      border-radius: 0;\n\n      &:first-child {\n        border-left: 1px solid ", ";\n      }\n\n      &.react-datepicker__day--outside-month {\n        color: ", ";\n      }\n\n      &.react-datepicker__day--selected,\n      &.react-datepicker__day--keyboard-selected {\n        background-color: ", ";\n        font-weight: 600;\n      }\n\n      &:focus {\n        outline: 0;\n      }\n    }\n\n    .react-datepicker__month-wrapper {\n      .react-datepicker__month-text:last-child {\n        border-right: 1px solid ", ";\n      }\n    }\n\n    .react-datepicker__month-wrapper:last-child {\n      .react-datepicker__month-text {\n        border-bottom: 1px solid ", ";\n      }\n    }\n\n    .react-datepicker__month-text {\n      width: 33.33%;\n      line-height: 4rem;\n      height: 4rem;\n      padding: 0px ", "px;\n      border-top: 1px solid ", ";\n      border-left: 1px solid ", ";\n      border-radius: 0;\n      text-transform: capitalize;\n\n      &.react-datepicker__month--selected,\n      &.react-datepicker__month--keyboard-selected {\n        background-color: ", ";\n        font-weight: 600;\n      }\n\n      &:focus {\n        outline: 0;\n      }\n    }\n  }\n  .react-datepicker-popper {\n    z-index: 5;\n  }\n"], ["\n  .react-datepicker__aria-live {\n    display: none;\n  }\n  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle,\n  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle,\n  .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__month-read-view--down-arrow,\n  .react-datepicker__month-year-read-view--down-arrow {\n    margin-left: -8px;\n    position: absolute;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle,\n  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle,\n  .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__month-read-view--down-arrow,\n  .react-datepicker__month-year-read-view--down-arrow,\n  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before,\n  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::before,\n  .react-datepicker__year-read-view--down-arrow::before,\n  .react-datepicker__month-read-view--down-arrow::before,\n  .react-datepicker__month-year-read-view--down-arrow::before {\n    box-sizing: content-box;\n    position: absolute;\n    border: 8px solid transparent;\n    height: 0;\n    width: 1px;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before,\n  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::before,\n  .react-datepicker__year-read-view--down-arrow::before,\n  .react-datepicker__month-read-view--down-arrow::before,\n  .react-datepicker__month-year-read-view--down-arrow::before {\n    content: '';\n    z-index: -1;\n    border-width: 8px;\n    left: -8px;\n    border-bottom-color: #e9e7ef;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle {\n    top: 0;\n    margin-top: -8px;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle,\n  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before {\n    border-top: none;\n    border-bottom-color: ", ";\n  }\n\n  .react-datepicker-popper[data-placement^='bottom'] .react-datepicker__triangle::before {\n    top: -1px;\n    border-bottom-color: #e9e7ef;\n  }\n\n  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle,\n  .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__month-read-view--down-arrow,\n  .react-datepicker__month-year-read-view--down-arrow {\n    bottom: 0;\n    margin-bottom: -8px;\n  }\n\n  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle,\n  .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__month-read-view--down-arrow,\n  .react-datepicker__month-year-read-view--down-arrow,\n  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::before,\n  .react-datepicker__year-read-view--down-arrow::before,\n  .react-datepicker__month-read-view--down-arrow::before,\n  .react-datepicker__month-year-read-view--down-arrow::before {\n    border-bottom: none;\n    border-top-color: ", ";\n  }\n\n  .react-datepicker-popper[data-placement^='top'] .react-datepicker__triangle::before,\n  .react-datepicker__year-read-view--down-arrow::before,\n  .react-datepicker__month-read-view--down-arrow::before,\n  .react-datepicker__month-year-read-view--down-arrow::before {\n    bottom: -1px;\n    border-top-color: #e9e7ef;\n  }\n\n  .react-datepicker-wrapper {\n    display: inline-block;\n    padding: 0;\n    border: 0;\n  }\n\n  .react-datepicker {\n    font-family: ", ";\n    font-size: 0.8rem;\n    background-color: ", ";\n    color: ", ";\n    border: 1px solid ", ";\n    border-radius: 0.3rem;\n    display: inline-block;\n    position: relative;\n  }\n\n  .react-datepicker--time-only .react-datepicker__triangle {\n    left: 35px;\n  }\n\n  .react-datepicker--time-only .react-datepicker__time-container {\n    border-left: 0;\n  }\n\n  .react-datepicker--time-only .react-datepicker__time {\n    border-radius: 0.3rem;\n  }\n\n  .react-datepicker--time-only .react-datepicker__time-box {\n    border-radius: 0.3rem;\n  }\n\n  .react-datepicker__triangle {\n    position: absolute;\n    left: 50px;\n  }\n\n  .react-datepicker-popper {\n    z-index: 1;\n  }\n\n  .react-datepicker-popper[data-placement^='bottom'] {\n    margin-top: 10px;\n  }\n\n  .react-datepicker-popper[data-placement='bottom-end'] .react-datepicker__triangle,\n  .react-datepicker-popper[data-placement='top-end'] .react-datepicker__triangle {\n    left: auto;\n    right: 50px;\n  }\n\n  .react-datepicker-popper[data-placement^='top'] {\n    margin-bottom: 10px;\n  }\n\n  .react-datepicker-popper[data-placement^='right'] {\n    margin-left: 8px;\n  }\n\n  .react-datepicker-popper[data-placement^='right'] .react-datepicker__triangle {\n    left: auto;\n    right: 42px;\n  }\n\n  .react-datepicker-popper[data-placement^='left'] {\n    margin-right: 8px;\n  }\n\n  .react-datepicker-popper[data-placement^='left'] .react-datepicker__triangle {\n    left: 42px;\n    right: auto;\n  }\n\n  .react-datepicker__header {\n    text-align: center;\n    background-color: ", ";\n    border-bottom: 1px solid ", ";\n    border-top-left-radius: 0.3rem;\n    border-top-right-radius: 0.3rem;\n    padding-top: 8px;\n    position: relative;\n  }\n\n  .react-datepicker__header--time {\n    padding-bottom: 8px;\n    padding-left: 5px;\n    padding-right: 5px;\n  }\n\n  .react-datepicker__year-dropdown-container--select,\n  .react-datepicker__month-dropdown-container--select,\n  .react-datepicker__month-year-dropdown-container--select,\n  .react-datepicker__year-dropdown-container--scroll,\n  .react-datepicker__month-dropdown-container--scroll,\n  .react-datepicker__month-year-dropdown-container--scroll {\n    display: inline-block;\n    margin: 0 2px;\n  }\n\n  .react-datepicker__current-month,\n  .react-datepicker-time__header,\n  .react-datepicker-year-header {\n    margin-top: 0;\n    color: ", ";\n    font-weight: bold;\n    font-size: 0.944rem;\n  }\n\n  .react-datepicker-time__header {\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n  }\n\n  .react-datepicker__navigation {\n    background: none;\n    line-height: 1.7rem;\n    text-align: center;\n    cursor: pointer;\n    position: absolute;\n    top: 10px;\n    width: 0;\n    padding: 0;\n    border: 0.45rem solid transparent;\n    z-index: 1;\n    height: 10px;\n    width: 10px;\n    text-indent: -999em;\n    overflow: hidden;\n  }\n\n  .react-datepicker__navigation--previous {\n    left: 10px;\n    border-right-color: ", ";\n  }\n\n  .react-datepicker__navigation--previous:hover {\n    border-right-color: ", ";\n  }\n\n  .react-datepicker__navigation--previous--disabled,\n  .react-datepicker__navigation--previous--disabled:hover {\n    border-right-color: ", ";\n    cursor: default;\n  }\n\n  .react-datepicker__navigation--next {\n    right: 10px;\n    border-left-color: ", ";\n  }\n\n  .react-datepicker__navigation--next--with-time:not(.react-datepicker__navigation--next--with-today-button) {\n    right: 80px;\n  }\n\n  .react-datepicker__navigation--next:hover {\n    border-left-color: ", ";\n  }\n\n  .react-datepicker__navigation--next--disabled,\n  .react-datepicker__navigation--next--disabled:hover {\n    border-left-color: ", ";\n    cursor: default;\n  }\n\n  .react-datepicker__navigation--years {\n    position: relative;\n    top: 0;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .react-datepicker__navigation--years-previous {\n    top: 4px;\n    border-top-color: ", ";\n  }\n\n  .react-datepicker__navigation--years-previous:hover {\n    border-top-color: ", ";\n  }\n\n  .react-datepicker__navigation--years-upcoming {\n    top: -4px;\n    border-bottom-color: ", ";\n  }\n\n  .react-datepicker__navigation--years-upcoming:hover {\n    border-bottom-color: ", ";\n  }\n\n  .react-datepicker__month-container {\n    float: left;\n  }\n\n  .react-datepicker__year-container {\n    margin: 0.4rem;\n    text-align: center;\n    display: flex;\n    flex-wrap: wrap;\n  }\n\n  .react-datepicker__year-container-text {\n    display: inline-block;\n    cursor: pointer;\n    flex: 1 0 30%;\n    width: 12px;\n    padding: 2px;\n  }\n\n  .react-datepicker__month {\n    margin: 0.4rem;\n    text-align: center;\n  }\n\n  .react-datepicker__month .react-datepicker__month-text,\n  .react-datepicker__month .react-datepicker__quarter-text {\n    display: inline-block;\n    width: 4rem;\n    margin: 2px;\n  }\n\n  .react-datepicker__input-time-container {\n    clear: both;\n    width: 100%;\n    float: left;\n    margin: 5px 0 10px 15px;\n    text-align: left;\n  }\n\n  .react-datepicker__input-time-container .react-datepicker-time__caption {\n    display: inline-block;\n  }\n\n  .react-datepicker__input-time-container .react-datepicker-time__input-container {\n    display: inline-block;\n  }\n\n  .react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input {\n    display: inline-block;\n    margin-left: 10px;\n  }\n\n  .react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input {\n    width: 85px;\n  }\n\n  .react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type='time']::-webkit-inner-spin-button,\n  .react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type='time']::-webkit-outer-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n\n  .react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__input input[type='time'] {\n    -moz-appearance: textfield;\n  }\n\n  .react-datepicker__input-time-container .react-datepicker-time__input-container .react-datepicker-time__delimiter {\n    margin-left: 5px;\n    display: inline-block;\n  }\n\n  .react-datepicker__time-container {\n    float: right;\n    border-left: 1px solid ", ";\n    width: 85px;\n  }\n\n  .react-datepicker__time-container--with-today-button {\n    display: inline;\n    border: 1px solid ", ";\n    border-radius: 0.3rem;\n    position: absolute;\n    right: -72px;\n    top: 0;\n  }\n\n  .react-datepicker__time-container .react-datepicker__time {\n    position: relative;\n    background: white;\n  }\n\n  .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box {\n    width: 85px;\n    overflow-x: hidden;\n    margin: 0 auto;\n    text-align: center;\n  }\n\n  .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list {\n    list-style: none;\n    margin: 0;\n    height: calc(195px + (1.7rem / 2));\n    overflow-y: scroll;\n    padding-right: 0px;\n    padding-left: 0px;\n    width: 100%;\n    box-sizing: content-box;\n  }\n\n  .react-datepicker__time-container .react-datepicker__time .react-datepicker__time-box ul.react-datepicker__time-list li.react-datepicker__time-list-item {\n    height: 30px;\n    padding: 5px 10px;\n    white-space: nowrap;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item:hover {\n    cursor: pointer;\n    background-color: ", ";\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item--selected {\n    background-color: ", ";\n    color: white;\n    font-weight: bold;\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item--selected:hover {\n    background-color: ", ";\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item--disabled {\n    color: ", ";\n  }\n\n  .react-datepicker__time-container\n    .react-datepicker__time\n    .react-datepicker__time-box\n    ul.react-datepicker__time-list\n    li.react-datepicker__time-list-item--disabled:hover {\n    cursor: default;\n    background-color: transparent;\n  }\n\n  .react-datepicker__week-number {\n    color: ", ";\n    display: inline-block;\n    width: 1.7rem;\n    line-height: 1.7rem;\n    text-align: center;\n    margin: 0.166rem;\n  }\n\n  .react-datepicker__week-number.react-datepicker__week-number--clickable {\n    cursor: pointer;\n  }\n\n  .react-datepicker__week-number.react-datepicker__week-number--clickable:hover {\n    border-radius: 0.3rem;\n    background-color: ", ";\n  }\n\n  .react-datepicker__day-names,\n  .react-datepicker__week {\n    white-space: nowrap;\n  }\n\n  .react-datepicker__day-name,\n  .react-datepicker__day,\n  .react-datepicker__time-name {\n    color: ", ";\n    display: inline-block;\n    text-align: center;\n    margin: 0.166rem;\n  }\n\n  .react-datepicker__month--selected,\n  .react-datepicker__month--in-selecting-range,\n  .react-datepicker__month--in-range,\n  .react-datepicker__quarter--selected,\n  .react-datepicker__quarter--in-selecting-range,\n  .react-datepicker__quarter--in-range {\n    border-radius: 0.3rem;\n    background-color: ", ";\n    color: ", ";\n  }\n\n  .react-datepicker__month--selected:hover,\n  .react-datepicker__month--in-selecting-range:hover,\n  .react-datepicker__month--in-range:hover,\n  .react-datepicker__quarter--selected:hover,\n  .react-datepicker__quarter--in-selecting-range:hover,\n  .react-datepicker__quarter--in-range:hover {\n    background-color: ", ";\n  }\n\n  .react-datepicker__month--disabled,\n  .react-datepicker__quarter--disabled {\n    color: ", ";\n    pointer-events: none;\n  }\n\n  .react-datepicker__month--disabled:hover,\n  .react-datepicker__quarter--disabled:hover {\n    cursor: default;\n    background-color: transparent;\n  }\n\n  .react-datepicker__day,\n  .react-datepicker__month-text,\n  .react-datepicker__quarter-text {\n    cursor: pointer;\n  }\n\n  .react-datepicker__day:hover,\n  .react-datepicker__month-text:hover,\n  .react-datepicker__quarter-text:hover {\n    border-radius: 0.3rem;\n    background-color: ", ";\n  }\n\n  .react-datepicker__day--today,\n  .react-datepicker__month-text--today,\n  .react-datepicker__quarter-text--today {\n    font-weight: bold;\n  }\n\n  .react-datepicker__day--highlighted,\n  .react-datepicker__month-text--highlighted,\n  .react-datepicker__quarter-text--highlighted {\n    border-radius: 0.3rem;\n    background-color: ", ";\n    color: ", ";\n  }\n\n  .react-datepicker__day--highlighted:hover,\n  .react-datepicker__month-text--highlighted:hover,\n  .react-datepicker__quarter-text--highlighted:hover {\n    background-color: ", ";\n  }\n\n  .react-datepicker__day--highlighted-custom-1,\n  .react-datepicker__month-text--highlighted-custom-1,\n  .react-datepicker__quarter-text--highlighted-custom-1 {\n    color: magenta;\n  }\n\n  .react-datepicker__day--highlighted-custom-2,\n  .react-datepicker__month-text--highlighted-custom-2,\n  .react-datepicker__quarter-text--highlighted-custom-2 {\n    color: green400;\n  }\n\n  .react-datepicker__day--selected,\n  .react-datepicker__day--in-selecting-range,\n  .react-datepicker__day--in-range,\n  .react-datepicker__month-text--selected,\n  .react-datepicker__month-text--in-selecting-range,\n  .react-datepicker__month-text--in-range,\n  .react-datepicker__quarter-text--selected,\n  .react-datepicker__quarter-text--in-selecting-range,\n  .react-datepicker__quarter-text--in-range {\n    border-radius: 0.3rem;\n    background-color: ", ";\n    color: ", ";\n  }\n\n  .react-datepicker__day--selected:hover,\n  .react-datepicker__day--in-selecting-range:hover,\n  .react-datepicker__day--in-range:hover,\n  .react-datepicker__month-text--selected:hover,\n  .react-datepicker__month-text--in-selecting-range:hover,\n  .react-datepicker__month-text--in-range:hover,\n  .react-datepicker__quarter-text--selected:hover,\n  .react-datepicker__quarter-text--in-selecting-range:hover,\n  .react-datepicker__quarter-text--in-range:hover {\n    background-color: ", ";\n  }\n\n  .react-datepicker__day--keyboard-selected,\n  .react-datepicker__month-text--keyboard-selected,\n  .react-datepicker__quarter-text--keyboard-selected {\n    border-radius: 0.3rem;\n    background-color: ", ";\n    color: ", ";\n  }\n\n  .react-datepicker__day--keyboard-selected:hover,\n  .react-datepicker__month-text--keyboard-selected:hover,\n  .react-datepicker__quarter-text--keyboard-selected:hover {\n    background-color: ", ";\n  }\n\n  .react-datepicker__day--in-selecting-range,\n  .react-datepicker__month-text--in-selecting-range,\n  .react-datepicker__quarter-text--in-selecting-range {\n    background-color: rgba(33, 107, 165, 0.5);\n  }\n\n  .react-datepicker__month--selecting-range .react-datepicker__day--in-range,\n  .react-datepicker__month--selecting-range .react-datepicker__month-text--in-range,\n  .react-datepicker__month--selecting-range .react-datepicker__quarter-text--in-range {\n    background-color: ", ";\n    color: ", ";\n  }\n\n  .react-datepicker__day--disabled,\n  .react-datepicker__month-text--disabled,\n  .react-datepicker__quarter-text--disabled {\n    cursor: default;\n    color: ", ";\n    background-color: ", ";\n  }\n\n  .react-datepicker__day--disabled:hover,\n  .react-datepicker__month-text--disabled:hover,\n  .react-datepicker__quarter-text--disabled:hover {\n    background-color: ", ";\n  }\n\n  .react-datepicker__month-text.react-datepicker__month--selected:hover,\n  .react-datepicker__month-text.react-datepicker__month--in-range:hover,\n  .react-datepicker__month-text.react-datepicker__quarter--selected:hover,\n  .react-datepicker__month-text.react-datepicker__quarter--in-range:hover,\n  .react-datepicker__quarter-text.react-datepicker__month--selected:hover,\n  .react-datepicker__quarter-text.react-datepicker__month--in-range:hover,\n  .react-datepicker__quarter-text.react-datepicker__quarter--selected:hover,\n  .react-datepicker__quarter-text.react-datepicker__quarter--in-range:hover {\n    background-color: ", ";\n  }\n\n  .react-datepicker__month-text:hover,\n  .react-datepicker__quarter-text:hover {\n    background-color: ", ";\n  }\n\n  .react-datepicker__input-container {\n    position: relative;\n    display: inline-block;\n    width: 100%;\n  }\n\n  .react-datepicker__year-read-view,\n  .react-datepicker__month-read-view,\n  .react-datepicker__month-year-read-view {\n    border: 1px solid transparent;\n    border-radius: 0.3rem;\n  }\n\n  .react-datepicker__year-read-view:hover,\n  .react-datepicker__month-read-view:hover,\n  .react-datepicker__month-year-read-view:hover {\n    cursor: pointer;\n  }\n\n  .react-datepicker__year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__year-read-view:hover .react-datepicker__month-read-view--down-arrow,\n  .react-datepicker__month-read-view:hover .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__month-read-view:hover .react-datepicker__month-read-view--down-arrow,\n  .react-datepicker__month-year-read-view:hover .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__month-year-read-view:hover .react-datepicker__month-read-view--down-arrow {\n    border-top-color: ", ";\n  }\n\n  .react-datepicker__year-read-view--down-arrow,\n  .react-datepicker__month-read-view--down-arrow,\n  .react-datepicker__month-year-read-view--down-arrow {\n    border-top-color: ", ";\n    float: right;\n    margin-left: 20px;\n    top: 8px;\n    position: relative;\n    border-width: 0.45rem;\n  }\n\n  .react-datepicker__year-dropdown,\n  .react-datepicker__month-dropdown,\n  .react-datepicker__month-year-dropdown {\n    background-color: ", ";\n    position: absolute;\n    width: 50%;\n    left: 25%;\n    top: 30px;\n    z-index: 1;\n    text-align: center;\n    border-radius: 0.3rem;\n    border: 1px solid ", ";\n  }\n\n  .react-datepicker__year-dropdown:hover,\n  .react-datepicker__month-dropdown:hover,\n  .react-datepicker__month-year-dropdown:hover {\n    cursor: pointer;\n  }\n\n  .react-datepicker__year-dropdown--scrollable,\n  .react-datepicker__month-dropdown--scrollable,\n  .react-datepicker__month-year-dropdown--scrollable {\n    height: 150px;\n    overflow-y: scroll;\n  }\n\n  .react-datepicker__year-option,\n  .react-datepicker__month-option,\n  .react-datepicker__month-year-option {\n    line-height: 20px;\n    width: 100%;\n    display: block;\n    margin-left: auto;\n    margin-right: auto;\n  }\n\n  .react-datepicker__year-option:first-of-type,\n  .react-datepicker__month-option:first-of-type,\n  .react-datepicker__month-year-option:first-of-type {\n    border-top-left-radius: 0.3rem;\n    border-top-right-radius: 0.3rem;\n  }\n\n  .react-datepicker__year-option:last-of-type,\n  .react-datepicker__month-option:last-of-type,\n  .react-datepicker__month-year-option:last-of-type {\n    -webkit-user-select: none;\n    -moz-user-select: none;\n    -ms-user-select: none;\n    user-select: none;\n    border-bottom-left-radius: 0.3rem;\n    border-bottom-right-radius: 0.3rem;\n  }\n\n  .react-datepicker__year-option:hover,\n  .react-datepicker__month-option:hover,\n  .react-datepicker__month-year-option:hover {\n    background-color: ", ";\n  }\n\n  .react-datepicker__year-option:hover .react-datepicker__navigation--years-upcoming,\n  .react-datepicker__month-option:hover .react-datepicker__navigation--years-upcoming,\n  .react-datepicker__month-year-option:hover .react-datepicker__navigation--years-upcoming {\n    border-bottom-color: ", ";\n  }\n\n  .react-datepicker__year-option:hover .react-datepicker__navigation--years-previous,\n  .react-datepicker__month-option:hover .react-datepicker__navigation--years-previous,\n  .react-datepicker__month-year-option:hover .react-datepicker__navigation--years-previous {\n    border-top-color: ", ";\n  }\n\n  .react-datepicker__year-option--selected,\n  .react-datepicker__month-option--selected,\n  .react-datepicker__month-year-option--selected {\n    position: absolute;\n    left: 15px;\n  }\n\n  .react-datepicker__close-icon {\n    cursor: pointer;\n    background-color: transparent;\n    border: 0;\n    outline: 0;\n    padding: 0px 6px 0px 0px;\n    position: absolute;\n    top: 0;\n    right: 0;\n    height: 100%;\n    display: table-cell;\n    vertical-align: middle;\n  }\n\n  .react-datepicker__close-icon::after {\n    cursor: pointer;\n    background-color: ", ";\n    color: ", ";\n    border-radius: 50%;\n    height: 16px;\n    width: 16px;\n    padding: 2px;\n    font-size: 12px;\n    line-height: 1;\n    text-align: center;\n    display: table-cell;\n    vertical-align: middle;\n    content: '\\\\00d7';\n  }\n\n  .react-datepicker__today-button {\n    background: ", ";\n    border-top: 1px solid ", ";\n    cursor: pointer;\n    text-align: center;\n    font-weight: bold;\n    padding: 5px 0;\n    clear: left;\n  }\n\n  .react-datepicker__portal {\n    position: fixed;\n    width: 100vw;\n    height: 100vh;\n    background-color: rgba(0, 0, 0, 0.8);\n    left: 0;\n    top: 0;\n    justify-content: center;\n    align-items: center;\n    display: flex;\n    z-index: 2147483647;\n  }\n\n  .react-datepicker__portal .react-datepicker__day-name,\n  .react-datepicker__portal .react-datepicker__day,\n  .react-datepicker__portal .react-datepicker__time-name {\n    width: 3rem;\n    line-height: 3rem;\n  }\n\n  @media (max-width: 400px), (max-height: 550px) {\n    .react-datepicker__portal .react-datepicker__day-name,\n    .react-datepicker__portal .react-datepicker__day,\n    .react-datepicker__portal .react-datepicker__time-name {\n      width: 20px;\n      line-height: 20px;\n    }\n  }\n\n  .react-datepicker__portal .react-datepicker__current-month,\n  .react-datepicker__portal .react-datepicker-time__header {\n    font-size: 1.44rem;\n  }\n\n  .react-datepicker__portal .react-datepicker__navigation {\n    border: 0.81rem solid transparent;\n  }\n\n  .react-datepicker__portal .react-datepicker__navigation--previous {\n    border-right-color: ", ";\n  }\n\n  .react-datepicker__portal .react-datepicker__navigation--previous:hover {\n    border-right-color: ", ";\n  }\n\n  .react-datepicker__portal .react-datepicker__navigation--previous--disabled,\n  .react-datepicker__portal .react-datepicker__navigation--previous--disabled:hover {\n    border-right-color: ", ";\n    cursor: default;\n  }\n\n  .react-datepicker__portal .react-datepicker__navigation--next {\n    border-left-color: ", ";\n  }\n\n  .react-datepicker__portal .react-datepicker__navigation--next:hover {\n    border-left-color: ", ";\n  }\n\n  .react-datepicker__portal .react-datepicker__navigation--next--disabled,\n  .react-datepicker__portal .react-datepicker__navigation--next--disabled:hover {\n    border-left-color: ", ";\n    cursor: default;\n  }\n\n  .react-datepicker-wrapper {\n    width: 100%;\n  }\n\n  .datepicker-calendar {\n    font-family: ", ";\n    border: none;\n    box-shadow: 0px 2px 6px rgba(0, 0, 0, 0.05), 0px 0px 0px 1px rgba(0, 0, 0, 0.07);\n    border-radius: 4px;\n    padding: ", "px;\n\n    .react-datepicker__triangle {\n      &::before {\n        border-bottom-color: ", ";\n      }\n    }\n    .react-datepicker__navigation {\n      top: unset;\n      &--previous {\n        left: unset;\n      }\n    }\n    .react-datepicker__header {\n      margin-top: -5px;\n      padding-top: 0px;\n      background-color: ", ";\n      border-bottom: none;\n      .react-datepicker__current-month {\n        font-size: 1.8rem;\n        margin-bottom: ", "px;\n        text-transform: capitalize;\n      }\n    }\n\n    .react-datepicker__day-name {\n      font-size: 1rem;\n      color: ", ";\n      width: 3.9rem;\n      margin: 0;\n      text-transform: capitalize;\n    }\n    .react-datepicker__day,\n    .react-datepicker__month-text {\n      margin: 0;\n      font-size: 1.3rem;\n    }\n\n    .react-datepicker__week:last-child {\n      .react-datepicker__day {\n        border-bottom: 1px solid ", ";\n      }\n    }\n\n    .react-datepicker__day {\n      width: 3.9rem;\n      height: 3.6rem;\n      padding: ", "px;\n      border-top: 1px solid ", ";\n      border-right: 1px solid ", ";\n      border-radius: 0;\n\n      &:first-child {\n        border-left: 1px solid ", ";\n      }\n\n      &.react-datepicker__day--outside-month {\n        color: ", ";\n      }\n\n      &.react-datepicker__day--selected,\n      &.react-datepicker__day--keyboard-selected {\n        background-color: ", ";\n        font-weight: 600;\n      }\n\n      &:focus {\n        outline: 0;\n      }\n    }\n\n    .react-datepicker__month-wrapper {\n      .react-datepicker__month-text:last-child {\n        border-right: 1px solid ", ";\n      }\n    }\n\n    .react-datepicker__month-wrapper:last-child {\n      .react-datepicker__month-text {\n        border-bottom: 1px solid ", ";\n      }\n    }\n\n    .react-datepicker__month-text {\n      width: 33.33%;\n      line-height: 4rem;\n      height: 4rem;\n      padding: 0px ", "px;\n      border-top: 1px solid ", ";\n      border-left: 1px solid ", ";\n      border-radius: 0;\n      text-transform: capitalize;\n\n      &.react-datepicker__month--selected,\n      &.react-datepicker__month--keyboard-selected {\n        background-color: ", ";\n        font-weight: 600;\n      }\n\n      &:focus {\n        outline: 0;\n      }\n    }\n  }\n  .react-datepicker-popper {\n    z-index: 5;\n  }\n"])), theme.colors.white, theme.colors.white, theme.global.defaultFont, theme.colors.white, theme.colors.grey700, theme.colors.grey700, theme.colors.grey700, theme.colors.grey400, theme.colors.grey700, theme.colors.grey700, theme.colors.grey100, theme.colors.grey100, theme.colors.grey700, theme.colors.grey100, theme.colors.grey100, theme.colors.grey700, theme.colors.grey100, theme.colors.grey700, theme.colors.grey100, theme.colors.grey700, theme.colors.grey700, theme.colors.grey100, theme.colors.blue400, theme.colors.blue400, theme.colors.grey700, theme.colors.grey700, theme.colors.grey100, theme.colors.grey700, theme.colors.blue400, theme.colors.white, theme.colors.blue400, theme.colors.grey700, theme.colors.grey100, theme.colors.green400, theme.colors.white, theme.colors.green400, theme.colors.blue400, theme.colors.white, theme.colors.blue400, theme.colors.blue400, theme.colors.white, theme.colors.blue400, theme.colors.grey700, theme.colors.grey700, theme.colors.grey400, theme.colors.grey100, theme.colors.grey100, theme.colors.blue400, theme.colors.grey100, theme.colors.grey700, theme.colors.grey700, theme.colors.grey700, theme.colors.grey700, theme.colors.grey700, theme.colors.grey700, theme.colors.grey700, theme.colors.blue400, theme.colors.white, theme.colors.grey700, theme.colors.grey700, theme.colors.grey700, theme.colors.grey700, theme.colors.grey700, theme.colors.grey700, theme.colors.grey700, theme.colors.grey700, theme.global.defaultFont, theme.global.gutterSpace, theme.colors.white, theme.colors.white, theme.global.gutterSpace / 2, theme.colors.grey700, theme.colors.grey400, theme.global.gutterSpace / 2, theme.colors.grey400, theme.colors.grey400, theme.colors.grey400, theme.colors.grey400, theme.colors.purple600, theme.colors.grey400, theme.colors.grey400, theme.global.gutterSpace * 1.5, theme.colors.grey400, theme.colors.grey400, theme.colors.purple600); };
var templateObject_1$V;

var VendorStyles = createGlobalStyle(reactDatepickerStyles);

var spinnerBorder = function (props) { return keyframes(templateObject_1$U || (templateObject_1$U = __makeTemplateObject(["\n    to {\n      transform: rotate(360deg);\n    }\n"], ["\n    to {\n      transform: rotate(360deg);\n    }\n"]))); };
var Container$7 = styled.div(templateObject_2$K || (templateObject_2$K = __makeTemplateObject(["\n  border: ", "px solid ", ";\n  animation: ", " 0.75s linear infinite;\n  border-right-color: transparent;\n  border-radius: 50%;\n  width: ", "px;\n  height: ", "px;\n"], ["\n  border: ", "px solid ", ";\n  animation: ", " 0.75s linear infinite;\n  border-right-color: transparent;\n  border-radius: 50%;\n  width: ", "px;\n  height: ", "px;\n"])), function (props) { return props.thickness || 5; }, function (props) { return (props.color ? props.theme.colors[props.color] : props.theme.colors.purple600); }, spinnerBorder, function (props) { return props.size || 50; }, function (props) { return props.size || 50; });
var templateObject_1$U, templateObject_2$K;

var BasicLoading = function (props) {
    var color = props.color, thickness = props.thickness, size = props.size, className = props.className, testId = props.testId;
    return React__default.createElement(Container$7, { className: className, color: color, thickness: thickness, size: size, "data-testid": testId });
};

var loadingSizes = {
    small: 12,
    medium: 16,
    large: 20,
};
var buttonsColors$1 = function (color, variant, customButtonColor, customTextColor) {
    var backgroundColors = {
        primary: theme.colors.purple600,
        secondary: theme.colors.purple100,
        confirm: theme.colors.green700,
        'confirm-light': theme.colors.green100,
        remove: theme.colors.red700,
        'remove-light': theme.colors.red100,
        default: theme.colors.purple600,
    };
    var fontColors = {
        primary: theme.colors.white,
        secondary: theme.colors.purple600,
        confirm: theme.colors.white,
        'confirm-light': theme.colors.green700,
        remove: theme.colors.white,
        'remove-light': theme.colors.red700,
        default: theme.colors.white,
    };
    var backgroundColor = customButtonColor || (variant === 'text' ? theme.colors.white : backgroundColors[color || 'default']);
    var textColor = customTextColor || (variant === 'text' ? theme.colors.purple600 : fontColors[color || 'default']);
    var backgroundHover = curriedDarken$1(color === 'secondary' || ['remove-light', 'confirm-light'].includes(color) ? 0.03 : 0.15, backgroundColor);
    if (variant === 'outlined') {
        return css(templateObject_2$J || (templateObject_2$J = __makeTemplateObject(["\n      background-color: ", ";\n      color: ", ";\n      border: solid 1px ", ";\n\n      &:hover {\n        background: ", ";\n      }\n\n      &:active {\n        background-color: ", ";\n        background-size: 100%;\n        transition: background 0s;\n      }\n    "], ["\n      background-color: ", ";\n      color: ", ";\n      border: solid 1px ", ";\n\n      &:hover {\n        background: ",
            ";\n      }\n\n      &:active {\n        background-color: ", ";\n        background-size: 100%;\n        transition: background 0s;\n      }\n    "])), theme.colors.white, theme.colors.grey400, theme.colors.grey400, css(templateObject_1$T || (templateObject_1$T = __makeTemplateObject(["\n          ", " radial-gradient(circle, transparent 1%, ", " 1%) center/15000%\n        "], ["\n          ", " radial-gradient(circle, transparent 1%, ", " 1%) center/15000%\n        "])), curriedDarken$1(0.1, theme.colors.white), curriedDarken$1(0.1, theme.colors.white)), theme.colors.white);
    }
    return css(templateObject_4$D || (templateObject_4$D = __makeTemplateObject(["\n    color: ", ";\n    background-color: ", ";\n    &:hover {\n      background: ", " radial-gradient(circle, transparent 1%, ", " 1%) center/15000%;\n    }\n\n    &:active {\n      background-color: ", ";\n      background-size: 100%;\n      transition: background 0s;\n    }\n\n    ", "\n  "], ["\n    color: ", ";\n    background-color: ", ";\n    &:hover {\n      background: ", " radial-gradient(circle, transparent 1%, ", " 1%) center/15000%;\n    }\n\n    &:active {\n      background-color: ", ";\n      background-size: 100%;\n      transition: background 0s;\n    }\n\n    ",
        "\n  "])), textColor, backgroundColor, backgroundHover, backgroundHover, curriedLighten$1(0.05, backgroundColor), variant === 'text' && css(templateObject_3$F || (templateObject_3$F = __makeTemplateObject(["\n      background-color: unset;\n      &&:hover {\n        box-shadow: unset;\n        background: unset;\n        color: ", ";\n      }\n\n      &&:active {\n        color: ", ";\n      }\n\n      &&&:disabled {\n        background: transparent;\n      }\n    "], ["\n      background-color: unset;\n      &&:hover {\n        box-shadow: unset;\n        background: unset;\n        color: ", ";\n      }\n\n      &&:active {\n        color: ", ";\n      }\n\n      &&&:disabled {\n        background: transparent;\n      }\n    "])), curriedLighten$1(0.2, textColor), curriedDarken$1(0.2, textColor)));
};
var buttonSizes = function (size, gutterSpace, variant) {
    var sizes = {
        small: css(templateObject_5$x || (templateObject_5$x = __makeTemplateObject(["\n      padding: ", "px ", "px;\n      font-size: ", ";\n    "], ["\n      padding: ", "px ", "px;\n      font-size: ", ";\n    "])), gutterSpace * 0.5, gutterSpace, theme.fontSizes[2]),
        medium: css(templateObject_7$u || (templateObject_7$u = __makeTemplateObject(["\n      padding: ", "px ", "px;\n      font-size: ", ";\n      ", "\n    "], ["\n      padding: ", "px ", "px;\n      font-size: ", ";\n      ",
            "\n    "])), Math.round(gutterSpace * 0.75), gutterSpace * 1.5, theme.fontSizes[2], variant === 'text' && css(templateObject_6$u || (templateObject_6$u = __makeTemplateObject(["\n        padding: ", "px;\n      "], ["\n        padding: ", "px;\n      "])), gutterSpace * 0.75)),
        large: css(templateObject_8$p || (templateObject_8$p = __makeTemplateObject(["\n      padding: ", "px ", "px;\n      font-size: ", ";\n    "], ["\n      padding: ", "px ", "px;\n      font-size: ", ";\n    "])), Math.round(gutterSpace), gutterSpace * 1.5, theme.fontSizes[3]),
    };
    return sizes[size] || sizes['medium'];
};
// eslint-disable-next-line react/button-has-type
var StyledButton$1 = styled(function (_a) {
    _a.loading; _a.buttonColor; _a.textColor; var otherProps = __rest(_a, ["loading", "buttonColor", "textColor"]);
    return React__default.createElement("button", __assign$2({}, otherProps));
})(templateObject_11$c || (templateObject_11$c = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  font-family: ", ";\n  font-weight: 400;\n  color: ", ";\n  border-radius: ", "px;\n  border: none;\n  line-height: ", "px;\n  outline: none;\n  transition: background-color 250ms, box-shadow 250ms, background 500ms, color 500ms, fill 500ms ease-out;\n  background-position: center;\n\n  ", ";\n  ", "\n\n  span {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  & span svg:first-child,\n  & span img:first-child {\n    margin-right: ", "px;\n  }\n\n  & span svg:last-child,\n  & span img:last-child {\n    margin-left: ", "px;\n  }\n\n  &&:disabled {\n    background: ", ";\n    border-color: ", ";\n    cursor: initial;\n    box-shadow: none;\n\n    span {\n      color: ", ";\n    }\n\n    ", "\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  font-family: ", ";\n  font-weight: 400;\n  color: ", ";\n  border-radius: ", "px;\n  border: none;\n  line-height: ", "px;\n  outline: none;\n  transition: background-color 250ms, box-shadow 250ms, background 500ms, color 500ms, fill 500ms ease-out;\n  background-position: center;\n\n  ", ";\n  ", "\n\n  span {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n  }\n\n  & span svg:first-child,\n  & span img:first-child {\n    margin-right: ", "px;\n  }\n\n  & span svg:last-child,\n  & span img:last-child {\n    margin-left: ", "px;\n  }\n\n  &&:disabled {\n    background: ", ";\n    border-color: ", ";\n    cursor: initial;\n    box-shadow: none;\n\n    span {\n      color: ", ";\n    }\n\n    ",
    "\n  }\n"])), function (props) { return props.theme.global.defaultFont; }, function (props) { return props.textColor || props.theme.colors.white; }, function (props) { return props.theme.forms.borderRadius; }, function (props) { return props.theme.global.gutterSpace; }, function (props) { return buttonSizes(props.size, props.theme.global.gutterSpace, props.variant); }, function (props) { return buttonsColors$1(props.color, props.variant, props.buttonColor, props.textColor); }, function (props) { return props.theme.global.gutterSpace * 0.625; }, function (props) { return props.theme.global.gutterSpace * 0.625; }, function (props) { return props.theme.colors.grey100; }, function (props) { return props.theme.colors.grey100; }, function (props) { return props.theme.colors.grey700; }, function (props) {
    return props.loading
        ? css(templateObject_9$i || (templateObject_9$i = __makeTemplateObject(["\n            color: ", ";\n            & svg {\n              fill: ", ";\n            }\n            & img {\n              opacity: 0.4;\n            }\n          "], ["\n            color: ", ";\n            & svg {\n              fill: ", ";\n            }\n            & img {\n              opacity: 0.4;\n            }\n          "])), rgba(props.theme.colors.grey400, 0.4), rgba(props.theme.colors.grey400, 0.4)) : css(templateObject_10$g || (templateObject_10$g = __makeTemplateObject(["\n            color: ", ";\n            & svg {\n              fill: ", ";\n            }\n          "], ["\n            color: ", ";\n            & svg {\n              fill: ", ";\n            }\n          "])), props.theme.colors.grey400, props.theme.colors.grey400);
});
var ButtonContainerLoading = styled.div(templateObject_12$b || (templateObject_12$b = __makeTemplateObject(["\n  position: absolute;\n"], ["\n  position: absolute;\n"])));
var templateObject_1$T, templateObject_2$J, templateObject_3$F, templateObject_4$D, templateObject_5$x, templateObject_6$u, templateObject_7$u, templateObject_8$p, templateObject_9$i, templateObject_10$g, templateObject_11$c, templateObject_12$b;

var Button$1 = function (props) {
    var children = props.children, disabled = props.disabled, loading = props.loading, testId = props.testId, as = props.as, otherProps = __rest(props, ["children", "disabled", "loading", "testId", "as"]);
    var childrenWithNode = Children.map(children, function (child) {
        if (typeof child === 'string') {
            return React__default.createElement("span", null, child);
        }
        return child;
    });
    return (React__default.createElement(StyledButton$1, __assign$2({ as: as, "data-testid": testId, disabled: disabled || loading, loading: loading }, otherProps),
        React__default.createElement("span", null, childrenWithNode),
        loading && (React__default.createElement(ButtonContainerLoading, null,
            React__default.createElement(BasicLoading, { size: loadingSizes[otherProps.size || 'medium'], thickness: 2, color: "purple600" })))));
};

var useStylesBootstrap = makeStyles(function () { return ({
    arrow: {
        color: rgba(theme.colors.grey700, 0.9),
    },
}); });
var ChildrenTooltipContent = styled.div(templateObject_2$I || (templateObject_2$I = __makeTemplateObject(["\n  display: inline-block;\n\n  ", "\n"], ["\n  display: inline-block;\n\n  ",
    "\n"])), function (props) {
    return props.$display === 'block' && css(templateObject_1$S || (templateObject_1$S = __makeTemplateObject(["\n      width: fit-content;\n      display: block;\n    "], ["\n      width: fit-content;\n      display: block;\n    "])));
});
var templateObject_1$S, templateObject_2$I;

var AgilizeTooltip = function (props) {
    var title = props.title, children = props.children, enterTouchDelay = props.enterTouchDelay, testId = props.testId, display = props.display, tooltipClassName = props.tooltipClassName, tooltipWidth = props.tooltipWidth, restProps = __rest(props, ["title", "children", "enterTouchDelay", "testId", "display", "tooltipClassName", "tooltipWidth"]);
    var classes = __assign$2(__assign$2(__assign$2({}, useStylesBootstrap()), { popper: tooltipClassName }), makeStyles$1(function () { return ({
        tooltip: {
            borderRadius: '4px',
            maxWidth: tooltipWidth || 220,
            padding: theme.global.gutterSpace / 4 + "px " + theme.global.gutterSpace / 2 + "px",
            backgroundColor: rgba(theme.colors.grey700, 0.9),
            fontSize: theme.fontSizes[1],
            fontWeight: 'normal',
            color: theme.colors.white,
            fontFamily: theme.global.defaultFont,
            lineHeight: '14px',
        },
    }); })());
    return (React__default.createElement(Tooltip$1, __assign$2({ arrow: true, title: title || '', "data-testid": testId, classes: classes, enterTouchDelay: enterTouchDelay || 0 }, restProps),
        React__default.createElement(ChildrenTooltipContent, { "$display": display }, children)));
};

var myInput = Math.round(theme.global.gutterSpace / 2);
var StyledLabelContainer = styled.div(templateObject_2$H || (templateObject_2$H = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n  width: 100%;\n\n  ", "\n"], ["\n  display: flex;\n  flex-direction: row;\n  align-items: baseline;\n  width: 100%;\n\n  ",
    "\n"])), function (props) {
    return props.horizontalLabel && css(templateObject_1$R || (templateObject_1$R = __makeTemplateObject(["\n      width: 40%;\n      flex-direction: column;\n      padding-top: ", "px;\n      ", " {\n        width: unset;\n        padding-top: 0;\n      }\n    "], ["\n      width: 40%;\n      flex-direction: column;\n      padding-top: ", "px;\n      ", " {\n        width: unset;\n        padding-top: 0;\n      }\n    "])), props.theme.forms.defaultHeight / 4, device.mobile);
});
var StyledLabel = styled.label(templateObject_6$t || (templateObject_6$t = __makeTemplateObject(["\n  display: flex;\n  flex: 1;\n  font-family: ", ";\n  font-style: normal;\n  font-weight: 400;\n  font-size: ", ";\n  color: ", ";\n  margin-bottom: ", "px;\n  line-height: ", "px;\n\n  & > span {\n    color: ", ";\n  }\n\n  ", "\n\n  ", "\n\n    ", "\n"], ["\n  display: flex;\n  flex: 1;\n  font-family: ", ";\n  font-style: normal;\n  font-weight: 400;\n  font-size: ", ";\n  color: ", ";\n  margin-bottom: ", "px;\n  line-height: ", "px;\n\n  & > span {\n    color: ", ";\n  }\n\n  ",
    "\n\n  ",
    "\n\n    ",
    "\n"])), function (props) { return props.theme.global.defaultFont; }, function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.colors.grey900; }, myInput, function (props) { return props.theme.global.gutterSpace; }, function (props) { return props.theme.colors.red400; }, function (props) {
    return props.optional && css(templateObject_3$E || (templateObject_3$E = __makeTemplateObject(["\n      &::after {\n        content: '(opcional)';\n        font-style: italic;\n        font-weight: normal;\n        font-family: ", ";\n        font-size: ", ";\n        color: ", ";\n        margin-left: 4px;\n      }\n    "], ["\n      &::after {\n        content: '(opcional)';\n        font-style: italic;\n        font-weight: normal;\n        font-family: ", ";\n        font-size: ", ";\n        color: ", ";\n        margin-left: 4px;\n      }\n    "])), props.theme.global.defaultFont, props.theme.fontSizes[1], props.theme.colors.grey400);
}, function (props) {
    return props.readOnly && css(templateObject_4$C || (templateObject_4$C = __makeTemplateObject(["\n      color: ", ";\n      font-weight: 400;\n      font-size: ", ";\n    "], ["\n      color: ", ";\n      font-weight: 400;\n      font-size: ", ";\n    "])), props.theme.colors.grey700, props.theme.fontSizes[2]);
}, function (props) {
    return props.inputHeight && css(templateObject_5$w || (templateObject_5$w = __makeTemplateObject(["\n      margin-bottom: ", "px;\n    "], ["\n      margin-bottom: ", "px;\n    "])), props.inputHeight * 0.27);
});
var StyledHelperInput = styled.div(templateObject_11$b || (templateObject_11$b = __makeTemplateObject(["\n  margin-top: ", "px;\n  font-style: normal;\n  font-weight: normal;\n  font-size: ", ";\n  color: ", ";\n\n  ", "\n"], ["\n  margin-top: ", "px;\n  font-style: normal;\n  font-weight: normal;\n  font-size: ", ";\n  color: ", ";\n\n  ",
    "\n"])), myInput / 2, function (props) { return props.theme.fontSizes[1]; }, function (props) { return (props.error ? props.theme.colors.red700 : props.theme.colors.grey700); }, function (props) {
    return props.horizontalLabel && css(templateObject_10$f || (templateObject_10$f = __makeTemplateObject(["\n      ", "\n\n      ", "\n\n      ", "\n    "], ["\n      ",
        "\n\n      ",
        "\n\n      ",
        "\n    "])), props.bottom && css(templateObject_7$t || (templateObject_7$t = __makeTemplateObject(["\n        display: none;\n        ", " {\n          display: block;\n        }\n      "], ["\n        display: none;\n        ", " {\n          display: block;\n        }\n      "])), device.mobile), props.error && css(templateObject_8$o || (templateObject_8$o = __makeTemplateObject(["\n        display: block;\n      "], ["\n        display: block;\n      "]))), !props.bottom && css(templateObject_9$h || (templateObject_9$h = __makeTemplateObject(["\n        margin-top: 0;\n        ", " {\n          display: none;\n        }\n      "], ["\n        margin-top: 0;\n        ", " {\n          display: none;\n        }\n      "])), device.mobile));
});
var Tooltip = styled(AgilizeTooltip)(templateObject_12$a || (templateObject_12$a = __makeTemplateObject(["\n  margin-left: ", "px;\n"], ["\n  margin-left: ", "px;\n"])), function (props) { return props.theme.global.gutterSpace / 4; });
var StyledIconInputContainer = styled.div(templateObject_13$8 || (templateObject_13$8 = __makeTemplateObject(["\n  display: flex;\n  align-self: center;\n  height: fit-content;\n  width: fit-content;\n\n  ", "\n"], ["\n  display: flex;\n  align-self: center;\n  height: fit-content;\n  width: fit-content;\n\n  ",
    "\n"])), function (props) {
    return props.hasMarginLeft &&
        "\n    margin-left: " + props.theme.global.gutterSpace / 4 + "px;\n  ";
});
var ReadOnlyValue = styled.span(templateObject_15$6 || (templateObject_15$6 = __makeTemplateObject(["\n  font-weight: 600;\n  font-size: ", ";\n  color: ", ";\n  ", "\n"], ["\n  font-weight: 600;\n  font-size: ", ";\n  color: ", ";\n  ",
    "\n"])), function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.colors.grey900; }, function (props) {
    return props.hasThumb && css(templateObject_14$6 || (templateObject_14$6 = __makeTemplateObject(["\n      margin-left: ", "px;\n    "], ["\n      margin-left: ", "px;\n    "])), props.theme.global.gutterSpace / 2);
});
var templateObject_1$R, templateObject_2$H, templateObject_3$E, templateObject_4$C, templateObject_5$w, templateObject_6$t, templateObject_7$t, templateObject_8$o, templateObject_9$h, templateObject_10$f, templateObject_11$b, templateObject_12$a, templateObject_13$8, templateObject_14$6, templateObject_15$6;

var CustomBox = styled.div(templateObject_1$Q || (templateObject_1$Q = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), space, color, typography, layout, flexbox, function (props) { return (props.textTransform ? "text-transform: " + props.textTransform : ''); }, function (props) { return (props.textDecoration ? "text-decoration: " + props.textDecoration : ''); });
var Box = function (props) { return React__default.createElement(CustomBox, __assign$2({}, props)); };
var templateObject_1$Q;

var ReadOnlyField = function (props) {
    var label = props.label, value = props.value, iconTooltip = props.iconTooltip, textTooltip = props.textTooltip, testId = props.testId, thumb = props.thumb;
    return (React__default.createElement(React__default.Fragment, null,
        label && (React__default.createElement(StyledLabel, { as: "div", readOnly: true },
            label,
            iconTooltip && textTooltip && (React__default.createElement(AgilizeTooltip, { title: textTooltip },
                React__default.createElement(StyledIconInputContainer, { hasMarginLeft: true }, iconTooltip))))),
        React__default.createElement(Box, { display: "flex", alignItems: "center" },
            thumb,
            React__default.createElement(ReadOnlyValue, { hasThumb: isValidElement(thumb), "data-testid": testId + "-read-only" }, value || '-'))));
};

var __read$3 = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var styleToObject = function (input) {
    var attributes = input.split(/ ?; ?/);
    return attributes.reduce(function (acc, d) {
        var _a = __read$3(d.split(/ ?: ?/), 2), key = _a[0], value = _a[1];
        if (key && value) {
            acc[key.replace(/-(\w)/g, function (_$0, $1) { return $1.toUpperCase(); })] = Number.isNaN(Number(value))
                ? value
                : Number(value);
        }
        return acc;
    }, {});
};
/* istanbul ignore next */
function randomString$1(length) {
    if (length === void 0) { length = 6; }
    var characters = '0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ';
    var result = '';
    for (var index = length; index > 0; --index) {
        result += characters[Math.round(Math.random() * (characters.length - 1))];
    }
    return result;
}
var noTextChildNodes = [
    'br',
    'col',
    'colgroup',
    'dl',
    'hr',
    'iframe',
    'img',
    'input',
    'link',
    'menuitem',
    'meta',
    'ol',
    'param',
    'select',
    'table',
    'tbody',
    'tfoot',
    'thead',
    'tr',
    'ul',
    'wbr',
];
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
// Taken from https://raw.githubusercontent.com/facebook/react/baff5cc2f69d30589a5dc65b089e47765437294b/packages/react-dom/src/shared/possibleStandardNames.js
// tslint:disable:object-literal-sort-keys
var possibleStandardNames = {
    // HTML
    'accept-charset': 'acceptCharset',
    acceptcharset: 'acceptCharset',
    accesskey: 'accessKey',
    allowfullscreen: 'allowFullScreen',
    autocapitalize: 'autoCapitalize',
    autocomplete: 'autoComplete',
    autocorrect: 'autoCorrect',
    autofocus: 'autoFocus',
    autoplay: 'autoPlay',
    autosave: 'autoSave',
    cellpadding: 'cellPadding',
    cellspacing: 'cellSpacing',
    charset: 'charSet',
    class: 'className',
    classid: 'classID',
    classname: 'className',
    colspan: 'colSpan',
    contenteditable: 'contentEditable',
    contextmenu: 'contextMenu',
    controlslist: 'controlsList',
    crossorigin: 'crossOrigin',
    dangerouslysetinnerhtml: 'dangerouslySetInnerHTML',
    datetime: 'dateTime',
    defaultchecked: 'defaultChecked',
    defaultvalue: 'defaultValue',
    enctype: 'encType',
    for: 'htmlFor',
    formmethod: 'formMethod',
    formaction: 'formAction',
    formenctype: 'formEncType',
    formnovalidate: 'formNoValidate',
    formtarget: 'formTarget',
    frameborder: 'frameBorder',
    hreflang: 'hrefLang',
    htmlfor: 'htmlFor',
    httpequiv: 'httpEquiv',
    'http-equiv': 'httpEquiv',
    icon: 'icon',
    innerhtml: 'innerHTML',
    inputmode: 'inputMode',
    itemid: 'itemID',
    itemprop: 'itemProp',
    itemref: 'itemRef',
    itemscope: 'itemScope',
    itemtype: 'itemType',
    keyparams: 'keyParams',
    keytype: 'keyType',
    marginwidth: 'marginWidth',
    marginheight: 'marginHeight',
    maxlength: 'maxLength',
    mediagroup: 'mediaGroup',
    minlength: 'minLength',
    nomodule: 'noModule',
    novalidate: 'noValidate',
    playsinline: 'playsInline',
    radiogroup: 'radioGroup',
    readonly: 'readOnly',
    referrerpolicy: 'referrerPolicy',
    rowspan: 'rowSpan',
    spellcheck: 'spellCheck',
    srcdoc: 'srcDoc',
    srclang: 'srcLang',
    srcset: 'srcSet',
    tabindex: 'tabIndex',
    typemustmatch: 'typeMustMatch',
    usemap: 'useMap',
    // SVG
    accentheight: 'accentHeight',
    'accent-height': 'accentHeight',
    alignmentbaseline: 'alignmentBaseline',
    'alignment-baseline': 'alignmentBaseline',
    allowreorder: 'allowReorder',
    arabicform: 'arabicForm',
    'arabic-form': 'arabicForm',
    attributename: 'attributeName',
    attributetype: 'attributeType',
    autoreverse: 'autoReverse',
    basefrequency: 'baseFrequency',
    baselineshift: 'baselineShift',
    'baseline-shift': 'baselineShift',
    baseprofile: 'baseProfile',
    calcmode: 'calcMode',
    capheight: 'capHeight',
    'cap-height': 'capHeight',
    clippath: 'clipPath',
    'clip-path': 'clipPath',
    clippathunits: 'clipPathUnits',
    cliprule: 'clipRule',
    'clip-rule': 'clipRule',
    colorinterpolation: 'colorInterpolation',
    'color-interpolation': 'colorInterpolation',
    colorinterpolationfilters: 'colorInterpolationFilters',
    'color-interpolation-filters': 'colorInterpolationFilters',
    colorprofile: 'colorProfile',
    'color-profile': 'colorProfile',
    colorrendering: 'colorRendering',
    'color-rendering': 'colorRendering',
    contentscripttype: 'contentScriptType',
    contentstyletype: 'contentStyleType',
    diffuseconstant: 'diffuseConstant',
    dominantbaseline: 'dominantBaseline',
    'dominant-baseline': 'dominantBaseline',
    edgemode: 'edgeMode',
    enablebackground: 'enableBackground',
    'enable-background': 'enableBackground',
    externalresourcesrequired: 'externalResourcesRequired',
    fillopacity: 'fillOpacity',
    'fill-opacity': 'fillOpacity',
    fillrule: 'fillRule',
    'fill-rule': 'fillRule',
    filterres: 'filterRes',
    filterunits: 'filterUnits',
    floodopacity: 'floodOpacity',
    'flood-opacity': 'floodOpacity',
    floodcolor: 'floodColor',
    'flood-color': 'floodColor',
    fontfamily: 'fontFamily',
    'font-family': 'fontFamily',
    fontsize: 'fontSize',
    'font-size': 'fontSize',
    fontsizeadjust: 'fontSizeAdjust',
    'font-size-adjust': 'fontSizeAdjust',
    fontstretch: 'fontStretch',
    'font-stretch': 'fontStretch',
    fontstyle: 'fontStyle',
    'font-style': 'fontStyle',
    fontvariant: 'fontVariant',
    'font-variant': 'fontVariant',
    fontweight: 'fontWeight',
    'font-weight': 'fontWeight',
    glyphname: 'glyphName',
    'glyph-name': 'glyphName',
    glyphorientationhorizontal: 'glyphOrientationHorizontal',
    'glyph-orientation-horizontal': 'glyphOrientationHorizontal',
    glyphorientationvertical: 'glyphOrientationVertical',
    'glyph-orientation-vertical': 'glyphOrientationVertical',
    glyphref: 'glyphRef',
    gradienttransform: 'gradientTransform',
    gradientunits: 'gradientUnits',
    horizadvx: 'horizAdvX',
    'horiz-adv-x': 'horizAdvX',
    horizoriginx: 'horizOriginX',
    'horiz-origin-x': 'horizOriginX',
    imagerendering: 'imageRendering',
    'image-rendering': 'imageRendering',
    kernelmatrix: 'kernelMatrix',
    kernelunitlength: 'kernelUnitLength',
    keypoints: 'keyPoints',
    keysplines: 'keySplines',
    keytimes: 'keyTimes',
    lengthadjust: 'lengthAdjust',
    letterspacing: 'letterSpacing',
    'letter-spacing': 'letterSpacing',
    lightingcolor: 'lightingColor',
    'lighting-color': 'lightingColor',
    limitingconeangle: 'limitingConeAngle',
    markerend: 'markerEnd',
    'marker-end': 'markerEnd',
    markerheight: 'markerHeight',
    markermid: 'markerMid',
    'marker-mid': 'markerMid',
    markerstart: 'markerStart',
    'marker-start': 'markerStart',
    markerunits: 'markerUnits',
    markerwidth: 'markerWidth',
    maskcontentunits: 'maskContentUnits',
    maskunits: 'maskUnits',
    numoctaves: 'numOctaves',
    overlineposition: 'overlinePosition',
    'overline-position': 'overlinePosition',
    overlinethickness: 'overlineThickness',
    'overline-thickness': 'overlineThickness',
    paintorder: 'paintOrder',
    'paint-order': 'paintOrder',
    'panose-1': 'panose1',
    pathlength: 'pathLength',
    patterncontentunits: 'patternContentUnits',
    patterntransform: 'patternTransform',
    patternunits: 'patternUnits',
    pointerevents: 'pointerEvents',
    'pointer-events': 'pointerEvents',
    pointsatx: 'pointsAtX',
    pointsaty: 'pointsAtY',
    pointsatz: 'pointsAtZ',
    preservealpha: 'preserveAlpha',
    preserveaspectratio: 'preserveAspectRatio',
    primitiveunits: 'primitiveUnits',
    refx: 'refX',
    refy: 'refY',
    renderingintent: 'renderingIntent',
    'rendering-intent': 'renderingIntent',
    repeatcount: 'repeatCount',
    repeatdur: 'repeatDur',
    requiredextensions: 'requiredExtensions',
    requiredfeatures: 'requiredFeatures',
    shaperendering: 'shapeRendering',
    'shape-rendering': 'shapeRendering',
    specularconstant: 'specularConstant',
    specularexponent: 'specularExponent',
    spreadmethod: 'spreadMethod',
    startoffset: 'startOffset',
    stddeviation: 'stdDeviation',
    stitchtiles: 'stitchTiles',
    stopcolor: 'stopColor',
    'stop-color': 'stopColor',
    stopopacity: 'stopOpacity',
    'stop-opacity': 'stopOpacity',
    strikethroughposition: 'strikethroughPosition',
    'strikethrough-position': 'strikethroughPosition',
    strikethroughthickness: 'strikethroughThickness',
    'strikethrough-thickness': 'strikethroughThickness',
    strokedasharray: 'strokeDasharray',
    'stroke-dasharray': 'strokeDasharray',
    strokedashoffset: 'strokeDashoffset',
    'stroke-dashoffset': 'strokeDashoffset',
    strokelinecap: 'strokeLinecap',
    'stroke-linecap': 'strokeLinecap',
    strokelinejoin: 'strokeLinejoin',
    'stroke-linejoin': 'strokeLinejoin',
    strokemiterlimit: 'strokeMiterlimit',
    'stroke-miterlimit': 'strokeMiterlimit',
    strokewidth: 'strokeWidth',
    'stroke-width': 'strokeWidth',
    strokeopacity: 'strokeOpacity',
    'stroke-opacity': 'strokeOpacity',
    suppresscontenteditablewarning: 'suppressContentEditableWarning',
    suppresshydrationwarning: 'suppressHydrationWarning',
    surfacescale: 'surfaceScale',
    systemlanguage: 'systemLanguage',
    tablevalues: 'tableValues',
    targetx: 'targetX',
    targety: 'targetY',
    textanchor: 'textAnchor',
    'text-anchor': 'textAnchor',
    textdecoration: 'textDecoration',
    'text-decoration': 'textDecoration',
    textlength: 'textLength',
    textrendering: 'textRendering',
    'text-rendering': 'textRendering',
    underlineposition: 'underlinePosition',
    'underline-position': 'underlinePosition',
    underlinethickness: 'underlineThickness',
    'underline-thickness': 'underlineThickness',
    unicodebidi: 'unicodeBidi',
    'unicode-bidi': 'unicodeBidi',
    unicoderange: 'unicodeRange',
    'unicode-range': 'unicodeRange',
    unitsperem: 'unitsPerEm',
    'units-per-em': 'unitsPerEm',
    unselectable: 'unselectable',
    valphabetic: 'vAlphabetic',
    'v-alphabetic': 'vAlphabetic',
    vectoreffect: 'vectorEffect',
    'vector-effect': 'vectorEffect',
    vertadvy: 'vertAdvY',
    'vert-adv-y': 'vertAdvY',
    vertoriginx: 'vertOriginX',
    'vert-origin-x': 'vertOriginX',
    vertoriginy: 'vertOriginY',
    'vert-origin-y': 'vertOriginY',
    vhanging: 'vHanging',
    'v-hanging': 'vHanging',
    videographic: 'vIdeographic',
    'v-ideographic': 'vIdeographic',
    viewbox: 'viewBox',
    viewtarget: 'viewTarget',
    vmathematical: 'vMathematical',
    'v-mathematical': 'vMathematical',
    wordspacing: 'wordSpacing',
    'word-spacing': 'wordSpacing',
    writingmode: 'writingMode',
    'writing-mode': 'writingMode',
    xchannelselector: 'xChannelSelector',
    xheight: 'xHeight',
    'x-height': 'xHeight',
    xlinkactuate: 'xlinkActuate',
    'xlink:actuate': 'xlinkActuate',
    xlinkarcrole: 'xlinkArcrole',
    'xlink:arcrole': 'xlinkArcrole',
    xlinkhref: 'xlinkHref',
    'xlink:href': 'xlinkHref',
    xlinkrole: 'xlinkRole',
    'xlink:role': 'xlinkRole',
    xlinkshow: 'xlinkShow',
    'xlink:show': 'xlinkShow',
    xlinktitle: 'xlinkTitle',
    'xlink:title': 'xlinkTitle',
    xlinktype: 'xlinkType',
    'xlink:type': 'xlinkType',
    xmlbase: 'xmlBase',
    'xml:base': 'xmlBase',
    xmllang: 'xmlLang',
    'xml:lang': 'xmlLang',
    'xml:space': 'xmlSpace',
    xmlnsxlink: 'xmlnsXlink',
    'xmlns:xlink': 'xmlnsXlink',
    xmlspace: 'xmlSpace',
    ychannelselector: 'yChannelSelector',
    zoomandpan: 'zoomAndPan',
    // event handlers
    onblur: 'onBlur',
    onchange: 'onChange',
    onclick: 'onClick',
    oncontextmenu: 'onContextMenu',
    ondoubleclick: 'onDoubleClick',
    ondrag: 'onDrag',
    ondragend: 'onDragEnd',
    ondragenter: 'onDragEnter',
    ondragexit: 'onDragExit',
    ondragleave: 'onDragLeave',
    ondragover: 'onDragOver',
    ondragstart: 'onDragStart',
    ondrop: 'onDrop',
    onerror: 'onError',
    onfocus: 'onFocus',
    oninput: 'onInput',
    oninvalid: 'onInvalid',
    onkeydown: 'onKeyDown',
    onkeypress: 'onKeyPress',
    onkeyup: 'onKeyUp',
    onload: 'onLoad',
    onmousedown: 'onMouseDown',
    onmouseenter: 'onMouseEnter',
    onmouseleave: 'onMouseLeave',
    onmousemove: 'onMouseMove',
    onmouseout: 'onMouseOut',
    onmouseover: 'onMouseOver',
    onmouseup: 'onMouseUp',
    onscroll: 'onScroll',
    onsubmit: 'onSubmit',
    ontouchcancel: 'onTouchCancel',
    ontouchend: 'onTouchEnd',
    ontouchmove: 'onTouchMove',
    ontouchstart: 'onTouchStart',
    onwheel: 'onWheel',
};

var __assign$1 = (undefined && undefined.__assign) || function () {
    __assign$1 = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign$1.apply(this, arguments);
};
var __read$2 = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray$1 = (undefined && undefined.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
function parseAttributes(node, reactKey) {
    var attributes = {
        key: reactKey,
    };
    /* istanbul ignore else */
    if (node instanceof Element) {
        var nodeClassNames = node.getAttribute('class');
        if (nodeClassNames) {
            attributes.className = nodeClassNames;
        }
        __spreadArray$1([], __read$2(node.attributes), false).forEach(function (d) {
            switch (d.name) {
                // this is manually handled above, so break;
                case 'class':
                    break;
                case 'style':
                    attributes[d.name] = styleToObject(d.value);
                    break;
                case 'allowfullscreen':
                case 'allowpaymentrequest':
                case 'async':
                case 'autofocus':
                case 'autoplay':
                case 'checked':
                case 'controls':
                case 'default':
                case 'defer':
                case 'disabled':
                case 'formnovalidate':
                case 'hidden':
                case 'ismap':
                case 'itemscope':
                case 'loop':
                case 'multiple':
                case 'muted':
                case 'nomodule':
                case 'novalidate':
                case 'open':
                case 'readonly':
                case 'required':
                case 'reversed':
                case 'selected':
                case 'typemustmatch':
                    attributes[possibleStandardNames[d.name] || d.name] = true;
                    break;
                default:
                    attributes[possibleStandardNames[d.name] || d.name] = d.value;
            }
        });
    }
    return attributes;
}
function parseChildren(childNodeList, level, options) {
    var children = __spreadArray$1([], __read$2(childNodeList), false).map(function (node, index) {
        return convertFromNode(node, __assign$1(__assign$1({}, options), { index: index, level: level + 1 }));
    })
        .filter(Boolean);
    if (!children.length) {
        return null;
    }
    return children;
}
function parseName(nodeName) {
    if (/[a-z]+[A-Z]+[a-z]+/.test(nodeName)) {
        return nodeName;
    }
    return nodeName.toLowerCase();
}
function convertFromNode(input, options) {
    var _a;
    if (options === void 0) { options = {}; }
    if (!input || !(input instanceof Node)) {
        return null;
    }
    var _b = options.actions, actions = _b === void 0 ? [] : _b, _c = options.index, index = _c === void 0 ? 0 : _c, _d = options.level, level = _d === void 0 ? 0 : _d, randomKey = options.randomKey;
    var node = input;
    var key = "".concat(level, "-").concat(index);
    var result = [];
    if (randomKey && level === 0) {
        key = "".concat(randomString$1(), "-").concat(key);
    }
    /* istanbul ignore else */
    if (Array.isArray(actions)) {
        actions.forEach(function (action) {
            if (action.condition(node, key, level)) {
                if (typeof action.pre === 'function') {
                    node = action.pre(node, key, level);
                    if (!(node instanceof Node)) {
                        node = input;
                        /* istanbul ignore else */
                        if (process.env.NODE_ENV !== 'production') {
                            // eslint-disable-next-line no-console
                            console.warn('The `pre` method always must return a valid DomNode (instanceof Node) - your modification will be ignored (Hint: if you want to render a React-component, use the `post` method instead)');
                        }
                    }
                }
                if (typeof action.post === 'function') {
                    result.push(action.post(node, key, level));
                }
            }
        });
    }
    if (result.length) {
        return result;
    }
    switch (node.nodeType) {
        case 1: {
            // regular dom-node
            return React.createElement(parseName(node.nodeName), parseAttributes(node, key), parseChildren(node.childNodes, level, options));
        }
        case 3: {
            // textnode
            var nodeText = ((_a = node.nodeValue) === null || _a === void 0 ? void 0 : _a.toString()) || '';
            /* istanbul ignore else */
            if (/^\s+$/.test(nodeText) && !/[\u00A0\u202F]/.test(nodeText)) {
                return null;
            }
            /* istanbul ignore next */
            if (!node.parentNode) {
                return nodeText;
            }
            var parentNodeName = node.parentNode.nodeName.toLowerCase();
            if (noTextChildNodes.includes(parentNodeName)) {
                /* istanbul ignore else */
                if (/\S/.test(nodeText)) {
                    // eslint-disable-next-line no-console
                    console.warn("A textNode is not allowed inside '".concat(parentNodeName, "'. Your text \"").concat(nodeText, "\" will be ignored"));
                }
                return null;
            }
            return nodeText;
        }
        case 8: {
            // html-comment
            return null;
        }
        /* istanbul ignore next */
        default: {
            return null;
        }
    }
}
function convertFromString(input, options) {
    if (options === void 0) { options = {}; }
    if (!input || typeof input !== 'string') {
        return null;
    }
    var _a = options.nodeOnly, nodeOnly = _a === void 0 ? false : _a, _b = options.selector, selector = _b === void 0 ? 'body > *' : _b, _c = options.type, type = _c === void 0 ? 'text/html' : _c;
    try {
        var parser = new DOMParser();
        var document_1 = parser.parseFromString(input, type);
        var node = document_1.querySelector(selector);
        if (!(node instanceof Node)) {
            throw new TypeError('Error parsing input');
        }
        if (nodeOnly) {
            return node;
        }
        return convertFromNode(node, options);
    }
    catch (error) {
        /* istanbul ignore else */
        if (process.env.NODE_ENV !== 'production') {
            // eslint-disable-next-line no-console
            console.error(error);
        }
    }
    return null;
}
function convert(input, options) {
    if (options === void 0) { options = {}; }
    if (typeof input === 'string') {
        return convertFromString(input, options);
    }
    if (input instanceof Node) {
        return convertFromNode(input, options);
    }
    return null;
}

function unwrapExports (x) {
	return x && x.__esModule && Object.prototype.hasOwnProperty.call(x, 'default') ? x['default'] : x;
}

function createCommonjsModule(fn, module) {
	return module = { exports: {} }, fn(module, module.exports), module.exports;
}

var exenv = createCommonjsModule(function (module) {
/*!
  Copyright (c) 2015 Jed Watson.
  Based on code that is Copyright 2013-2015, Facebook, Inc.
  All rights reserved.
*/
/* global define */

(function () {

	var canUseDOM = !!(
		typeof window !== 'undefined' &&
		window.document &&
		window.document.createElement
	);

	var ExecutionEnvironment = {

		canUseDOM: canUseDOM,

		canUseWorkers: typeof Worker !== 'undefined',

		canUseEventListeners:
			canUseDOM && !!(window.addEventListener || window.attachEvent),

		canUseViewport: canUseDOM && !!window.screen

	};

	if (module.exports) {
		module.exports = ExecutionEnvironment;
	} else {
		window.ExecutionEnvironment = ExecutionEnvironment;
	}

}());
});
var exenv_1 = exenv.canUseDOM;
exenv.canUseDOMFlag;

var STATUS = {
    FAILED: 'failed',
    LOADED: 'loaded',
    LOADING: 'loading',
    PENDING: 'pending',
    READY: 'ready',
    UNSUPPORTED: 'unsupported',
};
function canUseDOM() {
    return exenv_1;
}
function isSupportedEnvironment() {
    return supportsInlineSVG() && typeof window !== 'undefined' && window !== null;
}
function supportsInlineSVG() {
    /* istanbul ignore next */
    if (!document) {
        return false;
    }
    var div = document.createElement('div');
    div.innerHTML = '<svg />';
    return !!div.firstChild && div.firstChild.namespaceURI === 'http://www.w3.org/2000/svg';
}
function randomString(length) {
    var letters = 'abcdefghijklmnopqrstuvwxyz';
    var numbers = '1234567890';
    var charset = "" + letters + letters.toUpperCase() + numbers;
    var randomCharacter = function (character) {
        return character[Math.floor(Math.random() * character.length)];
    };
    var R = '';
    for (var i = 0; i < length; i++) {
        R += randomCharacter(charset);
    }
    return R;
}
/**
 *  Remove properties from an object
 */
function removeProperties(input) {
    var filter = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        filter[_i - 1] = arguments[_i];
    }
    var output = {};
    for (var key in input) {
        /* istanbul ignore else */
        if ({}.hasOwnProperty.call(input, key)) {
            if (!filter.includes(key)) {
                output[key] = input[key];
            }
        }
    }
    return output;
}

var __extends = (undefined && undefined.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (undefined && undefined.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __read$1 = (undefined && undefined.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (undefined && undefined.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
var cacheStore = Object.create(null);
var InlineSVG = /** @class */ (function (_super) {
    __extends(InlineSVG, _super);
    function InlineSVG(props) {
        var _this = _super.call(this, props) || this;
        _this.isActive = false;
        _this.handleCacheQueue = function (content) {
            /* istanbul ignore else */
            if (typeof content === 'string') {
                _this.handleLoad(content);
                return;
            }
            _this.handleError(content);
        };
        _this.handleLoad = function (content) {
            /* istanbul ignore else */
            if (_this.isActive) {
                _this.setState({
                    content: content,
                    status: STATUS.LOADED,
                }, _this.getElement);
            }
        };
        _this.handleError = function (error) {
            var onError = _this.props.onError;
            var status = error.message === 'Browser does not support SVG' ? STATUS.UNSUPPORTED : STATUS.FAILED;
            /* istanbul ignore else */
            if (_this.isActive) {
                _this.setState({ status: status }, function () {
                    /* istanbul ignore else */
                    if (typeof onError === 'function') {
                        onError(error);
                    }
                });
            }
        };
        _this.request = function () {
            var _a = _this.props, cacheRequests = _a.cacheRequests, fetchOptions = _a.fetchOptions, src = _a.src;
            try {
                if (cacheRequests) {
                    cacheStore[src] = { content: '', status: STATUS.LOADING, queue: [] };
                }
                return fetch(src, fetchOptions)
                    .then(function (response) {
                    var contentType = response.headers.get('content-type');
                    var _a = __read$1((contentType || '').split(/ ?; ?/), 1), fileType = _a[0];
                    if (response.status > 299) {
                        throw new Error('Not found');
                    }
                    if (!['image/svg+xml', 'text/plain'].some(function (d) { return fileType.indexOf(d) >= 0; })) {
                        throw new Error("Content type isn't valid: " + fileType);
                    }
                    return response.text();
                })
                    .then(function (content) {
                    var currentSrc = _this.props.src;
                    // the current src don't match the previous one, skipping...
                    if (src !== currentSrc) {
                        return;
                    }
                    _this.handleLoad(content);
                    /* istanbul ignore else */
                    if (cacheRequests) {
                        var cache = cacheStore[src];
                        /* istanbul ignore else */
                        if (cache) {
                            cache.content = content;
                            cache.status = STATUS.LOADED;
                            cache.queue = cache.queue.filter(function (cb) {
                                cb(content);
                                return false;
                            });
                        }
                    }
                })
                    .catch(function (error) {
                    _this.handleError(error);
                    /* istanbul ignore else */
                    if (cacheRequests) {
                        var cache = cacheStore[src];
                        /* istanbul ignore else */
                        if (cache) {
                            cache.queue.forEach(function (cb) {
                                cb(error);
                            });
                            delete cacheStore[src];
                        }
                    }
                });
            }
            catch (error) {
                return _this.handleError(new Error(error.message));
            }
        };
        _this.state = {
            content: '',
            element: null,
            hasCache: !!props.cacheRequests && !!cacheStore[props.src],
            status: STATUS.PENDING,
        };
        _this.hash = props.uniqueHash || randomString(8);
        return _this;
    }
    InlineSVG.prototype.componentDidMount = function () {
        this.isActive = true;
        if (!canUseDOM()) {
            return;
        }
        var status = this.state.status;
        var src = this.props.src;
        try {
            /* istanbul ignore else */
            if (status === STATUS.PENDING) {
                /* istanbul ignore else */
                if (!isSupportedEnvironment()) {
                    throw new Error('Browser does not support SVG');
                }
                /* istanbul ignore else */
                if (!src) {
                    throw new Error('Missing src');
                }
                this.load();
            }
        }
        catch (error) {
            this.handleError(error);
        }
    };
    InlineSVG.prototype.componentDidUpdate = function (prevProps, prevState) {
        if (!canUseDOM()) {
            return;
        }
        var _a = this.state, hasCache = _a.hasCache, status = _a.status;
        var _b = this.props, onLoad = _b.onLoad, src = _b.src;
        if (prevState.status !== STATUS.READY && status === STATUS.READY) {
            /* istanbul ignore else */
            if (onLoad) {
                onLoad(src, hasCache);
            }
        }
        if (prevProps.src !== src) {
            if (!src) {
                this.handleError(new Error('Missing src'));
                return;
            }
            this.load();
        }
    };
    InlineSVG.prototype.componentWillUnmount = function () {
        this.isActive = false;
    };
    InlineSVG.prototype.processSVG = function () {
        var content = this.state.content;
        var preProcessor = this.props.preProcessor;
        if (preProcessor) {
            return preProcessor(content);
        }
        return content;
    };
    InlineSVG.prototype.updateSVGAttributes = function (node) {
        var _this = this;
        var _a = this.props, _b = _a.baseURL, baseURL = _b === void 0 ? '' : _b, uniquifyIDs = _a.uniquifyIDs;
        var replaceableAttributes = ['id', 'href', 'xlink:href', 'xlink:role', 'xlink:arcrole'];
        var linkAttributes = ['href', 'xlink:href'];
        var isDataValue = function (name, value) {
            return linkAttributes.indexOf(name) >= 0 && (value ? value.indexOf('#') < 0 : false);
        };
        if (!uniquifyIDs) {
            return node;
        }
        __spreadArray([], __read$1(node.children)).map(function (d) {
            if (d.attributes && d.attributes.length) {
                var attributes_1 = Object.values(d.attributes).map(function (a) {
                    var attr = a;
                    var match = a.value.match(/url\((.*?)\)/);
                    if (match && match[1]) {
                        attr.value = a.value.replace(match[0], "url(" + baseURL + match[1] + "__" + _this.hash + ")");
                    }
                    return attr;
                });
                replaceableAttributes.forEach(function (r) {
                    var attribute = attributes_1.find(function (a) { return a.name === r; });
                    if (attribute && !isDataValue(r, attribute.value)) {
                        attribute.value = attribute.value + "__" + _this.hash;
                    }
                });
            }
            if (d.children.length) {
                return _this.updateSVGAttributes(d);
            }
            return d;
        });
        return node;
    };
    InlineSVG.prototype.getNode = function () {
        var _a = this.props, description = _a.description, title = _a.title;
        try {
            var svgText = this.processSVG();
            var node = convert(svgText, { nodeOnly: true });
            if (!node || !(node instanceof SVGSVGElement)) {
                throw new Error('Could not convert the src to a DOM Node');
            }
            var svg = this.updateSVGAttributes(node);
            if (description) {
                var originalDesc = svg.querySelector('desc');
                if (originalDesc && originalDesc.parentNode) {
                    originalDesc.parentNode.removeChild(originalDesc);
                }
                var descElement = document.createElement('desc');
                descElement.innerHTML = description;
                svg.prepend(descElement);
            }
            if (title) {
                var originalTitle = svg.querySelector('title');
                if (originalTitle && originalTitle.parentNode) {
                    originalTitle.parentNode.removeChild(originalTitle);
                }
                var titleElement = document.createElement('title');
                titleElement.innerHTML = title;
                svg.prepend(titleElement);
            }
            return svg;
        }
        catch (error) {
            return this.handleError(error);
        }
    };
    InlineSVG.prototype.getElement = function () {
        try {
            var node = this.getNode();
            var element = convert(node);
            if (!element || !React.isValidElement(element)) {
                throw new Error('Could not convert the src to a React element');
            }
            this.setState({
                element: element,
                status: STATUS.READY,
            });
        }
        catch (error) {
            this.handleError(new Error(error.message));
        }
    };
    InlineSVG.prototype.load = function () {
        var _this = this;
        /* istanbul ignore else */
        if (this.isActive) {
            this.setState({
                content: '',
                element: null,
                status: STATUS.LOADING,
            }, function () {
                var _a = _this.props, cacheRequests = _a.cacheRequests, src = _a.src;
                var cache = cacheRequests && cacheStore[src];
                if (cache) {
                    /* istanbul ignore else */
                    if (cache.status === STATUS.LOADING) {
                        cache.queue.push(_this.handleCacheQueue);
                    }
                    else if (cache.status === STATUS.LOADED) {
                        _this.handleLoad(cache.content);
                    }
                    return;
                }
                var dataURI = src.match(/data:image\/svg[^,]*?(;base64)?,(.*)/);
                var inlineSrc;
                if (dataURI) {
                    inlineSrc = dataURI[1] ? atob(dataURI[2]) : decodeURIComponent(dataURI[2]);
                }
                else if (src.indexOf('<svg') >= 0) {
                    inlineSrc = src;
                }
                if (inlineSrc) {
                    _this.handleLoad(inlineSrc);
                    return;
                }
                _this.request();
            });
        }
    };
    InlineSVG.prototype.render = function () {
        var _a = this.state, element = _a.element, status = _a.status;
        var _b = this.props, _c = _b.children, children = _c === void 0 ? null : _c, innerRef = _b.innerRef, _d = _b.loader, loader = _d === void 0 ? null : _d;
        var elementProps = removeProperties(this.props, 'baseURL', 'cacheRequests', 'children', 'description', 'fetchOptions', 'innerRef', 'loader', 'onError', 'onLoad', 'preProcessor', 'src', 'title', 'uniqueHash', 'uniquifyIDs');
        if (!canUseDOM()) {
            return loader;
        }
        if (element) {
            return React.cloneElement(element, __assign({ ref: innerRef }, elementProps));
        }
        if ([STATUS.UNSUPPORTED, STATUS.FAILED].indexOf(status) > -1) {
            return children;
        }
        return loader;
    };
    InlineSVG.defaultProps = {
        cacheRequests: true,
        uniquifyIDs: false,
    };
    return InlineSVG;
}(React.PureComponent));
var SVG = InlineSVG;

var CustomSvg = styled(SVG)(templateObject_1$P || (templateObject_1$P = __makeTemplateObject(["\n  width: ", "px;\n  height: ", "px;\n  max-width: 100%;\n  min-width: ", ";\n  flex: 0 0 ", "px;\n  ", "\n  ", "\n"], ["\n  width: ", "px;\n  height: ", "px;\n  max-width: 100%;\n  min-width: ", ";\n  flex: 0 0 ", "px;\n  ", "\n  ", "\n"])), function (props) { return props.width || 16; }, function (props) { return props.height || 16; }, function (props) { return (props.width ? props.width + "px" : 'auto'); }, function (props) { return props.width || 16; }, function (props) { return (props.fill ? "fill: " + props.theme.colors[props.fill] + ";" : 'fill: none;'); }, function (props) { return (props.stroke ? "stroke: " + props.theme.colors[props.stroke] + ";" : ''); });
var SvgIcon = function (props) {
    var src = props.src, width = props.width, height = props.height, fill = props.fill, stroke = props.stroke, className = props.className, testId = props.testId;
    var _a = useState(false), isIE = _a[0], setIsIE = _a[1];
    useEffect(function () {
        var isIE11 = !!window.MSInputMethodContext && !!document.documentMode;
        if (isIE11) {
            setIsIE(true);
        }
    }, []);
    if (isIE) {
        return React__default.createElement(CustomSvg, { "data-testid": testId, as: "img", src: src, width: width, height: height, stroke: stroke, alt: "Icon", className: className });
    }
    return React__default.createElement(CustomSvg, { "data-testid": testId, src: src, width: width, height: height, fill: fill, stroke: stroke, className: className });
};
var templateObject_1$P;

var BadgeContainer$2 = styled.div(templateObject_7$s || (templateObject_7$s = __makeTemplateObject(["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n  font-weight: 600;\n  line-height: 16px;\n  min-width: 20px;\n  min-height: 20px;\n  padding: ", "px ", "px;\n  font-size: ", ";\n  border-radius: ", "px;\n\n  ", "\n\n  & svg:first-child {\n    margin-right: ", "px;\n  }\n\n  & svg:last-child {\n    margin-left: ", "px;\n  }\n\n  ", "\n\n  ", "\n\n    ", "\n"], ["\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  white-space: nowrap;\n  font-weight: 600;\n  line-height: 16px;\n  min-width: 20px;\n  min-height: 20px;\n  padding: ", "px ", "px;\n  font-size: ", ";\n  border-radius: ", "px;\n\n  ",
    "\n\n  & svg:first-child {\n    margin-right: ", "px;\n  }\n\n  & svg:last-child {\n    margin-left: ", "px;\n  }\n\n  ",
    "\n\n  ",
    "\n\n    ",
    "\n"])), function (props) { return props.theme.global.gutterSpace / 8; }, function (props) { return props.theme.global.gutterSpace / 4; }, theme.fontSizes[1], function (props) { return props.theme.global.gutterSpace * 0.75; }, function (props) {
    return props.size === 'small' && css(templateObject_1$O || (templateObject_1$O = __makeTemplateObject(["\n      padding: 0 ", "px;\n    "], ["\n      padding: 0 ", "px;\n    "])), props.theme.global.gutterSpace * 0.375);
}, function (props) { return props.theme.global.gutterSpace * 0.5; }, function (props) { return props.theme.global.gutterSpace * 0.5; }, function (props) {
    return props.isLight
        ? css(templateObject_2$G || (templateObject_2$G = __makeTemplateObject(["\n          color: ", ";\n          background-color: ", ";\n        "], ["\n          color: ", ";\n          background-color: ", ";\n        "])), props.theme.behavior[props.type].primary, props.theme.behavior[props.type].secondary) : css(templateObject_3$D || (templateObject_3$D = __makeTemplateObject(["\n          color: ", ";\n          background-color: ", ";\n        "], ["\n          color: ", ";\n          background-color: ", ";\n        "])), props.theme.colors.white, props.theme.behavior[props.type].primary);
}, function (props) {
    return !props.isEmpty && css(templateObject_5$v || (templateObject_5$v = __makeTemplateObject(["\n      padding: 0;\n      width: 8px;\n      height: 8px;\n      min-width: 8px;\n      min-height: 8px;\n\n      ", "\n    "], ["\n      padding: 0;\n      width: 8px;\n      height: 8px;\n      min-width: 8px;\n      min-height: 8px;\n\n      ",
        "\n    "])), props.size === 'default' && css(templateObject_4$B || (templateObject_4$B = __makeTemplateObject(["\n        width: 12px;\n        height: 12px;\n        min-width: 12px;\n        min-height: 12px;\n      "], ["\n        width: 12px;\n        height: 12px;\n        min-width: 12px;\n        min-height: 12px;\n      "]))));
}, function (props) {
    return props.hasBorder && css(templateObject_6$s || (templateObject_6$s = __makeTemplateObject(["\n      border: 2px solid ", ";\n    "], ["\n      border: 2px solid ", ";\n    "])), props.theme.colors.white);
});
var templateObject_1$O, templateObject_2$G, templateObject_3$D, templateObject_4$B, templateObject_5$v, templateObject_6$s, templateObject_7$s;

var Badge = function (props) {
    var children = props.children, type = props.type, testId = props.testId, size = props.size, hasBorder = props.hasBorder, isLight = props.isLight, className = props.className;
    var childrenWithNode = Children.map(children, function (child) {
        if (typeof child === 'string') {
            return React__default.createElement("span", null, child);
        }
        return child;
    });
    return (React__default.createElement(BadgeContainer$2, { type: type || 'default', isLight: isLight, "data-testid": testId, className: className, size: size || 'default', isEmpty: !!children, hasBorder: hasBorder }, childrenWithNode));
};

var buttonsColors = function (variant, type, iconColor) {
    if (variant === void 0) { variant = 'light'; }
    var fill = variant === 'dark' || variant === 'medium' ? theme.behavior[type || 'default'].secondary : theme.behavior[type || 'default'].primary;
    var backgroundColor = (variant === 'dark' && theme.behavior[type || 'default'].primary) ||
        (variant === 'medium' && theme.behavior[type || 'default'].tertiary) ||
        (variant === 'light' && theme.behavior[type || 'default'].secondary);
    var backgroundHover = curriedDarken$1(0.03, backgroundColor);
    return css(templateObject_1$N || (templateObject_1$N = __makeTemplateObject(["\n    ", "\n\n    background-color: ", ";\n\n    &:not(:disabled) {\n      &:hover {\n        background: ", " radial-gradient(circle, transparent 1%, ", " 1%) center/15000%;\n      }\n\n      &:active {\n        background-color: ", ";\n        background-size: 100%;\n        transition: background 0s;\n      }\n    }\n  "], ["\n    ",
        "\n\n    background-color: ", ";\n\n    &:not(:disabled) {\n      &:hover {\n        background: ", " radial-gradient(circle, transparent 1%, ", " 1%) center/15000%;\n      }\n\n      &:active {\n        background-color: ", ";\n        background-size: 100%;\n        transition: background 0s;\n      }\n    }\n  "])), !iconColor &&
        "\n    svg {\n      fill: " + fill + ";\n    }\n    ", backgroundColor, backgroundHover, backgroundHover, curriedLighten$1(0.05, backgroundColor));
};
// eslint-disable-next-line react/button-has-type
var StyledFabButton = styled(function (_a) {
    _a.loading; _a.color; _a.size; _a.disabledBackgroundColor; _a.iconColor; var otherProps = __rest(_a, ["loading", "color", "size", "disabledBackgroundColor", "iconColor"]);
    return React__default.createElement("button", __assign$2({}, otherProps));
})(templateObject_5$u || (templateObject_5$u = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: fit-content;\n  width: fit-content;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  transition: background-color 250ms, background 500ms, fill 500ms ease-out;\n  background-position: center;\n  background-color: transparent;\n  font-family: ", ";\n\n  ", ";\n  svg {\n    transition: fill 0.5s linear;\n  }\n\n  &:focus {\n    outline: -webkit-focus-ring-color auto 0;\n  }\n\n  ", "\n\n  &&:disabled {\n    background: ", ";\n    border-color: ", ";\n    cursor: not-allowed;\n    box-shadow: none;\n\n    ", "\n  }\n"], ["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: fit-content;\n  width: fit-content;\n  padding: 0;\n  border: 0;\n  border-radius: 50%;\n  transition: background-color 250ms, background 500ms, fill 500ms ease-out;\n  background-position: center;\n  background-color: transparent;\n  font-family: ", ";\n\n  ", ";\n  svg {\n    transition: fill 0.5s linear;\n  }\n\n  &:focus {\n    outline: -webkit-focus-ring-color auto 0;\n  }\n\n  ",
    "\n\n  &&:disabled {\n    background: ", ";\n    border-color: ", ";\n    cursor: not-allowed;\n    box-shadow: none;\n\n    ",
    "\n  }\n"])), function (props) { return props.theme.global.defaultFont; }, function (props) { return buttonsColors(props.variant, props.color, props.iconColor); }, function (props) {
    return props.disabledBackgroundColor && css(templateObject_2$F || (templateObject_2$F = __makeTemplateObject(["\n      background-color: transparent;\n    "], ["\n      background-color: transparent;\n    "])));
}, function (props) { return props.theme.colors.grey100; }, function (props) { return props.theme.colors.grey100; }, function (props) {
    return props.loading
        ? css(templateObject_3$C || (templateObject_3$C = __makeTemplateObject(["\n            & svg {\n              fill: ", ";\n            }\n            & img {\n              opacity: 0.4;\n            }\n          "], ["\n            & svg {\n              fill: ", ";\n            }\n            & img {\n              opacity: 0.4;\n            }\n          "])), rgba(props.theme.colors.grey400, 0.4)) : css(templateObject_4$A || (templateObject_4$A = __makeTemplateObject(["\n            & svg {\n              fill: ", ";\n            }\n          "], ["\n            & svg {\n              fill: ", ";\n            }\n          "])), props.theme.colors.grey400);
});
var ContainerLoading = styled.div(templateObject_6$r || (templateObject_6$r = __makeTemplateObject(["\n  position: absolute;\n"], ["\n  position: absolute;\n"])));
var BadgeContainer$1 = styled.div(templateObject_10$e || (templateObject_10$e = __makeTemplateObject(["\n  position: absolute;\n  top: -4px;\n  right: -4px;\n\n  ", "\n\n  ", "\n"], ["\n  position: absolute;\n  top: -4px;\n  right: -4px;\n\n  ",
    "\n\n  ",
    "\n"])), function (props) {
    return !props.hasChildren && css(templateObject_7$r || (templateObject_7$r = __makeTemplateObject(["\n      top: -7px;\n      right: 2px;\n    "], ["\n      top: -7px;\n      right: 2px;\n    "])));
}, function (props) {
    return props.isSmall && css(templateObject_9$g || (templateObject_9$g = __makeTemplateObject(["\n      top: -8px;\n      right: -8px;\n\n      ", "\n    "], ["\n      top: -8px;\n      right: -8px;\n\n      ",
        "\n    "])), !props.hasChildren && css(templateObject_8$n || (templateObject_8$n = __makeTemplateObject(["\n        top: -7px;\n        right: -1px;\n      "], ["\n        top: -7px;\n        right: -1px;\n      "]))));
});
var TooltipContainer = styled(AgilizeTooltip)(templateObject_12$9 || (templateObject_12$9 = __makeTemplateObject(["\n  display: flex;\n  padding: ", "px;\n\n  ", "\n"], ["\n  display: flex;\n  padding: ", "px;\n\n  ",
    "\n"])), function (props) { return props.theme.global.gutterSpace * 0.625; }, function (props) {
    return props.size === 'small' && css(templateObject_11$a || (templateObject_11$a = __makeTemplateObject(["\n      padding: ", "px;\n    "], ["\n      padding: ", "px;\n    "])), Math.round(props.theme.global.gutterSpace * 0.25));
});
var templateObject_1$N, templateObject_2$F, templateObject_3$C, templateObject_4$A, templateObject_5$u, templateObject_6$r, templateObject_7$r, templateObject_8$n, templateObject_9$g, templateObject_10$e, templateObject_11$a, templateObject_12$9;

var FabButton = function (props) {
    var iconPath = props.iconPath, color = props.color, onClick = props.onClick, disabled = props.disabled, testId = props.testId, className = props.className, loading = props.loading, size = props.size, badge = props.badge, iconWidth = props.iconWidth, iconHeight = props.iconHeight, iconColor = props.iconColor, tooltipTitle = props.tooltipTitle, tooltipPlacement = props.tooltipPlacement, type = props.type, disabledBackgroundColor = props.disabledBackgroundColor, variant = props.variant;
    var loadingSize = size === 'small' ? 14 : 18;
    var defaultIconWidth = size === 'small' ? 16 : 20;
    var defaultIconHeight = size === 'small' ? 16 : 20;
    var handleClick = function (event) { return onClick && onClick(event); };
    return (React__default.createElement(StyledFabButton, { disabledBackgroundColor: disabledBackgroundColor, color: color, "data-testid": testId, className: className, onClick: handleClick, disabled: disabled || loading, loading: loading, type: type || 'button', variant: variant, iconColor: iconColor },
        React__default.createElement(TooltipContainer, { title: tooltipTitle, placement: tooltipPlacement || 'top', size: size },
            React__default.createElement(React__default.Fragment, null,
                React__default.createElement(SvgIcon, { src: iconPath, width: iconWidth || defaultIconWidth, height: iconHeight || defaultIconHeight, fill: iconColor }),
                loading && (React__default.createElement(ContainerLoading, null,
                    React__default.createElement(BasicLoading, { size: loadingSize, thickness: 2, color: "purple600" }))),
                !!badge && (React__default.createElement(BadgeContainer$1, { hasChildren: !!badge.children, isSmall: size === 'small' },
                    React__default.createElement(Badge, __assign$2({}, badge))))))));
};

var InputField$1 = styled.div(templateObject_3$B || (templateObject_3$B = __makeTemplateObject(["\n  max-width: 100%;\n\n  ", "\n\n  ", "\n"], ["\n  max-width: 100%;\n\n  ",
    "\n\n  ",
    "\n"])), function (props) {
    return props.horizontalLabel && css(templateObject_1$M || (templateObject_1$M = __makeTemplateObject(["\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      flex-wrap: wrap;\n    "], ["\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      flex-wrap: wrap;\n    "])));
}, function (props) {
    return props.readOnly && css(templateObject_2$E || (templateObject_2$E = __makeTemplateObject(["\n      display: none;\n    "], ["\n      display: none;\n    "])));
});
var InputContainer$1 = styled.div(templateObject_4$z || (templateObject_4$z = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  font-size: ", ";\n  font-family: ", ";\n  width: 100%;\n  height: ", "px;\n"], ["\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  font-size: ", ";\n  font-family: ", ";\n  width: 100%;\n  height: ", "px;\n"])), function (props) { return props.theme.forms.defaultFontSize; }, function (props) { return props.theme.global.defaultFont; }, function (props) { return props.height || props.theme.forms.defaultHeight; });
var TextInput = styled.input(templateObject_14$5 || (templateObject_14$5 = __makeTemplateObject(["\n  flex: 1;\n  height: 100%;\n  min-width: 0;\n  padding: ", ";\n  background-color: ", ";\n  font-size: ", ";\n  border: 1px solid ", ";\n  border-radius: ", "px;\n  font-weight: 500;\n  line-height: ", "px;\n  transition: box-shadow 200ms, border 200ms ease-in;\n  color: ", ";\n\n  ", "\n\n  ", "\n\n  ", "\n\n\n  ", "\n\n  &:focus {\n    outline: none;\n    border: 1px solid ", ";\n    box-shadow: 0px 0px 7px ", ";\n    z-index: 2;\n  }\n\n  ", "\n\n  ", "\n\n    ", "\n    \n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  /* Mozilla Firefox */\n  &[type='number'] {\n    -moz-appearance: textfield;\n  }\n\n  ", "\n\n  ", "\n    ", "\n"], ["\n  flex: 1;\n  height: 100%;\n  min-width: 0;\n  padding: ",
    ";\n  background-color: ", ";\n  font-size: ", ";\n  border: 1px solid ", ";\n  border-radius: ", "px;\n  font-weight: 500;\n  line-height: ", "px;\n  transition: box-shadow 200ms, border 200ms ease-in;\n  color: ", ";\n\n  ",
    "\n\n  ",
    "\n\n  ",
    "\n\n\n  ",
    "\n\n  &:focus {\n    outline: none;\n    border: 1px solid ", ";\n    box-shadow: 0px 0px 7px ", ";\n    z-index: 2;\n  }\n\n  ",
    "\n\n  ",
    "\n\n    ",
    "\n    \n  &::-webkit-outer-spin-button,\n  &::-webkit-inner-spin-button {\n    -webkit-appearance: none;\n    margin: 0;\n  }\n  /* Mozilla Firefox */\n  &[type='number'] {\n    -moz-appearance: textfield;\n  }\n\n  ",
    "\n\n  ",
    "\n    ",
    "\n"])), function (props) { return props.theme.forms.paddingY + "px\n    " + ((props.endIcon && Math.round(props.theme.global.gutterSpace * 2.5)) || props.theme.forms.paddingX) + "px\n    " + props.theme.forms.paddingY + "px\n    " + ((props.startIcon && Math.round(props.theme.global.gutterSpace * 2.5)) || props.theme.forms.paddingX) + "px"; }, function (props) { return props.theme.colors.white; }, function (props) { return props.theme.forms.defaultFontSize; }, function (props) { return props.theme.colors.grey400; }, function (props) { return props.theme.forms.borderRadius; }, function (props) { return props.theme.global.gutterSpace; }, function (props) { return props.theme.colors.grey900; }, function (props) {
    return props.isSelect &&
        "\n    cursor: default;\n  ";
}, function (props) {
    return props.success && css(templateObject_5$t || (templateObject_5$t = __makeTemplateObject(["\n      border: 1px solid ", ";\n    "], ["\n      border: 1px solid ", ";\n    "])), props.theme.colors.green700);
}, function (props) {
    return props.disabled && css(templateObject_6$q || (templateObject_6$q = __makeTemplateObject(["\n      background-color: ", ";\n      border: 1px solid ", ";\n      color: ", ";\n      cursor: not-allowed;\n    "], ["\n      background-color: ", ";\n      border: 1px solid ", ";\n      color: ", ";\n      cursor: not-allowed;\n    "])), props.theme.colors.grey200, props.theme.colors.grey200, props.theme.colors.grey700);
}, function (props) {
    return props.isDataList && css(templateObject_7$q || (templateObject_7$q = __makeTemplateObject(["\n      padding-right: ", "px;\n    "], ["\n      padding-right: ", "px;\n    "])), props.theme.forms.paddingX * 2.5);
}, function (props) { return rgba(props.theme.colors.purple400, 0.6); }, function (props) { return props.theme.colors.purple400; }, function (props) {
    return props.hasPrefix && css(templateObject_8$m || (templateObject_8$m = __makeTemplateObject(["\n      border-radius: 0px ", "px ", "px 0px;\n    "], ["\n      border-radius: 0px ", "px ", "px 0px;\n    "])), props.theme.forms.borderRadius, props.theme.forms.borderRadius);
}, function (props) {
    return props.hasSuffix && css(templateObject_9$f || (templateObject_9$f = __makeTemplateObject(["\n      border-radius: ", "px 0px 0px ", "px;\n      border-right: none;\n\n      &:focus {\n        border-right: none;\n      }\n    "], ["\n      border-radius: ", "px 0px 0px ", "px;\n      border-right: none;\n\n      &:focus {\n        border-right: none;\n      }\n    "])), props.theme.forms.borderRadius, props.theme.forms.borderRadius);
}, function (props) {
    return props.hasSuffix &&
        props.hasPrefix && css(templateObject_10$d || (templateObject_10$d = __makeTemplateObject(["\n      border-radius: 0;\n      border-left: none;\n      border-right: none;\n\n      &:focus {\n        border-left: none;\n        border-right: none;\n      }\n    "], ["\n      border-radius: 0;\n      border-left: none;\n      border-right: none;\n\n      &:focus {\n        border-left: none;\n        border-right: none;\n      }\n    "])));
}, function (props) {
    return !!props.loading && css(templateObject_11$9 || (templateObject_11$9 = __makeTemplateObject(["\n      padding-right: ", "px;\n    "], ["\n      padding-right: ", "px;\n    "])), props.theme.global.gutterSpace * 2);
}, function (props) {
    return props.error && css(templateObject_12$8 || (templateObject_12$8 = __makeTemplateObject(["\n      border: 1px solid ", ";\n    "], ["\n      border: 1px solid ", ";\n    "])), props.theme.colors.red700);
}, function (props) {
    return props.height && css(templateObject_13$7 || (templateObject_13$7 = __makeTemplateObject(["\n      height: ", "px;\n    "], ["\n      height: ", "px;\n    "])), props.height);
});
var InputStartedIcon = styled.span(templateObject_15$5 || (templateObject_15$5 = __makeTemplateObject(["\n  position: absolute;\n  pointer-events: none;\n  left: ", "px;\n  z-index: ", ";\n\n  svg {\n    display: block;\n  }\n"], ["\n  position: absolute;\n  pointer-events: none;\n  left: ", "px;\n  z-index: ", ";\n\n  svg {\n    display: block;\n  }\n"])), function (props) { return props.theme.global.gutterSpace * 0.75; }, function (props) { return props.theme.zIndex.inputIcon; });
var EndIcon = css(templateObject_16$5 || (templateObject_16$5 = __makeTemplateObject(["\n  position: absolute;\n  pointer-events: none;\n  right: ", "px;\n  z-index: ", ";\n"], ["\n  position: absolute;\n  pointer-events: none;\n  right: ", "px;\n  z-index: ", ";\n"])), function (props) { return props.theme.global.gutterSpace * 0.75; }, function (props) { return props.theme.zIndex.inputIcon; });
var InputEndIcon = styled.span(templateObject_17$4 || (templateObject_17$4 = __makeTemplateObject(["\n  ", " {\n    pointer-events: ", ";\n  }\n  svg {\n    display: block;\n  }\n"], ["\n  ", " {\n    pointer-events: ", ";\n  }\n  svg {\n    display: block;\n  }\n"])), EndIcon, function (props) { return (props.actionEndIcon ? 'all' : 'none'); });
var IconStatus = styled.div(templateObject_19$2 || (templateObject_19$2 = __makeTemplateObject(["\n  ", ";\n  opacity: 0;\n  transition: opacity 300ms ease-in-out;\n\n  ", "\n\n  svg {\n    display: block;\n  }\n"], ["\n  ", ";\n  opacity: 0;\n  transition: opacity 300ms ease-in-out;\n\n  ",
    "\n\n  svg {\n    display: block;\n  }\n"])), EndIcon, function (props) {
    return props.visible && css(templateObject_18$2 || (templateObject_18$2 = __makeTemplateObject(["\n      opacity: 1;\n    "], ["\n      opacity: 1;\n    "])));
});
var PasswordButton = styled(FabButton)(templateObject_21$1 || (templateObject_21$1 = __makeTemplateObject(["\n  position: absolute;\n  right: 12px;\n  top: 7px;\n  border-radius: 50%;\n  z-index: ", ";\n\n  ", "\n"], ["\n  position: absolute;\n  right: 12px;\n  top: 7px;\n  border-radius: 50%;\n  z-index: ", ";\n\n  ",
    "\n"])), function (props) { return props.theme.zIndex.inputIcon; }, function (props) {
    return props.showPassword && css(templateObject_20$1 || (templateObject_20$1 = __makeTemplateObject(["\n      display: none;\n    "], ["\n      display: none;\n    "])));
});
var InputLoading = styled(BasicLoading)(templateObject_22$1 || (templateObject_22$1 = __makeTemplateObject(["\n  position: absolute;\n  right: ", "px;\n  top: 50%;\n  margin-top: -", "px;\n  z-index: ", ";\n"], ["\n  position: absolute;\n  right: ", "px;\n  top: 50%;\n  margin-top: -", "px;\n  z-index: ", ";\n"])), function (props) { return props.theme.global.gutterSpace / 1.5; }, function (props) { return props.theme.global.gutterSpace / 2; }, function (props) { return props.theme.zIndex.inputIcon; });
var Container$6 = styled.div(templateObject_24$1 || (templateObject_24$1 = __makeTemplateObject(["\n  width: 100%;\n\n  ", "\n"], ["\n  width: 100%;\n\n  ",
    "\n"])), function (props) {
    return props.horizontalLabel && css(templateObject_23$1 || (templateObject_23$1 = __makeTemplateObject(["\n      width: 50%;\n      ", " {\n        width: 100%;\n      }\n    "], ["\n      width: 50%;\n      ", " {\n        width: 100%;\n      }\n    "])), device.mobile);
});
var styleGroup = css(templateObject_26$1 || (templateObject_26$1 = __makeTemplateObject(["\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 ", "px;\n  background-color: ", ";\n  border: 1px solid ", ";\n  font-size: ", ";\n  color: ", ";\n  line-height: 1;\n\n  ", "\n"], ["\n  height: 100%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0 ", "px;\n  background-color: ", ";\n  border: 1px solid ", ";\n  font-size: ", ";\n  color: ", ";\n  line-height: 1;\n\n  ",
    "\n"])), function (props) { return props.theme.global.gutterSpace * 0.75; }, function (props) { return props.theme.colors.grey100; }, function (props) { return props.theme.colors.grey400; }, function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.colors.grey700; }, function (props) {
    return props.disabled && css(templateObject_25$1 || (templateObject_25$1 = __makeTemplateObject(["\n      border: 1px solid ", ";\n    "], ["\n      border: 1px solid ", ";\n    "])), props.theme.colors.grey100);
});
var PrefixContainer = styled.div(templateObject_27$1 || (templateObject_27$1 = __makeTemplateObject(["\n  position: relative;\n  height: 100%;\n"], ["\n  position: relative;\n  height: 100%;\n"])));
var PrefixOptions = styled.ul(templateObject_28$1 || (templateObject_28$1 = __makeTemplateObject(["\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  max-width: 100%;\n  margin-top: 1px;\n  background-color: ", ";\n  border-radius: ", "px;\n  box-shadow: 0px 2px 5px ", ";\n  overflow: hidden;\n"], ["\n  margin: 0;\n  padding: 0;\n  list-style: none;\n  max-width: 100%;\n  margin-top: 1px;\n  background-color: ", ";\n  border-radius: ", "px;\n  box-shadow: 0px 2px 5px ", ";\n  overflow: hidden;\n"])), function (props) { return props.theme.colors.grey100; }, function (props) { return props.theme.forms.borderRadius; }, function (props) { return rgba(props.theme.colors.grey700, 0.25); });
var SelectPrefix = styled.button(templateObject_29$1 || (templateObject_29$1 = __makeTemplateObject(["\n  padding: ", "px ", "px;\n  width: 100%;\n  background: transparent;\n  text-align: left;\n  border: none;\n  outline: none;\n  color: ", ";\n  font-family: ", ";\n\n  &:hover,\n  &:focus {\n    background-color: ", ";\n  }\n"], ["\n  padding: ", "px ", "px;\n  width: 100%;\n  background: transparent;\n  text-align: left;\n  border: none;\n  outline: none;\n  color: ", ";\n  font-family: ", ";\n\n  &:hover,\n  &:focus {\n    background-color: ", ";\n  }\n"])), function (props) { return props.theme.global.gutterSpace * 0.5; }, function (props) { return props.theme.global.gutterSpace * 0.75; }, function (props) { return props.theme.colors.grey700; }, function (props) { return props.theme.global.defaultFont; }, function (props) { return props.theme.colors.grey200; });
var Prefix = styled.label(templateObject_30$1 || (templateObject_30$1 = __makeTemplateObject(["\n  ", "\n  border-right: none;\n  border-radius: ", "px 0 0 ", "px;\n  width: 100%;\n  outline: none;\n  font-family: ", ";\n\n  ", "\n\n  ", "\n    \n  svg {\n    margin: 2px -2px 0 8px;\n    transition: transform 150ms linear;\n  }\n\n  ", "\n"], ["\n  ", "\n  border-right: none;\n  border-radius: ", "px 0 0 ", "px;\n  width: 100%;\n  outline: none;\n  font-family: ", ";\n\n  ",
    "\n\n  ",
    "\n    \n  svg {\n    margin: 2px -2px 0 8px;\n    transition: transform 150ms linear;\n  }\n\n  ",
    "\n"])), styleGroup, function (props) { return props.theme.forms.borderRadius; }, function (props) { return props.theme.forms.borderRadius; }, function (props) { return props.theme.global.defaultFont; }, function (props) {
    return props.as === 'button' &&
        "\n    &:focus {\n      outline: none;\n      border-color: " + rgba(props.theme.colors.purple400, 0.6) + ";\n      box-shadow: 0px 0px 7px " + props.theme.colors.purple400 + ";\n      z-index: 2;\n    }\n  ";
}, function (props) {
    return props.hasHover &&
        "\n    &:hover {\n      outline: none;\n      border-color: " + rgba(props.theme.colors.purple400, 0.6) + ";\n      box-shadow: 0px 0px 7px " + props.theme.colors.purple400 + ";\n      z-index: 2;\n    }\n  ";
}, function (props) {
    return props.isOpen &&
        "\n    svg { transform: scale(-1); }\n  ";
});
var Suffix = styled.label(templateObject_31$1 || (templateObject_31$1 = __makeTemplateObject(["\n  ", "\n  border-radius: 0 ", "px ", "px 0;\n  border-left: none;\n"], ["\n  ", "\n  border-radius: 0 ", "px ", "px 0;\n  border-left: none;\n"])), styleGroup, function (props) { return props.theme.forms.borderRadius; }, function (props) { return props.theme.forms.borderRadius; });
var templateObject_1$M, templateObject_2$E, templateObject_3$B, templateObject_4$z, templateObject_5$t, templateObject_6$q, templateObject_7$q, templateObject_8$m, templateObject_9$f, templateObject_10$d, templateObject_11$9, templateObject_12$8, templateObject_13$7, templateObject_14$5, templateObject_15$5, templateObject_16$5, templateObject_17$4, templateObject_18$2, templateObject_19$2, templateObject_20$1, templateObject_21$1, templateObject_22$1, templateObject_23$1, templateObject_24$1, templateObject_25$1, templateObject_26$1, templateObject_27$1, templateObject_28$1, templateObject_29$1, templateObject_30$1, templateObject_31$1;

var IconArrowDown$1 = "<svg width=\"12\" height=\"8\" viewBox=\"0 0 12 8\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M0.292893 0.792893C0.683417 0.402369 1.31658 0.402369 1.70711 0.792893L6 5.08579L10.2929 0.792893C10.6834 0.402369 11.3166 0.402369 11.7071 0.792893C12.0976 1.18342 12.0976 1.81658 11.7071 2.20711L6.70711 7.20711C6.31658 7.59763 5.68342 7.59763 5.29289 7.20711L0.292893 2.20711C-0.0976311 1.81658 -0.0976311 1.18342 0.292893 0.792893Z\" />\n</svg>";

var Input = function (props, ref) {
    var id = props.id, testId = props.testId, error = props.error, label = props.label, textHelper = props.textHelper, startIcon = props.startIcon, endIcon = props.endIcon, actionEndIcon = props.actionEndIcon, passwordButton = props.passwordButton, iconSuccessStatus = props.iconSuccessStatus, iconErrorStatus = props.iconErrorStatus, iconTooltip = props.iconTooltip, textTooltip = props.textTooltip, className = props.className, name = props.name, value = props.value, type = props.type, inputContainerRef = props.inputContainerRef, autoComplete = props.autoComplete, readOnly = props.readOnly, disabled = props.disabled, optional = props.optional, loading = props.loading, horizontalLabel = props.horizontalLabel, maxLength = props.maxLength, isDatalistOpen = props.isDatalistOpen, prefix = props.prefix, suffix = props.suffix, arrowDataList = props.arrowDataList, prefixOptions = props.prefixOptions, onChangePrefix = props.onChangePrefix, height = props.height, asSelect = props.asSelect, containerHeight = props.containerHeight, otherProps = __rest(props, ["id", "testId", "error", "label", "textHelper", "startIcon", "endIcon", "actionEndIcon", "passwordButton", "iconSuccessStatus", "iconErrorStatus", "iconTooltip", "textTooltip", "className", "name", "value", "type", "inputContainerRef", "autoComplete", "readOnly", "disabled", "optional", "loading", "horizontalLabel", "maxLength", "isDatalistOpen", "prefix", "suffix", "arrowDataList", "prefixOptions", "onChangePrefix", "height", "asSelect", "containerHeight"]);
    var _a = useState(false), showPassword = _a[0], setShowPassword = _a[1];
    var toggleShowPassword = function () { return setShowPassword(!showPassword); };
    var isDataList = isDatalistOpen !== undefined;
    var isSuccess = (value === null || value === void 0 ? void 0 : value.toString().trim()) !== '';
    var _b = React__default.useState(null), anchorEl = _b[0], setAnchorEl = _b[1];
    var isPrefixPopperOpen = Boolean(anchorEl);
    var prefixId = isPrefixPopperOpen ? 'prefix-dropdown' : undefined;
    var handleTogglePrefix = function (event) {
        if (prefixOptions) {
            setAnchorEl(anchorEl ? null : event.currentTarget);
        }
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(InputField$1, { className: className, horizontalLabel: horizontalLabel, readOnly: readOnly === null || readOnly === void 0 ? void 0 : readOnly.active },
            (label || horizontalLabel) && (React__default.createElement(StyledLabelContainer, { horizontalLabel: horizontalLabel },
                label && (React__default.createElement(StyledLabel, { inputHeight: height, htmlFor: id, error: error, optional: optional, disabled: disabled },
                    label,
                    iconTooltip && textTooltip && (React__default.createElement(Tooltip, { title: textTooltip, placement: "top" },
                        React__default.createElement(StyledIconInputContainer, null, iconTooltip))),
                    iconTooltip && !textTooltip && React__default.createElement(StyledIconInputContainer, { hasMarginLeft: true }, iconTooltip))),
                horizontalLabel && textHelper && (React__default.createElement(StyledHelperInput, { horizontalLabel: horizontalLabel, bottom: false }, textHelper)))),
            React__default.createElement(Container$6, { horizontalLabel: horizontalLabel },
                React__default.createElement(InputContainer$1, { height: containerHeight, disabled: disabled, error: error, ref: inputContainerRef },
                    !prefix && startIcon && React__default.createElement(InputStartedIcon, null, startIcon),
                    prefix && (React__default.createElement(PrefixContainer, null,
                        React__default.createElement(Prefix, { as: prefixOptions ? 'button' : 'label', type: prefixOptions ? 'button' : null, hasHover: prefixOptions, isOpen: isPrefixPopperOpen, disabled: disabled, htmlFor: id, "aria-describedby": prefixId, onClick: handleTogglePrefix },
                            prefix,
                            prefixOptions && React__default.createElement(SvgIcon, { src: IconArrowDown$1, height: 8, width: 8, fill: "grey700" })),
                        prefixOptions && (React__default.createElement(Popper$1, { id: prefixId, open: isPrefixPopperOpen, anchorEl: anchorEl, placement: "bottom-start", disablePortal: true, style: { zIndex: 4, minWidth: '100%' } },
                            React__default.createElement(ClickAwayListener, { onClickAway: handleTogglePrefix },
                                React__default.createElement(PrefixOptions, null, prefixOptions.map(function (prefixOption, index) { return (React__default.createElement("li", { key: "prefix-" + index + "-" + prefixOption.value },
                                    React__default.createElement(SelectPrefix, { type: "button", autoFocus: prefix === prefixOption.label, onClick: function () {
                                            if (onChangePrefix) {
                                                onChangePrefix(prefixOption.value);
                                            }
                                            handleTogglePrefix(undefined);
                                        } }, prefixOption.label))); }))))))),
                    React__default.createElement(TextInput, __assign$2({ height: height, "data-testid": testId, id: id, name: name, value: value, startIcon: startIcon, endIcon: !!(endIcon || passwordButton || iconSuccessStatus || iconErrorStatus), type: showPassword ? 'text' : type, autoComplete: autoComplete, ref: ref, disabled: disabled, isSelect: asSelect, readOnly: (readOnly === null || readOnly === void 0 ? void 0 : readOnly.active) || asSelect, success: !!(iconSuccessStatus && isSuccess), error: error, loading: loading ? 1 : 0, maxLength: maxLength, isDataList: isDataList, hasPrefix: !!prefix, hasSuffix: !!suffix }, otherProps)),
                    arrowDataList,
                    loading && React__default.createElement(InputLoading, { size: 16, thickness: 2 }),
                    suffix ? (React__default.createElement(Suffix, { disabled: disabled, htmlFor: id }, suffix)) : (React__default.createElement(React__default.Fragment, null,
                        iconSuccessStatus && React__default.createElement(IconStatus, { visible: !error && isSuccess },
                            iconSuccessStatus,
                            " "),
                        iconErrorStatus && React__default.createElement(IconStatus, { visible: error },
                            iconErrorStatus,
                            " "),
                        endIcon && !iconSuccessStatus && !iconErrorStatus && React__default.createElement(InputEndIcon, { actionEndIcon: actionEndIcon }, endIcon),
                        type === 'password' && passwordButton && (React__default.createElement(React__default.Fragment, null,
                            React__default.createElement(PasswordButton, { size: "small", iconPath: passwordButton.iconPathScratched, onClick: toggleShowPassword, showPassword: showPassword, fill: "grey700" }),
                            React__default.createElement(PasswordButton, { size: "small", iconPath: passwordButton.iconPath, onClick: toggleShowPassword, showPassword: !showPassword, fill: "grey700" })))))),
                ((error && typeof error === 'string') || textHelper) && (React__default.createElement(StyledHelperInput, { horizontalLabel: horizontalLabel, error: error, bottom: true }, error || textHelper)))),
        (readOnly === null || readOnly === void 0 ? void 0 : readOnly.active) && (React__default.createElement(ReadOnlyField, { label: label, value: readOnly === null || readOnly === void 0 ? void 0 : readOnly.value, thumb: readOnly.thumb, textTooltip: textTooltip, iconTooltip: iconTooltip, testId: testId }))));
};
var Input$1 = forwardRef(Input);

var TextareaField = styled.div(templateObject_1$L || (templateObject_1$L = __makeTemplateObject(["\n  max-width: 100%;\n"], ["\n  max-width: 100%;\n"])));
var TextareaInput = styled.textarea(templateObject_4$y || (templateObject_4$y = __makeTemplateObject(["\n  width: 100%;\n  height: ", "px;\n  resize: none;\n  position: relative;\n  font-size: ", ";\n  font-family: ", ";\n  border: 1px solid ", ";\n  border-radius: ", "px;\n  min-height: 50px;\n  padding: ", "px ", "px;\n  background-color: ", ";\n  transition: box-shadow 200ms, border 200ms ease-in;\n\n  &:focus {\n    outline: none;\n    border: 1px solid ", ";\n    box-shadow: 0px 0px 7px ", ";\n  }\n\n  ", "\n\n  ", "\n"], ["\n  width: 100%;\n  height: ", "px;\n  resize: none;\n  position: relative;\n  font-size: ", ";\n  font-family: ", ";\n  border: 1px solid ", ";\n  border-radius: ", "px;\n  min-height: 50px;\n  padding: ", "px ", "px;\n  background-color: ", ";\n  transition: box-shadow 200ms, border 200ms ease-in;\n\n  &:focus {\n    outline: none;\n    border: 1px solid ", ";\n    box-shadow: 0px 0px 7px ", ";\n  }\n\n  ",
    "\n\n  ",
    "\n"])), function (props) { return props.height; }, function (props) { return props.theme.forms.defaultFontSize; }, function (props) { return props.theme.global.defaultFont; }, function (props) { return props.theme.colors.grey400; }, function (props) { return props.theme.forms.borderRadius; }, function (props) { return props.theme.forms.paddingY; }, function (props) { return props.theme.forms.paddingX; }, function (props) { return props.theme.colors.white; }, function (props) { return rgba(props.theme.colors.purple400, 0.6); }, function (props) { return props.theme.colors.purple400; }, function (props) {
    return props.disabled && css(templateObject_2$D || (templateObject_2$D = __makeTemplateObject(["\n      background-color: ", ";\n      border: 1px solid ", ";\n      color: ", ";\n      cursor: not-allowed;\n    "], ["\n      background-color: ", ";\n      border: 1px solid ", ";\n      color: ", ";\n      cursor: not-allowed;\n    "])), props.theme.colors.grey200, props.theme.colors.grey200, props.theme.colors.grey700);
}, function (props) {
    return props.error && css(templateObject_3$A || (templateObject_3$A = __makeTemplateObject(["\n      border: 1px solid ", ";\n    "], ["\n      border: 1px solid ", ";\n    "])), props.theme.colors.red400);
});
var templateObject_1$L, templateObject_2$D, templateObject_3$A, templateObject_4$y;

var Textarea = function (props, ref) {
    var id = props.id, testId = props.testId, error = props.error, onChange = props.onChange, label = props.label, textHelper = props.textHelper, className = props.className, name = props.name, value = props.value, readOnly = props.readOnly, disabled = props.disabled, optional = props.optional, iconTooltip = props.iconTooltip, textTooltip = props.textTooltip, horizontalLabel = props.horizontalLabel, maxLength = props.maxLength, otherProps = __rest(props, ["id", "testId", "error", "onChange", "label", "textHelper", "className", "name", "value", "readOnly", "disabled", "optional", "iconTooltip", "textTooltip", "horizontalLabel", "maxLength"]);
    var handleChange = function (event) {
        if (onChange) {
            onChange(event);
        }
    };
    return (React__default.createElement(TextareaField, { className: className },
        (label || horizontalLabel) && (React__default.createElement(StyledLabelContainer, { horizontalLabel: horizontalLabel },
            label && (React__default.createElement(StyledLabel, { htmlFor: id, error: error, optional: optional },
                label,
                iconTooltip && textTooltip && (React__default.createElement(AgilizeTooltip, { title: textTooltip },
                    React__default.createElement(StyledIconInputContainer, null, iconTooltip))))),
            horizontalLabel && textHelper && (React__default.createElement(StyledHelperInput, { horizontalLabel: horizontalLabel, bottom: false }, textHelper)))),
        React__default.createElement(TextareaInput, __assign$2({ "data-testid": testId, id: id, name: name, value: value, onChange: handleChange, ref: ref, readOnly: readOnly, disabled: disabled, maxLength: maxLength, error: error }, otherProps)),
        ((error && typeof error === 'string') || textHelper) && React__default.createElement(StyledHelperInput, { error: error }, error || textHelper)));
};
var Textarea$1 = forwardRef(Textarea);

var Container$5 = styled.div(templateObject_2$C || (templateObject_2$C = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n\n  ",
    "\n"])), function (props) {
    return props.readOnly && css(templateObject_1$K || (templateObject_1$K = __makeTemplateObject(["\n      display: none;\n    "], ["\n      display: none;\n    "])));
});
var Icon = styled.svg(templateObject_3$z || (templateObject_3$z = __makeTemplateObject(["\n  fill: none;\n  stroke: ", ";\n  stroke-width: 3px;\n"], ["\n  fill: none;\n  stroke: ", ";\n  stroke-width: 3px;\n"])), Colors.white);
var CheckboxSizes = function (size, error) {
    var borderColor = (!error && Colors.grey400) || Colors.red400;
    var border = "border: 1px solid " + borderColor;
    var sizes = {
        large: css(templateObject_4$x || (templateObject_4$x = __makeTemplateObject(["\n      ", ";\n      width: 20px;\n      height: 20px;\n      flex: 0 0 20px;\n      border-radius: ", "px;\n    "], ["\n      ", ";\n      width: 20px;\n      height: 20px;\n      flex: 0 0 20px;\n      border-radius: ", "px;\n    "])), border, function (props) { return props.theme.forms.borderRadius / 2; }),
        medium: css(templateObject_5$s || (templateObject_5$s = __makeTemplateObject(["\n      ", ";\n      width: 20px;\n      height: 20px;\n      flex: 0 0 20px;\n      border-radius: ", "px;\n    "], ["\n      ", ";\n      width: 20px;\n      height: 20px;\n      flex: 0 0 20px;\n      border-radius: ", "px;\n    "])), border, function (props) { return props.theme.forms.borderRadius / 2; }),
        small: css(templateObject_6$p || (templateObject_6$p = __makeTemplateObject(["\n      ", ";\n      width: 16px;\n      height: 16px;\n      flex: 0 0 16px;\n      border-radius: ", "px;\n    "], ["\n      ", ";\n      width: 16px;\n      height: 16px;\n      flex: 0 0 16px;\n      border-radius: ", "px;\n    "])), border, function (props) { return props.theme.forms.borderRadius / 2; }),
    };
    return sizes[size] || sizes['medium'];
};
var Checkbox$1 = styled.div(templateObject_9$e || (templateObject_9$e = __makeTemplateObject(["\n  display: inline-block;\n  cursor: pointer;\n\n  ", ";\n\n  svg {\n    display: block;\n  }\n\n  ", " {\n    visibility: hidden;\n  }\n\n  ", "\n\n  ", "\n"], ["\n  display: inline-block;\n  cursor: pointer;\n\n  ", ";\n\n  svg {\n    display: block;\n  }\n\n  ", " {\n    visibility: hidden;\n  }\n\n  ",
    "\n\n  ",
    "\n"])), function (props) { return CheckboxSizes(props.size, props.error); }, Icon, function (props) {
    return props.disabled && css(templateObject_7$p || (templateObject_7$p = __makeTemplateObject(["\n      background-color: ", ";\n      cursor: not-allowed;\n    "], ["\n      background-color: ", ";\n      cursor: not-allowed;\n    "])), props.theme.colors.grey200);
}, function (props) {
    return props.disabled && css(templateObject_8$l || (templateObject_8$l = __makeTemplateObject(["\n      border: 1px solid ", ";\n      background-color: ", ";\n      cursor: not-allowed;\n    "], ["\n      border: 1px solid ", ";\n      background-color: ", ";\n      cursor: not-allowed;\n    "])), props.theme.colors.grey400, props.theme.colors.grey400);
});
var Label = styled.label(templateObject_11$8 || (templateObject_11$8 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  font-size: ", ";\n  color: ", ";\n  line-height: ", "px;\n\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  font-size: ", ";\n  color: ", ";\n  line-height: ", "px;\n\n  ",
    "\n"])), function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.colors.grey900; }, function (props) { return props.theme.global.gutterSpace; }, function (props) {
    return props.disabled && css(templateObject_10$c || (templateObject_10$c = __makeTemplateObject(["\n      color: ", ";\n      cursor: not-allowed;\n    "], ["\n      color: ", ";\n      cursor: not-allowed;\n    "])), props.theme.colors.grey700);
});
var LabelPosition = function (position, gutterSpace) {
    var space = gutterSpace / 2 + "px";
    var positions = {
        left: 'margin-right',
        right: 'margin-left',
    };
    return (positions[position] || positions['right']) + ": " + space;
};
var LabelSizes = function (size) {
    var sizes = {
        small: '1.2',
        medium: '1.4',
        large: '1.4',
    };
    return (sizes[size] || sizes['medium']) + "rem";
};
var LabelText = styled.span(templateObject_13$6 || (templateObject_13$6 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  font-size: ", ";\n  ", ";\n\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  font-size: ", ";\n  ", ";\n\n  ",
    "\n"])), function (props) { return LabelSizes(props.size); }, function (props) { return LabelPosition(props.position, props.theme.global.gutterSpace); }, function (props) {
    return props.error && css(templateObject_12$7 || (templateObject_12$7 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), props.theme.colors.red700);
});
var HiddenInput$1 = styled.input(templateObject_16$4 || (templateObject_16$4 = __makeTemplateObject(["\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n\n  &:checked + ", " {\n    border: 1px solid ", ";\n    background-color: ", ";\n\n    ", "\n\n    ", "\n\n    ", " {\n      visibility: visible;\n    }\n  }\n"], ["\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n\n  &:checked + ", " {\n    border: 1px solid ", ";\n    background-color: ", ";\n\n    ",
    "\n\n    ",
    "\n\n    ", " {\n      visibility: visible;\n    }\n  }\n"])), Checkbox$1, function (props) { return props.theme.colors.purple600; }, function (props) { return props.theme.colors.purple600; }, function (props) {
    return props.disabled && css(templateObject_14$4 || (templateObject_14$4 = __makeTemplateObject(["\n        border: 1px solid ", ";\n        background-color: ", ";\n        cursor: not-allowed;\n      "], ["\n        border: 1px solid ", ";\n        background-color: ", ";\n        cursor: not-allowed;\n      "])), props.theme.colors.grey400, props.theme.colors.grey400);
}, function (props) {
    return props.error && css(templateObject_15$4 || (templateObject_15$4 = __makeTemplateObject(["\n        border: 1px solid ", ";\n      "], ["\n        border: 1px solid ", ";\n      "])), props.theme.colors.red700);
}, Icon);
var templateObject_1$K, templateObject_2$C, templateObject_3$z, templateObject_4$x, templateObject_5$s, templateObject_6$p, templateObject_7$p, templateObject_8$l, templateObject_9$e, templateObject_10$c, templateObject_11$8, templateObject_12$7, templateObject_13$6, templateObject_14$4, templateObject_15$4, templateObject_16$4;

var CheckboxInput = function (props, ref) {
    var checked = props.checked, id = props.id, testId = props.testId, label = props.label, size = props.size, name = props.name, onChange = props.onChange, className = props.className, error = props.error, readOnly = props.readOnly, disabled = props.disabled, iconTooltip = props.iconTooltip, textTooltip = props.textTooltip, otherProps = __rest(props, ["checked", "id", "testId", "label", "size", "name", "onChange", "className", "error", "readOnly", "disabled", "iconTooltip", "textTooltip"]);
    var _a = useState(otherProps.defaultChecked || checked), watchDefaultValue = _a[0], setWatchDefaultValue = _a[1];
    useEffect(function () {
        setWatchDefaultValue(checked);
    }, [checked]);
    var handleChange = function (event) {
        setWatchDefaultValue(!watchDefaultValue);
        if (onChange) {
            onChange(event);
        }
    };
    var renderTooltip = (React__default.createElement(React__default.Fragment, null,
        iconTooltip && textTooltip && (React__default.createElement(Tooltip, { title: textTooltip, placement: "top" },
            React__default.createElement(StyledIconInputContainer, null, iconTooltip))),
        iconTooltip && !textTooltip && React__default.createElement(StyledIconInputContainer, { singleTip: true }, iconTooltip)));
    var checkLabel = function (children) {
        if (label) {
            var text = label.text, position = label.position;
            var labelText = (React__default.createElement(LabelText, { position: position, size: label.size, error: !!error },
                text,
                renderTooltip));
            return (React__default.createElement(Label, { htmlFor: id, disabled: disabled },
                position === 'left' && labelText,
                children,
                (!position || position === 'right') && labelText));
        }
        return React__default.Children.map(children, function (child) { return React__default.cloneElement(child, { onClick: handleChange }); });
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Container$5, { className: className, readOnly: readOnly === null || readOnly === void 0 ? void 0 : readOnly.active }, checkLabel([
            React__default.createElement(HiddenInput$1, __assign$2({ key: "input-hidden", id: id, type: "checkbox", name: name, "data-testid": testId, disabled: disabled, ref: ref, onChange: handleChange, error: !!error }, otherProps, { checked: checked })),
            React__default.createElement(Checkbox$1, { key: "input-custom", size: size || 'medium', error: !!error, disabled: disabled },
                React__default.createElement(Icon, { viewBox: "0 0 25 25", "data-testid": "check-icon" },
                    React__default.createElement("polyline", { points: "20 6 9 18 4 12", strokeLinejoin: "round" }))),
        ])),
        (readOnly === null || readOnly === void 0 ? void 0 : readOnly.active) && React__default.createElement(ReadOnlyField, { label: label.text, value: readOnly === null || readOnly === void 0 ? void 0 : readOnly.value, iconTooltip: iconTooltip, textTooltip: textTooltip, testId: testId })));
};
var Checkbox = forwardRef(CheckboxInput);

var gutterSpace$2 = theme.global.gutterSpace;
var ContainerCustom = styled.div(templateObject_1$J || (templateObject_1$J = __makeTemplateObject(["\n  width: 100%;\n  display: block;\n  margin-right: auto;\n  margin-left: auto;\n\n  ", "\n"], ["\n  width: 100%;\n  display: block;\n  margin-right: auto;\n  margin-left: auto;\n\n  ",
    "\n"])), function (props) {
    return !props.noGutter &&
        "\n    padding-left: " + gutterSpace$2 / 2 + "px;\n    padding-right: " + gutterSpace$2 / 2 + "px;\n  ";
});
var Container$4 = function (_a) {
    var className = _a.className, children = _a.children, noGutter = _a.noGutter;
    return (React__default.createElement(ContainerCustom, { className: className, noGutter: noGutter }, children));
};
var templateObject_1$J;

var gutterSpace$1 = theme.global.gutterSpace;
var RowCustom = styled.div(templateObject_1$I || (templateObject_1$I = __makeTemplateObject(["\n  margin-left: ", ";\n  margin-right: ", ";\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: ", ";\n"], ["\n  margin-left: ", ";\n  margin-right: ", ";\n  display: flex;\n  flex-wrap: wrap;\n  justify-content: ", ";\n"])), function (props) { return (!props.noGutter ? "-" + gutterSpace$1 / 2 + "px" : '0px'); }, function (props) { return (!props.noGutter ? "-" + gutterSpace$1 / 2 + "px" : '0px'); }, function (props) { return props.justifyContent || 'initial'; });
var Row = function (_a) {
    var justifyContent = _a.justifyContent, children = _a.children, className = _a.className, noGutter = _a.noGutter;
    return (React__default.createElement(RowCustom, { justifyContent: justifyContent, className: className, noGutter: noGutter }, children));
};
var templateObject_1$I;

var noCol = 24;
var gutterSpace = theme.global.gutterSpace;
var getWidthGrid = function (value, offset) {
    var width = (value * 100) / noCol;
    var offsetValue = '';
    if (offset && noCol - value >= offset) {
        var margin = (offset * 100) / noCol;
        offsetValue = "margin-left: " + (margin.toString().length > 4 ? margin.toFixed(4) : margin) + "%;";
    }
    var widthFixed = width.toString().length > 4 ? width.toFixed(4) : width;
    return "flex: 0 0 " + widthFixed + "%;\n  max-width: " + widthFixed + "%;\n  " + offsetValue;
};
var ResponsiveCol = css(templateObject_1$H || (templateObject_1$H = __makeTemplateObject(["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"], ["\n  ", "\n  ", "\n  ", "\n  ", "\n  ", "\n"])), function (props) { return props.small && device.mobile + " {" + getWidthGrid(props.small, props.offsetLeft) + "}"; }, function (props) { return props.medium && device.tablet + " {" + getWidthGrid(props.medium, props.offsetLeft) + "}"; }, function (props) { return props.large && device.desktop + " {" + getWidthGrid(props.large, props.offsetLeft) + "}"; }, function (props) { return props.extraLarge && device.desktopLarge + " {" + getWidthGrid(props.extraLarge, props.offsetLeft) + "}"; }, function (props) { return props.desktopMedium && device.desktopMedium + " {" + getWidthGrid(props.desktopMedium, props.offsetLeft) + "}"; });
var ColCustom = styled.div(templateObject_2$B || (templateObject_2$B = __makeTemplateObject(["\n  position: relative;\n  padding-left: ", ";\n  padding-right: ", ";\n  min-height: 1px;\n  flex-grow: 1;\n  flex-basis: 0;\n  ", "\n  ", ";\n  ", "\n"], ["\n  position: relative;\n  padding-left: ", ";\n  padding-right: ", ";\n  min-height: 1px;\n  flex-grow: 1;\n  flex-basis: 0;\n  ", "\n  ", ";\n  ", "\n"])), function (props) { return (props.noGutter ? 0 : gutterSpace / 2 + "px"); }, function (props) { return (props.noGutter ? 0 : gutterSpace / 2 + "px"); }, function (props) { return props.alignSelf && "align-self: " + props.alignSelf + ";"; }, function (props) { return (props.small === props.medium && props.small === props.large ? getWidthGrid(props.small, props.offsetLeft) : ResponsiveCol); }, color);
var Col = function (_a) {
    var children = _a.children, props = __rest(_a, ["children"]);
    return React__default.createElement(ColCustom, __assign$2({}, props), children);
};
var templateObject_1$H, templateObject_2$B;

var Aside = styled.aside(templateObject_1$G || (templateObject_1$G = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  height: 100vh;\n  width: ", "px;\n\n  ", " {\n    width: 100%;\n    height: ", "px;\n  }\n\n  @media print {\n    display: none;\n    width: 0;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  position: relative;\n  height: 100vh;\n  width: ", "px;\n\n  ", " {\n    width: 100%;\n    height: ", "px;\n  }\n\n  @media print {\n    display: none;\n    width: 0;\n  }\n"])), function (props) { return props.theme.sideNav.width; }, device.mobile, function (props) { return (props.theme.global.headerSize / 5) * 4; });
var DesktopFabButton = styled(FabButton)(templateObject_2$A || (templateObject_2$A = __makeTemplateObject(["\n  padding: ", "px;\n  margin-right: ", "px;\n  transition: transform ", ";\n  transform: scaleX(-1);\n  ", "\n\n  ", " {\n    display: none;\n  }\n"], ["\n  padding: ", "px;\n  margin-right: ", "px;\n  transition: transform ", ";\n  transform: scaleX(-1);\n  ", "\n\n  ", " {\n    display: none;\n  }\n"])), function (props) { return props.theme.global.gutterSpace / 2; }, function (props) { return -props.theme.global.gutterSpace / 2; }, function (props) { return "100ms " + props.theme.sideNav.animation; }, function (props) { return props.isOpen && 'transform: scaleX(1);'; }, device.mobile);
var MobileFabButton = styled(FabButton)(templateObject_3$y || (templateObject_3$y = __makeTemplateObject(["\n  display: none;\n  transition: transform ", ";\n\n  ", " {\n    display: block;\n  }\n"], ["\n  display: none;\n  transition: transform ", ";\n\n  ", " {\n    display: block;\n  }\n"])), function (props) { return props.theme.sideNav.animationDuration + " " + props.theme.sideNav.animation; }, device.mobile);
var HeaderSidebar = styled.div(templateObject_4$w || (templateObject_4$w = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  min-height: ", "px;\n  background-color: ", ";\n  transition: all 0.3s ease;\n  padding: 0 ", "px;\n  transition: padding ", ";\n\n  ", " {\n    && {\n      min-height: ", "px;\n      justify-content: space-between;\n      padding-left: ", "px;\n\n      .agilize-name {\n        opacity: 1;\n        transform: unset;\n      }\n    }\n  }\n\n  .agilize-name {\n    transform: translateX(0);\n    transition: opacity ", ",\n      transform ", ";\n  }\n\n  ", "\n\n  .agilize-logo {\n    max-width: none;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: space-between;\n  align-items: center;\n  min-height: ", "px;\n  background-color: ", ";\n  transition: all 0.3s ease;\n  padding: 0 ", "px;\n  transition: padding ", ";\n\n  ", " {\n    && {\n      min-height: ", "px;\n      justify-content: space-between;\n      padding-left: ", "px;\n\n      .agilize-name {\n        opacity: 1;\n        transform: unset;\n      }\n    }\n  }\n\n  .agilize-name {\n    transform: translateX(0);\n    transition: opacity ", ",\n      transform ", ";\n  }\n\n  ",
    "\n\n  .agilize-logo {\n    max-width: none;\n  }\n"])), function (props) { return Math.round(props.theme.global.headerSize * 1.66); }, function (props) { return props.theme.sideNav.backgroundColorHeader; }, function (props) { return props.theme.global.gutterSpace; }, function (props) { return props.theme.sideNav.animationDuration + " " + props.theme.sideNav.animation; }, device.mobile, function (props) { return (props.theme.global.headerSize / 5) * 4; }, function (props) { return props.theme.global.gutterSpace; }, function (props) { return props.theme.sideNav.animationDuration + " " + props.theme.sideNav.animation; }, function (props) { return props.theme.sideNav.animationDuration + " " + props.theme.sideNav.animation; }, function (props) {
    return !props.isOpen &&
        "\n    justify-content: flex-start;\n    padding-left: " + (props.theme.sideNav.width - props.theme.sideNav.iconLogoWidth) / 2 + "px;\n\n    .desktop-button {\n      display: none;\n    }\n\n    .agilize-name {\n      opacity: 0;\n      transform: translateX(-30%);\n    }\n  ";
});
var Sidebar = styled.div(templateObject_5$r || (templateObject_5$r = __makeTemplateObject(["\n  width: ", "px;\n  max-height: calc(100vh - ", "px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  flex: 1;\n\n  ::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  /* Track */\n  ::-webkit-scrollbar-track {\n    background: ", ";\n  }\n\n  /* Handle */\n  ::-webkit-scrollbar-thumb {\n    background: ", ";\n  }\n\n  /* Handle on hover */\n  ::-webkit-scrollbar-thumb:hover {\n    background: ", ";\n  }\n\n  ", " {\n    position: absolute;\n    width: 80vw;\n    height: 100vh;\n    max-height: none;\n    transform: translateX(-100%);\n    background-color: ", ";\n    transition: transform ", ";\n    z-index: 2;\n  }\n"], ["\n  width: ", "px;\n  max-height: calc(100vh - ", "px);\n  overflow-y: auto;\n  overflow-x: hidden;\n  flex: 1;\n\n  ::-webkit-scrollbar {\n    width: 8px;\n  }\n\n  /* Track */\n  ::-webkit-scrollbar-track {\n    background: ", ";\n  }\n\n  /* Handle */\n  ::-webkit-scrollbar-thumb {\n    background: ", ";\n  }\n\n  /* Handle on hover */\n  ::-webkit-scrollbar-thumb:hover {\n    background: ", ";\n  }\n\n  ", " {\n    position: absolute;\n    width: 80vw;\n    height: 100vh;\n    max-height: none;\n    transform: translateX(-100%);\n    background-color: ", ";\n    transition: transform ", ";\n    z-index: 2;\n  }\n"])), function (props) { return props.theme.sideNav.expandedWidth; }, function (props) { return Math.round(props.theme.global.headerSize * 1.66); }, function (props) { return props.theme.colors.grey100; }, function (props) { return props.theme.colors.grey100; }, function (props) { return props.theme.colors.grey100; }, device.mobile, function (props) { return props.theme.sideNav.backgroundColor; }, function (props) { return props.theme.sideNav.animationDuration + " " + props.theme.sideNav.animation; });
var AsideContent = styled.div(templateObject_6$o || (templateObject_6$o = __makeTemplateObject(["\n  position: fixed;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  min-height: 100%;\n  width: ", "px;\n  transition: width ", ";\n  box-shadow: 1px 0px 8px ", ";\n  background-color: ", ";\n  overflow: hidden;\n  user-select: none;\n  z-index: 9;\n\n  .collapse--hide {\n    display: flex;\n    flex: 1;\n    transition: opacity ", ",\n      transform ", ";\n    opacity: 0;\n    transform: translateX(-15%);\n  }\n\n  .expansion-details {\n    display: ", ";\n  }\n\n  .expansion-icon {\n    transition: margin ", ";\n    margin-left: ", "px;\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n\n  ", " {\n    position: absolute;\n    overflow: initial;\n    transition: none;\n    width: 100%;\n    height: 100%;\n    box-shadow: none;\n\n    &:hover {\n      width: 100%;\n    }\n\n    .collapse--hide {\n      opacity: 1;\n      transform: translateX(0);\n    }\n\n    ", "\n  }\n"], ["\n  position: fixed;\n  display: flex;\n  flex-direction: column;\n  justify-content: flex-start;\n  min-height: 100%;\n  width: ", "px;\n  transition: width ", ";\n  box-shadow: 1px 0px 8px ", ";\n  background-color: ", ";\n  overflow: hidden;\n  user-select: none;\n  z-index: 9;\n\n  .collapse--hide {\n    display: flex;\n    flex: 1;\n    transition: opacity ", ",\n      transform ", ";\n    opacity: 0;\n    transform: translateX(-15%);\n  }\n\n  .expansion-details {\n    display: ", ";\n  }\n\n  .expansion-icon {\n    transition: margin ", ";\n    margin-left: ", "px;\n  }\n\n  ",
    "\n\n  ",
    "\n\n  ",
    "\n\n  ", " {\n    position: absolute;\n    overflow: initial;\n    transition: none;\n    width: 100%;\n    height: 100%;\n    box-shadow: none;\n\n    &:hover {\n      width: 100%;\n    }\n\n    .collapse--hide {\n      opacity: 1;\n      transform: translateX(0);\n    }\n\n    ",
    "\n  }\n"])), function (props) { return props.theme.sideNav.width; }, function (props) { return props.theme.sideNav.animationDuration + " " + props.theme.sideNav.animation; }, function (props) { return rgba(props.theme.colors.grey400, 0.5); }, function (props) { return props.theme.sideNav.backgroundColor; }, function (props) { return props.theme.sideNav.animationDuration + " " + props.theme.sideNav.animation; }, function (props) { return props.theme.sideNav.animationDuration + " " + props.theme.sideNav.animation; }, function (props) { return (props.isOpen ? 'block' : 'none'); }, function (props) { return props.theme.sideNav.animationDuration + " " + props.theme.sideNav.animation; }, function (props) { return props.theme.sideNav.width / 6; }, function (props) {
    return !props.isOpen &&
        "\n    &:not(:hover) {\n      .summary-padding.primary {\n        max-height: 40px;\n      }\n\n      " + device.desktop + "{\n        .accordion-container {\n          height: 0;\n        }\n      }\n\n      " + device.tablet + " {\n        .accordion-container {\n          height: 0;\n        }\n      }\n    }\n  ";
}, function (props) {
    return !props.isTrasitioning &&
        "&:hover {\n      width: " + props.theme.sideNav.expandedWidth + "px;\n\n      .expansion-details {\n        display: block;\n      }\n\n      .expansion-icon {\n        margin-left: 0;\n      }\n\n      .collapse--hide {\n        opacity: 1;\n        transform: translateX(0);\n      }\n\n      " + HeaderSidebar + " {\n        justify-content: space-between;\n\n        " + (!props.isOpen &&
            "\n          padding-left: " + props.theme.global.gutterSpace + "px;\n\n          .agilize-name {\n            opacity: 1;\n            transform: translateX(0);\n          }\n\n          .desktop-button {\n            display: block;\n          }\n\n          " + device.mobile + " {\n            .desktop-button {\n              display: none;\n            }\n          }\n        ") + "\n      }\n    }";
}, function (props) {
    return props.isOpen &&
        "\n      width: " + props.theme.sideNav.expandedWidth + "px;\n\n      .expansion-icon {\n        margin-left: 0;\n      }\n\n      .collapse--hide {\n        opacity: 1;\n        transform: translateX(0);\n      }\n   ";
}, device.mobile, function (props) {
    return props.mobileSidebarIsOpen &&
        "\n        " + Sidebar + " {\n          transform: translateX(0);\n        }\n\n        &:after {\n           opacity: 1;\n        }\n    ";
});
var Overlay = styled.div(templateObject_7$o || (templateObject_7$o = __makeTemplateObject(["\n  position: absolute;\n\n  ", " {\n    width: 100vw;\n    height: calc(100vh - ", "px);\n    top: ", "px;\n    transition: opacity 200ms linear;\n    background-color: ", ";\n    opacity: 1;\n    pointer-events: pointer;\n    z-index: 1;\n  }\n"], ["\n  position: absolute;\n\n  ", " {\n    width: 100vw;\n    height: calc(100vh - ", "px);\n    top: ", "px;\n    transition: opacity 200ms linear;\n    background-color: ", ";\n    opacity: 1;\n    pointer-events: pointer;\n    z-index: 1;\n  }\n"])), device.mobile, function (props) { return (props.theme.global.headerSize / 5) * 4; }, function (props) { return (props.theme.global.headerSize / 5) * 4; }, function (props) { return rgba(props.theme.colors.grey400, 0.6); });
var templateObject_1$G, templateObject_2$A, templateObject_3$y, templateObject_4$w, templateObject_5$r, templateObject_6$o, templateObject_7$o;

var Drawer = function (props) {
    var children = props.children, handleToggleSidebar = props.handleToggleSidebar, isOpen = props.isOpen, logo = props.logo, desktopIconPath = props.desktopIconPath, mobileIconPath = props.mobileIconPath, className = props.className;
    var _a = useState(false), transitioningDrawer = _a[0], setTransitioningDrawer = _a[1];
    var _b = useState(false), mobileSidebarIsOpen = _b[0], setMobileSidebarIsOpen = _b[1];
    var handleClickAsideButton = function () {
        setTransitioningDrawer(true);
        handleToggleSidebar();
        setTimeout(function () {
            setTransitioningDrawer(false);
        }, 200);
    };
    var handleOpenMobileSidebar = function () { return setMobileSidebarIsOpen(!mobileSidebarIsOpen); };
    return (React__default.createElement(Aside, { className: className },
        React__default.createElement(AsideContent, { "data-testid": "aside-content", isOpen: isOpen, isTrasitioning: transitioningDrawer, mobileSidebarIsOpen: mobileSidebarIsOpen },
            React__default.createElement(HeaderSidebar, { isOpen: isOpen },
                logo,
                React__default.createElement(DesktopFabButton, { title: isOpen ? 'Minimizar' : 'Maximizar', testId: "desktop-fabButton", iconPath: desktopIconPath, onClick: handleClickAsideButton, isOpen: isOpen, className: "desktop-button", disableActiveStyle: true, disabledBackgroundColor: true }),
                React__default.createElement(MobileFabButton, { testId: "mobile-fabButton", iconPath: mobileIconPath, onClick: handleOpenMobileSidebar, isOpen: isOpen, className: "mobile-button" })),
            mobileSidebarIsOpen && React__default.createElement(Overlay, { onClick: handleOpenMobileSidebar }),
            React__default.createElement(Sidebar, null, children))));
};

var Container$3 = styled.div(templateObject_1$F || (templateObject_1$F = __makeTemplateObject(["\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  width: 100%;\n\n  ", " {\n    flex-direction: column;\n  }\n"], ["\n  display: flex;\n  flex: 1;\n  flex-direction: row;\n  width: 100%;\n\n  ", " {\n    flex-direction: column;\n  }\n"])), device.mobile);
var templateObject_1$F;

var DrawerContainer = function (props) {
    var children = props.children, className = props.className;
    var _a = useState(true), isOpen = _a[0], setIsOpen = _a[1];
    var handleToggleSidebar = function () { return setIsOpen(!isOpen); };
    var childrenWithProps = Children.map(children, function (child) { return cloneElement(child, { isOpen: isOpen, handleToggleSidebar: handleToggleSidebar }); });
    return React__default.createElement(Container$3, { className: className }, childrenWithProps);
};

var Content = styled.div(templateObject_1$E || (templateObject_1$E = __makeTemplateObject(["\n  flex: 1;\n  transition: margin ", ";\n\n  ", "\n\n  ", " {\n    transition: none;\n    margin-left: 0;\n  }\n\n  @media print {\n    margin: 0;\n  }\n"], ["\n  flex: 1;\n  transition: margin ", ";\n\n  ", "\n\n  ", " {\n    transition: none;\n    margin-left: 0;\n  }\n\n  @media print {\n    margin: 0;\n  }\n"])), function (props) { return props.theme.sideNav.animationDuration + " " + props.theme.sideNav.animation; }, function (props) { return props.isOpen && "margin-left: " + (props.theme.sideNav.expandedWidth - props.theme.sideNav.width) + "px;"; }, device.mobile);
var templateObject_1$E;

var DrawerContent$1 = function (props) {
    var children = props.children, isOpen = props.isOpen, className = props.className;
    return (React__default.createElement(Content, { className: className, isOpen: isOpen }, children));
};

var Container$2 = styled.div(templateObject_1$D || (templateObject_1$D = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  height: ", "px;\n  box-shadow: 1px 0px 8px ", ";\n  transition: all 300ms ease;\n  overflow: hidden;\n  background-color: ", ";\n  ", " {\n    height: ", "px;\n  }\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-start;\n  align-items: center;\n  height: ", "px;\n  box-shadow: 1px 0px 8px ", ";\n  transition: all 300ms ease;\n  overflow: hidden;\n  background-color: ", ";\n  ", " {\n    height: ", "px;\n  }\n"])), function (props) { return props.theme.global.headerSize; }, function (props) { return rgba(props.theme.colors.grey400, 0.2); }, function (props) { return props.theme.colors.white; }, device.mobile, function (props) { return (props.theme.global.headerSize / 5) * 4; });
var templateObject_1$D;

var Header = function (props) {
    var className = props.className, children = props.children;
    return React__default.createElement(Container$2, { className: className }, children);
};

var SelectField = styled.div(templateObject_2$z || (templateObject_2$z = __makeTemplateObject(["\n  max-width: 100%;\n\n  ", "\n"], ["\n  max-width: 100%;\n\n  ",
    "\n"])), function (props) {
    return props.readOnly && css(templateObject_1$C || (templateObject_1$C = __makeTemplateObject(["\n      display: none;\n    "], ["\n      display: none;\n    "])));
});
var SelectContainer = styled.div(templateObject_3$x || (templateObject_3$x = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var ArrowSelect = styled(SvgIcon)(templateObject_4$v || (templateObject_4$v = __makeTemplateObject(["\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: 50%;\n  transform: translateY(-50%);\n  right: ", "px;\n  pointer-events: none;\n  fill: ", ";\n  transition: background-color 150ms ease-in, transform 180ms linear;\n"], ["\n  position: absolute;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  top: 50%;\n  transform: translateY(-50%);\n  right: ", "px;\n  pointer-events: none;\n  fill: ", ";\n  transition: background-color 150ms ease-in, transform 180ms linear;\n"])), function (props) { return props.theme.global.gutterSpace; }, function (props) { return props.theme.colors.grey700; });
var Select$1 = styled.select(templateObject_8$k || (templateObject_8$k = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0 ", "px 0 ", "px;\n  width: 100%;\n  height: ", "px;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  text-indent: 0;\n  text-overflow: initial;\n  background-color: ", ";\n  font-size: ", ";\n  font-family: ", ";\n  border: 1px solid ", ";\n  border-radius: ", "px;\n  transition: box-shadow 200ms, border 200ms ease-in;\n\n  ", ";\n\n  &::-ms-expand {\n    display: none;\n  }\n\n  &::-moz-focus-inner {\n    border: 0;\n    padding: 0;\n  }\n\n  &:focus {\n    outline-offset: 0;\n    outline: none;\n    border: 1px solid ", ";\n    box-shadow: 0px 0px 7px ", ";\n  }\n\n  option.hide {\n    display: none;\n  }\n\n  option:disabled {\n    ", ";\n  }\n\n  ", "\n  ", "\n  ", "\n  optgroup {\n    color: ", ";\n  }\n\n  option {\n    color: ", ";\n  }\n"], ["\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  align-items: center;\n  padding: 0 ", "px 0 ", "px;\n  width: 100%;\n  height: ", "px;\n  -webkit-appearance: none;\n  -moz-appearance: none;\n  text-indent: 0;\n  text-overflow: initial;\n  background-color: ", ";\n  font-size: ", ";\n  font-family: ", ";\n  border: 1px solid ", ";\n  border-radius: ", "px;\n  transition: box-shadow 200ms, border 200ms ease-in;\n\n  ", ";\n\n  &::-ms-expand {\n    display: none;\n  }\n\n  &::-moz-focus-inner {\n    border: 0;\n    padding: 0;\n  }\n\n  &:focus {\n    outline-offset: 0;\n    outline: none;\n    border: 1px solid ", ";\n    box-shadow: 0px 0px 7px ", ";\n  }\n\n  option.hide {\n    display: none;\n  }\n\n  option:disabled {\n    ", ";\n  }\n\n  ",
    "\n  ",
    "\n  ",
    "\n  optgroup {\n    color: ", ";\n  }\n\n  option {\n    color: ", ";\n  }\n"])), function (props) { return Math.round(props.theme.global.gutterSpace * 1.6); }, function (props) { return Math.round(props.theme.global.gutterSpace * 0.8); }, function (props) { return props.theme.forms.defaultHeight; }, function (props) { return props.theme.colors.white; }, function (props) { return props.theme.forms.defaultFontSize; }, function (props) { return props.theme.global.defaultFont; }, function (props) { return props.theme.colors.grey400; }, function (props) { return props.theme.forms.borderRadius; }, function (props) { return props.error && "border-color: " + props.theme.colors.red400 + ";"; }, function (props) { return rgba(props.theme.colors.purple400, 0.6); }, function (props) { return props.theme.colors.purple400; }, function (props) { return props.theme.colors.grey700; }, function (props) {
    return props.disabled && css(templateObject_5$q || (templateObject_5$q = __makeTemplateObject(["\n      background-color: ", ";\n      border: 1px solid ", ";\n      color: ", ";\n      cursor: not-allowed;\n    "], ["\n      background-color: ", ";\n      border: 1px solid ", ";\n      color: ", ";\n      cursor: not-allowed;\n    "])), props.theme.colors.grey200, props.theme.colors.grey200, props.theme.colors.grey700);
}, function (props) {
    return props.error && css(templateObject_6$n || (templateObject_6$n = __makeTemplateObject(["\n      border: 1px solid ", ";\n    "], ["\n      border: 1px solid ", ";\n    "])), props.theme.colors.red700);
}, function (props) {
    return props.success && css(templateObject_7$n || (templateObject_7$n = __makeTemplateObject(["\n      border: 1px solid ", ";\n    "], ["\n      border: 1px solid ", ";\n    "])), props.theme.colors.green700);
}, function (props) { return props.theme.colors.grey400; }, function (props) { return props.theme.colors.grey700; });
var templateObject_1$C, templateObject_2$z, templateObject_3$x, templateObject_4$v, templateObject_5$q, templateObject_6$n, templateObject_7$n, templateObject_8$k;

var SelectInput = function (props, ref) {
    var name = props.name, testId = props.testId, error = props.error, onChange = props.onChange, label = props.label, textHelper = props.textHelper, options = props.options, iconTooltip = props.iconTooltip, textTooltip = props.textTooltip, className = props.className, id = props.id, value = props.value, emptyOption = props.emptyOption, optional = props.optional, disabled = props.disabled, readOnly = props.readOnly, otherProps = __rest(props, ["name", "testId", "error", "onChange", "label", "textHelper", "options", "iconTooltip", "textTooltip", "className", "id", "value", "emptyOption", "optional", "disabled", "readOnly"]);
    var handleChange = function (event) {
        if (onChange) {
            onChange(event);
        }
    };
    var renderOption = function (option) { return (React__default.createElement("option", { key: name + "-" + option.value, value: option.value, className: option.hidden ? 'hide' : '', disabled: option.disabled }, option.label)); };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(SelectField, { "data-testid": testId, className: className, readOnly: readOnly === null || readOnly === void 0 ? void 0 : readOnly.active },
            label && (React__default.createElement(StyledLabelContainer, null,
                React__default.createElement(StyledLabel, { htmlFor: id, error: error, optional: optional },
                    label,
                    iconTooltip && textTooltip && (React__default.createElement(AgilizeTooltip, { title: textTooltip },
                        React__default.createElement(StyledIconInputContainer, null, iconTooltip)))))),
            React__default.createElement(SelectContainer, null,
                React__default.createElement(Select$1, __assign$2({ name: name, id: id, value: value, error: error, onChange: handleChange, disabled: disabled, ref: ref }, otherProps),
                    emptyOption && React__default.createElement("option", { "aria-label": "None", value: "" }),
                    options.map(function (option) {
                        if (option.optGroup && option.optGroup.length > 0) {
                            return (React__default.createElement("optgroup", { label: option.label, key: name + "-" + option.label }, option.optGroup.map(function (opt) { return renderOption(opt); })));
                        }
                        return renderOption(option);
                    })),
                !(readOnly === null || readOnly === void 0 ? void 0 : readOnly.active) && React__default.createElement(ArrowSelect, { src: IconArrowDown$1, width: 10, height: 10 })),
            (error || textHelper) && React__default.createElement(StyledHelperInput, { error: error }, error || textHelper)),
        (readOnly === null || readOnly === void 0 ? void 0 : readOnly.active) && React__default.createElement(ReadOnlyField, { label: label, value: readOnly === null || readOnly === void 0 ? void 0 : readOnly.value, textTooltip: textTooltip, iconTooltip: iconTooltip, testId: testId })));
};
var Select = forwardRef(SelectInput);

var MenuItemHeader = styled.div(templateObject_3$w || (templateObject_3$w = __makeTemplateObject(["\n  color: ", ";\n  display: flex;\n  align-items: center;\n  font-size: ", ";\n  padding: ", ";\n  text-decoration: none;\n  border-radius: ", "px;\n  border: 1px solid transparent;\n  cursor: pointer;\n  transition: background 100ms linear, border 100ms linear;\n  min-width: 212px;\n\n  &&:hover {\n    background-color: ", ";\n    border-color: ", ";\n  }\n\n  ", "\n\n  ", "\n"], ["\n  color: ", ";\n  display: flex;\n  align-items: center;\n  font-size: ", ";\n  padding: ",
    ";\n  text-decoration: none;\n  border-radius: ", "px;\n  border: 1px solid transparent;\n  cursor: pointer;\n  transition: background 100ms linear, border 100ms linear;\n  min-width: 212px;\n\n  &&:hover {\n    background-color: ", ";\n    border-color: ", ";\n  }\n\n  ",
    "\n\n  ",
    "\n"])), function (props) { return props.theme.colors.grey900; }, function (props) { return props.theme.fontSizes[2]; }, function (props) {
    return props.theme.global.gutterSpace * 0.875 + "px " + props.theme.space[2] + "px " + props.theme.global.gutterSpace * 0.875 + "px " + (props.hasPaddingLeft ? props.theme.global.gutterSpace * 0.875 : 0) + "px";
}, function (props) { return props.theme.forms.borderRadius; }, function (props) { return props.theme.colors.purple100; }, function (props) { return props.theme.colors.purple400; }, function (props) {
    return props.newLayout2024 && css(templateObject_1$B || (templateObject_1$B = __makeTemplateObject(["\n      display: flex;\n      align-items: center;\n      font-family: 'Inter', sans-serif;\n      font-weight: 500;\n      color: #3a363d;\n      padding-left: 16px;\n\n      &&:hover {\n        background-color: #f8f8f9;\n        border-color: transparent;\n      }\n    "], ["\n      display: flex;\n      align-items: center;\n      font-family: 'Inter', sans-serif;\n      font-weight: 500;\n      color: #3a363d;\n      padding-left: 16px;\n\n      &&:hover {\n        background-color: #f8f8f9;\n        border-color: transparent;\n      }\n    "])));
}, function (props) {
    return props.selected && css(templateObject_2$y || (templateObject_2$y = __makeTemplateObject(["\n      font-weight: 600;\n    "], ["\n      font-weight: 600;\n    "])));
});
var MenuLabel = styled.div(templateObject_5$p || (templateObject_5$p = __makeTemplateObject(["\n  max-width: 180px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n\n  ", "\n"], ["\n  max-width: 180px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n\n  ",
    "\n"])), function (props) {
    return props.newLayout2024 && css(templateObject_4$u || (templateObject_4$u = __makeTemplateObject(["\n      color: #3a363d;\n      font-weight: 500;\n    "], ["\n      color: #3a363d;\n      font-weight: 500;\n    "])));
});
var templateObject_1$B, templateObject_2$y, templateObject_3$w, templateObject_4$u, templateObject_5$p;

styled.div(templateObject_1$A || (templateObject_1$A = __makeTemplateObject(["\n  border-bottom: 1px solid ", ";\n  margin: ", "px 0;\n"], ["\n  border-bottom: 1px solid ", ";\n  margin: ", "px 0;\n"])), function (props) { return props.theme.colors.grey100; }, function (props) { return props.theme.global.gutterSpace / 4; });
var StyledPopper$2 = styled(Popper$1)(templateObject_2$x || (templateObject_2$x = __makeTemplateObject(["\n  z-index: ", ";\n"], ["\n  z-index: ", ";\n"])), function (props) { return props.theme.zIndex.modal + 1; });
var MenuDrop = styled.div(templateObject_4$t || (templateObject_4$t = __makeTemplateObject(["\n  border-radius: ", "px;\n  max-height: ", ";\n  width: ", ";\n  padding: ", "px;\n  z-index: ", ";\n  background-color: ", ";\n  box-shadow: 0px 2px 4px ", ";\n  overflow-y: auto;\n\n  ", "\n"], ["\n  border-radius: ", "px;\n  max-height: ", ";\n  width: ", ";\n  padding: ", "px;\n  z-index: ", ";\n  background-color: ", ";\n  box-shadow: 0px 2px 4px ", ";\n  overflow-y: auto;\n\n  ",
    "\n"])), function (props) { return props.theme.forms.borderRadius; }, function (props) { return (props.$itemHeight ? props.$itemHeight * 4 + "px" : 'auto'); }, function (props) { return (props.$itemWidth ? props.$itemWidth + "px" : 'auto'); }, function (props) { return props.theme.global.gutterSpace / 2; }, function (props) { return props.theme.zIndex.dropdownList; }, function (props) { return props.theme.colors.white; }, function (props) { return rgba(props.theme.colors.grey700, 0.3); }, function (props) {
    return props.newLayout2024 && css(templateObject_3$v || (templateObject_3$v = __makeTemplateObject(["\n      border: 0px;\n      padding: 0px;\n    "], ["\n      border: 0px;\n      padding: 0px;\n    "])));
});
var StyledMenuItem$1 = styled.div(templateObject_5$o || (templateObject_5$o = __makeTemplateObject(["\n  font-size: ", ";\n  color: ", ";\n  border-radius: ", "px;\n  font-family: ", ";\n  padding: ", "px ", "px;\n  cursor: pointer;\n  transition: background-color 200ms ease-in-out;\n\n  &&:hover {\n    background-color: ", ";\n  }\n"], ["\n  font-size: ", ";\n  color: ", ";\n  border-radius: ", "px;\n  font-family: ", ";\n  padding: ", "px ", "px;\n  cursor: pointer;\n  transition: background-color 200ms ease-in-out;\n\n  &&:hover {\n    background-color: ", ";\n  }\n"])), function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.colors.grey700; }, function (props) { return props.theme.forms.borderRadius / 2; }, function (props) { return props.theme.global.defaultFont; }, function (props) { return props.theme.global.gutterSpace / 4; }, function (props) { return props.theme.global.gutterSpace / 2; }, function (props) { return props.theme.colors.grey100; });
var templateObject_1$A, templateObject_2$x, templateObject_3$v, templateObject_4$t, templateObject_5$o;

var Menu = function (props) {
    var options = props.options, disabled = props.disabled, children = props.children, className = props.className, testId = props.testId, placement = props.placement, transformOrigin = props.transformOrigin, newLayout2024 = props.newLayout2024;
    var _a = useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var open = Boolean(anchorEl);
    var handleOpenDropdown = function (event) {
        setAnchorEl(anchorEl ? null : event.currentTarget);
    };
    var handleClose = function () {
        if (anchorEl) {
            setAnchorEl(null);
        }
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Box, { width: "fit-content", "aria-label": "more", "aria-controls": "long-menu", "aria-haspopup": "true", "aria-expanded": open ? 'true' : 'false', "data-testid": testId || 'simple-dropdown-iconButton', className: className, onClick: !disabled && handleOpenDropdown }, children),
        React__default.createElement(StyledPopper$2, { open: open, anchorEl: anchorEl, placement: placement || 'bottom', modifiers: {
                flip: {
                    enabled: true,
                },
                preventOverflow: {
                    enabled: true,
                    boundariesElement: 'scrollParent',
                },
            }, transition: true },
            React__default.createElement(ClickAwayListener$1, { onClickAway: handleClose },
                React__default.createElement(Grow, { in: open, style: { transformOrigin: transformOrigin || 'center 0' } },
                    React__default.createElement(MenuDrop, { "data-testid": "simple-dropdown", newLayout2024: newLayout2024 },
                        React__default.createElement("div", { onClick: handleClose, "aria-hidden": "true" }, options)))))));
};

var CustomButton = styled(Button$1)(templateObject_5$n || (templateObject_5$n = __makeTemplateObject(["\n  &,\n  &&:hover,\n  &&:active {\n    color: ", ";\n  }\n\n  ", "\n\n  ", " {\n    ", "\n  }\n\n  ", "\n\n  span {\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  ", "\n"], ["\n  &,\n  &&:hover,\n  &&:active {\n    color: ", ";\n  }\n\n  ",
    "\n\n  ", " {\n    ",
    "\n  }\n\n  ",
    "\n\n  span {\n    display: flex;\n    width: 100%;\n    justify-content: space-between;\n  }\n\n  ",
    "\n"])), function (props) { return props.theme.colors.grey900; }, function (props) {
    return props.$hasOnlyOption && css(templateObject_1$z || (templateObject_1$z = __makeTemplateObject(["\n      cursor: inherit;\n    "], ["\n      cursor: inherit;\n    "])));
}, device.mobile, function (props) {
    return !props.newLayout2024 && css(templateObject_2$w || (templateObject_2$w = __makeTemplateObject(["\n        width: 100%;\n        border: 1px solid ", ";\n        border-radius: ", "px;\n\n        span {\n          width: 100%;\n          display: flex;\n          justify-content: space-between;\n        }\n      "], ["\n        width: 100%;\n        border: 1px solid ", ";\n        border-radius: ", "px;\n\n        span {\n          width: 100%;\n          display: flex;\n          justify-content: space-between;\n        }\n      "])), props.theme.colors.grey200, props.theme.forms.borderRadius);
}, function (props) {
    return props.$hasHover && css(templateObject_3$u || (templateObject_3$u = __makeTemplateObject(["\n      transition: background-color ease-in-out 300ms;\n      &&:hover {\n        background-color: #f8f8f9;\n      }\n    "], ["\n      transition: background-color ease-in-out 300ms;\n      &&:hover {\n        background-color: #f8f8f9;\n      }\n    "])));
}, function (props) {
    return props.newLayout2024 && css(templateObject_4$s || (templateObject_4$s = __makeTemplateObject(["\n      padding: 0px;\n      padding-top: 8px;\n      padding-bottom: 8px;\n    "], ["\n      padding: 0px;\n      padding-top: 8px;\n      padding-bottom: 8px;\n    "])));
});
var Title$5 = styled.div(templateObject_7$m || (templateObject_7$m = __makeTemplateObject(["\n  padding-right: ", "px;\n  max-width: 160px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n\n  ", "\n\n  ", " {\n    max-width: 220px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n  }\n"], ["\n  padding-right: ", "px;\n  max-width: 160px;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n  overflow: hidden;\n\n  ",
    "\n\n  ", " {\n    max-width: 220px;\n    text-overflow: ellipsis;\n    white-space: nowrap;\n    overflow: hidden;\n  }\n"])), function (props) { return props.theme.global.gutterSpace * 1.75; }, function (props) {
    return props.newLayout2024 && css(templateObject_6$m || (templateObject_6$m = __makeTemplateObject(["\n      color: #3a363d;\n      font-weight: 500;\n    "], ["\n      color: #3a363d;\n      font-weight: 500;\n    "])));
}, device.mobile);
var Arrow = styled(SvgIcon)(templateObject_8$j || (templateObject_8$j = __makeTemplateObject([""], [""])));
var CustomMenu$1 = styled(Menu)(templateObject_10$b || (templateObject_10$b = __makeTemplateObject(["\n  ", " {\n    transition: all ease-in-out 0.2s;\n  }\n  &[aria-expanded='true'] {\n    ", " {\n      transform: scale(-1);\n    }\n    ", " {\n      background-color: ", ";\n    }\n    ", " {\n      width: 100%;\n    }\n    ", " {\n      background-color: red !important;\n    }\n  }\n  ", " {\n    ", "\n  }\n"], ["\n  ", " {\n    transition: all ease-in-out 0.2s;\n  }\n  &[aria-expanded='true'] {\n    ", " {\n      transform: scale(-1);\n    }\n    ", " {\n      background-color: ", ";\n    }\n    ", " {\n      width: 100%;\n    }\n    ", " {\n      background-color: red !important;\n    }\n  }\n  ", " {\n    ",
    "\n  }\n"])), Arrow, Arrow, CustomButton, function (props) { return props.theme.colors.grey200; }, device.mobile, MenuDrop, device.mobile, function (props) {
    return !props.newLayout2024 && css(templateObject_9$d || (templateObject_9$d = __makeTemplateObject(["\n        border: 1px solid ", ";\n        border-radius: ", "px;\n        width: 100%;\n        display: flex;\n        justify-content: space-between;\n      "], ["\n        border: 1px solid ", ";\n        border-radius: ", "px;\n        width: 100%;\n        display: flex;\n        justify-content: space-between;\n      "])), props.theme.colors.grey200, props.theme.forms.borderRadius);
});
var MenuItemIcon = styled.div(templateObject_11$7 || (templateObject_11$7 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  color: ", ";\n  margin-right: ", "px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 40px;\n  color: ", ";\n  margin-right: ", "px;\n"])), function (props) { return props.theme.colors.grey900; }, function (props) { return props.theme.global.gutterSpace / 2; });
var CompanyContainer = styled.div(templateObject_12$6 || (templateObject_12$6 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var TitleMenuApps = styled.p(templateObject_13$5 || (templateObject_13$5 = __makeTemplateObject(["\n  font-size: 12px;\n  font-weight: 400;\n  font-family: 'Inter', sans-serif;\n  color: #736e7a;\n  padding-top: 8px;\n  padding-left: 16px;\n  margin-top: 8px;\n"], ["\n  font-size: 12px;\n  font-weight: 400;\n  font-family: 'Inter', sans-serif;\n  color: #736e7a;\n  padding-top: 8px;\n  padding-left: 16px;\n  margin-top: 8px;\n"])));
var templateObject_1$z, templateObject_2$w, templateObject_3$u, templateObject_4$s, templateObject_5$n, templateObject_6$m, templateObject_7$m, templateObject_8$j, templateObject_9$d, templateObject_10$b, templateObject_11$7, templateObject_12$6, templateObject_13$5;

var IconArrowDown = "<svg width=\"11\" height=\"7\" viewBox=\"0 0 11 7\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M10.6852 0.319797C10.2907 -0.106599 9.69885 -0.106599 9.30432 0.319797L5.49053 4.44162L1.67675 0.319797C1.28222 -0.106599 0.690427 -0.106599 0.295897 0.319797C-0.0986324 0.746193 -0.0986324 1.38579 0.295897 1.81218L4.83298 6.71574C5.03025 6.92893 5.29327 7 5.55629 7C5.81931 7 6.08233 6.92893 6.27959 6.71574L10.8167 1.81218C11.0797 1.45685 11.0797 0.746193 10.6852 0.319797Z\" />\n</svg>";

var MenuApps = function (props) {
    var active = props.active, options = props.options, menuIcon = props.menuIcon, newLayout2024 = props.newLayout2024, endIcon = props.endIcon;
    var removeAppFromObject = function (obj, prop) {
        var _a = obj, _b = prop; _a[_b]; var rest = __rest(_a, [typeof _b === "symbol" ? _b : _b + ""]);
        return rest;
    };
    var Options = function () {
        if (newLayout2024) {
            return (React__default.createElement(React__default.Fragment, null,
                React__default.createElement(TitleMenuApps, null, "Aplica\u00E7\u00F5es"),
                Object.values(removeAppFromObject(options, active)).map(function (app) {
                    var title = app.title, href = app.href;
                    return (React__default.createElement(MenuItemHeader, { as: "a", href: href, key: title, newLayout2024: newLayout2024, style: { display: 'flex', justifyContent: 'space-between' } },
                        title,
                        endIcon && endIcon));
                })));
        }
        return (React__default.createElement(React__default.Fragment, null, Object.values(removeAppFromObject(options, active)).map(function (app) {
            var title = app.title, icon = app.icon, href = app.href;
            return (React__default.createElement(MenuItemHeader, { as: "a", href: href, key: title },
                React__default.createElement(MenuItemIcon, null, icon),
                title));
        })));
    };
    return (React__default.createElement(CustomMenu$1, { options: React__default.createElement(Options, null), placement: "bottom-start", newLayout2024: newLayout2024 },
        newLayout2024 && (React__default.createElement(CustomButton, { type: "button", variant: "text", "$hasHover": true, newLayout2024: newLayout2024 }, menuIcon && menuIcon)),
        !newLayout2024 && (React__default.createElement(CustomButton, { type: "button", variant: "text", "$hasHover": true },
            React__default.createElement(Box, { display: "flex", alignItems: "center" },
                options[active].icon,
                React__default.createElement(Title$5, null, options[active].title)),
            React__default.createElement(Arrow, { src: IconArrowDown, fill: "grey400", height: 7, width: 11 })))));
};

function useDebouncedCallback(callback, delay, options) {
    if (options === void 0) { options = {}; }
    var maxWait = options.maxWait, leading = options.leading;
    var maxWaitHandler = useRef(null);
    var maxWaitArgs = useRef([]);
    var trailing = options.trailing === undefined ? true : options.trailing;
    var leadingCall = useRef(false);
    var functionTimeoutHandler = useRef(null);
    var isComponentUnmounted = useRef(false);
    var debouncedFunction = useRef(callback);
    debouncedFunction.current = callback;
    var cancelDebouncedCallback = useCallback(function () {
        clearTimeout(functionTimeoutHandler.current);
        clearTimeout(maxWaitHandler.current);
        maxWaitHandler.current = null;
        maxWaitArgs.current = [];
        functionTimeoutHandler.current = null;
        leadingCall.current = false;
    }, []);
    useEffect(function () { return function () {
        // we use flag, as we allow to call callPending outside the hook
        isComponentUnmounted.current = true;
    }; }, []);
    var debouncedCallback = useCallback(function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        maxWaitArgs.current = args;
        clearTimeout(functionTimeoutHandler.current);
        if (leadingCall.current) {
            leadingCall.current = false;
        }
        if (!functionTimeoutHandler.current && leading && !leadingCall.current) {
            debouncedFunction.current.apply(debouncedFunction, args);
            leadingCall.current = true;
        }
        functionTimeoutHandler.current = setTimeout(function () {
            var shouldCallFunction = true;
            if (leading && leadingCall.current) {
                shouldCallFunction = false;
            }
            cancelDebouncedCallback();
            if (!isComponentUnmounted.current && trailing && shouldCallFunction) {
                debouncedFunction.current.apply(debouncedFunction, args);
            }
        }, delay);
        if (maxWait && !maxWaitHandler.current && trailing) {
            maxWaitHandler.current = setTimeout(function () {
                var current = maxWaitArgs.current;
                cancelDebouncedCallback();
                if (!isComponentUnmounted.current) {
                    debouncedFunction.current.apply(null, current);
                }
            }, maxWait);
        }
    }, [maxWait, delay, cancelDebouncedCallback, leading, trailing]);
    var callPending = useCallback(function () {
        if (!functionTimeoutHandler.current) {
            return;
        }
        debouncedFunction.current.apply(null, maxWaitArgs.current);
        cancelDebouncedCallback();
    }, [cancelDebouncedCallback]);
    return [debouncedCallback, cancelDebouncedCallback, callPending];
}

var useClickOutside = function (ref, callback) {
    useEffect(function () {
        var handleClickOutside = function (e) {
            if (ref.current && !ref.current.contains(e.target)) {
                callback();
            }
        };
        document.addEventListener('mousedown', handleClickOutside);
        return function () {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [ref]);
};

var NavigationContainer$1 = styled.div(templateObject_2$v || (templateObject_2$v = __makeTemplateObject(["\n  display: flex;\n  margin-top: ", "px;\n  padding: 0 ", "px;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid ", ";\n  border-radius: ", "px;\n  width: 100%;\n  min-width: ", "px;\n  height: ", "px;\n\n  ", "\n"], ["\n  display: flex;\n  margin-top: ", "px;\n  padding: 0 ", "px;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid ", ";\n  border-radius: ", "px;\n  width: 100%;\n  min-width: ", "px;\n  height: ", "px;\n\n  ",
    "\n"])), function (props) { return props.theme.global.gutterSpace / 4; }, function (props) { return props.theme.global.gutterSpace * 0.75; }, function (props) { return props.theme.colors.grey400; }, function (props) { return props.theme.forms.borderRadius; }, function (props) { return (props.useMonthWidth && props.hasNumberOfFiles && 240) || (props.useMonthWidth && !props.hasNumberOfFiles && 210) || 170; }, function (props) { return props.theme.forms.defaultHeight; }, function (props) {
    return props.disabled && css(templateObject_1$y || (templateObject_1$y = __makeTemplateObject(["\n      border-color: ", ";\n      background-color: ", ";\n    "], ["\n      border-color: ", ";\n      background-color: ", ";\n    "])), props.theme.colors.grey100, props.theme.colors.grey100);
});
var ButtonsContainer$1 = styled.div(templateObject_3$t || (templateObject_3$t = __makeTemplateObject(["\n  width: ", "px;\n  flex: 0 0 ", "px;\n  height: ", "px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  width: ", "px;\n  flex: 0 0 ", "px;\n  height: ", "px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])), function (props) { return props.width + 4; }, function (props) { return props.width + 4; }, function (props) { return props.height; });
var CalendarIconContainer = styled.div(templateObject_4$r || (templateObject_4$r = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: ", "px;\n  height: ", "px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: ", "px;\n  height: ", "px;\n"])), function (props) { return props.width; }, function (props) { return props.height; });
var ArrowButton$1 = styled(FabButton)(templateObject_5$m || (templateObject_5$m = __makeTemplateObject(["\n  && {\n    border-radius: 50%;\n    &&:disabled {\n      cursor: not-allowed;\n      background: transparent;\n      svg {\n        fill: ", ";\n      }\n    }\n  }\n"], ["\n  && {\n    border-radius: 50%;\n    &&:disabled {\n      cursor: not-allowed;\n      background: transparent;\n      svg {\n        fill: ", ";\n      }\n    }\n  }\n"])), function (props) { return props.theme.colors.grey400; });
var PrevButton = styled(ArrowButton$1)(templateObject_6$l || (templateObject_6$l = __makeTemplateObject(["\n  && {\n    margin-left: ", "px;\n    transform: rotateY(180deg);\n  }\n"], ["\n  && {\n    margin-left: ", "px;\n    transform: rotateY(180deg);\n  }\n"])), function (props) { return -props.theme.global.gutterSpace / 2; });
var NextButton = styled(ArrowButton$1)(templateObject_7$l || (templateObject_7$l = __makeTemplateObject(["\n  && {\n    transform: rotateY(0deg);\n    margin-right: ", "px;\n  }\n"], ["\n  && {\n    transform: rotateY(0deg);\n    margin-right: ", "px;\n  }\n"])), function (props) { return -props.theme.global.gutterSpace / 2; });
var textStyle = css(templateObject_8$i || (templateObject_8$i = __makeTemplateObject(["\n  font-family: ", ";\n  font-style: normal;\n  font-weight: 500;\n  font-size: ", ";\n"], ["\n  font-family: ", ";\n  font-style: normal;\n  font-weight: 500;\n  font-size: ", ";\n"])), function (props) { return props.theme.global.defaultFont; }, function (props) { return props.theme.fontSizes[2]; });
var quantityText = css(templateObject_9$c || (templateObject_9$c = __makeTemplateObject(["\n  font-weight: 300;\n  padding-left: ", "px;\n  color: ", ";\n"], ["\n  font-weight: 300;\n  padding-left: ", "px;\n  color: ", ";\n"])), function (props) { return props.theme.global.gutterSpace / 4; }, function (props) { return props.theme.colors.grey400; });
var DateText = styled.div(templateObject_10$a || (templateObject_10$a = __makeTemplateObject(["\n  ", ";\n  margin-top: 2px;\n  padding-left: ", "px;\n  line-height: ", "px;\n  color: ", ";\n  opacity: ", ";\n  min-width: 43px;\n  text-transform: capitalize;\n\n  span {\n    ", "\n  }\n"], ["\n  ", ";\n  margin-top: 2px;\n  padding-left: ", "px;\n  line-height: ", "px;\n  color: ", ";\n  opacity: ", ";\n  min-width: 43px;\n  text-transform: capitalize;\n\n  span {\n    ", "\n  }\n"])), textStyle, function (props) { return props.theme.global.gutterSpace / 2; }, function (props) { return props.theme.global.gutterSpace; }, function (props) { return props.theme.colors.grey900; }, function (props) { return (props.isLoading ? 0.75 : 1); }, quantityText);
var CalendarIcon = styled(SvgIcon)(templateObject_11$6 || (templateObject_11$6 = __makeTemplateObject(["\n  opacity: ", ";\n"], ["\n  opacity: ", ";\n"])), function (props) { return (props.isLoading ? 0.75 : 1); });
var Loading$1 = styled(BasicLoading)(templateObject_12$5 || (templateObject_12$5 = __makeTemplateObject(["\n  position: absolute;\n"], ["\n  position: absolute;\n"])));
var borderDropWidth = '1px';
var DropDatePicker = styled.ul(templateObject_13$4 || (templateObject_13$4 = __makeTemplateObject(["\n  display: none;\n  margin: 0;\n  padding: ", "px 0;\n  list-style: none;\n  position: absolute;\n  top: calc(100% - ", "px);\n  left: 0;\n  width: 100%;\n  background-color: ", ";\n  border: solid ", " ", ";\n  border-top: none;\n  border-bottom-left-radius: ", "px;\n  border-bottom-right-radius: ", "px;\n  z-index: 2;\n  ", "\n"], ["\n  display: none;\n  margin: 0;\n  padding: ", "px 0;\n  list-style: none;\n  position: absolute;\n  top: calc(100% - ", "px);\n  left: 0;\n  width: 100%;\n  background-color: ", ";\n  border: solid ", " ", ";\n  border-top: none;\n  border-bottom-left-radius: ", "px;\n  border-bottom-right-radius: ", "px;\n  z-index: 2;\n  ", "\n"])), function (props) { return props.theme.global.gutterSpace / 3; }, function (props) { return props.theme.forms.borderRadius; }, function (props) { return props.theme.colors.white; }, borderDropWidth, function (props) { return props.theme.colors.grey100; }, function (props) { return props.theme.forms.borderRadius; }, function (props) { return props.theme.forms.borderRadius; }, textStyle);
var YearButton$1 = styled.button(templateObject_14$3 || (templateObject_14$3 = __makeTemplateObject(["\n  padding: ", ";\n  text-align: left;\n  width: 100%;\n  border: none;\n  background: transparent;\n  outline: none;\n  ", "\n\n  &.active {\n    color: ", ";\n\n    span {\n      color: ", ";\n    }\n  }\n\n  &.disabled {\n    color: ", ";\n    cursor: not-allowed;\n  }\n\n  span {\n    ", "\n  }\n"], ["\n  padding: ",
    ";\n  text-align: left;\n  width: 100%;\n  border: none;\n  background: transparent;\n  outline: none;\n  ", "\n\n  &.active {\n    color: ", ";\n\n    span {\n      color: ", ";\n    }\n  }\n\n  &.disabled {\n    color: ", ";\n    cursor: not-allowed;\n  }\n\n  span {\n    ", "\n  }\n"])), function (props) {
    return props.withMonthPadding
        ? props.theme.global.gutterSpace / 4 + "px " + (props.theme.global.gutterSpace + 9) + "px"
        : props.theme.global.gutterSpace / 4 + "px " + props.theme.global.gutterSpace / 2 + "px\n       " + props.theme.global.gutterSpace / 4 + "px " + (props.theme.global.gutterSpace / 2 + 22) + "px";
}, textStyle, function (props) { return props.theme.colors.purple600; }, function (props) { return props.theme.colors.purple600; }, function (props) { return props.theme.colors.grey400; }, quantityText);
styled.li(templateObject_15$3 || (templateObject_15$3 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: ", "px ", "px;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: ", "px ", "px;\n"])), function (props) { return props.theme.global.gutterSpace / 4; }, function (props) { return props.theme.global.gutterSpace * 0.875; });
var CurrentDateContainer = styled.div(templateObject_16$3 || (templateObject_16$3 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var CurrentDate$1 = styled.div(templateObject_19$1 || (templateObject_19$1 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: ", ";\n  flex-direction: row;\n  min-width: ", "px;\n  min-height: ", "px;\n  border-radius: ", "px;\n  padding: 0px ", "px;\n  border: solid ", " transparent;\n  white-space: nowrap;\n  transition: background-color 150ms linear;\n\n  ", "\n"], ["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: ", ";\n  flex-direction: row;\n  min-width: ", "px;\n  min-height: ", "px;\n  border-radius: ", "px;\n  padding: 0px ", "px;\n  border: solid ", " transparent;\n  white-space: nowrap;\n  transition: background-color 150ms linear;\n\n  ",
    "\n"])), function (props) { return (props.hasFiles ? 'flex-start' : 'center'); }, function (props) { return (props.useMonthWidth && props.hasNumberOfFiles && 165) || (props.useMonthWidth && !props.hasNumberOfFiles && 145) || 100; }, function (props) { return props.theme.forms.defaultHeight - 4; }, function (props) { return props.theme.forms.borderRadius; }, function (props) { return props.theme.global.gutterSpace / 2; }, borderDropWidth, function (props) {
    return !props.isLoading &&
        !props.noPrependList && css(templateObject_18$1 || (templateObject_18$1 = __makeTemplateObject(["\n      cursor: pointer;\n\n      &:hover {\n        border-color: ", ";\n        background-color: ", ";\n        div {\n          color: ", ";\n        }\n      }\n\n      ", "\n    "], ["\n      cursor: pointer;\n\n      &:hover {\n        border-color: ", ";\n        background-color: ", ";\n        div {\n          color: ", ";\n        }\n      }\n\n      ",
        "\n    "])), props.theme.colors.grey100, props.theme.colors.grey100, props.theme.colors.grey700, props.dropIsActive
        ? css(templateObject_17$3 || (templateObject_17$3 = __makeTemplateObject(["\n            border-color: ", ";\n\n            & + ", " {\n              display: block;\n            }\n          "], ["\n            border-color: ", ";\n\n            & + ", " {\n              display: block;\n            }\n          "])), props.theme.colors.grey100, DropDatePicker) : '');
});
var templateObject_1$y, templateObject_2$v, templateObject_3$t, templateObject_4$r, templateObject_5$m, templateObject_6$l, templateObject_7$l, templateObject_8$i, templateObject_9$c, templateObject_10$a, templateObject_11$6, templateObject_12$5, templateObject_13$4, templateObject_14$3, templateObject_15$3, templateObject_16$3, templateObject_17$3, templateObject_18$1, templateObject_19$1;

var YearNavigation = function (props) {
    var onChange = props.onChange, startYear = props.startYear, maxYear = props.maxYear, minYear = props.minYear, debounceTime = props.debounceTime, calendarIconPath = props.calendarIconPath, label = props.label, arrowIconPath = props.arrowIconPath, className = props.className, testId = props.testId, years = props.years, _a = props.makeRequestOnChange, makeRequestOnChange = _a === void 0 ? true : _a;
    var _b = useState(startYear), currentYear = _b[0], setCurrentYear = _b[1];
    var _c = useState(startYear), prevYear = _c[0], setPrevYear = _c[1];
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    var _e = useState(false), showDropYear = _e[0], setShowDropYear = _e[1];
    var _f = useState([]), listOfYears = _f[0], setListOfYears = _f[1];
    var ArrowIconWidth = 16;
    var ArrowIconHeight = 16;
    var CalendarIconWidth = 20;
    var CalendarIconHeight = 20;
    var dropYearRef = useRef(null);
    useClickOutside(dropYearRef, function () {
        setShowDropYear(false);
    });
    var changeYearNavigation = function (yearToGo) {
        setLoading(true);
        setShowDropYear(false);
        var changedYear = yearToGo || currentYear;
        if (!makeRequestOnChange) {
            onChange(changedYear);
            setPrevYear(currentYear);
            setCurrentYear(changedYear);
            return setLoading(false);
        }
        onChange(changedYear)
            .then(function () {
            setPrevYear(currentYear);
        })
            .catch(function () {
            setCurrentYear(prevYear);
        })
            .finally(function () { return setLoading(false); });
    };
    var debounceChangeYear = useDebouncedCallback(function () {
        changeYearNavigation();
    }, debounceTime || 400)[0];
    var handleChangeYear = function (operation, yearToGo) { return function () {
        setCurrentYear(yearToGo || currentYear + operation);
        if (yearToGo) {
            return changeYearNavigation(yearToGo);
        }
        return debounceChangeYear();
    }; };
    var handleToggleDropYear = function () {
        if (!loading) {
            setShowDropYear(true);
        }
    };
    useEffect(function () {
        var arrayOfYears = years || [];
        if (!years && minYear && maxYear) {
            var newArrayOfYears = [];
            for (var year = minYear; year <= maxYear; year += 1) {
                newArrayOfYears.push({
                    year: year,
                    numberOfFiles: null,
                });
            }
            arrayOfYears = newArrayOfYears;
        }
        var sortYearsDsc = arrayOfYears.sort(function (a, b) { return b.year - a.year; });
        setListOfYears(sortYearsDsc);
    }, [years]);
    var CurrentYearObject = listOfYears.find(function (year) { return year.year === currentYear; });
    var numberOfFilesForCurrentYear = CurrentYearObject && CurrentYearObject.numberOfFiles ? React__default.createElement("span", null,
        "(",
        CurrentYearObject.numberOfFiles,
        ")") : '';
    var isCurrentMinYear = function () {
        if (listOfYears.length > 0) {
            return currentYear === listOfYears.slice(-1)[0].year;
        }
        return minYear === currentYear;
    };
    var isCurrentMaxYear = function () {
        if (listOfYears.length > 0) {
            return currentYear === listOfYears[0].year;
        }
        return maxYear === currentYear;
    };
    return (React__default.createElement("div", { className: className, "data-testid": testId },
        label && React__default.createElement(StyledLabel, null, label),
        React__default.createElement(NavigationContainer$1, { disabled: loading },
            React__default.createElement(ButtonsContainer$1, { width: ArrowIconWidth, height: ArrowIconHeight },
                React__default.createElement(PrevButton, { disabled: isCurrentMinYear() || loading, testId: "prevYearButton", iconPath: arrowIconPath, onClick: handleChangeYear(-1), fill: isCurrentMinYear() || loading ? Colors.grey400 : Colors.grey700, size: "small" })),
            React__default.createElement(CurrentDateContainer, null,
                loading && React__default.createElement(Loading$1, { className: "loading", thickness: 2, size: 15 }),
                React__default.createElement(CurrentDate$1, { hasFiles: !!numberOfFilesForCurrentYear, noPrependList: listOfYears.length <= 0, "data-testid": "current-year", onClick: handleToggleDropYear, dropIsActive: showDropYear, isLoading: loading },
                    React__default.createElement(CalendarIconContainer, { width: CalendarIconWidth, height: CalendarIconHeight },
                        React__default.createElement(CalendarIcon, { width: CalendarIconWidth, height: CalendarIconHeight, src: calendarIconPath, isLoading: loading, fill: "grey400" })),
                    React__default.createElement(DateText, { isLoading: loading },
                        currentYear,
                        numberOfFilesForCurrentYear)),
                React__default.createElement(DropDatePicker, { ref: dropYearRef, "data-testid": "dropdown-years" }, listOfYears.map(function (listYear) { return (React__default.createElement("li", { key: "drop-year-" + listYear.year },
                    React__default.createElement(YearButton$1, { type: "button", className: currentYear === listYear.year ? 'active' : '', onClick: handleChangeYear(null, listYear.year) },
                        listYear.year,
                        listYear.numberOfFiles !== undefined ? React__default.createElement("span", null,
                            "(",
                            listYear.numberOfFiles || 0,
                            ")") : ''))); }))),
            React__default.createElement(ButtonsContainer$1, { width: ArrowIconWidth, height: ArrowIconHeight },
                React__default.createElement(NextButton, { disabled: isCurrentMaxYear() || loading, testId: "nextYearButton", iconPath: arrowIconPath, onClick: handleChangeYear(1), fill: isCurrentMaxYear() || loading ? Colors.grey400 : Colors.grey700, size: "small" })))));
};

var allMonths = [
    {
        monthNumber: 1,
        month: 'Janeiro',
        shortcut: 'JAN',
    },
    {
        monthNumber: 2,
        month: 'Fevereiro',
        shortcut: 'FEV',
    },
    {
        monthNumber: 3,
        month: 'Março',
        shortcut: 'MAR',
    },
    {
        monthNumber: 4,
        month: 'Abril',
        shortcut: 'ABR',
    },
    {
        monthNumber: 5,
        month: 'Maio',
        shortcut: 'MAI',
    },
    {
        monthNumber: 6,
        month: 'Junho',
        shortcut: 'JUN',
    },
    {
        monthNumber: 7,
        month: 'Julho',
        shortcut: 'JUL',
    },
    {
        monthNumber: 8,
        month: 'Agosto',
        shortcut: 'AGO',
    },
    {
        monthNumber: 9,
        month: 'Setembro',
        shortcut: 'SET',
    },
    {
        monthNumber: 10,
        month: 'Outubro',
        shortcut: 'OUT',
    },
    {
        monthNumber: 11,
        month: 'Novembro',
        shortcut: 'NOV',
    },
    {
        monthNumber: 12,
        month: 'Dezembro',
        shortcut: 'DEZ',
    },
];

var NavigationContainer = styled.div(templateObject_2$u || (templateObject_2$u = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  padding: 0 ", "px;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid ", ";\n  border-radius: ", "px;\n  width: 100%;\n  min-width: 213px;\n  height: ", "px;\n\n  ", "\n"], ["\n  position: relative;\n  display: flex;\n  padding: 0 ", "px;\n  flex-direction: row;\n  align-items: center;\n  justify-content: space-between;\n  border: 1px solid ", ";\n  border-radius: ", "px;\n  width: 100%;\n  min-width: 213px;\n  height: ", "px;\n\n  ",
    "\n"])), function (props) { return props.theme.global.gutterSpace * 0.75; }, function (props) { return props.theme.colors.grey400; }, function (props) { return props.theme.forms.borderRadius; }, function (props) { return (props.styleHeight ? props.styleHeight : props.theme.forms.defaultHeight); }, function (props) {
    return props.disabled && css(templateObject_1$x || (templateObject_1$x = __makeTemplateObject(["\n      border-color: ", ";\n      background-color: ", ";\n    "], ["\n      border-color: ", ";\n      background-color: ", ";\n    "])), props.theme.colors.grey100, props.theme.colors.grey100);
});
var DropPicker = styled.div(templateObject_3$s || (templateObject_3$s = __makeTemplateObject(["\n  display: flex;\n  flex-flow: column;\n  margin: ", "px 0 0;\n  padding: ", "px 0 ", "px;\n  width: 100%;\n  background-color: ", ";\n  border-radius: ", "px;\n  box-shadow: 0 2px 5px ", ";\n\n  ul {\n    display: flex;\n    flex-flow: row wrap;\n    list-style: none;\n    margin: 0;\n    padding: ", "px ", "px 0;\n  }\n\n  li {\n    display: flex;\n    justify-content: center;\n    width: calc(100% / 4);\n    padding: ", "px 0;\n  }\n"], ["\n  display: flex;\n  flex-flow: column;\n  margin: ", "px 0 0;\n  padding: ", "px 0 ", "px;\n  width: 100%;\n  background-color: ", ";\n  border-radius: ", "px;\n  box-shadow: 0 2px 5px ", ";\n\n  ul {\n    display: flex;\n    flex-flow: row wrap;\n    list-style: none;\n    margin: 0;\n    padding: ", "px ", "px 0;\n  }\n\n  li {\n    display: flex;\n    justify-content: center;\n    width: calc(100% / 4);\n    padding: ", "px 0;\n  }\n"])), function (props) { return props.theme.global.gutterSpace / 2; }, function (props) { return props.theme.global.gutterSpace / 2; }, function (props) { return props.theme.global.gutterSpace; }, function (props) { return props.theme.colors.white; }, function (props) { return props.theme.forms.borderRadius; }, function (props) { return rgba(props.theme.colors.grey700, 0.25); }, function (props) { return props.theme.global.gutterSpace / 2; }, function (props) { return props.theme.global.gutterSpace * 0.75; }, function (props) { return props.theme.global.gutterSpace / 4; });
var YearNavContainer = styled.div(templateObject_4$q || (templateObject_4$q = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: ", "px ", "px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: flex-start;\n  padding: ", "px ", "px;\n"])), function (props) { return props.theme.global.gutterSpace / 4; }, function (props) { return props.theme.global.gutterSpace * 0.875; });
var YearButton = styled.button(templateObject_5$l || (templateObject_5$l = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 20px;\n  background-color: transparent;\n  border: none;\n  border-radius: ", "px;\n  outline: none;\n  color: ", ";\n  font-size: ", ";\n  font-weight: normal;\n\n  &.active {\n    color: ", ";\n    background-color: ", ";\n    font-weight: 500;\n  }\n\n  &.disabled {\n    color: ", ";\n    cursor: not-allowed;\n  }\n\n  &:hover:not(.disabled) {\n    color: ", ";\n    background-color: ", ";\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: 32px;\n  height: 20px;\n  background-color: transparent;\n  border: none;\n  border-radius: ", "px;\n  outline: none;\n  color: ", ";\n  font-size: ", ";\n  font-weight: normal;\n\n  &.active {\n    color: ", ";\n    background-color: ", ";\n    font-weight: 500;\n  }\n\n  &.disabled {\n    color: ", ";\n    cursor: not-allowed;\n  }\n\n  &:hover:not(.disabled) {\n    color: ", ";\n    background-color: ", ";\n  }\n"])), function (props) { return props.theme.forms.borderRadius / 2; }, function (props) { return props.theme.colors.grey700; }, function (props) { return props.theme.fontSizes[1]; }, function (props) { return props.theme.colors.purple600; }, function (props) { return props.theme.colors.purple100; }, function (props) { return props.theme.colors.grey400; }, function (props) { return props.theme.colors.purple600; }, function (props) { return props.theme.colors.purple100; });
var YearDropNav = styled.span(templateObject_6$k || (templateObject_6$k = __makeTemplateObject(["\n  padding: 0 ", "px;\n  color: ", ";\n  font-size: ", ";\n  font-weight: 500;\n"], ["\n  padding: 0 ", "px;\n  color: ", ";\n  font-size: ", ";\n  font-weight: 500;\n"])), function (props) { return props.theme.global.gutterSpace / 4; }, function (props) { return props.theme.colors.grey400; }, function (props) { return props.theme.fontSizes[2]; });
var CurrentDate = styled.div(templateObject_8$h || (templateObject_8$h = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: ", ";\n  flex-direction: row;\n  min-width: ", "px;\n  min-height: ", "px;\n  border-radius: ", "px;\n  padding: 0px ", "px;\n  border: none;\n  white-space: nowrap;\n\n  ", "\n"], ["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: ", ";\n  flex-direction: row;\n  min-width: ", "px;\n  min-height: ", "px;\n  border-radius: ", "px;\n  padding: 0px ", "px;\n  border: none;\n  white-space: nowrap;\n\n  ",
    "\n"])), function (props) { return (props.hasFiles ? 'flex-start' : 'center'); }, function (props) { return (props.useMonthWidth && props.hasNumberOfFiles && 155) || (props.useMonthWidth && !props.hasNumberOfFiles && 135) || 100; }, function (props) { return props.theme.forms.defaultHeight - 4; }, function (props) { return props.theme.forms.borderRadius; }, function (props) { return props.theme.global.gutterSpace / 2; }, function (props) {
    return !props.isLoading &&
        !props.noPrependList && css(templateObject_7$k || (templateObject_7$k = __makeTemplateObject(["\n      cursor: pointer;\n    "], ["\n      cursor: pointer;\n    "])));
});
var templateObject_1$x, templateObject_2$u, templateObject_3$s, templateObject_4$q, templateObject_5$l, templateObject_6$k, templateObject_7$k, templateObject_8$h;

var MonthNavigation = function (props) {
    var onChange = props.onChange, className = props.className, testId = props.testId, label = props.label, arrowIconPath = props.arrowIconPath, startMonth = props.startMonth, maxMonth = props.maxMonth, startYear = props.startYear, minYear = props.minYear, maxYear = props.maxYear, calendarIconPath = props.calendarIconPath, debounceTime = props.debounceTime, months = props.months, optional = props.optional, externalLoading = props.loading, styleHeight = props.styleHeight;
    var _a = useState(startMonth), month = _a[0], setMonth = _a[1];
    var _b = useState(startMonth), prevMonth = _b[0], setPrevMonth = _b[1];
    var _c = useState(startYear), year = _c[0], setYear = _c[1];
    var _d = useState(startYear), prevYear = _d[0], setPrevYear = _d[1];
    var _e = useState(false), internalLoading = _e[0], setInternalLoading = _e[1];
    var _f = useState(null), anchorEl = _f[0], setAnchorEl = _f[1];
    var isPopperOpen = Boolean(anchorEl);
    var loading = externalLoading || internalLoading;
    var useStyles = makeStyles(function () {
        return createStyles({
            popper: {
                zIndex: theme.zIndex.dropdownList,
                width: 'calc(100% + 2px)',
                left: '1px',
                marginTop: "2px",
            },
        });
    });
    var classes = useStyles();
    var ArrowIconSize = 16;
    var CalendarIconSize = 20;
    var findInAllMonths = function (monthNum) { return allMonths.find(function (monthFound) { return monthFound.monthNumber === monthNum; }).shortcut; };
    var getMonthName = function (monthNum) {
        if (monthNum) {
            return findInAllMonths(monthNum);
        }
        return findInAllMonths(month);
    };
    var listOfMonths = function () {
        var list;
        if (months) {
            var listWithFiles_1 = months.filter(function (monthFound) { return monthFound.year === year; });
            list = allMonths.map(function (monthObj) {
                var foundMonthWithFiles = listWithFiles_1.find(function (monthFound) { return monthFound.monthNumber === monthObj.monthNumber; });
                if (foundMonthWithFiles) {
                    return __assign$2(__assign$2({}, monthObj), { numberOfFiles: foundMonthWithFiles.numberOfFiles });
                }
                return __assign$2(__assign$2({}, monthObj), { numberOfFiles: 0 });
            });
        }
        return (list || allMonths).sort(function (a, b) { return a.monthNumber - b.monthNumber; });
    };
    var currentMonthObject = function () {
        var foundObject = listOfMonths().find(function (monthFound) { return monthFound.monthNumber === month; });
        if (foundObject) {
            return foundObject;
        }
        return months[months.length - 1];
    };
    var numberOfFilesForCurrentMonth = months && months.length > 0 ? React__default.createElement("span", null,
        "(",
        currentMonthObject().numberOfFiles,
        ")") : '';
    var isMaxYearMonth = function () {
        if (months && months.length > 0) {
            return month === listOfMonths().slice(-1)[0].monthNumber;
        }
        return year === maxYear && month === 12;
    };
    var isMinYearMonth = function () {
        if (months && months.length > 0) {
            return month === listOfMonths()[0].monthNumber;
        }
        return year === minYear && month === 1;
    };
    var isMaxYear = function (resultYear) { return (resultYear || year) === maxYear; };
    var isMinYear = function (resultYear) { return (resultYear || year) === minYear; };
    var isMaxMonth = function (monthNumber) {
        if (isMaxYear()) {
            if (monthNumber) {
                return monthNumber > maxMonth;
            }
            return month >= maxMonth;
        }
        return false;
    };
    var changeDateNavigation = function () {
        setInternalLoading(true);
        handleClose();
        onChange(year, month)
            .then(function () {
            setPrevMonth(month);
            setPrevYear(year);
        })
            .catch(function () {
            setMonth(prevMonth);
            setYear(prevYear);
        })
            .finally(function () { return setInternalLoading(false); });
    };
    var debounceChange = useDebouncedCallback(function () {
        changeDateNavigation();
    }, debounceTime || 400)[0];
    var handleChangeYear = function (operation) { return function () {
        setYear(year + operation);
    }; };
    var handleChangeMonth = function (operation, monthToGo) { return function () {
        var monthResult = monthToGo || month + operation;
        if (monthResult < 1) {
            setMonth(12);
            setYear(year - 1);
        }
        if (monthResult > 12) {
            setMonth(1);
            setYear(year + 1);
        }
        if (monthResult >= 1 && monthResult <= 12) {
            setMonth(monthResult);
            if (!isMinYear() || !isMaxYear()) {
                setYear(year);
            }
        }
        return debounceChange();
    }; };
    var monthClass = function (monthNumber) {
        var classStr = '';
        if (month === monthNumber) {
            classStr = 'active';
        }
        if (isMaxMonth(monthNumber)) {
            classStr = 'disabled';
        }
        return classStr;
    };
    var handleClick = function (event) {
        if (!loading) {
            event.preventDefault();
            if (anchorEl) {
                return setAnchorEl(null);
            }
            setAnchorEl(event.currentTarget);
        }
    };
    var handleClose = function () {
        if (anchorEl) {
            setAnchorEl(null);
        }
    };
    return (React__default.createElement("div", { className: className, "data-testid": testId },
        label && React__default.createElement(StyledLabel, { optional: optional }, label),
        React__default.createElement(NavigationContainer, { useMonthWidth: true, hasNumberOfFiles: numberOfFilesForCurrentMonth, styleHeight: styleHeight },
            React__default.createElement(ButtonsContainer$1, { width: ArrowIconSize, height: ArrowIconSize },
                React__default.createElement(PrevButton, { testId: "prevMonthButton", iconPath: arrowIconPath, onClick: handleChangeMonth(-1), fill: isMinYearMonth() || loading ? Colors.grey400 : Colors.grey700, disabled: loading || isMinYearMonth(), size: "small", disabledBackgroundColor: true })),
            React__default.createElement(CurrentDateContainer, null,
                loading && React__default.createElement(Loading$1, { className: "loading", thickness: 2, size: 15 }),
                React__default.createElement(CurrentDate, { noPrependList: listOfMonths().length <= 0, "data-testid": "current-month", onClick: handleClick, isLoading: loading, hasNumberOfFiles: numberOfFilesForCurrentMonth, useMonthWidth: true },
                    React__default.createElement(CalendarIconContainer, { width: CalendarIconSize, height: CalendarIconSize },
                        React__default.createElement(CalendarIcon, { width: CalendarIconSize, height: CalendarIconSize, src: calendarIconPath, isLoading: loading, fill: "grey400" })),
                    React__default.createElement(DateText, { isLoading: loading },
                        getMonthName(),
                        " / ",
                        year,
                        numberOfFilesForCurrentMonth))),
            React__default.createElement(ButtonsContainer$1, { width: ArrowIconSize, height: ArrowIconSize },
                React__default.createElement(NextButton, { testId: "nextMonthButton", iconPath: arrowIconPath, onClick: handleChangeMonth(1), fill: isMaxMonth() || isMaxYearMonth() || loading ? Colors.grey400 : Colors.grey700, disabled: loading || isMaxYearMonth() || isMaxMonth(), size: "small", disabledBackgroundColor: true })),
            React__default.createElement(Popper$1, { className: classes.popper, open: isPopperOpen, anchorEl: anchorEl, disablePortal: true },
                React__default.createElement(ClickAwayListener$1, { onClickAway: handleClose },
                    React__default.createElement(DropPicker, { "data-testid": "dropdown-months-and-year", hasNumberOfFiles: numberOfFilesForCurrentMonth, withMonthPadding: true },
                        React__default.createElement(YearNavContainer, { "data-testid": "dropdown-year-nav" },
                            React__default.createElement(PrevButton, { testId: "prevYearButton", iconPath: arrowIconPath, onClick: handleChangeYear(-1), fill: isMinYear() || loading ? Colors.grey400 : Colors.grey700, disabled: loading || isMinYear(), size: "small", disabledBackgroundColor: true }),
                            React__default.createElement(YearDropNav, null, year),
                            React__default.createElement(NextButton, { testId: "nextYearButton", iconPath: arrowIconPath, onClick: handleChangeYear(+1), fill: isMaxYear() || loading ? Colors.grey400 : Colors.grey700, disabled: loading || isMaxYear(), size: "small", disabledBackgroundColor: true })),
                        React__default.createElement("ul", null, listOfMonths().map(function (listMonth) { return (React__default.createElement("li", { key: "drop-month-" + listMonth.monthNumber, "data-testid": "month-line" },
                            React__default.createElement(YearButton, { type: "button", className: monthClass(listMonth.monthNumber), onClick: handleChangeMonth(null, listMonth.monthNumber), disabled: isMaxMonth(listMonth.monthNumber) },
                                getMonthName(listMonth.monthNumber),
                                listMonth.hasOwnProperty('numberOfFiles') && React__default.createElement("span", null,
                                    "(",
                                    listMonth.numberOfFiles,
                                    ")")))); }))))))));
};

var TRANSITION = 'cubic-bezier(0.4, 0, 0.2, 1)';
var TRANSITION_TIME = 300;
var AccordionContainer = styled.div(templateObject_1$w || (templateObject_1$w = __makeTemplateObject(["\n  width: 100%;\n"], ["\n  width: 100%;\n"])));
var TitleContainer$1 = styled.div(templateObject_2$t || (templateObject_2$t = __makeTemplateObject(["\n  display: flex;\n  flex: 1;\n"], ["\n  display: flex;\n  flex: 1;\n"])));
var Title$4 = styled.div(templateObject_4$p || (templateObject_4$p = __makeTemplateObject(["\n  cursor: pointer;\n  width: 100%;\n\n  .arrow-icon {\n    transition: transform ", "ms ", " 0ms;\n    transform: rotate(90deg);\n\n    ", "\n  }\n"], ["\n  cursor: pointer;\n  width: 100%;\n\n  .arrow-icon {\n    transition: transform ", "ms ", " 0ms;\n    transform: rotate(90deg);\n\n    ",
    "\n  }\n"])), TRANSITION_TIME, TRANSITION, function (props) {
    return props.open && css(templateObject_3$r || (templateObject_3$r = __makeTemplateObject(["\n        transform: rotate(0deg);\n      "], ["\n        transform: rotate(0deg);\n      "])));
});
var templateObject_1$w, templateObject_2$t, templateObject_3$r, templateObject_4$p;

var Accordion = function (props) {
    var _a = useState(false), open = _a[0], setOpen = _a[1];
    var title = props.title, children = props.children, testId = props.testId, className = props.className, onChangeOpenAccordion = props.onChangeOpenAccordion, openedAccordion = props.openedAccordion, accordionId = props.accordionId, otherProps = __rest(props, ["title", "children", "testId", "className", "onChangeOpenAccordion", "openedAccordion", "accordionId"]);
    var handleClickOpen = function (e) {
        e.stopPropagation();
        e.preventDefault();
        if (!onChangeOpenAccordion) {
            return setOpen(!open);
        }
        onChangeOpenAccordion();
    };
    return (React__default.createElement(AccordionContainer, { "data-testid": testId, className: className },
        React__default.createElement(TitleContainer$1, null,
            React__default.createElement(Title$4, { "data-testid": "title-container", onClick: handleClickOpen, open: onChangeOpenAccordion ? openedAccordion === accordionId : open, className: (onChangeOpenAccordion && openedAccordion === accordionId) || open ? 'open' : '' }, title)),
        React__default.createElement(Collapse, __assign$2({ in: onChangeOpenAccordion ? openedAccordion === accordionId : open, "data-testid": "accordion-container", className: "accordion-container" }, otherProps), children)));
};

var animaLoader = function (props) { return keyframes(templateObject_1$v || (templateObject_1$v = __makeTemplateObject(["\n  0%,\n  5%,\n  95%,\n  100% {\n    stroke-dasharray: 0 400;\n    fill: transparent;\n  }\n  25%,\n  75% {\n    stroke-dasharray: 450 450;\n    fill: transparent;\n  }\n  35%,\n  65% {\n    stroke-dasharray: 450 0;\n    fill: ", ";\n  }\n  0% {opacity: 0.2}\n  40%,\n  60% {opacity: 1}\n  100% {opacity: 0.2}\n"], ["\n  0%,\n  5%,\n  95%,\n  100% {\n    stroke-dasharray: 0 400;\n    fill: transparent;\n  }\n  25%,\n  75% {\n    stroke-dasharray: 450 450;\n    fill: transparent;\n  }\n  35%,\n  65% {\n    stroke-dasharray: 450 0;\n    fill: ", ";\n  }\n  0% {opacity: 0.2}\n  40%,\n  60% {opacity: 1}\n  100% {opacity: 0.2}\n"])), props.theme.colors.purple600); };
var Loader = styled.svg(templateObject_2$s || (templateObject_2$s = __makeTemplateObject(["\n  fill: transparent;\n  stroke: ", ";\n  stroke-width: 1;\n  stroke-dasharray: 0 400;\n  animation: ", " 4s linear infinite;\n"], ["\n  fill: transparent;\n  stroke: ", ";\n  stroke-width: 1;\n  stroke-dasharray: 0 400;\n  animation: ", " 4s linear infinite;\n"])), function (props) { return props.theme.colors.purple600; }, function (props) { return animaLoader(props); });
var templateObject_1$v, templateObject_2$s;

var Loading = function (props) {
    var size = props.size;
    var hasSize = size ? size + "px" : null;
    return (React__default.createElement(Loader, { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 100 100", width: hasSize, height: hasSize },
        React__default.createElement("g", { transform: "matrix(1.25,0,0,-1.25,-4.0155575,117.09926)" },
            React__default.createElement("g", { transform: "translate(-21,-152)" },
                React__default.createElement("path", { d: "m 64.126426,166.8029 c -0.0461,0 -0.091,0 -0.1371,0 -21.2207,0 -38.45,17.229 -38.45,38.45 0,21.221 17.2293,38.45 38.45,38.45 21.2212,0 38.450204,-17.229 38.450204,-38.45 v -32.523 c 0,-3.272 -2.656004,-5.927 -5.927004,-5.927 -2.92,0 -5.29,2.37 -5.29,5.289 v 33.161 0 c 0,15.014 -12.196,27.203 -27.218,27.203 -15.0218,0 -27.2179,-12.19 -27.2179,-27.203 0,-15.014 12.1961,-27.203 27.2179,-27.203 0.0411,0 0.1329,0 0.1461,0 2.5887,-0.013 4.6879,-2.12 4.6879,-4.712 v -1.824 c 0,-2.6 -2.1121,-4.711 -4.7121,-4.711 z m 21.5221,38.45 v 0 -32.497 c 0,-3.286 -2.668,-5.953 -5.954,-5.953 -2.932,0 -5.313,2.38 -5.313,5.313 v 33.137 c 0,5.722 -4.532,10.369 -10.2551,10.369 -5.723,0 -10.3687,-4.646 -10.3687,-10.369 0,-5.722 4.6457,-10.368 10.3687,-10.368 0.0153,0 0.0289,0 0.0442,0 2.58,-0.024 4.6679,-2.128 4.6679,-4.714 v -1.835 c 0,-2.601 -2.1121,-4.712 -4.7121,-4.712 0,0 -0.0808,0 -0.1219,0 -11.9449,0 -21.6441,9.684 -21.6441,21.611 0,11.927 9.6992,21.611 21.6441,21.611 11.939,0 21.634,-9.674 21.644,-21.593" })))));
};

var ErrorContainer = styled(Box)(templateObject_1$u || (templateObject_1$u = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n"])));
var Title$3 = styled.h1(templateObject_2$r || (templateObject_2$r = __makeTemplateObject(["\n  text-align: center;\n  color: ", ";\n  font-size: 6rem;\n  font-weight: 700;\n"], ["\n  text-align: center;\n  color: ", ";\n  font-size: 6rem;\n  font-weight: 700;\n"])), function (props) { return props.theme.colors.grey700; });
var SubTitle = styled.h2(templateObject_3$q || (templateObject_3$q = __makeTemplateObject(["\n  text-align: center;\n  font-size: 2.6rem;\n  font-weight: 100;\n  color: ", ";\n"], ["\n  text-align: center;\n  font-size: 2.6rem;\n  font-weight: 100;\n  color: ", ";\n"])), function (props) { return props.theme.colors.grey400; });
var Message = styled.h3(templateObject_4$o || (templateObject_4$o = __makeTemplateObject(["\n  font-size: ", ";\n  color: ", ";\n  font-weight: 300;\n"], ["\n  font-size: ", ";\n  color: ", ";\n  font-weight: 300;\n"])), function (props) { return props.theme.fontSizes[3]; }, function (props) { return props.theme.colors.grey400; });
var templateObject_1$u, templateObject_2$r, templateObject_3$q, templateObject_4$o;

var Error$1 = function (props) {
    var message = props.message, className = props.className, testId = props.testId, button = props.button, subTitle = props.subTitle, spacing = __rest(props, ["message", "className", "testId", "button", "subTitle"]);
    return (React__default.createElement(ErrorContainer, __assign$2({}, spacing, { "data-testid": testId, className: className }),
        React__default.createElement(Title$3, null, "Oops!"),
        React__default.createElement(SubTitle, null, subTitle),
        React__default.createElement(Message, null, message),
        button && button));
};

function _objectWithoutPropertiesLoose$4(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;
  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }
  return target;
}

/**
 * Applies mask on element.
 * @constructor
 * @param {HTMLInputElement|HTMLTextAreaElement|MaskElement} el - Element to apply mask
 * @param {Object} opts - Custom mask options
 * @return {InputMask}
 */
function IMask(el) {
  let opts = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
  // currently available only for input-like elements
  return new IMask.InputMask(el, opts);
}

/**
  Provides details of changing model value
  @param {Object} [details]
  @param {string} [details.inserted] - Inserted symbols
  @param {boolean} [details.skip] - Can skip chars
  @param {number} [details.removeCount] - Removed symbols count
  @param {number} [details.tailShift] - Additional offset if any changes occurred before tail
*/
class ChangeDetails {
  /** Inserted symbols */

  /** Can skip chars */

  /** Additional offset if any changes occurred before tail */

  /** Raw inserted is used by dynamic mask */

  constructor(details) {
    Object.assign(this, {
      inserted: '',
      rawInserted: '',
      skip: false,
      tailShift: 0
    }, details);
  }

  /**
    Aggregate changes
    @returns {ChangeDetails} `this`
  */
  aggregate(details) {
    this.rawInserted += details.rawInserted;
    this.skip = this.skip || details.skip;
    this.inserted += details.inserted;
    this.tailShift += details.tailShift;
    return this;
  }

  /** Total offset considering all changes */
  get offset() {
    return this.tailShift + this.inserted.length;
  }
}
IMask.ChangeDetails = ChangeDetails;

/** Checks if value is string */
function isString$1(str) {
  return typeof str === 'string' || str instanceof String;
}

/**
  Direction
  @prop {string} NONE
  @prop {string} LEFT
  @prop {string} FORCE_LEFT
  @prop {string} RIGHT
  @prop {string} FORCE_RIGHT
*/
const DIRECTION = {
  NONE: 'NONE',
  LEFT: 'LEFT',
  FORCE_LEFT: 'FORCE_LEFT',
  RIGHT: 'RIGHT',
  FORCE_RIGHT: 'FORCE_RIGHT'
};

/** */
function forceDirection(direction) {
  switch (direction) {
    case DIRECTION.LEFT:
      return DIRECTION.FORCE_LEFT;
    case DIRECTION.RIGHT:
      return DIRECTION.FORCE_RIGHT;
    default:
      return direction;
  }
}

/** Escapes regular expression control chars */
function escapeRegExp(str) {
  return str.replace(/([.*+?^=!:${}()|[\]\/\\])/g, '\\$1');
}
function normalizePrepare(prep) {
  return Array.isArray(prep) ? prep : [prep, new ChangeDetails()];
}

// cloned from https://github.com/epoberezkin/fast-deep-equal with small changes
function objectIncludes(b, a) {
  if (a === b) return true;
  var arrA = Array.isArray(a),
    arrB = Array.isArray(b),
    i;
  if (arrA && arrB) {
    if (a.length != b.length) return false;
    for (i = 0; i < a.length; i++) if (!objectIncludes(a[i], b[i])) return false;
    return true;
  }
  if (arrA != arrB) return false;
  if (a && b && typeof a === 'object' && typeof b === 'object') {
    var dateA = a instanceof Date,
      dateB = b instanceof Date;
    if (dateA && dateB) return a.getTime() == b.getTime();
    if (dateA != dateB) return false;
    var regexpA = a instanceof RegExp,
      regexpB = b instanceof RegExp;
    if (regexpA && regexpB) return a.toString() == b.toString();
    if (regexpA != regexpB) return false;
    var keys = Object.keys(a);
    // if (keys.length !== Object.keys(b).length) return false;

    for (i = 0; i < keys.length; i++)
    // $FlowFixMe ... ???
    if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    for (i = 0; i < keys.length; i++) if (!objectIncludes(b[keys[i]], a[keys[i]])) return false;
    return true;
  } else if (a && b && typeof a === 'function' && typeof b === 'function') {
    return a.toString() === b.toString();
  }
  return false;
}

/** Provides details of changing input */
class ActionDetails {
  /** Current input value */

  /** Current cursor position */

  /** Old input value */

  /** Old selection */

  constructor(value, cursorPos, oldValue, oldSelection) {
    this.value = value;
    this.cursorPos = cursorPos;
    this.oldValue = oldValue;
    this.oldSelection = oldSelection;

    // double check if left part was changed (autofilling, other non-standard input triggers)
    while (this.value.slice(0, this.startChangePos) !== this.oldValue.slice(0, this.startChangePos)) {
      --this.oldSelection.start;
    }
  }

  /**
    Start changing position
    @readonly
  */
  get startChangePos() {
    return Math.min(this.cursorPos, this.oldSelection.start);
  }

  /**
    Inserted symbols count
    @readonly
  */
  get insertedCount() {
    return this.cursorPos - this.startChangePos;
  }

  /**
    Inserted symbols
    @readonly
  */
  get inserted() {
    return this.value.substr(this.startChangePos, this.insertedCount);
  }

  /**
    Removed symbols count
    @readonly
  */
  get removedCount() {
    // Math.max for opposite operation
    return Math.max(this.oldSelection.end - this.startChangePos ||
    // for Delete
    this.oldValue.length - this.value.length, 0);
  }

  /**
    Removed symbols
    @readonly
  */
  get removed() {
    return this.oldValue.substr(this.startChangePos, this.removedCount);
  }

  /**
    Unchanged head symbols
    @readonly
  */
  get head() {
    return this.value.substring(0, this.startChangePos);
  }

  /**
    Unchanged tail symbols
    @readonly
  */
  get tail() {
    return this.value.substring(this.startChangePos + this.insertedCount);
  }

  /**
    Remove direction
    @readonly
  */
  get removeDirection() {
    if (!this.removedCount || this.insertedCount) return DIRECTION.NONE;

    // align right if delete at right
    return (this.oldSelection.end === this.cursorPos || this.oldSelection.start === this.cursorPos) &&
    // if not range removed (event with backspace)
    this.oldSelection.end === this.oldSelection.start ? DIRECTION.RIGHT : DIRECTION.LEFT;
  }
}

/** Provides details of continuous extracted tail */
class ContinuousTailDetails {
  /** Tail value as string */

  /** Tail start position */

  /** Start position */

  constructor() {
    let value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    let from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    let stop = arguments.length > 2 ? arguments[2] : undefined;
    this.value = value;
    this.from = from;
    this.stop = stop;
  }
  toString() {
    return this.value;
  }
  extend(tail) {
    this.value += String(tail);
  }
  appendTo(masked) {
    return masked.append(this.toString(), {
      tail: true
    }).aggregate(masked._appendPlaceholder());
  }
  get state() {
    return {
      value: this.value,
      from: this.from,
      stop: this.stop
    };
  }
  set state(state) {
    Object.assign(this, state);
  }
  unshift(beforePos) {
    if (!this.value.length || beforePos != null && this.from >= beforePos) return '';
    const shiftChar = this.value[0];
    this.value = this.value.slice(1);
    return shiftChar;
  }
  shift() {
    if (!this.value.length) return '';
    const shiftChar = this.value[this.value.length - 1];
    this.value = this.value.slice(0, -1);
    return shiftChar;
  }
}

/** Supported mask type */

/** Append flags */

/** Extract flags */

/** Provides common masking stuff */
class Masked {
  // $Shape<MaskedOptions>; TODO after fix https://github.com/facebook/flow/issues/4773

  /** @type {Mask} */

  /** */ // $FlowFixMe no ideas
  /** Transforms value before mask processing */
  /** Validates if value is acceptable */
  /** Does additional processing in the end of editing */
  /** Format typed value to string */
  /** Parse strgin to get typed value */
  /** Enable characters overwriting */
  /** */
  /** */
  /** */
  constructor(opts) {
    this._value = '';
    this._update(Object.assign({}, Masked.DEFAULTS, opts));
    this.isInitialized = true;
  }

  /** Sets and applies new options */
  updateOptions(opts) {
    if (!Object.keys(opts).length) return;
    // $FlowFixMe
    this.withValueRefresh(this._update.bind(this, opts));
  }

  /**
    Sets new options
    @protected
  */
  _update(opts) {
    Object.assign(this, opts);
  }

  /** Mask state */
  get state() {
    return {
      _value: this.value
    };
  }
  set state(state) {
    this._value = state._value;
  }

  /** Resets value */
  reset() {
    this._value = '';
  }

  /** */
  get value() {
    return this._value;
  }
  set value(value) {
    this.resolve(value);
  }

  /** Resolve new value */
  resolve(value) {
    let flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {
      input: true
    };
    this.reset();
    this.append(value, flags, '');
    this.doCommit();
    return this.value;
  }

  /** */
  get unmaskedValue() {
    return this.value;
  }
  set unmaskedValue(value) {
    this.reset();
    this.append(value, {}, '');
    this.doCommit();
  }

  /** */
  get typedValue() {
    return this.doParse(this.value);
  }
  set typedValue(value) {
    this.value = this.doFormat(value);
  }

  /** Value that includes raw user input */
  get rawInputValue() {
    return this.extractInput(0, this.value.length, {
      raw: true
    });
  }
  set rawInputValue(value) {
    this.reset();
    this.append(value, {
      raw: true
    }, '');
    this.doCommit();
  }
  get displayValue() {
    return this.value;
  }

  /** */
  get isComplete() {
    return true;
  }

  /** */
  get isFilled() {
    return this.isComplete;
  }

  /** Finds nearest input position in direction */
  nearestInputPos(cursorPos, direction) {
    return cursorPos;
  }
  totalInputPositions() {
    let fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    let toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
    return Math.min(this.value.length, toPos - fromPos);
  }

  /** Extracts value in range considering flags */
  extractInput() {
    let fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    let toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
    return this.value.slice(fromPos, toPos);
  }

  /** Extracts tail in range */
  extractTail() {
    let fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    let toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
    return new ContinuousTailDetails(this.extractInput(fromPos, toPos), fromPos);
  }

  /** Appends tail */
  // $FlowFixMe no ideas
  appendTail(tail) {
    if (isString$1(tail)) tail = new ContinuousTailDetails(String(tail));
    return tail.appendTo(this);
  }

  /** Appends char */
  _appendCharRaw(ch) {
    if (!ch) return new ChangeDetails();
    this._value += ch;
    return new ChangeDetails({
      inserted: ch,
      rawInserted: ch
    });
  }

  /** Appends char */
  _appendChar(ch) {
    let flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let checkTail = arguments.length > 2 ? arguments[2] : undefined;
    const consistentState = this.state;
    let details;
    [ch, details] = normalizePrepare(this.doPrepare(ch, flags));
    details = details.aggregate(this._appendCharRaw(ch, flags));
    if (details.inserted) {
      let consistentTail;
      let appended = this.doValidate(flags) !== false;
      if (appended && checkTail != null) {
        // validation ok, check tail
        const beforeTailState = this.state;
        if (this.overwrite === true) {
          consistentTail = checkTail.state;
          checkTail.unshift(this.value.length - details.tailShift);
        }
        let tailDetails = this.appendTail(checkTail);
        appended = tailDetails.rawInserted === checkTail.toString();

        // not ok, try shift
        if (!(appended && tailDetails.inserted) && this.overwrite === 'shift') {
          this.state = beforeTailState;
          consistentTail = checkTail.state;
          checkTail.shift();
          tailDetails = this.appendTail(checkTail);
          appended = tailDetails.rawInserted === checkTail.toString();
        }

        // if ok, rollback state after tail
        if (appended && tailDetails.inserted) this.state = beforeTailState;
      }

      // revert all if something went wrong
      if (!appended) {
        details = new ChangeDetails();
        this.state = consistentState;
        if (checkTail && consistentTail) checkTail.state = consistentTail;
      }
    }
    return details;
  }

  /** Appends optional placeholder at end */
  _appendPlaceholder() {
    return new ChangeDetails();
  }

  /** Appends optional eager placeholder at end */
  _appendEager() {
    return new ChangeDetails();
  }

  /** Appends symbols considering flags */
  // $FlowFixMe no ideas
  append(str, flags, tail) {
    if (!isString$1(str)) throw new Error('value should be string');
    const details = new ChangeDetails();
    const checkTail = isString$1(tail) ? new ContinuousTailDetails(String(tail)) : tail;
    if (flags !== null && flags !== void 0 && flags.tail) flags._beforeTailState = this.state;
    for (let ci = 0; ci < str.length; ++ci) {
      const d = this._appendChar(str[ci], flags, checkTail);
      if (!d.rawInserted && !this.doSkipInvalid(str[ci], flags, checkTail)) break;
      details.aggregate(d);
    }
    if ((this.eager === true || this.eager === 'append') && flags !== null && flags !== void 0 && flags.input && str) {
      details.aggregate(this._appendEager());
    }

    // append tail but aggregate only tailShift
    if (checkTail != null) {
      details.tailShift += this.appendTail(checkTail).tailShift;
      // TODO it's a good idea to clear state after appending ends
      // but it causes bugs when one append calls another (when dynamic dispatch set rawInputValue)
      // this._resetBeforeTailState();
    }

    return details;
  }

  /** */
  remove() {
    let fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    let toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
    this._value = this.value.slice(0, fromPos) + this.value.slice(toPos);
    return new ChangeDetails();
  }

  /** Calls function and reapplies current value */
  withValueRefresh(fn) {
    if (this._refreshing || !this.isInitialized) return fn();
    this._refreshing = true;
    const rawInput = this.rawInputValue;
    const value = this.value;
    const ret = fn();
    this.rawInputValue = rawInput;
    // append lost trailing chars at end
    if (this.value && this.value !== value && value.indexOf(this.value) === 0) {
      this.append(value.slice(this.value.length), {}, '');
    }
    delete this._refreshing;
    return ret;
  }

  /** */
  runIsolated(fn) {
    if (this._isolated || !this.isInitialized) return fn(this);
    this._isolated = true;
    const state = this.state;
    const ret = fn(this);
    this.state = state;
    delete this._isolated;
    return ret;
  }

  /** */
  doSkipInvalid(ch) {
    return this.skipInvalid;
  }

  /**
    Prepares string before mask processing
    @protected
  */
  doPrepare(str) {
    let flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    return this.prepare ? this.prepare(str, this, flags) : str;
  }

  /**
    Validates if value is acceptable
    @protected
  */
  doValidate(flags) {
    return (!this.validate || this.validate(this.value, this, flags)) && (!this.parent || this.parent.doValidate(flags));
  }

  /**
    Does additional processing in the end of editing
    @protected
  */
  doCommit() {
    if (this.commit) this.commit(this.value, this);
  }

  /** */
  doFormat(value) {
    return this.format ? this.format(value, this) : value;
  }

  /** */
  doParse(str) {
    return this.parse ? this.parse(str, this) : str;
  }

  /** */
  splice(start, deleteCount, inserted, removeDirection) {
    let flags = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : {
      input: true
    };
    const tailPos = start + deleteCount;
    const tail = this.extractTail(tailPos);
    const eagerRemove = this.eager === true || this.eager === 'remove';
    let oldRawValue;
    if (eagerRemove) {
      removeDirection = forceDirection(removeDirection);
      oldRawValue = this.extractInput(0, tailPos, {
        raw: true
      });
    }
    let startChangePos = start;
    const details = new ChangeDetails();

    // if it is just deletion without insertion
    if (removeDirection !== DIRECTION.NONE) {
      startChangePos = this.nearestInputPos(start, deleteCount > 1 && start !== 0 && !eagerRemove ? DIRECTION.NONE : removeDirection);

      // adjust tailShift if start was aligned
      details.tailShift = startChangePos - start;
    }
    details.aggregate(this.remove(startChangePos));
    if (eagerRemove && removeDirection !== DIRECTION.NONE && oldRawValue === this.rawInputValue) {
      if (removeDirection === DIRECTION.FORCE_LEFT) {
        let valLength;
        while (oldRawValue === this.rawInputValue && (valLength = this.value.length)) {
          details.aggregate(new ChangeDetails({
            tailShift: -1
          })).aggregate(this.remove(valLength - 1));
        }
      } else if (removeDirection === DIRECTION.FORCE_RIGHT) {
        tail.unshift();
      }
    }
    return details.aggregate(this.append(inserted, flags, tail));
  }
  maskEquals(mask) {
    return this.mask === mask;
  }
  typedValueEquals(value) {
    const tval = this.typedValue;
    return value === tval || Masked.EMPTY_VALUES.includes(value) && Masked.EMPTY_VALUES.includes(tval) || this.doFormat(value) === this.doFormat(this.typedValue);
  }
}
Masked.DEFAULTS = {
  format: String,
  parse: v => v,
  skipInvalid: true
};
Masked.EMPTY_VALUES = [undefined, null, ''];
IMask.Masked = Masked;

/** Get Masked class by mask type */
function maskedClass(mask) {
  if (mask == null) {
    throw new Error('mask property should be defined');
  }

  // $FlowFixMe
  if (mask instanceof RegExp) return IMask.MaskedRegExp;
  // $FlowFixMe
  if (isString$1(mask)) return IMask.MaskedPattern;
  // $FlowFixMe
  if (mask instanceof Date || mask === Date) return IMask.MaskedDate;
  // $FlowFixMe
  if (mask instanceof Number || typeof mask === 'number' || mask === Number) return IMask.MaskedNumber;
  // $FlowFixMe
  if (Array.isArray(mask) || mask === Array) return IMask.MaskedDynamic;
  // $FlowFixMe
  if (IMask.Masked && mask.prototype instanceof IMask.Masked) return mask;
  // $FlowFixMe
  if (mask instanceof IMask.Masked) return mask.constructor;
  // $FlowFixMe
  if (mask instanceof Function) return IMask.MaskedFunction;
  console.warn('Mask not found for mask', mask); // eslint-disable-line no-console
  // $FlowFixMe
  return IMask.Masked;
}

/** Creates new {@link Masked} depending on mask type */
function createMask(opts) {
  // $FlowFixMe
  if (IMask.Masked && opts instanceof IMask.Masked) return opts;
  opts = Object.assign({}, opts);
  const mask = opts.mask;

  // $FlowFixMe
  if (IMask.Masked && mask instanceof IMask.Masked) return mask;
  const MaskedClass = maskedClass(mask);
  if (!MaskedClass) throw new Error('Masked class is not found for provided mask, appropriate module needs to be import manually before creating mask.');
  return new MaskedClass(opts);
}
IMask.createMask = createMask;

const _excluded$5 = ["parent", "isOptional", "placeholderChar", "displayChar", "lazy", "eager"];

/** */

const DEFAULT_INPUT_DEFINITIONS = {
  '0': /\d/,
  'a': /[\u0041-\u005A\u0061-\u007A\u00AA\u00B5\u00BA\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u0527\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u08A0\u08A2-\u08AC\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0977\u0979-\u097F\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C33\u0C35-\u0C39\u0C3D\u0C58\u0C59\u0C60\u0C61\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D60\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F4\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191C\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19C1-\u19C7\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312D\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FCC\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA697\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA78E\uA790-\uA793\uA7A0-\uA7AA\uA7F8-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA80-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uABC0-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]/,
  // http://stackoverflow.com/a/22075070
  '*': /./
};

/** */
class PatternInputDefinition {
  /** */

  /** */

  /** */

  /** */

  /** */

  /** */

  /** */

  /** */

  constructor(opts) {
    const {
        parent,
        isOptional,
        placeholderChar,
        displayChar,
        lazy,
        eager
      } = opts,
      maskOpts = _objectWithoutPropertiesLoose$4(opts, _excluded$5);
    this.masked = createMask(maskOpts);
    Object.assign(this, {
      parent,
      isOptional,
      placeholderChar,
      displayChar,
      lazy,
      eager
    });
  }
  reset() {
    this.isFilled = false;
    this.masked.reset();
  }
  remove() {
    let fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    let toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
    if (fromPos === 0 && toPos >= 1) {
      this.isFilled = false;
      return this.masked.remove(fromPos, toPos);
    }
    return new ChangeDetails();
  }
  get value() {
    return this.masked.value || (this.isFilled && !this.isOptional ? this.placeholderChar : '');
  }
  get unmaskedValue() {
    return this.masked.unmaskedValue;
  }
  get displayValue() {
    return this.masked.value && this.displayChar || this.value;
  }
  get isComplete() {
    return Boolean(this.masked.value) || this.isOptional;
  }
  _appendChar(ch) {
    let flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (this.isFilled) return new ChangeDetails();
    const state = this.masked.state;
    // simulate input
    const details = this.masked._appendChar(ch, flags);
    if (details.inserted && this.doValidate(flags) === false) {
      details.inserted = details.rawInserted = '';
      this.masked.state = state;
    }
    if (!details.inserted && !this.isOptional && !this.lazy && !flags.input) {
      details.inserted = this.placeholderChar;
    }
    details.skip = !details.inserted && !this.isOptional;
    this.isFilled = Boolean(details.inserted);
    return details;
  }
  append() {
    // TODO probably should be done via _appendChar
    return this.masked.append(...arguments);
  }
  _appendPlaceholder() {
    const details = new ChangeDetails();
    if (this.isFilled || this.isOptional) return details;
    this.isFilled = true;
    details.inserted = this.placeholderChar;
    return details;
  }
  _appendEager() {
    return new ChangeDetails();
  }
  extractTail() {
    return this.masked.extractTail(...arguments);
  }
  appendTail() {
    return this.masked.appendTail(...arguments);
  }
  extractInput() {
    let fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    let toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
    let flags = arguments.length > 2 ? arguments[2] : undefined;
    return this.masked.extractInput(fromPos, toPos, flags);
  }
  nearestInputPos(cursorPos) {
    let direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DIRECTION.NONE;
    const minPos = 0;
    const maxPos = this.value.length;
    const boundPos = Math.min(Math.max(cursorPos, minPos), maxPos);
    switch (direction) {
      case DIRECTION.LEFT:
      case DIRECTION.FORCE_LEFT:
        return this.isComplete ? boundPos : minPos;
      case DIRECTION.RIGHT:
      case DIRECTION.FORCE_RIGHT:
        return this.isComplete ? boundPos : maxPos;
      case DIRECTION.NONE:
      default:
        return boundPos;
    }
  }
  totalInputPositions() {
    let fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    let toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
    return this.value.slice(fromPos, toPos).length;
  }
  doValidate() {
    return this.masked.doValidate(...arguments) && (!this.parent || this.parent.doValidate(...arguments));
  }
  doCommit() {
    this.masked.doCommit();
  }
  get state() {
    return {
      masked: this.masked.state,
      isFilled: this.isFilled
    };
  }
  set state(state) {
    this.masked.state = state.masked;
    this.isFilled = state.isFilled;
  }
}

/** */

class PatternFixedDefinition {
  /** */

  /** */

  /** */

  /** */

  /** */

  /** */

  constructor(opts) {
    Object.assign(this, opts);
    this._value = '';
    this.isFixed = true;
  }
  get value() {
    return this._value;
  }
  get unmaskedValue() {
    return this.isUnmasking ? this.value : '';
  }
  get displayValue() {
    return this.value;
  }
  reset() {
    this._isRawInput = false;
    this._value = '';
  }
  remove() {
    let fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    let toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._value.length;
    this._value = this._value.slice(0, fromPos) + this._value.slice(toPos);
    if (!this._value) this._isRawInput = false;
    return new ChangeDetails();
  }
  nearestInputPos(cursorPos) {
    let direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DIRECTION.NONE;
    const minPos = 0;
    const maxPos = this._value.length;
    switch (direction) {
      case DIRECTION.LEFT:
      case DIRECTION.FORCE_LEFT:
        return minPos;
      case DIRECTION.NONE:
      case DIRECTION.RIGHT:
      case DIRECTION.FORCE_RIGHT:
      default:
        return maxPos;
    }
  }
  totalInputPositions() {
    let fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    let toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._value.length;
    return this._isRawInput ? toPos - fromPos : 0;
  }
  extractInput() {
    let fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    let toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this._value.length;
    let flags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    return flags.raw && this._isRawInput && this._value.slice(fromPos, toPos) || '';
  }
  get isComplete() {
    return true;
  }
  get isFilled() {
    return Boolean(this._value);
  }
  _appendChar(ch) {
    let flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const details = new ChangeDetails();
    if (this.isFilled) return details;
    const appendEager = this.eager === true || this.eager === 'append';
    const appended = this.char === ch;
    const isResolved = appended && (this.isUnmasking || flags.input || flags.raw) && (!flags.raw || !appendEager) && !flags.tail;
    if (isResolved) details.rawInserted = this.char;
    this._value = details.inserted = this.char;
    this._isRawInput = isResolved && (flags.raw || flags.input);
    return details;
  }
  _appendEager() {
    return this._appendChar(this.char, {
      tail: true
    });
  }
  _appendPlaceholder() {
    const details = new ChangeDetails();
    if (this.isFilled) return details;
    this._value = details.inserted = this.char;
    return details;
  }
  extractTail() {
    arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
    return new ContinuousTailDetails('');
  }

  // $FlowFixMe no ideas
  appendTail(tail) {
    if (isString$1(tail)) tail = new ContinuousTailDetails(String(tail));
    return tail.appendTo(this);
  }
  append(str, flags, tail) {
    const details = this._appendChar(str[0], flags);
    if (tail != null) {
      details.tailShift += this.appendTail(tail).tailShift;
    }
    return details;
  }
  doCommit() {}
  get state() {
    return {
      _value: this._value,
      _isRawInput: this._isRawInput
    };
  }
  set state(state) {
    Object.assign(this, state);
  }
}

const _excluded$4 = ["chunks"];
class ChunksTailDetails {
  /** */

  constructor() {
    let chunks = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : [];
    let from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    this.chunks = chunks;
    this.from = from;
  }
  toString() {
    return this.chunks.map(String).join('');
  }

  // $FlowFixMe no ideas
  extend(tailChunk) {
    if (!String(tailChunk)) return;
    if (isString$1(tailChunk)) tailChunk = new ContinuousTailDetails(String(tailChunk));
    const lastChunk = this.chunks[this.chunks.length - 1];
    const extendLast = lastChunk && (
    // if stops are same or tail has no stop
    lastChunk.stop === tailChunk.stop || tailChunk.stop == null) &&
    // if tail chunk goes just after last chunk
    tailChunk.from === lastChunk.from + lastChunk.toString().length;
    if (tailChunk instanceof ContinuousTailDetails) {
      // check the ability to extend previous chunk
      if (extendLast) {
        // extend previous chunk
        lastChunk.extend(tailChunk.toString());
      } else {
        // append new chunk
        this.chunks.push(tailChunk);
      }
    } else if (tailChunk instanceof ChunksTailDetails) {
      if (tailChunk.stop == null) {
        // unwrap floating chunks to parent, keeping `from` pos
        let firstTailChunk;
        while (tailChunk.chunks.length && tailChunk.chunks[0].stop == null) {
          firstTailChunk = tailChunk.chunks.shift();
          firstTailChunk.from += tailChunk.from;
          this.extend(firstTailChunk);
        }
      }

      // if tail chunk still has value
      if (tailChunk.toString()) {
        // if chunks contains stops, then popup stop to container
        tailChunk.stop = tailChunk.blockIndex;
        this.chunks.push(tailChunk);
      }
    }
  }
  appendTo(masked) {
    // $FlowFixMe
    if (!(masked instanceof IMask.MaskedPattern)) {
      const tail = new ContinuousTailDetails(this.toString());
      return tail.appendTo(masked);
    }
    const details = new ChangeDetails();
    for (let ci = 0; ci < this.chunks.length && !details.skip; ++ci) {
      const chunk = this.chunks[ci];
      const lastBlockIter = masked._mapPosToBlock(masked.value.length);
      const stop = chunk.stop;
      let chunkBlock;
      if (stop != null && (
      // if block not found or stop is behind lastBlock
      !lastBlockIter || lastBlockIter.index <= stop)) {
        if (chunk instanceof ChunksTailDetails ||
        // for continuous block also check if stop is exist
        masked._stops.indexOf(stop) >= 0) {
          const phDetails = masked._appendPlaceholder(stop);
          details.aggregate(phDetails);
        }
        chunkBlock = chunk instanceof ChunksTailDetails && masked._blocks[stop];
      }
      if (chunkBlock) {
        const tailDetails = chunkBlock.appendTail(chunk);
        tailDetails.skip = false; // always ignore skip, it will be set on last
        details.aggregate(tailDetails);
        masked._value += tailDetails.inserted;

        // get not inserted chars
        const remainChars = chunk.toString().slice(tailDetails.rawInserted.length);
        if (remainChars) details.aggregate(masked.append(remainChars, {
          tail: true
        }));
      } else {
        details.aggregate(masked.append(chunk.toString(), {
          tail: true
        }));
      }
    }
    return details;
  }
  get state() {
    return {
      chunks: this.chunks.map(c => c.state),
      from: this.from,
      stop: this.stop,
      blockIndex: this.blockIndex
    };
  }
  set state(state) {
    const {
        chunks
      } = state,
      props = _objectWithoutPropertiesLoose$4(state, _excluded$4);
    Object.assign(this, props);
    this.chunks = chunks.map(cstate => {
      const chunk = "chunks" in cstate ? new ChunksTailDetails() : new ContinuousTailDetails();
      // $FlowFixMe already checked above
      chunk.state = cstate;
      return chunk;
    });
  }
  unshift(beforePos) {
    if (!this.chunks.length || beforePos != null && this.from >= beforePos) return '';
    const chunkShiftPos = beforePos != null ? beforePos - this.from : beforePos;
    let ci = 0;
    while (ci < this.chunks.length) {
      const chunk = this.chunks[ci];
      const shiftChar = chunk.unshift(chunkShiftPos);
      if (chunk.toString()) {
        // chunk still contains value
        // but not shifted - means no more available chars to shift
        if (!shiftChar) break;
        ++ci;
      } else {
        // clean if chunk has no value
        this.chunks.splice(ci, 1);
      }
      if (shiftChar) return shiftChar;
    }
    return '';
  }
  shift() {
    if (!this.chunks.length) return '';
    let ci = this.chunks.length - 1;
    while (0 <= ci) {
      const chunk = this.chunks[ci];
      const shiftChar = chunk.shift();
      if (chunk.toString()) {
        // chunk still contains value
        // but not shifted - means no more available chars to shift
        if (!shiftChar) break;
        --ci;
      } else {
        // clean if chunk has no value
        this.chunks.splice(ci, 1);
      }
      if (shiftChar) return shiftChar;
    }
    return '';
  }
}

class PatternCursor {
  constructor(masked, pos) {
    this.masked = masked;
    this._log = [];
    const {
      offset,
      index
    } = masked._mapPosToBlock(pos) || (pos < 0 ?
    // first
    {
      index: 0,
      offset: 0
    } :
    // last
    {
      index: this.masked._blocks.length,
      offset: 0
    });
    this.offset = offset;
    this.index = index;
    this.ok = false;
  }
  get block() {
    return this.masked._blocks[this.index];
  }
  get pos() {
    return this.masked._blockStartPos(this.index) + this.offset;
  }
  get state() {
    return {
      index: this.index,
      offset: this.offset,
      ok: this.ok
    };
  }
  set state(s) {
    Object.assign(this, s);
  }
  pushState() {
    this._log.push(this.state);
  }
  popState() {
    const s = this._log.pop();
    this.state = s;
    return s;
  }
  bindBlock() {
    if (this.block) return;
    if (this.index < 0) {
      this.index = 0;
      this.offset = 0;
    }
    if (this.index >= this.masked._blocks.length) {
      this.index = this.masked._blocks.length - 1;
      this.offset = this.block.value.length;
    }
  }
  _pushLeft(fn) {
    this.pushState();
    for (this.bindBlock(); 0 <= this.index; --this.index, this.offset = ((_this$block = this.block) === null || _this$block === void 0 ? void 0 : _this$block.value.length) || 0) {
      var _this$block;
      if (fn()) return this.ok = true;
    }
    return this.ok = false;
  }
  _pushRight(fn) {
    this.pushState();
    for (this.bindBlock(); this.index < this.masked._blocks.length; ++this.index, this.offset = 0) {
      if (fn()) return this.ok = true;
    }
    return this.ok = false;
  }
  pushLeftBeforeFilled() {
    return this._pushLeft(() => {
      if (this.block.isFixed || !this.block.value) return;
      this.offset = this.block.nearestInputPos(this.offset, DIRECTION.FORCE_LEFT);
      if (this.offset !== 0) return true;
    });
  }
  pushLeftBeforeInput() {
    // cases:
    // filled input: 00|
    // optional empty input: 00[]|
    // nested block: XX<[]>|
    return this._pushLeft(() => {
      if (this.block.isFixed) return;
      this.offset = this.block.nearestInputPos(this.offset, DIRECTION.LEFT);
      return true;
    });
  }
  pushLeftBeforeRequired() {
    return this._pushLeft(() => {
      if (this.block.isFixed || this.block.isOptional && !this.block.value) return;
      this.offset = this.block.nearestInputPos(this.offset, DIRECTION.LEFT);
      return true;
    });
  }
  pushRightBeforeFilled() {
    return this._pushRight(() => {
      if (this.block.isFixed || !this.block.value) return;
      this.offset = this.block.nearestInputPos(this.offset, DIRECTION.FORCE_RIGHT);
      if (this.offset !== this.block.value.length) return true;
    });
  }
  pushRightBeforeInput() {
    return this._pushRight(() => {
      if (this.block.isFixed) return;

      // const o = this.offset;
      this.offset = this.block.nearestInputPos(this.offset, DIRECTION.NONE);
      // HACK cases like (STILL DOES NOT WORK FOR NESTED)
      // aa|X
      // aa<X|[]>X_    - this will not work
      // if (o && o === this.offset && this.block instanceof PatternInputDefinition) continue;
      return true;
    });
  }
  pushRightBeforeRequired() {
    return this._pushRight(() => {
      if (this.block.isFixed || this.block.isOptional && !this.block.value) return;

      // TODO check |[*]XX_
      this.offset = this.block.nearestInputPos(this.offset, DIRECTION.NONE);
      return true;
    });
  }
}

/** Masking by RegExp */
class MaskedRegExp extends Masked {
  /**
    @override
    @param {Object} opts
  */
  _update(opts) {
    if (opts.mask) opts.validate = value => value.search(opts.mask) >= 0;
    super._update(opts);
  }
}
IMask.MaskedRegExp = MaskedRegExp;

const _excluded$3 = ["_blocks"];

/**
  Pattern mask
  @param {Object} opts
  @param {Object} opts.blocks
  @param {Object} opts.definitions
  @param {string} opts.placeholderChar
  @param {string} opts.displayChar
  @param {boolean} opts.lazy
*/
class MaskedPattern extends Masked {
  /** */

  /** */

  /** Single char for empty input */

  /** Single char for filled input */

  /** Show placeholder only when needed */

  constructor() {
    let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO type $Shape<MaskedPatternOptions>={} does not work
    opts.definitions = Object.assign({}, DEFAULT_INPUT_DEFINITIONS, opts.definitions);
    super(Object.assign({}, MaskedPattern.DEFAULTS, opts));
  }

  /**
    @override
    @param {Object} opts
  */
  _update() {
    let opts = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    opts.definitions = Object.assign({}, this.definitions, opts.definitions);
    super._update(opts);
    this._rebuildMask();
  }

  /** */
  _rebuildMask() {
    const defs = this.definitions;
    this._blocks = [];
    this._stops = [];
    this._maskedBlocks = {};
    let pattern = this.mask;
    if (!pattern || !defs) return;
    let unmaskingBlock = false;
    let optionalBlock = false;
    for (let i = 0; i < pattern.length; ++i) {
      var _defs$char, _defs$char2;
      if (this.blocks) {
        const p = pattern.slice(i);
        const bNames = Object.keys(this.blocks).filter(bName => p.indexOf(bName) === 0);
        // order by key length
        bNames.sort((a, b) => b.length - a.length);
        // use block name with max length
        const bName = bNames[0];
        if (bName) {
          // $FlowFixMe no ideas
          const maskedBlock = createMask(Object.assign({
            parent: this,
            lazy: this.lazy,
            eager: this.eager,
            placeholderChar: this.placeholderChar,
            displayChar: this.displayChar,
            overwrite: this.overwrite
          }, this.blocks[bName]));
          if (maskedBlock) {
            this._blocks.push(maskedBlock);

            // store block index
            if (!this._maskedBlocks[bName]) this._maskedBlocks[bName] = [];
            this._maskedBlocks[bName].push(this._blocks.length - 1);
          }
          i += bName.length - 1;
          continue;
        }
      }
      let char = pattern[i];
      let isInput = (char in defs);
      if (char === MaskedPattern.STOP_CHAR) {
        this._stops.push(this._blocks.length);
        continue;
      }
      if (char === '{' || char === '}') {
        unmaskingBlock = !unmaskingBlock;
        continue;
      }
      if (char === '[' || char === ']') {
        optionalBlock = !optionalBlock;
        continue;
      }
      if (char === MaskedPattern.ESCAPE_CHAR) {
        ++i;
        char = pattern[i];
        if (!char) break;
        isInput = false;
      }
      const maskOpts = (_defs$char = defs[char]) !== null && _defs$char !== void 0 && _defs$char.mask && !(((_defs$char2 = defs[char]) === null || _defs$char2 === void 0 ? void 0 : _defs$char2.mask.prototype) instanceof IMask.Masked) ? defs[char] : {
        mask: defs[char]
      };
      const def = isInput ? new PatternInputDefinition(Object.assign({
        parent: this,
        isOptional: optionalBlock,
        lazy: this.lazy,
        eager: this.eager,
        placeholderChar: this.placeholderChar,
        displayChar: this.displayChar
      }, maskOpts)) : new PatternFixedDefinition({
        char,
        eager: this.eager,
        isUnmasking: unmaskingBlock
      });
      this._blocks.push(def);
    }
  }

  /**
    @override
  */
  get state() {
    return Object.assign({}, super.state, {
      _blocks: this._blocks.map(b => b.state)
    });
  }
  set state(state) {
    const {
        _blocks
      } = state,
      maskedState = _objectWithoutPropertiesLoose$4(state, _excluded$3);
    this._blocks.forEach((b, bi) => b.state = _blocks[bi]);
    super.state = maskedState;
  }

  /**
    @override
  */
  reset() {
    super.reset();
    this._blocks.forEach(b => b.reset());
  }

  /**
    @override
  */
  get isComplete() {
    return this._blocks.every(b => b.isComplete);
  }

  /**
    @override
  */
  get isFilled() {
    return this._blocks.every(b => b.isFilled);
  }
  get isFixed() {
    return this._blocks.every(b => b.isFixed);
  }
  get isOptional() {
    return this._blocks.every(b => b.isOptional);
  }

  /**
    @override
  */
  doCommit() {
    this._blocks.forEach(b => b.doCommit());
    super.doCommit();
  }

  /**
    @override
  */
  get unmaskedValue() {
    return this._blocks.reduce((str, b) => str += b.unmaskedValue, '');
  }
  set unmaskedValue(unmaskedValue) {
    super.unmaskedValue = unmaskedValue;
  }

  /**
    @override
  */
  get value() {
    // TODO return _value when not in change?
    return this._blocks.reduce((str, b) => str += b.value, '');
  }
  set value(value) {
    super.value = value;
  }
  get displayValue() {
    return this._blocks.reduce((str, b) => str += b.displayValue, '');
  }

  /**
    @override
  */
  appendTail(tail) {
    return super.appendTail(tail).aggregate(this._appendPlaceholder());
  }

  /**
    @override
  */
  _appendEager() {
    var _this$_mapPosToBlock;
    const details = new ChangeDetails();
    let startBlockIndex = (_this$_mapPosToBlock = this._mapPosToBlock(this.value.length)) === null || _this$_mapPosToBlock === void 0 ? void 0 : _this$_mapPosToBlock.index;
    if (startBlockIndex == null) return details;

    // TODO test if it works for nested pattern masks
    if (this._blocks[startBlockIndex].isFilled) ++startBlockIndex;
    for (let bi = startBlockIndex; bi < this._blocks.length; ++bi) {
      const d = this._blocks[bi]._appendEager();
      if (!d.inserted) break;
      details.aggregate(d);
    }
    return details;
  }

  /**
    @override
  */
  _appendCharRaw(ch) {
    let flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const blockIter = this._mapPosToBlock(this.value.length);
    const details = new ChangeDetails();
    if (!blockIter) return details;
    for (let bi = blockIter.index;; ++bi) {
      var _flags$_beforeTailSta, _flags$_beforeTailSta2;
      const block = this._blocks[bi];
      if (!block) break;
      const blockDetails = block._appendChar(ch, Object.assign({}, flags, {
        _beforeTailState: (_flags$_beforeTailSta = flags._beforeTailState) === null || _flags$_beforeTailSta === void 0 ? void 0 : (_flags$_beforeTailSta2 = _flags$_beforeTailSta._blocks) === null || _flags$_beforeTailSta2 === void 0 ? void 0 : _flags$_beforeTailSta2[bi]
      }));
      const skip = blockDetails.skip;
      details.aggregate(blockDetails);
      if (skip || blockDetails.rawInserted) break; // go next char
    }

    return details;
  }

  /**
    @override
  */
  extractTail() {
    let fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    let toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
    const chunkTail = new ChunksTailDetails();
    if (fromPos === toPos) return chunkTail;
    this._forEachBlocksInRange(fromPos, toPos, (b, bi, bFromPos, bToPos) => {
      const blockChunk = b.extractTail(bFromPos, bToPos);
      blockChunk.stop = this._findStopBefore(bi);
      blockChunk.from = this._blockStartPos(bi);
      if (blockChunk instanceof ChunksTailDetails) blockChunk.blockIndex = bi;
      chunkTail.extend(blockChunk);
    });
    return chunkTail;
  }

  /**
    @override
  */
  extractInput() {
    let fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    let toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
    let flags = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    if (fromPos === toPos) return '';
    let input = '';
    this._forEachBlocksInRange(fromPos, toPos, (b, _, fromPos, toPos) => {
      input += b.extractInput(fromPos, toPos, flags);
    });
    return input;
  }
  _findStopBefore(blockIndex) {
    let stopBefore;
    for (let si = 0; si < this._stops.length; ++si) {
      const stop = this._stops[si];
      if (stop <= blockIndex) stopBefore = stop;else break;
    }
    return stopBefore;
  }

  /** Appends placeholder depending on laziness */
  _appendPlaceholder(toBlockIndex) {
    const details = new ChangeDetails();
    if (this.lazy && toBlockIndex == null) return details;
    const startBlockIter = this._mapPosToBlock(this.value.length);
    if (!startBlockIter) return details;
    const startBlockIndex = startBlockIter.index;
    const endBlockIndex = toBlockIndex != null ? toBlockIndex : this._blocks.length;
    this._blocks.slice(startBlockIndex, endBlockIndex).forEach(b => {
      if (!b.lazy || toBlockIndex != null) {
        // $FlowFixMe `_blocks` may not be present
        const args = b._blocks != null ? [b._blocks.length] : [];
        const bDetails = b._appendPlaceholder(...args);
        this._value += bDetails.inserted;
        details.aggregate(bDetails);
      }
    });
    return details;
  }

  /** Finds block in pos */
  _mapPosToBlock(pos) {
    let accVal = '';
    for (let bi = 0; bi < this._blocks.length; ++bi) {
      const block = this._blocks[bi];
      const blockStartPos = accVal.length;
      accVal += block.value;
      if (pos <= accVal.length) {
        return {
          index: bi,
          offset: pos - blockStartPos
        };
      }
    }
  }

  /** */
  _blockStartPos(blockIndex) {
    return this._blocks.slice(0, blockIndex).reduce((pos, b) => pos += b.value.length, 0);
  }

  /** */
  _forEachBlocksInRange(fromPos) {
    let toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
    let fn = arguments.length > 2 ? arguments[2] : undefined;
    const fromBlockIter = this._mapPosToBlock(fromPos);
    if (fromBlockIter) {
      const toBlockIter = this._mapPosToBlock(toPos);
      // process first block
      const isSameBlock = toBlockIter && fromBlockIter.index === toBlockIter.index;
      const fromBlockStartPos = fromBlockIter.offset;
      const fromBlockEndPos = toBlockIter && isSameBlock ? toBlockIter.offset : this._blocks[fromBlockIter.index].value.length;
      fn(this._blocks[fromBlockIter.index], fromBlockIter.index, fromBlockStartPos, fromBlockEndPos);
      if (toBlockIter && !isSameBlock) {
        // process intermediate blocks
        for (let bi = fromBlockIter.index + 1; bi < toBlockIter.index; ++bi) {
          fn(this._blocks[bi], bi, 0, this._blocks[bi].value.length);
        }

        // process last block
        fn(this._blocks[toBlockIter.index], toBlockIter.index, 0, toBlockIter.offset);
      }
    }
  }

  /**
    @override
  */
  remove() {
    let fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    let toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
    const removeDetails = super.remove(fromPos, toPos);
    this._forEachBlocksInRange(fromPos, toPos, (b, _, bFromPos, bToPos) => {
      removeDetails.aggregate(b.remove(bFromPos, bToPos));
    });
    return removeDetails;
  }

  /**
    @override
  */
  nearestInputPos(cursorPos) {
    let direction = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : DIRECTION.NONE;
    if (!this._blocks.length) return 0;
    const cursor = new PatternCursor(this, cursorPos);
    if (direction === DIRECTION.NONE) {
      // -------------------------------------------------
      // NONE should only go out from fixed to the right!
      // -------------------------------------------------
      if (cursor.pushRightBeforeInput()) return cursor.pos;
      cursor.popState();
      if (cursor.pushLeftBeforeInput()) return cursor.pos;
      return this.value.length;
    }

    // FORCE is only about a|* otherwise is 0
    if (direction === DIRECTION.LEFT || direction === DIRECTION.FORCE_LEFT) {
      // try to break fast when *|a
      if (direction === DIRECTION.LEFT) {
        cursor.pushRightBeforeFilled();
        if (cursor.ok && cursor.pos === cursorPos) return cursorPos;
        cursor.popState();
      }

      // forward flow
      cursor.pushLeftBeforeInput();
      cursor.pushLeftBeforeRequired();
      cursor.pushLeftBeforeFilled();

      // backward flow
      if (direction === DIRECTION.LEFT) {
        cursor.pushRightBeforeInput();
        cursor.pushRightBeforeRequired();
        if (cursor.ok && cursor.pos <= cursorPos) return cursor.pos;
        cursor.popState();
        if (cursor.ok && cursor.pos <= cursorPos) return cursor.pos;
        cursor.popState();
      }
      if (cursor.ok) return cursor.pos;
      if (direction === DIRECTION.FORCE_LEFT) return 0;
      cursor.popState();
      if (cursor.ok) return cursor.pos;
      cursor.popState();
      if (cursor.ok) return cursor.pos;

      // cursor.popState();
      // if (
      //   cursor.pushRightBeforeInput() &&
      //   // TODO HACK for lazy if has aligned left inside fixed and has came to the start - use start position
      //   (!this.lazy || this.extractInput())
      // ) return cursor.pos;

      return 0;
    }
    if (direction === DIRECTION.RIGHT || direction === DIRECTION.FORCE_RIGHT) {
      // forward flow
      cursor.pushRightBeforeInput();
      cursor.pushRightBeforeRequired();
      if (cursor.pushRightBeforeFilled()) return cursor.pos;
      if (direction === DIRECTION.FORCE_RIGHT) return this.value.length;

      // backward flow
      cursor.popState();
      if (cursor.ok) return cursor.pos;
      cursor.popState();
      if (cursor.ok) return cursor.pos;
      return this.nearestInputPos(cursorPos, DIRECTION.LEFT);
    }
    return cursorPos;
  }

  /**
    @override
  */
  totalInputPositions() {
    let fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    let toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
    let total = 0;
    this._forEachBlocksInRange(fromPos, toPos, (b, _, bFromPos, bToPos) => {
      total += b.totalInputPositions(bFromPos, bToPos);
    });
    return total;
  }

  /** Get block by name */
  maskedBlock(name) {
    return this.maskedBlocks(name)[0];
  }

  /** Get all blocks by name */
  maskedBlocks(name) {
    const indices = this._maskedBlocks[name];
    if (!indices) return [];
    return indices.map(gi => this._blocks[gi]);
  }
}
MaskedPattern.DEFAULTS = {
  lazy: true,
  placeholderChar: '_'
};
MaskedPattern.STOP_CHAR = '`';
MaskedPattern.ESCAPE_CHAR = '\\';
MaskedPattern.InputDefinition = PatternInputDefinition;
MaskedPattern.FixedDefinition = PatternFixedDefinition;
IMask.MaskedPattern = MaskedPattern;

/** Pattern which accepts ranges */
class MaskedRange extends MaskedPattern {
  /**
    Optionally sets max length of pattern.
    Used when pattern length is longer then `to` param length. Pads zeros at start in this case.
  */

  /** Min bound */

  /** Max bound */

  /** */

  get _matchFrom() {
    return this.maxLength - String(this.from).length;
  }

  /**
    @override
  */
  _update(opts) {
    // TODO type
    opts = Object.assign({
      to: this.to || 0,
      from: this.from || 0,
      maxLength: this.maxLength || 0
    }, opts);
    let maxLength = String(opts.to).length;
    if (opts.maxLength != null) maxLength = Math.max(maxLength, opts.maxLength);
    opts.maxLength = maxLength;
    const fromStr = String(opts.from).padStart(maxLength, '0');
    const toStr = String(opts.to).padStart(maxLength, '0');
    let sameCharsCount = 0;
    while (sameCharsCount < toStr.length && toStr[sameCharsCount] === fromStr[sameCharsCount]) ++sameCharsCount;
    opts.mask = toStr.slice(0, sameCharsCount).replace(/0/g, '\\0') + '0'.repeat(maxLength - sameCharsCount);
    super._update(opts);
  }

  /**
    @override
  */
  get isComplete() {
    return super.isComplete && Boolean(this.value);
  }
  boundaries(str) {
    let minstr = '';
    let maxstr = '';
    const [, placeholder, num] = str.match(/^(\D*)(\d*)(\D*)/) || [];
    if (num) {
      minstr = '0'.repeat(placeholder.length) + num;
      maxstr = '9'.repeat(placeholder.length) + num;
    }
    minstr = minstr.padEnd(this.maxLength, '0');
    maxstr = maxstr.padEnd(this.maxLength, '9');
    return [minstr, maxstr];
  }

  // TODO str is a single char everytime
  /**
    @override
  */
  doPrepare(ch) {
    let flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let details;
    [ch, details] = normalizePrepare(super.doPrepare(ch.replace(/\D/g, ''), flags));
    if (!this.autofix || !ch) return ch;
    const fromStr = String(this.from).padStart(this.maxLength, '0');
    const toStr = String(this.to).padStart(this.maxLength, '0');
    let nextVal = this.value + ch;
    if (nextVal.length > this.maxLength) return '';
    const [minstr, maxstr] = this.boundaries(nextVal);
    if (Number(maxstr) < this.from) return fromStr[nextVal.length - 1];
    if (Number(minstr) > this.to) {
      if (this.autofix === 'pad' && nextVal.length < this.maxLength) {
        return ['', details.aggregate(this.append(fromStr[nextVal.length - 1] + ch, flags))];
      }
      return toStr[nextVal.length - 1];
    }
    return ch;
  }

  /**
    @override
  */
  doValidate() {
    const str = this.value;
    const firstNonZero = str.search(/[^0]/);
    if (firstNonZero === -1 && str.length <= this._matchFrom) return true;
    const [minstr, maxstr] = this.boundaries(str);
    return this.from <= Number(maxstr) && Number(minstr) <= this.to && super.doValidate(...arguments);
  }
}
IMask.MaskedRange = MaskedRange;

/** Date mask */
class MaskedDate extends MaskedPattern {
  /** Pattern mask for date according to {@link MaskedDate#format} */

  /** Start date */

  /** End date */

  /** */

  /**
    @param {Object} opts
  */
  constructor(opts) {
    super(Object.assign({}, MaskedDate.DEFAULTS, opts));
  }

  /**
    @override
  */
  _update(opts) {
    if (opts.mask === Date) delete opts.mask;
    if (opts.pattern) opts.mask = opts.pattern;
    const blocks = opts.blocks;
    opts.blocks = Object.assign({}, MaskedDate.GET_DEFAULT_BLOCKS());
    // adjust year block
    if (opts.min) opts.blocks.Y.from = opts.min.getFullYear();
    if (opts.max) opts.blocks.Y.to = opts.max.getFullYear();
    if (opts.min && opts.max && opts.blocks.Y.from === opts.blocks.Y.to) {
      opts.blocks.m.from = opts.min.getMonth() + 1;
      opts.blocks.m.to = opts.max.getMonth() + 1;
      if (opts.blocks.m.from === opts.blocks.m.to) {
        opts.blocks.d.from = opts.min.getDate();
        opts.blocks.d.to = opts.max.getDate();
      }
    }
    Object.assign(opts.blocks, this.blocks, blocks);

    // add autofix
    Object.keys(opts.blocks).forEach(bk => {
      const b = opts.blocks[bk];
      if (!('autofix' in b) && 'autofix' in opts) b.autofix = opts.autofix;
    });
    super._update(opts);
  }

  /**
    @override
  */
  doValidate() {
    const date = this.date;
    return super.doValidate(...arguments) && (!this.isComplete || this.isDateExist(this.value) && date != null && (this.min == null || this.min <= date) && (this.max == null || date <= this.max));
  }

  /** Checks if date is exists */
  isDateExist(str) {
    return this.format(this.parse(str, this), this).indexOf(str) >= 0;
  }

  /** Parsed Date */
  get date() {
    return this.typedValue;
  }
  set date(date) {
    this.typedValue = date;
  }

  /**
    @override
  */
  get typedValue() {
    return this.isComplete ? super.typedValue : null;
  }
  set typedValue(value) {
    super.typedValue = value;
  }

  /**
    @override
  */
  maskEquals(mask) {
    return mask === Date || super.maskEquals(mask);
  }
}
MaskedDate.DEFAULTS = {
  pattern: 'd{.}`m{.}`Y',
  format: date => {
    if (!date) return '';
    const day = String(date.getDate()).padStart(2, '0');
    const month = String(date.getMonth() + 1).padStart(2, '0');
    const year = date.getFullYear();
    return [day, month, year].join('.');
  },
  parse: str => {
    const [day, month, year] = str.split('.');
    return new Date(year, month - 1, day);
  }
};
MaskedDate.GET_DEFAULT_BLOCKS = () => ({
  d: {
    mask: MaskedRange,
    from: 1,
    to: 31,
    maxLength: 2
  },
  m: {
    mask: MaskedRange,
    from: 1,
    to: 12,
    maxLength: 2
  },
  Y: {
    mask: MaskedRange,
    from: 1900,
    to: 9999
  }
});
IMask.MaskedDate = MaskedDate;

/**
  Generic element API to use with mask
  @interface
*/
class MaskElement {
  /** */

  /** */

  /** */

  /** Safely returns selection start */
  get selectionStart() {
    let start;
    try {
      start = this._unsafeSelectionStart;
    } catch (e) {}
    return start != null ? start : this.value.length;
  }

  /** Safely returns selection end */
  get selectionEnd() {
    let end;
    try {
      end = this._unsafeSelectionEnd;
    } catch (e) {}
    return end != null ? end : this.value.length;
  }

  /** Safely sets element selection */
  select(start, end) {
    if (start == null || end == null || start === this.selectionStart && end === this.selectionEnd) return;
    try {
      this._unsafeSelect(start, end);
    } catch (e) {}
  }

  /** Should be overriden in subclasses */
  _unsafeSelect(start, end) {}
  /** Should be overriden in subclasses */
  get isActive() {
    return false;
  }
  /** Should be overriden in subclasses */
  bindEvents(handlers) {}
  /** Should be overriden in subclasses */
  unbindEvents() {}
}
IMask.MaskElement = MaskElement;

/** Bridge between HTMLElement and {@link Masked} */
class HTMLMaskElement extends MaskElement {
  /** Mapping between HTMLElement events and mask internal events */

  /** HTMLElement to use mask on */

  /**
    @param {HTMLInputElement|HTMLTextAreaElement} input
  */
  constructor(input) {
    super();
    this.input = input;
    this._handlers = {};
  }

  /** */
  // $FlowFixMe https://github.com/facebook/flow/issues/2839
  get rootElement() {
    var _this$input$getRootNo, _this$input$getRootNo2, _this$input;
    return (_this$input$getRootNo = (_this$input$getRootNo2 = (_this$input = this.input).getRootNode) === null || _this$input$getRootNo2 === void 0 ? void 0 : _this$input$getRootNo2.call(_this$input)) !== null && _this$input$getRootNo !== void 0 ? _this$input$getRootNo : document;
  }

  /**
    Is element in focus
    @readonly
  */
  get isActive() {
    //$FlowFixMe
    return this.input === this.rootElement.activeElement;
  }

  /**
    Returns HTMLElement selection start
    @override
  */
  get _unsafeSelectionStart() {
    return this.input.selectionStart;
  }

  /**
    Returns HTMLElement selection end
    @override
  */
  get _unsafeSelectionEnd() {
    return this.input.selectionEnd;
  }

  /**
    Sets HTMLElement selection
    @override
  */
  _unsafeSelect(start, end) {
    this.input.setSelectionRange(start, end);
  }

  /**
    HTMLElement value
    @override
  */
  get value() {
    return this.input.value;
  }
  set value(value) {
    this.input.value = value;
  }

  /**
    Binds HTMLElement events to mask internal events
    @override
  */
  bindEvents(handlers) {
    Object.keys(handlers).forEach(event => this._toggleEventHandler(HTMLMaskElement.EVENTS_MAP[event], handlers[event]));
  }

  /**
    Unbinds HTMLElement events to mask internal events
    @override
  */
  unbindEvents() {
    Object.keys(this._handlers).forEach(event => this._toggleEventHandler(event));
  }

  /** */
  _toggleEventHandler(event, handler) {
    if (this._handlers[event]) {
      this.input.removeEventListener(event, this._handlers[event]);
      delete this._handlers[event];
    }
    if (handler) {
      this.input.addEventListener(event, handler);
      this._handlers[event] = handler;
    }
  }
}
HTMLMaskElement.EVENTS_MAP = {
  selectionChange: 'keydown',
  input: 'input',
  drop: 'drop',
  click: 'click',
  focus: 'focus',
  commit: 'blur'
};
IMask.HTMLMaskElement = HTMLMaskElement;

class HTMLContenteditableMaskElement extends HTMLMaskElement {
  /**
    Returns HTMLElement selection start
    @override
  */
  get _unsafeSelectionStart() {
    const root = this.rootElement;
    const selection = root.getSelection && root.getSelection();
    const anchorOffset = selection && selection.anchorOffset;
    const focusOffset = selection && selection.focusOffset;
    if (focusOffset == null || anchorOffset == null || anchorOffset < focusOffset) {
      return anchorOffset;
    }
    return focusOffset;
  }

  /**
    Returns HTMLElement selection end
    @override
  */
  get _unsafeSelectionEnd() {
    const root = this.rootElement;
    const selection = root.getSelection && root.getSelection();
    const anchorOffset = selection && selection.anchorOffset;
    const focusOffset = selection && selection.focusOffset;
    if (focusOffset == null || anchorOffset == null || anchorOffset > focusOffset) {
      return anchorOffset;
    }
    return focusOffset;
  }

  /**
    Sets HTMLElement selection
    @override
  */
  _unsafeSelect(start, end) {
    if (!this.rootElement.createRange) return;
    const range = this.rootElement.createRange();
    range.setStart(this.input.firstChild || this.input, start);
    range.setEnd(this.input.lastChild || this.input, end);
    const root = this.rootElement;
    const selection = root.getSelection && root.getSelection();
    if (selection) {
      selection.removeAllRanges();
      selection.addRange(range);
    }
  }

  /**
    HTMLElement value
    @override
  */
  get value() {
    // $FlowFixMe
    return this.input.textContent;
  }
  set value(value) {
    this.input.textContent = value;
  }
}
IMask.HTMLContenteditableMaskElement = HTMLContenteditableMaskElement;

const _excluded$2 = ["mask"];

/** Listens to element events and controls changes between element and {@link Masked} */
class InputMask$2 {
  /**
    View element
    @readonly
  */

  /**
    Internal {@link Masked} model
    @readonly
  */

  /**
    @param {MaskElement|HTMLInputElement|HTMLTextAreaElement} el
    @param {Object} opts
  */
  constructor(el, opts) {
    this.el = el instanceof MaskElement ? el : el.isContentEditable && el.tagName !== 'INPUT' && el.tagName !== 'TEXTAREA' ? new HTMLContenteditableMaskElement(el) : new HTMLMaskElement(el);
    this.masked = createMask(opts);
    this._listeners = {};
    this._value = '';
    this._unmaskedValue = '';
    this._saveSelection = this._saveSelection.bind(this);
    this._onInput = this._onInput.bind(this);
    this._onChange = this._onChange.bind(this);
    this._onDrop = this._onDrop.bind(this);
    this._onFocus = this._onFocus.bind(this);
    this._onClick = this._onClick.bind(this);
    this.alignCursor = this.alignCursor.bind(this);
    this.alignCursorFriendly = this.alignCursorFriendly.bind(this);
    this._bindEvents();

    // refresh
    this.updateValue();
    this._onChange();
  }

  /** Read or update mask */
  get mask() {
    return this.masked.mask;
  }
  maskEquals(mask) {
    var _this$masked;
    return mask == null || ((_this$masked = this.masked) === null || _this$masked === void 0 ? void 0 : _this$masked.maskEquals(mask));
  }
  set mask(mask) {
    if (this.maskEquals(mask)) return;

    // $FlowFixMe No ideas ... after update
    if (!(mask instanceof IMask.Masked) && this.masked.constructor === maskedClass(mask)) {
      this.masked.updateOptions({
        mask
      });
      return;
    }
    const masked = createMask({
      mask
    });
    masked.unmaskedValue = this.masked.unmaskedValue;
    this.masked = masked;
  }

  /** Raw value */
  get value() {
    return this._value;
  }
  set value(str) {
    if (this.value === str) return;
    this.masked.value = str;
    this.updateControl();
    this.alignCursor();
  }

  /** Unmasked value */
  get unmaskedValue() {
    return this._unmaskedValue;
  }
  set unmaskedValue(str) {
    if (this.unmaskedValue === str) return;
    this.masked.unmaskedValue = str;
    this.updateControl();
    this.alignCursor();
  }

  /** Typed unmasked value */
  get typedValue() {
    return this.masked.typedValue;
  }
  set typedValue(val) {
    if (this.masked.typedValueEquals(val)) return;
    this.masked.typedValue = val;
    this.updateControl();
    this.alignCursor();
  }

  /** Display value */
  get displayValue() {
    return this.masked.displayValue;
  }

  /**
    Starts listening to element events
    @protected
  */
  _bindEvents() {
    this.el.bindEvents({
      selectionChange: this._saveSelection,
      input: this._onInput,
      drop: this._onDrop,
      click: this._onClick,
      focus: this._onFocus,
      commit: this._onChange
    });
  }

  /**
    Stops listening to element events
    @protected
   */
  _unbindEvents() {
    if (this.el) this.el.unbindEvents();
  }

  /**
    Fires custom event
    @protected
   */
  _fireEvent(ev) {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }
    const listeners = this._listeners[ev];
    if (!listeners) return;
    listeners.forEach(l => l(...args));
  }

  /**
    Current selection start
    @readonly
  */
  get selectionStart() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionStart;
  }

  /** Current cursor position */
  get cursorPos() {
    return this._cursorChanging ? this._changingCursorPos : this.el.selectionEnd;
  }
  set cursorPos(pos) {
    if (!this.el || !this.el.isActive) return;
    this.el.select(pos, pos);
    this._saveSelection();
  }

  /**
    Stores current selection
    @protected
  */
  _saveSelection( /* ev */
  ) {
    if (this.displayValue !== this.el.value) {
      console.warn('Element value was changed outside of mask. Syncronize mask using `mask.updateValue()` to work properly.'); // eslint-disable-line no-console
    }

    this._selection = {
      start: this.selectionStart,
      end: this.cursorPos
    };
  }

  /** Syncronizes model value from view */
  updateValue() {
    this.masked.value = this.el.value;
    this._value = this.masked.value;
  }

  /** Syncronizes view from model value, fires change events */
  updateControl() {
    const newUnmaskedValue = this.masked.unmaskedValue;
    const newValue = this.masked.value;
    const newDisplayValue = this.displayValue;
    const isChanged = this.unmaskedValue !== newUnmaskedValue || this.value !== newValue;
    this._unmaskedValue = newUnmaskedValue;
    this._value = newValue;
    if (this.el.value !== newDisplayValue) this.el.value = newDisplayValue;
    if (isChanged) this._fireChangeEvents();
  }

  /** Updates options with deep equal check, recreates @{link Masked} model if mask type changes */
  updateOptions(opts) {
    const {
        mask
      } = opts,
      restOpts = _objectWithoutPropertiesLoose$4(opts, _excluded$2);
    const updateMask = !this.maskEquals(mask);
    const updateOpts = !objectIncludes(this.masked, restOpts);
    if (updateMask) this.mask = mask;
    if (updateOpts) this.masked.updateOptions(restOpts);
    if (updateMask || updateOpts) this.updateControl();
  }

  /** Updates cursor */
  updateCursor(cursorPos) {
    if (cursorPos == null) return;
    this.cursorPos = cursorPos;

    // also queue change cursor for mobile browsers
    this._delayUpdateCursor(cursorPos);
  }

  /**
    Delays cursor update to support mobile browsers
    @private
  */
  _delayUpdateCursor(cursorPos) {
    this._abortUpdateCursor();
    this._changingCursorPos = cursorPos;
    this._cursorChanging = setTimeout(() => {
      if (!this.el) return; // if was destroyed
      this.cursorPos = this._changingCursorPos;
      this._abortUpdateCursor();
    }, 10);
  }

  /**
    Fires custom events
    @protected
  */
  _fireChangeEvents() {
    this._fireEvent('accept', this._inputEvent);
    if (this.masked.isComplete) this._fireEvent('complete', this._inputEvent);
  }

  /**
    Aborts delayed cursor update
    @private
  */
  _abortUpdateCursor() {
    if (this._cursorChanging) {
      clearTimeout(this._cursorChanging);
      delete this._cursorChanging;
    }
  }

  /** Aligns cursor to nearest available position */
  alignCursor() {
    this.cursorPos = this.masked.nearestInputPos(this.masked.nearestInputPos(this.cursorPos, DIRECTION.LEFT));
  }

  /** Aligns cursor only if selection is empty */
  alignCursorFriendly() {
    if (this.selectionStart !== this.cursorPos) return; // skip if range is selected
    this.alignCursor();
  }

  /** Adds listener on custom event */
  on(ev, handler) {
    if (!this._listeners[ev]) this._listeners[ev] = [];
    this._listeners[ev].push(handler);
    return this;
  }

  /** Removes custom event listener */
  off(ev, handler) {
    if (!this._listeners[ev]) return this;
    if (!handler) {
      delete this._listeners[ev];
      return this;
    }
    const hIndex = this._listeners[ev].indexOf(handler);
    if (hIndex >= 0) this._listeners[ev].splice(hIndex, 1);
    return this;
  }

  /** Handles view input event */
  _onInput(e) {
    this._inputEvent = e;
    this._abortUpdateCursor();

    // fix strange IE behavior
    if (!this._selection) return this.updateValue();
    const details = new ActionDetails(
    // new state
    this.el.value, this.cursorPos,
    // old state
    this.displayValue, this._selection);
    const oldRawValue = this.masked.rawInputValue;
    const offset = this.masked.splice(details.startChangePos, details.removed.length, details.inserted, details.removeDirection, {
      input: true,
      raw: true
    }).offset;

    // force align in remove direction only if no input chars were removed
    // otherwise we still need to align with NONE (to get out from fixed symbols for instance)
    const removeDirection = oldRawValue === this.masked.rawInputValue ? details.removeDirection : DIRECTION.NONE;
    let cursorPos = this.masked.nearestInputPos(details.startChangePos + offset, removeDirection);
    if (removeDirection !== DIRECTION.NONE) cursorPos = this.masked.nearestInputPos(cursorPos, DIRECTION.NONE);
    this.updateControl();
    this.updateCursor(cursorPos);
    delete this._inputEvent;
  }

  /** Handles view change event and commits model value */
  _onChange() {
    if (this.displayValue !== this.el.value) {
      this.updateValue();
    }
    this.masked.doCommit();
    this.updateControl();
    this._saveSelection();
  }

  /** Handles view drop event, prevents by default */
  _onDrop(ev) {
    ev.preventDefault();
    ev.stopPropagation();
  }

  /** Restore last selection on focus */
  _onFocus(ev) {
    this.alignCursorFriendly();
  }

  /** Restore last selection on focus */
  _onClick(ev) {
    this.alignCursorFriendly();
  }

  /** Unbind view events and removes element reference */
  destroy() {
    this._unbindEvents();
    // $FlowFixMe why not do so?
    this._listeners.length = 0;
    // $FlowFixMe
    delete this.el;
  }
}
IMask.InputMask = InputMask$2;

/** Pattern which validates enum values */
class MaskedEnum extends MaskedPattern {
  /**
    @override
    @param {Object} opts
  */
  _update(opts) {
    // TODO type
    if (opts.enum) opts.mask = '*'.repeat(opts.enum[0].length);
    super._update(opts);
  }

  /**
    @override
  */
  doValidate() {
    return this.enum.some(e => e.indexOf(this.unmaskedValue) >= 0) && super.doValidate(...arguments);
  }
}
IMask.MaskedEnum = MaskedEnum;

/**
  Number mask
  @param {Object} opts
  @param {string} opts.radix - Single char
  @param {string} opts.thousandsSeparator - Single char
  @param {Array<string>} opts.mapToRadix - Array of single chars
  @param {number} opts.min
  @param {number} opts.max
  @param {number} opts.scale - Digits after point
  @param {boolean} opts.signed - Allow negative
  @param {boolean} opts.normalizeZeros - Flag to remove leading and trailing zeros in the end of editing
  @param {boolean} opts.padFractionalZeros - Flag to pad trailing zeros after point in the end of editing
*/
class MaskedNumber extends Masked {
  /** Single char */

  /** Single char */

  /** Array of single chars */

  /** */

  /** */

  /** Digits after point */

  /** */

  /** Flag to remove leading and trailing zeros in the end of editing */

  /** Flag to pad trailing zeros after point in the end of editing */

  constructor(opts) {
    super(Object.assign({}, MaskedNumber.DEFAULTS, opts));
  }

  /**
    @override
  */
  _update(opts) {
    super._update(opts);
    this._updateRegExps();
  }

  /** */
  _updateRegExps() {
    let start = '^' + (this.allowNegative ? '[+|\\-]?' : '');
    let mid = '\\d*';
    let end = (this.scale ? "(".concat(escapeRegExp(this.radix), "\\d{0,").concat(this.scale, "})?") : '') + '$';
    this._numberRegExp = new RegExp(start + mid + end);
    this._mapToRadixRegExp = new RegExp("[".concat(this.mapToRadix.map(escapeRegExp).join(''), "]"), 'g');
    this._thousandsSeparatorRegExp = new RegExp(escapeRegExp(this.thousandsSeparator), 'g');
  }

  /** */
  _removeThousandsSeparators(value) {
    return value.replace(this._thousandsSeparatorRegExp, '');
  }

  /** */
  _insertThousandsSeparators(value) {
    // https://stackoverflow.com/questions/2901102/how-to-print-a-number-with-commas-as-thousands-separators-in-javascript
    const parts = value.split(this.radix);
    parts[0] = parts[0].replace(/\B(?=(\d{3})+(?!\d))/g, this.thousandsSeparator);
    return parts.join(this.radix);
  }

  /**
    @override
  */
  doPrepare(ch) {
    let flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    ch = this._removeThousandsSeparators(this.scale && this.mapToRadix.length && (
    /*
      radix should be mapped when
      1) input is done from keyboard = flags.input && flags.raw
      2) unmasked value is set = !flags.input && !flags.raw
      and should not be mapped when
      1) value is set = flags.input && !flags.raw
      2) raw value is set = !flags.input && flags.raw
    */
    flags.input && flags.raw || !flags.input && !flags.raw) ? ch.replace(this._mapToRadixRegExp, this.radix) : ch);
    const [prepCh, details] = normalizePrepare(super.doPrepare(ch, flags));
    if (ch && !prepCh) details.skip = true;
    return [prepCh, details];
  }

  /** */
  _separatorsCount(to) {
    let extendOnSeparators = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
    let count = 0;
    for (let pos = 0; pos < to; ++pos) {
      if (this._value.indexOf(this.thousandsSeparator, pos) === pos) {
        ++count;
        if (extendOnSeparators) to += this.thousandsSeparator.length;
      }
    }
    return count;
  }

  /** */
  _separatorsCountFromSlice() {
    let slice = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._value;
    return this._separatorsCount(this._removeThousandsSeparators(slice).length, true);
  }

  /**
    @override
  */
  extractInput() {
    let fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    let toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
    let flags = arguments.length > 2 ? arguments[2] : undefined;
    [fromPos, toPos] = this._adjustRangeWithSeparators(fromPos, toPos);
    return this._removeThousandsSeparators(super.extractInput(fromPos, toPos, flags));
  }

  /**
    @override
  */
  _appendCharRaw(ch) {
    let flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!this.thousandsSeparator) return super._appendCharRaw(ch, flags);
    const prevBeforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;
    const prevBeforeTailSeparatorsCount = this._separatorsCountFromSlice(prevBeforeTailValue);
    this._value = this._removeThousandsSeparators(this.value);
    const appendDetails = super._appendCharRaw(ch, flags);
    this._value = this._insertThousandsSeparators(this._value);
    const beforeTailValue = flags.tail && flags._beforeTailState ? flags._beforeTailState._value : this._value;
    const beforeTailSeparatorsCount = this._separatorsCountFromSlice(beforeTailValue);
    appendDetails.tailShift += (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length;
    appendDetails.skip = !appendDetails.rawInserted && ch === this.thousandsSeparator;
    return appendDetails;
  }

  /** */
  _findSeparatorAround(pos) {
    if (this.thousandsSeparator) {
      const searchFrom = pos - this.thousandsSeparator.length + 1;
      const separatorPos = this.value.indexOf(this.thousandsSeparator, searchFrom);
      if (separatorPos <= pos) return separatorPos;
    }
    return -1;
  }
  _adjustRangeWithSeparators(from, to) {
    const separatorAroundFromPos = this._findSeparatorAround(from);
    if (separatorAroundFromPos >= 0) from = separatorAroundFromPos;
    const separatorAroundToPos = this._findSeparatorAround(to);
    if (separatorAroundToPos >= 0) to = separatorAroundToPos + this.thousandsSeparator.length;
    return [from, to];
  }

  /**
    @override
  */
  remove() {
    let fromPos = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
    let toPos = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : this.value.length;
    [fromPos, toPos] = this._adjustRangeWithSeparators(fromPos, toPos);
    const valueBeforePos = this.value.slice(0, fromPos);
    const valueAfterPos = this.value.slice(toPos);
    const prevBeforeTailSeparatorsCount = this._separatorsCount(valueBeforePos.length);
    this._value = this._insertThousandsSeparators(this._removeThousandsSeparators(valueBeforePos + valueAfterPos));
    const beforeTailSeparatorsCount = this._separatorsCountFromSlice(valueBeforePos);
    return new ChangeDetails({
      tailShift: (beforeTailSeparatorsCount - prevBeforeTailSeparatorsCount) * this.thousandsSeparator.length
    });
  }

  /**
    @override
  */
  nearestInputPos(cursorPos, direction) {
    if (!this.thousandsSeparator) return cursorPos;
    switch (direction) {
      case DIRECTION.NONE:
      case DIRECTION.LEFT:
      case DIRECTION.FORCE_LEFT:
        {
          const separatorAtLeftPos = this._findSeparatorAround(cursorPos - 1);
          if (separatorAtLeftPos >= 0) {
            const separatorAtLeftEndPos = separatorAtLeftPos + this.thousandsSeparator.length;
            if (cursorPos < separatorAtLeftEndPos || this.value.length <= separatorAtLeftEndPos || direction === DIRECTION.FORCE_LEFT) {
              return separatorAtLeftPos;
            }
          }
          break;
        }
      case DIRECTION.RIGHT:
      case DIRECTION.FORCE_RIGHT:
        {
          const separatorAtRightPos = this._findSeparatorAround(cursorPos);
          if (separatorAtRightPos >= 0) {
            return separatorAtRightPos + this.thousandsSeparator.length;
          }
        }
    }
    return cursorPos;
  }

  /**
    @override
  */
  doValidate(flags) {
    // validate as string
    let valid = Boolean(this._removeThousandsSeparators(this.value).match(this._numberRegExp));
    if (valid) {
      // validate as number
      const number = this.number;
      valid = valid && !isNaN(number) && (
      // check min bound for negative values
      this.min == null || this.min >= 0 || this.min <= this.number) && (
      // check max bound for positive values
      this.max == null || this.max <= 0 || this.number <= this.max);
    }
    return valid && super.doValidate(flags);
  }

  /**
    @override
  */
  doCommit() {
    if (this.value) {
      const number = this.number;
      let validnum = number;

      // check bounds
      if (this.min != null) validnum = Math.max(validnum, this.min);
      if (this.max != null) validnum = Math.min(validnum, this.max);
      if (validnum !== number) this.unmaskedValue = this.doFormat(validnum);
      let formatted = this.value;
      if (this.normalizeZeros) formatted = this._normalizeZeros(formatted);
      if (this.padFractionalZeros && this.scale > 0) formatted = this._padFractionalZeros(formatted);
      this._value = formatted;
    }
    super.doCommit();
  }

  /** */
  _normalizeZeros(value) {
    const parts = this._removeThousandsSeparators(value).split(this.radix);

    // remove leading zeros
    parts[0] = parts[0].replace(/^(\D*)(0*)(\d*)/, (match, sign, zeros, num) => sign + num);
    // add leading zero
    if (value.length && !/\d$/.test(parts[0])) parts[0] = parts[0] + '0';
    if (parts.length > 1) {
      parts[1] = parts[1].replace(/0*$/, ''); // remove trailing zeros
      if (!parts[1].length) parts.length = 1; // remove fractional
    }

    return this._insertThousandsSeparators(parts.join(this.radix));
  }

  /** */
  _padFractionalZeros(value) {
    if (!value) return value;
    const parts = value.split(this.radix);
    if (parts.length < 2) parts.push('');
    parts[1] = parts[1].padEnd(this.scale, '0');
    return parts.join(this.radix);
  }

  /** */
  doSkipInvalid(ch) {
    let flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let checkTail = arguments.length > 2 ? arguments[2] : undefined;
    const dropFractional = this.scale === 0 && ch !== this.thousandsSeparator && (ch === this.radix || ch === MaskedNumber.UNMASKED_RADIX || this.mapToRadix.includes(ch));
    return super.doSkipInvalid(ch, flags, checkTail) && !dropFractional;
  }

  /**
    @override
  */
  get unmaskedValue() {
    return this._removeThousandsSeparators(this._normalizeZeros(this.value)).replace(this.radix, MaskedNumber.UNMASKED_RADIX);
  }
  set unmaskedValue(unmaskedValue) {
    super.unmaskedValue = unmaskedValue;
  }

  /**
    @override
  */
  get typedValue() {
    return this.doParse(this.unmaskedValue);
  }
  set typedValue(n) {
    this.rawInputValue = this.doFormat(n).replace(MaskedNumber.UNMASKED_RADIX, this.radix);
  }

  /** Parsed Number */
  get number() {
    return this.typedValue;
  }
  set number(number) {
    this.typedValue = number;
  }

  /**
    Is negative allowed
    @readonly
  */
  get allowNegative() {
    return this.signed || this.min != null && this.min < 0 || this.max != null && this.max < 0;
  }

  /**
    @override
  */
  typedValueEquals(value) {
    // handle  0 -> '' case (typed = 0 even if value = '')
    // for details see https://github.com/uNmAnNeR/imaskjs/issues/134
    return (super.typedValueEquals(value) || MaskedNumber.EMPTY_VALUES.includes(value) && MaskedNumber.EMPTY_VALUES.includes(this.typedValue)) && !(value === 0 && this.value === '');
  }
}
MaskedNumber.UNMASKED_RADIX = '.';
MaskedNumber.DEFAULTS = {
  radix: ',',
  thousandsSeparator: '',
  mapToRadix: [MaskedNumber.UNMASKED_RADIX],
  scale: 2,
  signed: false,
  normalizeZeros: true,
  padFractionalZeros: false,
  parse: Number,
  format: n => n.toLocaleString('en-US', {
    useGrouping: false,
    maximumFractionDigits: 20
  })
};
MaskedNumber.EMPTY_VALUES = [...Masked.EMPTY_VALUES, 0];
IMask.MaskedNumber = MaskedNumber;

/** Masking by custom Function */
class MaskedFunction extends Masked {
  /**
    @override
    @param {Object} opts
  */
  _update(opts) {
    if (opts.mask) opts.validate = opts.mask;
    super._update(opts);
  }
}
IMask.MaskedFunction = MaskedFunction;

const _excluded$1 = ["compiledMasks", "currentMaskRef", "currentMask"],
  _excluded2$1 = ["mask"];
/** Dynamic mask for choosing apropriate mask in run-time */
class MaskedDynamic extends Masked {
  /** Currently chosen mask */

  /** Compliled {@link Masked} options */

  /** Chooses {@link Masked} depending on input value */

  /**
    @param {Object} opts
  */
  constructor(opts) {
    super(Object.assign({}, MaskedDynamic.DEFAULTS, opts));
    this.currentMask = null;
  }

  /**
    @override
  */
  _update(opts) {
    super._update(opts);
    if ('mask' in opts) {
      // mask could be totally dynamic with only `dispatch` option
      this.compiledMasks = Array.isArray(opts.mask) ? opts.mask.map(m => createMask(m)) : [];

      // this.currentMask = this.doDispatch(''); // probably not needed but lets see
    }
  }

  /**
    @override
  */
  _appendCharRaw(ch) {
    let flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    const details = this._applyDispatch(ch, flags);
    if (this.currentMask) {
      details.aggregate(this.currentMask._appendChar(ch, this.currentMaskFlags(flags)));
    }
    return details;
  }
  _applyDispatch() {
    let appended = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
    let flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let tail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    const prevValueBeforeTail = flags.tail && flags._beforeTailState != null ? flags._beforeTailState._value : this.value;
    const inputValue = this.rawInputValue;
    const insertValue = flags.tail && flags._beforeTailState != null ?
    // $FlowFixMe - tired to fight with type system
    flags._beforeTailState._rawInputValue : inputValue;
    const tailValue = inputValue.slice(insertValue.length);
    const prevMask = this.currentMask;
    const details = new ChangeDetails();
    const prevMaskState = prevMask === null || prevMask === void 0 ? void 0 : prevMask.state;

    // clone flags to prevent overwriting `_beforeTailState`
    this.currentMask = this.doDispatch(appended, Object.assign({}, flags), tail);

    // restore state after dispatch
    if (this.currentMask) {
      if (this.currentMask !== prevMask) {
        // if mask changed reapply input
        this.currentMask.reset();
        if (insertValue) {
          // $FlowFixMe - it's ok, we don't change current mask above
          const d = this.currentMask.append(insertValue, {
            raw: true
          });
          details.tailShift = d.inserted.length - prevValueBeforeTail.length;
        }
        if (tailValue) {
          // $FlowFixMe - it's ok, we don't change current mask above
          details.tailShift += this.currentMask.append(tailValue, {
            raw: true,
            tail: true
          }).tailShift;
        }
      } else {
        // Dispatch can do something bad with state, so
        // restore prev mask state
        this.currentMask.state = prevMaskState;
      }
    }
    return details;
  }
  _appendPlaceholder() {
    const details = this._applyDispatch(...arguments);
    if (this.currentMask) {
      details.aggregate(this.currentMask._appendPlaceholder());
    }
    return details;
  }

  /**
   @override
  */
  _appendEager() {
    const details = this._applyDispatch(...arguments);
    if (this.currentMask) {
      details.aggregate(this.currentMask._appendEager());
    }
    return details;
  }
  appendTail(tail) {
    const details = new ChangeDetails();
    if (tail) details.aggregate(this._applyDispatch('', {}, tail));
    return details.aggregate(this.currentMask ? this.currentMask.appendTail(tail) : super.appendTail(tail));
  }
  currentMaskFlags(flags) {
    var _flags$_beforeTailSta, _flags$_beforeTailSta2;
    return Object.assign({}, flags, {
      _beforeTailState: ((_flags$_beforeTailSta = flags._beforeTailState) === null || _flags$_beforeTailSta === void 0 ? void 0 : _flags$_beforeTailSta.currentMaskRef) === this.currentMask && ((_flags$_beforeTailSta2 = flags._beforeTailState) === null || _flags$_beforeTailSta2 === void 0 ? void 0 : _flags$_beforeTailSta2.currentMask) || flags._beforeTailState
    });
  }

  /**
    @override
  */
  doDispatch(appended) {
    let flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let tail = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '';
    return this.dispatch(appended, this, flags, tail);
  }

  /**
    @override
  */
  doValidate(flags) {
    return super.doValidate(flags) && (!this.currentMask || this.currentMask.doValidate(this.currentMaskFlags(flags)));
  }

  /**
    @override
  */
  doPrepare(str) {
    let flags = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    let [s, details] = normalizePrepare(super.doPrepare(str, flags));
    if (this.currentMask) {
      let currentDetails;
      [s, currentDetails] = normalizePrepare(super.doPrepare(s, this.currentMaskFlags(flags)));
      details = details.aggregate(currentDetails);
    }
    return [s, details];
  }

  /**
    @override
  */
  reset() {
    var _this$currentMask;
    (_this$currentMask = this.currentMask) === null || _this$currentMask === void 0 ? void 0 : _this$currentMask.reset();
    this.compiledMasks.forEach(m => m.reset());
  }

  /**
    @override
  */
  get value() {
    return this.currentMask ? this.currentMask.value : '';
  }
  set value(value) {
    super.value = value;
  }

  /**
    @override
  */
  get unmaskedValue() {
    return this.currentMask ? this.currentMask.unmaskedValue : '';
  }
  set unmaskedValue(unmaskedValue) {
    super.unmaskedValue = unmaskedValue;
  }

  /**
    @override
  */
  get typedValue() {
    return this.currentMask ? this.currentMask.typedValue : '';
  }

  // probably typedValue should not be used with dynamic
  set typedValue(value) {
    let unmaskedValue = String(value);

    // double check it
    if (this.currentMask) {
      this.currentMask.typedValue = value;
      unmaskedValue = this.currentMask.unmaskedValue;
    }
    this.unmaskedValue = unmaskedValue;
  }
  get displayValue() {
    return this.currentMask ? this.currentMask.displayValue : '';
  }

  /**
    @override
  */
  get isComplete() {
    var _this$currentMask2;
    return Boolean((_this$currentMask2 = this.currentMask) === null || _this$currentMask2 === void 0 ? void 0 : _this$currentMask2.isComplete);
  }

  /**
    @override
  */
  get isFilled() {
    var _this$currentMask3;
    return Boolean((_this$currentMask3 = this.currentMask) === null || _this$currentMask3 === void 0 ? void 0 : _this$currentMask3.isFilled);
  }

  /**
    @override
  */
  remove() {
    const details = new ChangeDetails();
    if (this.currentMask) {
      details.aggregate(this.currentMask.remove(...arguments))
      // update with dispatch
      .aggregate(this._applyDispatch());
    }
    return details;
  }

  /**
    @override
  */
  get state() {
    var _this$currentMask4;
    return Object.assign({}, super.state, {
      _rawInputValue: this.rawInputValue,
      compiledMasks: this.compiledMasks.map(m => m.state),
      currentMaskRef: this.currentMask,
      currentMask: (_this$currentMask4 = this.currentMask) === null || _this$currentMask4 === void 0 ? void 0 : _this$currentMask4.state
    });
  }
  set state(state) {
    const {
        compiledMasks,
        currentMaskRef,
        currentMask
      } = state,
      maskedState = _objectWithoutPropertiesLoose$4(state, _excluded$1);
    this.compiledMasks.forEach((m, mi) => m.state = compiledMasks[mi]);
    if (currentMaskRef != null) {
      this.currentMask = currentMaskRef;
      this.currentMask.state = currentMask;
    }
    super.state = maskedState;
  }

  /**
    @override
  */
  extractInput() {
    return this.currentMask ? this.currentMask.extractInput(...arguments) : '';
  }

  /**
    @override
  */
  extractTail() {
    return this.currentMask ? this.currentMask.extractTail(...arguments) : super.extractTail(...arguments);
  }

  /**
    @override
  */
  doCommit() {
    if (this.currentMask) this.currentMask.doCommit();
    super.doCommit();
  }

  /**
    @override
  */
  nearestInputPos() {
    return this.currentMask ? this.currentMask.nearestInputPos(...arguments) : super.nearestInputPos(...arguments);
  }
  get overwrite() {
    return this.currentMask ? this.currentMask.overwrite : super.overwrite;
  }
  set overwrite(overwrite) {
    console.warn('"overwrite" option is not available in dynamic mask, use this option in siblings');
  }
  get eager() {
    return this.currentMask ? this.currentMask.eager : super.eager;
  }
  set eager(eager) {
    console.warn('"eager" option is not available in dynamic mask, use this option in siblings');
  }
  get skipInvalid() {
    return this.currentMask ? this.currentMask.skipInvalid : super.skipInvalid;
  }
  set skipInvalid(skipInvalid) {
    if (this.isInitialized || skipInvalid !== Masked.DEFAULTS.skipInvalid) {
      console.warn('"skipInvalid" option is not available in dynamic mask, use this option in siblings');
    }
  }

  /**
    @override
  */
  maskEquals(mask) {
    return Array.isArray(mask) && this.compiledMasks.every((m, mi) => {
      if (!mask[mi]) return;
      const _mask$mi = mask[mi],
        {
          mask: oldMask
        } = _mask$mi,
        restOpts = _objectWithoutPropertiesLoose$4(_mask$mi, _excluded2$1);
      return objectIncludes(m, restOpts) && m.maskEquals(oldMask);
    });
  }

  /**
    @override
  */
  typedValueEquals(value) {
    var _this$currentMask5;
    return Boolean((_this$currentMask5 = this.currentMask) === null || _this$currentMask5 === void 0 ? void 0 : _this$currentMask5.typedValueEquals(value));
  }
}
MaskedDynamic.DEFAULTS = {
  dispatch: (appended, masked, flags, tail) => {
    if (!masked.compiledMasks.length) return;
    const inputValue = masked.rawInputValue;

    // simulate input
    const inputs = masked.compiledMasks.map((m, index) => {
      const isCurrent = masked.currentMask === m;
      const startInputPos = isCurrent ? m.value.length : m.nearestInputPos(m.value.length, DIRECTION.FORCE_LEFT);
      if (m.rawInputValue !== inputValue) {
        m.reset();
        m.append(inputValue, {
          raw: true
        });
      } else if (!isCurrent) {
        m.remove(startInputPos);
      }
      m.append(appended, masked.currentMaskFlags(flags));
      m.appendTail(tail);
      return {
        index,
        weight: m.rawInputValue.length,
        totalInputPositions: m.totalInputPositions(0, Math.max(startInputPos, m.nearestInputPos(m.value.length, DIRECTION.FORCE_LEFT)))
      };
    });

    // pop masks with longer values first
    inputs.sort((i1, i2) => i2.weight - i1.weight || i2.totalInputPositions - i1.totalInputPositions);
    return masked.compiledMasks[inputs[0].index];
  }
};
IMask.MaskedDynamic = MaskedDynamic;

/** Mask pipe source and destination types */
const PIPE_TYPE = {
  MASKED: 'value',
  UNMASKED: 'unmaskedValue',
  TYPED: 'typedValue'
};

/** Creates new pipe function depending on mask type, source and destination options */
function createPipe(mask) {
  let from = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : PIPE_TYPE.MASKED;
  let to = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : PIPE_TYPE.MASKED;
  const masked = createMask(mask);
  return value => masked.runIsolated(m => {
    m[from] = value;
    return m[to];
  });
}

/** Pipes value through mask depending on mask type, source and destination options */
function pipe(value) {
  for (var _len = arguments.length, pipeArgs = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    pipeArgs[_key - 1] = arguments[_key];
  }
  return createPipe(...pipeArgs)(value);
}
IMask.PIPE_TYPE = PIPE_TYPE;
IMask.createPipe = createPipe;
IMask.pipe = pipe;

try {
  globalThis.IMask = IMask;
} catch (e) {}

/** @license React v16.13.1
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b$1="function"===typeof Symbol&&Symbol.for,c$1=b$1?Symbol.for("react.element"):60103,d$1=b$1?Symbol.for("react.portal"):60106,e$1=b$1?Symbol.for("react.fragment"):60107,f$1=b$1?Symbol.for("react.strict_mode"):60108,g$1=b$1?Symbol.for("react.profiler"):60114,h$1=b$1?Symbol.for("react.provider"):60109,k$1=b$1?Symbol.for("react.context"):60110,l$1=b$1?Symbol.for("react.async_mode"):60111,m$1=b$1?Symbol.for("react.concurrent_mode"):60111,n$1=b$1?Symbol.for("react.forward_ref"):60112,p$1=b$1?Symbol.for("react.suspense"):60113,q$1=b$1?
Symbol.for("react.suspense_list"):60120,r$2=b$1?Symbol.for("react.memo"):60115,t=b$1?Symbol.for("react.lazy"):60116,v$1=b$1?Symbol.for("react.block"):60121,w$1=b$1?Symbol.for("react.fundamental"):60117,x$1=b$1?Symbol.for("react.responder"):60118,y$1=b$1?Symbol.for("react.scope"):60119;
function z$1(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c$1:switch(a=a.type,a){case l$1:case m$1:case e$1:case g$1:case f$1:case p$1:return a;default:switch(a=a&&a.$$typeof,a){case k$1:case n$1:case t:case r$2:case h$1:return a;default:return u}}case d$1:return u}}}function A$1(a){return z$1(a)===m$1}var AsyncMode=l$1;var ConcurrentMode=m$1;var ContextConsumer$1=k$1;var ContextProvider$1=h$1;var Element$2=c$1;var ForwardRef$1=n$1;var Fragment$1=e$1;var Lazy$1=t;var Memo$1=r$2;var Portal$1=d$1;
var Profiler$1=g$1;var StrictMode$1=f$1;var Suspense$1=p$1;var isAsyncMode$1=function(a){return A$1(a)||z$1(a)===l$1};var isConcurrentMode$1=A$1;var isContextConsumer$1=function(a){return z$1(a)===k$1};var isContextProvider$1=function(a){return z$1(a)===h$1};var isElement$3=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===c$1};var isForwardRef$1=function(a){return z$1(a)===n$1};var isFragment$1=function(a){return z$1(a)===e$1};var isLazy$1=function(a){return z$1(a)===t};
var isMemo$1=function(a){return z$1(a)===r$2};var isPortal$1=function(a){return z$1(a)===d$1};var isProfiler$1=function(a){return z$1(a)===g$1};var isStrictMode$1=function(a){return z$1(a)===f$1};var isSuspense$1=function(a){return z$1(a)===p$1};
var isValidElementType$1=function(a){return "string"===typeof a||"function"===typeof a||a===e$1||a===m$1||a===g$1||a===f$1||a===p$1||a===q$1||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r$2||a.$$typeof===h$1||a.$$typeof===k$1||a.$$typeof===n$1||a.$$typeof===w$1||a.$$typeof===x$1||a.$$typeof===y$1||a.$$typeof===v$1)};var typeOf$1=z$1;

var reactIs_production_min$1 = {
	AsyncMode: AsyncMode,
	ConcurrentMode: ConcurrentMode,
	ContextConsumer: ContextConsumer$1,
	ContextProvider: ContextProvider$1,
	Element: Element$2,
	ForwardRef: ForwardRef$1,
	Fragment: Fragment$1,
	Lazy: Lazy$1,
	Memo: Memo$1,
	Portal: Portal$1,
	Profiler: Profiler$1,
	StrictMode: StrictMode$1,
	Suspense: Suspense$1,
	isAsyncMode: isAsyncMode$1,
	isConcurrentMode: isConcurrentMode$1,
	isContextConsumer: isContextConsumer$1,
	isContextProvider: isContextProvider$1,
	isElement: isElement$3,
	isForwardRef: isForwardRef$1,
	isFragment: isFragment$1,
	isLazy: isLazy$1,
	isMemo: isMemo$1,
	isPortal: isPortal$1,
	isProfiler: isProfiler$1,
	isStrictMode: isStrictMode$1,
	isSuspense: isSuspense$1,
	isValidElementType: isValidElementType$1,
	typeOf: typeOf$1
};

var reactIs_development$1 = createCommonjsModule(function (module, exports) {



if (process.env.NODE_ENV !== "production") {
  (function() {

// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var hasSymbol = typeof Symbol === 'function' && Symbol.for;
var REACT_ELEMENT_TYPE = hasSymbol ? Symbol.for('react.element') : 0xeac7;
var REACT_PORTAL_TYPE = hasSymbol ? Symbol.for('react.portal') : 0xeaca;
var REACT_FRAGMENT_TYPE = hasSymbol ? Symbol.for('react.fragment') : 0xeacb;
var REACT_STRICT_MODE_TYPE = hasSymbol ? Symbol.for('react.strict_mode') : 0xeacc;
var REACT_PROFILER_TYPE = hasSymbol ? Symbol.for('react.profiler') : 0xead2;
var REACT_PROVIDER_TYPE = hasSymbol ? Symbol.for('react.provider') : 0xeacd;
var REACT_CONTEXT_TYPE = hasSymbol ? Symbol.for('react.context') : 0xeace; // TODO: We don't use AsyncMode or ConcurrentMode anymore. They were temporary
// (unstable) APIs that have been removed. Can we remove the symbols?

var REACT_ASYNC_MODE_TYPE = hasSymbol ? Symbol.for('react.async_mode') : 0xeacf;
var REACT_CONCURRENT_MODE_TYPE = hasSymbol ? Symbol.for('react.concurrent_mode') : 0xeacf;
var REACT_FORWARD_REF_TYPE = hasSymbol ? Symbol.for('react.forward_ref') : 0xead0;
var REACT_SUSPENSE_TYPE = hasSymbol ? Symbol.for('react.suspense') : 0xead1;
var REACT_SUSPENSE_LIST_TYPE = hasSymbol ? Symbol.for('react.suspense_list') : 0xead8;
var REACT_MEMO_TYPE = hasSymbol ? Symbol.for('react.memo') : 0xead3;
var REACT_LAZY_TYPE = hasSymbol ? Symbol.for('react.lazy') : 0xead4;
var REACT_BLOCK_TYPE = hasSymbol ? Symbol.for('react.block') : 0xead9;
var REACT_FUNDAMENTAL_TYPE = hasSymbol ? Symbol.for('react.fundamental') : 0xead5;
var REACT_RESPONDER_TYPE = hasSymbol ? Symbol.for('react.responder') : 0xead6;
var REACT_SCOPE_TYPE = hasSymbol ? Symbol.for('react.scope') : 0xead7;

function isValidElementType(type) {
  return typeof type === 'string' || typeof type === 'function' || // Note: its typeof might be other than 'symbol' or 'number' if it's a polyfill.
  type === REACT_FRAGMENT_TYPE || type === REACT_CONCURRENT_MODE_TYPE || type === REACT_PROFILER_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || typeof type === 'object' && type !== null && (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_RESPONDER_TYPE || type.$$typeof === REACT_SCOPE_TYPE || type.$$typeof === REACT_BLOCK_TYPE);
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_ASYNC_MODE_TYPE:
          case REACT_CONCURRENT_MODE_TYPE:
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
} // AsyncMode is deprecated along with isAsyncMode

var AsyncMode = REACT_ASYNC_MODE_TYPE;
var ConcurrentMode = REACT_CONCURRENT_MODE_TYPE;
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 17+. Update your code to use ' + 'ReactIs.isConcurrentMode() instead. It has the exact same API.');
    }
  }

  return isConcurrentMode(object) || typeOf(object) === REACT_ASYNC_MODE_TYPE;
}
function isConcurrentMode(object) {
  return typeOf(object) === REACT_CONCURRENT_MODE_TYPE;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.AsyncMode = AsyncMode;
exports.ConcurrentMode = ConcurrentMode;
exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});
reactIs_development$1.AsyncMode;
reactIs_development$1.ConcurrentMode;
reactIs_development$1.ContextConsumer;
reactIs_development$1.ContextProvider;
reactIs_development$1.Element;
reactIs_development$1.ForwardRef;
reactIs_development$1.Fragment;
reactIs_development$1.Lazy;
reactIs_development$1.Memo;
reactIs_development$1.Portal;
reactIs_development$1.Profiler;
reactIs_development$1.StrictMode;
reactIs_development$1.Suspense;
reactIs_development$1.isAsyncMode;
reactIs_development$1.isConcurrentMode;
reactIs_development$1.isContextConsumer;
reactIs_development$1.isContextProvider;
reactIs_development$1.isElement;
reactIs_development$1.isForwardRef;
reactIs_development$1.isFragment;
reactIs_development$1.isLazy;
reactIs_development$1.isMemo;
reactIs_development$1.isPortal;
reactIs_development$1.isProfiler;
reactIs_development$1.isStrictMode;
reactIs_development$1.isSuspense;
reactIs_development$1.isValidElementType;
reactIs_development$1.typeOf;

var reactIs$1 = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min$1;
} else {
  module.exports = reactIs_development$1;
}
});

/*
object-assign
(c) Sindre Sorhus
@license MIT
*/
/* eslint-disable no-unused-vars */
var getOwnPropertySymbols = Object.getOwnPropertySymbols;
var hasOwnProperty = Object.prototype.hasOwnProperty;
var propIsEnumerable = Object.prototype.propertyIsEnumerable;

function toObject(val) {
	if (val === null || val === undefined) {
		throw new TypeError('Object.assign cannot be called with null or undefined');
	}

	return Object(val);
}

function shouldUseNative() {
	try {
		if (!Object.assign) {
			return false;
		}

		// Detect buggy property enumeration order in older V8 versions.

		// https://bugs.chromium.org/p/v8/issues/detail?id=4118
		var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
		test1[5] = 'de';
		if (Object.getOwnPropertyNames(test1)[0] === '5') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test2 = {};
		for (var i = 0; i < 10; i++) {
			test2['_' + String.fromCharCode(i)] = i;
		}
		var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
			return test2[n];
		});
		if (order2.join('') !== '0123456789') {
			return false;
		}

		// https://bugs.chromium.org/p/v8/issues/detail?id=3056
		var test3 = {};
		'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
			test3[letter] = letter;
		});
		if (Object.keys(Object.assign({}, test3)).join('') !==
				'abcdefghijklmnopqrst') {
			return false;
		}

		return true;
	} catch (err) {
		// We don't expect any of the above to throw, but better to be safe.
		return false;
	}
}

var objectAssign = shouldUseNative() ? Object.assign : function (target, source) {
	var from;
	var to = toObject(target);
	var symbols;

	for (var s = 1; s < arguments.length; s++) {
		from = Object(arguments[s]);

		for (var key in from) {
			if (hasOwnProperty.call(from, key)) {
				to[key] = from[key];
			}
		}

		if (getOwnPropertySymbols) {
			symbols = getOwnPropertySymbols(from);
			for (var i = 0; i < symbols.length; i++) {
				if (propIsEnumerable.call(from, symbols[i])) {
					to[symbols[i]] = from[symbols[i]];
				}
			}
		}
	}

	return to;
};

/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

var ReactPropTypesSecret$2 = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';

var ReactPropTypesSecret_1 = ReactPropTypesSecret$2;

var has$2 = Function.call.bind(Object.prototype.hasOwnProperty);

var ReactPropTypesSecret$1 = ReactPropTypesSecret_1;

var has$1 = has$2;

var printWarning$2 = function() {};

if (process.env.NODE_ENV !== 'production') {
  var ReactPropTypesSecret = ReactPropTypesSecret$1;
  var loggedTypeFailures = {};
  var has = has$1;

  printWarning$2 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) { /**/ }
  };
}

/**
 * Assert that the values match with the type specs.
 * Error messages are memorized and will only be shown once.
 *
 * @param {object} typeSpecs Map of name to a ReactPropType
 * @param {object} values Runtime values that need to be type-checked
 * @param {string} location e.g. "prop", "context", "child context"
 * @param {string} componentName Name of the component for error messages.
 * @param {?Function} getStack Returns the component stack.
 * @private
 */
function checkPropTypes$1(typeSpecs, values, location, componentName, getStack) {
  if (process.env.NODE_ENV !== 'production') {
    for (var typeSpecName in typeSpecs) {
      if (has(typeSpecs, typeSpecName)) {
        var error;
        // Prop type validation may throw. In case they do, we don't want to
        // fail the render phase where it didn't fail before. So we log it.
        // After these have been cleaned up, we'll let them throw.
        try {
          // This is intentionally an invariant that gets caught. It's the same
          // behavior as without this statement except with a better message.
          if (typeof typeSpecs[typeSpecName] !== 'function') {
            var err = Error(
              (componentName || 'React class') + ': ' + location + ' type `' + typeSpecName + '` is invalid; ' +
              'it must be a function, usually from the `prop-types` package, but received `' + typeof typeSpecs[typeSpecName] + '`.' +
              'This often happens because of typos such as `PropTypes.function` instead of `PropTypes.func`.'
            );
            err.name = 'Invariant Violation';
            throw err;
          }
          error = typeSpecs[typeSpecName](values, typeSpecName, componentName, location, null, ReactPropTypesSecret);
        } catch (ex) {
          error = ex;
        }
        if (error && !(error instanceof Error)) {
          printWarning$2(
            (componentName || 'React class') + ': type specification of ' +
            location + ' `' + typeSpecName + '` is invalid; the type checker ' +
            'function must return `null` or an `Error` but returned a ' + typeof error + '. ' +
            'You may have forgotten to pass an argument to the type checker ' +
            'creator (arrayOf, instanceOf, objectOf, oneOf, oneOfType, and ' +
            'shape all require an argument).'
          );
        }
        if (error instanceof Error && !(error.message in loggedTypeFailures)) {
          // Only monitor this failure once because there tends to be a lot of the
          // same error.
          loggedTypeFailures[error.message] = true;

          var stack = getStack ? getStack() : '';

          printWarning$2(
            'Failed ' + location + ' type: ' + error.message + (stack != null ? stack : '')
          );
        }
      }
    }
  }
}

/**
 * Resets warning cache when testing.
 *
 * @private
 */
checkPropTypes$1.resetWarningCache = function() {
  if (process.env.NODE_ENV !== 'production') {
    loggedTypeFailures = {};
  }
};

var checkPropTypes_1 = checkPropTypes$1;

var checkPropTypes = checkPropTypes_1;

var printWarning$1 = function() {};

if (process.env.NODE_ENV !== 'production') {
  printWarning$1 = function(text) {
    var message = 'Warning: ' + text;
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };
}

function emptyFunctionThatReturnsNull() {
  return null;
}

var factoryWithTypeCheckers = function(isValidElement, throwOnDirectAccess) {
  /* global Symbol */
  var ITERATOR_SYMBOL = typeof Symbol === 'function' && Symbol.iterator;
  var FAUX_ITERATOR_SYMBOL = '@@iterator'; // Before Symbol spec.

  /**
   * Returns the iterator method function contained on the iterable object.
   *
   * Be sure to invoke the function with the iterable as context:
   *
   *     var iteratorFn = getIteratorFn(myIterable);
   *     if (iteratorFn) {
   *       var iterator = iteratorFn.call(myIterable);
   *       ...
   *     }
   *
   * @param {?object} maybeIterable
   * @return {?function}
   */
  function getIteratorFn(maybeIterable) {
    var iteratorFn = maybeIterable && (ITERATOR_SYMBOL && maybeIterable[ITERATOR_SYMBOL] || maybeIterable[FAUX_ITERATOR_SYMBOL]);
    if (typeof iteratorFn === 'function') {
      return iteratorFn;
    }
  }

  /**
   * Collection of methods that allow declaration and validation of props that are
   * supplied to React components. Example usage:
   *
   *   var Props = require('ReactPropTypes');
   *   var MyArticle = React.createClass({
   *     propTypes: {
   *       // An optional string prop named "description".
   *       description: Props.string,
   *
   *       // A required enum prop named "category".
   *       category: Props.oneOf(['News','Photos']).isRequired,
   *
   *       // A prop named "dialog" that requires an instance of Dialog.
   *       dialog: Props.instanceOf(Dialog).isRequired
   *     },
   *     render: function() { ... }
   *   });
   *
   * A more formal specification of how these methods are used:
   *
   *   type := array|bool|func|object|number|string|oneOf([...])|instanceOf(...)
   *   decl := ReactPropTypes.{type}(.isRequired)?
   *
   * Each and every declaration produces a function with the same signature. This
   * allows the creation of custom validation functions. For example:
   *
   *  var MyLink = React.createClass({
   *    propTypes: {
   *      // An optional string or URI prop named "href".
   *      href: function(props, propName, componentName) {
   *        var propValue = props[propName];
   *        if (propValue != null && typeof propValue !== 'string' &&
   *            !(propValue instanceof URI)) {
   *          return new Error(
   *            'Expected a string or an URI for ' + propName + ' in ' +
   *            componentName
   *          );
   *        }
   *      }
   *    },
   *    render: function() {...}
   *  });
   *
   * @internal
   */

  var ANONYMOUS = '<<anonymous>>';

  // Important!
  // Keep this list in sync with production version in `./factoryWithThrowingShims.js`.
  var ReactPropTypes = {
    array: createPrimitiveTypeChecker('array'),
    bigint: createPrimitiveTypeChecker('bigint'),
    bool: createPrimitiveTypeChecker('boolean'),
    func: createPrimitiveTypeChecker('function'),
    number: createPrimitiveTypeChecker('number'),
    object: createPrimitiveTypeChecker('object'),
    string: createPrimitiveTypeChecker('string'),
    symbol: createPrimitiveTypeChecker('symbol'),

    any: createAnyTypeChecker(),
    arrayOf: createArrayOfTypeChecker,
    element: createElementTypeChecker(),
    elementType: createElementTypeTypeChecker(),
    instanceOf: createInstanceTypeChecker,
    node: createNodeChecker(),
    objectOf: createObjectOfTypeChecker,
    oneOf: createEnumTypeChecker,
    oneOfType: createUnionTypeChecker,
    shape: createShapeTypeChecker,
    exact: createStrictShapeTypeChecker,
  };

  /**
   * inlined Object.is polyfill to avoid requiring consumers ship their own
   * https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Object/is
   */
  /*eslint-disable no-self-compare*/
  function is(x, y) {
    // SameValue algorithm
    if (x === y) {
      // Steps 1-5, 7-10
      // Steps 6.b-6.e: +0 != -0
      return x !== 0 || 1 / x === 1 / y;
    } else {
      // Step 6.a: NaN == NaN
      return x !== x && y !== y;
    }
  }
  /*eslint-enable no-self-compare*/

  /**
   * We use an Error-like object for backward compatibility as people may call
   * PropTypes directly and inspect their output. However, we don't use real
   * Errors anymore. We don't inspect their stack anyway, and creating them
   * is prohibitively expensive if they are created too often, such as what
   * happens in oneOfType() for any type before the one that matched.
   */
  function PropTypeError(message, data) {
    this.message = message;
    this.data = data && typeof data === 'object' ? data: {};
    this.stack = '';
  }
  // Make `instanceof Error` still work for returned errors.
  PropTypeError.prototype = Error.prototype;

  function createChainableTypeChecker(validate) {
    if (process.env.NODE_ENV !== 'production') {
      var manualPropTypeCallCache = {};
      var manualPropTypeWarningCount = 0;
    }
    function checkType(isRequired, props, propName, componentName, location, propFullName, secret) {
      componentName = componentName || ANONYMOUS;
      propFullName = propFullName || propName;

      if (secret !== ReactPropTypesSecret$1) {
        if (throwOnDirectAccess) {
          // New behavior only for users of `prop-types` package
          var err = new Error(
            'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
            'Use `PropTypes.checkPropTypes()` to call them. ' +
            'Read more at http://fb.me/use-check-prop-types'
          );
          err.name = 'Invariant Violation';
          throw err;
        } else if (process.env.NODE_ENV !== 'production' && typeof console !== 'undefined') {
          // Old behavior for people using React.PropTypes
          var cacheKey = componentName + ':' + propName;
          if (
            !manualPropTypeCallCache[cacheKey] &&
            // Avoid spamming the console because they are often not actionable except for lib authors
            manualPropTypeWarningCount < 3
          ) {
            printWarning$1(
              'You are manually calling a React.PropTypes validation ' +
              'function for the `' + propFullName + '` prop on `' + componentName + '`. This is deprecated ' +
              'and will throw in the standalone `prop-types` package. ' +
              'You may be seeing this warning due to a third-party PropTypes ' +
              'library. See https://fb.me/react-warning-dont-call-proptypes ' + 'for details.'
            );
            manualPropTypeCallCache[cacheKey] = true;
            manualPropTypeWarningCount++;
          }
        }
      }
      if (props[propName] == null) {
        if (isRequired) {
          if (props[propName] === null) {
            return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required ' + ('in `' + componentName + '`, but its value is `null`.'));
          }
          return new PropTypeError('The ' + location + ' `' + propFullName + '` is marked as required in ' + ('`' + componentName + '`, but its value is `undefined`.'));
        }
        return null;
      } else {
        return validate(props, propName, componentName, location, propFullName);
      }
    }

    var chainedCheckType = checkType.bind(null, false);
    chainedCheckType.isRequired = checkType.bind(null, true);

    return chainedCheckType;
  }

  function createPrimitiveTypeChecker(expectedType) {
    function validate(props, propName, componentName, location, propFullName, secret) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== expectedType) {
        // `propValue` being instance of, say, date/regexp, pass the 'object'
        // check, but we can offer a more precise error message here rather than
        // 'of type `object`'.
        var preciseType = getPreciseType(propValue);

        return new PropTypeError(
          'Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + preciseType + '` supplied to `' + componentName + '`, expected ') + ('`' + expectedType + '`.'),
          {expectedType: expectedType}
        );
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createAnyTypeChecker() {
    return createChainableTypeChecker(emptyFunctionThatReturnsNull);
  }

  function createArrayOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside arrayOf.');
      }
      var propValue = props[propName];
      if (!Array.isArray(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an array.'));
      }
      for (var i = 0; i < propValue.length; i++) {
        var error = typeChecker(propValue, i, componentName, location, propFullName + '[' + i + ']', ReactPropTypesSecret$1);
        if (error instanceof Error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!isValidElement(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createElementTypeTypeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      if (!reactIs$1.isValidElementType(propValue)) {
        var propType = getPropType(propValue);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected a single ReactElement type.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createInstanceTypeChecker(expectedClass) {
    function validate(props, propName, componentName, location, propFullName) {
      if (!(props[propName] instanceof expectedClass)) {
        var expectedClassName = expectedClass.name || ANONYMOUS;
        var actualClassName = getClassName(props[propName]);
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + actualClassName + '` supplied to `' + componentName + '`, expected ') + ('instance of `' + expectedClassName + '`.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createEnumTypeChecker(expectedValues) {
    if (!Array.isArray(expectedValues)) {
      if (process.env.NODE_ENV !== 'production') {
        if (arguments.length > 1) {
          printWarning$1(
            'Invalid arguments supplied to oneOf, expected an array, got ' + arguments.length + ' arguments. ' +
            'A common mistake is to write oneOf(x, y, z) instead of oneOf([x, y, z]).'
          );
        } else {
          printWarning$1('Invalid argument supplied to oneOf, expected an array.');
        }
      }
      return emptyFunctionThatReturnsNull;
    }

    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      for (var i = 0; i < expectedValues.length; i++) {
        if (is(propValue, expectedValues[i])) {
          return null;
        }
      }

      var valuesString = JSON.stringify(expectedValues, function replacer(key, value) {
        var type = getPreciseType(value);
        if (type === 'symbol') {
          return String(value);
        }
        return value;
      });
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of value `' + String(propValue) + '` ' + ('supplied to `' + componentName + '`, expected one of ' + valuesString + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createObjectOfTypeChecker(typeChecker) {
    function validate(props, propName, componentName, location, propFullName) {
      if (typeof typeChecker !== 'function') {
        return new PropTypeError('Property `' + propFullName + '` of component `' + componentName + '` has invalid PropType notation inside objectOf.');
      }
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type ' + ('`' + propType + '` supplied to `' + componentName + '`, expected an object.'));
      }
      for (var key in propValue) {
        if (has$1(propValue, key)) {
          var error = typeChecker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
          if (error instanceof Error) {
            return error;
          }
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createUnionTypeChecker(arrayOfTypeCheckers) {
    if (!Array.isArray(arrayOfTypeCheckers)) {
      process.env.NODE_ENV !== 'production' ? printWarning$1('Invalid argument supplied to oneOfType, expected an instance of array.') : void 0;
      return emptyFunctionThatReturnsNull;
    }

    for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
      var checker = arrayOfTypeCheckers[i];
      if (typeof checker !== 'function') {
        printWarning$1(
          'Invalid argument supplied to oneOfType. Expected an array of check functions, but ' +
          'received ' + getPostfixForTypeWarning(checker) + ' at index ' + i + '.'
        );
        return emptyFunctionThatReturnsNull;
      }
    }

    function validate(props, propName, componentName, location, propFullName) {
      var expectedTypes = [];
      for (var i = 0; i < arrayOfTypeCheckers.length; i++) {
        var checker = arrayOfTypeCheckers[i];
        var checkerResult = checker(props, propName, componentName, location, propFullName, ReactPropTypesSecret$1);
        if (checkerResult == null) {
          return null;
        }
        if (checkerResult.data && has$1(checkerResult.data, 'expectedType')) {
          expectedTypes.push(checkerResult.data.expectedType);
        }
      }
      var expectedTypesMessage = (expectedTypes.length > 0) ? ', expected one of type [' + expectedTypes.join(', ') + ']': '';
      return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`' + expectedTypesMessage + '.'));
    }
    return createChainableTypeChecker(validate);
  }

  function createNodeChecker() {
    function validate(props, propName, componentName, location, propFullName) {
      if (!isNode(props[propName])) {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` supplied to ' + ('`' + componentName + '`, expected a ReactNode.'));
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function invalidValidatorError(componentName, location, propFullName, key, type) {
    return new PropTypeError(
      (componentName || 'React class') + ': ' + location + ' type `' + propFullName + '.' + key + '` is invalid; ' +
      'it must be a function, usually from the `prop-types` package, but received `' + type + '`.'
    );
  }

  function createShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      for (var key in shapeTypes) {
        var checker = shapeTypes[key];
        if (typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }
    return createChainableTypeChecker(validate);
  }

  function createStrictShapeTypeChecker(shapeTypes) {
    function validate(props, propName, componentName, location, propFullName) {
      var propValue = props[propName];
      var propType = getPropType(propValue);
      if (propType !== 'object') {
        return new PropTypeError('Invalid ' + location + ' `' + propFullName + '` of type `' + propType + '` ' + ('supplied to `' + componentName + '`, expected `object`.'));
      }
      // We need to check all keys in case some are required but missing from props.
      var allKeys = objectAssign({}, props[propName], shapeTypes);
      for (var key in allKeys) {
        var checker = shapeTypes[key];
        if (has$1(shapeTypes, key) && typeof checker !== 'function') {
          return invalidValidatorError(componentName, location, propFullName, key, getPreciseType(checker));
        }
        if (!checker) {
          return new PropTypeError(
            'Invalid ' + location + ' `' + propFullName + '` key `' + key + '` supplied to `' + componentName + '`.' +
            '\nBad object: ' + JSON.stringify(props[propName], null, '  ') +
            '\nValid keys: ' + JSON.stringify(Object.keys(shapeTypes), null, '  ')
          );
        }
        var error = checker(propValue, key, componentName, location, propFullName + '.' + key, ReactPropTypesSecret$1);
        if (error) {
          return error;
        }
      }
      return null;
    }

    return createChainableTypeChecker(validate);
  }

  function isNode(propValue) {
    switch (typeof propValue) {
      case 'number':
      case 'string':
      case 'undefined':
        return true;
      case 'boolean':
        return !propValue;
      case 'object':
        if (Array.isArray(propValue)) {
          return propValue.every(isNode);
        }
        if (propValue === null || isValidElement(propValue)) {
          return true;
        }

        var iteratorFn = getIteratorFn(propValue);
        if (iteratorFn) {
          var iterator = iteratorFn.call(propValue);
          var step;
          if (iteratorFn !== propValue.entries) {
            while (!(step = iterator.next()).done) {
              if (!isNode(step.value)) {
                return false;
              }
            }
          } else {
            // Iterator will provide entry [k,v] tuples rather than values.
            while (!(step = iterator.next()).done) {
              var entry = step.value;
              if (entry) {
                if (!isNode(entry[1])) {
                  return false;
                }
              }
            }
          }
        } else {
          return false;
        }

        return true;
      default:
        return false;
    }
  }

  function isSymbol(propType, propValue) {
    // Native Symbol.
    if (propType === 'symbol') {
      return true;
    }

    // falsy value can't be a Symbol
    if (!propValue) {
      return false;
    }

    // 19.4.3.5 Symbol.prototype[@@toStringTag] === 'Symbol'
    if (propValue['@@toStringTag'] === 'Symbol') {
      return true;
    }

    // Fallback for non-spec compliant Symbols which are polyfilled.
    if (typeof Symbol === 'function' && propValue instanceof Symbol) {
      return true;
    }

    return false;
  }

  // Equivalent of `typeof` but with special handling for array and regexp.
  function getPropType(propValue) {
    var propType = typeof propValue;
    if (Array.isArray(propValue)) {
      return 'array';
    }
    if (propValue instanceof RegExp) {
      // Old webkits (at least until Android 4.0) return 'function' rather than
      // 'object' for typeof a RegExp. We'll normalize this here so that /bla/
      // passes PropTypes.object.
      return 'object';
    }
    if (isSymbol(propType, propValue)) {
      return 'symbol';
    }
    return propType;
  }

  // This handles more types than `getPropType`. Only used for error messages.
  // See `createPrimitiveTypeChecker`.
  function getPreciseType(propValue) {
    if (typeof propValue === 'undefined' || propValue === null) {
      return '' + propValue;
    }
    var propType = getPropType(propValue);
    if (propType === 'object') {
      if (propValue instanceof Date) {
        return 'date';
      } else if (propValue instanceof RegExp) {
        return 'regexp';
      }
    }
    return propType;
  }

  // Returns a string that is postfixed to a warning about an invalid type.
  // For example, "undefined" or "of type array"
  function getPostfixForTypeWarning(value) {
    var type = getPreciseType(value);
    switch (type) {
      case 'array':
      case 'object':
        return 'an ' + type;
      case 'boolean':
      case 'date':
      case 'regexp':
        return 'a ' + type;
      default:
        return type;
    }
  }

  // Returns class name of the object, if any.
  function getClassName(propValue) {
    if (!propValue.constructor || !propValue.constructor.name) {
      return ANONYMOUS;
    }
    return propValue.constructor.name;
  }

  ReactPropTypes.checkPropTypes = checkPropTypes;
  ReactPropTypes.resetWarningCache = checkPropTypes.resetWarningCache;
  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

function emptyFunction() {}
function emptyFunctionWithReset() {}
emptyFunctionWithReset.resetWarningCache = emptyFunction;

var factoryWithThrowingShims = function() {
  function shim(props, propName, componentName, location, propFullName, secret) {
    if (secret === ReactPropTypesSecret$1) {
      // It is still safe when called from React.
      return;
    }
    var err = new Error(
      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
      'Use PropTypes.checkPropTypes() to call them. ' +
      'Read more at http://fb.me/use-check-prop-types'
    );
    err.name = 'Invariant Violation';
    throw err;
  }  shim.isRequired = shim;
  function getShim() {
    return shim;
  }  // Important!
  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
  var ReactPropTypes = {
    array: shim,
    bigint: shim,
    bool: shim,
    func: shim,
    number: shim,
    object: shim,
    string: shim,
    symbol: shim,

    any: shim,
    arrayOf: getShim,
    element: shim,
    elementType: shim,
    instanceOf: getShim,
    node: shim,
    objectOf: getShim,
    oneOf: getShim,
    oneOfType: getShim,
    shape: getShim,
    exact: getShim,

    checkPropTypes: emptyFunctionWithReset,
    resetWarningCache: emptyFunction
  };

  ReactPropTypes.PropTypes = ReactPropTypes;

  return ReactPropTypes;
};

var require$$1$6 = factoryWithTypeCheckers;

var require$$2$2 = factoryWithThrowingShims;

var propTypes = createCommonjsModule(function (module) {
/**
 * Copyright (c) 2013-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

if (process.env.NODE_ENV !== 'production') {
  var ReactIs = reactIs$1;

  // By explicitly using `prop-types` you are opting into new development behavior.
  // http://fb.me/prop-types-in-prod
  var throwOnDirectAccess = true;
  module.exports = require$$1$6(ReactIs.isElement, throwOnDirectAccess);
} else {
  // By explicitly using `prop-types` you are opting into new production behavior.
  // http://fb.me/prop-types-in-prod
  module.exports = require$$2$2();
}
});

var PropTypes = propTypes;

function _classCallCheck$1(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _defineProperties$1(target, props) {
  for (var i = 0; i < props.length; i++) {
    var descriptor = props[i];
    descriptor.enumerable = descriptor.enumerable || false;
    descriptor.configurable = true;
    if ("value" in descriptor) descriptor.writable = true;
    Object.defineProperty(target, descriptor.key, descriptor);
  }
}

function _createClass$1(Constructor, protoProps, staticProps) {
  if (protoProps) _defineProperties$1(Constructor.prototype, protoProps);
  if (staticProps) _defineProperties$1(Constructor, staticProps);
  return Constructor;
}

function _inherits$1(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function");
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      writable: true,
      configurable: true
    }
  });
  if (superClass) _setPrototypeOf$1(subClass, superClass);
}

function _getPrototypeOf(o) {
  _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
    return o.__proto__ || Object.getPrototypeOf(o);
  };
  return _getPrototypeOf(o);
}

function _setPrototypeOf$1(o, p) {
  _setPrototypeOf$1 = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf$1(o, p);
}

function _isNativeReflectConstruct() {
  if (typeof Reflect === "undefined" || !Reflect.construct) return false;
  if (Reflect.construct.sham) return false;
  if (typeof Proxy === "function") return true;

  try {
    Date.prototype.toString.call(Reflect.construct(Date, [], function () {}));
    return true;
  } catch (e) {
    return false;
  }
}

function _objectWithoutPropertiesLoose$3(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _objectWithoutProperties$2(source, excluded) {
  if (source == null) return {};

  var target = _objectWithoutPropertiesLoose$3(source, excluded);

  var key, i;

  if (Object.getOwnPropertySymbols) {
    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);

    for (i = 0; i < sourceSymbolKeys.length; i++) {
      key = sourceSymbolKeys[i];
      if (excluded.indexOf(key) >= 0) continue;
      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
      target[key] = source[key];
    }
  }

  return target;
}

function _assertThisInitialized$1(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}

function _possibleConstructorReturn$1(self, call) {
  if (call && (typeof call === "object" || typeof call === "function")) {
    return call;
  }

  return _assertThisInitialized$1(self);
}

function _createSuper$1(Derived) {
  var hasNativeReflectConstruct = _isNativeReflectConstruct();

  return function _createSuperInternal() {
    var Super = _getPrototypeOf(Derived),
        result;

    if (hasNativeReflectConstruct) {
      var NewTarget = _getPrototypeOf(this).constructor;

      result = Reflect.construct(Super, arguments, NewTarget);
    } else {
      result = Super.apply(this, arguments);
    }

    return _possibleConstructorReturn$1(this, result);
  };
}

var MASK_PROPS = {
  // common
  mask: PropTypes.oneOfType([PropTypes.array, PropTypes.func, PropTypes.string, PropTypes.instanceOf(RegExp), PropTypes.oneOf([Date, Number, IMask.Masked]), PropTypes.instanceOf(IMask.Masked)]),
  value: PropTypes.any,
  unmask: PropTypes.oneOfType([PropTypes.bool, PropTypes.oneOf(['typed'])]),
  prepare: PropTypes.func,
  validate: PropTypes.func,
  commit: PropTypes.func,
  overwrite: PropTypes.bool,
  // events
  onAccept: PropTypes.func,
  onComplete: PropTypes.func,
  // pattern
  placeholderChar: PropTypes.string,
  lazy: PropTypes.bool,
  definitions: PropTypes.object,
  blocks: PropTypes.object,
  // date
  pattern: PropTypes.string,
  format: PropTypes.func,
  parse: PropTypes.func,
  autofix: PropTypes.bool,
  // number
  radix: PropTypes.string,
  thousandsSeparator: PropTypes.string,
  mapToRadix: PropTypes.arrayOf(PropTypes.string),
  scale: PropTypes.number,
  signed: PropTypes.bool,
  normalizeZeros: PropTypes.bool,
  padFractionalZeros: PropTypes.bool,
  min: PropTypes.oneOfType([PropTypes.number, PropTypes.instanceOf(Date)]),
  max: PropTypes.oneOfType([PropTypes.number, PropTypes.instanceOf(Date)]),
  // dynamic
  dispatch: PropTypes.func,
  // ref
  inputRef: PropTypes.func
};
var MASK_PROPS_NAMES = Object.keys(MASK_PROPS);
var NON_MASK_OPTIONS_PROPS_NAMES = ['value', 'unmask', 'onAccept', 'onComplete', 'inputRef'];
var MASK_OPTIONS_PROPS_NAMES = MASK_PROPS_NAMES.filter(function (pName) {
  return NON_MASK_OPTIONS_PROPS_NAMES.indexOf(pName) < 0;
});
function IMaskMixin(ComposedComponent) {
  var MaskedComponent = /*#__PURE__*/function (_React$Component) {
    _inherits$1(MaskedComponent, _React$Component);

    var _super = _createSuper$1(MaskedComponent);

    function MaskedComponent() {
      var _this;

      _classCallCheck$1(this, MaskedComponent);

      for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
        args[_key] = arguments[_key];
      }

      _this = _super.call.apply(_super, [this].concat(args));
      _this._inputRef = _this._inputRef.bind(_assertThisInitialized$1(_this));
      return _this;
    }

    _createClass$1(MaskedComponent, [{
      key: "componentDidMount",
      value: function componentDidMount() {
        if (!this.props.mask) return;
        this.initMask();
      }
    }, {
      key: "componentDidUpdate",
      value: function componentDidUpdate() {
        var props = this.props;

        var maskOptions = this._extractMaskOptionsFromProps(props);

        if (maskOptions.mask) {
          if (this.maskRef) {
            this.maskRef.updateOptions(maskOptions);

            if ('value' in props && (props.value !== this.maskValue || // handle cases like Number('') === 0,
            // for details see https://github.com/uNmAnNeR/imaskjs/issues/134
            typeof props.value !== 'string' && this.maskRef.value === '' && !this.maskRef.el.isActive)) {
              this.maskValue = props.value;
            }
          } else {
            this.initMask(maskOptions);
            if (props.value !== this.maskValue) this._onAccept();
          }
        } else {
          this.destroyMask();
          if ('value' in props) this.element.value = props.value;
        }
      }
    }, {
      key: "componentWillUnmount",
      value: function componentWillUnmount() {
        this.destroyMask();
      }
    }, {
      key: "_inputRef",
      value: function _inputRef(el) {
        this.element = el;
        if (this.props.inputRef) this.props.inputRef(el);
      }
    }, {
      key: "render",
      value: function render() {
        return React__default.createElement(ComposedComponent, Object.assign({}, this._extractNonMaskProps(this.props), {
          defaultValue: this.props.value,
          inputRef: this._inputRef
        }));
      }
    }, {
      key: "initMask",
      value: function initMask() {
        var maskOptions = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : this._extractMaskOptionsFromProps(Object.assign({}, this.props));
        this.maskRef = IMask(this.element, maskOptions).on('accept', this._onAccept.bind(this)).on('complete', this._onComplete.bind(this));
        this.maskValue = this.props.value;
      }
    }, {
      key: "destroyMask",
      value: function destroyMask() {
        if (this.maskRef) {
          this.maskRef.destroy();
          delete this.maskRef;
        }
      }
    }, {
      key: "_extractMaskOptionsFromProps",
      value: function _extractMaskOptionsFromProps(props) {
        props = Object.assign({}, props); // keep only mask options props

        Object.keys(props).filter(function (prop) {
          return MASK_OPTIONS_PROPS_NAMES.indexOf(prop) < 0;
        }).forEach(function (nonMaskProp) {
          delete props[nonMaskProp];
        });
        return props;
      }
    }, {
      key: "_extractNonMaskProps",
      value: function _extractNonMaskProps(props) {
        props = Object.assign({}, props);
        MASK_PROPS_NAMES.forEach(function (maskProp) {
          delete props[maskProp];
        });
        return props;
      }
    }, {
      key: "maskValue",
      get: function get() {
        if (this.props.unmask === 'typed') return this.maskRef.typedValue;
        if (this.props.unmask) return this.maskRef.unmaskedValue;
        return this.maskRef.value;
      },
      set: function set(value) {
        value = value == null ? '' : value;
        if (this.props.unmask === 'typed') this.maskRef.typedValue = value;else if (this.props.unmask) this.maskRef.unmaskedValue = value;else this.maskRef.value = value;
      }
    }, {
      key: "_onAccept",
      value: function _onAccept() {
        var _this$props;

        for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
          args[_key2] = arguments[_key2];
        }

        if (this.props.onAccept) (_this$props = this.props).onAccept.apply(_this$props, [this.maskValue, this.maskRef].concat(args));
      }
    }, {
      key: "_onComplete",
      value: function _onComplete() {
        var _this$props2;

        for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
          args[_key3] = arguments[_key3];
        }

        if (this.props.onComplete) (_this$props2 = this.props).onComplete.apply(_this$props2, [this.maskValue, this.maskRef].concat(args));
      }
    }]);

    return MaskedComponent;
  }(React__default.Component);

  MaskedComponent.propTypes = MASK_PROPS;
  var nestedComponentName = ComposedComponent.displayName || ComposedComponent.name || 'Component';
  MaskedComponent.displayName = "IMask(".concat(nestedComponentName, ")");
  return MaskedComponent;
}

var InputComponent = function InputComponent(_ref) {
  var inputRef = _ref.inputRef,
      props = _objectWithoutProperties$2(_ref, ["inputRef"]);

  return React__default.createElement('input', Object.assign({}, props, {
    ref: inputRef
  }));
};

IMaskMixin(InputComponent);

var currencyFormatter = function (props) {
    var value = props.value, zeroAllowed = props.zeroAllowed, prefix = props.prefix;
    if (!zeroAllowed && !value) {
        return '';
    }
    var currentValue = !Number(value) ? 0 : value;
    var amount = new Intl.NumberFormat('pt-BR', {
        style: prefix ? 'currency' : 'decimal',
        minimumFractionDigits: 2,
        currency: 'BRL',
    }).format(currentValue / 100);
    return "" + amount;
};

var InputMasked = IMaskMixin(function (_a) {
    var inputRef = _a.inputRef, value = _a.value, defaultValue = _a.defaultValue, type = _a.type, otherProps = __rest(_a, ["inputRef", "value", "defaultValue", "type"]);
    return (React__default.createElement(Input$1, __assign$2({ type: type || 'text' }, otherProps, { ref: inputRef, value: value || defaultValue })));
});
var InputMaskCurrency = memo(forwardRef(function (props, ref) {
    var onChange = props.onChange, negativeAllowed = props.negativeAllowed, zeroAllowed = props.zeroAllowed, value = props.value, _a = props.enablePrefix, enablePrefix = _a === void 0 ? false : _a, otherProps = __rest(props, ["onChange", "negativeAllowed", "zeroAllowed", "value", "enablePrefix"]);
    var _b = useState(''), valueDisplay = _b[0], setValueDisplay = _b[1];
    var negativeDecimalRegex = /[^0-9-]/g;
    var decimalRegex = /\D+/g;
    var regex = negativeAllowed ? negativeDecimalRegex : decimalRegex;
    var normalizedValue = function (valueToNormalize) { return Number(valueToNormalize.replace(regex, '')); };
    var getCharPosition = function (string, findChar) { return string.indexOf(findChar) + 1; };
    var handleChange = function (event) {
        event.persist();
        var inputValue = event.target.value;
        var formattedValue = function () {
            var formatted = inputValue;
            if (getCharPosition(formatted, '-') > 0) {
                formatted = "-" + inputValue.replace(/-/gi, '');
            }
            if (getCharPosition(formatted, '+') > 0) {
                formatted = inputValue.replace(/-/gi, '');
            }
            return formatted;
        };
        var normalized = normalizedValue(formattedValue());
        var parseValue = normalized / 100;
        var currencyData = {
            value: normalized,
            zeroAllowed: zeroAllowed,
            prefix: enablePrefix,
        };
        if (Object.is(normalized, -0) || Number.isNaN(normalized)) {
            setValueDisplay('-');
        }
        else {
            setValueDisplay(currencyFormatter(currencyData));
        }
        if (onChange) {
            onChange(parseValue);
        }
    };
    var handleBlur = function (event) {
        if (event.target.value === '-') {
            setValueDisplay('0,00');
            if (onChange) {
                onChange(0);
            }
        }
    };
    useEffect(function () {
        if (value !== undefined) {
            var valueWithRadix = Number(value) * 100;
            var currencyData = {
                value: valueWithRadix,
                zeroAllowed: zeroAllowed,
                prefix: enablePrefix,
            };
            setValueDisplay(currencyFormatter(currencyData));
        }
    }, [value]);
    return React__default.createElement(Input$1, __assign$2({ type: "text", value: valueDisplay, onChange: handleChange, onBlur: handleBlur, ref: ref }, otherProps));
}));
var InputMask = function (props, ref) {
    var isCurrency = props.isCurrency;
    if (isCurrency) {
        return React__default.createElement(InputMaskCurrency, __assign$2({}, props, { ref: ref }));
    }
    return React__default.createElement(InputMasked, __assign$2({}, props, { ref: ref }));
};
var InputMask$1 = forwardRef(InputMask);

var tagSizes = function (size, gutterSpace, variant) {
    if (size === void 0) { size = 'small'; }
    var subtractOutlined = variant === 'outlined' ? 1 : 0;
    var sizes = {
        small: css(templateObject_1$t || (templateObject_1$t = __makeTemplateObject(["\n      padding: ", "px ", "px;\n      font-size: ", ";\n      border-radius: ", "px;\n    "], ["\n      padding: ", "px ", "px;\n      font-size: ", ";\n      border-radius: ", "px;\n    "])), gutterSpace / 8, gutterSpace / 2, theme.fontSizes[1], function (props) { return props.theme.global.gutterSpace / 4; }),
        medium: css(templateObject_2$q || (templateObject_2$q = __makeTemplateObject(["\n      padding: ", "px ", "px;\n      font-size: ", ";\n      border-radius: ", "px;\n\n      && {\n        ", " {\n          svg {\n            flex: 0 0 16px;\n            min-width: 16px;\n            width: 16px;\n            height: 16px;\n          }\n        }\n      }\n    "], ["\n      padding: ", "px ", "px;\n      font-size: ", ";\n      border-radius: ", "px;\n\n      && {\n        ", " {\n          svg {\n            flex: 0 0 16px;\n            min-width: 16px;\n            width: 16px;\n            height: 16px;\n          }\n        }\n      }\n    "])), gutterSpace / 4 - subtractOutlined, gutterSpace * 0.75 - subtractOutlined, theme.fontSizes[2], function (props) { return props.theme.global.gutterSpace * 0.375; }, ButtonClose),
        large: css(templateObject_3$p || (templateObject_3$p = __makeTemplateObject(["\n      padding: ", "px ", "px;\n      font-size: ", ";\n      border-radius: ", "px;\n      line-height: 15px;\n      && {\n        ", " {\n          svg {\n            flex: 0 0 20px;\n            min-width: 20px;\n            width: 20px;\n            height: 20px;\n          }\n        }\n      }\n    "], ["\n      padding: ", "px ", "px;\n      font-size: ", ";\n      border-radius: ", "px;\n      line-height: 15px;\n      && {\n        ", " {\n          svg {\n            flex: 0 0 20px;\n            min-width: 20px;\n            width: 20px;\n            height: 20px;\n          }\n        }\n      }\n    "])), gutterSpace / 2 - subtractOutlined, gutterSpace - subtractOutlined, theme.fontSizes[3], function (props) { return props.theme.global.gutterSpace / 2; }, ButtonClose),
    };
    return sizes[size];
};
var tagColors = function (type, variant) {
    if (variant === void 0) { variant = 'light'; }
    var textColor = (variant === 'link' && theme.behavior['information'].primary) || variant === 'dark' || variant === 'medium'
        ? theme.behavior[type || 'default'].secondary
        : theme.behavior[type || 'default'].primary;
    var backgroundColor = (variant === 'dark' && theme.behavior[type || 'default'].primary) ||
        (variant === 'medium' && theme.behavior[type || 'default'].tertiary) ||
        (variant === 'light' && theme.behavior[type || 'default'].secondary) ||
        (variant === 'link' && theme.behavior['default'].secondary);
    return css(templateObject_4$n || (templateObject_4$n = __makeTemplateObject(["\n    background-color: ", ";\n    color: ", ";\n  "], ["\n    background-color: ", ";\n    color: ", ";\n  "])), backgroundColor, textColor);
};
var ButtonClose = styled.button(templateObject_5$k || (templateObject_5$k = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: fit-content;\n  width: 100%;\n  padding: 0;\n  border: none;\n  background: transparent;\n  outline: none;\n  margin-left: ", "px;\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  height: fit-content;\n  width: 100%;\n  padding: 0;\n  border: none;\n  background: transparent;\n  outline: none;\n  margin-left: ", "px;\n"])), function (props) { return props.theme.global.gutterSpace / 2; });
var TagContainer = styled.div(templateObject_7$j || (templateObject_7$j = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: fit-content;\n  white-space: nowrap;\n  font-weight: normal;\n  line-height: 14px;\n  ", "\n  ", ";\n\n  ", " {\n    margin-left: ", "px;\n\n    svg {\n      fill: ", ";\n      ", "\n    }\n  }\n\n  a {\n    color: ", ";\n    text-decoration: none;\n    &:visited {\n      color: ", ";\n    }\n\n    &:hover {\n      color: ", ";\n    }\n\n    &:active {\n      color: ", ";\n    }\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: fit-content;\n  white-space: nowrap;\n  font-weight: normal;\n  line-height: 14px;\n  ", "\n  ", ";\n\n  ", " {\n    margin-left: ", "px;\n\n    svg {\n      fill: ", ";\n      ",
    "\n    }\n  }\n\n  a {\n    color: ", ";\n    text-decoration: none;\n    &:visited {\n      color: ", ";\n    }\n\n    &:hover {\n      color: ", ";\n    }\n\n    &:active {\n      color: ", ";\n    }\n  }\n"])), function (props) { return tagSizes(props.size, props.theme.global.gutterSpace, props.variant); }, function (props) { return tagColors(props.type, props.variant); }, ButtonClose, function (props) { return props.theme.global.gutterSpace / 2; }, function (props) { return props.theme.colors.grey700; }, function (props) {
    return (props.variant === 'dark' || props.variant === 'medium') && css(templateObject_6$j || (templateObject_6$j = __makeTemplateObject(["\n          fill: ", ";\n        "], ["\n          fill: ", ";\n        "])), props.theme.colors.white);
}, function (props) { return props.theme.colors.blue700; }, function (props) { return props.theme.colors.blue700; }, function (props) { return props.theme.colors.blue700; }, function (props) { return props.theme.colors.blue700; });
var templateObject_1$t, templateObject_2$q, templateObject_3$p, templateObject_4$n, templateObject_5$k, templateObject_6$j, templateObject_7$j;

var IconClose$1 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path  d=\"M13.41,12l4.3-4.29a1,1,0,1,0-1.42-1.42L12,10.59,7.71,6.29A1,1,0,0,0,6.29,7.71L10.59,12l-4.3,4.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l4.29,4.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42Z\"/></svg>";

var Tag = function (props) {
    var children = props.children, type = props.type, isRemovable = props.isRemovable, onClose = props.onClose, testId = props.testId, size = props.size, className = props.className, variant = props.variant, isOpenExternal = props.isOpen;
    var _a = useState(true), isOpen = _a[0], setIsOpen = _a[1];
    var childrenWithNode = Children.map(children, function (child) {
        if (typeof child === 'string') {
            return React__default.createElement("span", null, child);
        }
        return child;
    });
    var handleSetIsOpen = function (e) {
        if (onClose) {
            return onClose(e);
        }
        setIsOpen(!isOpen);
    };
    var isOpenTag = onClose ? isOpenExternal : isOpen;
    if (isOpenTag) {
        return (React__default.createElement(TagContainer, { type: type || 'default', "data-testid": testId, className: className, size: size || 'small', variant: variant || 'light' },
            childrenWithNode,
            isRemovable && (React__default.createElement(ButtonClose, { onClick: handleSetIsOpen, type: "button" },
                React__default.createElement(SvgIcon, { src: IconClose$1, width: 12, height: 12 })))));
    }
    return null;
};

var useFilter = function (props) {
    var handleFilter = props.handleFilter, debounceDelay = props.debounceDelay, _a = props.mode, mode = _a === void 0 ? 'onSubmit' : _a;
    var filterParams = useRef({});
    var isModeOnChange = mode === 'onChange';
    var doChange = function (event) {
        var _a;
        var _b = event.target, name = _b.name, value = _b.value;
        filterParams.current = __assign$2(__assign$2({}, filterParams.current), (_a = {}, _a[name] = value, _a));
        return isModeOnChange && handleFilter(filterParams.current);
    };
    var debounceCallback = useDebouncedCallback(function (event) {
        doChange(event);
    }, debounceDelay || 500)[0];
    var debouncedChange = function (event) {
        event.persist();
        debounceCallback(event);
    };
    var handleSubmitFilters = function () { return handleFilter(filterParams.current); };
    return { doChange: doChange, debouncedChange: debouncedChange, filterParams: filterParams, handleSubmitFilters: handleSubmitFilters };
};

/**
 * TODO(v7): Remove this enum and replace with SeverityLevel
 */
var Severity;
(function (Severity) {
    /** JSDoc */
    Severity["Fatal"] = "fatal";
    /** JSDoc */
    Severity["Error"] = "error";
    /** JSDoc */
    Severity["Warning"] = "warning";
    /** JSDoc */
    Severity["Log"] = "log";
    /** JSDoc */
    Severity["Info"] = "info";
    /** JSDoc */
    Severity["Debug"] = "debug";
    /** JSDoc */
    Severity["Critical"] = "critical";
})(Severity || (Severity = {}));

/**
 * Consumes the promise and logs the error when it rejects.
 * @param promise A promise to forget.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function forget(promise) {
    void promise.then(null, function (e) {
        // TODO: Use a better logging mechanism
        // eslint-disable-next-line no-console
        console.error(e);
    });
}

/*
 * This module exists for optimizations in the build process through rollup and terser.  We define some global
 * constants, which can be overridden during build. By guarding certain pieces of code with functions that return these
 * constants, we can control whether or not they appear in the final bundle. (Any code guarded by a false condition will
 * never run, and will hence be dropped during treeshaking.) The two primary uses for this are stripping out calls to
 * `logger` and preventing node-related code from appearing in browser bundles.
 *
 * Attention:
 * This file should not be used to define constants/flags that are intended to be used for tree-shaking conducted by
 * users. These fags should live in their respective packages, as we identified user tooling (specifically webpack)
 * having issues tree-shaking these constants across package boundaries.
 * An example for this is the __SENTRY_DEBUG__ constant. It is declared in each package individually because we want
 * users to be able to shake away expressions that it guards.
 */
/**
 * Figures out if we're building a browser bundle.
 *
 * @returns true if this is a browser bundle build.
 */
function isBrowserBundle() {
    return typeof __SENTRY_BROWSER_BUNDLE__ !== 'undefined' && !!__SENTRY_BROWSER_BUNDLE__;
}

/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */
/**
 * Checks whether we're in the Node.js or Browser environment
 *
 * @returns Answer to given question
 */
function isNodeEnv() {
    // explicitly check for browser bundles as those can be optimized statically
    // by terser/rollup.
    return (!isBrowserBundle() &&
        Object.prototype.toString.call(typeof process !== 'undefined' ? process : 0) === '[object process]');
}
/**
 * Requires a module which is protected against bundler minification.
 *
 * @param request The module path to resolve
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types, @typescript-eslint/no-explicit-any
function dynamicRequire(mod, request) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return mod.require(request);
}
/**
 * Helper for dynamically loading module that should work with linked dependencies.
 * The problem is that we _should_ be using `require(require.resolve(moduleName, { paths: [cwd()] }))`
 * However it's _not possible_ to do that with Webpack, as it has to know all the dependencies during
 * build time. `require.resolve` is also not available in any other way, so we cannot create,
 * a fake helper like we do with `dynamicRequire`.
 *
 * We always prefer to use local package, thus the value is not returned early from each `try/catch` block.
 * That is to mimic the behavior of `require.resolve` exactly.
 *
 * @param moduleName module name to require
 * @returns possibly required module
 */
function loadModule(moduleName) {
    var mod;
    try {
        mod = dynamicRequire(module, moduleName);
    }
    catch (e) {
        // no-empty
    }
    try {
        var cwd = dynamicRequire(module, 'process').cwd;
        mod = dynamicRequire(module, cwd() + "/node_modules/" + moduleName);
    }
    catch (e) {
        // no-empty
    }
    return mod;
}

/**
 * NOTE: In order to avoid circular dependencies, if you add a function to this module and it needs to print something,
 * you must either a) use `console.log` rather than the logger, or b) put your function elsewhere.
 */
var fallbackGlobalObject = {};
/**
 * Safely get global scope object
 *
 * @returns Global scope object
 */
function getGlobalObject() {
    return (isNodeEnv()
        ? global
        : typeof window !== 'undefined' // eslint-disable-line no-restricted-globals
            ? window // eslint-disable-line no-restricted-globals
            : typeof self !== 'undefined'
                ? self
                : fallbackGlobalObject);
}
/**
 * Returns a global singleton contained in the global `__SENTRY__` object.
 *
 * If the singleton doesn't already exist in `__SENTRY__`, it will be created using the given factory
 * function and added to the `__SENTRY__` object.
 *
 * @param name name of the global singleton on __SENTRY__
 * @param creator creator Factory function to create the singleton if it doesn't already exist on `__SENTRY__`
 * @param obj (Optional) The global object on which to look for `__SENTRY__`, if not `getGlobalObject`'s return value
 * @returns the singleton
 */
function getGlobalSingleton(name, creator, obj) {
    var global = (obj || getGlobalObject());
    var __SENTRY__ = (global.__SENTRY__ = global.__SENTRY__ || {});
    var singleton = __SENTRY__[name] || (__SENTRY__[name] = creator());
    return singleton;
}

/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
// eslint-disable-next-line @typescript-eslint/unbound-method
var objectToString = Object.prototype.toString;
/**
 * Checks whether given value's type is one of a few Error or Error-like
 * {@link isError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isError(wat) {
    switch (objectToString.call(wat)) {
        case '[object Error]':
        case '[object Exception]':
        case '[object DOMException]':
            return true;
        default:
            return isInstanceOf(wat, Error);
    }
}
function isBuiltin(wat, ty) {
    return objectToString.call(wat) === "[object " + ty + "]";
}
/**
 * Checks whether given value's type is ErrorEvent
 * {@link isErrorEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isErrorEvent(wat) {
    return isBuiltin(wat, 'ErrorEvent');
}
/**
 * Checks whether given value's type is DOMError
 * {@link isDOMError}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMError(wat) {
    return isBuiltin(wat, 'DOMError');
}
/**
 * Checks whether given value's type is DOMException
 * {@link isDOMException}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isDOMException(wat) {
    return isBuiltin(wat, 'DOMException');
}
/**
 * Checks whether given value's type is a string
 * {@link isString}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isString(wat) {
    return isBuiltin(wat, 'String');
}
/**
 * Checks whether given value is a primitive (undefined, null, number, boolean, string, bigint, symbol)
 * {@link isPrimitive}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPrimitive(wat) {
    return wat === null || (typeof wat !== 'object' && typeof wat !== 'function');
}
/**
 * Checks whether given value's type is an object literal
 * {@link isPlainObject}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isPlainObject(wat) {
    return isBuiltin(wat, 'Object');
}
/**
 * Checks whether given value's type is an Event instance
 * {@link isEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isEvent(wat) {
    return typeof Event !== 'undefined' && isInstanceOf(wat, Event);
}
/**
 * Checks whether given value's type is an Element instance
 * {@link isElement}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isElement$2(wat) {
    return typeof Element !== 'undefined' && isInstanceOf(wat, Element);
}
/**
 * Checks whether given value's type is an regexp
 * {@link isRegExp}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isRegExp(wat) {
    return isBuiltin(wat, 'RegExp');
}
/**
 * Checks whether given value has a then function.
 * @param wat A value to be checked.
 */
function isThenable(wat) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    return Boolean(wat && wat.then && typeof wat.then === 'function');
}
/**
 * Checks whether given value's type is a SyntheticEvent
 * {@link isSyntheticEvent}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isSyntheticEvent(wat) {
    return isPlainObject(wat) && 'nativeEvent' in wat && 'preventDefault' in wat && 'stopPropagation' in wat;
}
/**
 * Checks whether given value is NaN
 * {@link isNaN}.
 *
 * @param wat A value to be checked.
 * @returns A boolean representing the result.
 */
function isNaN$1(wat) {
    return typeof wat === 'number' && wat !== wat;
}
/**
 * Checks whether given value's type is an instance of provided constructor.
 * {@link isInstanceOf}.
 *
 * @param wat A value to be checked.
 * @param base A constructor to be used in a check.
 * @returns A boolean representing the result.
 */
function isInstanceOf(wat, base) {
    try {
        return wat instanceof base;
    }
    catch (_e) {
        return false;
    }
}

/**
 * Given a child DOM element, returns a query-selector statement describing that
 * and its ancestors
 * e.g. [HTMLElement] => body > div > input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function htmlTreeAsString(elem, keyAttrs) {
    // try/catch both:
    // - accessing event.target (see getsentry/raven-js#838, #768)
    // - `htmlTreeAsString` because it's complex, and just accessing the DOM incorrectly
    // - can throw an exception in some circumstances.
    try {
        var currentElem = elem;
        var MAX_TRAVERSE_HEIGHT = 5;
        var MAX_OUTPUT_LEN = 80;
        var out = [];
        var height = 0;
        var len = 0;
        var separator = ' > ';
        var sepLength = separator.length;
        var nextStr = void 0;
        // eslint-disable-next-line no-plusplus
        while (currentElem && height++ < MAX_TRAVERSE_HEIGHT) {
            nextStr = _htmlElementAsString(currentElem, keyAttrs);
            // bail out if
            // - nextStr is the 'html' element
            // - the length of the string that would be created exceeds MAX_OUTPUT_LEN
            //   (ignore this limit if we are on the first iteration)
            if (nextStr === 'html' || (height > 1 && len + out.length * sepLength + nextStr.length >= MAX_OUTPUT_LEN)) {
                break;
            }
            out.push(nextStr);
            len += nextStr.length;
            currentElem = currentElem.parentNode;
        }
        return out.reverse().join(separator);
    }
    catch (_oO) {
        return '<unknown>';
    }
}
/**
 * Returns a simple, query-selector representation of a DOM element
 * e.g. [HTMLElement] => input#foo.btn[name=baz]
 * @returns generated DOM path
 */
function _htmlElementAsString(el, keyAttrs) {
    var elem = el;
    var out = [];
    var className;
    var classes;
    var key;
    var attr;
    var i;
    if (!elem || !elem.tagName) {
        return '';
    }
    out.push(elem.tagName.toLowerCase());
    // Pairs of attribute keys defined in `serializeAttribute` and their values on element.
    var keyAttrPairs = keyAttrs && keyAttrs.length
        ? keyAttrs.filter(function (keyAttr) { return elem.getAttribute(keyAttr); }).map(function (keyAttr) { return [keyAttr, elem.getAttribute(keyAttr)]; })
        : null;
    if (keyAttrPairs && keyAttrPairs.length) {
        keyAttrPairs.forEach(function (keyAttrPair) {
            out.push("[" + keyAttrPair[0] + "=\"" + keyAttrPair[1] + "\"]");
        });
    }
    else {
        if (elem.id) {
            out.push("#" + elem.id);
        }
        // eslint-disable-next-line prefer-const
        className = elem.className;
        if (className && isString(className)) {
            classes = className.split(/\s+/);
            for (i = 0; i < classes.length; i++) {
                out.push("." + classes[i]);
            }
        }
    }
    var allowedAttrs = ['type', 'name', 'title', 'alt'];
    for (i = 0; i < allowedAttrs.length; i++) {
        key = allowedAttrs[i];
        attr = elem.getAttribute(key);
        if (attr) {
            out.push("[" + key + "=\"" + attr + "\"]");
        }
    }
    return out.join('');
}
/**
 * A safe form of location.href
 */
function getLocationHref() {
    var global = getGlobalObject();
    try {
        return global.document.location.href;
    }
    catch (oO) {
        return '';
    }
}

var setPrototypeOf = Object.setPrototypeOf || ({ __proto__: [] } instanceof Array ? setProtoOf : mixinProperties);
/**
 * setPrototypeOf polyfill using __proto__
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function setProtoOf(obj, proto) {
    // @ts-ignore __proto__ does not exist on obj
    obj.__proto__ = proto;
    return obj;
}
/**
 * setPrototypeOf polyfill using mixin
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function mixinProperties(obj, proto) {
    for (var prop in proto) {
        if (!Object.prototype.hasOwnProperty.call(obj, prop)) {
            // @ts-ignore typescript complains about indexing so we remove
            obj[prop] = proto[prop];
        }
    }
    return obj;
}

/** An error emitted by Sentry SDKs and related utilities. */
var SentryError = /** @class */ (function (_super) {
    __extends$1(SentryError, _super);
    function SentryError(message) {
        var _newTarget = this.constructor;
        var _this = _super.call(this, message) || this;
        _this.message = message;
        _this.name = _newTarget.prototype.constructor.name;
        setPrototypeOf(_this, _newTarget.prototype);
        return _this;
    }
    return SentryError;
}(Error));

/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */
/** Flag that is true for debug builds, false otherwise. */
var IS_DEBUG_BUILD$4 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

/** Regular expression used to parse a Dsn. */
var DSN_REGEX = /^(?:(\w+):)\/\/(?:(\w+)(?::(\w+))?@)([\w.-]+)(?::(\d+))?\/(.+)/;
function isValidProtocol(protocol) {
    return protocol === 'http' || protocol === 'https';
}
/**
 * Renders the string representation of this Dsn.
 *
 * By default, this will render the public representation without the password
 * component. To get the deprecated private representation, set `withPassword`
 * to true.
 *
 * @param withPassword When set to true, the password will be included.
 */
function dsnToString(dsn, withPassword) {
    if (withPassword === void 0) { withPassword = false; }
    var host = dsn.host, path = dsn.path, pass = dsn.pass, port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol, publicKey = dsn.publicKey;
    return (protocol + "://" + publicKey + (withPassword && pass ? ":" + pass : '') +
        ("@" + host + (port ? ":" + port : '') + "/" + (path ? path + "/" : path) + projectId));
}
function dsnFromString(str) {
    var match = DSN_REGEX.exec(str);
    if (!match) {
        throw new SentryError("Invalid Sentry Dsn: " + str);
    }
    var _a = __read$4(match.slice(1), 6), protocol = _a[0], publicKey = _a[1], _b = _a[2], pass = _b === void 0 ? '' : _b, host = _a[3], _c = _a[4], port = _c === void 0 ? '' : _c, lastPath = _a[5];
    var path = '';
    var projectId = lastPath;
    var split = projectId.split('/');
    if (split.length > 1) {
        path = split.slice(0, -1).join('/');
        projectId = split.pop();
    }
    if (projectId) {
        var projectMatch = projectId.match(/^\d+/);
        if (projectMatch) {
            projectId = projectMatch[0];
        }
    }
    return dsnFromComponents({ host: host, pass: pass, path: path, projectId: projectId, port: port, protocol: protocol, publicKey: publicKey });
}
function dsnFromComponents(components) {
    // TODO this is for backwards compatibility, and can be removed in a future version
    if ('user' in components && !('publicKey' in components)) {
        components.publicKey = components.user;
    }
    return {
        user: components.publicKey || '',
        protocol: components.protocol,
        publicKey: components.publicKey || '',
        pass: components.pass || '',
        host: components.host,
        port: components.port || '',
        path: components.path || '',
        projectId: components.projectId,
    };
}
function validateDsn(dsn) {
    if (!IS_DEBUG_BUILD$4) {
        return;
    }
    var port = dsn.port, projectId = dsn.projectId, protocol = dsn.protocol;
    var requiredComponents = ['protocol', 'publicKey', 'host', 'projectId'];
    requiredComponents.forEach(function (component) {
        if (!dsn[component]) {
            throw new SentryError("Invalid Sentry Dsn: " + component + " missing");
        }
    });
    if (!projectId.match(/^\d+$/)) {
        throw new SentryError("Invalid Sentry Dsn: Invalid projectId " + projectId);
    }
    if (!isValidProtocol(protocol)) {
        throw new SentryError("Invalid Sentry Dsn: Invalid protocol " + protocol);
    }
    if (port && isNaN(parseInt(port, 10))) {
        throw new SentryError("Invalid Sentry Dsn: Invalid port " + port);
    }
    return true;
}
/** The Sentry Dsn, identifying a Sentry instance and project. */
function makeDsn(from) {
    var components = typeof from === 'string' ? dsnFromString(from) : dsnFromComponents(from);
    validateDsn(components);
    return components;
}

var SeverityLevels = ['fatal', 'error', 'warning', 'log', 'info', 'debug', 'critical'];

// TODO: Implement different loggers for different environments
var global$9 = getGlobalObject();
/** Prefix for logging strings */
var PREFIX = 'Sentry Logger ';
var CONSOLE_LEVELS = ['debug', 'info', 'warn', 'error', 'log', 'assert'];
/**
 * Temporarily disable sentry console instrumentations.
 *
 * @param callback The function to run against the original `console` messages
 * @returns The results of the callback
 */
function consoleSandbox(callback) {
    var global = getGlobalObject();
    if (!('console' in global)) {
        return callback();
    }
    var originalConsole = global.console;
    var wrappedLevels = {};
    // Restore all wrapped console methods
    CONSOLE_LEVELS.forEach(function (level) {
        // TODO(v7): Remove this check as it's only needed for Node 6
        var originalWrappedFunc = originalConsole[level] && originalConsole[level].__sentry_original__;
        if (level in global.console && originalWrappedFunc) {
            wrappedLevels[level] = originalConsole[level];
            originalConsole[level] = originalWrappedFunc;
        }
    });
    try {
        return callback();
    }
    finally {
        // Revert restoration to wrapped state
        Object.keys(wrappedLevels).forEach(function (level) {
            originalConsole[level] = wrappedLevels[level];
        });
    }
}
function makeLogger() {
    var enabled = false;
    var logger = {
        enable: function () {
            enabled = true;
        },
        disable: function () {
            enabled = false;
        },
    };
    if (IS_DEBUG_BUILD$4) {
        CONSOLE_LEVELS.forEach(function (name) {
            // eslint-disable-next-line @typescript-eslint/no-explicit-any
            logger[name] = function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                if (enabled) {
                    consoleSandbox(function () {
                        var _a;
                        (_a = global$9.console)[name].apply(_a, __spread$1([PREFIX + "[" + name + "]:"], args));
                    });
                }
            };
        });
    }
    else {
        CONSOLE_LEVELS.forEach(function (name) {
            logger[name] = function () { return undefined; };
        });
    }
    return logger;
}
// Ensure we only have a single logger instance, even if multiple versions of @sentry/utils are being used
var logger;
if (IS_DEBUG_BUILD$4) {
    logger = getGlobalSingleton('logger', makeLogger);
}
else {
    logger = makeLogger();
}

/**
 * Truncates given string to the maximum characters count
 *
 * @param str An object that contains serializable values
 * @param max Maximum number of characters in truncated string (0 = unlimited)
 * @returns string Encoded
 */
function truncate(str, max) {
    if (max === void 0) { max = 0; }
    if (typeof str !== 'string' || max === 0) {
        return str;
    }
    return str.length <= max ? str : str.substr(0, max) + "...";
}
/**
 * Join values in array
 * @param input array of values to be joined together
 * @param delimiter string to be placed in-between values
 * @returns Joined values
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function safeJoin(input, delimiter) {
    if (!Array.isArray(input)) {
        return '';
    }
    var output = [];
    // eslint-disable-next-line @typescript-eslint/prefer-for-of
    for (var i = 0; i < input.length; i++) {
        var value = input[i];
        try {
            output.push(String(value));
        }
        catch (e) {
            output.push('[value cannot be serialized]');
        }
    }
    return output.join(delimiter);
}
/**
 * Checks if the value matches a regex or includes the string
 * @param value The string value to be checked against
 * @param pattern Either a regex or a string that must be contained in value
 */
function isMatchingPattern(value, pattern) {
    if (!isString(value)) {
        return false;
    }
    if (isRegExp(pattern)) {
        return pattern.test(value);
    }
    if (typeof pattern === 'string') {
        return value.indexOf(pattern) !== -1;
    }
    return false;
}

/**
 * Replace a method in an object with a wrapped version of itself.
 *
 * @param source An object that contains a method to be wrapped.
 * @param name The name of the method to be wrapped.
 * @param replacementFactory A higher-order function that takes the original version of the given method and returns a
 * wrapped version. Note: The function returned by `replacementFactory` needs to be a non-arrow function, in order to
 * preserve the correct value of `this`, and the original method must be called using `origMethod.call(this, <other
 * args>)` or `origMethod.apply(this, [<other args>])` (rather than being called directly), again to preserve `this`.
 * @returns void
 */
function fill(source, name, replacementFactory) {
    if (!(name in source)) {
        return;
    }
    var original = source[name];
    var wrapped = replacementFactory(original);
    // Make sure it's a function first, as we need to attach an empty prototype for `defineProperties` to work
    // otherwise it'll throw "TypeError: Object.defineProperties called on non-object"
    if (typeof wrapped === 'function') {
        try {
            markFunctionWrapped(wrapped, original);
        }
        catch (_Oo) {
            // This can throw if multiple fill happens on a global object like XMLHttpRequest
            // Fixes https://github.com/getsentry/sentry-javascript/issues/2043
        }
    }
    source[name] = wrapped;
}
/**
 * Defines a non-enumerable property on the given object.
 *
 * @param obj The object on which to set the property
 * @param name The name of the property to be set
 * @param value The value to which to set the property
 */
function addNonEnumerableProperty(obj, name, value) {
    Object.defineProperty(obj, name, {
        // enumerable: false, // the default, so we can save on bundle size by not explicitly setting it
        value: value,
        writable: true,
        configurable: true,
    });
}
/**
 * Remembers the original function on the wrapped function and
 * patches up the prototype.
 *
 * @param wrapped the wrapper function
 * @param original the original function that gets wrapped
 */
function markFunctionWrapped(wrapped, original) {
    var proto = original.prototype || {};
    wrapped.prototype = original.prototype = proto;
    addNonEnumerableProperty(wrapped, '__sentry_original__', original);
}
/**
 * This extracts the original function if available.  See
 * `markFunctionWrapped` for more information.
 *
 * @param func the function to unwrap
 * @returns the unwrapped version of the function if available.
 */
function getOriginalFunction(func) {
    return func.__sentry_original__;
}
/**
 * Encodes given object into url-friendly format
 *
 * @param object An object that contains serializable values
 * @returns string Encoded
 */
function urlEncode(object) {
    return Object.keys(object)
        .map(function (key) { return encodeURIComponent(key) + "=" + encodeURIComponent(object[key]); })
        .join('&');
}
/**
 * Transforms any object into an object literal with all its attributes
 * attached to it.
 *
 * @param value Initial source that we have to transform in order for it to be usable by the serializer
 */
function convertToPlainObject(value) {
    var newObj = value;
    if (isError(value)) {
        newObj = __assign$2({ message: value.message, name: value.name, stack: value.stack }, getOwnProperties(value));
    }
    else if (isEvent(value)) {
        var event_1 = value;
        newObj = __assign$2({ type: event_1.type, target: serializeEventTarget(event_1.target), currentTarget: serializeEventTarget(event_1.currentTarget) }, getOwnProperties(event_1));
        if (typeof CustomEvent !== 'undefined' && isInstanceOf(value, CustomEvent)) {
            newObj.detail = event_1.detail;
        }
    }
    return newObj;
}
/** Creates a string representation of the target of an `Event` object */
function serializeEventTarget(target) {
    try {
        return isElement$2(target) ? htmlTreeAsString(target) : Object.prototype.toString.call(target);
    }
    catch (_oO) {
        return '<unknown>';
    }
}
/** Filters out all but an object's own properties */
function getOwnProperties(obj) {
    var extractedProps = {};
    for (var property in obj) {
        if (Object.prototype.hasOwnProperty.call(obj, property)) {
            extractedProps[property] = obj[property];
        }
    }
    return extractedProps;
}
/**
 * Given any captured exception, extract its keys and create a sorted
 * and truncated list that will be used inside the event message.
 * eg. `Non-error exception captured with keys: foo, bar, baz`
 */
// eslint-disable-next-line @typescript-eslint/explicit-module-boundary-types
function extractExceptionKeysForMessage(exception, maxLength) {
    if (maxLength === void 0) { maxLength = 40; }
    var keys = Object.keys(convertToPlainObject(exception));
    keys.sort();
    if (!keys.length) {
        return '[object has no keys]';
    }
    if (keys[0].length >= maxLength) {
        return truncate(keys[0], maxLength);
    }
    for (var includedKeys = keys.length; includedKeys > 0; includedKeys--) {
        var serialized = keys.slice(0, includedKeys).join(', ');
        if (serialized.length > maxLength) {
            continue;
        }
        if (includedKeys === keys.length) {
            return serialized;
        }
        return truncate(serialized, maxLength);
    }
    return '';
}
/**
 * Given any object, return the new object with removed keys that value was `undefined`.
 * Works recursively on objects and arrays.
 */
function dropUndefinedKeys(val) {
    var e_1, _a;
    if (isPlainObject(val)) {
        var rv = {};
        try {
            for (var _b = __values(Object.keys(val)), _c = _b.next(); !_c.done; _c = _b.next()) {
                var key = _c.value;
                if (typeof val[key] !== 'undefined') {
                    rv[key] = dropUndefinedKeys(val[key]);
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return rv;
    }
    if (Array.isArray(val)) {
        return val.map(dropUndefinedKeys);
    }
    return val;
}

var STACKTRACE_LIMIT = 50;
/**
 * Creates a stack parser with the supplied line parsers
 *
 * StackFrames are returned in the correct order for Sentry Exception
 * frames and with Sentry SDK internal frames removed from the top and bottom
 *
 */
function createStackParser() {
    var parsers = [];
    for (var _i = 0; _i < arguments.length; _i++) {
        parsers[_i] = arguments[_i];
    }
    var sortedParsers = parsers.sort(function (a, b) { return a[0] - b[0]; }).map(function (p) { return p[1]; });
    return function (stack, skipFirst) {
        var e_1, _a, e_2, _b;
        if (skipFirst === void 0) { skipFirst = 0; }
        var frames = [];
        try {
            for (var _c = __values(stack.split('\n').slice(skipFirst)), _d = _c.next(); !_d.done; _d = _c.next()) {
                var line = _d.value;
                try {
                    for (var sortedParsers_1 = (e_2 = void 0, __values(sortedParsers)), sortedParsers_1_1 = sortedParsers_1.next(); !sortedParsers_1_1.done; sortedParsers_1_1 = sortedParsers_1.next()) {
                        var parser = sortedParsers_1_1.value;
                        var frame = parser(line);
                        if (frame) {
                            frames.push(frame);
                            break;
                        }
                    }
                }
                catch (e_2_1) { e_2 = { error: e_2_1 }; }
                finally {
                    try {
                        if (sortedParsers_1_1 && !sortedParsers_1_1.done && (_b = sortedParsers_1.return)) _b.call(sortedParsers_1);
                    }
                    finally { if (e_2) throw e_2.error; }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
        return stripSentryFramesAndReverse(frames);
    };
}
/**
 * @hidden
 */
function stripSentryFramesAndReverse(stack) {
    if (!stack.length) {
        return [];
    }
    var localStack = stack;
    var firstFrameFunction = localStack[0].function || '';
    var lastFrameFunction = localStack[localStack.length - 1].function || '';
    // If stack starts with one of our API calls, remove it (starts, meaning it's the top of the stack - aka last call)
    if (firstFrameFunction.indexOf('captureMessage') !== -1 || firstFrameFunction.indexOf('captureException') !== -1) {
        localStack = localStack.slice(1);
    }
    // If stack ends with one of our internal API calls, remove it (ends, meaning it's the bottom of the stack - aka top-most call)
    if (lastFrameFunction.indexOf('sentryWrapped') !== -1) {
        localStack = localStack.slice(0, -1);
    }
    // The frame where the crash happened, should be the last entry in the array
    return localStack
        .slice(0, STACKTRACE_LIMIT)
        .map(function (frame) { return (__assign$2(__assign$2({}, frame), { filename: frame.filename || localStack[0].filename, function: frame.function || '?' })); })
        .reverse();
}
var defaultFunctionName = '<anonymous>';
/**
 * Safely extract function name from itself
 */
function getFunctionName(fn) {
    try {
        if (!fn || typeof fn !== 'function') {
            return defaultFunctionName;
        }
        return fn.name || defaultFunctionName;
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        return defaultFunctionName;
    }
}

/**
 * Tells whether current environment supports Fetch API
 * {@link supportsFetch}.
 *
 * @returns Answer to the given question.
 */
function supportsFetch() {
    if (!('fetch' in getGlobalObject())) {
        return false;
    }
    try {
        new Headers();
        new Request('');
        new Response();
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * isNativeFetch checks if the given function is a native implementation of fetch()
 */
// eslint-disable-next-line @typescript-eslint/ban-types
function isNativeFetch(func) {
    return func && /^function fetch\(\)\s+\{\s+\[native code\]\s+\}$/.test(func.toString());
}
/**
 * Tells whether current environment supports Fetch API natively
 * {@link supportsNativeFetch}.
 *
 * @returns true if `window.fetch` is natively implemented, false otherwise
 */
function supportsNativeFetch() {
    if (!supportsFetch()) {
        return false;
    }
    var global = getGlobalObject();
    // Fast path to avoid DOM I/O
    // eslint-disable-next-line @typescript-eslint/unbound-method
    if (isNativeFetch(global.fetch)) {
        return true;
    }
    // window.fetch is implemented, but is polyfilled or already wrapped (e.g: by a chrome extension)
    // so create a "pure" iframe to see if that has native fetch
    var result = false;
    var doc = global.document;
    // eslint-disable-next-line deprecation/deprecation
    if (doc && typeof doc.createElement === 'function') {
        try {
            var sandbox = doc.createElement('iframe');
            sandbox.hidden = true;
            doc.head.appendChild(sandbox);
            if (sandbox.contentWindow && sandbox.contentWindow.fetch) {
                // eslint-disable-next-line @typescript-eslint/unbound-method
                result = isNativeFetch(sandbox.contentWindow.fetch);
            }
            doc.head.removeChild(sandbox);
        }
        catch (err) {
            IS_DEBUG_BUILD$4 &&
                logger.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', err);
        }
    }
    return result;
}
/**
 * Tells whether current environment supports Referrer Policy API
 * {@link supportsReferrerPolicy}.
 *
 * @returns Answer to the given question.
 */
function supportsReferrerPolicy() {
    // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
    // (see https://caniuse.com/#feat=referrer-policy),
    // it doesn't. And it throws an exception instead of ignoring this parameter...
    // REF: https://github.com/getsentry/raven-js/issues/1233
    if (!supportsFetch()) {
        return false;
    }
    try {
        new Request('_', {
            referrerPolicy: 'origin',
        });
        return true;
    }
    catch (e) {
        return false;
    }
}
/**
 * Tells whether current environment supports History API
 * {@link supportsHistory}.
 *
 * @returns Answer to the given question.
 */
function supportsHistory() {
    // NOTE: in Chrome App environment, touching history.pushState, *even inside
    //       a try/catch block*, will cause Chrome to output an error to console.error
    // borrowed from: https://github.com/angular/angular.js/pull/13945/files
    var global = getGlobalObject();
    /* eslint-disable @typescript-eslint/no-unsafe-member-access */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var chrome = global.chrome;
    var isChromePackagedApp = chrome && chrome.app && chrome.app.runtime;
    /* eslint-enable @typescript-eslint/no-unsafe-member-access */
    var hasHistoryApi = 'history' in global && !!global.history.pushState && !!global.history.replaceState;
    return !isChromePackagedApp && hasHistoryApi;
}

var global$8 = getGlobalObject();
/**
 * Instrument native APIs to call handlers that can be used to create breadcrumbs, APM spans etc.
 *  - Console API
 *  - Fetch API
 *  - XHR API
 *  - History API
 *  - DOM API (click/typing)
 *  - Error API
 *  - UnhandledRejection API
 */
var handlers = {};
var instrumented = {};
/** Instruments given API */
function instrument(type) {
    if (instrumented[type]) {
        return;
    }
    instrumented[type] = true;
    switch (type) {
        case 'console':
            instrumentConsole();
            break;
        case 'dom':
            instrumentDOM();
            break;
        case 'xhr':
            instrumentXHR();
            break;
        case 'fetch':
            instrumentFetch();
            break;
        case 'history':
            instrumentHistory();
            break;
        case 'error':
            instrumentError();
            break;
        case 'unhandledrejection':
            instrumentUnhandledRejection();
            break;
        default:
            IS_DEBUG_BUILD$4 && logger.warn('unknown instrumentation type:', type);
            return;
    }
}
/**
 * Add handler that will be called when given type of instrumentation triggers.
 * Use at your own risk, this might break without changelog notice, only used internally.
 * @hidden
 */
function addInstrumentationHandler(type, callback) {
    handlers[type] = handlers[type] || [];
    handlers[type].push(callback);
    instrument(type);
}
/** JSDoc */
function triggerHandlers(type, data) {
    var e_1, _a;
    if (!type || !handlers[type]) {
        return;
    }
    try {
        for (var _b = __values(handlers[type] || []), _c = _b.next(); !_c.done; _c = _b.next()) {
            var handler = _c.value;
            try {
                handler(data);
            }
            catch (e) {
                IS_DEBUG_BUILD$4 &&
                    logger.error("Error while triggering instrumentation handler.\nType: " + type + "\nName: " + getFunctionName(handler) + "\nError:", e);
            }
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
        }
        finally { if (e_1) throw e_1.error; }
    }
}
/** JSDoc */
function instrumentConsole() {
    if (!('console' in global$8)) {
        return;
    }
    CONSOLE_LEVELS.forEach(function (level) {
        if (!(level in global$8.console)) {
            return;
        }
        fill(global$8.console, level, function (originalConsoleMethod) {
            return function () {
                var args = [];
                for (var _i = 0; _i < arguments.length; _i++) {
                    args[_i] = arguments[_i];
                }
                triggerHandlers('console', { args: args, level: level });
                // this fails for some browsers. :(
                if (originalConsoleMethod) {
                    originalConsoleMethod.apply(global$8.console, args);
                }
            };
        });
    });
}
/** JSDoc */
function instrumentFetch() {
    if (!supportsNativeFetch()) {
        return;
    }
    fill(global$8, 'fetch', function (originalFetch) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var handlerData = {
                args: args,
                fetchData: {
                    method: getFetchMethod(args),
                    url: getFetchUrl(args),
                },
                startTimestamp: Date.now(),
            };
            triggerHandlers('fetch', __assign$2({}, handlerData));
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            return originalFetch.apply(global$8, args).then(function (response) {
                triggerHandlers('fetch', __assign$2(__assign$2({}, handlerData), { endTimestamp: Date.now(), response: response }));
                return response;
            }, function (error) {
                triggerHandlers('fetch', __assign$2(__assign$2({}, handlerData), { endTimestamp: Date.now(), error: error }));
                // NOTE: If you are a Sentry user, and you are seeing this stack frame,
                //       it means the sentry.javascript SDK caught an error invoking your application code.
                //       This is expected behavior and NOT indicative of a bug with sentry.javascript.
                throw error;
            });
        };
    });
}
/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/** Extract `method` from fetch call arguments */
function getFetchMethod(fetchArgs) {
    if (fetchArgs === void 0) { fetchArgs = []; }
    if ('Request' in global$8 && isInstanceOf(fetchArgs[0], Request) && fetchArgs[0].method) {
        return String(fetchArgs[0].method).toUpperCase();
    }
    if (fetchArgs[1] && fetchArgs[1].method) {
        return String(fetchArgs[1].method).toUpperCase();
    }
    return 'GET';
}
/** Extract `url` from fetch call arguments */
function getFetchUrl(fetchArgs) {
    if (fetchArgs === void 0) { fetchArgs = []; }
    if (typeof fetchArgs[0] === 'string') {
        return fetchArgs[0];
    }
    if ('Request' in global$8 && isInstanceOf(fetchArgs[0], Request)) {
        return fetchArgs[0].url;
    }
    return String(fetchArgs[0]);
}
/* eslint-enable @typescript-eslint/no-unsafe-member-access */
/** JSDoc */
function instrumentXHR() {
    if (!('XMLHttpRequest' in global$8)) {
        return;
    }
    var xhrproto = XMLHttpRequest.prototype;
    fill(xhrproto, 'open', function (originalOpen) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            // eslint-disable-next-line @typescript-eslint/no-this-alias
            var xhr = this;
            var url = args[1];
            var xhrInfo = (xhr.__sentry_xhr__ = {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                method: isString(args[0]) ? args[0].toUpperCase() : args[0],
                url: args[1],
            });
            // if Sentry key appears in URL, don't capture it as a request
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (isString(url) && xhrInfo.method === 'POST' && url.match(/sentry_key/)) {
                xhr.__sentry_own_request__ = true;
            }
            var onreadystatechangeHandler = function () {
                if (xhr.readyState === 4) {
                    try {
                        // touching statusCode in some platforms throws
                        // an exception
                        xhrInfo.status_code = xhr.status;
                    }
                    catch (e) {
                        /* do nothing */
                    }
                    triggerHandlers('xhr', {
                        args: args,
                        endTimestamp: Date.now(),
                        startTimestamp: Date.now(),
                        xhr: xhr,
                    });
                }
            };
            if ('onreadystatechange' in xhr && typeof xhr.onreadystatechange === 'function') {
                fill(xhr, 'onreadystatechange', function (original) {
                    return function () {
                        var readyStateArgs = [];
                        for (var _i = 0; _i < arguments.length; _i++) {
                            readyStateArgs[_i] = arguments[_i];
                        }
                        onreadystatechangeHandler();
                        return original.apply(xhr, readyStateArgs);
                    };
                });
            }
            else {
                xhr.addEventListener('readystatechange', onreadystatechangeHandler);
            }
            return originalOpen.apply(xhr, args);
        };
    });
    fill(xhrproto, 'send', function (originalSend) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            if (this.__sentry_xhr__ && args[0] !== undefined) {
                this.__sentry_xhr__.body = args[0];
            }
            triggerHandlers('xhr', {
                args: args,
                startTimestamp: Date.now(),
                xhr: this,
            });
            return originalSend.apply(this, args);
        };
    });
}
var lastHref;
/** JSDoc */
function instrumentHistory() {
    if (!supportsHistory()) {
        return;
    }
    var oldOnPopState = global$8.onpopstate;
    global$8.onpopstate = function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var to = global$8.location.href;
        // keep track of the current URL state, as we always receive only the updated state
        var from = lastHref;
        lastHref = to;
        triggerHandlers('history', {
            from: from,
            to: to,
        });
        if (oldOnPopState) {
            // Apparently this can throw in Firefox when incorrectly implemented plugin is installed.
            // https://github.com/getsentry/sentry-javascript/issues/3344
            // https://github.com/bugsnag/bugsnag-js/issues/469
            try {
                return oldOnPopState.apply(this, args);
            }
            catch (_oO) {
                // no-empty
            }
        }
    };
    /** @hidden */
    function historyReplacementFunction(originalHistoryFunction) {
        return function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var url = args.length > 2 ? args[2] : undefined;
            if (url) {
                // coerce to string (this is what pushState does)
                var from = lastHref;
                var to = String(url);
                // keep track of the current URL state, as we always receive only the updated state
                lastHref = to;
                triggerHandlers('history', {
                    from: from,
                    to: to,
                });
            }
            return originalHistoryFunction.apply(this, args);
        };
    }
    fill(global$8.history, 'pushState', historyReplacementFunction);
    fill(global$8.history, 'replaceState', historyReplacementFunction);
}
var debounceDuration = 1000;
var debounceTimerID;
var lastCapturedEvent;
/**
 * Decide whether the current event should finish the debounce of previously captured one.
 * @param previous previously captured event
 * @param current event to be captured
 */
function shouldShortcircuitPreviousDebounce(previous, current) {
    // If there was no previous event, it should always be swapped for the new one.
    if (!previous) {
        return true;
    }
    // If both events have different type, then user definitely performed two separate actions. e.g. click + keypress.
    if (previous.type !== current.type) {
        return true;
    }
    try {
        // If both events have the same type, it's still possible that actions were performed on different targets.
        // e.g. 2 clicks on different buttons.
        if (previous.target !== current.target) {
            return true;
        }
    }
    catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    // If both events have the same type _and_ same `target` (an element which triggered an event, _not necessarily_
    // to which an event listener was attached), we treat them as the same action, as we want to capture
    // only one breadcrumb. e.g. multiple clicks on the same button, or typing inside a user input box.
    return false;
}
/**
 * Decide whether an event should be captured.
 * @param event event to be captured
 */
function shouldSkipDOMEvent(event) {
    // We are only interested in filtering `keypress` events for now.
    if (event.type !== 'keypress') {
        return false;
    }
    try {
        var target = event.target;
        if (!target || !target.tagName) {
            return true;
        }
        // Only consider keypress events on actual input elements. This will disregard keypresses targeting body
        // e.g.tabbing through elements, hotkeys, etc.
        if (target.tagName === 'INPUT' || target.tagName === 'TEXTAREA' || target.isContentEditable) {
            return false;
        }
    }
    catch (e) {
        // just accessing `target` property can throw an exception in some rare circumstances
        // see: https://github.com/getsentry/sentry-javascript/issues/838
    }
    return true;
}
/**
 * Wraps addEventListener to capture UI breadcrumbs
 * @param handler function that will be triggered
 * @param globalListener indicates whether event was captured by the global event listener
 * @returns wrapped breadcrumb events handler
 * @hidden
 */
function makeDOMEventHandler(handler, globalListener) {
    if (globalListener === void 0) { globalListener = false; }
    return function (event) {
        // It's possible this handler might trigger multiple times for the same
        // event (e.g. event propagation through node ancestors).
        // Ignore if we've already captured that event.
        if (!event || lastCapturedEvent === event) {
            return;
        }
        // We always want to skip _some_ events.
        if (shouldSkipDOMEvent(event)) {
            return;
        }
        var name = event.type === 'keypress' ? 'input' : event.type;
        // If there is no debounce timer, it means that we can safely capture the new event and store it for future comparisons.
        if (debounceTimerID === undefined) {
            handler({
                event: event,
                name: name,
                global: globalListener,
            });
            lastCapturedEvent = event;
        }
        // If there is a debounce awaiting, see if the new event is different enough to treat it as a unique one.
        // If that's the case, emit the previous event and store locally the newly-captured DOM event.
        else if (shouldShortcircuitPreviousDebounce(lastCapturedEvent, event)) {
            handler({
                event: event,
                name: name,
                global: globalListener,
            });
            lastCapturedEvent = event;
        }
        // Start a new debounce timer that will prevent us from capturing multiple events that should be grouped together.
        clearTimeout(debounceTimerID);
        debounceTimerID = global$8.setTimeout(function () {
            debounceTimerID = undefined;
        }, debounceDuration);
    };
}
/** JSDoc */
function instrumentDOM() {
    if (!('document' in global$8)) {
        return;
    }
    // Make it so that any click or keypress that is unhandled / bubbled up all the way to the document triggers our dom
    // handlers. (Normally we have only one, which captures a breadcrumb for each click or keypress.) Do this before
    // we instrument `addEventListener` so that we don't end up attaching this handler twice.
    var triggerDOMHandler = triggerHandlers.bind(null, 'dom');
    var globalDOMEventHandler = makeDOMEventHandler(triggerDOMHandler, true);
    global$8.document.addEventListener('click', globalDOMEventHandler, false);
    global$8.document.addEventListener('keypress', globalDOMEventHandler, false);
    // After hooking into click and keypress events bubbled up to `document`, we also hook into user-handled
    // clicks & keypresses, by adding an event listener of our own to any element to which they add a listener. That
    // way, whenever one of their handlers is triggered, ours will be, too. (This is needed because their handler
    // could potentially prevent the event from bubbling up to our global listeners. This way, our handler are still
    // guaranteed to fire at least once.)
    ['EventTarget', 'Node'].forEach(function (target) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        var proto = global$8[target] && global$8[target].prototype;
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
        if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
            return;
        }
        fill(proto, 'addEventListener', function (originalAddEventListener) {
            return function (type, listener, options) {
                if (type === 'click' || type == 'keypress') {
                    try {
                        var el = this;
                        var handlers_1 = (el.__sentry_instrumentation_handlers__ = el.__sentry_instrumentation_handlers__ || {});
                        var handlerForType = (handlers_1[type] = handlers_1[type] || { refCount: 0 });
                        if (!handlerForType.handler) {
                            var handler = makeDOMEventHandler(triggerDOMHandler);
                            handlerForType.handler = handler;
                            originalAddEventListener.call(this, type, handler, options);
                        }
                        handlerForType.refCount += 1;
                    }
                    catch (e) {
                        // Accessing dom properties is always fragile.
                        // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                    }
                }
                return originalAddEventListener.call(this, type, listener, options);
            };
        });
        fill(proto, 'removeEventListener', function (originalRemoveEventListener) {
            return function (type, listener, options) {
                if (type === 'click' || type == 'keypress') {
                    try {
                        var el = this;
                        var handlers_2 = el.__sentry_instrumentation_handlers__ || {};
                        var handlerForType = handlers_2[type];
                        if (handlerForType) {
                            handlerForType.refCount -= 1;
                            // If there are no longer any custom handlers of the current type on this element, we can remove ours, too.
                            if (handlerForType.refCount <= 0) {
                                originalRemoveEventListener.call(this, type, handlerForType.handler, options);
                                handlerForType.handler = undefined;
                                delete handlers_2[type]; // eslint-disable-line @typescript-eslint/no-dynamic-delete
                            }
                            // If there are no longer any custom handlers of any type on this element, cleanup everything.
                            if (Object.keys(handlers_2).length === 0) {
                                delete el.__sentry_instrumentation_handlers__;
                            }
                        }
                    }
                    catch (e) {
                        // Accessing dom properties is always fragile.
                        // Also allows us to skip `addEventListenrs` calls with no proper `this` context.
                    }
                }
                return originalRemoveEventListener.call(this, type, listener, options);
            };
        });
    });
}
var _oldOnErrorHandler = null;
/** JSDoc */
function instrumentError() {
    _oldOnErrorHandler = global$8.onerror;
    global$8.onerror = function (msg, url, line, column, error) {
        triggerHandlers('error', {
            column: column,
            error: error,
            line: line,
            msg: msg,
            url: url,
        });
        if (_oldOnErrorHandler) {
            // eslint-disable-next-line prefer-rest-params
            return _oldOnErrorHandler.apply(this, arguments);
        }
        return false;
    };
}
var _oldOnUnhandledRejectionHandler = null;
/** JSDoc */
function instrumentUnhandledRejection() {
    _oldOnUnhandledRejectionHandler = global$8.onunhandledrejection;
    global$8.onunhandledrejection = function (e) {
        triggerHandlers('unhandledrejection', e);
        if (_oldOnUnhandledRejectionHandler) {
            // eslint-disable-next-line prefer-rest-params
            return _oldOnUnhandledRejectionHandler.apply(this, arguments);
        }
        return true;
    };
}

/* eslint-disable @typescript-eslint/no-unsafe-member-access */
/* eslint-disable @typescript-eslint/no-explicit-any */
/**
 * Helper to decycle json objects
 */
function memoBuilder() {
    var hasWeakSet = typeof WeakSet === 'function';
    var inner = hasWeakSet ? new WeakSet() : [];
    function memoize(obj) {
        if (hasWeakSet) {
            if (inner.has(obj)) {
                return true;
            }
            inner.add(obj);
            return false;
        }
        // eslint-disable-next-line @typescript-eslint/prefer-for-of
        for (var i = 0; i < inner.length; i++) {
            var value = inner[i];
            if (value === obj) {
                return true;
            }
        }
        inner.push(obj);
        return false;
    }
    function unmemoize(obj) {
        if (hasWeakSet) {
            inner.delete(obj);
        }
        else {
            for (var i = 0; i < inner.length; i++) {
                if (inner[i] === obj) {
                    inner.splice(i, 1);
                    break;
                }
            }
        }
    }
    return [memoize, unmemoize];
}

/**
 * UUID4 generator
 *
 * @returns string Generated UUID4.
 */
function uuid4() {
    var global = getGlobalObject();
    var crypto = global.crypto || global.msCrypto;
    if (!(crypto === void 0) && crypto.getRandomValues) {
        // Use window.crypto API if available
        var arr = new Uint16Array(8);
        crypto.getRandomValues(arr);
        // set 4 in byte 7
        // eslint-disable-next-line no-bitwise
        arr[3] = (arr[3] & 0xfff) | 0x4000;
        // set 2 most significant bits of byte 9 to '10'
        // eslint-disable-next-line no-bitwise
        arr[4] = (arr[4] & 0x3fff) | 0x8000;
        var pad = function (num) {
            var v = num.toString(16);
            while (v.length < 4) {
                v = "0" + v;
            }
            return v;
        };
        return (pad(arr[0]) + pad(arr[1]) + pad(arr[2]) + pad(arr[3]) + pad(arr[4]) + pad(arr[5]) + pad(arr[6]) + pad(arr[7]));
    }
    // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/2117523#2117523
    return 'xxxxxxxxxxxx4xxxyxxxxxxxxxxxxxxx'.replace(/[xy]/g, function (c) {
        // eslint-disable-next-line no-bitwise
        var r = (Math.random() * 16) | 0;
        // eslint-disable-next-line no-bitwise
        var v = c === 'x' ? r : (r & 0x3) | 0x8;
        return v.toString(16);
    });
}
/**
 * Parses string form of URL into an object
 * // borrowed from https://tools.ietf.org/html/rfc3986#appendix-B
 * // intentionally using regex and not <a/> href parsing trick because React Native and other
 * // environments where DOM might not be available
 * @returns parsed URL object
 */
function parseUrl(url) {
    if (!url) {
        return {};
    }
    var match = url.match(/^(([^:/?#]+):)?(\/\/([^/?#]*))?([^?#]*)(\?([^#]*))?(#(.*))?$/);
    if (!match) {
        return {};
    }
    // coerce to undefined values to empty string so we don't get 'undefined'
    var query = match[6] || '';
    var fragment = match[8] || '';
    return {
        host: match[4],
        path: match[5],
        protocol: match[2],
        relative: match[5] + query + fragment,
    };
}
function getFirstException(event) {
    return event.exception && event.exception.values ? event.exception.values[0] : undefined;
}
/**
 * Extracts either message or type+value from an event that can be used for user-facing logs
 * @returns event's description
 */
function getEventDescription(event) {
    var message = event.message, eventId = event.event_id;
    if (message) {
        return message;
    }
    var firstException = getFirstException(event);
    if (firstException) {
        if (firstException.type && firstException.value) {
            return firstException.type + ": " + firstException.value;
        }
        return firstException.type || firstException.value || eventId || '<unknown>';
    }
    return eventId || '<unknown>';
}
/**
 * Adds exception values, type and value to an synthetic Exception.
 * @param event The event to modify.
 * @param value Value of the exception.
 * @param type Type of the exception.
 * @hidden
 */
function addExceptionTypeValue(event, value, type) {
    var exception = (event.exception = event.exception || {});
    var values = (exception.values = exception.values || []);
    var firstException = (values[0] = values[0] || {});
    if (!firstException.value) {
        firstException.value = value || '';
    }
    if (!firstException.type) {
        firstException.type = type || 'Error';
    }
}
/**
 * Adds exception mechanism data to a given event. Uses defaults if the second parameter is not passed.
 *
 * @param event The event to modify.
 * @param newMechanism Mechanism data to add to the event.
 * @hidden
 */
function addExceptionMechanism(event, newMechanism) {
    var firstException = getFirstException(event);
    if (!firstException) {
        return;
    }
    var defaultMechanism = { type: 'generic', handled: true };
    var currentMechanism = firstException.mechanism;
    firstException.mechanism = __assign$2(__assign$2(__assign$2({}, defaultMechanism), currentMechanism), newMechanism);
    if (newMechanism && 'data' in newMechanism) {
        var mergedData = __assign$2(__assign$2({}, (currentMechanism && currentMechanism.data)), newMechanism.data);
        firstException.mechanism.data = mergedData;
    }
}
/**
 * Checks whether or not we've already captured the given exception (note: not an identical exception - the very object
 * in question), and marks it captured if not.
 *
 * This is useful because it's possible for an error to get captured by more than one mechanism. After we intercept and
 * record an error, we rethrow it (assuming we've intercepted it before it's reached the top-level global handlers), so
 * that we don't interfere with whatever effects the error might have had were the SDK not there. At that point, because
 * the error has been rethrown, it's possible for it to bubble up to some other code we've instrumented. If it's not
 * caught after that, it will bubble all the way up to the global handlers (which of course we also instrument). This
 * function helps us ensure that even if we encounter the same error more than once, we only record it the first time we
 * see it.
 *
 * Note: It will ignore primitives (always return `false` and not mark them as seen), as properties can't be set on
 * them. {@link: Object.objectify} can be used on exceptions to convert any that are primitives into their equivalent
 * object wrapper forms so that this check will always work. However, because we need to flag the exact object which
 * will get rethrown, and because that rethrowing happens outside of the event processing pipeline, the objectification
 * must be done before the exception captured.
 *
 * @param A thrown exception to check or flag as having been seen
 * @returns `true` if the exception has already been captured, `false` if not (with the side effect of marking it seen)
 */
function checkOrSetAlreadyCaught(exception) {
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    if (exception && exception.__sentry_captured__) {
        return true;
    }
    try {
        // set it this way rather than by assignment so that it's not ennumerable and therefore isn't recorded by the
        // `ExtraErrorData` integration
        addNonEnumerableProperty(exception, '__sentry_captured__', true);
    }
    catch (err) {
        // `exception` is a primitive, so we can't mark it seen
    }
    return false;
}

/**
 * Recursively normalizes the given object.
 *
 * - Creates a copy to prevent original input mutation
 * - Skips non-enumerable properties
 * - When stringifying, calls `toJSON` if implemented
 * - Removes circular references
 * - Translates non-serializable values (`undefined`/`NaN`/functions) to serializable format
 * - Translates known global objects/classes to a string representations
 * - Takes care of `Error` object serialization
 * - Optionally limits depth of final output
 * - Optionally limits number of properties/elements included in any single object/array
 *
 * @param input The object to be normalized.
 * @param depth The max depth to which to normalize the object. (Anything deeper stringified whole.)
 * @param maxProperties The max number of elements or properties to be included in any single array or
 * object in the normallized output..
 * @returns A normalized version of the object, or `"**non-serializable**"` if any errors are thrown during normalization.
 */
function normalize(input, depth, maxProperties) {
    if (depth === void 0) { depth = +Infinity; }
    if (maxProperties === void 0) { maxProperties = +Infinity; }
    try {
        // since we're at the outermost level, there is no key
        return visit('', input, depth, maxProperties);
    }
    catch (err) {
        return { ERROR: "**non-serializable** (" + err + ")" };
    }
}
/** JSDoc */
function normalizeToSize(object, 
// Default Node.js REPL depth
depth, 
// 100kB, as 200kB is max payload size, so half sounds reasonable
maxSize) {
    if (depth === void 0) { depth = 3; }
    if (maxSize === void 0) { maxSize = 100 * 1024; }
    var normalized = normalize(object, depth);
    if (jsonSize(normalized) > maxSize) {
        return normalizeToSize(object, depth - 1, maxSize);
    }
    return normalized;
}
/**
 * Visits a node to perform normalization on it
 *
 * @param key The key corresponding to the given node
 * @param value The node to be visited
 * @param depth Optional number indicating the maximum recursion depth
 * @param maxProperties Optional maximum number of properties/elements included in any single object/array
 * @param memo Optional Memo class handling decycling
 */
function visit(key, value, depth, maxProperties, memo) {
    if (depth === void 0) { depth = +Infinity; }
    if (maxProperties === void 0) { maxProperties = +Infinity; }
    if (memo === void 0) { memo = memoBuilder(); }
    var _a = __read$4(memo, 2), memoize = _a[0], unmemoize = _a[1];
    // If the value has a `toJSON` method, see if we can bail and let it do the work
    var valueWithToJSON = value;
    if (valueWithToJSON && typeof valueWithToJSON.toJSON === 'function') {
        try {
            return valueWithToJSON.toJSON();
        }
        catch (err) {
            // pass (The built-in `toJSON` failed, but we can still try to do it ourselves)
        }
    }
    // Get the simple cases out of the way first
    if (value === null || (['number', 'boolean', 'string'].includes(typeof value) && !isNaN$1(value))) {
        return value;
    }
    var stringified = stringifyValue(key, value);
    // Anything we could potentially dig into more (objects or arrays) will have come back as `"[object XXXX]"`.
    // Everything else will have already been serialized, so if we don't see that pattern, we're done.
    if (!stringified.startsWith('[object ')) {
        return stringified;
    }
    // We're also done if we've reached the max depth
    if (depth === 0) {
        // At this point we know `serialized` is a string of the form `"[object XXXX]"`. Clean it up so it's just `"[XXXX]"`.
        return stringified.replace('object ', '');
    }
    // If we've already visited this branch, bail out, as it's circular reference. If not, note that we're seeing it now.
    if (memoize(value)) {
        return '[Circular ~]';
    }
    // At this point we know we either have an object or an array, we haven't seen it before, and we're going to recurse
    // because we haven't yet reached the max depth. Create an accumulator to hold the results of visiting each
    // property/entry, and keep track of the number of items we add to it.
    var normalized = (Array.isArray(value) ? [] : {});
    var numAdded = 0;
    // Before we begin, convert`Error` and`Event` instances into plain objects, since some of each of their relevant
    // properties are non-enumerable and otherwise would get missed.
    var visitable = (isError(value) || isEvent(value) ? convertToPlainObject(value) : value);
    for (var visitKey in visitable) {
        // Avoid iterating over fields in the prototype if they've somehow been exposed to enumeration.
        if (!Object.prototype.hasOwnProperty.call(visitable, visitKey)) {
            continue;
        }
        if (numAdded >= maxProperties) {
            normalized[visitKey] = '[MaxProperties ~]';
            break;
        }
        // Recursively visit all the child nodes
        var visitValue = visitable[visitKey];
        normalized[visitKey] = visit(visitKey, visitValue, depth - 1, maxProperties, memo);
        numAdded += 1;
    }
    // Once we've visited all the branches, remove the parent from memo storage
    unmemoize(value);
    // Return accumulated values
    return normalized;
}
/**
 * Stringify the given value. Handles various known special values and types.
 *
 * Not meant to be used on simple primitives which already have a string representation, as it will, for example, turn
 * the number 1231 into "[Object Number]", nor on `null`, as it will throw.
 *
 * @param value The value to stringify
 * @returns A stringified representation of the given value
 */
function stringifyValue(key, 
// this type is a tiny bit of a cheat, since this function does handle NaN (which is technically a number), but for
// our internal use, it'll do
value) {
    try {
        if (key === 'domain' && value && typeof value === 'object' && value._events) {
            return '[Domain]';
        }
        if (key === 'domainEmitter') {
            return '[DomainEmitter]';
        }
        // It's safe to use `global`, `window`, and `document` here in this manner, as we are asserting using `typeof` first
        // which won't throw if they are not present.
        if (typeof global !== 'undefined' && value === global) {
            return '[Global]';
        }
        // eslint-disable-next-line no-restricted-globals
        if (typeof window !== 'undefined' && value === window) {
            return '[Window]';
        }
        // eslint-disable-next-line no-restricted-globals
        if (typeof document !== 'undefined' && value === document) {
            return '[Document]';
        }
        // React's SyntheticEvent thingy
        if (isSyntheticEvent(value)) {
            return '[SyntheticEvent]';
        }
        if (typeof value === 'number' && value !== value) {
            return '[NaN]';
        }
        // this catches `undefined` (but not `null`, which is a primitive and can be serialized on its own)
        if (value === void 0) {
            return '[undefined]';
        }
        if (typeof value === 'function') {
            return "[Function: " + getFunctionName(value) + "]";
        }
        if (typeof value === 'symbol') {
            return "[" + String(value) + "]";
        }
        // stringified BigInts are indistinguishable from regular numbers, so we need to label them to avoid confusion
        if (typeof value === 'bigint') {
            return "[BigInt: " + String(value) + "]";
        }
        // Now that we've knocked out all the special cases and the primitives, all we have left are objects. Simply casting
        // them to strings means that instances of classes which haven't defined their `toStringTag` will just come out as
        // `"[object Object]"`. If we instead look at the constructor's name (which is the same as the name of the class),
        // we can make sure that only plain objects come out that way.
        return "[object " + Object.getPrototypeOf(value).constructor.name + "]";
    }
    catch (err) {
        return "**non-serializable** (" + err + ")";
    }
}
/** Calculates bytes size of input string */
function utf8Length(value) {
    // eslint-disable-next-line no-bitwise
    return ~-encodeURI(value).split(/%..|./).length;
}
/** Calculates bytes size of input object */
function jsonSize(value) {
    return utf8Length(JSON.stringify(value));
}

/* eslint-disable @typescript-eslint/explicit-function-return-type */
/**
 * Creates a resolved sync promise.
 *
 * @param value the value to resolve the promise with
 * @returns the resolved sync promise
 */
function resolvedSyncPromise(value) {
    return new SyncPromise(function (resolve) {
        resolve(value);
    });
}
/**
 * Creates a rejected sync promise.
 *
 * @param value the value to reject the promise with
 * @returns the rejected sync promise
 */
function rejectedSyncPromise(reason) {
    return new SyncPromise(function (_, reject) {
        reject(reason);
    });
}
/**
 * Thenable class that behaves like a Promise and follows it's interface
 * but is not async internally
 */
var SyncPromise = /** @class */ (function () {
    function SyncPromise(executor) {
        var _this = this;
        this._state = 0 /* PENDING */;
        this._handlers = [];
        /** JSDoc */
        this._resolve = function (value) {
            _this._setResult(1 /* RESOLVED */, value);
        };
        /** JSDoc */
        this._reject = function (reason) {
            _this._setResult(2 /* REJECTED */, reason);
        };
        /** JSDoc */
        this._setResult = function (state, value) {
            if (_this._state !== 0 /* PENDING */) {
                return;
            }
            if (isThenable(value)) {
                void value.then(_this._resolve, _this._reject);
                return;
            }
            _this._state = state;
            _this._value = value;
            _this._executeHandlers();
        };
        /** JSDoc */
        this._executeHandlers = function () {
            if (_this._state === 0 /* PENDING */) {
                return;
            }
            var cachedHandlers = _this._handlers.slice();
            _this._handlers = [];
            cachedHandlers.forEach(function (handler) {
                if (handler[0]) {
                    return;
                }
                if (_this._state === 1 /* RESOLVED */) {
                    // eslint-disable-next-line @typescript-eslint/no-floating-promises
                    handler[1](_this._value);
                }
                if (_this._state === 2 /* REJECTED */) {
                    handler[2](_this._value);
                }
                handler[0] = true;
            });
        };
        try {
            executor(this._resolve, this._reject);
        }
        catch (e) {
            this._reject(e);
        }
    }
    /** JSDoc */
    SyncPromise.prototype.then = function (onfulfilled, onrejected) {
        var _this = this;
        return new SyncPromise(function (resolve, reject) {
            _this._handlers.push([
                false,
                function (result) {
                    if (!onfulfilled) {
                        // TODO: ¯\_(ツ)_/¯
                        // TODO: FIXME
                        resolve(result);
                    }
                    else {
                        try {
                            resolve(onfulfilled(result));
                        }
                        catch (e) {
                            reject(e);
                        }
                    }
                },
                function (reason) {
                    if (!onrejected) {
                        reject(reason);
                    }
                    else {
                        try {
                            resolve(onrejected(reason));
                        }
                        catch (e) {
                            reject(e);
                        }
                    }
                },
            ]);
            _this._executeHandlers();
        });
    };
    /** JSDoc */
    SyncPromise.prototype.catch = function (onrejected) {
        return this.then(function (val) { return val; }, onrejected);
    };
    /** JSDoc */
    SyncPromise.prototype.finally = function (onfinally) {
        var _this = this;
        return new SyncPromise(function (resolve, reject) {
            var val;
            var isRejected;
            return _this.then(function (value) {
                isRejected = false;
                val = value;
                if (onfinally) {
                    onfinally();
                }
            }, function (reason) {
                isRejected = true;
                val = reason;
                if (onfinally) {
                    onfinally();
                }
            }).then(function () {
                if (isRejected) {
                    reject(val);
                    return;
                }
                resolve(val);
            });
        });
    };
    return SyncPromise;
}());

/**
 * Creates an new PromiseBuffer object with the specified limit
 * @param limit max number of promises that can be stored in the buffer
 */
function makePromiseBuffer(limit) {
    var buffer = [];
    function isReady() {
        return limit === undefined || buffer.length < limit;
    }
    /**
     * Remove a promise from the queue.
     *
     * @param task Can be any PromiseLike<T>
     * @returns Removed promise.
     */
    function remove(task) {
        return buffer.splice(buffer.indexOf(task), 1)[0];
    }
    /**
     * Add a promise (representing an in-flight action) to the queue, and set it to remove itself on fulfillment.
     *
     * @param taskProducer A function producing any PromiseLike<T>; In previous versions this used to be `task:
     *        PromiseLike<T>`, but under that model, Promises were instantly created on the call-site and their executor
     *        functions therefore ran immediately. Thus, even if the buffer was full, the action still happened. By
     *        requiring the promise to be wrapped in a function, we can defer promise creation until after the buffer
     *        limit check.
     * @returns The original promise.
     */
    function add(taskProducer) {
        if (!isReady()) {
            return rejectedSyncPromise(new SentryError('Not adding Promise due to buffer limit reached.'));
        }
        // start the task and add its promise to the queue
        var task = taskProducer();
        if (buffer.indexOf(task) === -1) {
            buffer.push(task);
        }
        void task
            .then(function () { return remove(task); })
            // Use `then(null, rejectionHandler)` rather than `catch(rejectionHandler)` so that we can use `PromiseLike`
            // rather than `Promise`. `PromiseLike` doesn't have a `.catch` method, making its polyfill smaller. (ES5 didn't
            // have promises, so TS has to polyfill when down-compiling.)
            .then(null, function () {
            return remove(task).then(null, function () {
                // We have to add another catch here because `remove()` starts a new promise chain.
            });
        });
        return task;
    }
    /**
     * Wait for all promises in the queue to resolve or for timeout to expire, whichever comes first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the queue is still non-empty. Passing `0` (or
     * not passing anything) will make the promise wait as long as it takes for the queue to drain before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if the queue is already empty or drains before the timeout, and
     * `false` otherwise
     */
    function drain(timeout) {
        return new SyncPromise(function (resolve, reject) {
            var counter = buffer.length;
            if (!counter) {
                return resolve(true);
            }
            // wait for `timeout` ms and then resolve to `false` (if not cancelled first)
            var capturedSetTimeout = setTimeout(function () {
                if (timeout && timeout > 0) {
                    resolve(false);
                }
            }, timeout);
            // if all promises resolve in time, cancel the timer and resolve to `true`
            buffer.forEach(function (item) {
                void resolvedSyncPromise(item).then(function () {
                    // eslint-disable-next-line no-plusplus
                    if (!--counter) {
                        clearTimeout(capturedSetTimeout);
                        resolve(true);
                    }
                }, reject);
            });
        });
    }
    return {
        $: buffer,
        add: add,
        drain: drain,
    };
}

function isSupportedSeverity(level) {
    return SeverityLevels.indexOf(level) !== -1;
}
/**
 * Converts a string-based level into a {@link Severity}.
 *
 * @param level string representation of Severity
 * @returns Severity
 */
function severityFromString(level) {
    if (level === 'warn')
        return Severity.Warning;
    if (isSupportedSeverity(level)) {
        return level;
    }
    return Severity.Log;
}

/**
 * Converts an HTTP status code to sentry status {@link EventStatus}.
 *
 * @param code number HTTP status code
 * @returns EventStatus
 */
function eventStatusFromHttpCode(code) {
    if (code >= 200 && code < 300) {
        return 'success';
    }
    if (code === 429) {
        return 'rate_limit';
    }
    if (code >= 400 && code < 500) {
        return 'invalid';
    }
    if (code >= 500) {
        return 'failed';
    }
    return 'unknown';
}

/**
 * A TimestampSource implementation for environments that do not support the Performance Web API natively.
 *
 * Note that this TimestampSource does not use a monotonic clock. A call to `nowSeconds` may return a timestamp earlier
 * than a previously returned value. We do not try to emulate a monotonic behavior in order to facilitate debugging. It
 * is more obvious to explain "why does my span have negative duration" than "why my spans have zero duration".
 */
var dateTimestampSource = {
    nowSeconds: function () { return Date.now() / 1000; },
};
/**
 * Returns a wrapper around the native Performance API browser implementation, or undefined for browsers that do not
 * support the API.
 *
 * Wrapping the native API works around differences in behavior from different browsers.
 */
function getBrowserPerformance() {
    var performance = getGlobalObject().performance;
    if (!performance || !performance.now) {
        return undefined;
    }
    // Replace performance.timeOrigin with our own timeOrigin based on Date.now().
    //
    // This is a partial workaround for browsers reporting performance.timeOrigin such that performance.timeOrigin +
    // performance.now() gives a date arbitrarily in the past.
    //
    // Additionally, computing timeOrigin in this way fills the gap for browsers where performance.timeOrigin is
    // undefined.
    //
    // The assumption that performance.timeOrigin + performance.now() ~= Date.now() is flawed, but we depend on it to
    // interact with data coming out of performance entries.
    //
    // Note that despite recommendations against it in the spec, browsers implement the Performance API with a clock that
    // might stop when the computer is asleep (and perhaps under other circumstances). Such behavior causes
    // performance.timeOrigin + performance.now() to have an arbitrary skew over Date.now(). In laptop computers, we have
    // observed skews that can be as long as days, weeks or months.
    //
    // See https://github.com/getsentry/sentry-javascript/issues/2590.
    //
    // BUG: despite our best intentions, this workaround has its limitations. It mostly addresses timings of pageload
    // transactions, but ignores the skew built up over time that can aversely affect timestamps of navigation
    // transactions of long-lived web pages.
    var timeOrigin = Date.now() - performance.now();
    return {
        now: function () { return performance.now(); },
        timeOrigin: timeOrigin,
    };
}
/**
 * Returns the native Performance API implementation from Node.js. Returns undefined in old Node.js versions that don't
 * implement the API.
 */
function getNodePerformance() {
    try {
        var perfHooks = dynamicRequire(module, 'perf_hooks');
        return perfHooks.performance;
    }
    catch (_) {
        return undefined;
    }
}
/**
 * The Performance API implementation for the current platform, if available.
 */
var platformPerformance = isNodeEnv() ? getNodePerformance() : getBrowserPerformance();
var timestampSource = platformPerformance === undefined
    ? dateTimestampSource
    : {
        nowSeconds: function () { return (platformPerformance.timeOrigin + platformPerformance.now()) / 1000; },
    };
/**
 * Returns a timestamp in seconds since the UNIX epoch using the Date API.
 */
var dateTimestampInSeconds = dateTimestampSource.nowSeconds.bind(dateTimestampSource);
/**
 * Returns a timestamp in seconds since the UNIX epoch using either the Performance or Date APIs, depending on the
 * availability of the Performance API.
 *
 * See `usingPerformanceAPI` to test whether the Performance API is used.
 *
 * BUG: Note that because of how browsers implement the Performance API, the clock might stop when the computer is
 * asleep. This creates a skew between `dateTimestampInSeconds` and `timestampInSeconds`. The
 * skew can grow to arbitrary amounts like days, weeks or months.
 * See https://github.com/getsentry/sentry-javascript/issues/2590.
 */
var timestampInSeconds = timestampSource.nowSeconds.bind(timestampSource);
// Re-exported with an old name for backwards-compatibility.
var timestampWithMs = timestampInSeconds;
/**
 * The number of milliseconds since the UNIX epoch. This value is only usable in a browser, and only when the
 * performance API is available.
 */
var browserPerformanceTimeOrigin = (function () {
    // Unfortunately browsers may report an inaccurate time origin data, through either performance.timeOrigin or
    // performance.timing.navigationStart, which results in poor results in performance data. We only treat time origin
    // data as reliable if they are within a reasonable threshold of the current time.
    var performance = getGlobalObject().performance;
    if (!performance || !performance.now) {
        return undefined;
    }
    var threshold = 3600 * 1000;
    var performanceNow = performance.now();
    var dateNow = Date.now();
    // if timeOrigin isn't available set delta to threshold so it isn't used
    var timeOriginDelta = performance.timeOrigin
        ? Math.abs(performance.timeOrigin + performanceNow - dateNow)
        : threshold;
    var timeOriginIsReliable = timeOriginDelta < threshold;
    // While performance.timing.navigationStart is deprecated in favor of performance.timeOrigin, performance.timeOrigin
    // is not as widely supported. Namely, performance.timeOrigin is undefined in Safari as of writing.
    // Also as of writing, performance.timing is not available in Web Workers in mainstream browsers, so it is not always
    // a valid fallback. In the absence of an initial time provided by the browser, fallback to the current time from the
    // Date API.
    // eslint-disable-next-line deprecation/deprecation
    var navigationStart = performance.timing && performance.timing.navigationStart;
    var hasNavigationStart = typeof navigationStart === 'number';
    // if navigationStart isn't available set delta to threshold so it isn't used
    var navigationStartDelta = hasNavigationStart ? Math.abs(navigationStart + performanceNow - dateNow) : threshold;
    var navigationStartIsReliable = navigationStartDelta < threshold;
    if (timeOriginIsReliable || navigationStartIsReliable) {
        // Use the more reliable time origin
        if (timeOriginDelta <= navigationStartDelta) {
            return performance.timeOrigin;
        }
        else {
            return navigationStart;
        }
    }
    return dateNow;
})();

var TRACEPARENT_REGEXP = new RegExp('^[ \\t]*' + // whitespace
    '([0-9a-f]{32})?' + // trace_id
    '-?([0-9a-f]{16})?' + // span_id
    '-?([01])?' + // sampled
    '[ \\t]*$');
/**
 * Extract transaction context data from a `sentry-trace` header.
 *
 * @param traceparent Traceparent string
 *
 * @returns Object containing data from the header, or undefined if traceparent string is malformed
 */
function extractTraceparentData(traceparent) {
    var matches = traceparent.match(TRACEPARENT_REGEXP);
    if (matches) {
        var parentSampled = void 0;
        if (matches[3] === '1') {
            parentSampled = true;
        }
        else if (matches[3] === '0') {
            parentSampled = false;
        }
        return {
            traceId: matches[1],
            parentSampled: parentSampled,
            parentSpanId: matches[2],
        };
    }
    return undefined;
}

/**
 * Creates an envelope.
 * Make sure to always explicitly provide the generic to this function
 * so that the envelope types resolve correctly.
 */
function createEnvelope(headers, items) {
    if (items === void 0) { items = []; }
    return [headers, items];
}
/**
 * Get the type of the envelope. Grabs the type from the first envelope item.
 */
function getEnvelopeType(envelope) {
    var _a = __read$4(envelope, 2), _b = __read$4(_a[1], 1), _c = __read$4(_b[0], 1), firstItemHeader = _c[0];
    return firstItemHeader.type;
}
/**
 * Serializes an envelope into a string.
 */
function serializeEnvelope(envelope) {
    var _a = __read$4(envelope, 2), headers = _a[0], items = _a[1];
    var serializedHeaders = JSON.stringify(headers);
    // Have to cast items to any here since Envelope is a union type
    // Fixed in Typescript 4.2
    // TODO: Remove any[] cast when we upgrade to TS 4.2
    // https://github.com/microsoft/TypeScript/issues/36390
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return items.reduce(function (acc, item) {
        var _a = __read$4(item, 2), itemHeaders = _a[0], payload = _a[1];
        // We do not serialize payloads that are primitives
        var serializedPayload = isPrimitive(payload) ? String(payload) : JSON.stringify(payload);
        return acc + "\n" + JSON.stringify(itemHeaders) + "\n" + serializedPayload;
    }, serializedHeaders);
}

/**
 * Creates client report envelope
 * @param discarded_events An array of discard events
 * @param dsn A DSN that can be set on the header. Optional.
 */
function createClientReportEnvelope(discarded_events, dsn, timestamp) {
    var clientReportItem = [
        { type: 'client_report' },
        {
            timestamp: timestamp || dateTimestampInSeconds(),
            discarded_events: discarded_events,
        },
    ];
    return createEnvelope(dsn ? { dsn: dsn } : {}, [clientReportItem]);
}

var DEFAULT_RETRY_AFTER = 60 * 1000; // 60 seconds
/**
 * Extracts Retry-After value from the request header or returns default value
 * @param header string representation of 'Retry-After' header
 * @param now current unix timestamp
 *
 */
function parseRetryAfterHeader(header, now) {
    if (now === void 0) { now = Date.now(); }
    var headerDelay = parseInt("" + header, 10);
    if (!isNaN(headerDelay)) {
        return headerDelay * 1000;
    }
    var headerDate = Date.parse("" + header);
    if (!isNaN(headerDate)) {
        return headerDate - now;
    }
    return DEFAULT_RETRY_AFTER;
}
/**
 * Gets the time that given category is disabled until for rate limiting
 */
function disabledUntil(limits, category) {
    return limits[category] || limits.all || 0;
}
/**
 * Checks if a category is rate limited
 */
function isRateLimited(limits, category, now) {
    if (now === void 0) { now = Date.now(); }
    return disabledUntil(limits, category) > now;
}
/**
 * Update ratelimits from incoming headers.
 * Returns true if headers contains a non-empty rate limiting header.
 */
function updateRateLimits(limits, headers, now) {
    var e_1, _a, e_2, _b;
    if (now === void 0) { now = Date.now(); }
    var updatedRateLimits = __assign$2({}, limits);
    // "The name is case-insensitive."
    // https://developer.mozilla.org/en-US/docs/Web/API/Headers/get
    var rateLimitHeader = headers['x-sentry-rate-limits'];
    var retryAfterHeader = headers['retry-after'];
    if (rateLimitHeader) {
        try {
            /**
             * rate limit headers are of the form
             *     <header>,<header>,..
             * where each <header> is of the form
             *     <retry_after>: <categories>: <scope>: <reason_code>
             * where
             *     <retry_after> is a delay in seconds
             *     <categories> is the event type(s) (error, transaction, etc) being rate limited and is of the form
             *         <category>;<category>;...
             *     <scope> is what's being limited (org, project, or key) - ignored by SDK
             *     <reason_code> is an arbitrary string like "org_quota" - ignored by SDK
             */
            for (var _c = __values(rateLimitHeader.trim().split(',')), _d = _c.next(); !_d.done; _d = _c.next()) {
                var limit = _d.value;
                var parameters = limit.split(':', 2);
                var headerDelay = parseInt(parameters[0], 10);
                var delay = (!isNaN(headerDelay) ? headerDelay : 60) * 1000; // 60sec default
                if (!parameters[1]) {
                    updatedRateLimits.all = now + delay;
                }
                else {
                    try {
                        for (var _e = (e_2 = void 0, __values(parameters[1].split(';'))), _f = _e.next(); !_f.done; _f = _e.next()) {
                            var category = _f.value;
                            updatedRateLimits[category] = now + delay;
                        }
                    }
                    catch (e_2_1) { e_2 = { error: e_2_1 }; }
                    finally {
                        try {
                            if (_f && !_f.done && (_b = _e.return)) _b.call(_e);
                        }
                        finally { if (e_2) throw e_2.error; }
                    }
                }
            }
        }
        catch (e_1_1) { e_1 = { error: e_1_1 }; }
        finally {
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            }
            finally { if (e_1) throw e_1.error; }
        }
    }
    else if (retryAfterHeader) {
        updatedRateLimits.all = now + parseRetryAfterHeader(retryAfterHeader, now);
    }
    return updatedRateLimits;
}

/**
 * Absolute maximum number of breadcrumbs added to an event.
 * The `maxBreadcrumbs` option cannot be higher than this value.
 */
var MAX_BREADCRUMBS = 100;
/**
 * Holds additional event information. {@link Scope.applyToEvent} will be
 * called by the client before an event will be sent.
 */
var Scope = /** @class */ (function () {
    function Scope() {
        /** Flag if notifying is happening. */
        this._notifyingListeners = false;
        /** Callback for client to receive scope changes. */
        this._scopeListeners = [];
        /** Callback list that will be called after {@link applyToEvent}. */
        this._eventProcessors = [];
        /** Array of breadcrumbs. */
        this._breadcrumbs = [];
        /** User */
        this._user = {};
        /** Tags */
        this._tags = {};
        /** Extra */
        this._extra = {};
        /** Contexts */
        this._contexts = {};
        /**
         * A place to stash data which is needed at some point in the SDK's event processing pipeline but which shouldn't get
         * sent to Sentry
         */
        this._sdkProcessingMetadata = {};
    }
    /**
     * Inherit values from the parent scope.
     * @param scope to clone.
     */
    Scope.clone = function (scope) {
        var newScope = new Scope();
        if (scope) {
            newScope._breadcrumbs = __spread$1(scope._breadcrumbs);
            newScope._tags = __assign$2({}, scope._tags);
            newScope._extra = __assign$2({}, scope._extra);
            newScope._contexts = __assign$2({}, scope._contexts);
            newScope._user = scope._user;
            newScope._level = scope._level;
            newScope._span = scope._span;
            newScope._session = scope._session;
            newScope._transactionName = scope._transactionName;
            newScope._fingerprint = scope._fingerprint;
            newScope._eventProcessors = __spread$1(scope._eventProcessors);
            newScope._requestSession = scope._requestSession;
        }
        return newScope;
    };
    /**
     * Add internal on change listener. Used for sub SDKs that need to store the scope.
     * @hidden
     */
    Scope.prototype.addScopeListener = function (callback) {
        this._scopeListeners.push(callback);
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addEventProcessor = function (callback) {
        this._eventProcessors.push(callback);
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setUser = function (user) {
        this._user = user || {};
        if (this._session) {
            this._session.update({ user: user });
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getUser = function () {
        return this._user;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getRequestSession = function () {
        return this._requestSession;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setRequestSession = function (requestSession) {
        this._requestSession = requestSession;
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTags = function (tags) {
        this._tags = __assign$2(__assign$2({}, this._tags), tags);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTag = function (key, value) {
        var _a;
        this._tags = __assign$2(__assign$2({}, this._tags), (_a = {}, _a[key] = value, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtras = function (extras) {
        this._extra = __assign$2(__assign$2({}, this._extra), extras);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setExtra = function (key, extra) {
        var _a;
        this._extra = __assign$2(__assign$2({}, this._extra), (_a = {}, _a[key] = extra, _a));
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setFingerprint = function (fingerprint) {
        this._fingerprint = fingerprint;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setLevel = function (level) {
        this._level = level;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setTransactionName = function (name) {
        this._transactionName = name;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Can be removed in major version.
     * @deprecated in favor of {@link this.setTransactionName}
     */
    Scope.prototype.setTransaction = function (name) {
        return this.setTransactionName(name);
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setContext = function (key, context) {
        var _a;
        if (context === null) {
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this._contexts[key];
        }
        else {
            this._contexts = __assign$2(__assign$2({}, this._contexts), (_a = {}, _a[key] = context, _a));
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setSpan = function (span) {
        this._span = span;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getSpan = function () {
        return this._span;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getTransaction = function () {
        // Often, this span (if it exists at all) will be a transaction, but it's not guaranteed to be. Regardless, it will
        // have a pointer to the currently-active transaction.
        var span = this.getSpan();
        return span && span.transaction;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.setSession = function (session) {
        if (!session) {
            delete this._session;
        }
        else {
            this._session = session;
        }
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.getSession = function () {
        return this._session;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.update = function (captureContext) {
        if (!captureContext) {
            return this;
        }
        if (typeof captureContext === 'function') {
            var updatedScope = captureContext(this);
            return updatedScope instanceof Scope ? updatedScope : this;
        }
        if (captureContext instanceof Scope) {
            this._tags = __assign$2(__assign$2({}, this._tags), captureContext._tags);
            this._extra = __assign$2(__assign$2({}, this._extra), captureContext._extra);
            this._contexts = __assign$2(__assign$2({}, this._contexts), captureContext._contexts);
            if (captureContext._user && Object.keys(captureContext._user).length) {
                this._user = captureContext._user;
            }
            if (captureContext._level) {
                this._level = captureContext._level;
            }
            if (captureContext._fingerprint) {
                this._fingerprint = captureContext._fingerprint;
            }
            if (captureContext._requestSession) {
                this._requestSession = captureContext._requestSession;
            }
        }
        else if (isPlainObject(captureContext)) {
            // eslint-disable-next-line no-param-reassign
            captureContext = captureContext;
            this._tags = __assign$2(__assign$2({}, this._tags), captureContext.tags);
            this._extra = __assign$2(__assign$2({}, this._extra), captureContext.extra);
            this._contexts = __assign$2(__assign$2({}, this._contexts), captureContext.contexts);
            if (captureContext.user) {
                this._user = captureContext.user;
            }
            if (captureContext.level) {
                this._level = captureContext.level;
            }
            if (captureContext.fingerprint) {
                this._fingerprint = captureContext.fingerprint;
            }
            if (captureContext.requestSession) {
                this._requestSession = captureContext.requestSession;
            }
        }
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clear = function () {
        this._breadcrumbs = [];
        this._tags = {};
        this._extra = {};
        this._user = {};
        this._contexts = {};
        this._level = undefined;
        this._transactionName = undefined;
        this._fingerprint = undefined;
        this._requestSession = undefined;
        this._span = undefined;
        this._session = undefined;
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.addBreadcrumb = function (breadcrumb, maxBreadcrumbs) {
        var maxCrumbs = typeof maxBreadcrumbs === 'number' ? Math.min(maxBreadcrumbs, MAX_BREADCRUMBS) : MAX_BREADCRUMBS;
        // No data has been changed, so don't notify scope listeners
        if (maxCrumbs <= 0) {
            return this;
        }
        var mergedBreadcrumb = __assign$2({ timestamp: dateTimestampInSeconds() }, breadcrumb);
        this._breadcrumbs = __spread$1(this._breadcrumbs, [mergedBreadcrumb]).slice(-maxCrumbs);
        this._notifyScopeListeners();
        return this;
    };
    /**
     * @inheritDoc
     */
    Scope.prototype.clearBreadcrumbs = function () {
        this._breadcrumbs = [];
        this._notifyScopeListeners();
        return this;
    };
    /**
     * Applies the current context and fingerprint to the event.
     * Note that breadcrumbs will be added by the client.
     * Also if the event has already breadcrumbs on it, we do not merge them.
     * @param event Event
     * @param hint May contain additional information about the original exception.
     * @hidden
     */
    Scope.prototype.applyToEvent = function (event, hint) {
        if (this._extra && Object.keys(this._extra).length) {
            event.extra = __assign$2(__assign$2({}, this._extra), event.extra);
        }
        if (this._tags && Object.keys(this._tags).length) {
            event.tags = __assign$2(__assign$2({}, this._tags), event.tags);
        }
        if (this._user && Object.keys(this._user).length) {
            event.user = __assign$2(__assign$2({}, this._user), event.user);
        }
        if (this._contexts && Object.keys(this._contexts).length) {
            event.contexts = __assign$2(__assign$2({}, this._contexts), event.contexts);
        }
        if (this._level) {
            event.level = this._level;
        }
        if (this._transactionName) {
            event.transaction = this._transactionName;
        }
        // We want to set the trace context for normal events only if there isn't already
        // a trace context on the event. There is a product feature in place where we link
        // errors with transaction and it relies on that.
        if (this._span) {
            event.contexts = __assign$2({ trace: this._span.getTraceContext() }, event.contexts);
            var transactionName = this._span.transaction && this._span.transaction.name;
            if (transactionName) {
                event.tags = __assign$2({ transaction: transactionName }, event.tags);
            }
        }
        this._applyFingerprint(event);
        event.breadcrumbs = __spread$1((event.breadcrumbs || []), this._breadcrumbs);
        event.breadcrumbs = event.breadcrumbs.length > 0 ? event.breadcrumbs : undefined;
        event.sdkProcessingMetadata = this._sdkProcessingMetadata;
        return this._notifyEventProcessors(__spread$1(getGlobalEventProcessors(), this._eventProcessors), event, hint);
    };
    /**
     * Add data which will be accessible during event processing but won't get sent to Sentry
     */
    Scope.prototype.setSDKProcessingMetadata = function (newData) {
        this._sdkProcessingMetadata = __assign$2(__assign$2({}, this._sdkProcessingMetadata), newData);
        return this;
    };
    /**
     * This will be called after {@link applyToEvent} is finished.
     */
    Scope.prototype._notifyEventProcessors = function (processors, event, hint, index) {
        var _this = this;
        if (index === void 0) { index = 0; }
        return new SyncPromise(function (resolve, reject) {
            var processor = processors[index];
            if (event === null || typeof processor !== 'function') {
                resolve(event);
            }
            else {
                var result = processor(__assign$2({}, event), hint);
                if (isThenable(result)) {
                    void result
                        .then(function (final) { return _this._notifyEventProcessors(processors, final, hint, index + 1).then(resolve); })
                        .then(null, reject);
                }
                else {
                    void _this._notifyEventProcessors(processors, result, hint, index + 1)
                        .then(resolve)
                        .then(null, reject);
                }
            }
        });
    };
    /**
     * This will be called on every set call.
     */
    Scope.prototype._notifyScopeListeners = function () {
        var _this = this;
        // We need this check for this._notifyingListeners to be able to work on scope during updates
        // If this check is not here we'll produce endless recursion when something is done with the scope
        // during the callback.
        if (!this._notifyingListeners) {
            this._notifyingListeners = true;
            this._scopeListeners.forEach(function (callback) {
                callback(_this);
            });
            this._notifyingListeners = false;
        }
    };
    /**
     * Applies fingerprint from the scope to the event if there's one,
     * uses message if there's one instead or get rid of empty fingerprint
     */
    Scope.prototype._applyFingerprint = function (event) {
        // Make sure it's an array first and we actually have something in place
        event.fingerprint = event.fingerprint
            ? Array.isArray(event.fingerprint)
                ? event.fingerprint
                : [event.fingerprint]
            : [];
        // If we have something on the scope, then merge it with event
        if (this._fingerprint) {
            event.fingerprint = event.fingerprint.concat(this._fingerprint);
        }
        // If we have no data at all, remove empty array default
        if (event.fingerprint && !event.fingerprint.length) {
            delete event.fingerprint;
        }
    };
    return Scope;
}());
/**
 * Returns the global event processors.
 */
function getGlobalEventProcessors() {
    return getGlobalSingleton('globalEventProcessors', function () { return []; });
}
/**
 * Add a EventProcessor to be kept globally.
 * @param callback EventProcessor to add
 */
function addGlobalEventProcessor(callback) {
    getGlobalEventProcessors().push(callback);
}

/**
 * @inheritdoc
 */
var Session = /** @class */ (function () {
    function Session(context) {
        this.errors = 0;
        this.sid = uuid4();
        this.duration = 0;
        this.status = 'ok';
        this.init = true;
        this.ignoreDuration = false;
        // Both timestamp and started are in seconds since the UNIX epoch.
        var startingTime = timestampInSeconds();
        this.timestamp = startingTime;
        this.started = startingTime;
        if (context) {
            this.update(context);
        }
    }
    /** JSDoc */
    // eslint-disable-next-line complexity
    Session.prototype.update = function (context) {
        if (context === void 0) { context = {}; }
        if (context.user) {
            if (!this.ipAddress && context.user.ip_address) {
                this.ipAddress = context.user.ip_address;
            }
            if (!this.did && !context.did) {
                this.did = context.user.id || context.user.email || context.user.username;
            }
        }
        this.timestamp = context.timestamp || timestampInSeconds();
        if (context.ignoreDuration) {
            this.ignoreDuration = context.ignoreDuration;
        }
        if (context.sid) {
            // Good enough uuid validation. — Kamil
            this.sid = context.sid.length === 32 ? context.sid : uuid4();
        }
        if (context.init !== undefined) {
            this.init = context.init;
        }
        if (!this.did && context.did) {
            this.did = "" + context.did;
        }
        if (typeof context.started === 'number') {
            this.started = context.started;
        }
        if (this.ignoreDuration) {
            this.duration = undefined;
        }
        else if (typeof context.duration === 'number') {
            this.duration = context.duration;
        }
        else {
            var duration = this.timestamp - this.started;
            this.duration = duration >= 0 ? duration : 0;
        }
        if (context.release) {
            this.release = context.release;
        }
        if (context.environment) {
            this.environment = context.environment;
        }
        if (!this.ipAddress && context.ipAddress) {
            this.ipAddress = context.ipAddress;
        }
        if (!this.userAgent && context.userAgent) {
            this.userAgent = context.userAgent;
        }
        if (typeof context.errors === 'number') {
            this.errors = context.errors;
        }
        if (context.status) {
            this.status = context.status;
        }
    };
    /** JSDoc */
    Session.prototype.close = function (status) {
        if (status) {
            this.update({ status: status });
        }
        else if (this.status === 'ok') {
            this.update({ status: 'exited' });
        }
        else {
            this.update();
        }
    };
    /** JSDoc */
    Session.prototype.toJSON = function () {
        return dropUndefinedKeys({
            sid: "" + this.sid,
            init: this.init,
            // Make sure that sec is converted to ms for date constructor
            started: new Date(this.started * 1000).toISOString(),
            timestamp: new Date(this.timestamp * 1000).toISOString(),
            status: this.status,
            errors: this.errors,
            did: typeof this.did === 'number' || typeof this.did === 'string' ? "" + this.did : undefined,
            duration: this.duration,
            attrs: {
                release: this.release,
                environment: this.environment,
                ip_address: this.ipAddress,
                user_agent: this.userAgent,
            },
        });
    };
    return Session;
}());

/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */
/** Flag that is true for debug builds, false otherwise. */
var IS_DEBUG_BUILD$3 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

/**
 * API compatibility version of this hub.
 *
 * WARNING: This number should only be increased when the global interface
 * changes and new methods are introduced.
 *
 * @hidden
 */
var API_VERSION = 4;
/**
 * Default maximum number of breadcrumbs added to an event. Can be overwritten
 * with {@link Options.maxBreadcrumbs}.
 */
var DEFAULT_BREADCRUMBS = 100;
/**
 * @inheritDoc
 */
var Hub = /** @class */ (function () {
    /**
     * Creates a new instance of the hub, will push one {@link Layer} into the
     * internal stack on creation.
     *
     * @param client bound to the hub.
     * @param scope bound to the hub.
     * @param version number, higher number means higher priority.
     */
    function Hub(client, scope, _version) {
        if (scope === void 0) { scope = new Scope(); }
        if (_version === void 0) { _version = API_VERSION; }
        this._version = _version;
        /** Is a {@link Layer}[] containing the client and scope */
        this._stack = [{}];
        this.getStackTop().scope = scope;
        if (client) {
            this.bindClient(client);
        }
    }
    /**
     * @inheritDoc
     */
    Hub.prototype.isOlderThan = function (version) {
        return this._version < version;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.bindClient = function (client) {
        var top = this.getStackTop();
        top.client = client;
        if (client && client.setupIntegrations) {
            client.setupIntegrations();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.pushScope = function () {
        // We want to clone the content of prev scope
        var scope = Scope.clone(this.getScope());
        this.getStack().push({
            client: this.getClient(),
            scope: scope,
        });
        return scope;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.popScope = function () {
        if (this.getStack().length <= 1)
            return false;
        return !!this.getStack().pop();
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.withScope = function (callback) {
        var scope = this.pushScope();
        try {
            callback(scope);
        }
        finally {
            this.popScope();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getClient = function () {
        return this.getStackTop().client;
    };
    /** Returns the scope of the top stack. */
    Hub.prototype.getScope = function () {
        return this.getStackTop().scope;
    };
    /** Returns the scope stack for domains or the process. */
    Hub.prototype.getStack = function () {
        return this._stack;
    };
    /** Returns the topmost scope layer in the order domain > local > process. */
    Hub.prototype.getStackTop = function () {
        return this._stack[this._stack.length - 1];
    };
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Hub.prototype.captureException = function (exception, hint) {
        var eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : uuid4());
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error('Sentry syntheticException');
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: exception,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureException', exception, __assign$2(__assign$2({}, finalHint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureMessage = function (message, level, hint) {
        var eventId = (this._lastEventId = hint && hint.event_id ? hint.event_id : uuid4());
        var finalHint = hint;
        // If there's no explicit hint provided, mimic the same thing that would happen
        // in the minimal itself to create a consistent behavior.
        // We don't do this in the client, as it's the lowest level API, and doing this,
        // would prevent user from having full control over direct calls.
        if (!hint) {
            var syntheticException = void 0;
            try {
                throw new Error(message);
            }
            catch (exception) {
                syntheticException = exception;
            }
            finalHint = {
                originalException: message,
                syntheticException: syntheticException,
            };
        }
        this._invokeClient('captureMessage', message, level, __assign$2(__assign$2({}, finalHint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureEvent = function (event, hint) {
        var eventId = hint && hint.event_id ? hint.event_id : uuid4();
        if (event.type !== 'transaction') {
            this._lastEventId = eventId;
        }
        this._invokeClient('captureEvent', event, __assign$2(__assign$2({}, hint), { event_id: eventId }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.lastEventId = function () {
        return this._lastEventId;
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.addBreadcrumb = function (breadcrumb, hint) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope || !client)
            return;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _b = (client.getOptions && client.getOptions()) || {}, _c = _b.beforeBreadcrumb, beforeBreadcrumb = _c === void 0 ? null : _c, _d = _b.maxBreadcrumbs, maxBreadcrumbs = _d === void 0 ? DEFAULT_BREADCRUMBS : _d;
        if (maxBreadcrumbs <= 0)
            return;
        var timestamp = dateTimestampInSeconds();
        var mergedBreadcrumb = __assign$2({ timestamp: timestamp }, breadcrumb);
        var finalBreadcrumb = beforeBreadcrumb
            ? consoleSandbox(function () { return beforeBreadcrumb(mergedBreadcrumb, hint); })
            : mergedBreadcrumb;
        if (finalBreadcrumb === null)
            return;
        scope.addBreadcrumb(finalBreadcrumb, maxBreadcrumbs);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setUser = function (user) {
        var scope = this.getScope();
        if (scope)
            scope.setUser(user);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTags = function (tags) {
        var scope = this.getScope();
        if (scope)
            scope.setTags(tags);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtras = function (extras) {
        var scope = this.getScope();
        if (scope)
            scope.setExtras(extras);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setTag = function (key, value) {
        var scope = this.getScope();
        if (scope)
            scope.setTag(key, value);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.setExtra = function (key, extra) {
        var scope = this.getScope();
        if (scope)
            scope.setExtra(key, extra);
    };
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype.setContext = function (name, context) {
        var scope = this.getScope();
        if (scope)
            scope.setContext(name, context);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.configureScope = function (callback) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (scope && client) {
            callback(scope);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.run = function (callback) {
        var oldHub = makeMain(this);
        try {
            callback(this);
        }
        finally {
            makeMain(oldHub);
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.getIntegration = function (integration) {
        var client = this.getClient();
        if (!client)
            return null;
        try {
            return client.getIntegration(integration);
        }
        catch (_oO) {
            IS_DEBUG_BUILD$3 && logger.warn("Cannot retrieve integration " + integration.id + " from the current Hub");
            return null;
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startSpan = function (context) {
        return this._callExtensionMethod('startSpan', context);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startTransaction = function (context, customSamplingContext) {
        return this._callExtensionMethod('startTransaction', context, customSamplingContext);
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.traceHeaders = function () {
        return this._callExtensionMethod('traceHeaders');
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.captureSession = function (endSession) {
        if (endSession === void 0) { endSession = false; }
        // both send the update and pull the session from the scope
        if (endSession) {
            return this.endSession();
        }
        // only send the update
        this._sendSessionUpdate();
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.endSession = function () {
        var layer = this.getStackTop();
        var scope = layer && layer.scope;
        var session = scope && scope.getSession();
        if (session) {
            session.close();
        }
        this._sendSessionUpdate();
        // the session is over; take it off of the scope
        if (scope) {
            scope.setSession();
        }
    };
    /**
     * @inheritDoc
     */
    Hub.prototype.startSession = function (context) {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        var _b = (client && client.getOptions()) || {}, release = _b.release, environment = _b.environment;
        // Will fetch userAgent if called from browser sdk
        var global = getGlobalObject();
        var userAgent = (global.navigator || {}).userAgent;
        var session = new Session(__assign$2(__assign$2(__assign$2({ release: release,
            environment: environment }, (scope && { user: scope.getUser() })), (userAgent && { userAgent: userAgent })), context));
        if (scope) {
            // End existing session if there's one
            var currentSession = scope.getSession && scope.getSession();
            if (currentSession && currentSession.status === 'ok') {
                currentSession.update({ status: 'exited' });
            }
            this.endSession();
            // Afterwards we set the new session on the scope
            scope.setSession(session);
        }
        return session;
    };
    /**
     * Sends the current Session on the scope
     */
    Hub.prototype._sendSessionUpdate = function () {
        var _a = this.getStackTop(), scope = _a.scope, client = _a.client;
        if (!scope)
            return;
        var session = scope.getSession && scope.getSession();
        if (session) {
            if (client && client.captureSession) {
                client.captureSession(session);
            }
        }
    };
    /**
     * Internal helper function to call a method on the top client if it exists.
     *
     * @param method The method to call on the client.
     * @param args Arguments to pass to the client function.
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._invokeClient = function (method) {
        var _a;
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var _b = this.getStackTop(), scope = _b.scope, client = _b.client;
        if (client && client[method]) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, @typescript-eslint/no-explicit-any
            (_a = client)[method].apply(_a, __spread$1(args, [scope]));
        }
    };
    /**
     * Calls global extension method and binding current instance to the function call
     */
    // @ts-ignore Function lacks ending return statement and return type does not include 'undefined'. ts(2366)
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    Hub.prototype._callExtensionMethod = function (method) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        var carrier = getMainCarrier();
        var sentry = carrier.__SENTRY__;
        if (sentry && sentry.extensions && typeof sentry.extensions[method] === 'function') {
            return sentry.extensions[method].apply(this, args);
        }
        IS_DEBUG_BUILD$3 && logger.warn("Extension method " + method + " couldn't be found, doing nothing.");
    };
    return Hub;
}());
/**
 * Returns the global shim registry.
 *
 * FIXME: This function is problematic, because despite always returning a valid Carrier,
 * it has an optional `__SENTRY__` property, which then in turn requires us to always perform an unnecessary check
 * at the call-site. We always access the carrier through this function, so we can guarantee that `__SENTRY__` is there.
 **/
function getMainCarrier() {
    var carrier = getGlobalObject();
    carrier.__SENTRY__ = carrier.__SENTRY__ || {
        extensions: {},
        hub: undefined,
    };
    return carrier;
}
/**
 * Replaces the current main hub with the passed one on the global object
 *
 * @returns The old replaced hub
 */
function makeMain(hub) {
    var registry = getMainCarrier();
    var oldHub = getHubFromCarrier(registry);
    setHubOnCarrier(registry, hub);
    return oldHub;
}
/**
 * Returns the default hub instance.
 *
 * If a hub is already registered in the global carrier but this module
 * contains a more recent version, it replaces the registered version.
 * Otherwise, the currently registered hub will be returned.
 */
function getCurrentHub() {
    // Get main carrier (global for every environment)
    var registry = getMainCarrier();
    // If there's no hub, or its an old API, assign a new one
    if (!hasHubOnCarrier(registry) || getHubFromCarrier(registry).isOlderThan(API_VERSION)) {
        setHubOnCarrier(registry, new Hub());
    }
    // Prefer domains over global if they are there (applicable only to Node environment)
    if (isNodeEnv()) {
        return getHubFromActiveDomain(registry);
    }
    // Return hub that lives on a global object
    return getHubFromCarrier(registry);
}
/**
 * Try to read the hub from an active domain, and fallback to the registry if one doesn't exist
 * @returns discovered hub
 */
function getHubFromActiveDomain(registry) {
    try {
        var sentry = getMainCarrier().__SENTRY__;
        var activeDomain = sentry && sentry.extensions && sentry.extensions.domain && sentry.extensions.domain.active;
        // If there's no active domain, just return global hub
        if (!activeDomain) {
            return getHubFromCarrier(registry);
        }
        // If there's no hub on current domain, or it's an old API, assign a new one
        if (!hasHubOnCarrier(activeDomain) || getHubFromCarrier(activeDomain).isOlderThan(API_VERSION)) {
            var registryHubTopStack = getHubFromCarrier(registry).getStackTop();
            setHubOnCarrier(activeDomain, new Hub(registryHubTopStack.client, Scope.clone(registryHubTopStack.scope)));
        }
        // Return hub that lives on a domain
        return getHubFromCarrier(activeDomain);
    }
    catch (_Oo) {
        // Return hub that lives on a global object
        return getHubFromCarrier(registry);
    }
}
/**
 * This will tell whether a carrier has a hub on it or not
 * @param carrier object
 */
function hasHubOnCarrier(carrier) {
    return !!(carrier && carrier.__SENTRY__ && carrier.__SENTRY__.hub);
}
/**
 * This will create a new {@link Hub} and add to the passed object on
 * __SENTRY__.hub.
 * @param carrier object
 * @hidden
 */
function getHubFromCarrier(carrier) {
    return getGlobalSingleton('hub', function () { return new Hub(); }, carrier);
}
/**
 * This will set passed {@link Hub} on the passed object's __SENTRY__.hub attribute
 * @param carrier object
 * @param hub Hub
 * @returns A boolean indicating success or failure
 */
function setHubOnCarrier(carrier, hub) {
    if (!carrier)
        return false;
    var __SENTRY__ = (carrier.__SENTRY__ = carrier.__SENTRY__ || {});
    __SENTRY__.hub = hub;
    return true;
}

/**
 * This calls a function on the current hub.
 * @param method function to call on hub.
 * @param args to pass to function.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function callOnHub(method) {
    var args = [];
    for (var _i = 1; _i < arguments.length; _i++) {
        args[_i - 1] = arguments[_i];
    }
    var hub = getCurrentHub();
    if (hub && hub[method]) {
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        return hub[method].apply(hub, __spread$1(args));
    }
    throw new Error("No hub defined or " + method + " was not found on the hub, please open a bug report.");
}
/**
 * Captures an exception event and sends it to Sentry.
 *
 * @param exception An exception-like object.
 * @returns The generated eventId.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
function captureException(exception, captureContext) {
    var syntheticException = new Error('Sentry syntheticException');
    return callOnHub('captureException', exception, {
        captureContext: captureContext,
        originalException: exception,
        syntheticException: syntheticException,
    });
}
/**
 * Creates a new scope with and executes the given operation within.
 * The scope is automatically removed once the operation
 * finishes or throws.
 *
 * This is essentially a convenience function for:
 *
 *     pushScope();
 *     callback();
 *     popScope();
 *
 * @param callback that will be enclosed into push/popScope.
 */
function withScope(callback) {
    callOnHub('withScope', callback);
}

var SENTRY_API_VERSION = '7';
/** Initializes API Details */
function initAPIDetails(dsn, metadata, tunnel) {
    return {
        initDsn: dsn,
        metadata: metadata || {},
        dsn: makeDsn(dsn),
        tunnel: tunnel,
    };
}
/** Returns the prefix to construct Sentry ingestion API endpoints. */
function getBaseApiEndpoint(dsn) {
    var protocol = dsn.protocol ? dsn.protocol + ":" : '';
    var port = dsn.port ? ":" + dsn.port : '';
    return protocol + "//" + dsn.host + port + (dsn.path ? "/" + dsn.path : '') + "/api/";
}
/** Returns the ingest API endpoint for target. */
function _getIngestEndpoint(dsn, target) {
    return "" + getBaseApiEndpoint(dsn) + dsn.projectId + "/" + target + "/";
}
/** Returns a URL-encoded string with auth config suitable for a query string. */
function _encodedAuth(dsn) {
    return urlEncode({
        // We send only the minimum set of required information. See
        // https://github.com/getsentry/sentry-javascript/issues/2572.
        sentry_key: dsn.publicKey,
        sentry_version: SENTRY_API_VERSION,
    });
}
/** Returns the store endpoint URL. */
function getStoreEndpoint(dsn) {
    return _getIngestEndpoint(dsn, 'store');
}
/**
 * Returns the store endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */
function getStoreEndpointWithUrlEncodedAuth(dsn) {
    return getStoreEndpoint(dsn) + "?" + _encodedAuth(dsn);
}
/** Returns the envelope endpoint URL. */
function _getEnvelopeEndpoint(dsn) {
    return _getIngestEndpoint(dsn, 'envelope');
}
/**
 * Returns the envelope endpoint URL with auth in the query string.
 *
 * Sending auth as part of the query string and not as custom HTTP headers avoids CORS preflight requests.
 */
function getEnvelopeEndpointWithUrlEncodedAuth(dsn, tunnel) {
    return tunnel ? tunnel : _getEnvelopeEndpoint(dsn) + "?" + _encodedAuth(dsn);
}
/** Returns the url to the report dialog endpoint. */
function getReportDialogEndpoint(dsnLike, dialogOptions) {
    var dsn = makeDsn(dsnLike);
    var endpoint = getBaseApiEndpoint(dsn) + "embed/error-page/";
    var encodedOptions = "dsn=" + dsnToString(dsn);
    for (var key in dialogOptions) {
        if (key === 'dsn') {
            continue;
        }
        if (key === 'user') {
            if (!dialogOptions.user) {
                continue;
            }
            if (dialogOptions.user.name) {
                encodedOptions += "&name=" + encodeURIComponent(dialogOptions.user.name);
            }
            if (dialogOptions.user.email) {
                encodedOptions += "&email=" + encodeURIComponent(dialogOptions.user.email);
            }
        }
        else {
            encodedOptions += "&" + encodeURIComponent(key) + "=" + encodeURIComponent(dialogOptions[key]);
        }
    }
    return endpoint + "?" + encodedOptions;
}

/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */
/** Flag that is true for debug builds, false otherwise. */
var IS_DEBUG_BUILD$2 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

var installedIntegrations = [];
/**
 * @private
 */
function filterDuplicates(integrations) {
    return integrations.reduce(function (acc, integrations) {
        if (acc.every(function (accIntegration) { return integrations.name !== accIntegration.name; })) {
            acc.push(integrations);
        }
        return acc;
    }, []);
}
/** Gets integration to install */
function getIntegrationsToSetup(options) {
    var defaultIntegrations = (options.defaultIntegrations && __spread$1(options.defaultIntegrations)) || [];
    var userIntegrations = options.integrations;
    var integrations = __spread$1(filterDuplicates(defaultIntegrations));
    if (Array.isArray(userIntegrations)) {
        // Filter out integrations that are also included in user options
        integrations = __spread$1(integrations.filter(function (integrations) {
            return userIntegrations.every(function (userIntegration) { return userIntegration.name !== integrations.name; });
        }), filterDuplicates(userIntegrations));
    }
    else if (typeof userIntegrations === 'function') {
        integrations = userIntegrations(integrations);
        integrations = Array.isArray(integrations) ? integrations : [integrations];
    }
    // Make sure that if present, `Debug` integration will always run last
    var integrationsNames = integrations.map(function (i) { return i.name; });
    var alwaysLastToRun = 'Debug';
    if (integrationsNames.indexOf(alwaysLastToRun) !== -1) {
        integrations.push.apply(integrations, __spread$1(integrations.splice(integrationsNames.indexOf(alwaysLastToRun), 1)));
    }
    return integrations;
}
/** Setup given integration */
function setupIntegration(integration) {
    if (installedIntegrations.indexOf(integration.name) !== -1) {
        return;
    }
    integration.setupOnce(addGlobalEventProcessor, getCurrentHub);
    installedIntegrations.push(integration.name);
    IS_DEBUG_BUILD$2 && logger.log("Integration installed: " + integration.name);
}
/**
 * Given a list of integration instances this installs them all. When `withDefaults` is set to `true` then all default
 * integrations are added unless they were already provided before.
 * @param integrations array of integration instances
 * @param withDefault should enable default integrations
 */
function setupIntegrations(options) {
    var integrations = {};
    getIntegrationsToSetup(options).forEach(function (integration) {
        integrations[integration.name] = integration;
        setupIntegration(integration);
    });
    // set the `initialized` flag so we don't run through the process again unecessarily; use `Object.defineProperty`
    // because by default it creates a property which is nonenumerable, which we want since `initialized` shouldn't be
    // considered a member of the index the way the actual integrations are
    addNonEnumerableProperty(integrations, 'initialized', true);
    return integrations;
}

var ALREADY_SEEN_ERROR = "Not capturing exception because it's already been captured.";
/**
 * Base implementation for all JavaScript SDK clients.
 *
 * Call the constructor with the corresponding backend constructor and options
 * specific to the client subclass. To access these options later, use
 * {@link Client.getOptions}. Also, the Backend instance is available via
 * {@link Client.getBackend}.
 *
 * If a Dsn is specified in the options, it will be parsed and stored. Use
 * {@link Client.getDsn} to retrieve the Dsn at any moment. In case the Dsn is
 * invalid, the constructor will throw a {@link SentryException}. Note that
 * without a valid Dsn, the SDK will not send any events to Sentry.
 *
 * Before sending an event via the backend, it is passed through
 * {@link BaseClient._prepareEvent} to add SDK information and scope data
 * (breadcrumbs and context). To add more custom information, override this
 * method and extend the resulting prepared event.
 *
 * To issue automatically created events (e.g. via instrumentation), use
 * {@link Client.captureEvent}. It will prepare the event and pass it through
 * the callback lifecycle. To issue auto-breadcrumbs, use
 * {@link Client.addBreadcrumb}.
 *
 * @example
 * class NodeClient extends BaseClient<NodeBackend, NodeOptions> {
 *   public constructor(options: NodeOptions) {
 *     super(NodeBackend, options);
 *   }
 *
 *   // ...
 * }
 */
var BaseClient = /** @class */ (function () {
    /**
     * Initializes this client instance.
     *
     * @param backendClass A constructor function to create the backend.
     * @param options Options for the client.
     */
    function BaseClient(backendClass, options) {
        /** Array of used integrations. */
        this._integrations = {};
        /** Number of calls being processed */
        this._numProcessing = 0;
        this._backend = new backendClass(options);
        this._options = options;
        if (options.dsn) {
            this._dsn = makeDsn(options.dsn);
        }
    }
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseClient.prototype.captureException = function (exception, hint, scope) {
        var _this = this;
        // ensure we haven't captured this very object before
        if (checkOrSetAlreadyCaught(exception)) {
            IS_DEBUG_BUILD$2 && logger.log(ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._getBackend()
            .eventFromException(exception, hint)
            .then(function (event) { return _this._captureEvent(event, hint, scope); })
            .then(function (result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureMessage = function (message, level, hint, scope) {
        var _this = this;
        var eventId = hint && hint.event_id;
        var promisedEvent = isPrimitive(message)
            ? this._getBackend().eventFromMessage(String(message), level, hint)
            : this._getBackend().eventFromException(message, hint);
        this._process(promisedEvent
            .then(function (event) { return _this._captureEvent(event, hint, scope); })
            .then(function (result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureEvent = function (event, hint, scope) {
        // ensure we haven't captured this very object before
        if (hint && hint.originalException && checkOrSetAlreadyCaught(hint.originalException)) {
            IS_DEBUG_BUILD$2 && logger.log(ALREADY_SEEN_ERROR);
            return;
        }
        var eventId = hint && hint.event_id;
        this._process(this._captureEvent(event, hint, scope).then(function (result) {
            eventId = result;
        }));
        return eventId;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.captureSession = function (session) {
        if (!this._isEnabled()) {
            IS_DEBUG_BUILD$2 && logger.warn('SDK not enabled, will not capture session.');
            return;
        }
        if (!(typeof session.release === 'string')) {
            IS_DEBUG_BUILD$2 && logger.warn('Discarded session because of missing or non-string release');
        }
        else {
            this._sendSession(session);
            // After sending, we set init false to indicate it's not the first occurrence
            session.update({ init: false });
        }
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getDsn = function () {
        return this._dsn;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getOptions = function () {
        return this._options;
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getTransport = function () {
        return this._getBackend().getTransport();
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.flush = function (timeout) {
        var _this = this;
        return this._isClientDoneProcessing(timeout).then(function (clientFinished) {
            return _this.getTransport()
                .close(timeout)
                .then(function (transportFlushed) { return clientFinished && transportFlushed; });
        });
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.close = function (timeout) {
        var _this = this;
        return this.flush(timeout).then(function (result) {
            _this.getOptions().enabled = false;
            return result;
        });
    };
    /**
     * Sets up the integrations
     */
    BaseClient.prototype.setupIntegrations = function () {
        if (this._isEnabled() && !this._integrations.initialized) {
            this._integrations = setupIntegrations(this._options);
        }
    };
    /**
     * @inheritDoc
     */
    BaseClient.prototype.getIntegration = function (integration) {
        try {
            return this._integrations[integration.id] || null;
        }
        catch (_oO) {
            IS_DEBUG_BUILD$2 && logger.warn("Cannot retrieve integration " + integration.id + " from the current Client");
            return null;
        }
    };
    /** Updates existing session based on the provided event */
    BaseClient.prototype._updateSessionFromEvent = function (session, event) {
        var e_1, _a;
        var crashed = false;
        var errored = false;
        var exceptions = event.exception && event.exception.values;
        if (exceptions) {
            errored = true;
            try {
                for (var exceptions_1 = __values(exceptions), exceptions_1_1 = exceptions_1.next(); !exceptions_1_1.done; exceptions_1_1 = exceptions_1.next()) {
                    var ex = exceptions_1_1.value;
                    var mechanism = ex.mechanism;
                    if (mechanism && mechanism.handled === false) {
                        crashed = true;
                        break;
                    }
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (exceptions_1_1 && !exceptions_1_1.done && (_a = exceptions_1.return)) _a.call(exceptions_1);
                }
                finally { if (e_1) throw e_1.error; }
            }
        }
        // A session is updated and that session update is sent in only one of the two following scenarios:
        // 1. Session with non terminal status and 0 errors + an error occurred -> Will set error count to 1 and send update
        // 2. Session with non terminal status and 1 error + a crash occurred -> Will set status crashed and send update
        var sessionNonTerminal = session.status === 'ok';
        var shouldUpdateAndSend = (sessionNonTerminal && session.errors === 0) || (sessionNonTerminal && crashed);
        if (shouldUpdateAndSend) {
            session.update(__assign$2(__assign$2({}, (crashed && { status: 'crashed' })), { errors: session.errors || Number(errored || crashed) }));
            this.captureSession(session);
        }
    };
    /** Deliver captured session to Sentry */
    BaseClient.prototype._sendSession = function (session) {
        this._getBackend().sendSession(session);
    };
    /**
     * Determine if the client is finished processing. Returns a promise because it will wait `timeout` ms before saying
     * "no" (resolving to `false`) in order to give the client a chance to potentially finish first.
     *
     * @param timeout The time, in ms, after which to resolve to `false` if the client is still busy. Passing `0` (or not
     * passing anything) will make the promise wait as long as it takes for processing to finish before resolving to
     * `true`.
     * @returns A promise which will resolve to `true` if processing is already done or finishes before the timeout, and
     * `false` otherwise
     */
    BaseClient.prototype._isClientDoneProcessing = function (timeout) {
        var _this = this;
        return new SyncPromise(function (resolve) {
            var ticked = 0;
            var tick = 1;
            var interval = setInterval(function () {
                if (_this._numProcessing == 0) {
                    clearInterval(interval);
                    resolve(true);
                }
                else {
                    ticked += tick;
                    if (timeout && ticked >= timeout) {
                        clearInterval(interval);
                        resolve(false);
                    }
                }
            }, tick);
        });
    };
    /** Returns the current backend. */
    BaseClient.prototype._getBackend = function () {
        return this._backend;
    };
    /** Determines whether this SDK is enabled and a valid Dsn is present. */
    BaseClient.prototype._isEnabled = function () {
        return this.getOptions().enabled !== false && this._dsn !== undefined;
    };
    /**
     * Adds common information to events.
     *
     * The information includes release and environment from `options`,
     * breadcrumbs and context (extra, tags and user) from the scope.
     *
     * Information that is already present in the event is never overwritten. For
     * nested objects, such as the context, keys are merged.
     *
     * @param event The original event.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A new event with more information.
     */
    BaseClient.prototype._prepareEvent = function (event, scope, hint) {
        var _this = this;
        var _a = this.getOptions(), _b = _a.normalizeDepth, normalizeDepth = _b === void 0 ? 3 : _b, _c = _a.normalizeMaxBreadth, normalizeMaxBreadth = _c === void 0 ? 1000 : _c;
        var prepared = __assign$2(__assign$2({}, event), { event_id: event.event_id || (hint && hint.event_id ? hint.event_id : uuid4()), timestamp: event.timestamp || dateTimestampInSeconds() });
        this._applyClientOptions(prepared);
        this._applyIntegrationsMetadata(prepared);
        // If we have scope given to us, use it as the base for further modifications.
        // This allows us to prevent unnecessary copying of data if `captureContext` is not provided.
        var finalScope = scope;
        if (hint && hint.captureContext) {
            finalScope = Scope.clone(finalScope).update(hint.captureContext);
        }
        // We prepare the result here with a resolved Event.
        var result = resolvedSyncPromise(prepared);
        // This should be the last thing called, since we want that
        // {@link Hub.addEventProcessor} gets the finished prepared event.
        if (finalScope) {
            // In case we have a hub we reassign it.
            result = finalScope.applyToEvent(prepared, hint);
        }
        return result.then(function (evt) {
            if (evt) {
                // TODO this is more of the hack trying to solve https://github.com/getsentry/sentry-javascript/issues/2809
                // it is only attached as extra data to the event if the event somehow skips being normalized
                evt.sdkProcessingMetadata = __assign$2(__assign$2({}, evt.sdkProcessingMetadata), { normalizeDepth: normalize(normalizeDepth) + " (" + typeof normalizeDepth + ")" });
            }
            if (typeof normalizeDepth === 'number' && normalizeDepth > 0) {
                return _this._normalizeEvent(evt, normalizeDepth, normalizeMaxBreadth);
            }
            return evt;
        });
    };
    /**
     * Applies `normalize` function on necessary `Event` attributes to make them safe for serialization.
     * Normalized keys:
     * - `breadcrumbs.data`
     * - `user`
     * - `contexts`
     * - `extra`
     * @param event Event
     * @returns Normalized event
     */
    BaseClient.prototype._normalizeEvent = function (event, depth, maxBreadth) {
        if (!event) {
            return null;
        }
        var normalized = __assign$2(__assign$2(__assign$2(__assign$2(__assign$2({}, event), (event.breadcrumbs && {
            breadcrumbs: event.breadcrumbs.map(function (b) { return (__assign$2(__assign$2({}, b), (b.data && {
                data: normalize(b.data, depth, maxBreadth),
            }))); }),
        })), (event.user && {
            user: normalize(event.user, depth, maxBreadth),
        })), (event.contexts && {
            contexts: normalize(event.contexts, depth, maxBreadth),
        })), (event.extra && {
            extra: normalize(event.extra, depth, maxBreadth),
        }));
        // event.contexts.trace stores information about a Transaction. Similarly,
        // event.spans[] stores information about child Spans. Given that a
        // Transaction is conceptually a Span, normalization should apply to both
        // Transactions and Spans consistently.
        // For now the decision is to skip normalization of Transactions and Spans,
        // so this block overwrites the normalized event to add back the original
        // Transaction information prior to normalization.
        if (event.contexts && event.contexts.trace) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            normalized.contexts.trace = event.contexts.trace;
        }
        normalized.sdkProcessingMetadata = __assign$2(__assign$2({}, normalized.sdkProcessingMetadata), { baseClientNormalized: true });
        return normalized;
    };
    /**
     *  Enhances event using the client configuration.
     *  It takes care of all "static" values like environment, release and `dist`,
     *  as well as truncating overly long values.
     * @param event event instance to be enhanced
     */
    BaseClient.prototype._applyClientOptions = function (event) {
        var options = this.getOptions();
        var environment = options.environment, release = options.release, dist = options.dist, _a = options.maxValueLength, maxValueLength = _a === void 0 ? 250 : _a;
        if (!('environment' in event)) {
            event.environment = 'environment' in options ? environment : 'production';
        }
        if (event.release === undefined && release !== undefined) {
            event.release = release;
        }
        if (event.dist === undefined && dist !== undefined) {
            event.dist = dist;
        }
        if (event.message) {
            event.message = truncate(event.message, maxValueLength);
        }
        var exception = event.exception && event.exception.values && event.exception.values[0];
        if (exception && exception.value) {
            exception.value = truncate(exception.value, maxValueLength);
        }
        var request = event.request;
        if (request && request.url) {
            request.url = truncate(request.url, maxValueLength);
        }
    };
    /**
     * This function adds all used integrations to the SDK info in the event.
     * @param event The event that will be filled with all integrations.
     */
    BaseClient.prototype._applyIntegrationsMetadata = function (event) {
        var integrationsArray = Object.keys(this._integrations);
        if (integrationsArray.length > 0) {
            event.sdk = event.sdk || {};
            event.sdk.integrations = __spread$1((event.sdk.integrations || []), integrationsArray);
        }
    };
    /**
     * Tells the backend to send this event
     * @param event The Sentry event to send
     */
    BaseClient.prototype._sendEvent = function (event) {
        this._getBackend().sendEvent(event);
    };
    /**
     * Processes the event and logs an error in case of rejection
     * @param event
     * @param hint
     * @param scope
     */
    BaseClient.prototype._captureEvent = function (event, hint, scope) {
        return this._processEvent(event, hint, scope).then(function (finalEvent) {
            return finalEvent.event_id;
        }, function (reason) {
            IS_DEBUG_BUILD$2 && logger.error(reason);
            return undefined;
        });
    };
    /**
     * Processes an event (either error or message) and sends it to Sentry.
     *
     * This also adds breadcrumbs and context information to the event. However,
     * platform specific meta data (such as the User's IP address) must be added
     * by the SDK implementor.
     *
     *
     * @param event The event to send to Sentry.
     * @param hint May contain additional information about the original exception.
     * @param scope A scope containing event metadata.
     * @returns A SyncPromise that resolves with the event or rejects in case event was/will not be send.
     */
    BaseClient.prototype._processEvent = function (event, hint, scope) {
        var _this = this;
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.getOptions(), beforeSend = _a.beforeSend, sampleRate = _a.sampleRate;
        var transport = this.getTransport();
        function recordLostEvent(outcome, category) {
            if (transport.recordLostEvent) {
                transport.recordLostEvent(outcome, category);
            }
        }
        if (!this._isEnabled()) {
            return rejectedSyncPromise(new SentryError('SDK not enabled, will not capture event.'));
        }
        var isTransaction = event.type === 'transaction';
        // 1.0 === 100% events are sent
        // 0.0 === 0% events are sent
        // Sampling for transaction happens somewhere else
        if (!isTransaction && typeof sampleRate === 'number' && Math.random() > sampleRate) {
            recordLostEvent('sample_rate', 'event');
            return rejectedSyncPromise(new SentryError("Discarding event because it's not included in the random sample (sampling rate = " + sampleRate + ")"));
        }
        return this._prepareEvent(event, scope, hint)
            .then(function (prepared) {
            if (prepared === null) {
                recordLostEvent('event_processor', event.type || 'event');
                throw new SentryError('An event processor returned null, will not send event.');
            }
            var isInternalException = hint && hint.data && hint.data.__sentry__ === true;
            if (isInternalException || isTransaction || !beforeSend) {
                return prepared;
            }
            var beforeSendResult = beforeSend(prepared, hint);
            return _ensureBeforeSendRv(beforeSendResult);
        })
            .then(function (processedEvent) {
            if (processedEvent === null) {
                recordLostEvent('before_send', event.type || 'event');
                throw new SentryError('`beforeSend` returned `null`, will not send event.');
            }
            var session = scope && scope.getSession && scope.getSession();
            if (!isTransaction && session) {
                _this._updateSessionFromEvent(session, processedEvent);
            }
            _this._sendEvent(processedEvent);
            return processedEvent;
        })
            .then(null, function (reason) {
            if (reason instanceof SentryError) {
                throw reason;
            }
            _this.captureException(reason, {
                data: {
                    __sentry__: true,
                },
                originalException: reason,
            });
            throw new SentryError("Event processing pipeline threw an error, original event will not be sent. Details have been sent as a new event.\nReason: " + reason);
        });
    };
    /**
     * Occupies the client with processing and event
     */
    BaseClient.prototype._process = function (promise) {
        var _this = this;
        this._numProcessing += 1;
        void promise.then(function (value) {
            _this._numProcessing -= 1;
            return value;
        }, function (reason) {
            _this._numProcessing -= 1;
            return reason;
        });
    };
    return BaseClient;
}());
/**
 * Verifies that return value of configured `beforeSend` is of expected type.
 */
function _ensureBeforeSendRv(rv) {
    var nullErr = '`beforeSend` method has to return `null` or a valid event.';
    if (isThenable(rv)) {
        return rv.then(function (event) {
            if (!(isPlainObject(event) || event === null)) {
                throw new SentryError(nullErr);
            }
            return event;
        }, function (e) {
            throw new SentryError("beforeSend rejected with " + e);
        });
    }
    else if (!(isPlainObject(rv) || rv === null)) {
        throw new SentryError(nullErr);
    }
    return rv;
}

/** Extract sdk info from from the API metadata */
function getSdkMetadataForEnvelopeHeader(api) {
    if (!api.metadata || !api.metadata.sdk) {
        return;
    }
    var _a = api.metadata.sdk, name = _a.name, version = _a.version;
    return { name: name, version: version };
}
/**
 * Apply SdkInfo (name, version, packages, integrations) to the corresponding event key.
 * Merge with existing data if any.
 **/
function enhanceEventWithSdkInfo(event, sdkInfo) {
    if (!sdkInfo) {
        return event;
    }
    event.sdk = event.sdk || {};
    event.sdk.name = event.sdk.name || sdkInfo.name;
    event.sdk.version = event.sdk.version || sdkInfo.version;
    event.sdk.integrations = __spread$1((event.sdk.integrations || []), (sdkInfo.integrations || []));
    event.sdk.packages = __spread$1((event.sdk.packages || []), (sdkInfo.packages || []));
    return event;
}
/** Creates an envelope from a Session */
function createSessionEnvelope(session, api) {
    var sdkInfo = getSdkMetadataForEnvelopeHeader(api);
    var envelopeHeaders = __assign$2(__assign$2({ sent_at: new Date().toISOString() }, (sdkInfo && { sdk: sdkInfo })), (!!api.tunnel && { dsn: dsnToString(api.dsn) }));
    // I know this is hacky but we don't want to add `sessions` to request type since it's never rate limited
    var type = 'aggregates' in session ? 'sessions' : 'session';
    // TODO (v7) Have to cast type because envelope items do not accept a `SentryRequestType`
    var envelopeItem = [{ type: type }, session];
    var envelope = createEnvelope(envelopeHeaders, [envelopeItem]);
    return [envelope, type];
}
/** Creates a SentryRequest from a Session. */
function sessionToSentryRequest(session, api) {
    var _a = __read$4(createSessionEnvelope(session, api), 2), envelope = _a[0], type = _a[1];
    return {
        body: serializeEnvelope(envelope),
        type: type,
        url: getEnvelopeEndpointWithUrlEncodedAuth(api.dsn, api.tunnel),
    };
}
/**
 * Create an Envelope from an event. Note that this is duplicated from below,
 * but on purpose as this will be refactored in v7.
 */
function createEventEnvelope(event, api) {
    var sdkInfo = getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var envelopeHeaders = __assign$2(__assign$2({ event_id: event.event_id, sent_at: new Date().toISOString() }, (sdkInfo && { sdk: sdkInfo })), (!!api.tunnel && { dsn: dsnToString(api.dsn) }));
    var eventItem = [
        {
            type: eventType,
            sample_rates: [{ id: samplingMethod, rate: sampleRate }],
        },
        event,
    ];
    return createEnvelope(envelopeHeaders, [eventItem]);
}
/** Creates a SentryRequest from an event. */
function eventToSentryRequest(event, api) {
    var sdkInfo = getSdkMetadataForEnvelopeHeader(api);
    var eventType = event.type || 'event';
    var useEnvelope = eventType === 'transaction' || !!api.tunnel;
    var transactionSampling = (event.sdkProcessingMetadata || {}).transactionSampling;
    var _a = transactionSampling || {}, samplingMethod = _a.method, sampleRate = _a.rate;
    // TODO: Below is a temporary hack in order to debug a serialization error - see
    // https://github.com/getsentry/sentry-javascript/issues/2809,
    // https://github.com/getsentry/sentry-javascript/pull/4425, and
    // https://github.com/getsentry/sentry-javascript/pull/4574.
    //
    // TL; DR: even though we normalize all events (which should prevent this), something is causing `JSON.stringify` to
    // throw a circular reference error.
    //
    // When it's time to remove it:
    // 1. Delete everything between here and where the request object `req` is created, EXCEPT the line deleting
    //    `sdkProcessingMetadata`
    // 2. Restore the original version of the request body, which is commented out
    // 3. Search for either of the PR URLs above and pull out the companion hacks in the browser playwright tests and the
    //    baseClient tests in this package
    enhanceEventWithSdkInfo(event, api.metadata.sdk);
    event.tags = event.tags || {};
    event.extra = event.extra || {};
    // In theory, all events should be marked as having gone through normalization and so
    // we should never set this tag/extra data
    if (!(event.sdkProcessingMetadata && event.sdkProcessingMetadata.baseClientNormalized)) {
        event.tags.skippedNormalization = true;
        event.extra.normalizeDepth = event.sdkProcessingMetadata ? event.sdkProcessingMetadata.normalizeDepth : 'unset';
    }
    // prevent this data from being sent to sentry
    // TODO: This is NOT part of the hack - DO NOT DELETE
    delete event.sdkProcessingMetadata;
    var body;
    try {
        // 99.9% of events should get through just fine - no change in behavior for them
        body = JSON.stringify(event);
    }
    catch (err) {
        // Record data about the error without replacing original event data, then force renormalization
        event.tags.JSONStringifyError = true;
        event.extra.JSONStringifyError = err;
        try {
            body = JSON.stringify(normalize(event));
        }
        catch (newErr) {
            // At this point even renormalization hasn't worked, meaning something about the event data has gone very wrong.
            // Time to cut our losses and record only the new error. With luck, even in the problematic cases we're trying to
            // debug with this hack, we won't ever land here.
            var innerErr = newErr;
            body = JSON.stringify({
                message: 'JSON.stringify error after renormalization',
                // setting `extra: { innerErr }` here for some reason results in an empty object, so unpack manually
                extra: { message: innerErr.message, stack: innerErr.stack },
            });
        }
    }
    var req = {
        // this is the relevant line of code before the hack was added, to make it easy to undo said hack once we've solved
        // the mystery
        // body: JSON.stringify(sdkInfo ? enhanceEventWithSdkInfo(event, api.metadata.sdk) : event),
        body: body,
        type: eventType,
        url: useEnvelope
            ? getEnvelopeEndpointWithUrlEncodedAuth(api.dsn, api.tunnel)
            : getStoreEndpointWithUrlEncodedAuth(api.dsn),
    };
    // https://develop.sentry.dev/sdk/envelopes/
    // Since we don't need to manipulate envelopes nor store them, there is no
    // exported concept of an Envelope with operations including serialization and
    // deserialization. Instead, we only implement a minimal subset of the spec to
    // serialize events inline here.
    if (useEnvelope) {
        var envelopeHeaders = __assign$2(__assign$2({ event_id: event.event_id, sent_at: new Date().toISOString() }, (sdkInfo && { sdk: sdkInfo })), (!!api.tunnel && { dsn: dsnToString(api.dsn) }));
        var eventItem = [
            {
                type: eventType,
                sample_rates: [{ id: samplingMethod, rate: sampleRate }],
            },
            req.body,
        ];
        var envelope = createEnvelope(envelopeHeaders, [eventItem]);
        req.body = serializeEnvelope(envelope);
    }
    return req;
}

/** Noop transport */
var NoopTransport = /** @class */ (function () {
    function NoopTransport() {
    }
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.sendEvent = function (_) {
        return resolvedSyncPromise({
            reason: 'NoopTransport: Event has been skipped because no Dsn is configured.',
            status: 'skipped',
        });
    };
    /**
     * @inheritDoc
     */
    NoopTransport.prototype.close = function (_) {
        return resolvedSyncPromise(true);
    };
    return NoopTransport;
}());

/**
 * This is the base implemention of a Backend.
 * @hidden
 */
var BaseBackend = /** @class */ (function () {
    /** Creates a new backend instance. */
    function BaseBackend(options) {
        this._options = options;
        if (!this._options.dsn) {
            IS_DEBUG_BUILD$2 && logger.warn('No DSN provided, backend will not do anything.');
        }
        this._transport = this._setupTransport();
    }
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    BaseBackend.prototype.eventFromException = function (_exception, _hint) {
        throw new SentryError('Backend has to implement `eventFromException` method');
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.eventFromMessage = function (_message, _level, _hint) {
        throw new SentryError('Backend has to implement `eventFromMessage` method');
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.sendEvent = function (event) {
        // TODO(v7): Remove the if-else
        if (this._newTransport &&
            this._options.dsn &&
            this._options._experiments &&
            this._options._experiments.newTransport) {
            var api = initAPIDetails(this._options.dsn, this._options._metadata, this._options.tunnel);
            var env = createEventEnvelope(event, api);
            void this._newTransport.send(env).then(null, function (reason) {
                IS_DEBUG_BUILD$2 && logger.error('Error while sending event:', reason);
            });
        }
        else {
            void this._transport.sendEvent(event).then(null, function (reason) {
                IS_DEBUG_BUILD$2 && logger.error('Error while sending event:', reason);
            });
        }
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.sendSession = function (session) {
        if (!this._transport.sendSession) {
            IS_DEBUG_BUILD$2 && logger.warn("Dropping session because custom transport doesn't implement sendSession");
            return;
        }
        // TODO(v7): Remove the if-else
        if (this._newTransport &&
            this._options.dsn &&
            this._options._experiments &&
            this._options._experiments.newTransport) {
            var api = initAPIDetails(this._options.dsn, this._options._metadata, this._options.tunnel);
            var _a = __read$4(createSessionEnvelope(session, api), 1), env = _a[0];
            void this._newTransport.send(env).then(null, function (reason) {
                IS_DEBUG_BUILD$2 && logger.error('Error while sending session:', reason);
            });
        }
        else {
            void this._transport.sendSession(session).then(null, function (reason) {
                IS_DEBUG_BUILD$2 && logger.error('Error while sending session:', reason);
            });
        }
    };
    /**
     * @inheritDoc
     */
    BaseBackend.prototype.getTransport = function () {
        return this._transport;
    };
    /**
     * Sets up the transport so it can be used later to send requests.
     */
    BaseBackend.prototype._setupTransport = function () {
        return new NoopTransport();
    };
    return BaseBackend;
}());

/**
 * Internal function to create a new SDK client instance. The client is
 * installed and then bound to the current scope.
 *
 * @param clientClass The client class to instantiate.
 * @param options Options to pass to the client.
 */
function initAndBind(clientClass, options) {
    if (options.debug === true) {
        if (IS_DEBUG_BUILD$2) {
            logger.enable();
        }
        else {
            // use `console.warn` rather than `logger.warn` since by non-debug bundles have all `logger.x` statements stripped
            // eslint-disable-next-line no-console
            console.warn('[Sentry] Cannot initialize SDK with `debug` option using a non-debug bundle.');
        }
    }
    var hub = getCurrentHub();
    var scope = hub.getScope();
    if (scope) {
        scope.update(options.initialScope);
    }
    var client = new clientClass(options);
    hub.bindClient(client);
}

var DEFAULT_TRANSPORT_BUFFER_SIZE = 30;
/**
 * Creates a `NewTransport`
 *
 * @param options
 * @param makeRequest
 */
function createTransport(options, makeRequest, buffer) {
    if (buffer === void 0) { buffer = makePromiseBuffer(options.bufferSize || DEFAULT_TRANSPORT_BUFFER_SIZE); }
    var rateLimits = {};
    var flush = function (timeout) { return buffer.drain(timeout); };
    function send(envelope) {
        var envCategory = getEnvelopeType(envelope);
        var category = envCategory === 'event' ? 'error' : envCategory;
        var request = {
            category: category,
            body: serializeEnvelope(envelope),
        };
        // Don't add to buffer if transport is already rate-limited
        if (isRateLimited(rateLimits, category)) {
            return rejectedSyncPromise({
                status: 'rate_limit',
                reason: getRateLimitReason(rateLimits, category),
            });
        }
        var requestTask = function () {
            return makeRequest(request).then(function (_a) {
                var body = _a.body, headers = _a.headers, reason = _a.reason, statusCode = _a.statusCode;
                var status = eventStatusFromHttpCode(statusCode);
                if (headers) {
                    rateLimits = updateRateLimits(rateLimits, headers);
                }
                if (status === 'success') {
                    return resolvedSyncPromise({ status: status, reason: reason });
                }
                return rejectedSyncPromise({
                    status: status,
                    reason: reason ||
                        body ||
                        (status === 'rate_limit' ? getRateLimitReason(rateLimits, category) : 'Unknown transport error'),
                });
            });
        };
        return buffer.add(requestTask);
    }
    return {
        send: send,
        flush: flush,
    };
}
function getRateLimitReason(rateLimits, category) {
    return "Too many " + category + " requests, backing off until: " + new Date(disabledUntil(rateLimits, category)).toISOString();
}

var SDK_VERSION = '6.19.7';

var originalFunctionToString;
/** Patch toString calls to return proper name for wrapped functions */
var FunctionToString = /** @class */ (function () {
    function FunctionToString() {
        /**
         * @inheritDoc
         */
        this.name = FunctionToString.id;
    }
    /**
     * @inheritDoc
     */
    FunctionToString.prototype.setupOnce = function () {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        originalFunctionToString = Function.prototype.toString;
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        Function.prototype.toString = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            var context = getOriginalFunction(this) || this;
            return originalFunctionToString.apply(context, args);
        };
    };
    /**
     * @inheritDoc
     */
    FunctionToString.id = 'FunctionToString';
    return FunctionToString;
}());

// "Script error." is hard coded into browsers for errors that it can't read.
// this is the result of a script being pulled in from an external domain and CORS.
var DEFAULT_IGNORE_ERRORS = [/^Script error\.?$/, /^Javascript error: Script error\.? on line 0$/];
/** Inbound filters configurable by the user */
var InboundFilters = /** @class */ (function () {
    function InboundFilters(_options) {
        if (_options === void 0) { _options = {}; }
        this._options = _options;
        /**
         * @inheritDoc
         */
        this.name = InboundFilters.id;
    }
    /**
     * @inheritDoc
     */
    InboundFilters.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function (event) {
            var hub = getCurrentHub();
            if (hub) {
                var self_1 = hub.getIntegration(InboundFilters);
                if (self_1) {
                    var client = hub.getClient();
                    var clientOptions = client ? client.getOptions() : {};
                    var options = _mergeOptions(self_1._options, clientOptions);
                    return _shouldDropEvent$1(event, options) ? null : event;
                }
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    InboundFilters.id = 'InboundFilters';
    return InboundFilters;
}());
/** JSDoc */
function _mergeOptions(internalOptions, clientOptions) {
    if (internalOptions === void 0) { internalOptions = {}; }
    if (clientOptions === void 0) { clientOptions = {}; }
    return {
        allowUrls: __spread$1((internalOptions.whitelistUrls || []), (internalOptions.allowUrls || []), (clientOptions.whitelistUrls || []), (clientOptions.allowUrls || [])),
        denyUrls: __spread$1((internalOptions.blacklistUrls || []), (internalOptions.denyUrls || []), (clientOptions.blacklistUrls || []), (clientOptions.denyUrls || [])),
        ignoreErrors: __spread$1((internalOptions.ignoreErrors || []), (clientOptions.ignoreErrors || []), DEFAULT_IGNORE_ERRORS),
        ignoreInternal: internalOptions.ignoreInternal !== undefined ? internalOptions.ignoreInternal : true,
    };
}
/** JSDoc */
function _shouldDropEvent$1(event, options) {
    if (options.ignoreInternal && _isSentryError(event)) {
        IS_DEBUG_BUILD$2 &&
            logger.warn("Event dropped due to being internal Sentry Error.\nEvent: " + getEventDescription(event));
        return true;
    }
    if (_isIgnoredError(event, options.ignoreErrors)) {
        IS_DEBUG_BUILD$2 &&
            logger.warn("Event dropped due to being matched by `ignoreErrors` option.\nEvent: " + getEventDescription(event));
        return true;
    }
    if (_isDeniedUrl(event, options.denyUrls)) {
        IS_DEBUG_BUILD$2 &&
            logger.warn("Event dropped due to being matched by `denyUrls` option.\nEvent: " + getEventDescription(event) + ".\nUrl: " + _getEventFilterUrl(event));
        return true;
    }
    if (!_isAllowedUrl(event, options.allowUrls)) {
        IS_DEBUG_BUILD$2 &&
            logger.warn("Event dropped due to not being matched by `allowUrls` option.\nEvent: " + getEventDescription(event) + ".\nUrl: " + _getEventFilterUrl(event));
        return true;
    }
    return false;
}
function _isIgnoredError(event, ignoreErrors) {
    if (!ignoreErrors || !ignoreErrors.length) {
        return false;
    }
    return _getPossibleEventMessages(event).some(function (message) {
        return ignoreErrors.some(function (pattern) { return isMatchingPattern(message, pattern); });
    });
}
function _isDeniedUrl(event, denyUrls) {
    // TODO: Use Glob instead?
    if (!denyUrls || !denyUrls.length) {
        return false;
    }
    var url = _getEventFilterUrl(event);
    return !url ? false : denyUrls.some(function (pattern) { return isMatchingPattern(url, pattern); });
}
function _isAllowedUrl(event, allowUrls) {
    // TODO: Use Glob instead?
    if (!allowUrls || !allowUrls.length) {
        return true;
    }
    var url = _getEventFilterUrl(event);
    return !url ? true : allowUrls.some(function (pattern) { return isMatchingPattern(url, pattern); });
}
function _getPossibleEventMessages(event) {
    if (event.message) {
        return [event.message];
    }
    if (event.exception) {
        try {
            var _a = (event.exception.values && event.exception.values[0]) || {}, _b = _a.type, type = _b === void 0 ? '' : _b, _c = _a.value, value = _c === void 0 ? '' : _c;
            return ["" + value, type + ": " + value];
        }
        catch (oO) {
            IS_DEBUG_BUILD$2 && logger.error("Cannot extract message for event " + getEventDescription(event));
            return [];
        }
    }
    return [];
}
function _isSentryError(event) {
    try {
        // @ts-ignore can't be a sentry error if undefined
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return event.exception.values[0].type === 'SentryError';
    }
    catch (e) {
        // ignore
    }
    return false;
}
function _getLastValidUrl(frames) {
    if (frames === void 0) { frames = []; }
    for (var i = frames.length - 1; i >= 0; i--) {
        var frame = frames[i];
        if (frame && frame.filename !== '<anonymous>' && frame.filename !== '[native code]') {
            return frame.filename || null;
        }
    }
    return null;
}
function _getEventFilterUrl(event) {
    try {
        if (event.stacktrace) {
            return _getLastValidUrl(event.stacktrace.frames);
        }
        var frames_1;
        try {
            // @ts-ignore we only care about frames if the whole thing here is defined
            frames_1 = event.exception.values[0].stacktrace.frames;
        }
        catch (e) {
            // ignore
        }
        return frames_1 ? _getLastValidUrl(frames_1) : null;
    }
    catch (oO) {
        IS_DEBUG_BUILD$2 && logger.error("Cannot extract url for event " + getEventDescription(event));
        return null;
    }
}

// global reference to slice
var UNKNOWN_FUNCTION = '?';
var OPERA10_PRIORITY = 10;
var OPERA11_PRIORITY = 20;
var CHROME_PRIORITY = 30;
var WINJS_PRIORITY = 40;
var GECKO_PRIORITY = 50;
function createFrame(filename, func, lineno, colno) {
    var frame = {
        filename: filename,
        function: func,
        // All browser frames are considered in_app
        in_app: true,
    };
    if (lineno !== undefined) {
        frame.lineno = lineno;
    }
    if (colno !== undefined) {
        frame.colno = colno;
    }
    return frame;
}
// Chromium based browsers: Chrome, Brave, new Opera, new Edge
var chromeRegex = /^\s*at (?:(.*?) ?\((?:address at )?)?((?:file|https?|blob|chrome-extension|address|native|eval|webpack|<anonymous>|[-a-z]+:|.*bundle|\/).*?)(?::(\d+))?(?::(\d+))?\)?\s*$/i;
var chromeEvalRegex = /\((\S*)(?::(\d+))(?::(\d+))\)/;
var chrome = function (line) {
    var parts = chromeRegex.exec(line);
    if (parts) {
        var isEval = parts[2] && parts[2].indexOf('eval') === 0; // start of line
        if (isEval) {
            var subMatch = chromeEvalRegex.exec(parts[2]);
            if (subMatch) {
                // throw out eval line/column and use top-most line/column number
                parts[2] = subMatch[1]; // url
                parts[3] = subMatch[2]; // line
                parts[4] = subMatch[3]; // column
            }
        }
        // Kamil: One more hack won't hurt us right? Understanding and adding more rules on top of these regexps right now
        // would be way too time consuming. (TODO: Rewrite whole RegExp to be more readable)
        var _a = __read$4(extractSafariExtensionDetails(parts[1] || UNKNOWN_FUNCTION, parts[2]), 2), func = _a[0], filename = _a[1];
        return createFrame(filename, func, parts[3] ? +parts[3] : undefined, parts[4] ? +parts[4] : undefined);
    }
    return;
};
var chromeStackParser = [CHROME_PRIORITY, chrome];
// gecko regex: `(?:bundle|\d+\.js)`: `bundle` is for react native, `\d+\.js` also but specifically for ram bundles because it
// generates filenames without a prefix like `file://` the filenames in the stacktrace are just 42.js
// We need this specific case for now because we want no other regex to match.
var geckoREgex = /^\s*(.*?)(?:\((.*?)\))?(?:^|@)?((?:file|https?|blob|chrome|webpack|resource|moz-extension|capacitor).*?:\/.*?|\[native code\]|[^@]*(?:bundle|\d+\.js)|\/[\w\-. /=]+)(?::(\d+))?(?::(\d+))?\s*$/i;
var geckoEvalRegex = /(\S+) line (\d+)(?: > eval line \d+)* > eval/i;
var gecko = function (line) {
    var _a;
    var parts = geckoREgex.exec(line);
    if (parts) {
        var isEval = parts[3] && parts[3].indexOf(' > eval') > -1;
        if (isEval) {
            var subMatch = geckoEvalRegex.exec(parts[3]);
            if (subMatch) {
                // throw out eval line/column and use top-most line number
                parts[1] = parts[1] || 'eval';
                parts[3] = subMatch[1];
                parts[4] = subMatch[2];
                parts[5] = ''; // no column when eval
            }
        }
        var filename = parts[3];
        var func = parts[1] || UNKNOWN_FUNCTION;
        _a = __read$4(extractSafariExtensionDetails(func, filename), 2), func = _a[0], filename = _a[1];
        return createFrame(filename, func, parts[4] ? +parts[4] : undefined, parts[5] ? +parts[5] : undefined);
    }
    return;
};
var geckoStackParser = [GECKO_PRIORITY, gecko];
var winjsRegex = /^\s*at (?:((?:\[object object\])?.+) )?\(?((?:file|ms-appx|https?|webpack|blob):.*?):(\d+)(?::(\d+))?\)?\s*$/i;
var winjs = function (line) {
    var parts = winjsRegex.exec(line);
    return parts
        ? createFrame(parts[2], parts[1] || UNKNOWN_FUNCTION, +parts[3], parts[4] ? +parts[4] : undefined)
        : undefined;
};
var winjsStackParser = [WINJS_PRIORITY, winjs];
var opera10Regex = / line (\d+).*script (?:in )?(\S+)(?:: in function (\S+))?$/i;
var opera10 = function (line) {
    var parts = opera10Regex.exec(line);
    return parts ? createFrame(parts[2], parts[3] || UNKNOWN_FUNCTION, +parts[1]) : undefined;
};
var opera10StackParser = [OPERA10_PRIORITY, opera10];
var opera11Regex = / line (\d+), column (\d+)\s*(?:in (?:<anonymous function: ([^>]+)>|([^)]+))\(.*\))? in (.*):\s*$/i;
var opera11 = function (line) {
    var parts = opera11Regex.exec(line);
    return parts ? createFrame(parts[5], parts[3] || parts[4] || UNKNOWN_FUNCTION, +parts[1], +parts[2]) : undefined;
};
var opera11StackParser = [OPERA11_PRIORITY, opera11];
/**
 * Safari web extensions, starting version unknown, can produce "frames-only" stacktraces.
 * What it means, is that instead of format like:
 *
 * Error: wat
 *   at function@url:row:col
 *   at function@url:row:col
 *   at function@url:row:col
 *
 * it produces something like:
 *
 *   function@url:row:col
 *   function@url:row:col
 *   function@url:row:col
 *
 * Because of that, it won't be captured by `chrome` RegExp and will fall into `Gecko` branch.
 * This function is extracted so that we can use it in both places without duplicating the logic.
 * Unfortunately "just" changing RegExp is too complicated now and making it pass all tests
 * and fix this case seems like an impossible, or at least way too time-consuming task.
 */
var extractSafariExtensionDetails = function (func, filename) {
    var isSafariExtension = func.indexOf('safari-extension') !== -1;
    var isSafariWebExtension = func.indexOf('safari-web-extension') !== -1;
    return isSafariExtension || isSafariWebExtension
        ? [
            func.indexOf('@') !== -1 ? func.split('@')[0] : UNKNOWN_FUNCTION,
            isSafariExtension ? "safari-extension:" + filename : "safari-web-extension:" + filename,
        ]
        : [func, filename];
};

/**
 * This function creates an exception from an TraceKitStackTrace
 * @param stacktrace TraceKitStackTrace that will be converted to an exception
 * @hidden
 */
function exceptionFromError(ex) {
    // Get the frames first since Opera can lose the stack if we touch anything else first
    var frames = parseStackFrames(ex);
    var exception = {
        type: ex && ex.name,
        value: extractMessage(ex),
    };
    if (frames.length) {
        exception.stacktrace = { frames: frames };
    }
    if (exception.type === undefined && exception.value === '') {
        exception.value = 'Unrecoverable error caught';
    }
    return exception;
}
/**
 * @hidden
 */
function eventFromPlainObject(exception, syntheticException, isUnhandledRejection) {
    var event = {
        exception: {
            values: [
                {
                    type: isEvent(exception) ? exception.constructor.name : isUnhandledRejection ? 'UnhandledRejection' : 'Error',
                    value: "Non-Error " + (isUnhandledRejection ? 'promise rejection' : 'exception') + " captured with keys: " + extractExceptionKeysForMessage(exception),
                },
            ],
        },
        extra: {
            __serialized__: normalizeToSize(exception),
        },
    };
    if (syntheticException) {
        var frames_1 = parseStackFrames(syntheticException);
        if (frames_1.length) {
            event.stacktrace = { frames: frames_1 };
        }
    }
    return event;
}
/**
 * @hidden
 */
function eventFromError(ex) {
    return {
        exception: {
            values: [exceptionFromError(ex)],
        },
    };
}
/** Parses stack frames from an error */
function parseStackFrames(ex) {
    // Access and store the stacktrace property before doing ANYTHING
    // else to it because Opera is not very good at providing it
    // reliably in other circumstances.
    var stacktrace = ex.stacktrace || ex.stack || '';
    var popSize = getPopSize(ex);
    try {
        return createStackParser(opera10StackParser, opera11StackParser, chromeStackParser, winjsStackParser, geckoStackParser)(stacktrace, popSize);
    }
    catch (e) {
        // no-empty
    }
    return [];
}
// Based on our own mapping pattern - https://github.com/getsentry/sentry/blob/9f08305e09866c8bd6d0c24f5b0aabdd7dd6c59c/src/sentry/lang/javascript/errormapping.py#L83-L108
var reactMinifiedRegexp = /Minified React error #\d+;/i;
function getPopSize(ex) {
    if (ex) {
        if (typeof ex.framesToPop === 'number') {
            return ex.framesToPop;
        }
        if (reactMinifiedRegexp.test(ex.message)) {
            return 1;
        }
    }
    return 0;
}
/**
 * There are cases where stacktrace.message is an Event object
 * https://github.com/getsentry/sentry-javascript/issues/1949
 * In this specific case we try to extract stacktrace.message.error.message
 */
function extractMessage(ex) {
    var message = ex && ex.message;
    if (!message) {
        return 'No error message';
    }
    if (message.error && typeof message.error.message === 'string') {
        return message.error.message;
    }
    return message;
}
/**
 * Creates an {@link Event} from all inputs to `captureException` and non-primitive inputs to `captureMessage`.
 * @hidden
 */
function eventFromException(exception, hint, attachStacktrace) {
    var syntheticException = (hint && hint.syntheticException) || undefined;
    var event = eventFromUnknownInput(exception, syntheticException, attachStacktrace);
    addExceptionMechanism(event); // defaults to { type: 'generic', handled: true }
    event.level = Severity.Error;
    if (hint && hint.event_id) {
        event.event_id = hint.event_id;
    }
    return resolvedSyncPromise(event);
}
/**
 * Builds and Event from a Message
 * @hidden
 */
function eventFromMessage(message, level, hint, attachStacktrace) {
    if (level === void 0) { level = Severity.Info; }
    var syntheticException = (hint && hint.syntheticException) || undefined;
    var event = eventFromString(message, syntheticException, attachStacktrace);
    event.level = level;
    if (hint && hint.event_id) {
        event.event_id = hint.event_id;
    }
    return resolvedSyncPromise(event);
}
/**
 * @hidden
 */
function eventFromUnknownInput(exception, syntheticException, attachStacktrace, isUnhandledRejection) {
    var event;
    if (isErrorEvent(exception) && exception.error) {
        // If it is an ErrorEvent with `error` property, extract it to get actual Error
        var errorEvent = exception;
        return eventFromError(errorEvent.error);
    }
    // If it is a `DOMError` (which is a legacy API, but still supported in some browsers) then we just extract the name
    // and message, as it doesn't provide anything else. According to the spec, all `DOMExceptions` should also be
    // `Error`s, but that's not the case in IE11, so in that case we treat it the same as we do a `DOMError`.
    //
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMError
    // https://developer.mozilla.org/en-US/docs/Web/API/DOMException
    // https://webidl.spec.whatwg.org/#es-DOMException-specialness
    if (isDOMError(exception) || isDOMException(exception)) {
        var domException = exception;
        if ('stack' in exception) {
            event = eventFromError(exception);
        }
        else {
            var name_1 = domException.name || (isDOMError(domException) ? 'DOMError' : 'DOMException');
            var message = domException.message ? name_1 + ": " + domException.message : name_1;
            event = eventFromString(message, syntheticException, attachStacktrace);
            addExceptionTypeValue(event, message);
        }
        if ('code' in domException) {
            event.tags = __assign$2(__assign$2({}, event.tags), { 'DOMException.code': "" + domException.code });
        }
        return event;
    }
    if (isError(exception)) {
        // we have a real Error object, do nothing
        return eventFromError(exception);
    }
    if (isPlainObject(exception) || isEvent(exception)) {
        // If it's a plain object or an instance of `Event` (the built-in JS kind, not this SDK's `Event` type), serialize
        // it manually. This will allow us to group events based on top-level keys which is much better than creating a new
        // group on any key/value change.
        var objectException = exception;
        event = eventFromPlainObject(objectException, syntheticException, isUnhandledRejection);
        addExceptionMechanism(event, {
            synthetic: true,
        });
        return event;
    }
    // If none of previous checks were valid, then it means that it's not:
    // - an instance of DOMError
    // - an instance of DOMException
    // - an instance of Event
    // - an instance of Error
    // - a valid ErrorEvent (one with an error property)
    // - a plain Object
    //
    // So bail out and capture it as a simple message:
    event = eventFromString(exception, syntheticException, attachStacktrace);
    addExceptionTypeValue(event, "" + exception, undefined);
    addExceptionMechanism(event, {
        synthetic: true,
    });
    return event;
}
/**
 * @hidden
 */
function eventFromString(input, syntheticException, attachStacktrace) {
    var event = {
        message: input,
    };
    if (attachStacktrace && syntheticException) {
        var frames_2 = parseStackFrames(syntheticException);
        if (frames_2.length) {
            event.stacktrace = { frames: frames_2 };
        }
    }
    return event;
}

/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */
/** Flag that is true for debug builds, false otherwise. */
var IS_DEBUG_BUILD$1 = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

var global$7 = getGlobalObject();
var cachedFetchImpl;
/**
 * A special usecase for incorrectly wrapped Fetch APIs in conjunction with ad-blockers.
 * Whenever someone wraps the Fetch API and returns the wrong promise chain,
 * this chain becomes orphaned and there is no possible way to capture it's rejections
 * other than allowing it bubble up to this very handler. eg.
 *
 * const f = window.fetch;
 * window.fetch = function () {
 *   const p = f.apply(this, arguments);
 *
 *   p.then(function() {
 *     console.log('hi.');
 *   });
 *
 *   return p;
 * }
 *
 * `p.then(function () { ... })` is producing a completely separate promise chain,
 * however, what's returned is `p` - the result of original `fetch` call.
 *
 * This mean, that whenever we use the Fetch API to send our own requests, _and_
 * some ad-blocker blocks it, this orphaned chain will _always_ reject,
 * effectively causing another event to be captured.
 * This makes a whole process become an infinite loop, which we need to somehow
 * deal with, and break it in one way or another.
 *
 * To deal with this issue, we are making sure that we _always_ use the real
 * browser Fetch API, instead of relying on what `window.fetch` exposes.
 * The only downside to this would be missing our own requests as breadcrumbs,
 * but because we are already not doing this, it should be just fine.
 *
 * Possible failed fetch error messages per-browser:
 *
 * Chrome:  Failed to fetch
 * Edge:    Failed to Fetch
 * Firefox: NetworkError when attempting to fetch resource
 * Safari:  resource blocked by content blocker
 */
function getNativeFetchImplementation() {
    if (cachedFetchImpl) {
        return cachedFetchImpl;
    }
    /* eslint-disable @typescript-eslint/unbound-method */
    // Fast path to avoid DOM I/O
    if (isNativeFetch(global$7.fetch)) {
        return (cachedFetchImpl = global$7.fetch.bind(global$7));
    }
    var document = global$7.document;
    var fetchImpl = global$7.fetch;
    // eslint-disable-next-line deprecation/deprecation
    if (document && typeof document.createElement === 'function') {
        try {
            var sandbox = document.createElement('iframe');
            sandbox.hidden = true;
            document.head.appendChild(sandbox);
            var contentWindow = sandbox.contentWindow;
            if (contentWindow && contentWindow.fetch) {
                fetchImpl = contentWindow.fetch;
            }
            document.head.removeChild(sandbox);
        }
        catch (e) {
            IS_DEBUG_BUILD$1 &&
                logger.warn('Could not create sandbox iframe for pure fetch check, bailing to window.fetch: ', e);
        }
    }
    return (cachedFetchImpl = fetchImpl.bind(global$7));
    /* eslint-enable @typescript-eslint/unbound-method */
}
/**
 * Sends sdk client report using sendBeacon or fetch as a fallback if available
 *
 * @param url report endpoint
 * @param body report payload
 */
function sendReport(url, body) {
    var isRealNavigator = Object.prototype.toString.call(global$7 && global$7.navigator) === '[object Navigator]';
    var hasSendBeacon = isRealNavigator && typeof global$7.navigator.sendBeacon === 'function';
    if (hasSendBeacon) {
        // Prevent illegal invocations - https://xgwang.me/posts/you-may-not-know-beacon/#it-may-throw-error%2C-be-sure-to-catch
        var sendBeacon = global$7.navigator.sendBeacon.bind(global$7.navigator);
        return sendBeacon(url, body);
    }
    if (supportsFetch()) {
        var fetch_1 = getNativeFetchImplementation();
        return forget(fetch_1(url, {
            body: body,
            method: 'POST',
            credentials: 'omit',
            keepalive: true,
        }));
    }
}

function requestTypeToCategory(ty) {
    var tyStr = ty;
    return tyStr === 'event' ? 'error' : tyStr;
}
var global$6 = getGlobalObject();
/** Base Transport class implementation */
var BaseTransport = /** @class */ (function () {
    function BaseTransport(options) {
        var _this = this;
        this.options = options;
        /** A simple buffer holding all requests. */
        this._buffer = makePromiseBuffer(30);
        /** Locks transport after receiving rate limits in a response */
        this._rateLimits = {};
        this._outcomes = {};
        this._api = initAPIDetails(options.dsn, options._metadata, options.tunnel);
        // eslint-disable-next-line deprecation/deprecation
        this.url = getStoreEndpointWithUrlEncodedAuth(this._api.dsn);
        if (this.options.sendClientReports && global$6.document) {
            global$6.document.addEventListener('visibilitychange', function () {
                if (global$6.document.visibilityState === 'hidden') {
                    _this._flushOutcomes();
                }
            });
        }
    }
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.sendEvent = function (event) {
        return this._sendRequest(eventToSentryRequest(event, this._api), event);
    };
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.sendSession = function (session) {
        return this._sendRequest(sessionToSentryRequest(session, this._api), session);
    };
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.close = function (timeout) {
        return this._buffer.drain(timeout);
    };
    /**
     * @inheritDoc
     */
    BaseTransport.prototype.recordLostEvent = function (reason, category) {
        var _a;
        if (!this.options.sendClientReports) {
            return;
        }
        // We want to track each category (event, transaction, session) separately
        // but still keep the distinction between different type of outcomes.
        // We could use nested maps, but it's much easier to read and type this way.
        // A correct type for map-based implementation if we want to go that route
        // would be `Partial<Record<SentryRequestType, Partial<Record<Outcome, number>>>>`
        var key = requestTypeToCategory(category) + ":" + reason;
        IS_DEBUG_BUILD$1 && logger.log("Adding outcome: " + key);
        this._outcomes[key] = (_a = this._outcomes[key], (_a !== null && _a !== void 0 ? _a : 0)) + 1;
    };
    /**
     * Send outcomes as an envelope
     */
    BaseTransport.prototype._flushOutcomes = function () {
        if (!this.options.sendClientReports) {
            return;
        }
        var outcomes = this._outcomes;
        this._outcomes = {};
        // Nothing to send
        if (!Object.keys(outcomes).length) {
            IS_DEBUG_BUILD$1 && logger.log('No outcomes to flush');
            return;
        }
        IS_DEBUG_BUILD$1 && logger.log("Flushing outcomes:\n" + JSON.stringify(outcomes, null, 2));
        var url = getEnvelopeEndpointWithUrlEncodedAuth(this._api.dsn, this._api.tunnel);
        var discardedEvents = Object.keys(outcomes).map(function (key) {
            var _a = __read$4(key.split(':'), 2), category = _a[0], reason = _a[1];
            return {
                reason: reason,
                category: category,
                quantity: outcomes[key],
            };
            // TODO: Improve types on discarded_events to get rid of cast
        });
        var envelope = createClientReportEnvelope(discardedEvents, this._api.tunnel && dsnToString(this._api.dsn));
        try {
            sendReport(url, serializeEnvelope(envelope));
        }
        catch (e) {
            IS_DEBUG_BUILD$1 && logger.error(e);
        }
    };
    /**
     * Handle Sentry repsonse for promise-based transports.
     */
    BaseTransport.prototype._handleResponse = function (_a) {
        var requestType = _a.requestType, response = _a.response, headers = _a.headers, resolve = _a.resolve, reject = _a.reject;
        var status = eventStatusFromHttpCode(response.status);
        this._rateLimits = updateRateLimits(this._rateLimits, headers);
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(requestType)) {
            IS_DEBUG_BUILD$1 &&
                // eslint-disable-next-line deprecation/deprecation
                logger.warn("Too many " + requestType + " requests, backing off until: " + this._disabledUntil(requestType));
        }
        if (status === 'success') {
            resolve({ status: status });
            return;
        }
        reject(response);
    };
    /**
     * Gets the time that given category is disabled until for rate limiting
     *
     * @deprecated Please use `disabledUntil` from @sentry/utils
     */
    BaseTransport.prototype._disabledUntil = function (requestType) {
        var category = requestTypeToCategory(requestType);
        return new Date(disabledUntil(this._rateLimits, category));
    };
    /**
     * Checks if a category is rate limited
     *
     * @deprecated Please use `isRateLimited` from @sentry/utils
     */
    BaseTransport.prototype._isRateLimited = function (requestType) {
        var category = requestTypeToCategory(requestType);
        return isRateLimited(this._rateLimits, category);
    };
    return BaseTransport;
}());

/** `fetch` based transport */
var FetchTransport = /** @class */ (function (_super) {
    __extends$1(FetchTransport, _super);
    function FetchTransport(options, fetchImpl) {
        if (fetchImpl === void 0) { fetchImpl = getNativeFetchImplementation(); }
        var _this = _super.call(this, options) || this;
        _this._fetch = fetchImpl;
        return _this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */
    FetchTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429,
            });
        }
        var options = {
            body: sentryRequest.body,
            method: 'POST',
            // Despite all stars in the sky saying that Edge supports old draft syntax, aka 'never', 'always', 'origin' and 'default'
            // (see https://caniuse.com/#feat=referrer-policy),
            // it doesn't. And it throws an exception instead of ignoring this parameter...
            // REF: https://github.com/getsentry/raven-js/issues/1233
            referrerPolicy: (supportsReferrerPolicy() ? 'origin' : ''),
        };
        if (this.options.fetchParameters !== undefined) {
            Object.assign(options, this.options.fetchParameters);
        }
        if (this.options.headers !== undefined) {
            options.headers = this.options.headers;
        }
        return this._buffer
            .add(function () {
            return new SyncPromise(function (resolve, reject) {
                void _this._fetch(sentryRequest.url, options)
                    .then(function (response) {
                    var headers = {
                        'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                        'retry-after': response.headers.get('Retry-After'),
                    };
                    _this._handleResponse({
                        requestType: sentryRequest.type,
                        response: response,
                        headers: headers,
                        resolve: resolve,
                        reject: reject,
                    });
                })
                    .catch(reject);
            });
        })
            .then(undefined, function (reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof SentryError) {
                _this.recordLostEvent('queue_overflow', sentryRequest.type);
            }
            else {
                _this.recordLostEvent('network_error', sentryRequest.type);
            }
            throw reason;
        });
    };
    return FetchTransport;
}(BaseTransport));

/** `XHR` based transport */
var XHRTransport = /** @class */ (function (_super) {
    __extends$1(XHRTransport, _super);
    function XHRTransport() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @param sentryRequest Prepared SentryRequest to be delivered
     * @param originalPayload Original payload used to create SentryRequest
     */
    XHRTransport.prototype._sendRequest = function (sentryRequest, originalPayload) {
        var _this = this;
        // eslint-disable-next-line deprecation/deprecation
        if (this._isRateLimited(sentryRequest.type)) {
            this.recordLostEvent('ratelimit_backoff', sentryRequest.type);
            return Promise.reject({
                event: originalPayload,
                type: sentryRequest.type,
                // eslint-disable-next-line deprecation/deprecation
                reason: "Transport for " + sentryRequest.type + " requests locked till " + this._disabledUntil(sentryRequest.type) + " due to too many requests.",
                status: 429,
            });
        }
        return this._buffer
            .add(function () {
            return new SyncPromise(function (resolve, reject) {
                var request = new XMLHttpRequest();
                request.onreadystatechange = function () {
                    if (request.readyState === 4) {
                        var headers = {
                            'x-sentry-rate-limits': request.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': request.getResponseHeader('Retry-After'),
                        };
                        _this._handleResponse({ requestType: sentryRequest.type, response: request, headers: headers, resolve: resolve, reject: reject });
                    }
                };
                request.open('POST', sentryRequest.url);
                for (var header in _this.options.headers) {
                    if (Object.prototype.hasOwnProperty.call(_this.options.headers, header)) {
                        request.setRequestHeader(header, _this.options.headers[header]);
                    }
                }
                request.send(sentryRequest.body);
            });
        })
            .then(undefined, function (reason) {
            // It's either buffer rejection or any other xhr/fetch error, which are treated as NetworkError.
            if (reason instanceof SentryError) {
                _this.recordLostEvent('queue_overflow', sentryRequest.type);
            }
            else {
                _this.recordLostEvent('network_error', sentryRequest.type);
            }
            throw reason;
        });
    };
    return XHRTransport;
}(BaseTransport));

/**
 * Creates a Transport that uses the Fetch API to send events to Sentry.
 */
function makeNewFetchTransport(options, nativeFetch) {
    if (nativeFetch === void 0) { nativeFetch = getNativeFetchImplementation(); }
    function makeRequest(request) {
        var requestOptions = __assign$2({ body: request.body, method: 'POST', referrerPolicy: 'origin' }, options.requestOptions);
        return nativeFetch(options.url, requestOptions).then(function (response) {
            return response.text().then(function (body) { return ({
                body: body,
                headers: {
                    'x-sentry-rate-limits': response.headers.get('X-Sentry-Rate-Limits'),
                    'retry-after': response.headers.get('Retry-After'),
                },
                reason: response.statusText,
                statusCode: response.status,
            }); });
        });
    }
    return createTransport({ bufferSize: options.bufferSize }, makeRequest);
}

/**
 * The DONE ready state for XmlHttpRequest
 *
 * Defining it here as a constant b/c XMLHttpRequest.DONE is not always defined
 * (e.g. during testing, it is `undefined`)
 *
 * @see {@link https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest/readyState}
 */
var XHR_READYSTATE_DONE = 4;
/**
 * Creates a Transport that uses the XMLHttpRequest API to send events to Sentry.
 */
function makeNewXHRTransport(options) {
    function makeRequest(request) {
        return new SyncPromise(function (resolve, _reject) {
            var xhr = new XMLHttpRequest();
            xhr.onreadystatechange = function () {
                if (xhr.readyState === XHR_READYSTATE_DONE) {
                    var response = {
                        body: xhr.response,
                        headers: {
                            'x-sentry-rate-limits': xhr.getResponseHeader('X-Sentry-Rate-Limits'),
                            'retry-after': xhr.getResponseHeader('Retry-After'),
                        },
                        reason: xhr.statusText,
                        statusCode: xhr.status,
                    };
                    resolve(response);
                }
            };
            xhr.open('POST', options.url);
            for (var header in options.headers) {
                if (Object.prototype.hasOwnProperty.call(options.headers, header)) {
                    xhr.setRequestHeader(header, options.headers[header]);
                }
            }
            xhr.send(request.body);
        });
    }
    return createTransport({ bufferSize: options.bufferSize }, makeRequest);
}

/**
 * The Sentry Browser SDK Backend.
 * @hidden
 */
var BrowserBackend = /** @class */ (function (_super) {
    __extends$1(BrowserBackend, _super);
    function BrowserBackend() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromException = function (exception, hint) {
        return eventFromException(exception, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype.eventFromMessage = function (message, level, hint) {
        if (level === void 0) { level = Severity.Info; }
        return eventFromMessage(message, level, hint, this._options.attachStacktrace);
    };
    /**
     * @inheritDoc
     */
    BrowserBackend.prototype._setupTransport = function () {
        if (!this._options.dsn) {
            // We return the noop transport here in case there is no Dsn.
            return _super.prototype._setupTransport.call(this);
        }
        var transportOptions = __assign$2(__assign$2({}, this._options.transportOptions), { dsn: this._options.dsn, tunnel: this._options.tunnel, sendClientReports: this._options.sendClientReports, _metadata: this._options._metadata });
        var api = initAPIDetails(transportOptions.dsn, transportOptions._metadata, transportOptions.tunnel);
        var url = getEnvelopeEndpointWithUrlEncodedAuth(api.dsn, api.tunnel);
        if (this._options.transport) {
            return new this._options.transport(transportOptions);
        }
        if (supportsFetch()) {
            var requestOptions = __assign$2({}, transportOptions.fetchParameters);
            this._newTransport = makeNewFetchTransport({ requestOptions: requestOptions, url: url });
            return new FetchTransport(transportOptions);
        }
        this._newTransport = makeNewXHRTransport({
            url: url,
            headers: transportOptions.headers,
        });
        return new XHRTransport(transportOptions);
    };
    return BrowserBackend;
}(BaseBackend));

var global$5 = getGlobalObject();
var ignoreOnError = 0;
/**
 * @hidden
 */
function shouldIgnoreOnError() {
    return ignoreOnError > 0;
}
/**
 * @hidden
 */
function ignoreNextOnError() {
    // onerror should trigger before setTimeout
    ignoreOnError += 1;
    setTimeout(function () {
        ignoreOnError -= 1;
    });
}
/**
 * Instruments the given function and sends an event to Sentry every time the
 * function throws an exception.
 *
 * @param fn A function to wrap.
 * @returns The wrapped function.
 * @hidden
 */
function wrap(fn, options, before) {
    // for future readers what this does is wrap a function and then create
    // a bi-directional wrapping between them.
    //
    // example: wrapped = wrap(original);
    //  original.__sentry_wrapped__ -> wrapped
    //  wrapped.__sentry_original__ -> original
    if (options === void 0) { options = {}; }
    if (typeof fn !== 'function') {
        return fn;
    }
    try {
        // if we're dealing with a function that was previously wrapped, return
        // the original wrapper.
        var wrapper = fn.__sentry_wrapped__;
        if (wrapper) {
            return wrapper;
        }
        // We don't wanna wrap it twice
        if (getOriginalFunction(fn)) {
            return fn;
        }
    }
    catch (e) {
        // Just accessing custom props in some Selenium environments
        // can cause a "Permission denied" exception (see raven-js#495).
        // Bail on wrapping and return the function as-is (defers to window.onerror).
        return fn;
    }
    /* eslint-disable prefer-rest-params */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var sentryWrapped = function () {
        var args = Array.prototype.slice.call(arguments);
        try {
            if (before && typeof before === 'function') {
                before.apply(this, arguments);
            }
            // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/no-unsafe-member-access
            var wrappedArguments = args.map(function (arg) { return wrap(arg, options); });
            // Attempt to invoke user-land function
            // NOTE: If you are a Sentry user, and you are seeing this stack frame, it
            //       means the sentry.javascript SDK caught an error invoking your application code. This
            //       is expected behavior and NOT indicative of a bug with sentry.javascript.
            return fn.apply(this, wrappedArguments);
        }
        catch (ex) {
            ignoreNextOnError();
            withScope(function (scope) {
                scope.addEventProcessor(function (event) {
                    if (options.mechanism) {
                        addExceptionTypeValue(event, undefined, undefined);
                        addExceptionMechanism(event, options.mechanism);
                    }
                    event.extra = __assign$2(__assign$2({}, event.extra), { arguments: args });
                    return event;
                });
                captureException(ex);
            });
            throw ex;
        }
    };
    /* eslint-enable prefer-rest-params */
    // Accessing some objects may throw
    // ref: https://github.com/getsentry/sentry-javascript/issues/1168
    try {
        for (var property in fn) {
            if (Object.prototype.hasOwnProperty.call(fn, property)) {
                sentryWrapped[property] = fn[property];
            }
        }
    }
    catch (_oO) { } // eslint-disable-line no-empty
    // Signal that this function has been wrapped/filled already
    // for both debugging and to prevent it to being wrapped/filled twice
    markFunctionWrapped(sentryWrapped, fn);
    addNonEnumerableProperty(fn, '__sentry_wrapped__', sentryWrapped);
    // Restore original function name (not all browsers allow that)
    try {
        var descriptor = Object.getOwnPropertyDescriptor(sentryWrapped, 'name');
        if (descriptor.configurable) {
            Object.defineProperty(sentryWrapped, 'name', {
                get: function () {
                    return fn.name;
                },
            });
        }
        // eslint-disable-next-line no-empty
    }
    catch (_oO) { }
    return sentryWrapped;
}
/**
 * Injects the Report Dialog script
 * @hidden
 */
function injectReportDialog(options) {
    if (options === void 0) { options = {}; }
    if (!global$5.document) {
        return;
    }
    if (!options.eventId) {
        IS_DEBUG_BUILD$1 && logger.error('Missing eventId option in showReportDialog call');
        return;
    }
    if (!options.dsn) {
        IS_DEBUG_BUILD$1 && logger.error('Missing dsn option in showReportDialog call');
        return;
    }
    var script = global$5.document.createElement('script');
    script.async = true;
    script.src = getReportDialogEndpoint(options.dsn, options);
    if (options.onLoad) {
        // eslint-disable-next-line @typescript-eslint/unbound-method
        script.onload = options.onLoad;
    }
    var injectionPoint = global$5.document.head || global$5.document.body;
    if (injectionPoint) {
        injectionPoint.appendChild(script);
    }
}

/** Global handlers */
var GlobalHandlers = /** @class */ (function () {
    /** JSDoc */
    function GlobalHandlers(options) {
        /**
         * @inheritDoc
         */
        this.name = GlobalHandlers.id;
        /**
         * Stores references functions to installing handlers. Will set to undefined
         * after they have been run so that they are not used twice.
         */
        this._installFunc = {
            onerror: _installGlobalOnErrorHandler,
            onunhandledrejection: _installGlobalOnUnhandledRejectionHandler,
        };
        this._options = __assign$2({ onerror: true, onunhandledrejection: true }, options);
    }
    /**
     * @inheritDoc
     */
    GlobalHandlers.prototype.setupOnce = function () {
        Error.stackTraceLimit = 50;
        var options = this._options;
        // We can disable guard-for-in as we construct the options object above + do checks against
        // `this._installFunc` for the property.
        // eslint-disable-next-line guard-for-in
        for (var key in options) {
            var installFunc = this._installFunc[key];
            if (installFunc && options[key]) {
                globalHandlerLog(key);
                installFunc();
                this._installFunc[key] = undefined;
            }
        }
    };
    /**
     * @inheritDoc
     */
    GlobalHandlers.id = 'GlobalHandlers';
    return GlobalHandlers;
}());
/** JSDoc */
function _installGlobalOnErrorHandler() {
    addInstrumentationHandler('error', 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function (data) {
        var _a = __read$4(getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration(GlobalHandlers)) {
            return;
        }
        var msg = data.msg, url = data.url, line = data.line, column = data.column, error = data.error;
        if (shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
            return;
        }
        var event = error === undefined && isString(msg)
            ? _eventFromIncompleteOnError(msg, url, line, column)
            : _enhanceEventWithInitialFrame(eventFromUnknownInput(error || msg, undefined, attachStacktrace, false), url, line, column);
        event.level = Severity.Error;
        addMechanismAndCapture(hub, error, event, 'onerror');
    });
}
/** JSDoc */
function _installGlobalOnUnhandledRejectionHandler() {
    addInstrumentationHandler('unhandledrejection', 
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function (e) {
        var _a = __read$4(getHubAndAttachStacktrace(), 2), hub = _a[0], attachStacktrace = _a[1];
        if (!hub.getIntegration(GlobalHandlers)) {
            return;
        }
        var error = e;
        // dig the object of the rejection out of known event types
        try {
            // PromiseRejectionEvents store the object of the rejection under 'reason'
            // see https://developer.mozilla.org/en-US/docs/Web/API/PromiseRejectionEvent
            if ('reason' in e) {
                error = e.reason;
            }
            // something, somewhere, (likely a browser extension) effectively casts PromiseRejectionEvents
            // to CustomEvents, moving the `promise` and `reason` attributes of the PRE into
            // the CustomEvent's `detail` attribute, since they're not part of CustomEvent's spec
            // see https://developer.mozilla.org/en-US/docs/Web/API/CustomEvent and
            // https://github.com/getsentry/sentry-javascript/issues/2380
            else if ('detail' in e && 'reason' in e.detail) {
                error = e.detail.reason;
            }
        }
        catch (_oO) {
            // no-empty
        }
        if (shouldIgnoreOnError() || (error && error.__sentry_own_request__)) {
            return true;
        }
        var event = isPrimitive(error)
            ? _eventFromRejectionWithPrimitive(error)
            : eventFromUnknownInput(error, undefined, attachStacktrace, true);
        event.level = Severity.Error;
        addMechanismAndCapture(hub, error, event, 'onunhandledrejection');
        return;
    });
}
/**
 * Create an event from a promise rejection where the `reason` is a primitive.
 *
 * @param reason: The `reason` property of the promise rejection
 * @returns An Event object with an appropriate `exception` value
 */
function _eventFromRejectionWithPrimitive(reason) {
    return {
        exception: {
            values: [
                {
                    type: 'UnhandledRejection',
                    // String() is needed because the Primitive type includes symbols (which can't be automatically stringified)
                    value: "Non-Error promise rejection captured with value: " + String(reason),
                },
            ],
        },
    };
}
/**
 * This function creates a stack from an old, error-less onerror handler.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _eventFromIncompleteOnError(msg, url, line, column) {
    var ERROR_TYPES_RE = /^(?:[Uu]ncaught (?:exception: )?)?(?:((?:Eval|Internal|Range|Reference|Syntax|Type|URI|)Error): )?(.*)$/i;
    // If 'message' is ErrorEvent, get real message from inside
    var message = isErrorEvent(msg) ? msg.message : msg;
    var name = 'Error';
    var groups = message.match(ERROR_TYPES_RE);
    if (groups) {
        name = groups[1];
        message = groups[2];
    }
    var event = {
        exception: {
            values: [
                {
                    type: name,
                    value: message,
                },
            ],
        },
    };
    return _enhanceEventWithInitialFrame(event, url, line, column);
}
/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _enhanceEventWithInitialFrame(event, url, line, column) {
    // event.exception
    var e = (event.exception = event.exception || {});
    // event.exception.values
    var ev = (e.values = e.values || []);
    // event.exception.values[0]
    var ev0 = (ev[0] = ev[0] || {});
    // event.exception.values[0].stacktrace
    var ev0s = (ev0.stacktrace = ev0.stacktrace || {});
    // event.exception.values[0].stacktrace.frames
    var ev0sf = (ev0s.frames = ev0s.frames || []);
    var colno = isNaN(parseInt(column, 10)) ? undefined : column;
    var lineno = isNaN(parseInt(line, 10)) ? undefined : line;
    var filename = isString(url) && url.length > 0 ? url : getLocationHref();
    // event.exception.values[0].stacktrace.frames
    if (ev0sf.length === 0) {
        ev0sf.push({
            colno: colno,
            filename: filename,
            function: '?',
            in_app: true,
            lineno: lineno,
        });
    }
    return event;
}
function globalHandlerLog(type) {
    IS_DEBUG_BUILD$1 && logger.log("Global Handler attached: " + type);
}
function addMechanismAndCapture(hub, error, event, type) {
    addExceptionMechanism(event, {
        handled: false,
        type: type,
    });
    hub.captureEvent(event, {
        originalException: error,
    });
}
function getHubAndAttachStacktrace() {
    var hub = getCurrentHub();
    var client = hub.getClient();
    var attachStacktrace = client && client.getOptions().attachStacktrace;
    return [hub, attachStacktrace];
}

var DEFAULT_EVENT_TARGET = [
    'EventTarget',
    'Window',
    'Node',
    'ApplicationCache',
    'AudioTrackList',
    'ChannelMergerNode',
    'CryptoOperation',
    'EventSource',
    'FileReader',
    'HTMLUnknownElement',
    'IDBDatabase',
    'IDBRequest',
    'IDBTransaction',
    'KeyOperation',
    'MediaController',
    'MessagePort',
    'ModalWindow',
    'Notification',
    'SVGElementInstance',
    'Screen',
    'TextTrack',
    'TextTrackCue',
    'TextTrackList',
    'WebSocket',
    'WebSocketWorker',
    'Worker',
    'XMLHttpRequest',
    'XMLHttpRequestEventTarget',
    'XMLHttpRequestUpload',
];
/** Wrap timer functions and event targets to catch errors and provide better meta data */
var TryCatch = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function TryCatch(options) {
        /**
         * @inheritDoc
         */
        this.name = TryCatch.id;
        this._options = __assign$2({ XMLHttpRequest: true, eventTarget: true, requestAnimationFrame: true, setInterval: true, setTimeout: true }, options);
    }
    /**
     * Wrap timer functions and event targets to catch errors
     * and provide better metadata.
     */
    TryCatch.prototype.setupOnce = function () {
        var global = getGlobalObject();
        if (this._options.setTimeout) {
            fill(global, 'setTimeout', _wrapTimeFunction);
        }
        if (this._options.setInterval) {
            fill(global, 'setInterval', _wrapTimeFunction);
        }
        if (this._options.requestAnimationFrame) {
            fill(global, 'requestAnimationFrame', _wrapRAF);
        }
        if (this._options.XMLHttpRequest && 'XMLHttpRequest' in global) {
            fill(XMLHttpRequest.prototype, 'send', _wrapXHR);
        }
        var eventTargetOption = this._options.eventTarget;
        if (eventTargetOption) {
            var eventTarget = Array.isArray(eventTargetOption) ? eventTargetOption : DEFAULT_EVENT_TARGET;
            eventTarget.forEach(_wrapEventTarget);
        }
    };
    /**
     * @inheritDoc
     */
    TryCatch.id = 'TryCatch';
    return TryCatch;
}());
/** JSDoc */
function _wrapTimeFunction(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        var originalCallback = args[0];
        args[0] = wrap(originalCallback, {
            mechanism: {
                data: { function: getFunctionName(original) },
                handled: true,
                type: 'instrument',
            },
        });
        return original.apply(this, args);
    };
}
/** JSDoc */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _wrapRAF(original) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function (callback) {
        // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
        return original.apply(this, [
            wrap(callback, {
                mechanism: {
                    data: {
                        function: 'requestAnimationFrame',
                        handler: getFunctionName(original),
                    },
                    handled: true,
                    type: 'instrument',
                },
            }),
        ]);
    };
}
/** JSDoc */
function _wrapXHR(originalSend) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    return function () {
        var args = [];
        for (var _i = 0; _i < arguments.length; _i++) {
            args[_i] = arguments[_i];
        }
        // eslint-disable-next-line @typescript-eslint/no-this-alias
        var xhr = this;
        var xmlHttpRequestProps = ['onload', 'onerror', 'onprogress', 'onreadystatechange'];
        xmlHttpRequestProps.forEach(function (prop) {
            if (prop in xhr && typeof xhr[prop] === 'function') {
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                fill(xhr, prop, function (original) {
                    var wrapOptions = {
                        mechanism: {
                            data: {
                                function: prop,
                                handler: getFunctionName(original),
                            },
                            handled: true,
                            type: 'instrument',
                        },
                    };
                    // If Instrument integration has been called before TryCatch, get the name of original function
                    var originalFunction = getOriginalFunction(original);
                    if (originalFunction) {
                        wrapOptions.mechanism.data.handler = getFunctionName(originalFunction);
                    }
                    // Otherwise wrap directly
                    return wrap(original, wrapOptions);
                });
            }
        });
        return originalSend.apply(this, args);
    };
}
/** JSDoc */
function _wrapEventTarget(target) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    var global = getGlobalObject();
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
    var proto = global[target] && global[target].prototype;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access, no-prototype-builtins
    if (!proto || !proto.hasOwnProperty || !proto.hasOwnProperty('addEventListener')) {
        return;
    }
    fill(proto, 'addEventListener', function (original) {
        return function (eventName, fn, options) {
            try {
                if (typeof fn.handleEvent === 'function') {
                    fn.handleEvent = wrap(fn.handleEvent.bind(fn), {
                        mechanism: {
                            data: {
                                function: 'handleEvent',
                                handler: getFunctionName(fn),
                                target: target,
                            },
                            handled: true,
                            type: 'instrument',
                        },
                    });
                }
            }
            catch (err) {
                // can sometimes get 'Permission denied to access property "handle Event'
            }
            return original.apply(this, [
                eventName,
                // eslint-disable-next-line @typescript-eslint/no-explicit-any
                wrap(fn, {
                    mechanism: {
                        data: {
                            function: 'addEventListener',
                            handler: getFunctionName(fn),
                            target: target,
                        },
                        handled: true,
                        type: 'instrument',
                    },
                }),
                options,
            ]);
        };
    });
    fill(proto, 'removeEventListener', function (originalRemoveEventListener) {
        return function (eventName, fn, options) {
            /**
             * There are 2 possible scenarios here:
             *
             * 1. Someone passes a callback, which was attached prior to Sentry initialization, or by using unmodified
             * method, eg. `document.addEventListener.call(el, name, handler). In this case, we treat this function
             * as a pass-through, and call original `removeEventListener` with it.
             *
             * 2. Someone passes a callback, which was attached after Sentry was initialized, which means that it was using
             * our wrapped version of `addEventListener`, which internally calls `wrap` helper.
             * This helper "wraps" whole callback inside a try/catch statement, and attached appropriate metadata to it,
             * in order for us to make a distinction between wrapped/non-wrapped functions possible.
             * If a function was wrapped, it has additional property of `__sentry_wrapped__`, holding the handler.
             *
             * When someone adds a handler prior to initialization, and then do it again, but after,
             * then we have to detach both of them. Otherwise, if we'd detach only wrapped one, it'd be impossible
             * to get rid of the initial handler and it'd stick there forever.
             */
            var wrappedEventHandler = fn;
            try {
                var originalEventHandler = wrappedEventHandler && wrappedEventHandler.__sentry_wrapped__;
                if (originalEventHandler) {
                    originalRemoveEventListener.call(this, eventName, originalEventHandler, options);
                }
            }
            catch (e) {
                // ignore, accessing __sentry_wrapped__ will throw in some Selenium environments
            }
            return originalRemoveEventListener.call(this, eventName, wrappedEventHandler, options);
        };
    });
}

/**
 * Default Breadcrumbs instrumentations
 * TODO: Deprecated - with v6, this will be renamed to `Instrument`
 */
var Breadcrumbs = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function Breadcrumbs(options) {
        /**
         * @inheritDoc
         */
        this.name = Breadcrumbs.id;
        this._options = __assign$2({ console: true, dom: true, fetch: true, history: true, sentry: true, xhr: true }, options);
    }
    /**
     * Create a breadcrumb of `sentry` from the events themselves
     */
    Breadcrumbs.prototype.addSentryBreadcrumb = function (event) {
        if (!this._options.sentry) {
            return;
        }
        getCurrentHub().addBreadcrumb({
            category: "sentry." + (event.type === 'transaction' ? 'transaction' : 'event'),
            event_id: event.event_id,
            level: event.level,
            message: getEventDescription(event),
        }, {
            event: event,
        });
    };
    /**
     * Instrument browser built-ins w/ breadcrumb capturing
     *  - Console API
     *  - DOM API (click/typing)
     *  - XMLHttpRequest API
     *  - Fetch API
     *  - History API
     */
    Breadcrumbs.prototype.setupOnce = function () {
        if (this._options.console) {
            addInstrumentationHandler('console', _consoleBreadcrumb);
        }
        if (this._options.dom) {
            addInstrumentationHandler('dom', _domBreadcrumb(this._options.dom));
        }
        if (this._options.xhr) {
            addInstrumentationHandler('xhr', _xhrBreadcrumb);
        }
        if (this._options.fetch) {
            addInstrumentationHandler('fetch', _fetchBreadcrumb);
        }
        if (this._options.history) {
            addInstrumentationHandler('history', _historyBreadcrumb);
        }
    };
    /**
     * @inheritDoc
     */
    Breadcrumbs.id = 'Breadcrumbs';
    return Breadcrumbs;
}());
/**
 * A HOC that creaes a function that creates breadcrumbs from DOM API calls.
 * This is a HOC so that we get access to dom options in the closure.
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _domBreadcrumb(dom) {
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    function _innerDomBreadcrumb(handlerData) {
        var target;
        var keyAttrs = typeof dom === 'object' ? dom.serializeAttribute : undefined;
        if (typeof keyAttrs === 'string') {
            keyAttrs = [keyAttrs];
        }
        // Accessing event.target can throw (see getsentry/raven-js#838, #768)
        try {
            target = handlerData.event.target
                ? htmlTreeAsString(handlerData.event.target, keyAttrs)
                : htmlTreeAsString(handlerData.event, keyAttrs);
        }
        catch (e) {
            target = '<unknown>';
        }
        if (target.length === 0) {
            return;
        }
        getCurrentHub().addBreadcrumb({
            category: "ui." + handlerData.name,
            message: target,
        }, {
            event: handlerData.event,
            name: handlerData.name,
            global: handlerData.global,
        });
    }
    return _innerDomBreadcrumb;
}
/**
 * Creates breadcrumbs from console API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _consoleBreadcrumb(handlerData) {
    var breadcrumb = {
        category: 'console',
        data: {
            arguments: handlerData.args,
            logger: 'console',
        },
        level: severityFromString(handlerData.level),
        message: safeJoin(handlerData.args, ' '),
    };
    if (handlerData.level === 'assert') {
        if (handlerData.args[0] === false) {
            breadcrumb.message = "Assertion failed: " + (safeJoin(handlerData.args.slice(1), ' ') || 'console.assert');
            breadcrumb.data.arguments = handlerData.args.slice(1);
        }
        else {
            // Don't capture a breadcrumb for passed assertions
            return;
        }
    }
    getCurrentHub().addBreadcrumb(breadcrumb, {
        input: handlerData.args,
        level: handlerData.level,
    });
}
/**
 * Creates breadcrumbs from XHR API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _xhrBreadcrumb(handlerData) {
    if (handlerData.endTimestamp) {
        // We only capture complete, non-sentry requests
        if (handlerData.xhr.__sentry_own_request__) {
            return;
        }
        var _a = handlerData.xhr.__sentry_xhr__ || {}, method = _a.method, url = _a.url, status_code = _a.status_code, body = _a.body;
        getCurrentHub().addBreadcrumb({
            category: 'xhr',
            data: {
                method: method,
                url: url,
                status_code: status_code,
            },
            type: 'http',
        }, {
            xhr: handlerData.xhr,
            input: body,
        });
        return;
    }
}
/**
 * Creates breadcrumbs from fetch API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _fetchBreadcrumb(handlerData) {
    // We only capture complete fetch requests
    if (!handlerData.endTimestamp) {
        return;
    }
    if (handlerData.fetchData.url.match(/sentry_key/) && handlerData.fetchData.method === 'POST') {
        // We will not create breadcrumbs for fetch requests that contain `sentry_key` (internal sentry requests)
        return;
    }
    if (handlerData.error) {
        getCurrentHub().addBreadcrumb({
            category: 'fetch',
            data: handlerData.fetchData,
            level: Severity.Error,
            type: 'http',
        }, {
            data: handlerData.error,
            input: handlerData.args,
        });
    }
    else {
        getCurrentHub().addBreadcrumb({
            category: 'fetch',
            data: __assign$2(__assign$2({}, handlerData.fetchData), { status_code: handlerData.response.status }),
            type: 'http',
        }, {
            input: handlerData.args,
            response: handlerData.response,
        });
    }
}
/**
 * Creates breadcrumbs from history API calls
 */
// eslint-disable-next-line @typescript-eslint/no-explicit-any
function _historyBreadcrumb(handlerData) {
    var global = getGlobalObject();
    var from = handlerData.from;
    var to = handlerData.to;
    var parsedLoc = parseUrl(global.location.href);
    var parsedFrom = parseUrl(from);
    var parsedTo = parseUrl(to);
    // Initial pushState doesn't provide `from` information
    if (!parsedFrom.path) {
        parsedFrom = parsedLoc;
    }
    // Use only the path component of the URL if the URL matches the current
    // document (almost all the time when using pushState)
    if (parsedLoc.protocol === parsedTo.protocol && parsedLoc.host === parsedTo.host) {
        to = parsedTo.relative;
    }
    if (parsedLoc.protocol === parsedFrom.protocol && parsedLoc.host === parsedFrom.host) {
        from = parsedFrom.relative;
    }
    getCurrentHub().addBreadcrumb({
        category: 'navigation',
        data: {
            from: from,
            to: to,
        },
    });
}

var DEFAULT_KEY = 'cause';
var DEFAULT_LIMIT = 5;
/** Adds SDK info to an event. */
var LinkedErrors = /** @class */ (function () {
    /**
     * @inheritDoc
     */
    function LinkedErrors(options) {
        if (options === void 0) { options = {}; }
        /**
         * @inheritDoc
         */
        this.name = LinkedErrors.id;
        this._key = options.key || DEFAULT_KEY;
        this._limit = options.limit || DEFAULT_LIMIT;
    }
    /**
     * @inheritDoc
     */
    LinkedErrors.prototype.setupOnce = function () {
        addGlobalEventProcessor(function (event, hint) {
            var self = getCurrentHub().getIntegration(LinkedErrors);
            return self ? _handler(self._key, self._limit, event, hint) : event;
        });
    };
    /**
     * @inheritDoc
     */
    LinkedErrors.id = 'LinkedErrors';
    return LinkedErrors;
}());
/**
 * @inheritDoc
 */
function _handler(key, limit, event, hint) {
    if (!event.exception || !event.exception.values || !hint || !isInstanceOf(hint.originalException, Error)) {
        return event;
    }
    var linkedErrors = _walkErrorTree(limit, hint.originalException, key);
    event.exception.values = __spread$1(linkedErrors, event.exception.values);
    return event;
}
/**
 * JSDOC
 */
function _walkErrorTree(limit, error, key, stack) {
    if (stack === void 0) { stack = []; }
    if (!isInstanceOf(error[key], Error) || stack.length + 1 >= limit) {
        return stack;
    }
    var exception = exceptionFromError(error[key]);
    return _walkErrorTree(limit, error[key], key, __spread$1([exception], stack));
}

var global$4 = getGlobalObject();
/** UserAgent */
var UserAgent = /** @class */ (function () {
    function UserAgent() {
        /**
         * @inheritDoc
         */
        this.name = UserAgent.id;
    }
    /**
     * @inheritDoc
     */
    UserAgent.prototype.setupOnce = function () {
        addGlobalEventProcessor(function (event) {
            if (getCurrentHub().getIntegration(UserAgent)) {
                // if none of the information we want exists, don't bother
                if (!global$4.navigator && !global$4.location && !global$4.document) {
                    return event;
                }
                // grab as much info as exists and add it to the event
                var url = (event.request && event.request.url) || (global$4.location && global$4.location.href);
                var referrer = (global$4.document || {}).referrer;
                var userAgent = (global$4.navigator || {}).userAgent;
                var headers = __assign$2(__assign$2(__assign$2({}, (event.request && event.request.headers)), (referrer && { Referer: referrer })), (userAgent && { 'User-Agent': userAgent }));
                var request = __assign$2(__assign$2({}, (url && { url: url })), { headers: headers });
                return __assign$2(__assign$2({}, event), { request: request });
            }
            return event;
        });
    };
    /**
     * @inheritDoc
     */
    UserAgent.id = 'UserAgent';
    return UserAgent;
}());

/** Deduplication filter */
var Dedupe = /** @class */ (function () {
    function Dedupe() {
        /**
         * @inheritDoc
         */
        this.name = Dedupe.id;
    }
    /**
     * @inheritDoc
     */
    Dedupe.prototype.setupOnce = function (addGlobalEventProcessor, getCurrentHub) {
        addGlobalEventProcessor(function (currentEvent) {
            var self = getCurrentHub().getIntegration(Dedupe);
            if (self) {
                // Juuust in case something goes wrong
                try {
                    if (_shouldDropEvent(currentEvent, self._previousEvent)) {
                        IS_DEBUG_BUILD$1 && logger.warn('Event dropped due to being a duplicate of previously captured event.');
                        return null;
                    }
                }
                catch (_oO) {
                    return (self._previousEvent = currentEvent);
                }
                return (self._previousEvent = currentEvent);
            }
            return currentEvent;
        });
    };
    /**
     * @inheritDoc
     */
    Dedupe.id = 'Dedupe';
    return Dedupe;
}());
/** JSDoc */
function _shouldDropEvent(currentEvent, previousEvent) {
    if (!previousEvent) {
        return false;
    }
    if (_isSameMessageEvent(currentEvent, previousEvent)) {
        return true;
    }
    if (_isSameExceptionEvent(currentEvent, previousEvent)) {
        return true;
    }
    return false;
}
/** JSDoc */
function _isSameMessageEvent(currentEvent, previousEvent) {
    var currentMessage = currentEvent.message;
    var previousMessage = previousEvent.message;
    // If neither event has a message property, they were both exceptions, so bail out
    if (!currentMessage && !previousMessage) {
        return false;
    }
    // If only one event has a stacktrace, but not the other one, they are not the same
    if ((currentMessage && !previousMessage) || (!currentMessage && previousMessage)) {
        return false;
    }
    if (currentMessage !== previousMessage) {
        return false;
    }
    if (!_isSameFingerprint(currentEvent, previousEvent)) {
        return false;
    }
    if (!_isSameStacktrace(currentEvent, previousEvent)) {
        return false;
    }
    return true;
}
/** JSDoc */
function _isSameExceptionEvent(currentEvent, previousEvent) {
    var previousException = _getExceptionFromEvent(previousEvent);
    var currentException = _getExceptionFromEvent(currentEvent);
    if (!previousException || !currentException) {
        return false;
    }
    if (previousException.type !== currentException.type || previousException.value !== currentException.value) {
        return false;
    }
    if (!_isSameFingerprint(currentEvent, previousEvent)) {
        return false;
    }
    if (!_isSameStacktrace(currentEvent, previousEvent)) {
        return false;
    }
    return true;
}
/** JSDoc */
function _isSameStacktrace(currentEvent, previousEvent) {
    var currentFrames = _getFramesFromEvent(currentEvent);
    var previousFrames = _getFramesFromEvent(previousEvent);
    // If neither event has a stacktrace, they are assumed to be the same
    if (!currentFrames && !previousFrames) {
        return true;
    }
    // If only one event has a stacktrace, but not the other one, they are not the same
    if ((currentFrames && !previousFrames) || (!currentFrames && previousFrames)) {
        return false;
    }
    currentFrames = currentFrames;
    previousFrames = previousFrames;
    // If number of frames differ, they are not the same
    if (previousFrames.length !== currentFrames.length) {
        return false;
    }
    // Otherwise, compare the two
    for (var i = 0; i < previousFrames.length; i++) {
        var frameA = previousFrames[i];
        var frameB = currentFrames[i];
        if (frameA.filename !== frameB.filename ||
            frameA.lineno !== frameB.lineno ||
            frameA.colno !== frameB.colno ||
            frameA.function !== frameB.function) {
            return false;
        }
    }
    return true;
}
/** JSDoc */
function _isSameFingerprint(currentEvent, previousEvent) {
    var currentFingerprint = currentEvent.fingerprint;
    var previousFingerprint = previousEvent.fingerprint;
    // If neither event has a fingerprint, they are assumed to be the same
    if (!currentFingerprint && !previousFingerprint) {
        return true;
    }
    // If only one event has a fingerprint, but not the other one, they are not the same
    if ((currentFingerprint && !previousFingerprint) || (!currentFingerprint && previousFingerprint)) {
        return false;
    }
    currentFingerprint = currentFingerprint;
    previousFingerprint = previousFingerprint;
    // Otherwise, compare the two
    try {
        return !!(currentFingerprint.join('') === previousFingerprint.join(''));
    }
    catch (_oO) {
        return false;
    }
}
/** JSDoc */
function _getExceptionFromEvent(event) {
    return event.exception && event.exception.values && event.exception.values[0];
}
/** JSDoc */
function _getFramesFromEvent(event) {
    var exception = event.exception;
    if (exception) {
        try {
            // @ts-ignore Object could be undefined
            return exception.values[0].stacktrace.frames;
        }
        catch (_oO) {
            return undefined;
        }
    }
    else if (event.stacktrace) {
        return event.stacktrace.frames;
    }
    return undefined;
}

/**
 * The Sentry Browser SDK Client.
 *
 * @see BrowserOptions for documentation on configuration options.
 * @see SentryClient for usage documentation.
 */
var BrowserClient = /** @class */ (function (_super) {
    __extends$1(BrowserClient, _super);
    /**
     * Creates a new Browser SDK instance.
     *
     * @param options Configuration options for this SDK.
     */
    function BrowserClient(options) {
        if (options === void 0) { options = {}; }
        var _this = this;
        options._metadata = options._metadata || {};
        options._metadata.sdk = options._metadata.sdk || {
            name: 'sentry.javascript.browser',
            packages: [
                {
                    name: 'npm:@sentry/browser',
                    version: SDK_VERSION,
                },
            ],
            version: SDK_VERSION,
        };
        _this = _super.call(this, BrowserBackend, options) || this;
        return _this;
    }
    /**
     * Show a report dialog to the user to send feedback to a specific event.
     *
     * @param options Set individual options for the dialog
     */
    BrowserClient.prototype.showReportDialog = function (options) {
        if (options === void 0) { options = {}; }
        // doesn't work without a document (React Native)
        var document = getGlobalObject().document;
        if (!document) {
            return;
        }
        if (!this._isEnabled()) {
            IS_DEBUG_BUILD$1 && logger.error('Trying to call showReportDialog with Sentry Client disabled');
            return;
        }
        injectReportDialog(__assign$2(__assign$2({}, options), { dsn: options.dsn || this.getDsn() }));
    };
    /**
     * @inheritDoc
     */
    BrowserClient.prototype._prepareEvent = function (event, scope, hint) {
        event.platform = event.platform || 'javascript';
        return _super.prototype._prepareEvent.call(this, event, scope, hint);
    };
    /**
     * @inheritDoc
     */
    BrowserClient.prototype._sendEvent = function (event) {
        var integration = this.getIntegration(Breadcrumbs);
        if (integration) {
            integration.addSentryBreadcrumb(event);
        }
        _super.prototype._sendEvent.call(this, event);
    };
    return BrowserClient;
}(BaseClient));

var defaultIntegrations = [
    new InboundFilters(),
    new FunctionToString(),
    new TryCatch(),
    new Breadcrumbs(),
    new GlobalHandlers(),
    new LinkedErrors(),
    new Dedupe(),
    new UserAgent(),
];
/**
 * The Sentry Browser SDK Client.
 *
 * To use this SDK, call the {@link init} function as early as possible when
 * loading the web page. To set context information or send manual events, use
 * the provided methods.
 *
 * @example
 *
 * ```
 *
 * import { init } from '@sentry/browser';
 *
 * init({
 *   dsn: '__DSN__',
 *   // ...
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { configureScope } from '@sentry/browser';
 * configureScope((scope: Scope) => {
 *   scope.setExtra({ battery: 0.7 });
 *   scope.setTag({ user_mode: 'admin' });
 *   scope.setUser({ id: '4711' });
 * });
 * ```
 *
 * @example
 * ```
 *
 * import { addBreadcrumb } from '@sentry/browser';
 * addBreadcrumb({
 *   message: 'My Breadcrumb',
 *   // ...
 * });
 * ```
 *
 * @example
 *
 * ```
 *
 * import * as Sentry from '@sentry/browser';
 * Sentry.captureMessage('Hello, world!');
 * Sentry.captureException(new Error('Good bye'));
 * Sentry.captureEvent({
 *   message: 'Manual',
 *   stacktrace: [
 *     // ...
 *   ],
 * });
 * ```
 *
 * @see {@link BrowserOptions} for documentation on configuration options.
 */
function init$1(options) {
    if (options === void 0) { options = {}; }
    if (options.defaultIntegrations === undefined) {
        options.defaultIntegrations = defaultIntegrations;
    }
    if (options.release === undefined) {
        var window_1 = getGlobalObject();
        // This supports the variable that sentry-webpack-plugin injects
        if (window_1.SENTRY_RELEASE && window_1.SENTRY_RELEASE.id) {
            options.release = window_1.SENTRY_RELEASE.id;
        }
    }
    if (options.autoSessionTracking === undefined) {
        options.autoSessionTracking = true;
    }
    if (options.sendClientReports === undefined) {
        options.sendClientReports = true;
    }
    initAndBind(BrowserClient, options);
    if (options.autoSessionTracking) {
        startSessionTracking();
    }
}
function startSessionOnHub(hub) {
    hub.startSession({ ignoreDuration: true });
    hub.captureSession();
}
/**
 * Enable automatic Session Tracking for the initial page load.
 */
function startSessionTracking() {
    var window = getGlobalObject();
    var document = window.document;
    if (typeof document === 'undefined') {
        IS_DEBUG_BUILD$1 && logger.warn('Session tracking in non-browser environment with @sentry/browser is not supported.');
        return;
    }
    var hub = getCurrentHub();
    // The only way for this to be false is for there to be a version mismatch between @sentry/browser (>= 6.0.0) and
    // @sentry/hub (< 5.27.0). In the simple case, there won't ever be such a mismatch, because the two packages are
    // pinned at the same version in package.json, but there are edge cases where it's possible. See
    // https://github.com/getsentry/sentry-javascript/issues/3207 and
    // https://github.com/getsentry/sentry-javascript/issues/3234 and
    // https://github.com/getsentry/sentry-javascript/issues/3278.
    if (!hub.captureSession) {
        return;
    }
    // The session duration for browser sessions does not track a meaningful
    // concept that can be used as a metric.
    // Automatically captured sessions are akin to page views, and thus we
    // discard their duration.
    startSessionOnHub(hub);
    // We want to create a session for every navigation as well
    addInstrumentationHandler('history', function (_a) {
        var from = _a.from, to = _a.to;
        // Don't create an additional session for the initial route or if the location did not change
        if (!(from === undefined || from === to)) {
            startSessionOnHub(getCurrentHub());
        }
    });
}

/**
 * Inits the React SDK
 */
function init(options) {
    options._metadata = options._metadata || {};
    options._metadata.sdk = options._metadata.sdk || {
        name: 'sentry.javascript.react',
        packages: [
            {
                name: 'npm:@sentry/react',
                version: SDK_VERSION,
            },
        ],
        version: SDK_VERSION,
    };
    init$1(options);
}

var uuidRegex = /\b[0-9a-f]{8}\b-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-\b[0-9a-f]{12}\b/;
var numberBetweenBarsRegex = /\/\d+\//;
function apiSentryError(response) {
    if (!response) {
        return null;
    }
    var config = response.config, data = response.data, status = response.status;
    var sentryData = {
        url: config.baseURL + config.url,
        method: config.method,
        payload: config.data,
        params: config.params,
        headers: config.headers,
        timeout: config.timeout,
        exception: data.exception,
        file: data.file,
        line: data.line,
        message: data.message,
        trace: data.trace,
    };
    var errorMessage = (data === null || data === void 0 ? void 0 : data.message) || (data === null || data === void 0 ? void 0 : data.exception);
    var url = config.url.replace(uuidRegex, '{{uuid}}');
    url = url.replace(numberBetweenBarsRegex, '/{{number}}/');
    withScope(function (scope) {
        scope.setFingerprint([config.method, url]);
        scope.setExtras(sentryData);
        captureException(new Error("api Error (" + status + "): [" + config.method + "] " + url + " - " + errorMessage), {
            tags: {
                type: 'api',
                status: status,
            },
        });
    });
}

var SentryErrorBoundaryHandle = function (error, errorInfo) {
    withScope(function (scope) {
        scope.setExtras(errorInfo);
        captureException(error);
    });
};

/*
 * This file defines flags and constants that can be modified during compile time in order to facilitate tree shaking
 * for users.
 *
 * Debug flags need to be declared in each package individually and must not be imported across package boundaries,
 * because some build tools have trouble tree-shaking imported guards.
 *
 * As a convention, we define debug flags in a `flags.ts` file in the root of a package's `src` folder.
 *
 * Debug flag files will contain "magic strings" like `__SENTRY_DEBUG__` that may get replaced with actual values during
 * our, or the user's build process. Take care when introducing new flags - they must not throw if they are not
 * replaced.
 */
/** Flag that is true for debug builds, false otherwise. */
var IS_DEBUG_BUILD = typeof __SENTRY_DEBUG__ === 'undefined' ? true : __SENTRY_DEBUG__;

/**
 * Determines if tracing is currently enabled.
 *
 * Tracing is enabled when at least one of `tracesSampleRate` and `tracesSampler` is defined in the SDK config.
 */
function hasTracingEnabled(maybeOptions) {
    var client = getCurrentHub().getClient();
    var options = maybeOptions || (client && client.getOptions());
    return !!options && ('tracesSampleRate' in options || 'tracesSampler' in options);
}
/** Grabs active transaction off scope, if any */
function getActiveTransaction(maybeHub) {
    var hub = maybeHub || getCurrentHub();
    var scope = hub.getScope();
    return scope && scope.getTransaction();
}
/**
 * Converts from milliseconds to seconds
 * @param time time in ms
 */
function msToSec(time) {
    return time / 1000;
}
/**
 * Converts from seconds to milliseconds
 * @param time time in seconds
 */
function secToMs(time) {
    return time * 1000;
}

/**
 * Configures global error listeners
 */
function registerErrorInstrumentation() {
    addInstrumentationHandler('error', errorCallback);
    addInstrumentationHandler('unhandledrejection', errorCallback);
}
/**
 * If an error or unhandled promise occurs, we mark the active transaction as failed
 */
function errorCallback() {
    var activeTransaction = getActiveTransaction();
    if (activeTransaction) {
        var status_1 = 'internal_error';
        IS_DEBUG_BUILD && logger.log("[Tracing] Transaction: " + status_1 + " -> Global error occured");
        activeTransaction.setStatus(status_1);
    }
}

// Store finish reasons in tuple to save on bundle size
// Readonly type should enforce that this is not mutated.
var FINISH_REASON_TAG = 'finishReason';
var IDLE_TRANSACTION_FINISH_REASONS = ['heartbeatFailed', 'idleTimeout', 'documentHidden'];

/**
 * Keeps track of finished spans for a given transaction
 * @internal
 * @hideconstructor
 * @hidden
 */
var SpanRecorder = /** @class */ (function () {
    function SpanRecorder(maxlen) {
        if (maxlen === void 0) { maxlen = 1000; }
        this.spans = [];
        this._maxlen = maxlen;
    }
    /**
     * This is just so that we don't run out of memory while recording a lot
     * of spans. At some point we just stop and flush out the start of the
     * trace tree (i.e.the first n spans with the smallest
     * start_timestamp).
     */
    SpanRecorder.prototype.add = function (span) {
        if (this.spans.length > this._maxlen) {
            span.spanRecorder = undefined;
        }
        else {
            this.spans.push(span);
        }
    };
    return SpanRecorder;
}());
/**
 * Span contains all data about a span
 */
var Span = /** @class */ (function () {
    /**
     * You should never call the constructor manually, always use `Sentry.startTransaction()`
     * or call `startChild()` on an existing span.
     * @internal
     * @hideconstructor
     * @hidden
     */
    function Span(spanContext) {
        /**
         * @inheritDoc
         */
        this.traceId = uuid4();
        /**
         * @inheritDoc
         */
        this.spanId = uuid4().substring(16);
        /**
         * Timestamp in seconds when the span was created.
         */
        this.startTimestamp = timestampWithMs();
        /**
         * @inheritDoc
         */
        this.tags = {};
        /**
         * @inheritDoc
         */
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        this.data = {};
        if (!spanContext) {
            return this;
        }
        if (spanContext.traceId) {
            this.traceId = spanContext.traceId;
        }
        if (spanContext.spanId) {
            this.spanId = spanContext.spanId;
        }
        if (spanContext.parentSpanId) {
            this.parentSpanId = spanContext.parentSpanId;
        }
        // We want to include booleans as well here
        if ('sampled' in spanContext) {
            this.sampled = spanContext.sampled;
        }
        if (spanContext.op) {
            this.op = spanContext.op;
        }
        if (spanContext.description) {
            this.description = spanContext.description;
        }
        if (spanContext.data) {
            this.data = spanContext.data;
        }
        if (spanContext.tags) {
            this.tags = spanContext.tags;
        }
        if (spanContext.status) {
            this.status = spanContext.status;
        }
        if (spanContext.startTimestamp) {
            this.startTimestamp = spanContext.startTimestamp;
        }
        if (spanContext.endTimestamp) {
            this.endTimestamp = spanContext.endTimestamp;
        }
    }
    /**
     * @inheritDoc
     * @deprecated
     */
    Span.prototype.child = function (spanContext) {
        return this.startChild(spanContext);
    };
    /**
     * @inheritDoc
     */
    Span.prototype.startChild = function (spanContext) {
        var childSpan = new Span(__assign$2(__assign$2({}, spanContext), { parentSpanId: this.spanId, sampled: this.sampled, traceId: this.traceId }));
        childSpan.spanRecorder = this.spanRecorder;
        if (childSpan.spanRecorder) {
            childSpan.spanRecorder.add(childSpan);
        }
        childSpan.transaction = this.transaction;
        return childSpan;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.setTag = function (key, value) {
        var _a;
        this.tags = __assign$2(__assign$2({}, this.tags), (_a = {}, _a[key] = value, _a));
        return this;
    };
    /**
     * @inheritDoc
     */
    // eslint-disable-next-line @typescript-eslint/no-explicit-any, @typescript-eslint/explicit-module-boundary-types
    Span.prototype.setData = function (key, value) {
        var _a;
        this.data = __assign$2(__assign$2({}, this.data), (_a = {}, _a[key] = value, _a));
        return this;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.setStatus = function (value) {
        this.status = value;
        return this;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.setHttpStatus = function (httpStatus) {
        this.setTag('http.status_code', String(httpStatus));
        var spanStatus = spanStatusfromHttpCode(httpStatus);
        if (spanStatus !== 'unknown_error') {
            this.setStatus(spanStatus);
        }
        return this;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.isSuccess = function () {
        return this.status === 'ok';
    };
    /**
     * @inheritDoc
     */
    Span.prototype.finish = function (endTimestamp) {
        this.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : timestampWithMs();
    };
    /**
     * @inheritDoc
     */
    Span.prototype.toTraceparent = function () {
        var sampledString = '';
        if (this.sampled !== undefined) {
            sampledString = this.sampled ? '-1' : '-0';
        }
        return this.traceId + "-" + this.spanId + sampledString;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.toContext = function () {
        return dropUndefinedKeys({
            data: this.data,
            description: this.description,
            endTimestamp: this.endTimestamp,
            op: this.op,
            parentSpanId: this.parentSpanId,
            sampled: this.sampled,
            spanId: this.spanId,
            startTimestamp: this.startTimestamp,
            status: this.status,
            tags: this.tags,
            traceId: this.traceId,
        });
    };
    /**
     * @inheritDoc
     */
    Span.prototype.updateWithContext = function (spanContext) {
        var _a, _b, _c, _d, _e;
        this.data = (_a = spanContext.data, (_a !== null && _a !== void 0 ? _a : {}));
        this.description = spanContext.description;
        this.endTimestamp = spanContext.endTimestamp;
        this.op = spanContext.op;
        this.parentSpanId = spanContext.parentSpanId;
        this.sampled = spanContext.sampled;
        this.spanId = (_b = spanContext.spanId, (_b !== null && _b !== void 0 ? _b : this.spanId));
        this.startTimestamp = (_c = spanContext.startTimestamp, (_c !== null && _c !== void 0 ? _c : this.startTimestamp));
        this.status = spanContext.status;
        this.tags = (_d = spanContext.tags, (_d !== null && _d !== void 0 ? _d : {}));
        this.traceId = (_e = spanContext.traceId, (_e !== null && _e !== void 0 ? _e : this.traceId));
        return this;
    };
    /**
     * @inheritDoc
     */
    Span.prototype.getTraceContext = function () {
        return dropUndefinedKeys({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            trace_id: this.traceId,
        });
    };
    /**
     * @inheritDoc
     */
    Span.prototype.toJSON = function () {
        return dropUndefinedKeys({
            data: Object.keys(this.data).length > 0 ? this.data : undefined,
            description: this.description,
            op: this.op,
            parent_span_id: this.parentSpanId,
            span_id: this.spanId,
            start_timestamp: this.startTimestamp,
            status: this.status,
            tags: Object.keys(this.tags).length > 0 ? this.tags : undefined,
            timestamp: this.endTimestamp,
            trace_id: this.traceId,
        });
    };
    return Span;
}());
/**
 * Converts a HTTP status code into a {@link SpanStatusType}.
 *
 * @param httpStatus The HTTP response status code.
 * @returns The span status or unknown_error.
 */
function spanStatusfromHttpCode(httpStatus) {
    if (httpStatus < 400 && httpStatus >= 100) {
        return 'ok';
    }
    if (httpStatus >= 400 && httpStatus < 500) {
        switch (httpStatus) {
            case 401:
                return 'unauthenticated';
            case 403:
                return 'permission_denied';
            case 404:
                return 'not_found';
            case 409:
                return 'already_exists';
            case 413:
                return 'failed_precondition';
            case 429:
                return 'resource_exhausted';
            default:
                return 'invalid_argument';
        }
    }
    if (httpStatus >= 500 && httpStatus < 600) {
        switch (httpStatus) {
            case 501:
                return 'unimplemented';
            case 503:
                return 'unavailable';
            case 504:
                return 'deadline_exceeded';
            default:
                return 'internal_error';
        }
    }
    return 'unknown_error';
}

/** JSDoc */
var Transaction = /** @class */ (function (_super) {
    __extends$1(Transaction, _super);
    /**
     * This constructor should never be called manually. Those instrumenting tracing should use
     * `Sentry.startTransaction()`, and internal methods should use `hub.startTransaction()`.
     * @internal
     * @hideconstructor
     * @hidden
     */
    function Transaction(transactionContext, hub) {
        var _this = _super.call(this, transactionContext) || this;
        _this._measurements = {};
        /**
         * The reference to the current hub.
         */
        _this._hub = getCurrentHub();
        if (isInstanceOf(hub, Hub)) {
            _this._hub = hub;
        }
        _this.name = transactionContext.name || '';
        _this.metadata = transactionContext.metadata || {};
        _this._trimEnd = transactionContext.trimEnd;
        // this is because transactions are also spans, and spans have a transaction pointer
        _this.transaction = _this;
        return _this;
    }
    /**
     * JSDoc
     */
    Transaction.prototype.setName = function (name) {
        this.name = name;
    };
    /**
     * Attaches SpanRecorder to the span itself
     * @param maxlen maximum number of spans that can be recorded
     */
    Transaction.prototype.initSpanRecorder = function (maxlen) {
        if (maxlen === void 0) { maxlen = 1000; }
        if (!this.spanRecorder) {
            this.spanRecorder = new SpanRecorder(maxlen);
        }
        this.spanRecorder.add(this);
    };
    /**
     * Set observed measurements for this transaction.
     * @hidden
     */
    Transaction.prototype.setMeasurements = function (measurements) {
        this._measurements = __assign$2({}, measurements);
    };
    /**
     * Set metadata for this transaction.
     * @hidden
     */
    Transaction.prototype.setMetadata = function (newMetadata) {
        this.metadata = __assign$2(__assign$2({}, this.metadata), newMetadata);
    };
    /**
     * @inheritDoc
     */
    Transaction.prototype.finish = function (endTimestamp) {
        var _this = this;
        // This transaction is already finished, so we should not flush it again.
        if (this.endTimestamp !== undefined) {
            return undefined;
        }
        if (!this.name) {
            IS_DEBUG_BUILD && logger.warn('Transaction has no name, falling back to `<unlabeled transaction>`.');
            this.name = '<unlabeled transaction>';
        }
        // just sets the end timestamp
        _super.prototype.finish.call(this, endTimestamp);
        if (this.sampled !== true) {
            // At this point if `sampled !== true` we want to discard the transaction.
            IS_DEBUG_BUILD && logger.log('[Tracing] Discarding transaction because its trace was not chosen to be sampled.');
            var client = this._hub.getClient();
            var transport = client && client.getTransport && client.getTransport();
            if (transport && transport.recordLostEvent) {
                transport.recordLostEvent('sample_rate', 'transaction');
            }
            return undefined;
        }
        var finishedSpans = this.spanRecorder ? this.spanRecorder.spans.filter(function (s) { return s !== _this && s.endTimestamp; }) : [];
        if (this._trimEnd && finishedSpans.length > 0) {
            this.endTimestamp = finishedSpans.reduce(function (prev, current) {
                if (prev.endTimestamp && current.endTimestamp) {
                    return prev.endTimestamp > current.endTimestamp ? prev : current;
                }
                return prev;
            }).endTimestamp;
        }
        var transaction = {
            contexts: {
                trace: this.getTraceContext(),
            },
            spans: finishedSpans,
            start_timestamp: this.startTimestamp,
            tags: this.tags,
            timestamp: this.endTimestamp,
            transaction: this.name,
            type: 'transaction',
            sdkProcessingMetadata: this.metadata,
        };
        var hasMeasurements = Object.keys(this._measurements).length > 0;
        if (hasMeasurements) {
            IS_DEBUG_BUILD &&
                logger.log('[Measurements] Adding measurements to transaction', JSON.stringify(this._measurements, undefined, 2));
            transaction.measurements = this._measurements;
        }
        IS_DEBUG_BUILD && logger.log("[Tracing] Finishing " + this.op + " transaction: " + this.name + ".");
        return this._hub.captureEvent(transaction);
    };
    /**
     * @inheritDoc
     */
    Transaction.prototype.toContext = function () {
        var spanContext = _super.prototype.toContext.call(this);
        return dropUndefinedKeys(__assign$2(__assign$2({}, spanContext), { name: this.name, trimEnd: this._trimEnd }));
    };
    /**
     * @inheritDoc
     */
    Transaction.prototype.updateWithContext = function (transactionContext) {
        var _a;
        _super.prototype.updateWithContext.call(this, transactionContext);
        this.name = (_a = transactionContext.name, (_a !== null && _a !== void 0 ? _a : ''));
        this._trimEnd = transactionContext.trimEnd;
        return this;
    };
    return Transaction;
}(Span));

var DEFAULT_IDLE_TIMEOUT = 1000;
var HEARTBEAT_INTERVAL = 5000;
/**
 * @inheritDoc
 */
var IdleTransactionSpanRecorder = /** @class */ (function (_super) {
    __extends$1(IdleTransactionSpanRecorder, _super);
    function IdleTransactionSpanRecorder(_pushActivity, _popActivity, transactionSpanId, maxlen) {
        if (transactionSpanId === void 0) { transactionSpanId = ''; }
        var _this = _super.call(this, maxlen) || this;
        _this._pushActivity = _pushActivity;
        _this._popActivity = _popActivity;
        _this.transactionSpanId = transactionSpanId;
        return _this;
    }
    /**
     * @inheritDoc
     */
    IdleTransactionSpanRecorder.prototype.add = function (span) {
        var _this = this;
        // We should make sure we do not push and pop activities for
        // the transaction that this span recorder belongs to.
        if (span.spanId !== this.transactionSpanId) {
            // We patch span.finish() to pop an activity after setting an endTimestamp.
            span.finish = function (endTimestamp) {
                span.endTimestamp = typeof endTimestamp === 'number' ? endTimestamp : timestampWithMs();
                _this._popActivity(span.spanId);
            };
            // We should only push new activities if the span does not have an end timestamp.
            if (span.endTimestamp === undefined) {
                this._pushActivity(span.spanId);
            }
        }
        _super.prototype.add.call(this, span);
    };
    return IdleTransactionSpanRecorder;
}(SpanRecorder));
/**
 * An IdleTransaction is a transaction that automatically finishes. It does this by tracking child spans as activities.
 * You can have multiple IdleTransactions active, but if the `onScope` option is specified, the idle transaction will
 * put itself on the scope on creation.
 */
var IdleTransaction = /** @class */ (function (_super) {
    __extends$1(IdleTransaction, _super);
    function IdleTransaction(transactionContext, _idleHub, 
    /**
     * The time to wait in ms until the idle transaction will be finished.
     * @default 1000
     */
    _idleTimeout, 
    // Whether or not the transaction should put itself on the scope when it starts and pop itself off when it ends
    _onScope) {
        if (_idleTimeout === void 0) { _idleTimeout = DEFAULT_IDLE_TIMEOUT; }
        if (_onScope === void 0) { _onScope = false; }
        var _this = _super.call(this, transactionContext, _idleHub) || this;
        _this._idleHub = _idleHub;
        _this._idleTimeout = _idleTimeout;
        _this._onScope = _onScope;
        // Activities store a list of active spans
        _this.activities = {};
        // Amount of times heartbeat has counted. Will cause transaction to finish after 3 beats.
        _this._heartbeatCounter = 0;
        // We should not use heartbeat if we finished a transaction
        _this._finished = false;
        _this._beforeFinishCallbacks = [];
        if (_idleHub && _onScope) {
            // There should only be one active transaction on the scope
            clearActiveTransaction(_idleHub);
            // We set the transaction here on the scope so error events pick up the trace
            // context and attach it to the error.
            IS_DEBUG_BUILD && logger.log("Setting idle transaction on scope. Span ID: " + _this.spanId);
            _idleHub.configureScope(function (scope) { return scope.setSpan(_this); });
        }
        _this._initTimeout = setTimeout(function () {
            if (!_this._finished) {
                _this.finish();
            }
        }, _this._idleTimeout);
        return _this;
    }
    /** {@inheritDoc} */
    IdleTransaction.prototype.finish = function (endTimestamp) {
        var e_1, _a;
        var _this = this;
        if (endTimestamp === void 0) { endTimestamp = timestampWithMs(); }
        this._finished = true;
        this.activities = {};
        if (this.spanRecorder) {
            IS_DEBUG_BUILD &&
                logger.log('[Tracing] finishing IdleTransaction', new Date(endTimestamp * 1000).toISOString(), this.op);
            try {
                for (var _b = __values(this._beforeFinishCallbacks), _c = _b.next(); !_c.done; _c = _b.next()) {
                    var callback = _c.value;
                    callback(this, endTimestamp);
                }
            }
            catch (e_1_1) { e_1 = { error: e_1_1 }; }
            finally {
                try {
                    if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
                }
                finally { if (e_1) throw e_1.error; }
            }
            this.spanRecorder.spans = this.spanRecorder.spans.filter(function (span) {
                // If we are dealing with the transaction itself, we just return it
                if (span.spanId === _this.spanId) {
                    return true;
                }
                // We cancel all pending spans with status "cancelled" to indicate the idle transaction was finished early
                if (!span.endTimestamp) {
                    span.endTimestamp = endTimestamp;
                    span.setStatus('cancelled');
                    IS_DEBUG_BUILD &&
                        logger.log('[Tracing] cancelling span since transaction ended early', JSON.stringify(span, undefined, 2));
                }
                var keepSpan = span.startTimestamp < endTimestamp;
                if (!keepSpan) {
                    IS_DEBUG_BUILD &&
                        logger.log('[Tracing] discarding Span since it happened after Transaction was finished', JSON.stringify(span, undefined, 2));
                }
                return keepSpan;
            });
            IS_DEBUG_BUILD && logger.log('[Tracing] flushing IdleTransaction');
        }
        else {
            IS_DEBUG_BUILD && logger.log('[Tracing] No active IdleTransaction');
        }
        // if `this._onScope` is `true`, the transaction put itself on the scope when it started
        if (this._onScope) {
            clearActiveTransaction(this._idleHub);
        }
        return _super.prototype.finish.call(this, endTimestamp);
    };
    /**
     * Register a callback function that gets excecuted before the transaction finishes.
     * Useful for cleanup or if you want to add any additional spans based on current context.
     *
     * This is exposed because users have no other way of running something before an idle transaction
     * finishes.
     */
    IdleTransaction.prototype.registerBeforeFinishCallback = function (callback) {
        this._beforeFinishCallbacks.push(callback);
    };
    /**
     * @inheritDoc
     */
    IdleTransaction.prototype.initSpanRecorder = function (maxlen) {
        var _this = this;
        if (!this.spanRecorder) {
            var pushActivity = function (id) {
                if (_this._finished) {
                    return;
                }
                _this._pushActivity(id);
            };
            var popActivity = function (id) {
                if (_this._finished) {
                    return;
                }
                _this._popActivity(id);
            };
            this.spanRecorder = new IdleTransactionSpanRecorder(pushActivity, popActivity, this.spanId, maxlen);
            // Start heartbeat so that transactions do not run forever.
            IS_DEBUG_BUILD && logger.log('Starting heartbeat');
            this._pingHeartbeat();
        }
        this.spanRecorder.add(this);
    };
    /**
     * Start tracking a specific activity.
     * @param spanId The span id that represents the activity
     */
    IdleTransaction.prototype._pushActivity = function (spanId) {
        if (this._initTimeout) {
            clearTimeout(this._initTimeout);
            this._initTimeout = undefined;
        }
        IS_DEBUG_BUILD && logger.log("[Tracing] pushActivity: " + spanId);
        this.activities[spanId] = true;
        IS_DEBUG_BUILD && logger.log('[Tracing] new activities count', Object.keys(this.activities).length);
    };
    /**
     * Remove an activity from usage
     * @param spanId The span id that represents the activity
     */
    IdleTransaction.prototype._popActivity = function (spanId) {
        var _this = this;
        if (this.activities[spanId]) {
            IS_DEBUG_BUILD && logger.log("[Tracing] popActivity " + spanId);
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete this.activities[spanId];
            IS_DEBUG_BUILD && logger.log('[Tracing] new activities count', Object.keys(this.activities).length);
        }
        if (Object.keys(this.activities).length === 0) {
            var timeout = this._idleTimeout;
            // We need to add the timeout here to have the real endtimestamp of the transaction
            // Remember timestampWithMs is in seconds, timeout is in ms
            var end_1 = timestampWithMs() + timeout / 1000;
            setTimeout(function () {
                if (!_this._finished) {
                    _this.setTag(FINISH_REASON_TAG, IDLE_TRANSACTION_FINISH_REASONS[1]);
                    _this.finish(end_1);
                }
            }, timeout);
        }
    };
    /**
     * Checks when entries of this.activities are not changing for 3 beats.
     * If this occurs we finish the transaction.
     */
    IdleTransaction.prototype._beat = function () {
        // We should not be running heartbeat if the idle transaction is finished.
        if (this._finished) {
            return;
        }
        var heartbeatString = Object.keys(this.activities).join('');
        if (heartbeatString === this._prevHeartbeatString) {
            this._heartbeatCounter += 1;
        }
        else {
            this._heartbeatCounter = 1;
        }
        this._prevHeartbeatString = heartbeatString;
        if (this._heartbeatCounter >= 3) {
            IS_DEBUG_BUILD && logger.log('[Tracing] Transaction finished because of no change for 3 heart beats');
            this.setStatus('deadline_exceeded');
            this.setTag(FINISH_REASON_TAG, IDLE_TRANSACTION_FINISH_REASONS[0]);
            this.finish();
        }
        else {
            this._pingHeartbeat();
        }
    };
    /**
     * Pings the heartbeat
     */
    IdleTransaction.prototype._pingHeartbeat = function () {
        var _this = this;
        IS_DEBUG_BUILD && logger.log("pinging Heartbeat -> current counter: " + this._heartbeatCounter);
        setTimeout(function () {
            _this._beat();
        }, HEARTBEAT_INTERVAL);
    };
    return IdleTransaction;
}(Transaction));
/**
 * Reset transaction on scope to `undefined`
 */
function clearActiveTransaction(hub) {
    if (hub) {
        var scope = hub.getScope();
        if (scope) {
            var transaction = scope.getTransaction();
            if (transaction) {
                scope.setSpan(undefined);
            }
        }
    }
}

/** Returns all trace headers that are currently on the top scope. */
function traceHeaders() {
    var scope = this.getScope();
    if (scope) {
        var span = scope.getSpan();
        if (span) {
            return {
                'sentry-trace': span.toTraceparent(),
            };
        }
    }
    return {};
}
/**
 * Makes a sampling decision for the given transaction and stores it on the transaction.
 *
 * Called every time a transaction is created. Only transactions which emerge with a `sampled` value of `true` will be
 * sent to Sentry.
 *
 * @param transaction: The transaction needing a sampling decision
 * @param options: The current client's options, so we can access `tracesSampleRate` and/or `tracesSampler`
 * @param samplingContext: Default and user-provided data which may be used to help make the decision
 *
 * @returns The given transaction with its `sampled` value set
 */
function sample(transaction, options, samplingContext) {
    // nothing to do if tracing is not enabled
    if (!hasTracingEnabled(options)) {
        transaction.sampled = false;
        return transaction;
    }
    // if the user has forced a sampling decision by passing a `sampled` value in their transaction context, go with that
    if (transaction.sampled !== undefined) {
        transaction.setMetadata({
            transactionSampling: { method: 'explicitly_set' },
        });
        return transaction;
    }
    // we would have bailed already if neither `tracesSampler` nor `tracesSampleRate` were defined, so one of these should
    // work; prefer the hook if so
    var sampleRate;
    if (typeof options.tracesSampler === 'function') {
        sampleRate = options.tracesSampler(samplingContext);
        transaction.setMetadata({
            transactionSampling: {
                method: 'client_sampler',
                // cast to number in case it's a boolean
                rate: Number(sampleRate),
            },
        });
    }
    else if (samplingContext.parentSampled !== undefined) {
        sampleRate = samplingContext.parentSampled;
        transaction.setMetadata({
            transactionSampling: { method: 'inheritance' },
        });
    }
    else {
        sampleRate = options.tracesSampleRate;
        transaction.setMetadata({
            transactionSampling: {
                method: 'client_rate',
                // cast to number in case it's a boolean
                rate: Number(sampleRate),
            },
        });
    }
    // Since this is coming from the user (or from a function provided by the user), who knows what we might get. (The
    // only valid values are booleans or numbers between 0 and 1.)
    if (!isValidSampleRate(sampleRate)) {
        IS_DEBUG_BUILD && logger.warn('[Tracing] Discarding transaction because of invalid sample rate.');
        transaction.sampled = false;
        return transaction;
    }
    // if the function returned 0 (or false), or if `tracesSampleRate` is 0, it's a sign the transaction should be dropped
    if (!sampleRate) {
        IS_DEBUG_BUILD &&
            logger.log("[Tracing] Discarding transaction because " + (typeof options.tracesSampler === 'function'
                ? 'tracesSampler returned 0 or false'
                : 'a negative sampling decision was inherited or tracesSampleRate is set to 0'));
        transaction.sampled = false;
        return transaction;
    }
    // Now we roll the dice. Math.random is inclusive of 0, but not of 1, so strict < is safe here. In case sampleRate is
    // a boolean, the < comparison will cause it to be automatically cast to 1 if it's true and 0 if it's false.
    transaction.sampled = Math.random() < sampleRate;
    // if we're not going to keep it, we're done
    if (!transaction.sampled) {
        IS_DEBUG_BUILD &&
            logger.log("[Tracing] Discarding transaction because it's not included in the random sample (sampling rate = " + Number(sampleRate) + ")");
        return transaction;
    }
    IS_DEBUG_BUILD && logger.log("[Tracing] starting " + transaction.op + " transaction - " + transaction.name);
    return transaction;
}
/**
 * Checks the given sample rate to make sure it is valid type and value (a boolean, or a number between 0 and 1).
 */
function isValidSampleRate(rate) {
    // we need to check NaN explicitly because it's of type 'number' and therefore wouldn't get caught by this typecheck
    // eslint-disable-next-line @typescript-eslint/no-explicit-any
    if (isNaN$1(rate) || !(typeof rate === 'number' || typeof rate === 'boolean')) {
        IS_DEBUG_BUILD &&
            logger.warn("[Tracing] Given sample rate is invalid. Sample rate must be a boolean or a number between 0 and 1. Got " + JSON.stringify(rate) + " of type " + JSON.stringify(typeof rate) + ".");
        return false;
    }
    // in case sampleRate is a boolean, it will get automatically cast to 1 if it's true and 0 if it's false
    if (rate < 0 || rate > 1) {
        IS_DEBUG_BUILD &&
            logger.warn("[Tracing] Given sample rate is invalid. Sample rate must be between 0 and 1. Got " + rate + ".");
        return false;
    }
    return true;
}
/**
 * Creates a new transaction and adds a sampling decision if it doesn't yet have one.
 *
 * The Hub.startTransaction method delegates to this method to do its work, passing the Hub instance in as `this`, as if
 * it had been called on the hub directly. Exists as a separate function so that it can be injected into the class as an
 * "extension method."
 *
 * @param this: The Hub starting the transaction
 * @param transactionContext: Data used to configure the transaction
 * @param CustomSamplingContext: Optional data to be provided to the `tracesSampler` function (if any)
 *
 * @returns The new transaction
 *
 * @see {@link Hub.startTransaction}
 */
function _startTransaction(transactionContext, customSamplingContext) {
    var client = this.getClient();
    var options = (client && client.getOptions()) || {};
    var transaction = new Transaction(transactionContext, this);
    transaction = sample(transaction, options, __assign$2({ parentSampled: transactionContext.parentSampled, transactionContext: transactionContext }, customSamplingContext));
    if (transaction.sampled) {
        transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    }
    return transaction;
}
/**
 * Create new idle transaction.
 */
function startIdleTransaction(hub, transactionContext, idleTimeout, onScope, customSamplingContext) {
    var client = hub.getClient();
    var options = (client && client.getOptions()) || {};
    var transaction = new IdleTransaction(transactionContext, hub, idleTimeout, onScope);
    transaction = sample(transaction, options, __assign$2({ parentSampled: transactionContext.parentSampled, transactionContext: transactionContext }, customSamplingContext));
    if (transaction.sampled) {
        transaction.initSpanRecorder(options._experiments && options._experiments.maxSpans);
    }
    return transaction;
}
/**
 * @private
 */
function _addTracingExtensions() {
    var carrier = getMainCarrier();
    if (!carrier.__SENTRY__) {
        return;
    }
    carrier.__SENTRY__.extensions = carrier.__SENTRY__.extensions || {};
    if (!carrier.__SENTRY__.extensions.startTransaction) {
        carrier.__SENTRY__.extensions.startTransaction = _startTransaction;
    }
    if (!carrier.__SENTRY__.extensions.traceHeaders) {
        carrier.__SENTRY__.extensions.traceHeaders = traceHeaders;
    }
}
/**
 * @private
 */
function _autoloadDatabaseIntegrations() {
    var carrier = getMainCarrier();
    if (!carrier.__SENTRY__) {
        return;
    }
    var packageToIntegrationMapping = {
        mongodb: function () {
            var integration = dynamicRequire(module, './integrations/node/mongo');
            return new integration.Mongo();
        },
        mongoose: function () {
            var integration = dynamicRequire(module, './integrations/node/mongo');
            return new integration.Mongo({ mongoose: true });
        },
        mysql: function () {
            var integration = dynamicRequire(module, './integrations/node/mysql');
            return new integration.Mysql();
        },
        pg: function () {
            var integration = dynamicRequire(module, './integrations/node/postgres');
            return new integration.Postgres();
        },
    };
    var mappedPackages = Object.keys(packageToIntegrationMapping)
        .filter(function (moduleName) { return !!loadModule(moduleName); })
        .map(function (pkg) {
        try {
            return packageToIntegrationMapping[pkg]();
        }
        catch (e) {
            return undefined;
        }
    })
        .filter(function (p) { return p; });
    if (mappedPackages.length > 0) {
        carrier.__SENTRY__.integrations = __spread$1((carrier.__SENTRY__.integrations || []), mappedPackages);
    }
}
/**
 * This patches the global object and injects the Tracing extensions methods
 */
function addExtensionMethods() {
    _addTracingExtensions();
    // Detect and automatically load specified integrations.
    if (isNodeEnv()) {
        _autoloadDatabaseIntegrations();
    }
    // If an error happens globally, we should make sure transaction status is set to error.
    registerErrorInstrumentation();
}

var global$3 = getGlobalObject();
/**
 * Add a listener that cancels and finishes a transaction when the global
 * document is hidden.
 */
function registerBackgroundTabDetection() {
    if (global$3 && global$3.document) {
        global$3.document.addEventListener('visibilitychange', function () {
            var activeTransaction = getActiveTransaction();
            if (global$3.document.hidden && activeTransaction) {
                var statusType = 'cancelled';
                IS_DEBUG_BUILD &&
                    logger.log("[Tracing] Transaction: " + statusType + " -> since tab moved to the background, op: " + activeTransaction.op);
                // We should not set status if it is already set, this prevent important statuses like
                // error or data loss from being overwritten on transaction.
                if (!activeTransaction.status) {
                    activeTransaction.setStatus(statusType);
                }
                activeTransaction.setTag('visibilitychange', 'document.hidden');
                activeTransaction.setTag(FINISH_REASON_TAG, IDLE_TRANSACTION_FINISH_REASONS[2]);
                activeTransaction.finish();
            }
        });
    }
    else {
        IS_DEBUG_BUILD && logger.warn('[Tracing] Could not set up background tab detection due to lack of global document');
    }
}

/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var bindReporter = function (callback, metric, reportAllChanges) {
    var prevValue;
    return function (forceReport) {
        if (metric.value >= 0) {
            if (forceReport || reportAllChanges) {
                metric.delta = metric.value - (prevValue || 0);
                // Report the metric if there's a non-zero delta or if no previous
                // value exists (which can happen in the case of the document becoming
                // hidden when the metric value is 0).
                // See: https://github.com/GoogleChrome/web-vitals/issues/14
                if (metric.delta || prevValue === undefined) {
                    prevValue = metric.value;
                    callback(metric);
                }
            }
        }
    };
};

/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Performantly generate a unique, 30-char string by combining a version
 * number, the current timestamp with a 13-digit number integer.
 * @return {string}
 */
var generateUniqueID = function () {
    return "v2-" + Date.now() + "-" + (Math.floor(Math.random() * (9e12 - 1)) + 1e12);
};

/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var initMetric = function (name, value) {
    return {
        name: name,
        value: (value !== null && value !== void 0 ? value : -1),
        delta: 0,
        entries: [],
        id: generateUniqueID(),
    };
};

/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
/**
 * Takes a performance entry type and a callback function, and creates a
 * `PerformanceObserver` instance that will observe the specified entry type
 * with buffering enabled and call the callback _for each entry_.
 *
 * This function also feature-detects entry support and wraps the logic in a
 * try/catch to avoid errors in unsupporting browsers.
 */
var observe = function (type, callback) {
    try {
        if (PerformanceObserver.supportedEntryTypes.includes(type)) {
            // More extensive feature detect needed for Firefox due to:
            // https://github.com/GoogleChrome/web-vitals/issues/142
            if (type === 'first-input' && !('PerformanceEventTiming' in self)) {
                return;
            }
            var po = new PerformanceObserver(function (l) { return l.getEntries().map(callback); });
            po.observe({ type: type, buffered: true });
            return po;
        }
    }
    catch (e) {
        // Do nothing.
    }
    return;
};

/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var onHidden = function (cb, once) {
    var onHiddenOrPageHide = function (event) {
        if (event.type === 'pagehide' || getGlobalObject().document.visibilityState === 'hidden') {
            cb(event);
            if (once) {
                removeEventListener('visibilitychange', onHiddenOrPageHide, true);
                removeEventListener('pagehide', onHiddenOrPageHide, true);
            }
        }
    };
    addEventListener('visibilitychange', onHiddenOrPageHide, true);
    // Some browsers have buggy implementations of visibilitychange,
    // so we use pagehide in addition, just to be safe.
    addEventListener('pagehide', onHiddenOrPageHide, true);
};

/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var getCLS = function (onReport, reportAllChanges) {
    var metric = initMetric('CLS', 0);
    var report;
    var sessionValue = 0;
    var sessionEntries = [];
    var entryHandler = function (entry) {
        // Only count layout shifts without recent user input.
        // TODO: Figure out why entry can be undefined
        if (entry && !entry.hadRecentInput) {
            var firstSessionEntry = sessionEntries[0];
            var lastSessionEntry = sessionEntries[sessionEntries.length - 1];
            // If the entry occurred less than 1 second after the previous entry and
            // less than 5 seconds after the first entry in the session, include the
            // entry in the current session. Otherwise, start a new session.
            if (sessionValue &&
                sessionEntries.length !== 0 &&
                entry.startTime - lastSessionEntry.startTime < 1000 &&
                entry.startTime - firstSessionEntry.startTime < 5000) {
                sessionValue += entry.value;
                sessionEntries.push(entry);
            }
            else {
                sessionValue = entry.value;
                sessionEntries = [entry];
            }
            // If the current session value is larger than the current CLS value,
            // update CLS and the entries contributing to it.
            if (sessionValue > metric.value) {
                metric.value = sessionValue;
                metric.entries = sessionEntries;
                if (report) {
                    report();
                }
            }
        }
    };
    var po = observe('layout-shift', entryHandler);
    if (po) {
        report = bindReporter(onReport, metric, reportAllChanges);
        onHidden(function () {
            po.takeRecords().map(entryHandler);
            report(true);
        });
    }
};

/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var firstHiddenTime = -1;
var initHiddenTime = function () {
    return getGlobalObject().document.visibilityState === 'hidden' ? 0 : Infinity;
};
var trackChanges = function () {
    // Update the time if/when the document becomes hidden.
    onHidden(function (_a) {
        var timeStamp = _a.timeStamp;
        firstHiddenTime = timeStamp;
    }, true);
};
var getVisibilityWatcher = function () {
    if (firstHiddenTime < 0) {
        // If the document is hidden when this code runs, assume it was hidden
        // since navigation start. This isn't a perfect heuristic, but it's the
        // best we can do until an API is available to support querying past
        // visibilityState.
        firstHiddenTime = initHiddenTime();
        trackChanges();
    }
    return {
        get firstHiddenTime() {
            return firstHiddenTime;
        },
    };
};

/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var getFID = function (onReport, reportAllChanges) {
    var visibilityWatcher = getVisibilityWatcher();
    var metric = initMetric('FID');
    var report;
    var entryHandler = function (entry) {
        // Only report if the page wasn't hidden prior to the first input.
        if (report && entry.startTime < visibilityWatcher.firstHiddenTime) {
            metric.value = entry.processingStart - entry.startTime;
            metric.entries.push(entry);
            report(true);
        }
    };
    var po = observe('first-input', entryHandler);
    if (po) {
        report = bindReporter(onReport, metric, reportAllChanges);
        onHidden(function () {
            po.takeRecords().map(entryHandler);
            po.disconnect();
        }, true);
    }
};

/*
 * Copyright 2020 Google LLC
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
var reportedMetricIDs = {};
var getLCP = function (onReport, reportAllChanges) {
    var visibilityWatcher = getVisibilityWatcher();
    var metric = initMetric('LCP');
    var report;
    var entryHandler = function (entry) {
        // The startTime attribute returns the value of the renderTime if it is not 0,
        // and the value of the loadTime otherwise.
        var value = entry.startTime;
        // If the page was hidden prior to paint time of the entry,
        // ignore it and mark the metric as final, otherwise add the entry.
        if (value < visibilityWatcher.firstHiddenTime) {
            metric.value = value;
            metric.entries.push(entry);
        }
        if (report) {
            report();
        }
    };
    var po = observe('largest-contentful-paint', entryHandler);
    if (po) {
        report = bindReporter(onReport, metric, reportAllChanges);
        var stopListening_1 = function () {
            if (!reportedMetricIDs[metric.id]) {
                po.takeRecords().map(entryHandler);
                po.disconnect();
                reportedMetricIDs[metric.id] = true;
                report(true);
            }
        };
        // Stop listening after input. Note: while scrolling is an input that
        // stop LCP observation, it's unreliable since it can be programmatically
        // generated. See: https://github.com/GoogleChrome/web-vitals/issues/75
        ['keydown', 'click'].forEach(function (type) {
            addEventListener(type, stopListening_1, { once: true, capture: true });
        });
        onHidden(stopListening_1, true);
    }
};

var global$2 = getGlobalObject();
/** Class tracking metrics  */
var MetricsInstrumentation = /** @class */ (function () {
    function MetricsInstrumentation(_reportAllChanges) {
        if (_reportAllChanges === void 0) { _reportAllChanges = false; }
        this._reportAllChanges = _reportAllChanges;
        this._measurements = {};
        this._performanceCursor = 0;
        if (!isNodeEnv() && global$2 && global$2.performance && global$2.document) {
            if (global$2.performance.mark) {
                global$2.performance.mark('sentry-tracing-init');
            }
            this._trackCLS();
            this._trackLCP();
            this._trackFID();
        }
    }
    /** Add performance related spans to a transaction */
    MetricsInstrumentation.prototype.addPerformanceEntries = function (transaction) {
        var _this = this;
        if (!global$2 || !global$2.performance || !global$2.performance.getEntries || !browserPerformanceTimeOrigin) {
            // Gatekeeper if performance API not available
            return;
        }
        IS_DEBUG_BUILD && logger.log('[Tracing] Adding & adjusting spans using Performance API');
        var timeOrigin = msToSec(browserPerformanceTimeOrigin);
        var responseStartTimestamp;
        var requestStartTimestamp;
        global$2.performance
            .getEntries()
            .slice(this._performanceCursor)
            .forEach(function (entry) {
            var startTime = msToSec(entry.startTime);
            var duration = msToSec(entry.duration);
            if (transaction.op === 'navigation' && timeOrigin + startTime < transaction.startTimestamp) {
                return;
            }
            switch (entry.entryType) {
                case 'navigation': {
                    addNavigationSpans(transaction, entry, timeOrigin);
                    responseStartTimestamp = timeOrigin + msToSec(entry.responseStart);
                    requestStartTimestamp = timeOrigin + msToSec(entry.requestStart);
                    break;
                }
                case 'mark':
                case 'paint':
                case 'measure': {
                    var startTimestamp = addMeasureSpans(transaction, entry, startTime, duration, timeOrigin);
                    // capture web vitals
                    var firstHidden = getVisibilityWatcher();
                    // Only report if the page wasn't hidden prior to the web vital.
                    var shouldRecord = entry.startTime < firstHidden.firstHiddenTime;
                    if (entry.name === 'first-paint' && shouldRecord) {
                        IS_DEBUG_BUILD && logger.log('[Measurements] Adding FP');
                        _this._measurements['fp'] = { value: entry.startTime };
                        _this._measurements['mark.fp'] = { value: startTimestamp };
                    }
                    if (entry.name === 'first-contentful-paint' && shouldRecord) {
                        IS_DEBUG_BUILD && logger.log('[Measurements] Adding FCP');
                        _this._measurements['fcp'] = { value: entry.startTime };
                        _this._measurements['mark.fcp'] = { value: startTimestamp };
                    }
                    break;
                }
                case 'resource': {
                    var resourceName = entry.name.replace(global$2.location.origin, '');
                    addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin);
                    break;
                }
                // Ignore other entry types.
            }
        });
        this._performanceCursor = Math.max(performance.getEntries().length - 1, 0);
        this._trackNavigator(transaction);
        // Measurements are only available for pageload transactions
        if (transaction.op === 'pageload') {
            // normalize applicable web vital values to be relative to transaction.startTimestamp
            var timeOrigin_1 = msToSec(browserPerformanceTimeOrigin);
            // Generate TTFB (Time to First Byte), which measured as the time between the beginning of the transaction and the
            // start of the response in milliseconds
            if (typeof responseStartTimestamp === 'number') {
                IS_DEBUG_BUILD && logger.log('[Measurements] Adding TTFB');
                this._measurements['ttfb'] = { value: (responseStartTimestamp - transaction.startTimestamp) * 1000 };
                if (typeof requestStartTimestamp === 'number' && requestStartTimestamp <= responseStartTimestamp) {
                    // Capture the time spent making the request and receiving the first byte of the response.
                    // This is the time between the start of the request and the start of the response in milliseconds.
                    this._measurements['ttfb.requestTime'] = { value: (responseStartTimestamp - requestStartTimestamp) * 1000 };
                }
            }
            ['fcp', 'fp', 'lcp'].forEach(function (name) {
                if (!_this._measurements[name] || timeOrigin_1 >= transaction.startTimestamp) {
                    return;
                }
                // The web vitals, fcp, fp, lcp, and ttfb, all measure relative to timeOrigin.
                // Unfortunately, timeOrigin is not captured within the transaction span data, so these web vitals will need
                // to be adjusted to be relative to transaction.startTimestamp.
                var oldValue = _this._measurements[name].value;
                var measurementTimestamp = timeOrigin_1 + msToSec(oldValue);
                // normalizedValue should be in milliseconds
                var normalizedValue = Math.abs((measurementTimestamp - transaction.startTimestamp) * 1000);
                var delta = normalizedValue - oldValue;
                IS_DEBUG_BUILD &&
                    logger.log("[Measurements] Normalized " + name + " from " + oldValue + " to " + normalizedValue + " (" + delta + ")");
                _this._measurements[name].value = normalizedValue;
            });
            if (this._measurements['mark.fid'] && this._measurements['fid']) {
                // create span for FID
                _startChild(transaction, {
                    description: 'first input delay',
                    endTimestamp: this._measurements['mark.fid'].value + msToSec(this._measurements['fid'].value),
                    op: 'web.vitals',
                    startTimestamp: this._measurements['mark.fid'].value,
                });
            }
            // If FCP is not recorded we should not record the cls value
            // according to the new definition of CLS.
            if (!('fcp' in this._measurements)) {
                delete this._measurements.cls;
            }
            transaction.setMeasurements(this._measurements);
            tagMetricInfo(transaction, this._lcpEntry, this._clsEntry);
            transaction.setTag('sentry_reportAllChanges', this._reportAllChanges);
        }
    };
    /**
     * Capture the information of the user agent.
     */
    MetricsInstrumentation.prototype._trackNavigator = function (transaction) {
        var navigator = global$2.navigator;
        if (!navigator) {
            return;
        }
        // track network connectivity
        var connection = navigator.connection;
        if (connection) {
            if (connection.effectiveType) {
                transaction.setTag('effectiveConnectionType', connection.effectiveType);
            }
            if (connection.type) {
                transaction.setTag('connectionType', connection.type);
            }
            if (isMeasurementValue(connection.rtt)) {
                this._measurements['connection.rtt'] = { value: connection.rtt };
            }
            if (isMeasurementValue(connection.downlink)) {
                this._measurements['connection.downlink'] = { value: connection.downlink };
            }
        }
        if (isMeasurementValue(navigator.deviceMemory)) {
            transaction.setTag('deviceMemory', String(navigator.deviceMemory));
        }
        if (isMeasurementValue(navigator.hardwareConcurrency)) {
            transaction.setTag('hardwareConcurrency', String(navigator.hardwareConcurrency));
        }
    };
    /** Starts tracking the Cumulative Layout Shift on the current page. */
    MetricsInstrumentation.prototype._trackCLS = function () {
        var _this = this;
        // See:
        // https://web.dev/evolving-cls/
        // https://web.dev/cls-web-tooling/
        getCLS(function (metric) {
            var entry = metric.entries.pop();
            if (!entry) {
                return;
            }
            IS_DEBUG_BUILD && logger.log('[Measurements] Adding CLS');
            _this._measurements['cls'] = { value: metric.value };
            _this._clsEntry = entry;
        });
    };
    /** Starts tracking the Largest Contentful Paint on the current page. */
    MetricsInstrumentation.prototype._trackLCP = function () {
        var _this = this;
        getLCP(function (metric) {
            var entry = metric.entries.pop();
            if (!entry) {
                return;
            }
            var timeOrigin = msToSec(browserPerformanceTimeOrigin);
            var startTime = msToSec(entry.startTime);
            IS_DEBUG_BUILD && logger.log('[Measurements] Adding LCP');
            _this._measurements['lcp'] = { value: metric.value };
            _this._measurements['mark.lcp'] = { value: timeOrigin + startTime };
            _this._lcpEntry = entry;
        }, this._reportAllChanges);
    };
    /** Starts tracking the First Input Delay on the current page. */
    MetricsInstrumentation.prototype._trackFID = function () {
        var _this = this;
        getFID(function (metric) {
            var entry = metric.entries.pop();
            if (!entry) {
                return;
            }
            var timeOrigin = msToSec(browserPerformanceTimeOrigin);
            var startTime = msToSec(entry.startTime);
            IS_DEBUG_BUILD && logger.log('[Measurements] Adding FID');
            _this._measurements['fid'] = { value: metric.value };
            _this._measurements['mark.fid'] = { value: timeOrigin + startTime };
        });
    };
    return MetricsInstrumentation;
}());
/** Instrument navigation entries */
function addNavigationSpans(transaction, entry, timeOrigin) {
    ['unloadEvent', 'redirect', 'domContentLoadedEvent', 'loadEvent', 'connect'].forEach(function (event) {
        addPerformanceNavigationTiming(transaction, entry, event, timeOrigin);
    });
    addPerformanceNavigationTiming(transaction, entry, 'secureConnection', timeOrigin, 'TLS/SSL', 'connectEnd');
    addPerformanceNavigationTiming(transaction, entry, 'fetch', timeOrigin, 'cache', 'domainLookupStart');
    addPerformanceNavigationTiming(transaction, entry, 'domainLookup', timeOrigin, 'DNS');
    addRequest(transaction, entry, timeOrigin);
}
/** Create measure related spans */
function addMeasureSpans(transaction, entry, startTime, duration, timeOrigin) {
    var measureStartTimestamp = timeOrigin + startTime;
    var measureEndTimestamp = measureStartTimestamp + duration;
    _startChild(transaction, {
        description: entry.name,
        endTimestamp: measureEndTimestamp,
        op: entry.entryType,
        startTimestamp: measureStartTimestamp,
    });
    return measureStartTimestamp;
}
/** Create resource-related spans */
function addResourceSpans(transaction, entry, resourceName, startTime, duration, timeOrigin) {
    // we already instrument based on fetch and xhr, so we don't need to
    // duplicate spans here.
    if (entry.initiatorType === 'xmlhttprequest' || entry.initiatorType === 'fetch') {
        return;
    }
    var data = {};
    if ('transferSize' in entry) {
        data['Transfer Size'] = entry.transferSize;
    }
    if ('encodedBodySize' in entry) {
        data['Encoded Body Size'] = entry.encodedBodySize;
    }
    if ('decodedBodySize' in entry) {
        data['Decoded Body Size'] = entry.decodedBodySize;
    }
    var startTimestamp = timeOrigin + startTime;
    var endTimestamp = startTimestamp + duration;
    _startChild(transaction, {
        description: resourceName,
        endTimestamp: endTimestamp,
        op: entry.initiatorType ? "resource." + entry.initiatorType : 'resource',
        startTimestamp: startTimestamp,
        data: data,
    });
}
/** Create performance navigation related spans */
function addPerformanceNavigationTiming(transaction, entry, event, timeOrigin, description, eventEnd) {
    var end = eventEnd ? entry[eventEnd] : entry[event + "End"];
    var start = entry[event + "Start"];
    if (!start || !end) {
        return;
    }
    _startChild(transaction, {
        op: 'browser',
        description: (description !== null && description !== void 0 ? description : event),
        startTimestamp: timeOrigin + msToSec(start),
        endTimestamp: timeOrigin + msToSec(end),
    });
}
/** Create request and response related spans */
function addRequest(transaction, entry, timeOrigin) {
    _startChild(transaction, {
        op: 'browser',
        description: 'request',
        startTimestamp: timeOrigin + msToSec(entry.requestStart),
        endTimestamp: timeOrigin + msToSec(entry.responseEnd),
    });
    _startChild(transaction, {
        op: 'browser',
        description: 'response',
        startTimestamp: timeOrigin + msToSec(entry.responseStart),
        endTimestamp: timeOrigin + msToSec(entry.responseEnd),
    });
}
/**
 * Helper function to start child on transactions. This function will make sure that the transaction will
 * use the start timestamp of the created child span if it is earlier than the transactions actual
 * start timestamp.
 */
function _startChild(transaction, _a) {
    var startTimestamp = _a.startTimestamp, ctx = __rest(_a, ["startTimestamp"]);
    if (startTimestamp && transaction.startTimestamp > startTimestamp) {
        transaction.startTimestamp = startTimestamp;
    }
    return transaction.startChild(__assign$2({ startTimestamp: startTimestamp }, ctx));
}
/**
 * Checks if a given value is a valid measurement value.
 */
function isMeasurementValue(value) {
    return typeof value === 'number' && isFinite(value);
}
/** Add LCP / CLS data to transaction to allow debugging */
function tagMetricInfo(transaction, lcpEntry, clsEntry) {
    if (lcpEntry) {
        IS_DEBUG_BUILD && logger.log('[Measurements] Adding LCP Data');
        // Capture Properties of the LCP element that contributes to the LCP.
        if (lcpEntry.element) {
            transaction.setTag('lcp.element', htmlTreeAsString(lcpEntry.element));
        }
        if (lcpEntry.id) {
            transaction.setTag('lcp.id', lcpEntry.id);
        }
        if (lcpEntry.url) {
            // Trim URL to the first 200 characters.
            transaction.setTag('lcp.url', lcpEntry.url.trim().slice(0, 200));
        }
        transaction.setTag('lcp.size', lcpEntry.size);
    }
    // See: https://developer.mozilla.org/en-US/docs/Web/API/LayoutShift
    if (clsEntry && clsEntry.sources) {
        IS_DEBUG_BUILD && logger.log('[Measurements] Adding CLS Data');
        clsEntry.sources.forEach(function (source, index) {
            return transaction.setTag("cls.source." + (index + 1), htmlTreeAsString(source.node));
        });
    }
}

var DEFAULT_TRACING_ORIGINS = ['localhost', /^\//];
var defaultRequestInstrumentationOptions = {
    traceFetch: true,
    traceXHR: true,
    tracingOrigins: DEFAULT_TRACING_ORIGINS,
};
/** Registers span creators for xhr and fetch requests  */
function instrumentOutgoingRequests(_options) {
    // eslint-disable-next-line @typescript-eslint/unbound-method
    var _a = __assign$2(__assign$2({}, defaultRequestInstrumentationOptions), _options), traceFetch = _a.traceFetch, traceXHR = _a.traceXHR, tracingOrigins = _a.tracingOrigins, shouldCreateSpanForRequest = _a.shouldCreateSpanForRequest;
    // We should cache url -> decision so that we don't have to compute
    // regexp everytime we create a request.
    var urlMap = {};
    var defaultShouldCreateSpan = function (url) {
        if (urlMap[url]) {
            return urlMap[url];
        }
        var origins = tracingOrigins;
        urlMap[url] =
            origins.some(function (origin) { return isMatchingPattern(url, origin); }) &&
                !isMatchingPattern(url, 'sentry_key');
        return urlMap[url];
    };
    // We want that our users don't have to re-implement shouldCreateSpanForRequest themselves
    // That's why we filter out already unwanted Spans from tracingOrigins
    var shouldCreateSpan = defaultShouldCreateSpan;
    if (typeof shouldCreateSpanForRequest === 'function') {
        shouldCreateSpan = function (url) {
            return defaultShouldCreateSpan(url) && shouldCreateSpanForRequest(url);
        };
    }
    var spans = {};
    if (traceFetch) {
        addInstrumentationHandler('fetch', function (handlerData) {
            fetchCallback(handlerData, shouldCreateSpan, spans);
        });
    }
    if (traceXHR) {
        addInstrumentationHandler('xhr', function (handlerData) {
            xhrCallback(handlerData, shouldCreateSpan, spans);
        });
    }
}
/**
 * Create and track fetch request spans
 */
function fetchCallback(handlerData, shouldCreateSpan, spans) {
    if (!hasTracingEnabled() || !(handlerData.fetchData && shouldCreateSpan(handlerData.fetchData.url))) {
        return;
    }
    if (handlerData.endTimestamp) {
        var spanId = handlerData.fetchData.__span;
        if (!spanId)
            return;
        var span = spans[spanId];
        if (span) {
            if (handlerData.response) {
                // TODO (kmclb) remove this once types PR goes through
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                span.setHttpStatus(handlerData.response.status);
            }
            else if (handlerData.error) {
                span.setStatus('internal_error');
            }
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return;
    }
    var activeTransaction = getActiveTransaction();
    if (activeTransaction) {
        var span = activeTransaction.startChild({
            data: __assign$2(__assign$2({}, handlerData.fetchData), { type: 'fetch' }),
            description: handlerData.fetchData.method + " " + handlerData.fetchData.url,
            op: 'http.client',
        });
        handlerData.fetchData.__span = span.spanId;
        spans[span.spanId] = span;
        var request = (handlerData.args[0] = handlerData.args[0]);
        // eslint-disable-next-line @typescript-eslint/no-explicit-any
        var options = (handlerData.args[1] = handlerData.args[1] || {});
        var headers = options.headers;
        if (isInstanceOf(request, Request)) {
            headers = request.headers;
        }
        if (headers) {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
            if (typeof headers.append === 'function') {
                // eslint-disable-next-line @typescript-eslint/no-unsafe-member-access
                headers.append('sentry-trace', span.toTraceparent());
            }
            else if (Array.isArray(headers)) {
                headers = __spread$1(headers, [['sentry-trace', span.toTraceparent()]]);
            }
            else {
                headers = __assign$2(__assign$2({}, headers), { 'sentry-trace': span.toTraceparent() });
            }
        }
        else {
            headers = { 'sentry-trace': span.toTraceparent() };
        }
        options.headers = headers;
    }
}
/**
 * Create and track xhr request spans
 */
function xhrCallback(handlerData, shouldCreateSpan, spans) {
    if (!hasTracingEnabled() ||
        (handlerData.xhr && handlerData.xhr.__sentry_own_request__) ||
        !(handlerData.xhr && handlerData.xhr.__sentry_xhr__ && shouldCreateSpan(handlerData.xhr.__sentry_xhr__.url))) {
        return;
    }
    var xhr = handlerData.xhr.__sentry_xhr__;
    // check first if the request has finished and is tracked by an existing span which should now end
    if (handlerData.endTimestamp) {
        var spanId = handlerData.xhr.__sentry_xhr_span_id__;
        if (!spanId)
            return;
        var span = spans[spanId];
        if (span) {
            span.setHttpStatus(xhr.status_code);
            span.finish();
            // eslint-disable-next-line @typescript-eslint/no-dynamic-delete
            delete spans[spanId];
        }
        return;
    }
    // if not, create a new span to track it
    var activeTransaction = getActiveTransaction();
    if (activeTransaction) {
        var span = activeTransaction.startChild({
            data: __assign$2(__assign$2({}, xhr.data), { type: 'xhr', method: xhr.method, url: xhr.url }),
            description: xhr.method + " " + xhr.url,
            op: 'http.client',
        });
        handlerData.xhr.__sentry_xhr_span_id__ = span.spanId;
        spans[handlerData.xhr.__sentry_xhr_span_id__] = span;
        if (handlerData.xhr.setRequestHeader) {
            try {
                handlerData.xhr.setRequestHeader('sentry-trace', span.toTraceparent());
            }
            catch (_) {
                // Error: InvalidStateError: Failed to execute 'setRequestHeader' on 'XMLHttpRequest': The object's state must be OPENED.
            }
        }
    }
}

var global$1 = getGlobalObject();
/**
 * Default function implementing pageload and navigation transactions
 */
function instrumentRoutingWithDefaults(customStartTransaction, startTransactionOnPageLoad, startTransactionOnLocationChange) {
    if (startTransactionOnPageLoad === void 0) { startTransactionOnPageLoad = true; }
    if (startTransactionOnLocationChange === void 0) { startTransactionOnLocationChange = true; }
    if (!global$1 || !global$1.location) {
        IS_DEBUG_BUILD && logger.warn('Could not initialize routing instrumentation due to invalid location');
        return;
    }
    var startingUrl = global$1.location.href;
    var activeTransaction;
    if (startTransactionOnPageLoad) {
        activeTransaction = customStartTransaction({ name: global$1.location.pathname, op: 'pageload' });
    }
    if (startTransactionOnLocationChange) {
        addInstrumentationHandler('history', function (_a) {
            var to = _a.to, from = _a.from;
            /**
             * This early return is there to account for some cases where a navigation transaction starts right after
             * long-running pageload. We make sure that if `from` is undefined and a valid `startingURL` exists, we don't
             * create an uneccessary navigation transaction.
             *
             * This was hard to duplicate, but this behavior stopped as soon as this fix was applied. This issue might also
             * only be caused in certain development environments where the usage of a hot module reloader is causing
             * errors.
             */
            if (from === undefined && startingUrl && startingUrl.indexOf(to) !== -1) {
                startingUrl = undefined;
                return;
            }
            if (from !== to) {
                startingUrl = undefined;
                if (activeTransaction) {
                    IS_DEBUG_BUILD && logger.log("[Tracing] Finishing current transaction with op: " + activeTransaction.op);
                    // If there's an open transaction on the scope, we need to finish it before creating an new one.
                    activeTransaction.finish();
                }
                activeTransaction = customStartTransaction({ name: global$1.location.pathname, op: 'navigation' });
            }
        });
    }
}

var DEFAULT_MAX_TRANSACTION_DURATION_SECONDS = 600;
var DEFAULT_BROWSER_TRACING_OPTIONS = __assign$2({ idleTimeout: DEFAULT_IDLE_TIMEOUT, markBackgroundTransactions: true, maxTransactionDuration: DEFAULT_MAX_TRANSACTION_DURATION_SECONDS, routingInstrumentation: instrumentRoutingWithDefaults, startTransactionOnLocationChange: true, startTransactionOnPageLoad: true }, defaultRequestInstrumentationOptions);
/**
 * The Browser Tracing integration automatically instruments browser pageload/navigation
 * actions as transactions, and captures requests, metrics and errors as spans.
 *
 * The integration can be configured with a variety of options, and can be extended to use
 * any routing library. This integration uses {@see IdleTransaction} to create transactions.
 */
var BrowserTracing = /** @class */ (function () {
    function BrowserTracing(_options) {
        /**
         * @inheritDoc
         */
        this.name = BrowserTracing.id;
        /** Store configured idle timeout so that it can be added as a tag to transactions */
        this._configuredIdleTimeout = undefined;
        var tracingOrigins = defaultRequestInstrumentationOptions.tracingOrigins;
        // NOTE: Logger doesn't work in constructors, as it's initialized after integrations instances
        if (_options) {
            this._configuredIdleTimeout = _options.idleTimeout;
            if (_options.tracingOrigins && Array.isArray(_options.tracingOrigins) && _options.tracingOrigins.length !== 0) {
                tracingOrigins = _options.tracingOrigins;
            }
            else {
                IS_DEBUG_BUILD && (this._emitOptionsWarning = true);
            }
        }
        this.options = __assign$2(__assign$2(__assign$2({}, DEFAULT_BROWSER_TRACING_OPTIONS), _options), { tracingOrigins: tracingOrigins });
        var _metricOptions = this.options._metricOptions;
        this._metrics = new MetricsInstrumentation(_metricOptions && _metricOptions._reportAllChanges);
    }
    /**
     * @inheritDoc
     */
    BrowserTracing.prototype.setupOnce = function (_, getCurrentHub) {
        var _this = this;
        this._getCurrentHub = getCurrentHub;
        if (this._emitOptionsWarning) {
            IS_DEBUG_BUILD &&
                logger.warn('[Tracing] You need to define `tracingOrigins` in the options. Set an array of urls or patterns to trace.');
            IS_DEBUG_BUILD &&
                logger.warn("[Tracing] We added a reasonable default for you: " + defaultRequestInstrumentationOptions.tracingOrigins);
        }
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.options, instrumentRouting = _a.routingInstrumentation, startTransactionOnLocationChange = _a.startTransactionOnLocationChange, startTransactionOnPageLoad = _a.startTransactionOnPageLoad, markBackgroundTransactions = _a.markBackgroundTransactions, traceFetch = _a.traceFetch, traceXHR = _a.traceXHR, tracingOrigins = _a.tracingOrigins, shouldCreateSpanForRequest = _a.shouldCreateSpanForRequest;
        instrumentRouting(function (context) { return _this._createRouteTransaction(context); }, startTransactionOnPageLoad, startTransactionOnLocationChange);
        if (markBackgroundTransactions) {
            registerBackgroundTabDetection();
        }
        instrumentOutgoingRequests({ traceFetch: traceFetch, traceXHR: traceXHR, tracingOrigins: tracingOrigins, shouldCreateSpanForRequest: shouldCreateSpanForRequest });
    };
    /** Create routing idle transaction. */
    BrowserTracing.prototype._createRouteTransaction = function (context) {
        var _this = this;
        if (!this._getCurrentHub) {
            IS_DEBUG_BUILD &&
                logger.warn("[Tracing] Did not create " + context.op + " transaction because _getCurrentHub is invalid.");
            return undefined;
        }
        // eslint-disable-next-line @typescript-eslint/unbound-method
        var _a = this.options, beforeNavigate = _a.beforeNavigate, idleTimeout = _a.idleTimeout, maxTransactionDuration = _a.maxTransactionDuration;
        var parentContextFromHeader = context.op === 'pageload' ? getHeaderContext() : undefined;
        var expandedContext = __assign$2(__assign$2(__assign$2({}, context), parentContextFromHeader), { trimEnd: true });
        var modifiedContext = typeof beforeNavigate === 'function' ? beforeNavigate(expandedContext) : expandedContext;
        // For backwards compatibility reasons, beforeNavigate can return undefined to "drop" the transaction (prevent it
        // from being sent to Sentry).
        var finalContext = modifiedContext === undefined ? __assign$2(__assign$2({}, expandedContext), { sampled: false }) : modifiedContext;
        if (finalContext.sampled === false) {
            IS_DEBUG_BUILD && logger.log("[Tracing] Will not send " + finalContext.op + " transaction because of beforeNavigate.");
        }
        IS_DEBUG_BUILD && logger.log("[Tracing] Starting " + finalContext.op + " transaction on scope");
        var hub = this._getCurrentHub();
        var location = getGlobalObject().location;
        var idleTransaction = startIdleTransaction(hub, finalContext, idleTimeout, true, { location: location });
        idleTransaction.registerBeforeFinishCallback(function (transaction, endTimestamp) {
            _this._metrics.addPerformanceEntries(transaction);
            adjustTransactionDuration(secToMs(maxTransactionDuration), transaction, endTimestamp);
        });
        idleTransaction.setTag('idleTimeout', this._configuredIdleTimeout);
        return idleTransaction;
    };
    /**
     * @inheritDoc
     */
    BrowserTracing.id = 'BrowserTracing';
    return BrowserTracing;
}());
/**
 * Gets transaction context from a sentry-trace meta.
 *
 * @returns Transaction context data from the header or undefined if there's no header or the header is malformed
 */
function getHeaderContext() {
    var header = getMetaContent('sentry-trace');
    if (header) {
        return extractTraceparentData(header);
    }
    return undefined;
}
/** Returns the value of a meta tag */
function getMetaContent(metaName) {
    var el = getGlobalObject().document.querySelector("meta[name=" + metaName + "]");
    return el ? el.getAttribute('content') : null;
}
/** Adjusts transaction value based on max transaction duration */
function adjustTransactionDuration(maxDuration, transaction, endTimestamp) {
    var diff = endTimestamp - transaction.startTimestamp;
    var isOutdatedTransaction = endTimestamp && (diff > maxDuration || diff < 0);
    if (isOutdatedTransaction) {
        transaction.setStatus('deadline_exceeded');
        transaction.setTag('maxTransactionDurationExceeded', 'true');
    }
}

// We are patching the global object with our hub extension methods
addExtensionMethods();

var SentryInit = function (dsn, environment) {
    if (environment === void 0) { environment = 'production'; }
    init({
        dsn: dsn,
        environment: environment,
        integrations: [new BrowserTracing()],
        tracesSampleRate: 0.5,
    });
};

function getKeyByValue(myEnum, enumValue) {
    var keys = Object.keys(myEnum).filter(function (x) { return myEnum[x] === enumValue; });
    return keys[0];
}

var WaningIcon$1 = "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path  d=\"M12,14a1.25,1.25,0,1,0,1.25,1.25A1.25,1.25,0,0,0,12,14Zm0-1.5a1,1,0,0,0,1-1v-3a1,1,0,0,0-2,0v3A1,1,0,0,0,12,12.5ZM12,2A10,10,0,1,0,22,12,10.01114,10.01114,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,12,20Z\"/></svg>";

var WaningIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path  d=\"M12,16a1,1,0,1,0,1,1A1,1,0,0,0,12,16Zm10.67,1.47-8.05-14a3,3,0,0,0-5.24,0l-8,14A3,3,0,0,0,3.94,22H20.06a3,3,0,0,0,2.61-4.53Zm-1.73,2a1,1,0,0,1-.88.51H3.94a1,1,0,0,1-.88-.51,1,1,0,0,1,0-1l8-14a1,1,0,0,1,1.78,0l8.05,14A1,1,0,0,1,20.94,19.49ZM12,8a1,1,0,0,0-1,1v4a1,1,0,0,0,2,0V9A1,1,0,0,0,12,8Z\"/></svg>";

var XCircle = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path  d=\"M15.71,8.29a1,1,0,0,0-1.42,0L12,10.59,9.71,8.29A1,1,0,0,0,8.29,9.71L10.59,12l-2.3,2.29a1,1,0,0,0,0,1.42,1,1,0,0,0,1.42,0L12,13.41l2.29,2.3a1,1,0,0,0,1.42,0,1,1,0,0,0,0-1.42L13.41,12l2.3-2.29A1,1,0,0,0,15.71,8.29Zm3.36-3.36A10,10,0,1,0,4.93,19.07,10,10,0,1,0,19.07,4.93ZM17.66,17.66A8,8,0,1,1,20,12,7.95,7.95,0,0,1,17.66,17.66Z\"/></svg>";

var DoneIcon = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path  d=\"M14.72,8.79l-4.29,4.3L8.78,11.44a1,1,0,1,0-1.41,1.41l2.35,2.36a1,1,0,0,0,.71.29,1,1,0,0,0,.7-.29l5-5a1,1,0,0,0,0-1.42A1,1,0,0,0,14.72,8.79ZM12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Z\"/></svg>";

var SupportIcon$1 = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path  d=\"M19,2H5A3,3,0,0,0,2,5V15a3,3,0,0,0,3,3H16.59l3.7,3.71A1,1,0,0,0,21,22a.84.84,0,0,0,.38-.08A1,1,0,0,0,22,21V5A3,3,0,0,0,19,2Zm1,16.59-2.29-2.3A1,1,0,0,0,17,16H5a1,1,0,0,1-1-1V5A1,1,0,0,1,5,4H19a1,1,0,0,1,1,1Z\"/></svg>";

// @ts-ignore
var AlertData = {
    information: WaningIcon$1,
    warning: WaningIcon,
    error: XCircle,
    confirmation: DoneIcon,
    support: SupportIcon$1,
};

var AlertContainer = styled.div(templateObject_2$p || (templateObject_2$p = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  min-height: ", "px;\n  padding: ", "px ", "px;\n  position: relative;\n  align-items: center;\n  border-radius: ", "px;\n  background-color: ", ";\n  transform: scale(1);\n  opacity: 1;\n  transition: transform 0.2s cubic-bezier(0.45, -0.38, 1, 0.5), opacity 0.2s ease-in;\n  ", ";\n\n  ", " {\n    flex-direction: column;\n  }\n"], ["\n  display: flex;\n  width: 100%;\n  min-height: ", "px;\n  padding: ", "px ", "px;\n  position: relative;\n  align-items: center;\n  border-radius: ", "px;\n  background-color: ", ";\n  transform: scale(1);\n  opacity: 1;\n  transition: transform 0.2s cubic-bezier(0.45, -0.38, 1, 0.5), opacity 0.2s ease-in;\n  ",
    ";\n\n  ", " {\n    flex-direction: column;\n  }\n"])), function (props) { return props.theme.forms.defaultHeight; }, function (props) { return props.theme.global.gutterSpace / 2; }, function (props) { return props.theme.global.gutterSpace; }, function (props) { return props.theme.forms.borderRadius; }, function (props) { return props.theme.behavior[props.type].secondary; }, function (props) {
    return props.isTransitioning && css(templateObject_1$s || (templateObject_1$s = __makeTemplateObject(["\n      transform: scale(0.95);\n      opacity: 0;\n    "], ["\n      transform: scale(0.95);\n      opacity: 0;\n    "])));
}, device.mobile);
var AlertContent = styled.div(templateObject_3$o || (templateObject_3$o = __makeTemplateObject(["\n  display: flex;\n  flex: 1;\n  svg {\n    display: block;\n  }\n"], ["\n  display: flex;\n  flex: 1;\n  svg {\n    display: block;\n  }\n"])));
var AlertTitle = styled.h1(templateObject_4$m || (templateObject_4$m = __makeTemplateObject(["\n  margin: 0;\n  font-size: ", ";\n  font-weight: 600;\n  line-height: 20px;\n  color: ", ";\n"], ["\n  margin: 0;\n  font-size: ", ";\n  font-weight: 600;\n  line-height: 20px;\n  color: ", ";\n"])), function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.colors.grey900; });
var AlertDescription = styled.div(templateObject_5$j || (templateObject_5$j = __makeTemplateObject(["\n  margin: 0;\n  font-size: ", ";\n  color: ", ";\n  line-height: 20px;\n"], ["\n  margin: 0;\n  font-size: ", ";\n  color: ", ";\n  line-height: 20px;\n"])), function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.colors.grey700; });
var Description$1 = styled.div(templateObject_6$i || (templateObject_6$i = __makeTemplateObject([""], [""])));
var AlertTitleContainer = styled.div(templateObject_8$g || (templateObject_8$g = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n\n  ", "\n\n  & + ", " {\n    padding-top: ", "px;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n\n  ",
    "\n\n  & + ", " {\n    padding-top: ", "px;\n  }\n"])), function (props) {
    return props.isAccordion && css(templateObject_7$i || (templateObject_7$i = __makeTemplateObject(["\n      justify-content: space-between;\n      margin-bottom: 0;\n    "], ["\n      justify-content: space-between;\n      margin-bottom: 0;\n    "])));
}, Description$1, function (props) { return props.theme.global.gutterSpace * 0.5; });
var SvgContainer = styled.div(templateObject_10$9 || (templateObject_10$9 = __makeTemplateObject(["\n  margin-right: ", "px;\n\n  ", "\n"], ["\n  margin-right: ", "px;\n\n  ",
    "\n"])), function (props) { return props.theme.global.gutterSpace / 2; }, function (props) {
    return props.centralizedIcon && css(templateObject_9$b || (templateObject_9$b = __makeTemplateObject(["\n      display: flex;\n      align-items: center;\n    "], ["\n      display: flex;\n      align-items: center;\n    "])));
});
var templateObject_1$s, templateObject_2$p, templateObject_3$o, templateObject_4$m, templateObject_5$j, templateObject_6$i, templateObject_7$i, templateObject_8$g, templateObject_9$b, templateObject_10$9;

var IconArrowRight = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path  d=\"M14.83,11.29,10.59,7.05a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.41L12.71,12,9.17,15.54a1,1,0,0,0,0,1.41,1,1,0,0,0,.71.29,1,1,0,0,0,.71-.29l4.24-4.24A1,1,0,0,0,14.83,11.29Z\"/></svg>";

var Alert = function (props) {
    var title = props.title, description = props.description, actions = props.actions, className = props.className, type = props.type, testId = props.testId, visible = props.visible, illustration = props.illustration, isCollapsed = props.isCollapsed, disabledIcon = props.disabledIcon, centralizedIcon = props.centralizedIcon, customIcon = props.customIcon;
    var _a = useState(false), isVisible = _a[0], setIsVisible = _a[1];
    var _b = useState(false), isTransitioning = _b[0], setIsTransitioning = _b[1];
    useEffect(function () {
        (function () {
            if (visible === false) {
                setIsTransitioning(true);
                return setTimeout(function () {
                    setIsVisible(false);
                    setIsTransitioning(false);
                }, 200);
            }
            return setIsVisible(true);
        })();
    }, [visible]);
    var alertType = type || 'information';
    var fillColor = getKeyByValue(Colors, theme.behavior[alertType].primary);
    if (isCollapsed) {
        return (React__default.createElement(React__default.Fragment, null, isVisible && (React__default.createElement(AlertContainer, { type: alertType, className: className, "data-testid": testId, isTransitioning: isTransitioning },
            React__default.createElement(Accordion, { title: React__default.createElement(AlertContent, null,
                    !disabledIcon && (React__default.createElement(SvgContainer, { centralizedIcon: centralizedIcon },
                        React__default.createElement(SvgIcon, { src: AlertData[alertType], fill: fillColor, width: 20, height: 20 }))),
                    React__default.createElement(Box, { width: "100%" }, title && (React__default.createElement(AlertTitleContainer, { isAccordion: true },
                        React__default.createElement(AlertTitle, null, title),
                        React__default.createElement(SvgIcon, { src: IconArrowRight, width: 20, height: 20, fill: "grey400", className: "arrow-icon" }))))) },
                React__default.createElement(Box, { mt: "12px" },
                    description && React__default.createElement(AlertDescription, null, description),
                    actions && React__default.createElement("div", null, actions)))))));
    }
    return (React__default.createElement(React__default.Fragment, null, isVisible && (React__default.createElement(AlertContainer, { type: alertType, className: className, "data-testid": testId, isTransitioning: isTransitioning },
        illustration && React__default.createElement("div", null, illustration),
        React__default.createElement(AlertContent, null,
            !disabledIcon && (React__default.createElement(SvgContainer, { centralizedIcon: centralizedIcon }, customIcon ? React__default.createElement(React__default.Fragment, null, customIcon) : React__default.createElement(SvgIcon, { src: AlertData[alertType], fill: fillColor, width: 20, height: 20 }))),
            React__default.createElement(Box, { flex: "1" },
                title && (React__default.createElement(AlertTitleContainer, null,
                    React__default.createElement(AlertTitle, null, title))),
                description && (React__default.createElement(Description$1, null,
                    description && React__default.createElement(AlertDescription, null, description),
                    actions && React__default.createElement("div", null, actions)))))))));
};

// @ts-ignore
var InlineAlertData = {
    information: WaningIcon$1,
    warning: WaningIcon,
    error: XCircle,
    confirmation: DoneIcon,
    support: SupportIcon$1,
};

var InlineAlertContainer = styled.div(templateObject_1$r || (templateObject_1$r = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n"], ["\n  display: flex;\n  align-items: center;\n"])));
var InlineAlertTitle = styled.span(templateObject_2$o || (templateObject_2$o = __makeTemplateObject(["\n  font-size: ", ";\n  font-weight: 400;\n  line-height: 16px;\n  color: ", ";\n  margin-left: ", "px;\n\n  ", "\n\n  a {\n    color: ", ";\n  }\n"], ["\n  font-size: ", ";\n  font-weight: 400;\n  line-height: 16px;\n  color: ", ";\n  margin-left: ", "px;\n\n  ",
    "\n\n  a {\n    color: ", ";\n  }\n"])), function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.colors.grey900; }, function (props) { return props.theme.global.gutterSpace / 2; }, function (props) {
    return props.customColor &&
        "\n    color: " + props.theme.colors[props.customColor] + ";\n  ";
}, function (props) { return props.theme.colors.blue700; });
var templateObject_1$r, templateObject_2$o;

var InlineAlert = function (props) {
    var title = props.title, className = props.className, type = props.type, testId = props.testId, textColored = props.textColored, onClick = props.onClick;
    var alertType = type || 'information';
    var fillColor = getKeyByValue(Colors, theme.behavior[alertType].primary);
    return (React__default.createElement(InlineAlertContainer, { className: className, "data-testid": testId, onClick: onClick },
        React__default.createElement(SvgIcon, { src: InlineAlertData[alertType], fill: fillColor, width: 16, height: 16 }),
        React__default.createElement(InlineAlertTitle, { customColor: textColored && fillColor }, title)));
};

var SupportIcon = "<svg width=\"18\" height=\"18\" viewBox=\"0 0 18 18\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M8.40866 11.7417C8.37283 11.7813 8.33943 11.823 8.30866 11.8667C8.27712 11.9131 8.2519 11.9636 8.23366 12.0167C8.20964 12.0639 8.19278 12.1145 8.18366 12.1667C8.17957 12.2222 8.17957 12.2779 8.18366 12.3334C8.18085 12.4427 8.20368 12.5511 8.25033 12.65C8.28776 12.7534 8.34747 12.8474 8.42523 12.9251C8.503 13.0029 8.59692 13.0626 8.70033 13.1C8.80008 13.1441 8.90794 13.1669 9.017 13.1669C9.12606 13.1669 9.23391 13.1441 9.33366 13.1C9.43708 13.0626 9.53099 13.0029 9.60876 12.9251C9.68652 12.8474 9.74624 12.7534 9.78366 12.65C9.82067 12.5487 9.83765 12.4412 9.83366 12.3334C9.8343 12.2237 9.81328 12.115 9.7718 12.0134C9.73033 11.9119 9.66923 11.8196 9.592 11.7417C9.51453 11.6636 9.42236 11.6016 9.32081 11.5593C9.21926 11.517 9.11034 11.4952 9.00033 11.4952C8.89032 11.4952 8.7814 11.517 8.67985 11.5593C8.5783 11.6016 8.48613 11.6636 8.40866 11.7417ZM9.00033 0.666687C7.35215 0.666687 5.74099 1.15543 4.37058 2.07111C3.00017 2.98679 1.93206 4.28827 1.30133 5.81099C0.670603 7.33371 0.505575 9.00926 0.827119 10.6258C1.14866 12.2423 1.94234 13.7271 3.10777 14.8926C4.27321 16.058 5.75807 16.8517 7.37458 17.1732C8.99109 17.4948 10.6666 17.3297 12.1894 16.699C13.7121 16.0683 15.0136 15.0002 15.9292 13.6298C16.8449 12.2594 17.3337 10.6482 17.3337 9.00002C17.3337 7.90567 17.1181 6.82204 16.6993 5.81099C16.2805 4.79995 15.6667 3.88129 14.8929 3.10746C14.1191 2.33364 13.2004 1.71981 12.1894 1.30102C11.1783 0.882235 10.0947 0.666687 9.00033 0.666687ZM9.00033 15.6667C7.68179 15.6667 6.39286 15.2757 5.29653 14.5432C4.2002 13.8106 3.34572 12.7694 2.84113 11.5512C2.33655 10.3331 2.20453 8.99263 2.46176 7.69942C2.719 6.40621 3.35393 5.21833 4.28628 4.28598C5.21863 3.35363 6.40652 2.71869 7.69973 2.46145C8.99293 2.20422 10.3334 2.33624 11.5516 2.84082C12.7697 3.34541 13.8109 4.19989 14.5435 5.29622C15.276 6.39255 15.667 7.68148 15.667 9.00002C15.667 10.7681 14.9646 12.4638 13.7144 13.7141C12.4641 14.9643 10.7684 15.6667 9.00033 15.6667ZM9.00033 4.83335C8.56122 4.83307 8.12977 4.94845 7.74942 5.16789C7.36907 5.38732 7.05322 5.70307 6.83366 6.08335C6.77337 6.1782 6.73288 6.28427 6.71464 6.39517C6.6964 6.50607 6.70078 6.61951 6.72752 6.72868C6.75426 6.83784 6.8028 6.94047 6.87023 7.03038C6.93766 7.1203 7.02258 7.19565 7.11989 7.25189C7.21719 7.30814 7.32487 7.34412 7.43644 7.35767C7.54801 7.37122 7.66117 7.36207 7.76911 7.33075C7.87705 7.29944 7.97754 7.24661 8.06454 7.17545C8.15153 7.1043 8.22323 7.01628 8.27533 6.91669C8.34875 6.78952 8.45447 6.68401 8.58178 6.61084C8.7091 6.53767 8.85349 6.49944 9.00033 6.50002C9.22134 6.50002 9.4333 6.58782 9.58958 6.7441C9.74586 6.90038 9.83366 7.11234 9.83366 7.33335C9.83366 7.55437 9.74586 7.76633 9.58958 7.92261C9.4333 8.07889 9.22134 8.16669 9.00033 8.16669C8.77932 8.16669 8.56735 8.25448 8.41107 8.41077C8.25479 8.56705 8.167 8.77901 8.167 9.00002V9.83335C8.167 10.0544 8.25479 10.2663 8.41107 10.4226C8.56735 10.5789 8.77932 10.6667 9.00033 10.6667C9.22134 10.6667 9.4333 10.5789 9.58958 10.4226C9.74586 10.2663 9.83366 10.0544 9.83366 9.83335V9.68335C10.3848 9.48337 10.8481 9.09604 11.1426 8.58908C11.4371 8.08211 11.5441 7.48776 11.4448 6.90993C11.3455 6.33209 11.0463 5.80754 10.5995 5.42795C10.1527 5.04836 9.58661 4.8379 9.00033 4.83335Z\" />\n</svg>";

var InfoIcon = "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M12,2A10,10,0,1,0,22,12,10.01114,10.01114,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,12,20Zm0-8.5a1,1,0,0,0-1,1v3a1,1,0,0,0,2,0v-3A1,1,0,0,0,12,11.5Zm0-4a1.25,1.25,0,1,0,1.25,1.25A1.25,1.25,0,0,0,12,7.5Z\"/></svg>";

// @ts-ignore
var InlineDialogData = {
    information: WaningIcon$1,
    warning: WaningIcon,
    error: XCircle,
    confirmation: DoneIcon,
    support: SupportIcon,
    default: InfoIcon,
};

var InlineDialogContainer = styled.div(templateObject_1$q || (templateObject_1$q = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  align-items: center;\n"], ["\n  position: relative;\n  display: flex;\n  align-items: center;\n"])));
var StyledButton = styled(Button$1)(templateObject_2$n || (templateObject_2$n = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding: 0;\n  cursor: pointer;\n\n  svg:first-child {\n    margin: 0;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  padding: 0;\n  cursor: pointer;\n\n  svg:first-child {\n    margin: 0;\n  }\n"])));
var InlineDialogTitle = styled.span(templateObject_3$n || (templateObject_3$n = __makeTemplateObject(["\n  margin-left: ", "px;\n  font-size: ", ";\n  font-weight: 400;\n  line-height: 16px;\n  color: ", ";\n"], ["\n  margin-left: ", "px;\n  font-size: ", ";\n  font-weight: 400;\n  line-height: 16px;\n  color: ", ";\n"])), function (props) { return props.theme.global.gutterSpace / 2; }, function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.colors.grey900; });
var InlineContentContainer = styled.div(templateObject_5$i || (templateObject_5$i = __makeTemplateObject(["\n  padding: ", "px ", "px;\n  background-color: ", ";\n  border-radius: ", "px;\n  box-shadow: 0px 2px 5px ", ";\n  max-width: ", ";\n\n  ", "\n"], ["\n  padding: ", "px ", "px;\n  background-color: ", ";\n  border-radius: ", "px;\n  box-shadow: 0px 2px 5px ", ";\n  max-width: ", ";\n\n  ",
    "\n"])), function (props) { return props.theme.global.gutterSpace / 2; }, function (props) { return props.theme.global.gutterSpace * 0.75; }, function (props) { return props.theme.colors.white; }, function (props) { return props.theme.forms.borderRadius / 2; }, function (props) { return rgba(props.theme.colors.grey700, 0.25); }, function (props) { return (props.$maxWidth ? props.$maxWidth + "px" : '275px'); }, function (props) {
    return props.$width && css(templateObject_4$l || (templateObject_4$l = __makeTemplateObject(["\n      width: ", "px;\n    "], ["\n      width: ", "px;\n    "])), props.$width);
});
var InlineDialogContent = styled.div(templateObject_6$h || (templateObject_6$h = __makeTemplateObject(["\n  margin: 0;\n  line-height: 18px;\n  font-size: ", ";\n  color: ", ";\n"], ["\n  margin: 0;\n  line-height: 18px;\n  font-size: ", ";\n  color: ", ";\n"])), function (props) { return props.theme.fontSizes[1]; }, function (props) { return props.theme.colors.grey700; });
var StyledPopover = styled(Popper$1)(templateObject_7$h || (templateObject_7$h = __makeTemplateObject(["\n  z-index: ", ";\n  .MuiPaper-root {\n    box-shadow: 0px 2px 5px ", ";\n    max-width: 220px;\n    border-radius: ", "px;\n  }\n"], ["\n  z-index: ", ";\n  .MuiPaper-root {\n    box-shadow: 0px 2px 5px ", ";\n    max-width: 220px;\n    border-radius: ", "px;\n  }\n"])), function (props) { return props.theme.zIndex.highPriority; }, function (props) { return rgba(props.theme.colors.grey400, 0.25); }, function (props) { return props.theme.forms.borderRadius / 2; });
var templateObject_1$q, templateObject_2$n, templateObject_3$n, templateObject_4$l, templateObject_5$i, templateObject_6$h, templateObject_7$h;

var InlineDialog = function (props) {
    var title = props.title, description = props.description, actions = props.actions, className = props.className, testId = props.testId, type = props.type, placement = props.placement, maxPopoverWidth = props.maxPopoverWidth, popoverWidth = props.popoverWidth, children = props.children, otherProps = __rest(props, ["title", "description", "actions", "className", "testId", "type", "placement", "maxPopoverWidth", "popoverWidth", "children"]);
    var _a = React__default.useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var handleClick = function (event) {
        event.preventDefault();
        if (anchorEl) {
            return setAnchorEl(null);
        }
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function () {
        if (anchorEl) {
            setAnchorEl(null);
        }
    };
    var open = Boolean(anchorEl);
    var id = open ? 'inline-dialog' : undefined;
    var dialogType = type || 'information';
    var fillColor = getKeyByValue(Colors, theme.behavior[dialogType].primary);
    var renderActionElement = function () {
        if (children) {
            return React__default.Children.map(children, function (child) { return React__default.cloneElement(child, { onClick: handleClick }); });
        }
        return (React__default.createElement(StyledButton, { as: "a", onClick: handleClick, type: "button", variant: "text" },
            React__default.createElement(SvgIcon, { src: InlineDialogData[dialogType], fill: fillColor, width: 20, height: 20 }),
            title && React__default.createElement(InlineDialogTitle, null, title)));
    };
    return (React__default.createElement(InlineDialogContainer, { className: className, "data-testid": testId },
        renderActionElement(),
        React__default.createElement(StyledPopover, __assign$2({ id: id, "data-testid": testId || 'inline-dialog-popper', open: open, anchorEl: anchorEl, onClose: handleClose, placement: placement || 'bottom-start' }, otherProps),
            React__default.createElement(ClickAwayListener, { onClickAway: handleClose, mouseEvent: "onClick" },
                React__default.createElement(InlineContentContainer, { "$maxWidth": maxPopoverWidth, "$width": popoverWidth },
                    React__default.createElement(InlineDialogContent, null, description),
                    actions && React__default.createElement(Box, { mt: theme.global.gutterSpace * 0.75 + "px" }, actions))))));
};

const useRifm = props => {
  const [, refresh] = useReducer(c => c + 1, 0);
  const valueRef = useRef(null);
  const {
    replace,
    append
  } = props;
  const userValue = replace ? replace(props.format(props.value)) : props.format(props.value); // state of delete button see comments below about inputType support

  const isDeleleteButtonDownRef = useRef(false);

  const onChange = evt => {
    if (process.env.NODE_ENV !== 'production') {
      if (evt.target.type === 'number') {
        console.error('Rifm does not support input type=number, use type=tel instead.');
        return;
      }

      if (evt.target.type === 'date') {
        console.error('Rifm does not support input type=date.');
        return;
      }
    }

    const eventValue = evt.target.value;
    valueRef.current = [eventValue, // eventValue
    evt.target, // input
    eventValue.length > userValue.length, // isSizeIncreaseOperation
    isDeleleteButtonDownRef.current, // isDeleleteButtonDown
    userValue === props.format(eventValue) // isNoOperation
    ];

    if (process.env.NODE_ENV !== 'production') {
      const formattedEventValue = props.format(eventValue);

      if (eventValue !== formattedEventValue && eventValue.toLowerCase() === formattedEventValue.toLowerCase()) {
        console.warn('Case enforcement does not work with format. Please use replace={value => value.toLowerCase()} instead');
      }
    } // The main trick is to update underlying input with non formatted value (= eventValue)
    // that allows us to calculate right cursor position after formatting (see getCursorPosition)
    // then we format new value and call props.onChange with masked/formatted value
    // and finally we are able to set cursor position into right place


    refresh();
  }; // React prints warn on server in non production mode about useLayoutEffect usage
  // in both cases it's noop


  if (process.env.NODE_ENV === 'production' || typeof window !== 'undefined') {
    useLayoutEffect(() => {
      if (valueRef.current == null) return;
      let [eventValue, input, isSizeIncreaseOperation, isDeleleteButtonDown, // No operation means that value itself hasn't been changed, BTW cursor, selection etc can be changed
      isNoOperation] = valueRef.current;
      valueRef.current = null; // this usually occurs on deleting special symbols like ' here 123'123.00
      // in case of isDeleleteButtonDown cursor should move differently vs backspace

      const deleteWasNoOp = isDeleleteButtonDown && isNoOperation;
      const valueAfterSelectionStart = eventValue.slice(input.selectionStart);
      const acceptedCharIndexAfterDelete = valueAfterSelectionStart.search(props.accept || /\d/g);
      const charsToSkipAfterDelete = acceptedCharIndexAfterDelete !== -1 ? acceptedCharIndexAfterDelete : 0; // Create string from only accepted symbols

      const clean = str => (str.match(props.accept || /\d/g) || []).join('');

      const valueBeforeSelectionStart = clean(eventValue.substr(0, input.selectionStart)); // trying to find cursor position in formatted value having knowledge about valueBeforeSelectionStart
      // This works because we assume that format doesn't change the order of accepted symbols.
      // Imagine we have formatter which adds ' symbol between numbers, and by default we refuse all non numeric symbols
      // for example we had input = 1'2|'4 (| means cursor position) then user entered '3' symbol
      // inputValue = 1'23'|4 so valueBeforeSelectionStart = 123 and formatted value = 1'2'3'4
      // calling getCursorPosition("1'2'3'4") will give us position after 3, 1'2'3|'4
      // so for formatting just this function to determine cursor position after formatting is enough
      // with masking we need to do some additional checks see `mask` below

      const getCursorPosition = val => {
        let start = 0;
        let cleanPos = 0;

        for (let i = 0; i !== valueBeforeSelectionStart.length; ++i) {
          let newPos = val.indexOf(valueBeforeSelectionStart[i], start) + 1;
          let newCleanPos = clean(val).indexOf(valueBeforeSelectionStart[i], cleanPos) + 1; // this skips position change if accepted symbols order was broken
          // For example fixes edge case with fixed point numbers:
          // You have '0|.00', then press 1, it becomes 01|.00 and after format 1.00, this breaks our assumption
          // that order of accepted symbols is not changed after format,
          // so here we don't update start position if other accepted symbols was inbetween current and new position

          if (newCleanPos - cleanPos > 1) {
            newPos = start;
            newCleanPos = cleanPos;
          }

          cleanPos = Math.max(newCleanPos, cleanPos);
          start = Math.max(start, newPos);
        }

        return start;
      }; // Masking part, for masks if size of mask is above some value
      // we need to replace symbols instead of do nothing as like in format


      if (props.mask === true && isSizeIncreaseOperation && !isNoOperation) {
        let start = getCursorPosition(eventValue);
        const c = clean(eventValue.substr(start))[0];
        start = eventValue.indexOf(c, start);
        eventValue = `${eventValue.substr(0, start)}${eventValue.substr(start + 1)}`;
      }

      let formattedValue = props.format(eventValue);

      if (append != null && // cursor at the end
      input.selectionStart === eventValue.length && !isNoOperation) {
        if (isSizeIncreaseOperation) {
          formattedValue = append(formattedValue);
        } else {
          // If after delete last char is special character and we use append
          // delete it too
          // was: "12-3|" backspace pressed, then should be "12|"
          if (clean(formattedValue.slice(-1)) === '') {
            formattedValue = formattedValue.slice(0, -1);
          }
        }
      }

      const replacedValue = replace ? replace(formattedValue) : formattedValue;

      if (userValue === replacedValue) {
        // if nothing changed for formatted value, just refresh so userValue will be used at render
        refresh();
      } else {
        props.onChange(replacedValue);
      }

      return () => {
        let start = getCursorPosition(formattedValue); // Visually improves working with masked values,
        // like cursor jumping over refused symbols
        // as an example date mask: was "5|1-24-3" then user pressed "6"
        // it becomes "56-|12-43" with this code, and "56|-12-43" without

        if (props.mask != null && (isSizeIncreaseOperation || isDeleleteButtonDown && !deleteWasNoOp)) {
          while (formattedValue[start] && clean(formattedValue[start]) === '') {
            start += 1;
          }
        }

        input.selectionStart = input.selectionEnd = start + (deleteWasNoOp ? 1 + charsToSkipAfterDelete : 0);
      };
    });
  }

  useEffect(() => {
    // until https://developer.mozilla.org/en-US/docs/Web/API/InputEvent/inputType will be supported
    // by all major browsers (now supported by: +chrome, +safari, ?edge, !firefox)
    // there is no way I found to distinguish in onChange
    // backspace or delete was called in some situations
    // firefox track https://bugzilla.mozilla.org/show_bug.cgi?id=1447239
    const handleKeyDown = evt => {
      if (evt.code === 'Delete') {
        isDeleleteButtonDownRef.current = true;
      }
    };

    const handleKeyUp = evt => {
      if (evt.code === 'Delete') {
        isDeleleteButtonDownRef.current = false;
      }
    };

    document.addEventListener('keydown', handleKeyDown);
    document.addEventListener('keyup', handleKeyUp);
    return () => {
      document.removeEventListener('keydown', handleKeyDown);
      document.removeEventListener('keyup', handleKeyUp);
    };
  }, []);
  return {
    value: valueRef.current != null ? valueRef.current[0] : userValue,
    onChange
  };
};

var classnames = createCommonjsModule(function (module) {
/*!
	Copyright (c) 2018 Jed Watson.
	Licensed under the MIT License (MIT), see
	http://jedwatson.github.io/classnames
*/
/* global define */

(function () {

	var hasOwn = {}.hasOwnProperty;

	function classNames () {
		var classes = '';

		for (var i = 0; i < arguments.length; i++) {
			var arg = arguments[i];
			if (arg) {
				classes = appendClass(classes, parseValue(arg));
			}
		}

		return classes;
	}

	function parseValue (arg) {
		if (typeof arg === 'string' || typeof arg === 'number') {
			return arg;
		}

		if (typeof arg !== 'object') {
			return '';
		}

		if (Array.isArray(arg)) {
			return classNames.apply(null, arg);
		}

		if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes('[native code]')) {
			return arg.toString();
		}

		var classes = '';

		for (var key in arg) {
			if (hasOwn.call(arg, key) && arg[key]) {
				classes = appendClass(classes, key);
			}
		}

		return classes;
	}

	function appendClass (value, newClass) {
		if (!newClass) {
			return value;
		}
	
		if (value) {
			return value + ' ' + newClass;
		}
	
		return value + newClass;
	}

	if (module.exports) {
		classNames.default = classNames;
		module.exports = classNames;
	} else {
		window.classNames = classNames;
	}
}());
});

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}

function requiredArgs(required, args) {
  if (args.length < required) {
    throw new TypeError(required + ' argument' + (required > 1 ? 's' : '') + ' required, but only ' + args.length + ' present');
  }
}

/**
 * @name isDate
 * @category Common Helpers
 * @summary Is the given value a date?
 *
 * @description
 * Returns true if the given value is an instance of Date. The function works for dates transferred across iframes.
 *
 * @param {*} value - the value to check
 * @returns {boolean} true if the given value is a date
 * @throws {TypeError} 1 arguments required
 *
 * @example
 * // For a valid date:
 * const result = isDate(new Date())
 * //=> true
 *
 * @example
 * // For an invalid date:
 * const result = isDate(new Date(NaN))
 * //=> true
 *
 * @example
 * // For some value:
 * const result = isDate('2014-02-31')
 * //=> false
 *
 * @example
 * // For an object:
 * const result = isDate({})
 * //=> false
 */
function isDate(value) {
  requiredArgs(1, arguments);
  return value instanceof Date || _typeof(value) === 'object' && Object.prototype.toString.call(value) === '[object Date]';
}

/**
 * @name toDate
 * @category Common Helpers
 * @summary Convert the given argument to an instance of Date.
 *
 * @description
 * Convert the given argument to an instance of Date.
 *
 * If the argument is an instance of Date, the function returns its clone.
 *
 * If the argument is a number, it is treated as a timestamp.
 *
 * If the argument is none of the above, the function returns Invalid Date.
 *
 * **Note**: *all* Date arguments passed to any *date-fns* function is processed by `toDate`.
 *
 * @param {Date|Number} argument - the value to convert
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Clone the date:
 * const result = toDate(new Date(2014, 1, 11, 11, 30, 30))
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert the timestamp to date:
 * const result = toDate(1392098430000)
 * //=> Tue Feb 11 2014 11:30:30
 */
function toDate(argument) {
  requiredArgs(1, arguments);
  var argStr = Object.prototype.toString.call(argument);

  // Clone the date
  if (argument instanceof Date || _typeof(argument) === 'object' && argStr === '[object Date]') {
    // Prevent the date to lose the milliseconds when passed to new Date() in IE10
    return new Date(argument.getTime());
  } else if (typeof argument === 'number' || argStr === '[object Number]') {
    return new Date(argument);
  } else {
    if ((typeof argument === 'string' || argStr === '[object String]') && typeof console !== 'undefined') {
      // eslint-disable-next-line no-console
      console.warn("Starting with v2.0.0-beta.1 date-fns doesn't accept strings as date arguments. Please use `parseISO` to parse strings. See: https://github.com/date-fns/date-fns/blob/master/docs/upgradeGuide.md#string-arguments");
      // eslint-disable-next-line no-console
      console.warn(new Error().stack);
    }
    return new Date(NaN);
  }
}

/**
 * @name isValid
 * @category Common Helpers
 * @summary Is the given date valid?
 *
 * @description
 * Returns false if argument is Invalid Date and true otherwise.
 * Argument is converted to Date using `toDate`. See [toDate]{@link https://date-fns.org/docs/toDate}
 * Invalid Date is a Date, whose time value is NaN.
 *
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {*} date - the date to check
 * @returns {Boolean} the date is valid
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // For the valid date:
 * const result = isValid(new Date(2014, 1, 31))
 * //=> true
 *
 * @example
 * // For the value, convertable into a date:
 * const result = isValid(1393804800000)
 * //=> true
 *
 * @example
 * // For the invalid date:
 * const result = isValid(new Date(''))
 * //=> false
 */
function isValid$1(dirtyDate) {
  requiredArgs(1, arguments);
  if (!isDate(dirtyDate) && typeof dirtyDate !== 'number') {
    return false;
  }
  var date = toDate(dirtyDate);
  return !isNaN(Number(date));
}

function toInteger(dirtyNumber) {
  if (dirtyNumber === null || dirtyNumber === true || dirtyNumber === false) {
    return NaN;
  }
  var number = Number(dirtyNumber);
  if (isNaN(number)) {
    return number;
  }
  return number < 0 ? Math.ceil(number) : Math.floor(number);
}

/**
 * @name addMilliseconds
 * @category Millisecond Helpers
 * @summary Add the specified number of milliseconds to the given date.
 *
 * @description
 * Add the specified number of milliseconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 750 milliseconds to 10 July 2014 12:45:30.000:
 * const result = addMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:30.750
 */
function addMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var timestamp = toDate(dirtyDate).getTime();
  var amount = toInteger(dirtyAmount);
  return new Date(timestamp + amount);
}

/**
 * @name subMilliseconds
 * @category Millisecond Helpers
 * @summary Subtract the specified number of milliseconds from the given date.
 *
 * @description
 * Subtract the specified number of milliseconds from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of milliseconds to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the milliseconds subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 750 milliseconds from 10 July 2014 12:45:30.000:
 * const result = subMilliseconds(new Date(2014, 6, 10, 12, 45, 30, 0), 750)
 * //=> Thu Jul 10 2014 12:45:29.250
 */
function subMilliseconds(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, -amount);
}

var MILLISECONDS_IN_DAY$1 = 86400000;
function getUTCDayOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  date.setUTCMonth(0, 1);
  date.setUTCHours(0, 0, 0, 0);
  var startOfYearTimestamp = date.getTime();
  var difference = timestamp - startOfYearTimestamp;
  return Math.floor(difference / MILLISECONDS_IN_DAY$1) + 1;
}

function startOfUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setUTCFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setUTCFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getUTCISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setUTCFullYear(year, 0, 4);
  fourthOfJanuary.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK$2 = 604800000;
function getUTCISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCISOWeek(date).getTime() - startOfUTCISOWeekYear(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK$2) + 1;
}

var defaultOptions = {};
function getDefaultOptions() {
  return defaultOptions;
}

function startOfUTCWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate(dirtyDate);
  var day = date.getUTCDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setUTCDate(date.getUTCDate() - diff);
  date.setUTCHours(0, 0, 0, 0);
  return date;
}

function getUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getUTCFullYear();
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var firstWeekOfNextYear = new Date(0);
  firstWeekOfNextYear.setUTCFullYear(year + 1, 0, firstWeekContainsDate);
  firstWeekOfNextYear.setUTCHours(0, 0, 0, 0);
  var startOfNextYear = startOfUTCWeek(firstWeekOfNextYear, options);
  var firstWeekOfThisYear = new Date(0);
  firstWeekOfThisYear.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeekOfThisYear.setUTCHours(0, 0, 0, 0);
  var startOfThisYear = startOfUTCWeek(firstWeekOfThisYear, options);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

function startOfUTCWeekYear(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$firstWeekCon, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var firstWeekContainsDate = toInteger((_ref = (_ref2 = (_ref3 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref !== void 0 ? _ref : 1);
  var year = getUTCWeekYear(dirtyDate, options);
  var firstWeek = new Date(0);
  firstWeek.setUTCFullYear(year, 0, firstWeekContainsDate);
  firstWeek.setUTCHours(0, 0, 0, 0);
  var date = startOfUTCWeek(firstWeek, options);
  return date;
}

var MILLISECONDS_IN_WEEK$1 = 604800000;
function getUTCWeek(dirtyDate, options) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfUTCWeek(date, options).getTime() - startOfUTCWeekYear(date, options).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK$1) + 1;
}

function addLeadingZeros(number, targetLength) {
  var sign = number < 0 ? '-' : '';
  var output = Math.abs(number).toString();
  while (output.length < targetLength) {
    output = '0' + output;
  }
  return sign + output;
}

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* |                                |
 * |  d  | Day of month                   |  D  |                                |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  m  | Minute                         |  M  | Month                          |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  y  | Year (abs)                     |  Y  |                                |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 */
var formatters$2 = {
  // Year
  y: function y(date, token) {
    // From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_tokens
    // | Year     |     y | yy |   yyy |  yyyy | yyyyy |
    // |----------|-------|----|-------|-------|-------|
    // | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
    // | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
    // | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
    // | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
    // | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |

    var signedYear = date.getUTCFullYear();
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var year = signedYear > 0 ? signedYear : 1 - signedYear;
    return addLeadingZeros(token === 'yy' ? year % 100 : year, token.length);
  },
  // Month
  M: function M(date, token) {
    var month = date.getUTCMonth();
    return token === 'M' ? String(month + 1) : addLeadingZeros(month + 1, 2);
  },
  // Day of the month
  d: function d(date, token) {
    return addLeadingZeros(date.getUTCDate(), token.length);
  },
  // AM or PM
  a: function a(date, token) {
    var dayPeriodEnumValue = date.getUTCHours() / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return dayPeriodEnumValue.toUpperCase();
      case 'aaa':
        return dayPeriodEnumValue;
      case 'aaaaa':
        return dayPeriodEnumValue[0];
      case 'aaaa':
      default:
        return dayPeriodEnumValue === 'am' ? 'a.m.' : 'p.m.';
    }
  },
  // Hour [1-12]
  h: function h(date, token) {
    return addLeadingZeros(date.getUTCHours() % 12 || 12, token.length);
  },
  // Hour [0-23]
  H: function H(date, token) {
    return addLeadingZeros(date.getUTCHours(), token.length);
  },
  // Minute
  m: function m(date, token) {
    return addLeadingZeros(date.getUTCMinutes(), token.length);
  },
  // Second
  s: function s(date, token) {
    return addLeadingZeros(date.getUTCSeconds(), token.length);
  },
  // Fraction of second
  S: function S(date, token) {
    var numberOfDigits = token.length;
    var milliseconds = date.getUTCMilliseconds();
    var fractionalSeconds = Math.floor(milliseconds * Math.pow(10, numberOfDigits - 3));
    return addLeadingZeros(fractionalSeconds, token.length);
  }
};
var formatters$3 = formatters$2;

var dayPeriodEnum = {
  am: 'am',
  pm: 'pm',
  midnight: 'midnight',
  noon: 'noon',
  morning: 'morning',
  afternoon: 'afternoon',
  evening: 'evening',
  night: 'night'
};
/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O  | Timezone (GMT)                 |
 * |  p! | Long localized time            |  P! | Long localized date            |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z  | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `format` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 * - `P` is long localized date format
 * - `p` is long localized time format
 */

var formatters = {
  // Era
  G: function G(date, token, localize) {
    var era = date.getUTCFullYear() > 0 ? 1 : 0;
    switch (token) {
      // AD, BC
      case 'G':
      case 'GG':
      case 'GGG':
        return localize.era(era, {
          width: 'abbreviated'
        });
      // A, B
      case 'GGGGG':
        return localize.era(era, {
          width: 'narrow'
        });
      // Anno Domini, Before Christ
      case 'GGGG':
      default:
        return localize.era(era, {
          width: 'wide'
        });
    }
  },
  // Year
  y: function y(date, token, localize) {
    // Ordinal number
    if (token === 'yo') {
      var signedYear = date.getUTCFullYear();
      // Returns 1 for 1 BC (which is year 0 in JavaScript)
      var year = signedYear > 0 ? signedYear : 1 - signedYear;
      return localize.ordinalNumber(year, {
        unit: 'year'
      });
    }
    return formatters$3.y(date, token);
  },
  // Local week-numbering year
  Y: function Y(date, token, localize, options) {
    var signedWeekYear = getUTCWeekYear(date, options);
    // Returns 1 for 1 BC (which is year 0 in JavaScript)
    var weekYear = signedWeekYear > 0 ? signedWeekYear : 1 - signedWeekYear;

    // Two digit year
    if (token === 'YY') {
      var twoDigitYear = weekYear % 100;
      return addLeadingZeros(twoDigitYear, 2);
    }

    // Ordinal number
    if (token === 'Yo') {
      return localize.ordinalNumber(weekYear, {
        unit: 'year'
      });
    }

    // Padding
    return addLeadingZeros(weekYear, token.length);
  },
  // ISO week-numbering year
  R: function R(date, token) {
    var isoWeekYear = getUTCISOWeekYear(date);

    // Padding
    return addLeadingZeros(isoWeekYear, token.length);
  },
  // Extended year. This is a single number designating the year of this calendar system.
  // The main difference between `y` and `u` localizers are B.C. years:
  // | Year | `y` | `u` |
  // |------|-----|-----|
  // | AC 1 |   1 |   1 |
  // | BC 1 |   1 |   0 |
  // | BC 2 |   2 |  -1 |
  // Also `yy` always returns the last two digits of a year,
  // while `uu` pads single digit years to 2 characters and returns other years unchanged.
  u: function u(date, token) {
    var year = date.getUTCFullYear();
    return addLeadingZeros(year, token.length);
  },
  // Quarter
  Q: function Q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'Q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'QQ':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'Qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'QQQ':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'QQQQQ':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'formatting'
        });
      // 1st quarter, 2nd quarter, ...
      case 'QQQQ':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone quarter
  q: function q(date, token, localize) {
    var quarter = Math.ceil((date.getUTCMonth() + 1) / 3);
    switch (token) {
      // 1, 2, 3, 4
      case 'q':
        return String(quarter);
      // 01, 02, 03, 04
      case 'qq':
        return addLeadingZeros(quarter, 2);
      // 1st, 2nd, 3rd, 4th
      case 'qo':
        return localize.ordinalNumber(quarter, {
          unit: 'quarter'
        });
      // Q1, Q2, Q3, Q4
      case 'qqq':
        return localize.quarter(quarter, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // 1, 2, 3, 4 (narrow quarter; could be not numerical)
      case 'qqqqq':
        return localize.quarter(quarter, {
          width: 'narrow',
          context: 'standalone'
        });
      // 1st quarter, 2nd quarter, ...
      case 'qqqq':
      default:
        return localize.quarter(quarter, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Month
  M: function M(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      case 'M':
      case 'MM':
        return formatters$3.M(date, token);
      // 1st, 2nd, ..., 12th
      case 'Mo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'MMM':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // J, F, ..., D
      case 'MMMMM':
        return localize.month(month, {
          width: 'narrow',
          context: 'formatting'
        });
      // January, February, ..., December
      case 'MMMM':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone month
  L: function L(date, token, localize) {
    var month = date.getUTCMonth();
    switch (token) {
      // 1, 2, ..., 12
      case 'L':
        return String(month + 1);
      // 01, 02, ..., 12
      case 'LL':
        return addLeadingZeros(month + 1, 2);
      // 1st, 2nd, ..., 12th
      case 'Lo':
        return localize.ordinalNumber(month + 1, {
          unit: 'month'
        });
      // Jan, Feb, ..., Dec
      case 'LLL':
        return localize.month(month, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // J, F, ..., D
      case 'LLLLL':
        return localize.month(month, {
          width: 'narrow',
          context: 'standalone'
        });
      // January, February, ..., December
      case 'LLLL':
      default:
        return localize.month(month, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // Local week of year
  w: function w(date, token, localize, options) {
    var week = getUTCWeek(date, options);
    if (token === 'wo') {
      return localize.ordinalNumber(week, {
        unit: 'week'
      });
    }
    return addLeadingZeros(week, token.length);
  },
  // ISO week of year
  I: function I(date, token, localize) {
    var isoWeek = getUTCISOWeek(date);
    if (token === 'Io') {
      return localize.ordinalNumber(isoWeek, {
        unit: 'week'
      });
    }
    return addLeadingZeros(isoWeek, token.length);
  },
  // Day of the month
  d: function d(date, token, localize) {
    if (token === 'do') {
      return localize.ordinalNumber(date.getUTCDate(), {
        unit: 'date'
      });
    }
    return formatters$3.d(date, token);
  },
  // Day of year
  D: function D(date, token, localize) {
    var dayOfYear = getUTCDayOfYear(date);
    if (token === 'Do') {
      return localize.ordinalNumber(dayOfYear, {
        unit: 'dayOfYear'
      });
    }
    return addLeadingZeros(dayOfYear, token.length);
  },
  // Day of week
  E: function E(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    switch (token) {
      // Tue
      case 'E':
      case 'EE':
      case 'EEE':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'EEEEE':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'EEEEEE':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'EEEE':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Local day of week
  e: function e(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (Nth day of week with current locale or weekStartsOn)
      case 'e':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'ee':
        return addLeadingZeros(localDayOfWeek, 2);
      // 1st, 2nd, ..., 7th
      case 'eo':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'eee':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'eeeee':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'eeeeee':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'eeee':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Stand-alone local day of week
  c: function c(date, token, localize, options) {
    var dayOfWeek = date.getUTCDay();
    var localDayOfWeek = (dayOfWeek - options.weekStartsOn + 8) % 7 || 7;
    switch (token) {
      // Numerical value (same as in `e`)
      case 'c':
        return String(localDayOfWeek);
      // Padded numerical value
      case 'cc':
        return addLeadingZeros(localDayOfWeek, token.length);
      // 1st, 2nd, ..., 7th
      case 'co':
        return localize.ordinalNumber(localDayOfWeek, {
          unit: 'day'
        });
      case 'ccc':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'standalone'
        });
      // T
      case 'ccccc':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'standalone'
        });
      // Tu
      case 'cccccc':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'standalone'
        });
      // Tuesday
      case 'cccc':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'standalone'
        });
    }
  },
  // ISO day of week
  i: function i(date, token, localize) {
    var dayOfWeek = date.getUTCDay();
    var isoDayOfWeek = dayOfWeek === 0 ? 7 : dayOfWeek;
    switch (token) {
      // 2
      case 'i':
        return String(isoDayOfWeek);
      // 02
      case 'ii':
        return addLeadingZeros(isoDayOfWeek, token.length);
      // 2nd
      case 'io':
        return localize.ordinalNumber(isoDayOfWeek, {
          unit: 'day'
        });
      // Tue
      case 'iii':
        return localize.day(dayOfWeek, {
          width: 'abbreviated',
          context: 'formatting'
        });
      // T
      case 'iiiii':
        return localize.day(dayOfWeek, {
          width: 'narrow',
          context: 'formatting'
        });
      // Tu
      case 'iiiiii':
        return localize.day(dayOfWeek, {
          width: 'short',
          context: 'formatting'
        });
      // Tuesday
      case 'iiii':
      default:
        return localize.day(dayOfWeek, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM or PM
  a: function a(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    switch (token) {
      case 'a':
      case 'aa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'aaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'aaaaa':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'aaaa':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // AM, PM, midnight, noon
  b: function b(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours === 12) {
      dayPeriodEnumValue = dayPeriodEnum.noon;
    } else if (hours === 0) {
      dayPeriodEnumValue = dayPeriodEnum.midnight;
    } else {
      dayPeriodEnumValue = hours / 12 >= 1 ? 'pm' : 'am';
    }
    switch (token) {
      case 'b':
      case 'bb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'bbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        }).toLowerCase();
      case 'bbbbb':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'bbbb':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // in the morning, in the afternoon, in the evening, at night
  B: function B(date, token, localize) {
    var hours = date.getUTCHours();
    var dayPeriodEnumValue;
    if (hours >= 17) {
      dayPeriodEnumValue = dayPeriodEnum.evening;
    } else if (hours >= 12) {
      dayPeriodEnumValue = dayPeriodEnum.afternoon;
    } else if (hours >= 4) {
      dayPeriodEnumValue = dayPeriodEnum.morning;
    } else {
      dayPeriodEnumValue = dayPeriodEnum.night;
    }
    switch (token) {
      case 'B':
      case 'BB':
      case 'BBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'abbreviated',
          context: 'formatting'
        });
      case 'BBBBB':
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'narrow',
          context: 'formatting'
        });
      case 'BBBB':
      default:
        return localize.dayPeriod(dayPeriodEnumValue, {
          width: 'wide',
          context: 'formatting'
        });
    }
  },
  // Hour [1-12]
  h: function h(date, token, localize) {
    if (token === 'ho') {
      var hours = date.getUTCHours() % 12;
      if (hours === 0) hours = 12;
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return formatters$3.h(date, token);
  },
  // Hour [0-23]
  H: function H(date, token, localize) {
    if (token === 'Ho') {
      return localize.ordinalNumber(date.getUTCHours(), {
        unit: 'hour'
      });
    }
    return formatters$3.H(date, token);
  },
  // Hour [0-11]
  K: function K(date, token, localize) {
    var hours = date.getUTCHours() % 12;
    if (token === 'Ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Hour [1-24]
  k: function k(date, token, localize) {
    var hours = date.getUTCHours();
    if (hours === 0) hours = 24;
    if (token === 'ko') {
      return localize.ordinalNumber(hours, {
        unit: 'hour'
      });
    }
    return addLeadingZeros(hours, token.length);
  },
  // Minute
  m: function m(date, token, localize) {
    if (token === 'mo') {
      return localize.ordinalNumber(date.getUTCMinutes(), {
        unit: 'minute'
      });
    }
    return formatters$3.m(date, token);
  },
  // Second
  s: function s(date, token, localize) {
    if (token === 'so') {
      return localize.ordinalNumber(date.getUTCSeconds(), {
        unit: 'second'
      });
    }
    return formatters$3.s(date, token);
  },
  // Fraction of second
  S: function S(date, token) {
    return formatters$3.S(date, token);
  },
  // Timezone (ISO-8601. If offset is 0, output is always `'Z'`)
  X: function X(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    if (timezoneOffset === 0) {
      return 'Z';
    }
    switch (token) {
      // Hours and optional minutes
      case 'X':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XX`
      case 'XXXX':
      case 'XX':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `XXX`
      case 'XXXXX':
      case 'XXX': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (ISO-8601. If offset is 0, output is `'+00:00'` or equivalent)
  x: function x(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Hours and optional minutes
      case 'x':
        return formatTimezoneWithOptionalMinutes(timezoneOffset);

      // Hours, minutes and optional seconds without `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xx`
      case 'xxxx':
      case 'xx':
        // Hours and minutes without `:` delimiter
        return formatTimezone(timezoneOffset);

      // Hours, minutes and optional seconds with `:` delimiter
      // Note: neither ISO-8601 nor JavaScript supports seconds in timezone offsets
      // so this token always has the same output as `xxx`
      case 'xxxxx':
      case 'xxx': // Hours and minutes with `:` delimiter
      default:
        return formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (GMT)
  O: function O(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'O':
      case 'OO':
      case 'OOO':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'OOOO':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Timezone (specific non-location)
  z: function z(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timezoneOffset = originalDate.getTimezoneOffset();
    switch (token) {
      // Short
      case 'z':
      case 'zz':
      case 'zzz':
        return 'GMT' + formatTimezoneShort(timezoneOffset, ':');
      // Long
      case 'zzzz':
      default:
        return 'GMT' + formatTimezone(timezoneOffset, ':');
    }
  },
  // Seconds timestamp
  t: function t(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = Math.floor(originalDate.getTime() / 1000);
    return addLeadingZeros(timestamp, token.length);
  },
  // Milliseconds timestamp
  T: function T(date, token, _localize, options) {
    var originalDate = options._originalDate || date;
    var timestamp = originalDate.getTime();
    return addLeadingZeros(timestamp, token.length);
  }
};
function formatTimezoneShort(offset, dirtyDelimiter) {
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = Math.floor(absOffset / 60);
  var minutes = absOffset % 60;
  if (minutes === 0) {
    return sign + String(hours);
  }
  var delimiter = dirtyDelimiter || '';
  return sign + String(hours) + delimiter + addLeadingZeros(minutes, 2);
}
function formatTimezoneWithOptionalMinutes(offset, dirtyDelimiter) {
  if (offset % 60 === 0) {
    var sign = offset > 0 ? '-' : '+';
    return sign + addLeadingZeros(Math.abs(offset) / 60, 2);
  }
  return formatTimezone(offset, dirtyDelimiter);
}
function formatTimezone(offset, dirtyDelimiter) {
  var delimiter = dirtyDelimiter || '';
  var sign = offset > 0 ? '-' : '+';
  var absOffset = Math.abs(offset);
  var hours = addLeadingZeros(Math.floor(absOffset / 60), 2);
  var minutes = addLeadingZeros(absOffset % 60, 2);
  return sign + hours + delimiter + minutes;
}
var formatters$1 = formatters;

var dateLongFormatter = function dateLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'P':
      return formatLong.date({
        width: 'short'
      });
    case 'PP':
      return formatLong.date({
        width: 'medium'
      });
    case 'PPP':
      return formatLong.date({
        width: 'long'
      });
    case 'PPPP':
    default:
      return formatLong.date({
        width: 'full'
      });
  }
};
var timeLongFormatter = function timeLongFormatter(pattern, formatLong) {
  switch (pattern) {
    case 'p':
      return formatLong.time({
        width: 'short'
      });
    case 'pp':
      return formatLong.time({
        width: 'medium'
      });
    case 'ppp':
      return formatLong.time({
        width: 'long'
      });
    case 'pppp':
    default:
      return formatLong.time({
        width: 'full'
      });
  }
};
var dateTimeLongFormatter = function dateTimeLongFormatter(pattern, formatLong) {
  var matchResult = pattern.match(/(P+)(p+)?/) || [];
  var datePattern = matchResult[1];
  var timePattern = matchResult[2];
  if (!timePattern) {
    return dateLongFormatter(pattern, formatLong);
  }
  var dateTimeFormat;
  switch (datePattern) {
    case 'P':
      dateTimeFormat = formatLong.dateTime({
        width: 'short'
      });
      break;
    case 'PP':
      dateTimeFormat = formatLong.dateTime({
        width: 'medium'
      });
      break;
    case 'PPP':
      dateTimeFormat = formatLong.dateTime({
        width: 'long'
      });
      break;
    case 'PPPP':
    default:
      dateTimeFormat = formatLong.dateTime({
        width: 'full'
      });
      break;
  }
  return dateTimeFormat.replace('{{date}}', dateLongFormatter(datePattern, formatLong)).replace('{{time}}', timeLongFormatter(timePattern, formatLong));
};
var longFormatters = {
  p: timeLongFormatter,
  P: dateTimeLongFormatter
};
var longFormatters$1 = longFormatters;

/**
 * Google Chrome as of 67.0.3396.87 introduced timezones with offset that includes seconds.
 * They usually appear for dates that denote time before the timezones were introduced
 * (e.g. for 'Europe/Prague' timezone the offset is GMT+00:57:44 before 1 October 1891
 * and GMT+01:00:00 after that date)
 *
 * Date#getTimezoneOffset returns the offset in minutes and would return 57 for the example above,
 * which would lead to incorrect calculations.
 *
 * This function returns the timezone offset in milliseconds that takes seconds in account.
 */
function getTimezoneOffsetInMilliseconds(date) {
  var utcDate = new Date(Date.UTC(date.getFullYear(), date.getMonth(), date.getDate(), date.getHours(), date.getMinutes(), date.getSeconds(), date.getMilliseconds()));
  utcDate.setUTCFullYear(date.getFullYear());
  return date.getTime() - utcDate.getTime();
}

var protectedDayOfYearTokens = ['D', 'DD'];
var protectedWeekYearTokens = ['YY', 'YYYY'];
function isProtectedDayOfYearToken(token) {
  return protectedDayOfYearTokens.indexOf(token) !== -1;
}
function isProtectedWeekYearToken(token) {
  return protectedWeekYearTokens.indexOf(token) !== -1;
}
function throwProtectedError(token, format, input) {
  if (token === 'YYYY') {
    throw new RangeError("Use `yyyy` instead of `YYYY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'YY') {
    throw new RangeError("Use `yy` instead of `YY` (in `".concat(format, "`) for formatting years to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'D') {
    throw new RangeError("Use `d` instead of `D` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  } else if (token === 'DD') {
    throw new RangeError("Use `dd` instead of `DD` (in `".concat(format, "`) for formatting days of the month to the input `").concat(input, "`; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md"));
  }
}

var formatDistanceLocale$1 = {
  lessThanXSeconds: {
    one: 'less than a second',
    other: 'less than {{count}} seconds'
  },
  xSeconds: {
    one: '1 second',
    other: '{{count}} seconds'
  },
  halfAMinute: 'half a minute',
  lessThanXMinutes: {
    one: 'less than a minute',
    other: 'less than {{count}} minutes'
  },
  xMinutes: {
    one: '1 minute',
    other: '{{count}} minutes'
  },
  aboutXHours: {
    one: 'about 1 hour',
    other: 'about {{count}} hours'
  },
  xHours: {
    one: '1 hour',
    other: '{{count}} hours'
  },
  xDays: {
    one: '1 day',
    other: '{{count}} days'
  },
  aboutXWeeks: {
    one: 'about 1 week',
    other: 'about {{count}} weeks'
  },
  xWeeks: {
    one: '1 week',
    other: '{{count}} weeks'
  },
  aboutXMonths: {
    one: 'about 1 month',
    other: 'about {{count}} months'
  },
  xMonths: {
    one: '1 month',
    other: '{{count}} months'
  },
  aboutXYears: {
    one: 'about 1 year',
    other: 'about {{count}} years'
  },
  xYears: {
    one: '1 year',
    other: '{{count}} years'
  },
  overXYears: {
    one: 'over 1 year',
    other: 'over {{count}} years'
  },
  almostXYears: {
    one: 'almost 1 year',
    other: 'almost {{count}} years'
  }
};
var formatDistance$2 = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale$1[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', count.toString());
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'in ' + result;
    } else {
      return result + ' ago';
    }
  }
  return result;
};
var formatDistance$3 = formatDistance$2;

function buildFormatLongFn(args) {
  return function () {
    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    // TODO: Remove String()
    var width = options.width ? String(options.width) : args.defaultWidth;
    var format = args.formats[width] || args.formats[args.defaultWidth];
    return format;
  };
}

var dateFormats$1 = {
  full: 'EEEE, MMMM do, y',
  long: 'MMMM do, y',
  medium: 'MMM d, y',
  short: 'MM/dd/yyyy'
};
var timeFormats$1 = {
  full: 'h:mm:ss a zzzz',
  long: 'h:mm:ss a z',
  medium: 'h:mm:ss a',
  short: 'h:mm a'
};
var dateTimeFormats$1 = {
  full: "{{date}} 'at' {{time}}",
  long: "{{date}} 'at' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong$2 = {
  date: buildFormatLongFn({
    formats: dateFormats$1,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats$1,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats$1,
    defaultWidth: 'full'
  })
};
var formatLong$3 = formatLong$2;

var formatRelativeLocale$1 = {
  lastWeek: "'last' eeee 'at' p",
  yesterday: "'yesterday at' p",
  today: "'today at' p",
  tomorrow: "'tomorrow at' p",
  nextWeek: "eeee 'at' p",
  other: 'P'
};
var formatRelative$2 = function formatRelative(token, _date, _baseDate, _options) {
  return formatRelativeLocale$1[token];
};
var formatRelative$3 = formatRelative$2;

function buildLocalizeFn(args) {
  return function (dirtyIndex, options) {
    var context = options !== null && options !== void 0 && options.context ? String(options.context) : 'standalone';
    var valuesArray;
    if (context === 'formatting' && args.formattingValues) {
      var defaultWidth = args.defaultFormattingWidth || args.defaultWidth;
      var width = options !== null && options !== void 0 && options.width ? String(options.width) : defaultWidth;
      valuesArray = args.formattingValues[width] || args.formattingValues[defaultWidth];
    } else {
      var _defaultWidth = args.defaultWidth;
      var _width = options !== null && options !== void 0 && options.width ? String(options.width) : args.defaultWidth;
      valuesArray = args.values[_width] || args.values[_defaultWidth];
    }
    var index = args.argumentCallback ? args.argumentCallback(dirtyIndex) : dirtyIndex;
    // @ts-ignore: For some reason TypeScript just don't want to match it, no matter how hard we try. I challenge you to try to remove it!
    return valuesArray[index];
  };
}

var eraValues$1 = {
  narrow: ['B', 'A'],
  abbreviated: ['BC', 'AD'],
  wide: ['Before Christ', 'Anno Domini']
};
var quarterValues$1 = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['Q1', 'Q2', 'Q3', 'Q4'],
  wide: ['1st quarter', '2nd quarter', '3rd quarter', '4th quarter']
};

// Note: in English, the names of days of the week and months are capitalized.
// If you are making a new locale based on this one, check if the same is true for the language you're working on.
// Generally, formatted dates should look like they are in the middle of a sentence,
// e.g. in Spanish language the weekdays and months should be in the lowercase.
var monthValues$1 = {
  narrow: ['J', 'F', 'M', 'A', 'M', 'J', 'J', 'A', 'S', 'O', 'N', 'D'],
  abbreviated: ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'],
  wide: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December']
};
var dayValues$1 = {
  narrow: ['S', 'M', 'T', 'W', 'T', 'F', 'S'],
  short: ['Su', 'Mo', 'Tu', 'We', 'Th', 'Fr', 'Sa'],
  abbreviated: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
  wide: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday']
};
var dayPeriodValues$1 = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'morning',
    afternoon: 'afternoon',
    evening: 'evening',
    night: 'night'
  }
};
var formattingDayPeriodValues$1 = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mi',
    noon: 'n',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'midnight',
    noon: 'noon',
    morning: 'in the morning',
    afternoon: 'in the afternoon',
    evening: 'in the evening',
    night: 'at night'
  }
};
var ordinalNumber$1 = function ordinalNumber(dirtyNumber, _options) {
  var number = Number(dirtyNumber);

  // If ordinal numbers depend on context, for example,
  // if they are different for different grammatical genders,
  // use `options.unit`.
  //
  // `unit` can be 'year', 'quarter', 'month', 'week', 'date', 'dayOfYear',
  // 'day', 'hour', 'minute', 'second'.

  var rem100 = number % 100;
  if (rem100 > 20 || rem100 < 10) {
    switch (rem100 % 10) {
      case 1:
        return number + 'st';
      case 2:
        return number + 'nd';
      case 3:
        return number + 'rd';
    }
  }
  return number + 'th';
};
var localize$2 = {
  ordinalNumber: ordinalNumber$1,
  era: buildLocalizeFn({
    values: eraValues$1,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues$1,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues$1,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues$1,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues$1,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues$1,
    defaultFormattingWidth: 'wide'
  })
};
var localize$3 = localize$2;

function buildMatchFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var width = options.width;
    var matchPattern = width && args.matchPatterns[width] || args.matchPatterns[args.defaultMatchWidth];
    var matchResult = string.match(matchPattern);
    if (!matchResult) {
      return null;
    }
    var matchedString = matchResult[0];
    var parsePatterns = width && args.parsePatterns[width] || args.parsePatterns[args.defaultParseWidth];
    var key = Array.isArray(parsePatterns) ? findIndex$1(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    }) : findKey(parsePatterns, function (pattern) {
      return pattern.test(matchedString);
    });
    var value;
    value = args.valueCallback ? args.valueCallback(key) : key;
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}
function findKey(object, predicate) {
  for (var key in object) {
    if (object.hasOwnProperty(key) && predicate(object[key])) {
      return key;
    }
  }
  return undefined;
}
function findIndex$1(array, predicate) {
  for (var key = 0; key < array.length; key++) {
    if (predicate(array[key])) {
      return key;
    }
  }
  return undefined;
}

function buildMatchPatternFn(args) {
  return function (string) {
    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var matchResult = string.match(args.matchPattern);
    if (!matchResult) return null;
    var matchedString = matchResult[0];
    var parseResult = string.match(args.parsePattern);
    if (!parseResult) return null;
    var value = args.valueCallback ? args.valueCallback(parseResult[0]) : parseResult[0];
    value = options.valueCallback ? options.valueCallback(value) : value;
    var rest = string.slice(matchedString.length);
    return {
      value: value,
      rest: rest
    };
  };
}

var matchOrdinalNumberPattern$1 = /^(\d+)(th|st|nd|rd)?/i;
var parseOrdinalNumberPattern$1 = /\d+/i;
var matchEraPatterns$1 = {
  narrow: /^(b|a)/i,
  abbreviated: /^(b\.?\s?c\.?|b\.?\s?c\.?\s?e\.?|a\.?\s?d\.?|c\.?\s?e\.?)/i,
  wide: /^(before christ|before common era|anno domini|common era)/i
};
var parseEraPatterns$1 = {
  any: [/^b/i, /^(a|c)/i]
};
var matchQuarterPatterns$1 = {
  narrow: /^[1234]/i,
  abbreviated: /^q[1234]/i,
  wide: /^[1234](th|st|nd|rd)? quarter/i
};
var parseQuarterPatterns$1 = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns$1 = {
  narrow: /^[jfmasond]/i,
  abbreviated: /^(jan|feb|mar|apr|may|jun|jul|aug|sep|oct|nov|dec)/i,
  wide: /^(january|february|march|april|may|june|july|august|september|october|november|december)/i
};
var parseMonthPatterns$1 = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^f/i, /^mar/i, /^ap/i, /^may/i, /^jun/i, /^jul/i, /^au/i, /^s/i, /^o/i, /^n/i, /^d/i]
};
var matchDayPatterns$1 = {
  narrow: /^[smtwf]/i,
  short: /^(su|mo|tu|we|th|fr|sa)/i,
  abbreviated: /^(sun|mon|tue|wed|thu|fri|sat)/i,
  wide: /^(sunday|monday|tuesday|wednesday|thursday|friday|saturday)/i
};
var parseDayPatterns$1 = {
  narrow: [/^s/i, /^m/i, /^t/i, /^w/i, /^t/i, /^f/i, /^s/i],
  any: [/^su/i, /^m/i, /^tu/i, /^w/i, /^th/i, /^f/i, /^sa/i]
};
var matchDayPeriodPatterns$1 = {
  narrow: /^(a|p|mi|n|(in the|at) (morning|afternoon|evening|night))/i,
  any: /^([ap]\.?\s?m\.?|midnight|noon|(in the|at) (morning|afternoon|evening|night))/i
};
var parseDayPeriodPatterns$1 = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mi/i,
    noon: /^no/i,
    morning: /morning/i,
    afternoon: /afternoon/i,
    evening: /evening/i,
    night: /night/i
  }
};
var match$2 = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern$1,
    parsePattern: parseOrdinalNumberPattern$1,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns$1,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns$1,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns$1,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns$1,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns$1,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns$1,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns$1,
    defaultParseWidth: 'any'
  })
};
var match$3 = match$2;

/**
 * @type {Locale}
 * @category Locales
 * @summary English locale (United States).
 * @language English
 * @iso-639-2 eng
 * @author Sasha Koss [@kossnocorp]{@link https://github.com/kossnocorp}
 * @author Lesha Koss [@leshakoss]{@link https://github.com/leshakoss}
 */
var locale$1 = {
  code: 'en-US',
  formatDistance: formatDistance$3,
  formatLong: formatLong$3,
  formatRelative: formatRelative$3,
  localize: localize$3,
  match: match$3,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};
var defaultLocale = locale$1;

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp$1 = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp$1 = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp$1 = /^'([^]*?)'?$/;
var doubleQuoteRegExp$1 = /''/g;
var unescapedLatinCharacterRegExp$1 = /[a-zA-Z]/;

/**
 * @name format
 * @category Common Helpers
 * @summary Format the date.
 *
 * @description
 * Return the formatted date string in the given format. The result may vary by locale.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 * (see the last example)
 *
 * Format of the string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 7 below the table).
 *
 * Accepted patterns:
 * | Unit                            | Pattern | Result examples                   | Notes |
 * |---------------------------------|---------|-----------------------------------|-------|
 * | Era                             | G..GGG  | AD, BC                            |       |
 * |                                 | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 | GGGGG   | A, B                              |       |
 * | Calendar year                   | y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | yo      | 44th, 1st, 0th, 17th              | 5,7   |
 * |                                 | yy      | 44, 01, 00, 17                    | 5     |
 * |                                 | yyy     | 044, 001, 1900, 2017              | 5     |
 * |                                 | yyyy    | 0044, 0001, 1900, 2017            | 5     |
 * |                                 | yyyyy   | ...                               | 3,5   |
 * | Local week-numbering year       | Y       | 44, 1, 1900, 2017                 | 5     |
 * |                                 | Yo      | 44th, 1st, 1900th, 2017th         | 5,7   |
 * |                                 | YY      | 44, 01, 00, 17                    | 5,8   |
 * |                                 | YYY     | 044, 001, 1900, 2017              | 5     |
 * |                                 | YYYY    | 0044, 0001, 1900, 2017            | 5,8   |
 * |                                 | YYYYY   | ...                               | 3,5   |
 * | ISO week-numbering year         | R       | -43, 0, 1, 1900, 2017             | 5,7   |
 * |                                 | RR      | -43, 00, 01, 1900, 2017           | 5,7   |
 * |                                 | RRR     | -043, 000, 001, 1900, 2017        | 5,7   |
 * |                                 | RRRR    | -0043, 0000, 0001, 1900, 2017     | 5,7   |
 * |                                 | RRRRR   | ...                               | 3,5,7 |
 * | Extended year                   | u       | -43, 0, 1, 1900, 2017             | 5     |
 * |                                 | uu      | -43, 01, 1900, 2017               | 5     |
 * |                                 | uuu     | -043, 001, 1900, 2017             | 5     |
 * |                                 | uuuu    | -0043, 0001, 1900, 2017           | 5     |
 * |                                 | uuuuu   | ...                               | 3,5   |
 * | Quarter (formatting)            | Q       | 1, 2, 3, 4                        |       |
 * |                                 | Qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | QQ      | 01, 02, 03, 04                    |       |
 * |                                 | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | q       | 1, 2, 3, 4                        |       |
 * |                                 | qo      | 1st, 2nd, 3rd, 4th                | 7     |
 * |                                 | qq      | 01, 02, 03, 04                    |       |
 * |                                 | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 | qqqqq   | 1, 2, 3, 4                        | 4     |
 * | Month (formatting)              | M       | 1, 2, ..., 12                     |       |
 * |                                 | Mo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | MM      | 01, 02, ..., 12                   |       |
 * |                                 | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 | MMMM    | January, February, ..., December  | 2     |
 * |                                 | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | L       | 1, 2, ..., 12                     |       |
 * |                                 | Lo      | 1st, 2nd, ..., 12th               | 7     |
 * |                                 | LL      | 01, 02, ..., 12                   |       |
 * |                                 | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 | LLLL    | January, February, ..., December  | 2     |
 * |                                 | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | w       | 1, 2, ..., 53                     |       |
 * |                                 | wo      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | I       | 1, 2, ..., 53                     | 7     |
 * |                                 | Io      | 1st, 2nd, ..., 53th               | 7     |
 * |                                 | II      | 01, 02, ..., 53                   | 7     |
 * | Day of month                    | d       | 1, 2, ..., 31                     |       |
 * |                                 | do      | 1st, 2nd, ..., 31st               | 7     |
 * |                                 | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     | D       | 1, 2, ..., 365, 366               | 9     |
 * |                                 | Do      | 1st, 2nd, ..., 365th, 366th       | 7     |
 * |                                 | DD      | 01, 02, ..., 365, 366             | 9     |
 * |                                 | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 | DDDD    | ...                               | 3     |
 * | Day of week (formatting)        | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    | i       | 1, 2, 3, ..., 7                   | 7     |
 * |                                 | io      | 1st, 2nd, ..., 7th                | 7     |
 * |                                 | ii      | 01, 02, ..., 07                   | 7     |
 * |                                 | iii     | Mon, Tue, Wed, ..., Sun           | 7     |
 * |                                 | iiii    | Monday, Tuesday, ..., Sunday      | 2,7   |
 * |                                 | iiiii   | M, T, W, T, F, S, S               | 7     |
 * |                                 | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 7     |
 * | Local day of week (formatting)  | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 | eo      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | ee      | 02, 03, ..., 01                   |       |
 * |                                 | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 | co      | 2nd, 3rd, ..., 1st                | 7     |
 * |                                 | cc      | 02, 03, ..., 01                   |       |
 * |                                 | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          | a..aa   | AM, PM                            |       |
 * |                                 | aaa     | am, pm                            |       |
 * |                                 | aaaa    | a.m., p.m.                        | 2     |
 * |                                 | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          | b..bb   | AM, PM, noon, midnight            |       |
 * |                                 | bbb     | am, pm, noon, midnight            |       |
 * |                                 | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             | B..BBB  | at night, in the morning, ...     |       |
 * |                                 | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 | ho      | 1st, 2nd, ..., 11th, 12th         | 7     |
 * |                                 | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 | Ho      | 0th, 1st, 2nd, ..., 23rd          | 7     |
 * |                                 | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 | Ko      | 1st, 2nd, ..., 11th, 0th          | 7     |
 * |                                 | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 | ko      | 24th, 1st, 2nd, ..., 23rd         | 7     |
 * |                                 | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          | m       | 0, 1, ..., 59                     |       |
 * |                                 | mo      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | mm      | 00, 01, ..., 59                   |       |
 * | Second                          | s       | 0, 1, ..., 59                     |       |
 * |                                 | so      | 0th, 1st, ..., 59th               | 7     |
 * |                                 | ss      | 00, 01, ..., 59                   |       |
 * | Fraction of second              | S       | 0, 1, ..., 9                      |       |
 * |                                 | SS      | 00, 01, ..., 99                   |       |
 * |                                 | SSS     | 000, 001, ..., 999                |       |
 * |                                 | SSSS    | ...                               | 3     |
 * | Timezone (ISO-8601 w/ Z)        | X       | -08, +0530, Z                     |       |
 * |                                 | XX      | -0800, +0530, Z                   |       |
 * |                                 | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       | x       | -08, +0530, +00                   |       |
 * |                                 | xx      | -0800, +0530, +0000               |       |
 * |                                 | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Timezone (GMT)                  | O...OOO | GMT-8, GMT+5:30, GMT+0            |       |
 * |                                 | OOOO    | GMT-08:00, GMT+05:30, GMT+00:00   | 2     |
 * | Timezone (specific non-locat.)  | z...zzz | GMT-8, GMT+5:30, GMT+0            | 6     |
 * |                                 | zzzz    | GMT-08:00, GMT+05:30, GMT+00:00   | 2,6   |
 * | Seconds timestamp               | t       | 512969520                         | 7     |
 * |                                 | tt      | ...                               | 3,7   |
 * | Milliseconds timestamp          | T       | 512969520900                      | 7     |
 * |                                 | TT      | ...                               | 3,7   |
 * | Long localized date             | P       | 04/29/1453                        | 7     |
 * |                                 | PP      | Apr 29, 1453                      | 7     |
 * |                                 | PPP     | April 29th, 1453                  | 7     |
 * |                                 | PPPP    | Friday, April 29th, 1453          | 2,7   |
 * | Long localized time             | p       | 12:00 AM                          | 7     |
 * |                                 | pp      | 12:00:00 AM                       | 7     |
 * |                                 | ppp     | 12:00:00 AM GMT+2                 | 7     |
 * |                                 | pppp    | 12:00:00 AM GMT+02:00             | 2,7   |
 * | Combination of date and time    | Pp      | 04/29/1453, 12:00 AM              | 7     |
 * |                                 | PPpp    | Apr 29, 1453, 12:00:00 AM         | 7     |
 * |                                 | PPPppp  | April 29th, 1453 at ...           | 7     |
 * |                                 | PPPPpppp| Friday, April 29th, 1453 at ...   | 2,7   |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table (e.g. `EEEEEEEEEEE`)
 *    the output will be the same as default pattern for this unit, usually
 *    the longest one (in case of ISO weekdays, `EEEE`). Default patterns for units
 *    are marked with "2" in the last column of the table.
 *
 *    `format(new Date(2017, 10, 6), 'MMM') //=> 'Nov'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMM') //=> 'N'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMM') //=> 'November'`
 *
 *    `format(new Date(2017, 10, 6), 'MMMMMMM') //=> 'November'`
 *
 * 3. Some patterns could be unlimited length (such as `yyyyyyyy`).
 *    The output will be padded with zeros to match the length of the pattern.
 *
 *    `format(new Date(2017, 10, 6), 'yyyyyyyy') //=> '00002017'`
 *
 * 4. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 5. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` always returns the last two digits of a year,
 *    while `uu` pads single digit years to 2 characters and returns other years unchanged:
 *
 *    | Year | `yy` | `uu` |
 *    |------|------|------|
 *    | 1    |   01 |   01 |
 *    | 14   |   14 |   14 |
 *    | 376  |   76 |  376 |
 *    | 1453 |   53 | 1453 |
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [getISOWeekYear]{@link https://date-fns.org/docs/getISOWeekYear}
 *    and [getWeekYear]{@link https://date-fns.org/docs/getWeekYear}).
 *
 * 6. Specific non-location timezones are currently unavailable in `date-fns`,
 *    so right now these tokens fall back to GMT timezones.
 *
 * 7. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `t`: seconds timestamp
 *    - `T`: milliseconds timestamp
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 8. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 9. `D` and `DD` tokens represent days of the year but they are often confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * @param {Date|Number} date - the original date
 * @param {String} format - the string of tokens
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {Number} [options.firstWeekContainsDate=1] - the day of January, which is
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {String} the formatted date string
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `date` must not be Invalid Date
 * @throws {RangeError} `options.locale` must contain `localize` property
 * @throws {RangeError} `options.locale` must contain `formatLong` property
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Represent 11 February 2014 in middle-endian format:
 * const result = format(new Date(2014, 1, 11), 'MM/dd/yyyy')
 * //=> '02/11/2014'
 *
 * @example
 * // Represent 2 July 2014 in Esperanto:
 * import { eoLocale } from 'date-fns/locale/eo'
 * const result = format(new Date(2014, 6, 2), "do 'de' MMMM yyyy", {
 *   locale: eoLocale
 * })
 * //=> '2-a de julio 2014'
 *
 * @example
 * // Escape string by single quote characters:
 * const result = format(new Date(2014, 6, 2, 15), "h 'o''clock'")
 * //=> "3 o'clock"
 */

function format(dirtyDate, dirtyFormatStr, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(2, arguments);
  var formatStr = String(dirtyFormatStr);
  var defaultOptions = getDefaultOptions();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale;
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (!locale.localize) {
    throw new RangeError('locale must contain localize property');
  }
  if (!locale.formatLong) {
    throw new RangeError('locale must contain formatLong property');
  }
  var originalDate = toDate(dirtyDate);
  if (!isValid$1(originalDate)) {
    throw new RangeError('Invalid time value');
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  // This ensures that when UTC functions will be implemented, locales will be compatible with them.
  // See an issue about UTC functions: https://github.com/date-fns/date-fns/issues/376
  var timezoneOffset = getTimezoneOffsetInMilliseconds(originalDate);
  var utcDate = subMilliseconds(originalDate, timezoneOffset);
  var formatterOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale,
    _originalDate: originalDate
  };
  var result = formatStr.match(longFormattingTokensRegExp$1).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter === 'p' || firstCharacter === 'P') {
      var longFormatter = longFormatters$1[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp$1).map(function (substring) {
    // Replace two single quote characters with one single quote character
    if (substring === "''") {
      return "'";
    }
    var firstCharacter = substring[0];
    if (firstCharacter === "'") {
      return cleanEscapedString$1(substring);
    }
    var formatter = formatters$1[firstCharacter];
    if (formatter) {
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(substring)) {
        throwProtectedError(substring, dirtyFormatStr, String(dirtyDate));
      }
      return formatter(utcDate, substring, locale.localize, formatterOptions);
    }
    if (firstCharacter.match(unescapedLatinCharacterRegExp$1)) {
      throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
    }
    return substring;
  }).join('');
  return result;
}
function cleanEscapedString$1(input) {
  var matched = input.match(escapedStringRegExp$1);
  if (!matched) {
    return input;
  }
  return matched[1].replace(doubleQuoteRegExp$1, "'");
}

var MILLISECONDS_IN_MINUTE = 60000;

/**
 * @name addMinutes
 * @category Minute Helpers
 * @summary Add the specified number of minutes to the given date.
 *
 * @description
 * Add the specified number of minutes to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of minutes to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the minutes added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 30 minutes to 10 July 2014 12:00:00:
 * const result = addMinutes(new Date(2014, 6, 10, 12, 0), 30)
 * //=> Thu Jul 10 2014 12:30:00
 */
function addMinutes(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_MINUTE);
}

var MILLISECONDS_IN_HOUR = 3600000;

/**
 * @name addHours
 * @category Hour Helpers
 * @summary Add the specified number of hours to the given date.
 *
 * @description
 * Add the specified number of hours to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of hours to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the hours added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 2 hours to 10 July 2014 23:00:00:
 * const result = addHours(new Date(2014, 6, 10, 23, 0), 2)
 * //=> Fri Jul 11 2014 01:00:00
 */
function addHours(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMilliseconds(dirtyDate, amount * MILLISECONDS_IN_HOUR);
}

/**
 * @name addDays
 * @category Day Helpers
 * @summary Add the specified number of days to the given date.
 *
 * @description
 * Add the specified number of days to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} - the new date with the days added
 * @throws {TypeError} - 2 arguments required
 *
 * @example
 * // Add 10 days to 1 September 2014:
 * const result = addDays(new Date(2014, 8, 1), 10)
 * //=> Thu Sep 11 2014 00:00:00
 */
function addDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    // If 0 days, no-op to avoid changing times in the hour before end of DST
    return date;
  }
  date.setDate(date.getDate() + amount);
  return date;
}

/**
 * @name addWeeks
 * @category Week Helpers
 * @summary Add the specified number of weeks to the given date.
 *
 * @description
 * Add the specified number of week to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 4 weeks to 1 September 2014:
 * const result = addWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Sep 29 2014 00:00:00
 */
function addWeeks(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  var days = amount * 7;
  return addDays(dirtyDate, days);
}

/**
 * @name addMonths
 * @category Month Helpers
 * @summary Add the specified number of months to the given date.
 *
 * @description
 * Add the specified number of months to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 months to 1 September 2014:
 * const result = addMonths(new Date(2014, 8, 1), 5)
 * //=> Sun Feb 01 2015 00:00:00
 */
function addMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var amount = toInteger(dirtyAmount);
  if (isNaN(amount)) {
    return new Date(NaN);
  }
  if (!amount) {
    // If 0 months, no-op to avoid changing times in the hour before end of DST
    return date;
  }
  var dayOfMonth = date.getDate();

  // The JS Date object supports date math by accepting out-of-bounds values for
  // month, day, etc. For example, new Date(2020, 0, 0) returns 31 Dec 2019 and
  // new Date(2020, 13, 1) returns 1 Feb 2021.  This is *almost* the behavior we
  // want except that dates will wrap around the end of a month, meaning that
  // new Date(2020, 13, 31) will return 3 Mar 2021 not 28 Feb 2021 as desired. So
  // we'll default to the end of the desired month by adding 1 to the desired
  // month and using a date of 0 to back up one day to the end of the desired
  // month.
  var endOfDesiredMonth = new Date(date.getTime());
  endOfDesiredMonth.setMonth(date.getMonth() + amount + 1, 0);
  var daysInMonth = endOfDesiredMonth.getDate();
  if (dayOfMonth >= daysInMonth) {
    // If we're already at the end of the month, then this is the correct date
    // and we're done.
    return endOfDesiredMonth;
  } else {
    // Otherwise, we now know that setting the original day-of-month value won't
    // cause an overflow, so set the desired day-of-month. Note that we can't
    // just set the date of `endOfDesiredMonth` because that object may have had
    // its time changed in the unusual case where where a DST transition was on
    // the last day of the month and its local time was in the hour skipped or
    // repeated next to a DST transition.  So we use `date` instead which is
    // guaranteed to still have the original time.
    date.setFullYear(endOfDesiredMonth.getFullYear(), endOfDesiredMonth.getMonth(), dayOfMonth);
    return date;
  }
}

/**
 * @name addQuarters
 * @category Quarter Helpers
 * @summary Add the specified number of year quarters to the given date.
 *
 * @description
 * Add the specified number of year quarters to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the quarters added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 1 quarter to 1 September 2014:
 * const result = addQuarters(new Date(2014, 8, 1), 1)
 * //=> Mon Dec 01 2014 00:00:00
 */
function addQuarters(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  var months = amount * 3;
  return addMonths(dirtyDate, months);
}

/**
 * @name addYears
 * @category Year Helpers
 * @summary Add the specified number of years to the given date.
 *
 * @description
 * Add the specified number of years to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be added. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years added
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Add 5 years to 1 September 2014:
 * const result = addYears(new Date(2014, 8, 1), 5)
 * //=> Sun Sep 01 2019 00:00:00
 */
function addYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, amount * 12);
}

/**
 * @name subDays
 * @category Day Helpers
 * @summary Subtract the specified number of days from the given date.
 *
 * @description
 * Subtract the specified number of days from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of days to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the days subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 10 days from 1 September 2014:
 * const result = subDays(new Date(2014, 8, 1), 10)
 * //=> Fri Aug 22 2014 00:00:00
 */
function subDays(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addDays(dirtyDate, -amount);
}

/**
 * @name subWeeks
 * @category Week Helpers
 * @summary Subtract the specified number of weeks from the given date.
 *
 * @description
 * Subtract the specified number of weeks from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of weeks to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the weeks subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 4 weeks from 1 September 2014:
 * const result = subWeeks(new Date(2014, 8, 1), 4)
 * //=> Mon Aug 04 2014 00:00:00
 */
function subWeeks(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addWeeks(dirtyDate, -amount);
}

/**
 * @name subMonths
 * @category Month Helpers
 * @summary Subtract the specified number of months from the given date.
 *
 * @description
 * Subtract the specified number of months from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of months to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the months subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 months from 1 February 2015:
 * const result = subMonths(new Date(2015, 1, 1), 5)
 * //=> Mon Sep 01 2014 00:00:00
 */
function subMonths(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addMonths(dirtyDate, -amount);
}

/**
 * @name subQuarters
 * @category Quarter Helpers
 * @summary Subtract the specified number of year quarters from the given date.
 *
 * @description
 * Subtract the specified number of year quarters from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of quarters to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the quarters subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 3 quarters from 1 September 2014:
 * const result = subQuarters(new Date(2014, 8, 1), 3)
 * //=> Sun Dec 01 2013 00:00:00
 */
function subQuarters(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addQuarters(dirtyDate, -amount);
}

/**
 * @name subYears
 * @category Year Helpers
 * @summary Subtract the specified number of years from the given date.
 *
 * @description
 * Subtract the specified number of years from the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} amount - the amount of years to be subtracted. Positive decimals will be rounded using `Math.floor`, decimals less than zero will be rounded using `Math.ceil`.
 * @returns {Date} the new date with the years subtracted
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Subtract 5 years from 1 September 2014:
 * const result = subYears(new Date(2014, 8, 1), 5)
 * //=> Tue Sep 01 2009 00:00:00
 */
function subYears(dirtyDate, dirtyAmount) {
  requiredArgs(2, arguments);
  var amount = toInteger(dirtyAmount);
  return addYears(dirtyDate, -amount);
}

/**
 * @name getSeconds
 * @category Second Helpers
 * @summary Get the seconds of the given date.
 *
 * @description
 * Get the seconds of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the seconds
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the seconds of 29 February 2012 11:45:05.123:
 * const result = getSeconds(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 5
 */
function getSeconds(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var seconds = date.getSeconds();
  return seconds;
}

/**
 * @name getMinutes
 * @category Minute Helpers
 * @summary Get the minutes of the given date.
 *
 * @description
 * Get the minutes of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the minutes
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the minutes of 29 February 2012 11:45:05:
 * const result = getMinutes(new Date(2012, 1, 29, 11, 45, 5))
 * //=> 45
 */
function getMinutes(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var minutes = date.getMinutes();
  return minutes;
}

/**
 * @name getHours
 * @category Hour Helpers
 * @summary Get the hours of the given date.
 *
 * @description
 * Get the hours of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the hours
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the hours of 29 February 2012 11:45:00:
 * const result = getHours(new Date(2012, 1, 29, 11, 45))
 * //=> 11
 */
function getHours(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var hours = date.getHours();
  return hours;
}

/**
 * @name getDay
 * @category Weekday Helpers
 * @summary Get the day of the week of the given date.
 *
 * @description
 * Get the day of the week of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {0|1|2|3|4|5|6} the day of week, 0 represents Sunday
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the week is 29 February 2012?
 * const result = getDay(new Date(2012, 1, 29))
 * //=> 3
 */
function getDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var day = date.getDay();
  return day;
}

/**
 * @name getDate
 * @category Day Helpers
 * @summary Get the day of the month of the given date.
 *
 * @description
 * Get the day of the month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the day of month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which day of the month is 29 February 2012?
 * const result = getDate(new Date(2012, 1, 29))
 * //=> 29
 */
function getDate(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var dayOfMonth = date.getDate();
  return dayOfMonth;
}

/**
 * @name startOfWeek
 * @category Week Helpers
 * @summary Return the start of a week for the given date.
 *
 * @description
 * Return the start of a week for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @returns {Date} the start of a week
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 *
 * @example
 * // The start of a week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Sun Aug 31 2014 00:00:00
 *
 * @example
 * // If the week starts on Monday, the start of the week for 2 September 2014 11:55:00:
 * const result = startOfWeek(new Date(2014, 8, 2, 11, 55, 0), { weekStartsOn: 1 })
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfWeek(dirtyDate, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(1, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate(dirtyDate);
  var day = date.getDay();
  var diff = (day < weekStartsOn ? 7 : 0) + day - weekStartsOn;
  date.setDate(date.getDate() - diff);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name startOfISOWeek
 * @category ISO Week Helpers
 * @summary Return the start of an ISO week for the given date.
 *
 * @description
 * Return the start of an ISO week for the given date.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week for 2 September 2014 11:55:00:
 * const result = startOfISOWeek(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  return startOfWeek(dirtyDate, {
    weekStartsOn: 1
  });
}

/**
 * @name getISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Get the ISO week-numbering year of the given date.
 *
 * @description
 * Get the ISO week-numbering year of the given date,
 * which always starts 3 days before the year's first Thursday.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which ISO-week numbering year is 2 January 2005?
 * const result = getISOWeekYear(new Date(2005, 0, 2))
 * //=> 2004
 */
function getISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  var fourthOfJanuaryOfNextYear = new Date(0);
  fourthOfJanuaryOfNextYear.setFullYear(year + 1, 0, 4);
  fourthOfJanuaryOfNextYear.setHours(0, 0, 0, 0);
  var startOfNextYear = startOfISOWeek(fourthOfJanuaryOfNextYear);
  var fourthOfJanuaryOfThisYear = new Date(0);
  fourthOfJanuaryOfThisYear.setFullYear(year, 0, 4);
  fourthOfJanuaryOfThisYear.setHours(0, 0, 0, 0);
  var startOfThisYear = startOfISOWeek(fourthOfJanuaryOfThisYear);
  if (date.getTime() >= startOfNextYear.getTime()) {
    return year + 1;
  } else if (date.getTime() >= startOfThisYear.getTime()) {
    return year;
  } else {
    return year - 1;
  }
}

/**
 * @name startOfISOWeekYear
 * @category ISO Week-Numbering Year Helpers
 * @summary Return the start of an ISO week-numbering year for the given date.
 *
 * @description
 * Return the start of an ISO week-numbering year,
 * which always starts 3 days before the year's first Thursday.
 * The result will be in the local timezone.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of an ISO week-numbering year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of an ISO week-numbering year for 2 July 2005:
 * const result = startOfISOWeekYear(new Date(2005, 6, 2))
 * //=> Mon Jan 03 2005 00:00:00
 */
function startOfISOWeekYear(dirtyDate) {
  requiredArgs(1, arguments);
  var year = getISOWeekYear(dirtyDate);
  var fourthOfJanuary = new Date(0);
  fourthOfJanuary.setFullYear(year, 0, 4);
  fourthOfJanuary.setHours(0, 0, 0, 0);
  var date = startOfISOWeek(fourthOfJanuary);
  return date;
}

var MILLISECONDS_IN_WEEK = 604800000;

/**
 * @name getISOWeek
 * @category ISO Week Helpers
 * @summary Get the ISO week of the given date.
 *
 * @description
 * Get the ISO week of the given date.
 *
 * ISO week-numbering year: http://en.wikipedia.org/wiki/ISO_week_date
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the ISO week
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which week of the ISO-week numbering year is 2 January 2005?
 * const result = getISOWeek(new Date(2005, 0, 2))
 * //=> 53
 */
function getISOWeek(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var diff = startOfISOWeek(date).getTime() - startOfISOWeekYear(date).getTime();

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a week is not constant
  // (e.g. it's different in the week of the daylight saving time clock shift)
  return Math.round(diff / MILLISECONDS_IN_WEEK) + 1;
}

/**
 * @name getMonth
 * @category Month Helpers
 * @summary Get the month of the given date.
 *
 * @description
 * Get the month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which month is 29 February 2012?
 * const result = getMonth(new Date(2012, 1, 29))
 * //=> 1
 */
function getMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var month = date.getMonth();
  return month;
}

/**
 * @name getQuarter
 * @category Quarter Helpers
 * @summary Get the year quarter of the given date.
 *
 * @description
 * Get the year quarter of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which quarter is 2 July 2014?
 * const result = getQuarter(new Date(2014, 6, 2))
 * //=> 3
 */
function getQuarter(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var quarter = Math.floor(date.getMonth() / 3) + 1;
  return quarter;
}

/**
 * @name getYear
 * @category Year Helpers
 * @summary Get the year of the given date.
 *
 * @description
 * Get the year of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which year is 2 July 2014?
 * const result = getYear(new Date(2014, 6, 2))
 * //=> 2014
 */
function getYear(dirtyDate) {
  requiredArgs(1, arguments);
  return toDate(dirtyDate).getFullYear();
}

/**
 * @name getTime
 * @category Timestamp Helpers
 * @summary Get the milliseconds timestamp of the given date.
 *
 * @description
 * Get the milliseconds timestamp of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the timestamp
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Get the timestamp of 29 February 2012 11:45:05.123:
 * const result = getTime(new Date(2012, 1, 29, 11, 45, 5, 123))
 * //=> 1330515905123
 */
function getTime(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var timestamp = date.getTime();
  return timestamp;
}

/**
 * @name setSeconds
 * @category Second Helpers
 * @summary Set the seconds to the given date.
 *
 * @description
 * Set the seconds to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} seconds - the seconds of the new date
 * @returns {Date} the new date with the seconds set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 seconds to 1 September 2014 11:30:40:
 * const result = setSeconds(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:30:45
 */
function setSeconds(dirtyDate, dirtySeconds) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var seconds = toInteger(dirtySeconds);
  date.setSeconds(seconds);
  return date;
}

/**
 * @name setMinutes
 * @category Minute Helpers
 * @summary Set the minutes to the given date.
 *
 * @description
 * Set the minutes to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} minutes - the minutes of the new date
 * @returns {Date} the new date with the minutes set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 45 minutes to 1 September 2014 11:30:40:
 * const result = setMinutes(new Date(2014, 8, 1, 11, 30, 40), 45)
 * //=> Mon Sep 01 2014 11:45:40
 */
function setMinutes(dirtyDate, dirtyMinutes) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var minutes = toInteger(dirtyMinutes);
  date.setMinutes(minutes);
  return date;
}

/**
 * @name setHours
 * @category Hour Helpers
 * @summary Set the hours to the given date.
 *
 * @description
 * Set the hours to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} hours - the hours of the new date
 * @returns {Date} the new date with the hours set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set 4 hours to 1 September 2014 11:30:00:
 * const result = setHours(new Date(2014, 8, 1, 11, 30), 4)
 * //=> Mon Sep 01 2014 04:30:00
 */
function setHours(dirtyDate, dirtyHours) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var hours = toInteger(dirtyHours);
  date.setHours(hours);
  return date;
}

/**
 * @name getDaysInMonth
 * @category Month Helpers
 * @summary Get the number of days in a month of the given date.
 *
 * @description
 * Get the number of days in a month of the given date.
 *
 * @param {Date|Number} date - the given date
 * @returns {Number} the number of days in a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // How many days are in February 2000?
 * const result = getDaysInMonth(new Date(2000, 1))
 * //=> 29
 */
function getDaysInMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  var monthIndex = date.getMonth();
  var lastDayOfMonth = new Date(0);
  lastDayOfMonth.setFullYear(year, monthIndex + 1, 0);
  lastDayOfMonth.setHours(0, 0, 0, 0);
  return lastDayOfMonth.getDate();
}

/**
 * @name setMonth
 * @category Month Helpers
 * @summary Set the month to the given date.
 *
 * @description
 * Set the month to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} month - the month of the new date
 * @returns {Date} the new date with the month set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set February to 1 September 2014:
 * const result = setMonth(new Date(2014, 8, 1), 1)
 * //=> Sat Feb 01 2014 00:00:00
 */
function setMonth(dirtyDate, dirtyMonth) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var month = toInteger(dirtyMonth);
  var year = date.getFullYear();
  var day = date.getDate();
  var dateWithDesiredMonth = new Date(0);
  dateWithDesiredMonth.setFullYear(year, month, 15);
  dateWithDesiredMonth.setHours(0, 0, 0, 0);
  var daysInMonth = getDaysInMonth(dateWithDesiredMonth);
  // Set the last day of the new month
  // if the original date was the last day of the longer month
  date.setMonth(month, Math.min(day, daysInMonth));
  return date;
}

/**
 * @name setQuarter
 * @category Quarter Helpers
 * @summary Set the year quarter to the given date.
 *
 * @description
 * Set the year quarter to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} quarter - the quarter of the new date
 * @returns {Date} the new date with the quarter set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set the 2nd quarter to 2 July 2014:
 * const result = setQuarter(new Date(2014, 6, 2), 2)
 * //=> Wed Apr 02 2014 00:00:00
 */
function setQuarter(dirtyDate, dirtyQuarter) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var quarter = toInteger(dirtyQuarter);
  var oldQuarter = Math.floor(date.getMonth() / 3) + 1;
  var diff = quarter - oldQuarter;
  return setMonth(date, date.getMonth() + diff * 3);
}

/**
 * @name setYear
 * @category Year Helpers
 * @summary Set the year to the given date.
 *
 * @description
 * Set the year to the given date.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Number} year - the year of the new date
 * @returns {Date} the new date with the year set
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Set year 2013 to 1 September 2014:
 * const result = setYear(new Date(2014, 8, 1), 2013)
 * //=> Sun Sep 01 2013 00:00:00
 */
function setYear(dirtyDate, dirtyYear) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var year = toInteger(dirtyYear);

  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }
  date.setFullYear(year);
  return date;
}

/**
 * @name min
 * @category Common Helpers
 * @summary Returns the earliest of the given dates.
 *
 * @description
 * Returns the earliest of the given dates.
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} - the earliest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the earliest?
 * const result = min([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Wed Feb 11 1987 00:00:00
 */
function min$1(dirtyDatesArray) {
  requiredArgs(1, arguments);
  var datesArray;
  // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray;
    // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if (_typeof(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }
  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = toDate(dirtyDate);
    if (result === undefined || result > currentDate || isNaN(currentDate.getDate())) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}

/**
 * @name max
 * @category Common Helpers
 * @summary Return the latest of the given dates.
 *
 * @description
 * Return the latest of the given dates.
 *
 * @param {Date[]|Number[]} datesArray - the dates to compare
 * @returns {Date} the latest of the dates
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // Which of these dates is the latest?
 * const result = max([
 *   new Date(1989, 6, 10),
 *   new Date(1987, 1, 11),
 *   new Date(1995, 6, 2),
 *   new Date(1990, 0, 1)
 * ])
 * //=> Sun Jul 02 1995 00:00:00
 */
function max$1(dirtyDatesArray) {
  requiredArgs(1, arguments);
  var datesArray;
  // `dirtyDatesArray` is Array, Set or Map, or object with custom `forEach` method
  if (dirtyDatesArray && typeof dirtyDatesArray.forEach === 'function') {
    datesArray = dirtyDatesArray;

    // If `dirtyDatesArray` is Array-like Object, convert to Array.
  } else if (_typeof(dirtyDatesArray) === 'object' && dirtyDatesArray !== null) {
    datesArray = Array.prototype.slice.call(dirtyDatesArray);
  } else {
    // `dirtyDatesArray` is non-iterable, return Invalid Date
    return new Date(NaN);
  }
  var result;
  datesArray.forEach(function (dirtyDate) {
    var currentDate = toDate(dirtyDate);
    if (result === undefined || result < currentDate || isNaN(Number(currentDate))) {
      result = currentDate;
    }
  });
  return result || new Date(NaN);
}

/**
 * @name startOfDay
 * @category Day Helpers
 * @summary Return the start of a day for the given date.
 *
 * @description
 * Return the start of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a day for 2 September 2014 11:55:00:
 * const result = startOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 00:00:00
 */
function startOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(0, 0, 0, 0);
  return date;
}

var MILLISECONDS_IN_DAY = 86400000;

/**
 * @name differenceInCalendarDays
 * @category Day Helpers
 * @summary Get the number of calendar days between the given dates.
 *
 * @description
 * Get the number of calendar days between the given dates. This means that the times are removed
 * from the dates and then the difference in days is calculated.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar days
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar days are between
 * // 2 July 2011 23:00:00 and 2 July 2012 00:00:00?
 * const result = differenceInCalendarDays(
 *   new Date(2012, 6, 2, 0, 0),
 *   new Date(2011, 6, 2, 23, 0)
 * )
 * //=> 366
 * // How many calendar days are between
 * // 2 July 2011 23:59:00 and 3 July 2011 00:01:00?
 * const result = differenceInCalendarDays(
 *   new Date(2011, 6, 3, 0, 1),
 *   new Date(2011, 6, 2, 23, 59)
 * )
 * //=> 1
 */
function differenceInCalendarDays(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var startOfDayLeft = startOfDay(dirtyDateLeft);
  var startOfDayRight = startOfDay(dirtyDateRight);
  var timestampLeft = startOfDayLeft.getTime() - getTimezoneOffsetInMilliseconds(startOfDayLeft);
  var timestampRight = startOfDayRight.getTime() - getTimezoneOffsetInMilliseconds(startOfDayRight);

  // Round the number of days to the nearest integer
  // because the number of milliseconds in a day is not constant
  // (e.g. it's different in the day of the daylight saving time clock shift)
  return Math.round((timestampLeft - timestampRight) / MILLISECONDS_IN_DAY);
}

/**
 * @name differenceInCalendarMonths
 * @category Month Helpers
 * @summary Get the number of calendar months between the given dates.
 *
 * @description
 * Get the number of calendar months between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar months
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar months are between 31 January 2014 and 1 September 2014?
 * const result = differenceInCalendarMonths(
 *   new Date(2014, 8, 1),
 *   new Date(2014, 0, 31)
 * )
 * //=> 8
 */
function differenceInCalendarMonths(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  var yearDiff = dateLeft.getFullYear() - dateRight.getFullYear();
  var monthDiff = dateLeft.getMonth() - dateRight.getMonth();
  return yearDiff * 12 + monthDiff;
}

/**
 * @name differenceInCalendarYears
 * @category Year Helpers
 * @summary Get the number of calendar years between the given dates.
 *
 * @description
 * Get the number of calendar years between the given dates.
 *
 * @param {Date|Number} dateLeft - the later date
 * @param {Date|Number} dateRight - the earlier date
 * @returns {Number} the number of calendar years
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // How many calendar years are between 31 December 2013 and 11 February 2015?
 * const result = differenceInCalendarYears(
 *   new Date(2015, 1, 11),
 *   new Date(2013, 11, 31)
 * )
 * //=> 2
 */
function differenceInCalendarYears(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() - dateRight.getFullYear();
}

/**
 * @name startOfMonth
 * @category Month Helpers
 * @summary Return the start of a month for the given date.
 *
 * @description
 * Return the start of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a month for 2 September 2014 11:55:00:
 * const result = startOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Mon Sep 01 2014 00:00:00
 */
function startOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setDate(1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name startOfQuarter
 * @category Quarter Helpers
 * @summary Return the start of a year quarter for the given date.
 *
 * @description
 * Return the start of a year quarter for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a quarter
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a quarter for 2 September 2014 11:55:00:
 * const result = startOfQuarter(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Jul 01 2014 00:00:00
 */
function startOfQuarter(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var currentMonth = date.getMonth();
  var month = currentMonth - currentMonth % 3;
  date.setMonth(month, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name startOfYear
 * @category Year Helpers
 * @summary Return the start of a year for the given date.
 *
 * @description
 * Return the start of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the start of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The start of a year for 2 September 2014 11:55:00:
 * const result = startOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Jan 01 2014 00:00:00
 */
function startOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var cleanDate = toDate(dirtyDate);
  var date = new Date(0);
  date.setFullYear(cleanDate.getFullYear(), 0, 1);
  date.setHours(0, 0, 0, 0);
  return date;
}

/**
 * @name endOfDay
 * @category Day Helpers
 * @summary Return the end of a day for the given date.
 *
 * @description
 * Return the end of a day for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a day
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a day for 2 September 2014 11:55:00:
 * const result = endOfDay(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 02 2014 23:59:59.999
 */
function endOfDay(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name endOfMonth
 * @category Month Helpers
 * @summary Return the end of a month for the given date.
 *
 * @description
 * Return the end of a month for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a month
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a month for 2 September 2014 11:55:00:
 * const result = endOfMonth(new Date(2014, 8, 2, 11, 55, 0))
 * //=> Tue Sep 30 2014 23:59:59.999
 */
function endOfMonth(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var month = date.getMonth();
  date.setFullYear(date.getFullYear(), month + 1, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name endOfYear
 * @category Year Helpers
 * @summary Return the end of a year for the given date.
 *
 * @description
 * Return the end of a year for the given date.
 * The result will be in the local timezone.
 *
 * @param {Date|Number} date - the original date
 * @returns {Date} the end of a year
 * @throws {TypeError} 1 argument required
 *
 * @example
 * // The end of a year for 2 September 2014 11:55:00:
 * const result = endOfYear(new Date(2014, 8, 2, 11, 55, 00))
 * //=> Wed Dec 31 2014 23:59:59.999
 */
function endOfYear(dirtyDate) {
  requiredArgs(1, arguments);
  var date = toDate(dirtyDate);
  var year = date.getFullYear();
  date.setFullYear(year + 1, 0, 0);
  date.setHours(23, 59, 59, 999);
  return date;
}

/**
 * @name isEqual
 * @category Common Helpers
 * @summary Are the given dates equal?
 *
 * @description
 * Are the given dates equal?
 *
 * @param {Date|Number} dateLeft - the first date to compare
 * @param {Date|Number} dateRight - the second date to compare
 * @returns {Boolean} the dates are equal
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 July 2014 06:30:45.000 and 2 July 2014 06:30:45.500 equal?
 * const result = isEqual(
 *   new Date(2014, 6, 2, 6, 30, 45, 0),
 *   new Date(2014, 6, 2, 6, 30, 45, 500)
 * )
 * //=> false
 */
function isEqual(dirtyLeftDate, dirtyRightDate) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyLeftDate);
  var dateRight = toDate(dirtyRightDate);
  return dateLeft.getTime() === dateRight.getTime();
}

/**
 * @name isSameDay
 * @category Day Helpers
 * @summary Are the given dates in the same day (and year and month)?
 *
 * @description
 * Are the given dates in the same day (and year and month)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same day (and year and month)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 4 September 06:00:00 and 4 September 18:00:00 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4, 6, 0), new Date(2014, 8, 4, 18, 0))
 * //=> true
 *
 * @example
 * // Are 4 September and 4 October in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2014, 9, 4))
 * //=> false
 *
 * @example
 * // Are 4 September, 2014 and 4 September, 2015 in the same day?
 * const result = isSameDay(new Date(2014, 8, 4), new Date(2015, 8, 4))
 * //=> false
 */
function isSameDay(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfDay = startOfDay(dirtyDateLeft);
  var dateRightStartOfDay = startOfDay(dirtyDateRight);
  return dateLeftStartOfDay.getTime() === dateRightStartOfDay.getTime();
}

/**
 * @name isSameMonth
 * @category Month Helpers
 * @summary Are the given dates in the same month (and year)?
 *
 * @description
 * Are the given dates in the same month (and year)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same month (and year)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 *
 * @example
 * // Are 2 September 2014 and 25 September 2015 in the same month?
 * const result = isSameMonth(new Date(2014, 8, 2), new Date(2015, 8, 25))
 * //=> false
 */
function isSameMonth(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear() && dateLeft.getMonth() === dateRight.getMonth();
}

/**
 * @name isSameYear
 * @category Year Helpers
 * @summary Are the given dates in the same year?
 *
 * @description
 * Are the given dates in the same year?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same year
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 2 September 2014 and 25 September 2014 in the same year?
 * const result = isSameYear(new Date(2014, 8, 2), new Date(2014, 8, 25))
 * //=> true
 */
function isSameYear(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeft = toDate(dirtyDateLeft);
  var dateRight = toDate(dirtyDateRight);
  return dateLeft.getFullYear() === dateRight.getFullYear();
}

/**
 * @name isSameQuarter
 * @category Quarter Helpers
 * @summary Are the given dates in the same quarter (and year)?
 *
 * @description
 * Are the given dates in the same quarter (and year)?
 *
 * @param {Date|Number} dateLeft - the first date to check
 * @param {Date|Number} dateRight - the second date to check
 * @returns {Boolean} the dates are in the same quarter (and year)
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Are 1 January 2014 and 8 March 2014 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2014, 2, 8))
 * //=> true
 *
 * @example
 * // Are 1 January 2014 and 1 January 2015 in the same quarter?
 * const result = isSameQuarter(new Date(2014, 0, 1), new Date(2015, 0, 1))
 * //=> false
 */
function isSameQuarter(dirtyDateLeft, dirtyDateRight) {
  requiredArgs(2, arguments);
  var dateLeftStartOfQuarter = startOfQuarter(dirtyDateLeft);
  var dateRightStartOfQuarter = startOfQuarter(dirtyDateRight);
  return dateLeftStartOfQuarter.getTime() === dateRightStartOfQuarter.getTime();
}

/**
 * @name isAfter
 * @category Common Helpers
 * @summary Is the first date after the second one?
 *
 * @description
 * Is the first date after the second one?
 *
 * @param {Date|Number} date - the date that should be after the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is after the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 after 11 February 1987?
 * const result = isAfter(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> true
 */
function isAfter(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() > dateToCompare.getTime();
}

/**
 * @name isBefore
 * @category Common Helpers
 * @summary Is the first date before the second one?
 *
 * @description
 * Is the first date before the second one?
 *
 * @param {Date|Number} date - the date that should be before the other one to return true
 * @param {Date|Number} dateToCompare - the date to compare with
 * @returns {Boolean} the first date is before the second date
 * @throws {TypeError} 2 arguments required
 *
 * @example
 * // Is 10 July 1989 before 11 February 1987?
 * const result = isBefore(new Date(1989, 6, 10), new Date(1987, 1, 11))
 * //=> false
 */
function isBefore(dirtyDate, dirtyDateToCompare) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var dateToCompare = toDate(dirtyDateToCompare);
  return date.getTime() < dateToCompare.getTime();
}

/**
 * @name isWithinInterval
 * @category Interval Helpers
 * @summary Is the given date within the interval?
 *
 * @description
 * Is the given date within the interval? (Including start and end.)
 *
 * @param {Date|Number} date - the date to check
 * @param {Interval} interval - the interval to check
 * @returns {Boolean} the date is within the interval
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} The start of an interval cannot be after its end
 * @throws {RangeError} Date in interval cannot be `Invalid Date`
 *
 * @example
 * // For the date within the interval:
 * isWithinInterval(new Date(2014, 0, 3), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> true
 *
 * @example
 * // For the date outside of the interval:
 * isWithinInterval(new Date(2014, 0, 10), {
 *   start: new Date(2014, 0, 1),
 *   end: new Date(2014, 0, 7)
 * })
 * //=> false
 *
 * @example
 * // For date equal to interval start:
 * isWithinInterval(date, { start, end: date }) // => true
 *
 * @example
 * // For date equal to interval end:
 * isWithinInterval(date, { start: date, end }) // => true
 */
function isWithinInterval(dirtyDate, interval) {
  requiredArgs(2, arguments);
  var time = toDate(dirtyDate).getTime();
  var startTime = toDate(interval.start).getTime();
  var endTime = toDate(interval.end).getTime();

  // Throw an exception if start date is after end date or if any date is `Invalid Date`
  if (!(startTime <= endTime)) {
    throw new RangeError('Invalid interval');
  }
  return time >= startTime && time <= endTime;
}

function _arrayLikeToArray$2(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}

function _unsupportedIterableToArray$2(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray$2(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray$2(r, a) : void 0;
  }
}

function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray$2(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}

function assign(target, object) {
  if (target == null) {
    throw new TypeError('assign requires that input parameter not be null or undefined');
  }
  for (var property in object) {
    if (Object.prototype.hasOwnProperty.call(object, property)) {
      target[property] = object[property];
    }
  }
  return target;
}

function _inherits(t, e) {
  if ("function" != typeof e && null !== e) throw new TypeError("Super expression must either be null or a function");
  t.prototype = Object.create(e && e.prototype, {
    constructor: {
      value: t,
      writable: !0,
      configurable: !0
    }
  }), Object.defineProperty(t, "prototype", {
    writable: !1
  }), e && _setPrototypeOf$2(t, e);
}

function _possibleConstructorReturn(t, e) {
  if (e && ("object" == _typeof(e) || "function" == typeof e)) return e;
  if (void 0 !== e) throw new TypeError("Derived constructors may only return object or undefined");
  return _assertThisInitialized$2(t);
}

function _createSuper(t) {
  var r = _isNativeReflectConstruct$1();
  return function () {
    var e,
      o = _getPrototypeOf$1(t);
    if (r) {
      var s = _getPrototypeOf$1(this).constructor;
      e = Reflect.construct(o, arguments, s);
    } else e = o.apply(this, arguments);
    return _possibleConstructorReturn(this, e);
  };
}

function _classCallCheck(a, n) {
  if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function");
}

function toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}

function toPropertyKey(t) {
  var i = toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}

function _defineProperties(e, r) {
  for (var t = 0; t < r.length; t++) {
    var o = r[t];
    o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, toPropertyKey(o.key), o);
  }
}
function _createClass(e, r, t) {
  return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", {
    writable: !1
  }), e;
}

function _defineProperty$2(e, r, t) {
  return (r = toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}

var TIMEZONE_UNIT_PRIORITY = 10;
var Setter = /*#__PURE__*/function () {
  function Setter() {
    _classCallCheck(this, Setter);
    _defineProperty$2(this, "priority", void 0);
    _defineProperty$2(this, "subPriority", 0);
  }
  _createClass(Setter, [{
    key: "validate",
    value: function validate(_utcDate, _options) {
      return true;
    }
  }]);
  return Setter;
}();
var ValueSetter = /*#__PURE__*/function (_Setter) {
  _inherits(ValueSetter, _Setter);
  var _super = _createSuper(ValueSetter);
  function ValueSetter(value, validateValue, setValue, priority, subPriority) {
    var _this;
    _classCallCheck(this, ValueSetter);
    _this = _super.call(this);
    _this.value = value;
    _this.validateValue = validateValue;
    _this.setValue = setValue;
    _this.priority = priority;
    if (subPriority) {
      _this.subPriority = subPriority;
    }
    return _this;
  }
  _createClass(ValueSetter, [{
    key: "validate",
    value: function validate(utcDate, options) {
      return this.validateValue(utcDate, this.value, options);
    }
  }, {
    key: "set",
    value: function set(utcDate, flags, options) {
      return this.setValue(utcDate, flags, this.value, options);
    }
  }]);
  return ValueSetter;
}(Setter);
var DateToSystemTimezoneSetter = /*#__PURE__*/function (_Setter2) {
  _inherits(DateToSystemTimezoneSetter, _Setter2);
  var _super2 = _createSuper(DateToSystemTimezoneSetter);
  function DateToSystemTimezoneSetter() {
    var _this2;
    _classCallCheck(this, DateToSystemTimezoneSetter);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this2 = _super2.call.apply(_super2, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$2(_this2), "priority", TIMEZONE_UNIT_PRIORITY);
    _defineProperty$2(_assertThisInitialized$2(_this2), "subPriority", -1);
    return _this2;
  }
  _createClass(DateToSystemTimezoneSetter, [{
    key: "set",
    value: function set(date, flags) {
      if (flags.timestampIsSet) {
        return date;
      }
      var convertedDate = new Date(0);
      convertedDate.setFullYear(date.getUTCFullYear(), date.getUTCMonth(), date.getUTCDate());
      convertedDate.setHours(date.getUTCHours(), date.getUTCMinutes(), date.getUTCSeconds(), date.getUTCMilliseconds());
      return convertedDate;
    }
  }]);
  return DateToSystemTimezoneSetter;
}(Setter);

var Parser = /*#__PURE__*/function () {
  function Parser() {
    _classCallCheck(this, Parser);
    _defineProperty$2(this, "incompatibleTokens", void 0);
    _defineProperty$2(this, "priority", void 0);
    _defineProperty$2(this, "subPriority", void 0);
  }
  _createClass(Parser, [{
    key: "run",
    value: function run(dateString, token, match, options) {
      var result = this.parse(dateString, token, match, options);
      if (!result) {
        return null;
      }
      return {
        setter: new ValueSetter(result.value, this.validate, this.set, this.priority, this.subPriority),
        rest: result.rest
      };
    }
  }, {
    key: "validate",
    value: function validate(_utcDate, _value, _options) {
      return true;
    }
  }]);
  return Parser;
}();

var EraParser = /*#__PURE__*/function (_Parser) {
  _inherits(EraParser, _Parser);
  var _super = _createSuper(EraParser);
  function EraParser() {
    var _this;
    _classCallCheck(this, EraParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$2(_this), "priority", 140);
    _defineProperty$2(_assertThisInitialized$2(_this), "incompatibleTokens", ['R', 'u', 't', 'T']);
    return _this;
  }
  _createClass(EraParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // AD, BC
        case 'G':
        case 'GG':
        case 'GGG':
          return match.era(dateString, {
            width: 'abbreviated'
          }) || match.era(dateString, {
            width: 'narrow'
          });
        // A, B
        case 'GGGGG':
          return match.era(dateString, {
            width: 'narrow'
          });
        // Anno Domini, Before Christ
        case 'GGGG':
        default:
          return match.era(dateString, {
            width: 'wide'
          }) || match.era(dateString, {
            width: 'abbreviated'
          }) || match.era(dateString, {
            width: 'narrow'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      flags.era = value;
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return EraParser;
}(Parser);

/**
 * Days in 1 week.
 *
 * @name daysInWeek
 * @constant
 * @type {number}
 * @default
 */

/**
 * Milliseconds in 1 minute
 *
 * @name millisecondsInMinute
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInMinute = 60000;

/**
 * Milliseconds in 1 hour
 *
 * @name millisecondsInHour
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInHour = 3600000;

/**
 * Milliseconds in 1 second
 *
 * @name millisecondsInSecond
 * @constant
 * @type {number}
 * @default
 */
var millisecondsInSecond = 1000;

var numericPatterns = {
  month: /^(1[0-2]|0?\d)/,
  // 0 to 12
  date: /^(3[0-1]|[0-2]?\d)/,
  // 0 to 31
  dayOfYear: /^(36[0-6]|3[0-5]\d|[0-2]?\d?\d)/,
  // 0 to 366
  week: /^(5[0-3]|[0-4]?\d)/,
  // 0 to 53
  hour23h: /^(2[0-3]|[0-1]?\d)/,
  // 0 to 23
  hour24h: /^(2[0-4]|[0-1]?\d)/,
  // 0 to 24
  hour11h: /^(1[0-1]|0?\d)/,
  // 0 to 11
  hour12h: /^(1[0-2]|0?\d)/,
  // 0 to 12
  minute: /^[0-5]?\d/,
  // 0 to 59
  second: /^[0-5]?\d/,
  // 0 to 59

  singleDigit: /^\d/,
  // 0 to 9
  twoDigits: /^\d{1,2}/,
  // 0 to 99
  threeDigits: /^\d{1,3}/,
  // 0 to 999
  fourDigits: /^\d{1,4}/,
  // 0 to 9999

  anyDigitsSigned: /^-?\d+/,
  singleDigitSigned: /^-?\d/,
  // 0 to 9, -0 to -9
  twoDigitsSigned: /^-?\d{1,2}/,
  // 0 to 99, -0 to -99
  threeDigitsSigned: /^-?\d{1,3}/,
  // 0 to 999, -0 to -999
  fourDigitsSigned: /^-?\d{1,4}/ // 0 to 9999, -0 to -9999
};

var timezonePatterns = {
  basicOptionalMinutes: /^([+-])(\d{2})(\d{2})?|Z/,
  basic: /^([+-])(\d{2})(\d{2})|Z/,
  basicOptionalSeconds: /^([+-])(\d{2})(\d{2})((\d{2}))?|Z/,
  extended: /^([+-])(\d{2}):(\d{2})|Z/,
  extendedOptionalSeconds: /^([+-])(\d{2}):(\d{2})(:(\d{2}))?|Z/
};

function mapValue(parseFnResult, mapFn) {
  if (!parseFnResult) {
    return parseFnResult;
  }
  return {
    value: mapFn(parseFnResult.value),
    rest: parseFnResult.rest
  };
}
function parseNumericPattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }
  return {
    value: parseInt(matchResult[0], 10),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseTimezonePattern(pattern, dateString) {
  var matchResult = dateString.match(pattern);
  if (!matchResult) {
    return null;
  }

  // Input is 'Z'
  if (matchResult[0] === 'Z') {
    return {
      value: 0,
      rest: dateString.slice(1)
    };
  }
  var sign = matchResult[1] === '+' ? 1 : -1;
  var hours = matchResult[2] ? parseInt(matchResult[2], 10) : 0;
  var minutes = matchResult[3] ? parseInt(matchResult[3], 10) : 0;
  var seconds = matchResult[5] ? parseInt(matchResult[5], 10) : 0;
  return {
    value: sign * (hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * millisecondsInSecond),
    rest: dateString.slice(matchResult[0].length)
  };
}
function parseAnyDigitsSigned(dateString) {
  return parseNumericPattern(numericPatterns.anyDigitsSigned, dateString);
}
function parseNDigits(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigit, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigits, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigits, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigits, dateString);
    default:
      return parseNumericPattern(new RegExp('^\\d{1,' + n + '}'), dateString);
  }
}
function parseNDigitsSigned(n, dateString) {
  switch (n) {
    case 1:
      return parseNumericPattern(numericPatterns.singleDigitSigned, dateString);
    case 2:
      return parseNumericPattern(numericPatterns.twoDigitsSigned, dateString);
    case 3:
      return parseNumericPattern(numericPatterns.threeDigitsSigned, dateString);
    case 4:
      return parseNumericPattern(numericPatterns.fourDigitsSigned, dateString);
    default:
      return parseNumericPattern(new RegExp('^-?\\d{1,' + n + '}'), dateString);
  }
}
function dayPeriodEnumToHours(dayPeriod) {
  switch (dayPeriod) {
    case 'morning':
      return 4;
    case 'evening':
      return 17;
    case 'pm':
    case 'noon':
    case 'afternoon':
      return 12;
    case 'am':
    case 'midnight':
    case 'night':
    default:
      return 0;
  }
}
function normalizeTwoDigitYear(twoDigitYear, currentYear) {
  var isCommonEra = currentYear > 0;
  // Absolute number of the current year:
  // 1 -> 1 AC
  // 0 -> 1 BC
  // -1 -> 2 BC
  var absCurrentYear = isCommonEra ? currentYear : 1 - currentYear;
  var result;
  if (absCurrentYear <= 50) {
    result = twoDigitYear || 100;
  } else {
    var rangeEnd = absCurrentYear + 50;
    var rangeEndCentury = Math.floor(rangeEnd / 100) * 100;
    var isPreviousCentury = twoDigitYear >= rangeEnd % 100;
    result = twoDigitYear + rangeEndCentury - (isPreviousCentury ? 100 : 0);
  }
  return isCommonEra ? result : 1 - result;
}
function isLeapYearIndex$1(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}

// From http://www.unicode.org/reports/tr35/tr35-31/tr35-dates.html#Date_Format_Patterns
// | Year     |     y | yy |   yyy |  yyyy | yyyyy |
// |----------|-------|----|-------|-------|-------|
// | AD 1     |     1 | 01 |   001 |  0001 | 00001 |
// | AD 12    |    12 | 12 |   012 |  0012 | 00012 |
// | AD 123   |   123 | 23 |   123 |  0123 | 00123 |
// | AD 1234  |  1234 | 34 |  1234 |  1234 | 01234 |
// | AD 12345 | 12345 | 45 | 12345 | 12345 | 12345 |
var YearParser = /*#__PURE__*/function (_Parser) {
  _inherits(YearParser, _Parser);
  var _super = _createSuper(YearParser);
  function YearParser() {
    var _this;
    _classCallCheck(this, YearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$2(_this), "priority", 130);
    _defineProperty$2(_assertThisInitialized$2(_this), "incompatibleTokens", ['Y', 'R', 'u', 'w', 'I', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(YearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'yy'
        };
      };
      switch (token) {
        case 'y':
          return mapValue(parseNDigits(4, dateString), valueCallback);
        case 'yo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'year'
          }), valueCallback);
        default:
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value.isTwoDigitYear || value.year > 0;
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      var currentYear = date.getUTCFullYear();
      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, 1);
        date.setUTCHours(0, 0, 0, 0);
        return date;
      }
      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return YearParser;
}(Parser);

// Local week-numbering year
var LocalWeekYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(LocalWeekYearParser, _Parser);
  var _super = _createSuper(LocalWeekYearParser);
  function LocalWeekYearParser() {
    var _this;
    _classCallCheck(this, LocalWeekYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$2(_this), "priority", 130);
    _defineProperty$2(_assertThisInitialized$2(_this), "incompatibleTokens", ['y', 'R', 'u', 'Q', 'q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);
    return _this;
  }
  _createClass(LocalWeekYearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(year) {
        return {
          year: year,
          isTwoDigitYear: token === 'YY'
        };
      };
      switch (token) {
        case 'Y':
          return mapValue(parseNDigits(4, dateString), valueCallback);
        case 'Yo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'year'
          }), valueCallback);
        default:
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value.isTwoDigitYear || value.year > 0;
    }
  }, {
    key: "set",
    value: function set(date, flags, value, options) {
      var currentYear = getUTCWeekYear(date, options);
      if (value.isTwoDigitYear) {
        var normalizedTwoDigitYear = normalizeTwoDigitYear(value.year, currentYear);
        date.setUTCFullYear(normalizedTwoDigitYear, 0, options.firstWeekContainsDate);
        date.setUTCHours(0, 0, 0, 0);
        return startOfUTCWeek(date, options);
      }
      var year = !('era' in flags) || flags.era === 1 ? value.year : 1 - value.year;
      date.setUTCFullYear(year, 0, options.firstWeekContainsDate);
      date.setUTCHours(0, 0, 0, 0);
      return startOfUTCWeek(date, options);
    }
  }]);
  return LocalWeekYearParser;
}(Parser);

var ISOWeekYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOWeekYearParser, _Parser);
  var _super = _createSuper(ISOWeekYearParser);
  function ISOWeekYearParser() {
    var _this;
    _classCallCheck(this, ISOWeekYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$2(_this), "priority", 130);
    _defineProperty$2(_assertThisInitialized$2(_this), "incompatibleTokens", ['G', 'y', 'Y', 'u', 'Q', 'q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(ISOWeekYearParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      if (token === 'R') {
        return parseNDigitsSigned(4, dateString);
      }
      return parseNDigitsSigned(token.length, dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      var firstWeekOfYear = new Date(0);
      firstWeekOfYear.setUTCFullYear(value, 0, 4);
      firstWeekOfYear.setUTCHours(0, 0, 0, 0);
      return startOfUTCISOWeek(firstWeekOfYear);
    }
  }]);
  return ISOWeekYearParser;
}(Parser);

var ExtendedYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(ExtendedYearParser, _Parser);
  var _super = _createSuper(ExtendedYearParser);
  function ExtendedYearParser() {
    var _this;
    _classCallCheck(this, ExtendedYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$2(_this), "priority", 130);
    _defineProperty$2(_assertThisInitialized$2(_this), "incompatibleTokens", ['G', 'y', 'Y', 'R', 'w', 'I', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(ExtendedYearParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      if (token === 'u') {
        return parseNDigitsSigned(4, dateString);
      }
      return parseNDigitsSigned(token.length, dateString);
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCFullYear(value, 0, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return ExtendedYearParser;
}(Parser);

var QuarterParser = /*#__PURE__*/function (_Parser) {
  _inherits(QuarterParser, _Parser);
  var _super = _createSuper(QuarterParser);
  function QuarterParser() {
    var _this;
    _classCallCheck(this, QuarterParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$2(_this), "priority", 120);
    _defineProperty$2(_assertThisInitialized$2(_this), "incompatibleTokens", ['Y', 'R', 'q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(QuarterParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // 1, 2, 3, 4
        case 'Q':
        case 'QQ':
          // 01, 02, 03, 04
          return parseNDigits(token.length, dateString);
        // 1st, 2nd, 3rd, 4th
        case 'Qo':
          return match.ordinalNumber(dateString, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4
        case 'QQQ':
          return match.quarter(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case 'QQQQQ':
          return match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // 1st quarter, 2nd quarter, ...
        case 'QQQQ':
        default:
          return match.quarter(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 4;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return QuarterParser;
}(Parser);

var StandAloneQuarterParser = /*#__PURE__*/function (_Parser) {
  _inherits(StandAloneQuarterParser, _Parser);
  var _super = _createSuper(StandAloneQuarterParser);
  function StandAloneQuarterParser() {
    var _this;
    _classCallCheck(this, StandAloneQuarterParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$2(_this), "priority", 120);
    _defineProperty$2(_assertThisInitialized$2(_this), "incompatibleTokens", ['Y', 'R', 'Q', 'M', 'L', 'w', 'I', 'd', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(StandAloneQuarterParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // 1, 2, 3, 4
        case 'q':
        case 'qq':
          // 01, 02, 03, 04
          return parseNDigits(token.length, dateString);
        // 1st, 2nd, 3rd, 4th
        case 'qo':
          return match.ordinalNumber(dateString, {
            unit: 'quarter'
          });
        // Q1, Q2, Q3, Q4
        case 'qqq':
          return match.quarter(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1, 2, 3, 4 (narrow quarter; could be not numerical)
        case 'qqqqq':
          return match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // 1st quarter, 2nd quarter, ...
        case 'qqqq':
        default:
          return match.quarter(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.quarter(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 4;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth((value - 1) * 3, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneQuarterParser;
}(Parser);

var MonthParser = /*#__PURE__*/function (_Parser) {
  _inherits(MonthParser, _Parser);
  var _super = _createSuper(MonthParser);
  function MonthParser() {
    var _this;
    _classCallCheck(this, MonthParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$2(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'L', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
    _defineProperty$2(_assertThisInitialized$2(_this), "priority", 110);
    return _this;
  }
  _createClass(MonthParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };
      switch (token) {
        // 1, 2, ..., 12
        case 'M':
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
        // 01, 02, ..., 12
        case 'MM':
          return mapValue(parseNDigits(2, dateString), valueCallback);
        // 1st, 2nd, ..., 12th
        case 'Mo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'month'
          }), valueCallback);
        // Jan, Feb, ..., Dec
        case 'MMM':
          return match.month(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // J, F, ..., D
        case 'MMMMM':
          return match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // January, February, ..., December
        case 'MMMM':
        default:
          return match.month(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return MonthParser;
}(Parser);

var StandAloneMonthParser = /*#__PURE__*/function (_Parser) {
  _inherits(StandAloneMonthParser, _Parser);
  var _super = _createSuper(StandAloneMonthParser);
  function StandAloneMonthParser() {
    var _this;
    _classCallCheck(this, StandAloneMonthParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$2(_this), "priority", 110);
    _defineProperty$2(_assertThisInitialized$2(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(StandAloneMonthParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        return value - 1;
      };
      switch (token) {
        // 1, 2, ..., 12
        case 'L':
          return mapValue(parseNumericPattern(numericPatterns.month, dateString), valueCallback);
        // 01, 02, ..., 12
        case 'LL':
          return mapValue(parseNDigits(2, dateString), valueCallback);
        // 1st, 2nd, ..., 12th
        case 'Lo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'month'
          }), valueCallback);
        // Jan, Feb, ..., Dec
        case 'LLL':
          return match.month(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // J, F, ..., D
        case 'LLLLL':
          return match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // January, February, ..., December
        case 'LLLL':
        default:
          return match.month(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.month(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(value, 1);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneMonthParser;
}(Parser);

function setUTCWeek(dirtyDate, dirtyWeek, options) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var week = toInteger(dirtyWeek);
  var diff = getUTCWeek(date, options) - week;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

var LocalWeekParser = /*#__PURE__*/function (_Parser) {
  _inherits(LocalWeekParser, _Parser);
  var _super = _createSuper(LocalWeekParser);
  function LocalWeekParser() {
    var _this;
    _classCallCheck(this, LocalWeekParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$2(_this), "priority", 100);
    _defineProperty$2(_assertThisInitialized$2(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'i', 't', 'T']);
    return _this;
  }
  _createClass(LocalWeekParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'w':
          return parseNumericPattern(numericPatterns.week, dateString);
        case 'wo':
          return match.ordinalNumber(dateString, {
            unit: 'week'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 53;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      return startOfUTCWeek(setUTCWeek(date, value, options), options);
    }
  }]);
  return LocalWeekParser;
}(Parser);

function setUTCISOWeek(dirtyDate, dirtyISOWeek) {
  requiredArgs(2, arguments);
  var date = toDate(dirtyDate);
  var isoWeek = toInteger(dirtyISOWeek);
  var diff = getUTCISOWeek(date) - isoWeek;
  date.setUTCDate(date.getUTCDate() - diff * 7);
  return date;
}

var ISOWeekParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOWeekParser, _Parser);
  var _super = _createSuper(ISOWeekParser);
  function ISOWeekParser() {
    var _this;
    _classCallCheck(this, ISOWeekParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$2(_this), "priority", 100);
    _defineProperty$2(_assertThisInitialized$2(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(ISOWeekParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'I':
          return parseNumericPattern(numericPatterns.week, dateString);
        case 'Io':
          return match.ordinalNumber(dateString, {
            unit: 'week'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 53;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      return startOfUTCISOWeek(setUTCISOWeek(date, value));
    }
  }]);
  return ISOWeekParser;
}(Parser);

var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
var DAYS_IN_MONTH_LEAP_YEAR = [31, 29, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];

// Day of the month
var DateParser = /*#__PURE__*/function (_Parser) {
  _inherits(DateParser, _Parser);
  var _super = _createSuper(DateParser);
  function DateParser() {
    var _this;
    _classCallCheck(this, DateParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$2(_this), "priority", 90);
    _defineProperty$2(_assertThisInitialized$2(_this), "subPriority", 1);
    _defineProperty$2(_assertThisInitialized$2(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'w', 'I', 'D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(DateParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'd':
          return parseNumericPattern(numericPatterns.date, dateString);
        case 'do':
          return match.ordinalNumber(dateString, {
            unit: 'date'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(date, value) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex$1(year);
      var month = date.getUTCMonth();
      if (isLeapYear) {
        return value >= 1 && value <= DAYS_IN_MONTH_LEAP_YEAR[month];
      } else {
        return value >= 1 && value <= DAYS_IN_MONTH[month];
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCDate(value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DateParser;
}(Parser);

var DayOfYearParser = /*#__PURE__*/function (_Parser) {
  _inherits(DayOfYearParser, _Parser);
  var _super = _createSuper(DayOfYearParser);
  function DayOfYearParser() {
    var _this;
    _classCallCheck(this, DayOfYearParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$2(_this), "priority", 90);
    _defineProperty$2(_assertThisInitialized$2(_this), "subpriority", 1);
    _defineProperty$2(_assertThisInitialized$2(_this), "incompatibleTokens", ['Y', 'R', 'q', 'Q', 'M', 'L', 'w', 'I', 'd', 'E', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(DayOfYearParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'D':
        case 'DD':
          return parseNumericPattern(numericPatterns.dayOfYear, dateString);
        case 'Do':
          return match.ordinalNumber(dateString, {
            unit: 'date'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(date, value) {
      var year = date.getUTCFullYear();
      var isLeapYear = isLeapYearIndex$1(year);
      if (isLeapYear) {
        return value >= 1 && value <= 366;
      } else {
        return value >= 1 && value <= 365;
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMonth(0, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DayOfYearParser;
}(Parser);

function setUTCDay(dirtyDate, dirtyDay, options) {
  var _ref, _ref2, _ref3, _options$weekStartsOn, _options$locale, _options$locale$optio, _defaultOptions$local, _defaultOptions$local2;
  requiredArgs(2, arguments);
  var defaultOptions = getDefaultOptions();
  var weekStartsOn = toInteger((_ref = (_ref2 = (_ref3 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale = options.locale) === null || _options$locale === void 0 ? void 0 : (_options$locale$optio = _options$locale.options) === null || _options$locale$optio === void 0 ? void 0 : _options$locale$optio.weekStartsOn) !== null && _ref3 !== void 0 ? _ref3 : defaultOptions.weekStartsOn) !== null && _ref2 !== void 0 ? _ref2 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.weekStartsOn) !== null && _ref !== void 0 ? _ref : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  var date = toDate(dirtyDate);
  var day = toInteger(dirtyDay);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

var DayParser = /*#__PURE__*/function (_Parser) {
  _inherits(DayParser, _Parser);
  var _super = _createSuper(DayParser);
  function DayParser() {
    var _this;
    _classCallCheck(this, DayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$2(_this), "priority", 90);
    _defineProperty$2(_assertThisInitialized$2(_this), "incompatibleTokens", ['D', 'i', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(DayParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        // Tue
        case 'E':
        case 'EE':
        case 'EEE':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // T
        case 'EEEEE':
          return match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu
        case 'EEEEEE':
          return match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday
        case 'EEEE':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return DayParser;
}(Parser);

var LocalDayParser = /*#__PURE__*/function (_Parser) {
  _inherits(LocalDayParser, _Parser);
  var _super = _createSuper(LocalDayParser);
  function LocalDayParser() {
    var _this;
    _classCallCheck(this, LocalDayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$2(_this), "priority", 90);
    _defineProperty$2(_assertThisInitialized$2(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'c', 't', 'T']);
    return _this;
  }
  _createClass(LocalDayParser, [{
    key: "parse",
    value: function parse(dateString, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token) {
        // 3
        case 'e':
        case 'ee':
          // 03
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
        // 3rd
        case 'eo':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'day'
          }), valueCallback);
        // Tue
        case 'eee':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // T
        case 'eeeee':
          return match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tu
        case 'eeeeee':
          return match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        // Tuesday
        case 'eeee':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return LocalDayParser;
}(Parser);

var StandAloneLocalDayParser = /*#__PURE__*/function (_Parser) {
  _inherits(StandAloneLocalDayParser, _Parser);
  var _super = _createSuper(StandAloneLocalDayParser);
  function StandAloneLocalDayParser() {
    var _this;
    _classCallCheck(this, StandAloneLocalDayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$2(_this), "priority", 90);
    _defineProperty$2(_assertThisInitialized$2(_this), "incompatibleTokens", ['y', 'R', 'u', 'q', 'Q', 'M', 'L', 'I', 'd', 'D', 'E', 'i', 'e', 't', 'T']);
    return _this;
  }
  _createClass(StandAloneLocalDayParser, [{
    key: "parse",
    value: function parse(dateString, token, match, options) {
      var valueCallback = function valueCallback(value) {
        var wholeWeekDays = Math.floor((value - 1) / 7) * 7;
        return (value + options.weekStartsOn + 6) % 7 + wholeWeekDays;
      };
      switch (token) {
        // 3
        case 'c':
        case 'cc':
          // 03
          return mapValue(parseNDigits(token.length, dateString), valueCallback);
        // 3rd
        case 'co':
          return mapValue(match.ordinalNumber(dateString, {
            unit: 'day'
          }), valueCallback);
        // Tue
        case 'ccc':
          return match.day(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // T
        case 'ccccc':
          return match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tu
        case 'cccccc':
          return match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
        // Tuesday
        case 'cccc':
        default:
          return match.day(dateString, {
            width: 'wide',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'short',
            context: 'standalone'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'standalone'
          });
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 6;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value, options) {
      date = setUTCDay(date, value, options);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return StandAloneLocalDayParser;
}(Parser);

function setUTCISODay(dirtyDate, dirtyDay) {
  requiredArgs(2, arguments);
  var day = toInteger(dirtyDay);
  if (day % 7 === 0) {
    day = day - 7;
  }
  var weekStartsOn = 1;
  var date = toDate(dirtyDate);
  var currentDay = date.getUTCDay();
  var remainder = day % 7;
  var dayIndex = (remainder + 7) % 7;
  var diff = (dayIndex < weekStartsOn ? 7 : 0) + day - currentDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

var ISODayParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISODayParser, _Parser);
  var _super = _createSuper(ISODayParser);
  function ISODayParser() {
    var _this;
    _classCallCheck(this, ISODayParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$2(_this), "priority", 90);
    _defineProperty$2(_assertThisInitialized$2(_this), "incompatibleTokens", ['y', 'Y', 'u', 'q', 'Q', 'M', 'L', 'w', 'd', 'D', 'E', 'e', 'c', 't', 'T']);
    return _this;
  }
  _createClass(ISODayParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      var valueCallback = function valueCallback(value) {
        if (value === 0) {
          return 7;
        }
        return value;
      };
      switch (token) {
        // 2
        case 'i':
        case 'ii':
          // 02
          return parseNDigits(token.length, dateString);
        // 2nd
        case 'io':
          return match.ordinalNumber(dateString, {
            unit: 'day'
          });
        // Tue
        case 'iii':
          return mapValue(match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // T
        case 'iiiii':
          return mapValue(match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // Tu
        case 'iiiiii':
          return mapValue(match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
        // Tuesday
        case 'iiii':
        default:
          return mapValue(match.day(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'short',
            context: 'formatting'
          }) || match.day(dateString, {
            width: 'narrow',
            context: 'formatting'
          }), valueCallback);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 7;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date = setUTCISODay(date, value);
      date.setUTCHours(0, 0, 0, 0);
      return date;
    }
  }]);
  return ISODayParser;
}(Parser);

var AMPMParser = /*#__PURE__*/function (_Parser) {
  _inherits(AMPMParser, _Parser);
  var _super = _createSuper(AMPMParser);
  function AMPMParser() {
    var _this;
    _classCallCheck(this, AMPMParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$2(_this), "priority", 80);
    _defineProperty$2(_assertThisInitialized$2(_this), "incompatibleTokens", ['b', 'B', 'H', 'k', 't', 'T']);
    return _this;
  }
  _createClass(AMPMParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'a':
        case 'aa':
        case 'aaa':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'aaaaa':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'aaaa':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);
  return AMPMParser;
}(Parser);

var AMPMMidnightParser = /*#__PURE__*/function (_Parser) {
  _inherits(AMPMMidnightParser, _Parser);
  var _super = _createSuper(AMPMMidnightParser);
  function AMPMMidnightParser() {
    var _this;
    _classCallCheck(this, AMPMMidnightParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$2(_this), "priority", 80);
    _defineProperty$2(_assertThisInitialized$2(_this), "incompatibleTokens", ['a', 'B', 'H', 'k', 't', 'T']);
    return _this;
  }
  _createClass(AMPMMidnightParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'b':
        case 'bb':
        case 'bbb':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'bbbbb':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'bbbb':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);
  return AMPMMidnightParser;
}(Parser);

var DayPeriodParser = /*#__PURE__*/function (_Parser) {
  _inherits(DayPeriodParser, _Parser);
  var _super = _createSuper(DayPeriodParser);
  function DayPeriodParser() {
    var _this;
    _classCallCheck(this, DayPeriodParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$2(_this), "priority", 80);
    _defineProperty$2(_assertThisInitialized$2(_this), "incompatibleTokens", ['a', 'b', 't', 'T']);
    return _this;
  }
  _createClass(DayPeriodParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'B':
        case 'BB':
        case 'BBB':
          return match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'BBBBB':
          return match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
        case 'BBBB':
        default:
          return match.dayPeriod(dateString, {
            width: 'wide',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'abbreviated',
            context: 'formatting'
          }) || match.dayPeriod(dateString, {
            width: 'narrow',
            context: 'formatting'
          });
      }
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(dayPeriodEnumToHours(value), 0, 0, 0);
      return date;
    }
  }]);
  return DayPeriodParser;
}(Parser);

var Hour1to12Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour1to12Parser, _Parser);
  var _super = _createSuper(Hour1to12Parser);
  function Hour1to12Parser() {
    var _this;
    _classCallCheck(this, Hour1to12Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$2(_this), "priority", 70);
    _defineProperty$2(_assertThisInitialized$2(_this), "incompatibleTokens", ['H', 'K', 'k', 't', 'T']);
    return _this;
  }
  _createClass(Hour1to12Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'h':
          return parseNumericPattern(numericPatterns.hour12h, dateString);
        case 'ho':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 12;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else if (!isPM && value === 12) {
        date.setUTCHours(0, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }
      return date;
    }
  }]);
  return Hour1to12Parser;
}(Parser);

var Hour0to23Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour0to23Parser, _Parser);
  var _super = _createSuper(Hour0to23Parser);
  function Hour0to23Parser() {
    var _this;
    _classCallCheck(this, Hour0to23Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$2(_this), "priority", 70);
    _defineProperty$2(_assertThisInitialized$2(_this), "incompatibleTokens", ['a', 'b', 'h', 'K', 'k', 't', 'T']);
    return _this;
  }
  _createClass(Hour0to23Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'H':
          return parseNumericPattern(numericPatterns.hour23h, dateString);
        case 'Ho':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 23;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCHours(value, 0, 0, 0);
      return date;
    }
  }]);
  return Hour0to23Parser;
}(Parser);

var Hour0To11Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour0To11Parser, _Parser);
  var _super = _createSuper(Hour0To11Parser);
  function Hour0To11Parser() {
    var _this;
    _classCallCheck(this, Hour0To11Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$2(_this), "priority", 70);
    _defineProperty$2(_assertThisInitialized$2(_this), "incompatibleTokens", ['h', 'H', 'k', 't', 'T']);
    return _this;
  }
  _createClass(Hour0To11Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'K':
          return parseNumericPattern(numericPatterns.hour11h, dateString);
        case 'Ko':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 11;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var isPM = date.getUTCHours() >= 12;
      if (isPM && value < 12) {
        date.setUTCHours(value + 12, 0, 0, 0);
      } else {
        date.setUTCHours(value, 0, 0, 0);
      }
      return date;
    }
  }]);
  return Hour0To11Parser;
}(Parser);

var Hour1To24Parser = /*#__PURE__*/function (_Parser) {
  _inherits(Hour1To24Parser, _Parser);
  var _super = _createSuper(Hour1To24Parser);
  function Hour1To24Parser() {
    var _this;
    _classCallCheck(this, Hour1To24Parser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$2(_this), "priority", 70);
    _defineProperty$2(_assertThisInitialized$2(_this), "incompatibleTokens", ['a', 'b', 'h', 'H', 'K', 't', 'T']);
    return _this;
  }
  _createClass(Hour1To24Parser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'k':
          return parseNumericPattern(numericPatterns.hour24h, dateString);
        case 'ko':
          return match.ordinalNumber(dateString, {
            unit: 'hour'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 1 && value <= 24;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      var hours = value <= 24 ? value % 24 : value;
      date.setUTCHours(hours, 0, 0, 0);
      return date;
    }
  }]);
  return Hour1To24Parser;
}(Parser);

var MinuteParser = /*#__PURE__*/function (_Parser) {
  _inherits(MinuteParser, _Parser);
  var _super = _createSuper(MinuteParser);
  function MinuteParser() {
    var _this;
    _classCallCheck(this, MinuteParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$2(_this), "priority", 60);
    _defineProperty$2(_assertThisInitialized$2(_this), "incompatibleTokens", ['t', 'T']);
    return _this;
  }
  _createClass(MinuteParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 'm':
          return parseNumericPattern(numericPatterns.minute, dateString);
        case 'mo':
          return match.ordinalNumber(dateString, {
            unit: 'minute'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 59;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMinutes(value, 0, 0);
      return date;
    }
  }]);
  return MinuteParser;
}(Parser);

var SecondParser = /*#__PURE__*/function (_Parser) {
  _inherits(SecondParser, _Parser);
  var _super = _createSuper(SecondParser);
  function SecondParser() {
    var _this;
    _classCallCheck(this, SecondParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$2(_this), "priority", 50);
    _defineProperty$2(_assertThisInitialized$2(_this), "incompatibleTokens", ['t', 'T']);
    return _this;
  }
  _createClass(SecondParser, [{
    key: "parse",
    value: function parse(dateString, token, match) {
      switch (token) {
        case 's':
          return parseNumericPattern(numericPatterns.second, dateString);
        case 'so':
          return match.ordinalNumber(dateString, {
            unit: 'second'
          });
        default:
          return parseNDigits(token.length, dateString);
      }
    }
  }, {
    key: "validate",
    value: function validate(_date, value) {
      return value >= 0 && value <= 59;
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCSeconds(value, 0);
      return date;
    }
  }]);
  return SecondParser;
}(Parser);

var FractionOfSecondParser = /*#__PURE__*/function (_Parser) {
  _inherits(FractionOfSecondParser, _Parser);
  var _super = _createSuper(FractionOfSecondParser);
  function FractionOfSecondParser() {
    var _this;
    _classCallCheck(this, FractionOfSecondParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$2(_this), "priority", 30);
    _defineProperty$2(_assertThisInitialized$2(_this), "incompatibleTokens", ['t', 'T']);
    return _this;
  }
  _createClass(FractionOfSecondParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      var valueCallback = function valueCallback(value) {
        return Math.floor(value * Math.pow(10, -token.length + 3));
      };
      return mapValue(parseNDigits(token.length, dateString), valueCallback);
    }
  }, {
    key: "set",
    value: function set(date, _flags, value) {
      date.setUTCMilliseconds(value);
      return date;
    }
  }]);
  return FractionOfSecondParser;
}(Parser);

var ISOTimezoneWithZParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOTimezoneWithZParser, _Parser);
  var _super = _createSuper(ISOTimezoneWithZParser);
  function ISOTimezoneWithZParser() {
    var _this;
    _classCallCheck(this, ISOTimezoneWithZParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$2(_this), "priority", 10);
    _defineProperty$2(_assertThisInitialized$2(_this), "incompatibleTokens", ['t', 'T', 'x']);
    return _this;
  }
  _createClass(ISOTimezoneWithZParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      switch (token) {
        case 'X':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
        case 'XX':
          return parseTimezonePattern(timezonePatterns.basic, dateString);
        case 'XXXX':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
        case 'XXXXX':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
        case 'XXX':
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      if (flags.timestampIsSet) {
        return date;
      }
      return new Date(date.getTime() - value);
    }
  }]);
  return ISOTimezoneWithZParser;
}(Parser);

var ISOTimezoneParser = /*#__PURE__*/function (_Parser) {
  _inherits(ISOTimezoneParser, _Parser);
  var _super = _createSuper(ISOTimezoneParser);
  function ISOTimezoneParser() {
    var _this;
    _classCallCheck(this, ISOTimezoneParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$2(_this), "priority", 10);
    _defineProperty$2(_assertThisInitialized$2(_this), "incompatibleTokens", ['t', 'T', 'X']);
    return _this;
  }
  _createClass(ISOTimezoneParser, [{
    key: "parse",
    value: function parse(dateString, token) {
      switch (token) {
        case 'x':
          return parseTimezonePattern(timezonePatterns.basicOptionalMinutes, dateString);
        case 'xx':
          return parseTimezonePattern(timezonePatterns.basic, dateString);
        case 'xxxx':
          return parseTimezonePattern(timezonePatterns.basicOptionalSeconds, dateString);
        case 'xxxxx':
          return parseTimezonePattern(timezonePatterns.extendedOptionalSeconds, dateString);
        case 'xxx':
        default:
          return parseTimezonePattern(timezonePatterns.extended, dateString);
      }
    }
  }, {
    key: "set",
    value: function set(date, flags, value) {
      if (flags.timestampIsSet) {
        return date;
      }
      return new Date(date.getTime() - value);
    }
  }]);
  return ISOTimezoneParser;
}(Parser);

var TimestampSecondsParser = /*#__PURE__*/function (_Parser) {
  _inherits(TimestampSecondsParser, _Parser);
  var _super = _createSuper(TimestampSecondsParser);
  function TimestampSecondsParser() {
    var _this;
    _classCallCheck(this, TimestampSecondsParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$2(_this), "priority", 40);
    _defineProperty$2(_assertThisInitialized$2(_this), "incompatibleTokens", '*');
    return _this;
  }
  _createClass(TimestampSecondsParser, [{
    key: "parse",
    value: function parse(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      return [new Date(value * 1000), {
        timestampIsSet: true
      }];
    }
  }]);
  return TimestampSecondsParser;
}(Parser);

var TimestampMillisecondsParser = /*#__PURE__*/function (_Parser) {
  _inherits(TimestampMillisecondsParser, _Parser);
  var _super = _createSuper(TimestampMillisecondsParser);
  function TimestampMillisecondsParser() {
    var _this;
    _classCallCheck(this, TimestampMillisecondsParser);
    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }
    _this = _super.call.apply(_super, [this].concat(args));
    _defineProperty$2(_assertThisInitialized$2(_this), "priority", 20);
    _defineProperty$2(_assertThisInitialized$2(_this), "incompatibleTokens", '*');
    return _this;
  }
  _createClass(TimestampMillisecondsParser, [{
    key: "parse",
    value: function parse(dateString) {
      return parseAnyDigitsSigned(dateString);
    }
  }, {
    key: "set",
    value: function set(_date, _flags, value) {
      return [new Date(value), {
        timestampIsSet: true
      }];
    }
  }]);
  return TimestampMillisecondsParser;
}(Parser);

/*
 * |     | Unit                           |     | Unit                           |
 * |-----|--------------------------------|-----|--------------------------------|
 * |  a  | AM, PM                         |  A* | Milliseconds in day            |
 * |  b  | AM, PM, noon, midnight         |  B  | Flexible day period            |
 * |  c  | Stand-alone local day of week  |  C* | Localized hour w/ day period   |
 * |  d  | Day of month                   |  D  | Day of year                    |
 * |  e  | Local day of week              |  E  | Day of week                    |
 * |  f  |                                |  F* | Day of week in month           |
 * |  g* | Modified Julian day            |  G  | Era                            |
 * |  h  | Hour [1-12]                    |  H  | Hour [0-23]                    |
 * |  i! | ISO day of week                |  I! | ISO week of year               |
 * |  j* | Localized hour w/ day period   |  J* | Localized hour w/o day period  |
 * |  k  | Hour [1-24]                    |  K  | Hour [0-11]                    |
 * |  l* | (deprecated)                   |  L  | Stand-alone month              |
 * |  m  | Minute                         |  M  | Month                          |
 * |  n  |                                |  N  |                                |
 * |  o! | Ordinal number modifier        |  O* | Timezone (GMT)                 |
 * |  p  |                                |  P  |                                |
 * |  q  | Stand-alone quarter            |  Q  | Quarter                        |
 * |  r* | Related Gregorian year         |  R! | ISO week-numbering year        |
 * |  s  | Second                         |  S  | Fraction of second             |
 * |  t! | Seconds timestamp              |  T! | Milliseconds timestamp         |
 * |  u  | Extended year                  |  U* | Cyclic year                    |
 * |  v* | Timezone (generic non-locat.)  |  V* | Timezone (location)            |
 * |  w  | Local week of year             |  W* | Week of month                  |
 * |  x  | Timezone (ISO-8601 w/o Z)      |  X  | Timezone (ISO-8601)            |
 * |  y  | Year (abs)                     |  Y  | Local week-numbering year      |
 * |  z* | Timezone (specific non-locat.) |  Z* | Timezone (aliases)             |
 *
 * Letters marked by * are not implemented but reserved by Unicode standard.
 *
 * Letters marked by ! are non-standard, but implemented by date-fns:
 * - `o` modifies the previous token to turn it into an ordinal (see `parse` docs)
 * - `i` is ISO day of week. For `i` and `ii` is returns numeric ISO week days,
 *   i.e. 7 for Sunday, 1 for Monday, etc.
 * - `I` is ISO week of year, as opposed to `w` which is local week of year.
 * - `R` is ISO week-numbering year, as opposed to `Y` which is local week-numbering year.
 *   `R` is supposed to be used in conjunction with `I` and `i`
 *   for universal ISO week-numbering date, whereas
 *   `Y` is supposed to be used in conjunction with `w` and `e`
 *   for week-numbering date specific to the locale.
 */
var parsers = {
  G: new EraParser(),
  y: new YearParser(),
  Y: new LocalWeekYearParser(),
  R: new ISOWeekYearParser(),
  u: new ExtendedYearParser(),
  Q: new QuarterParser(),
  q: new StandAloneQuarterParser(),
  M: new MonthParser(),
  L: new StandAloneMonthParser(),
  w: new LocalWeekParser(),
  I: new ISOWeekParser(),
  d: new DateParser(),
  D: new DayOfYearParser(),
  E: new DayParser(),
  e: new LocalDayParser(),
  c: new StandAloneLocalDayParser(),
  i: new ISODayParser(),
  a: new AMPMParser(),
  b: new AMPMMidnightParser(),
  B: new DayPeriodParser(),
  h: new Hour1to12Parser(),
  H: new Hour0to23Parser(),
  K: new Hour0To11Parser(),
  k: new Hour1To24Parser(),
  m: new MinuteParser(),
  s: new SecondParser(),
  S: new FractionOfSecondParser(),
  X: new ISOTimezoneWithZParser(),
  x: new ISOTimezoneParser(),
  t: new TimestampSecondsParser(),
  T: new TimestampMillisecondsParser()
};

// - [yYQqMLwIdDecihHKkms]o matches any available ordinal number token
//   (one of the certain letters followed by `o`)
// - (\w)\1* matches any sequences of the same letter
// - '' matches two quote characters in a row
// - '(''|[^'])+('|$) matches anything surrounded by two quote characters ('),
//   except a single quote symbol, which ends the sequence.
//   Two quote characters do not end the sequence.
//   If there is no matching single quote
//   then the sequence will continue until the end of the string.
// - . matches any single character unmatched by previous parts of the RegExps
var formattingTokensRegExp = /[yYQqMLwIdDecihHKkms]o|(\w)\1*|''|'(''|[^'])+('|$)|./g;

// This RegExp catches symbols escaped by quotes, and also
// sequences of symbols P, p, and the combinations like `PPPPPPPppppp`
var longFormattingTokensRegExp = /P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;
var escapedStringRegExp = /^'([^]*?)'?$/;
var doubleQuoteRegExp = /''/g;
var notWhitespaceRegExp = /\S/;
var unescapedLatinCharacterRegExp = /[a-zA-Z]/;

/**
 * @name parse
 * @category Common Helpers
 * @summary Parse the date.
 *
 * @description
 * Return the date parsed from string using the given format string.
 *
 * > ⚠️ Please note that the `format` tokens differ from Moment.js and other libraries.
 * > See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * The characters in the format string wrapped between two single quotes characters (') are escaped.
 * Two single quotes in a row, whether inside or outside a quoted sequence, represent a 'real' single quote.
 *
 * Format of the format string is based on Unicode Technical Standard #35:
 * https://www.unicode.org/reports/tr35/tr35-dates.html#Date_Field_Symbol_Table
 * with a few additions (see note 5 below the table).
 *
 * Not all tokens are compatible. Combinations that don't make sense or could lead to bugs are prohibited
 * and will throw `RangeError`. For example usage of 24-hour format token with AM/PM token will throw an exception:
 *
 * ```javascript
 * parse('23 AM', 'HH a', new Date())
 * //=> RangeError: The format string mustn't contain `HH` and `a` at the same time
 * ```
 *
 * See the compatibility table: https://docs.google.com/spreadsheets/d/e/2PACX-1vQOPU3xUhplll6dyoMmVUXHKl_8CRDs6_ueLmex3SoqwhuolkuN3O05l4rqx5h1dKX8eb46Ul-CCSrq/pubhtml?gid=0&single=true
 *
 * Accepted format string patterns:
 * | Unit                            |Prior| Pattern | Result examples                   | Notes |
 * |---------------------------------|-----|---------|-----------------------------------|-------|
 * | Era                             | 140 | G..GGG  | AD, BC                            |       |
 * |                                 |     | GGGG    | Anno Domini, Before Christ        | 2     |
 * |                                 |     | GGGGG   | A, B                              |       |
 * | Calendar year                   | 130 | y       | 44, 1, 1900, 2017, 9999           | 4     |
 * |                                 |     | yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | yy      | 44, 01, 00, 17                    | 4     |
 * |                                 |     | yyy     | 044, 001, 123, 999                | 4     |
 * |                                 |     | yyyy    | 0044, 0001, 1900, 2017            | 4     |
 * |                                 |     | yyyyy   | ...                               | 2,4   |
 * | Local week-numbering year       | 130 | Y       | 44, 1, 1900, 2017, 9000           | 4     |
 * |                                 |     | Yo      | 44th, 1st, 1900th, 9999999th      | 4,5   |
 * |                                 |     | YY      | 44, 01, 00, 17                    | 4,6   |
 * |                                 |     | YYY     | 044, 001, 123, 999                | 4     |
 * |                                 |     | YYYY    | 0044, 0001, 1900, 2017            | 4,6   |
 * |                                 |     | YYYYY   | ...                               | 2,4   |
 * | ISO week-numbering year         | 130 | R       | -43, 1, 1900, 2017, 9999, -9999   | 4,5   |
 * |                                 |     | RR      | -43, 01, 00, 17                   | 4,5   |
 * |                                 |     | RRR     | -043, 001, 123, 999, -999         | 4,5   |
 * |                                 |     | RRRR    | -0043, 0001, 2017, 9999, -9999    | 4,5   |
 * |                                 |     | RRRRR   | ...                               | 2,4,5 |
 * | Extended year                   | 130 | u       | -43, 1, 1900, 2017, 9999, -999    | 4     |
 * |                                 |     | uu      | -43, 01, 99, -99                  | 4     |
 * |                                 |     | uuu     | -043, 001, 123, 999, -999         | 4     |
 * |                                 |     | uuuu    | -0043, 0001, 2017, 9999, -9999    | 4     |
 * |                                 |     | uuuuu   | ...                               | 2,4   |
 * | Quarter (formatting)            | 120 | Q       | 1, 2, 3, 4                        |       |
 * |                                 |     | Qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | QQ      | 01, 02, 03, 04                    |       |
 * |                                 |     | QQQ     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | QQQQ    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | QQQQQ   | 1, 2, 3, 4                        | 4     |
 * | Quarter (stand-alone)           | 120 | q       | 1, 2, 3, 4                        |       |
 * |                                 |     | qo      | 1st, 2nd, 3rd, 4th                | 5     |
 * |                                 |     | qq      | 01, 02, 03, 04                    |       |
 * |                                 |     | qqq     | Q1, Q2, Q3, Q4                    |       |
 * |                                 |     | qqqq    | 1st quarter, 2nd quarter, ...     | 2     |
 * |                                 |     | qqqqq   | 1, 2, 3, 4                        | 3     |
 * | Month (formatting)              | 110 | M       | 1, 2, ..., 12                     |       |
 * |                                 |     | Mo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | MM      | 01, 02, ..., 12                   |       |
 * |                                 |     | MMM     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | MMMM    | January, February, ..., December  | 2     |
 * |                                 |     | MMMMM   | J, F, ..., D                      |       |
 * | Month (stand-alone)             | 110 | L       | 1, 2, ..., 12                     |       |
 * |                                 |     | Lo      | 1st, 2nd, ..., 12th               | 5     |
 * |                                 |     | LL      | 01, 02, ..., 12                   |       |
 * |                                 |     | LLL     | Jan, Feb, ..., Dec                |       |
 * |                                 |     | LLLL    | January, February, ..., December  | 2     |
 * |                                 |     | LLLLL   | J, F, ..., D                      |       |
 * | Local week of year              | 100 | w       | 1, 2, ..., 53                     |       |
 * |                                 |     | wo      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | ww      | 01, 02, ..., 53                   |       |
 * | ISO week of year                | 100 | I       | 1, 2, ..., 53                     | 5     |
 * |                                 |     | Io      | 1st, 2nd, ..., 53th               | 5     |
 * |                                 |     | II      | 01, 02, ..., 53                   | 5     |
 * | Day of month                    |  90 | d       | 1, 2, ..., 31                     |       |
 * |                                 |     | do      | 1st, 2nd, ..., 31st               | 5     |
 * |                                 |     | dd      | 01, 02, ..., 31                   |       |
 * | Day of year                     |  90 | D       | 1, 2, ..., 365, 366               | 7     |
 * |                                 |     | Do      | 1st, 2nd, ..., 365th, 366th       | 5     |
 * |                                 |     | DD      | 01, 02, ..., 365, 366             | 7     |
 * |                                 |     | DDD     | 001, 002, ..., 365, 366           |       |
 * |                                 |     | DDDD    | ...                               | 2     |
 * | Day of week (formatting)        |  90 | E..EEE  | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | EEEE    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | EEEEE   | M, T, W, T, F, S, S               |       |
 * |                                 |     | EEEEEE  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | ISO day of week (formatting)    |  90 | i       | 1, 2, 3, ..., 7                   | 5     |
 * |                                 |     | io      | 1st, 2nd, ..., 7th                | 5     |
 * |                                 |     | ii      | 01, 02, ..., 07                   | 5     |
 * |                                 |     | iii     | Mon, Tue, Wed, ..., Sun           | 5     |
 * |                                 |     | iiii    | Monday, Tuesday, ..., Sunday      | 2,5   |
 * |                                 |     | iiiii   | M, T, W, T, F, S, S               | 5     |
 * |                                 |     | iiiiii  | Mo, Tu, We, Th, Fr, Sa, Su        | 5     |
 * | Local day of week (formatting)  |  90 | e       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | eo      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | ee      | 02, 03, ..., 01                   |       |
 * |                                 |     | eee     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | eeee    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | eeeee   | M, T, W, T, F, S, S               |       |
 * |                                 |     | eeeeee  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | Local day of week (stand-alone) |  90 | c       | 2, 3, 4, ..., 1                   |       |
 * |                                 |     | co      | 2nd, 3rd, ..., 1st                | 5     |
 * |                                 |     | cc      | 02, 03, ..., 01                   |       |
 * |                                 |     | ccc     | Mon, Tue, Wed, ..., Sun           |       |
 * |                                 |     | cccc    | Monday, Tuesday, ..., Sunday      | 2     |
 * |                                 |     | ccccc   | M, T, W, T, F, S, S               |       |
 * |                                 |     | cccccc  | Mo, Tu, We, Th, Fr, Sa, Su        |       |
 * | AM, PM                          |  80 | a..aaa  | AM, PM                            |       |
 * |                                 |     | aaaa    | a.m., p.m.                        | 2     |
 * |                                 |     | aaaaa   | a, p                              |       |
 * | AM, PM, noon, midnight          |  80 | b..bbb  | AM, PM, noon, midnight            |       |
 * |                                 |     | bbbb    | a.m., p.m., noon, midnight        | 2     |
 * |                                 |     | bbbbb   | a, p, n, mi                       |       |
 * | Flexible day period             |  80 | B..BBB  | at night, in the morning, ...     |       |
 * |                                 |     | BBBB    | at night, in the morning, ...     | 2     |
 * |                                 |     | BBBBB   | at night, in the morning, ...     |       |
 * | Hour [1-12]                     |  70 | h       | 1, 2, ..., 11, 12                 |       |
 * |                                 |     | ho      | 1st, 2nd, ..., 11th, 12th         | 5     |
 * |                                 |     | hh      | 01, 02, ..., 11, 12               |       |
 * | Hour [0-23]                     |  70 | H       | 0, 1, 2, ..., 23                  |       |
 * |                                 |     | Ho      | 0th, 1st, 2nd, ..., 23rd          | 5     |
 * |                                 |     | HH      | 00, 01, 02, ..., 23               |       |
 * | Hour [0-11]                     |  70 | K       | 1, 2, ..., 11, 0                  |       |
 * |                                 |     | Ko      | 1st, 2nd, ..., 11th, 0th          | 5     |
 * |                                 |     | KK      | 01, 02, ..., 11, 00               |       |
 * | Hour [1-24]                     |  70 | k       | 24, 1, 2, ..., 23                 |       |
 * |                                 |     | ko      | 24th, 1st, 2nd, ..., 23rd         | 5     |
 * |                                 |     | kk      | 24, 01, 02, ..., 23               |       |
 * | Minute                          |  60 | m       | 0, 1, ..., 59                     |       |
 * |                                 |     | mo      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | mm      | 00, 01, ..., 59                   |       |
 * | Second                          |  50 | s       | 0, 1, ..., 59                     |       |
 * |                                 |     | so      | 0th, 1st, ..., 59th               | 5     |
 * |                                 |     | ss      | 00, 01, ..., 59                   |       |
 * | Seconds timestamp               |  40 | t       | 512969520                         |       |
 * |                                 |     | tt      | ...                               | 2     |
 * | Fraction of second              |  30 | S       | 0, 1, ..., 9                      |       |
 * |                                 |     | SS      | 00, 01, ..., 99                   |       |
 * |                                 |     | SSS     | 000, 001, ..., 999                |       |
 * |                                 |     | SSSS    | ...                               | 2     |
 * | Milliseconds timestamp          |  20 | T       | 512969520900                      |       |
 * |                                 |     | TT      | ...                               | 2     |
 * | Timezone (ISO-8601 w/ Z)        |  10 | X       | -08, +0530, Z                     |       |
 * |                                 |     | XX      | -0800, +0530, Z                   |       |
 * |                                 |     | XXX     | -08:00, +05:30, Z                 |       |
 * |                                 |     | XXXX    | -0800, +0530, Z, +123456          | 2     |
 * |                                 |     | XXXXX   | -08:00, +05:30, Z, +12:34:56      |       |
 * | Timezone (ISO-8601 w/o Z)       |  10 | x       | -08, +0530, +00                   |       |
 * |                                 |     | xx      | -0800, +0530, +0000               |       |
 * |                                 |     | xxx     | -08:00, +05:30, +00:00            | 2     |
 * |                                 |     | xxxx    | -0800, +0530, +0000, +123456      |       |
 * |                                 |     | xxxxx   | -08:00, +05:30, +00:00, +12:34:56 |       |
 * | Long localized date             |  NA | P       | 05/29/1453                        | 5,8   |
 * |                                 |     | PP      | May 29, 1453                      |       |
 * |                                 |     | PPP     | May 29th, 1453                    |       |
 * |                                 |     | PPPP    | Sunday, May 29th, 1453            | 2,5,8 |
 * | Long localized time             |  NA | p       | 12:00 AM                          | 5,8   |
 * |                                 |     | pp      | 12:00:00 AM                       |       |
 * | Combination of date and time    |  NA | Pp      | 05/29/1453, 12:00 AM              |       |
 * |                                 |     | PPpp    | May 29, 1453, 12:00:00 AM         |       |
 * |                                 |     | PPPpp   | May 29th, 1453 at ...             |       |
 * |                                 |     | PPPPpp  | Sunday, May 29th, 1453 at ...     | 2,5,8 |
 * Notes:
 * 1. "Formatting" units (e.g. formatting quarter) in the default en-US locale
 *    are the same as "stand-alone" units, but are different in some languages.
 *    "Formatting" units are declined according to the rules of the language
 *    in the context of a date. "Stand-alone" units are always nominative singular.
 *    In `format` function, they will produce different result:
 *
 *    `format(new Date(2017, 10, 6), 'do LLLL', {locale: cs}) //=> '6. listopad'`
 *
 *    `format(new Date(2017, 10, 6), 'do MMMM', {locale: cs}) //=> '6. listopadu'`
 *
 *    `parse` will try to match both formatting and stand-alone units interchangably.
 *
 * 2. Any sequence of the identical letters is a pattern, unless it is escaped by
 *    the single quote characters (see below).
 *    If the sequence is longer than listed in table:
 *    - for numerical units (`yyyyyyyy`) `parse` will try to match a number
 *      as wide as the sequence
 *    - for text units (`MMMMMMMM`) `parse` will try to match the widest variation of the unit.
 *      These variations are marked with "2" in the last column of the table.
 *
 * 3. `QQQQQ` and `qqqqq` could be not strictly numerical in some locales.
 *    These tokens represent the shortest form of the quarter.
 *
 * 4. The main difference between `y` and `u` patterns are B.C. years:
 *
 *    | Year | `y` | `u` |
 *    |------|-----|-----|
 *    | AC 1 |   1 |   1 |
 *    | BC 1 |   1 |   0 |
 *    | BC 2 |   2 |  -1 |
 *
 *    Also `yy` will try to guess the century of two digit year by proximity with `referenceDate`:
 *
 *    `parse('50', 'yy', new Date(2018, 0, 1)) //=> Sat Jan 01 2050 00:00:00`
 *
 *    `parse('75', 'yy', new Date(2018, 0, 1)) //=> Wed Jan 01 1975 00:00:00`
 *
 *    while `uu` will just assign the year as is:
 *
 *    `parse('50', 'uu', new Date(2018, 0, 1)) //=> Sat Jan 01 0050 00:00:00`
 *
 *    `parse('75', 'uu', new Date(2018, 0, 1)) //=> Tue Jan 01 0075 00:00:00`
 *
 *    The same difference is true for local and ISO week-numbering years (`Y` and `R`),
 *    except local week-numbering years are dependent on `options.weekStartsOn`
 *    and `options.firstWeekContainsDate` (compare [setISOWeekYear]{@link https://date-fns.org/docs/setISOWeekYear}
 *    and [setWeekYear]{@link https://date-fns.org/docs/setWeekYear}).
 *
 * 5. These patterns are not in the Unicode Technical Standard #35:
 *    - `i`: ISO day of week
 *    - `I`: ISO week of year
 *    - `R`: ISO week-numbering year
 *    - `o`: ordinal number modifier
 *    - `P`: long localized date
 *    - `p`: long localized time
 *
 * 6. `YY` and `YYYY` tokens represent week-numbering years but they are often confused with years.
 *    You should enable `options.useAdditionalWeekYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 7. `D` and `DD` tokens represent days of the year but they are ofthen confused with days of the month.
 *    You should enable `options.useAdditionalDayOfYearTokens` to use them. See: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 *
 * 8. `P+` tokens do not have a defined priority since they are merely aliases to other tokens based
 *    on the given locale.
 *
 *    using `en-US` locale: `P` => `MM/dd/yyyy`
 *    using `en-US` locale: `p` => `hh:mm a`
 *    using `pt-BR` locale: `P` => `dd/MM/yyyy`
 *    using `pt-BR` locale: `p` => `HH:mm`
 *
 * Values will be assigned to the date in the descending order of its unit's priority.
 * Units of an equal priority overwrite each other in the order of appearance.
 *
 * If no values of higher priority are parsed (e.g. when parsing string 'January 1st' without a year),
 * the values will be taken from 3rd argument `referenceDate` which works as a context of parsing.
 *
 * `referenceDate` must be passed for correct work of the function.
 * If you're not sure which `referenceDate` to supply, create a new instance of Date:
 * `parse('02/11/2014', 'MM/dd/yyyy', new Date())`
 * In this case parsing will be done in the context of the current date.
 * If `referenceDate` is `Invalid Date` or a value not convertible to valid `Date`,
 * then `Invalid Date` will be returned.
 *
 * The result may vary by locale.
 *
 * If `formatString` matches with `dateString` but does not provides tokens, `referenceDate` will be returned.
 *
 * If parsing failed, `Invalid Date` will be returned.
 * Invalid Date is a Date, whose time value is NaN.
 * Time value of Date: http://es5.github.io/#x15.9.1.1
 *
 * @param {String} dateString - the string to parse
 * @param {String} formatString - the string of tokens
 * @param {Date|Number} referenceDate - defines values missing from the parsed dateString
 * @param {Object} [options] - an object with options.
 * @param {Locale} [options.locale=defaultLocale] - the locale object. See [Locale]{@link https://date-fns.org/docs/Locale}
 * @param {0|1|2|3|4|5|6} [options.weekStartsOn=0] - the index of the first day of the week (0 - Sunday)
 * @param {1|2|3|4|5|6|7} [options.firstWeekContainsDate=1] - the day of January, which is always in the first week of the year
 * @param {Boolean} [options.useAdditionalWeekYearTokens=false] - if true, allows usage of the week-numbering year tokens `YY` and `YYYY`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @param {Boolean} [options.useAdditionalDayOfYearTokens=false] - if true, allows usage of the day of year tokens `D` and `DD`;
 *   see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @returns {Date} the parsed date
 * @throws {TypeError} 3 arguments required
 * @throws {RangeError} `options.weekStartsOn` must be between 0 and 6
 * @throws {RangeError} `options.firstWeekContainsDate` must be between 1 and 7
 * @throws {RangeError} `options.locale` must contain `match` property
 * @throws {RangeError} use `yyyy` instead of `YYYY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `yy` instead of `YY` for formatting years using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `d` instead of `D` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} use `dd` instead of `DD` for formatting days of the month using [format provided] to the input [input provided]; see: https://github.com/date-fns/date-fns/blob/master/docs/unicodeTokens.md
 * @throws {RangeError} format string contains an unescaped latin alphabet character
 *
 * @example
 * // Parse 11 February 2014 from middle-endian format:
 * var result = parse('02/11/2014', 'MM/dd/yyyy', new Date())
 * //=> Tue Feb 11 2014 00:00:00
 *
 * @example
 * // Parse 28th of February in Esperanto locale in the context of 2010 year:
 * import eo from 'date-fns/locale/eo'
 * var result = parse('28-a de februaro', "do 'de' MMMM", new Date(2010, 0, 1), {
 *   locale: eo
 * })
 * //=> Sun Feb 28 2010 00:00:00
 */
function parse(dirtyDateString, dirtyFormatString, dirtyReferenceDate, options) {
  var _ref, _options$locale, _ref2, _ref3, _ref4, _options$firstWeekCon, _options$locale2, _options$locale2$opti, _defaultOptions$local, _defaultOptions$local2, _ref5, _ref6, _ref7, _options$weekStartsOn, _options$locale3, _options$locale3$opti, _defaultOptions$local3, _defaultOptions$local4;
  requiredArgs(3, arguments);
  var dateString = String(dirtyDateString);
  var formatString = String(dirtyFormatString);
  var defaultOptions = getDefaultOptions();
  var locale = (_ref = (_options$locale = options === null || options === void 0 ? void 0 : options.locale) !== null && _options$locale !== void 0 ? _options$locale : defaultOptions.locale) !== null && _ref !== void 0 ? _ref : defaultLocale;
  if (!locale.match) {
    throw new RangeError('locale must contain match property');
  }
  var firstWeekContainsDate = toInteger((_ref2 = (_ref3 = (_ref4 = (_options$firstWeekCon = options === null || options === void 0 ? void 0 : options.firstWeekContainsDate) !== null && _options$firstWeekCon !== void 0 ? _options$firstWeekCon : options === null || options === void 0 ? void 0 : (_options$locale2 = options.locale) === null || _options$locale2 === void 0 ? void 0 : (_options$locale2$opti = _options$locale2.options) === null || _options$locale2$opti === void 0 ? void 0 : _options$locale2$opti.firstWeekContainsDate) !== null && _ref4 !== void 0 ? _ref4 : defaultOptions.firstWeekContainsDate) !== null && _ref3 !== void 0 ? _ref3 : (_defaultOptions$local = defaultOptions.locale) === null || _defaultOptions$local === void 0 ? void 0 : (_defaultOptions$local2 = _defaultOptions$local.options) === null || _defaultOptions$local2 === void 0 ? void 0 : _defaultOptions$local2.firstWeekContainsDate) !== null && _ref2 !== void 0 ? _ref2 : 1);

  // Test if weekStartsOn is between 1 and 7 _and_ is not NaN
  if (!(firstWeekContainsDate >= 1 && firstWeekContainsDate <= 7)) {
    throw new RangeError('firstWeekContainsDate must be between 1 and 7 inclusively');
  }
  var weekStartsOn = toInteger((_ref5 = (_ref6 = (_ref7 = (_options$weekStartsOn = options === null || options === void 0 ? void 0 : options.weekStartsOn) !== null && _options$weekStartsOn !== void 0 ? _options$weekStartsOn : options === null || options === void 0 ? void 0 : (_options$locale3 = options.locale) === null || _options$locale3 === void 0 ? void 0 : (_options$locale3$opti = _options$locale3.options) === null || _options$locale3$opti === void 0 ? void 0 : _options$locale3$opti.weekStartsOn) !== null && _ref7 !== void 0 ? _ref7 : defaultOptions.weekStartsOn) !== null && _ref6 !== void 0 ? _ref6 : (_defaultOptions$local3 = defaultOptions.locale) === null || _defaultOptions$local3 === void 0 ? void 0 : (_defaultOptions$local4 = _defaultOptions$local3.options) === null || _defaultOptions$local4 === void 0 ? void 0 : _defaultOptions$local4.weekStartsOn) !== null && _ref5 !== void 0 ? _ref5 : 0);

  // Test if weekStartsOn is between 0 and 6 _and_ is not NaN
  if (!(weekStartsOn >= 0 && weekStartsOn <= 6)) {
    throw new RangeError('weekStartsOn must be between 0 and 6 inclusively');
  }
  if (formatString === '') {
    if (dateString === '') {
      return toDate(dirtyReferenceDate);
    } else {
      return new Date(NaN);
    }
  }
  var subFnOptions = {
    firstWeekContainsDate: firstWeekContainsDate,
    weekStartsOn: weekStartsOn,
    locale: locale
  };

  // If timezone isn't specified, it will be set to the system timezone
  var setters = [new DateToSystemTimezoneSetter()];
  var tokens = formatString.match(longFormattingTokensRegExp).map(function (substring) {
    var firstCharacter = substring[0];
    if (firstCharacter in longFormatters$1) {
      var longFormatter = longFormatters$1[firstCharacter];
      return longFormatter(substring, locale.formatLong);
    }
    return substring;
  }).join('').match(formattingTokensRegExp);
  var usedTokens = [];
  var _iterator = _createForOfIteratorHelper(tokens),
    _step;
  try {
    var _loop = function _loop() {
      var token = _step.value;
      if (!(options !== null && options !== void 0 && options.useAdditionalWeekYearTokens) && isProtectedWeekYearToken(token)) {
        throwProtectedError(token, formatString, dirtyDateString);
      }
      if (!(options !== null && options !== void 0 && options.useAdditionalDayOfYearTokens) && isProtectedDayOfYearToken(token)) {
        throwProtectedError(token, formatString, dirtyDateString);
      }
      var firstCharacter = token[0];
      var parser = parsers[firstCharacter];
      if (parser) {
        var incompatibleTokens = parser.incompatibleTokens;
        if (Array.isArray(incompatibleTokens)) {
          var incompatibleToken = usedTokens.find(function (usedToken) {
            return incompatibleTokens.includes(usedToken.token) || usedToken.token === firstCharacter;
          });
          if (incompatibleToken) {
            throw new RangeError("The format string mustn't contain `".concat(incompatibleToken.fullToken, "` and `").concat(token, "` at the same time"));
          }
        } else if (parser.incompatibleTokens === '*' && usedTokens.length > 0) {
          throw new RangeError("The format string mustn't contain `".concat(token, "` and any other token at the same time"));
        }
        usedTokens.push({
          token: firstCharacter,
          fullToken: token
        });
        var parseResult = parser.run(dateString, token, locale.match, subFnOptions);
        if (!parseResult) {
          return {
            v: new Date(NaN)
          };
        }
        setters.push(parseResult.setter);
        dateString = parseResult.rest;
      } else {
        if (firstCharacter.match(unescapedLatinCharacterRegExp)) {
          throw new RangeError('Format string contains an unescaped latin alphabet character `' + firstCharacter + '`');
        }

        // Replace two single quote characters with one single quote character
        if (token === "''") {
          token = "'";
        } else if (firstCharacter === "'") {
          token = cleanEscapedString(token);
        }

        // Cut token from string, or, if string doesn't match the token, return Invalid Date
        if (dateString.indexOf(token) === 0) {
          dateString = dateString.slice(token.length);
        } else {
          return {
            v: new Date(NaN)
          };
        }
      }
    };
    for (_iterator.s(); !(_step = _iterator.n()).done;) {
      var _ret = _loop();
      if (_typeof(_ret) === "object") return _ret.v;
    }

    // Check if the remaining input contains something other than whitespace
  } catch (err) {
    _iterator.e(err);
  } finally {
    _iterator.f();
  }
  if (dateString.length > 0 && notWhitespaceRegExp.test(dateString)) {
    return new Date(NaN);
  }
  var uniquePrioritySetters = setters.map(function (setter) {
    return setter.priority;
  }).sort(function (a, b) {
    return b - a;
  }).filter(function (priority, index, array) {
    return array.indexOf(priority) === index;
  }).map(function (priority) {
    return setters.filter(function (setter) {
      return setter.priority === priority;
    }).sort(function (a, b) {
      return b.subPriority - a.subPriority;
    });
  }).map(function (setterArray) {
    return setterArray[0];
  });
  var date = toDate(dirtyReferenceDate);
  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }

  // Convert the date in system timezone to the same date in UTC+00:00 timezone.
  var utcDate = subMilliseconds(date, getTimezoneOffsetInMilliseconds(date));
  var flags = {};
  var _iterator2 = _createForOfIteratorHelper(uniquePrioritySetters),
    _step2;
  try {
    for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
      var setter = _step2.value;
      if (!setter.validate(utcDate, subFnOptions)) {
        return new Date(NaN);
      }
      var result = setter.set(utcDate, flags, subFnOptions);
      // Result is tuple (date, flags)
      if (Array.isArray(result)) {
        utcDate = result[0];
        assign(flags, result[1]);
        // Result is date
      } else {
        utcDate = result;
      }
    }
  } catch (err) {
    _iterator2.e(err);
  } finally {
    _iterator2.f();
  }
  return utcDate;
}
function cleanEscapedString(input) {
  return input.match(escapedStringRegExp)[1].replace(doubleQuoteRegExp, "'");
}

/**
 * @name parseISO
 * @category Common Helpers
 * @summary Parse ISO string
 *
 * @description
 * Parse the given string in ISO 8601 format and return an instance of Date.
 *
 * Function accepts complete ISO 8601 formats as well as partial implementations.
 * ISO 8601: http://en.wikipedia.org/wiki/ISO_8601
 *
 * If the argument isn't a string, the function cannot parse the string or
 * the values are invalid, it returns Invalid Date.
 *
 * @param {String} argument - the value to convert
 * @param {Object} [options] - an object with options.
 * @param {0|1|2} [options.additionalDigits=2] - the additional number of digits in the extended year format
 * @returns {Date} the parsed date in the local time zone
 * @throws {TypeError} 1 argument required
 * @throws {RangeError} `options.additionalDigits` must be 0, 1 or 2
 *
 * @example
 * // Convert string '2014-02-11T11:30:30' to date:
 * const result = parseISO('2014-02-11T11:30:30')
 * //=> Tue Feb 11 2014 11:30:30
 *
 * @example
 * // Convert string '+02014101' to date,
 * // if the additional number of digits in the extended year format is 1:
 * const result = parseISO('+02014101', { additionalDigits: 1 })
 * //=> Fri Apr 11 2014 00:00:00
 */
function parseISO(argument, options) {
  var _options$additionalDi;
  requiredArgs(1, arguments);
  var additionalDigits = toInteger((_options$additionalDi = options === null || options === void 0 ? void 0 : options.additionalDigits) !== null && _options$additionalDi !== void 0 ? _options$additionalDi : 2);
  if (additionalDigits !== 2 && additionalDigits !== 1 && additionalDigits !== 0) {
    throw new RangeError('additionalDigits must be 0, 1 or 2');
  }
  if (!(typeof argument === 'string' || Object.prototype.toString.call(argument) === '[object String]')) {
    return new Date(NaN);
  }
  var dateStrings = splitDateString(argument);
  var date;
  if (dateStrings.date) {
    var parseYearResult = parseYear(dateStrings.date, additionalDigits);
    date = parseDate(parseYearResult.restDateString, parseYearResult.year);
  }
  if (!date || isNaN(date.getTime())) {
    return new Date(NaN);
  }
  var timestamp = date.getTime();
  var time = 0;
  var offset;
  if (dateStrings.time) {
    time = parseTime(dateStrings.time);
    if (isNaN(time)) {
      return new Date(NaN);
    }
  }
  if (dateStrings.timezone) {
    offset = parseTimezone(dateStrings.timezone);
    if (isNaN(offset)) {
      return new Date(NaN);
    }
  } else {
    var dirtyDate = new Date(timestamp + time);
    // js parsed string assuming it's in UTC timezone
    // but we need it to be parsed in our timezone
    // so we use utc values to build date in our timezone.
    // Year values from 0 to 99 map to the years 1900 to 1999
    // so set year explicitly with setFullYear.
    var result = new Date(0);
    result.setFullYear(dirtyDate.getUTCFullYear(), dirtyDate.getUTCMonth(), dirtyDate.getUTCDate());
    result.setHours(dirtyDate.getUTCHours(), dirtyDate.getUTCMinutes(), dirtyDate.getUTCSeconds(), dirtyDate.getUTCMilliseconds());
    return result;
  }
  return new Date(timestamp + time + offset);
}
var patterns = {
  dateTimeDelimiter: /[T ]/,
  timeZoneDelimiter: /[Z ]/i,
  timezone: /([Z+-].*)$/
};
var dateRegex = /^-?(?:(\d{3})|(\d{2})(?:-?(\d{2}))?|W(\d{2})(?:-?(\d{1}))?|)$/;
var timeRegex = /^(\d{2}(?:[.,]\d*)?)(?::?(\d{2}(?:[.,]\d*)?))?(?::?(\d{2}(?:[.,]\d*)?))?$/;
var timezoneRegex = /^([+-])(\d{2})(?::?(\d{2}))?$/;
function splitDateString(dateString) {
  var dateStrings = {};
  var array = dateString.split(patterns.dateTimeDelimiter);
  var timeString;

  // The regex match should only return at maximum two array elements.
  // [date], [time], or [date, time].
  if (array.length > 2) {
    return dateStrings;
  }
  if (/:/.test(array[0])) {
    timeString = array[0];
  } else {
    dateStrings.date = array[0];
    timeString = array[1];
    if (patterns.timeZoneDelimiter.test(dateStrings.date)) {
      dateStrings.date = dateString.split(patterns.timeZoneDelimiter)[0];
      timeString = dateString.substr(dateStrings.date.length, dateString.length);
    }
  }
  if (timeString) {
    var token = patterns.timezone.exec(timeString);
    if (token) {
      dateStrings.time = timeString.replace(token[1], '');
      dateStrings.timezone = token[1];
    } else {
      dateStrings.time = timeString;
    }
  }
  return dateStrings;
}
function parseYear(dateString, additionalDigits) {
  var regex = new RegExp('^(?:(\\d{4}|[+-]\\d{' + (4 + additionalDigits) + '})|(\\d{2}|[+-]\\d{' + (2 + additionalDigits) + '})$)');
  var captures = dateString.match(regex);
  // Invalid ISO-formatted year
  if (!captures) return {
    year: NaN,
    restDateString: ''
  };
  var year = captures[1] ? parseInt(captures[1]) : null;
  var century = captures[2] ? parseInt(captures[2]) : null;

  // either year or century is null, not both
  return {
    year: century === null ? year : century * 100,
    restDateString: dateString.slice((captures[1] || captures[2]).length)
  };
}
function parseDate(dateString, year) {
  // Invalid ISO-formatted year
  if (year === null) return new Date(NaN);
  var captures = dateString.match(dateRegex);
  // Invalid ISO-formatted string
  if (!captures) return new Date(NaN);
  var isWeekDate = !!captures[4];
  var dayOfYear = parseDateUnit(captures[1]);
  var month = parseDateUnit(captures[2]) - 1;
  var day = parseDateUnit(captures[3]);
  var week = parseDateUnit(captures[4]);
  var dayOfWeek = parseDateUnit(captures[5]) - 1;
  if (isWeekDate) {
    if (!validateWeekDate(year, week, dayOfWeek)) {
      return new Date(NaN);
    }
    return dayOfISOWeekYear(year, week, dayOfWeek);
  } else {
    var date = new Date(0);
    if (!validateDate(year, month, day) || !validateDayOfYearDate(year, dayOfYear)) {
      return new Date(NaN);
    }
    date.setUTCFullYear(year, month, Math.max(dayOfYear, day));
    return date;
  }
}
function parseDateUnit(value) {
  return value ? parseInt(value) : 1;
}
function parseTime(timeString) {
  var captures = timeString.match(timeRegex);
  if (!captures) return NaN; // Invalid ISO-formatted time

  var hours = parseTimeUnit(captures[1]);
  var minutes = parseTimeUnit(captures[2]);
  var seconds = parseTimeUnit(captures[3]);
  if (!validateTime(hours, minutes, seconds)) {
    return NaN;
  }
  return hours * millisecondsInHour + minutes * millisecondsInMinute + seconds * 1000;
}
function parseTimeUnit(value) {
  return value && parseFloat(value.replace(',', '.')) || 0;
}
function parseTimezone(timezoneString) {
  if (timezoneString === 'Z') return 0;
  var captures = timezoneString.match(timezoneRegex);
  if (!captures) return 0;
  var sign = captures[1] === '+' ? -1 : 1;
  var hours = parseInt(captures[2]);
  var minutes = captures[3] && parseInt(captures[3]) || 0;
  if (!validateTimezone(hours, minutes)) {
    return NaN;
  }
  return sign * (hours * millisecondsInHour + minutes * millisecondsInMinute);
}
function dayOfISOWeekYear(isoWeekYear, week, day) {
  var date = new Date(0);
  date.setUTCFullYear(isoWeekYear, 0, 4);
  var fourthOfJanuaryDay = date.getUTCDay() || 7;
  var diff = (week - 1) * 7 + day + 1 - fourthOfJanuaryDay;
  date.setUTCDate(date.getUTCDate() + diff);
  return date;
}

// Validation functions

// February is null to handle the leap year (using ||)
var daysInMonths = [31, null, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
function isLeapYearIndex(year) {
  return year % 400 === 0 || year % 4 === 0 && year % 100 !== 0;
}
function validateDate(year, month, date) {
  return month >= 0 && month <= 11 && date >= 1 && date <= (daysInMonths[month] || (isLeapYearIndex(year) ? 29 : 28));
}
function validateDayOfYearDate(year, dayOfYear) {
  return dayOfYear >= 1 && dayOfYear <= (isLeapYearIndex(year) ? 366 : 365);
}
function validateWeekDate(_year, week, day) {
  return week >= 1 && week <= 53 && day >= 0 && day <= 6;
}
function validateTime(hours, minutes, seconds) {
  if (hours === 24) {
    return minutes === 0 && seconds === 0;
  }
  return seconds >= 0 && seconds < 60 && minutes >= 0 && minutes < 60 && hours >= 0 && hours < 25;
}
function validateTimezone(_hours, minutes) {
  return minutes >= 0 && minutes <= 59;
}

function _inheritsLoose(subClass, superClass) {
  subClass.prototype = Object.create(superClass.prototype);
  subClass.prototype.constructor = subClass;

  _setPrototypeOf(subClass, superClass);
}

function _setPrototypeOf(o, p) {
  _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
    o.__proto__ = p;
    return o;
  };

  return _setPrototypeOf(o, p);
}

function _objectWithoutPropertiesLoose$2(source, excluded) {
  if (source == null) return {};
  var target = {};
  var sourceKeys = Object.keys(source);
  var key, i;

  for (i = 0; i < sourceKeys.length; i++) {
    key = sourceKeys[i];
    if (excluded.indexOf(key) >= 0) continue;
    target[key] = source[key];
  }

  return target;
}

function _assertThisInitialized(self) {
  if (self === void 0) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return self;
}/**
 * Check whether some DOM node is our Component's node.
 */
function isNodeFound(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // SVG <use/> elements do not technically reside in the rendered DOM, so
  // they do not have classList directly, but they offer a link to their
  // corresponding element, which can have classList. This extra check is for
  // that case.
  // See: http://www.w3.org/TR/SVG11/struct.html#InterfaceSVGUseElement
  // Discussion: https://github.com/Pomax/react-onclickoutside/pull/17


  if (current.correspondingElement) {
    return current.correspondingElement.classList.contains(ignoreClass);
  }

  return current.classList.contains(ignoreClass);
}
/**
 * Try to find our node in a hierarchy of nodes, returning the document
 * node as highest node if our node is not found in the path up.
 */

function findHighest(current, componentNode, ignoreClass) {
  if (current === componentNode) {
    return true;
  } // If source=local then this event came from 'somewhere'
  // inside and should be ignored. We could handle this with
  // a layered approach, too, but that requires going back to
  // thinking in terms of Dom node nesting, running counter
  // to React's 'you shouldn't care about the DOM' philosophy.
  // Also cover shadowRoot node by checking current.host


  while (current.parentNode || current.host) {
    // Only check normal node without shadowRoot
    if (current.parentNode && isNodeFound(current, componentNode, ignoreClass)) {
      return true;
    }

    current = current.parentNode || current.host;
  }

  return current;
}
/**
 * Check if the browser scrollbar was clicked
 */

function clickedScrollbar(evt) {
  return document.documentElement.clientWidth <= evt.clientX || document.documentElement.clientHeight <= evt.clientY;
}// ideally will get replaced with external dep
// when rafrex/detect-passive-events#4 and rafrex/detect-passive-events#5 get merged in
var testPassiveEventSupport = function testPassiveEventSupport() {
  if (typeof window === 'undefined' || typeof window.addEventListener !== 'function') {
    return;
  }

  var passive = false;
  var options = Object.defineProperty({}, 'passive', {
    get: function get() {
      passive = true;
    }
  });

  var noop = function noop() {};

  window.addEventListener('testPassiveEventSupport', noop, options);
  window.removeEventListener('testPassiveEventSupport', noop, options);
  return passive;
};function autoInc(seed) {
  if (seed === void 0) {
    seed = 0;
  }

  return function () {
    return ++seed;
  };
}

var uid = autoInc();var passiveEventSupport;
var handlersMap = {};
var enabledInstances = {};
var touchEvents = ['touchstart', 'touchmove'];
var IGNORE_CLASS_NAME = 'ignore-react-onclickoutside';
/**
 * Options for addEventHandler and removeEventHandler
 */

function getEventHandlerOptions(instance, eventName) {
  var handlerOptions = {};
  var isTouchEvent = touchEvents.indexOf(eventName) !== -1;

  if (isTouchEvent && passiveEventSupport) {
    handlerOptions.passive = !instance.props.preventDefault;
  }

  return handlerOptions;
}
/**
 * This function generates the HOC function that you'll use
 * in order to impart onOutsideClick listening to an
 * arbitrary component. It gets called at the end of the
 * bootstrapping code to yield an instance of the
 * onClickOutsideHOC function defined inside setupHOC().
 */


function onClickOutsideHOC(WrappedComponent, config) {
  var _class, _temp;

  var componentName = WrappedComponent.displayName || WrappedComponent.name || 'Component';
  return _temp = _class = /*#__PURE__*/function (_Component) {
    _inheritsLoose(onClickOutside, _Component);

    function onClickOutside(props) {
      var _this;

      _this = _Component.call(this, props) || this;

      _this.__outsideClickHandler = function (event) {
        if (typeof _this.__clickOutsideHandlerProp === 'function') {
          _this.__clickOutsideHandlerProp(event);

          return;
        }

        var instance = _this.getInstance();

        if (typeof instance.props.handleClickOutside === 'function') {
          instance.props.handleClickOutside(event);
          return;
        }

        if (typeof instance.handleClickOutside === 'function') {
          instance.handleClickOutside(event);
          return;
        }

        throw new Error("WrappedComponent: " + componentName + " lacks a handleClickOutside(event) function for processing outside click events.");
      };

      _this.__getComponentNode = function () {
        var instance = _this.getInstance();

        if (config && typeof config.setClickOutsideRef === 'function') {
          return config.setClickOutsideRef()(instance);
        }

        if (typeof instance.setClickOutsideRef === 'function') {
          return instance.setClickOutsideRef();
        }

        return findDOMNode(instance);
      };

      _this.enableOnClickOutside = function () {
        if (typeof document === 'undefined' || enabledInstances[_this._uid]) {
          return;
        }

        if (typeof passiveEventSupport === 'undefined') {
          passiveEventSupport = testPassiveEventSupport();
        }

        enabledInstances[_this._uid] = true;
        var events = _this.props.eventTypes;

        if (!events.forEach) {
          events = [events];
        }

        handlersMap[_this._uid] = function (event) {
          if (_this.componentNode === null) return;
          if (_this.initTimeStamp > event.timeStamp) return;

          if (_this.props.preventDefault) {
            event.preventDefault();
          }

          if (_this.props.stopPropagation) {
            event.stopPropagation();
          }

          if (_this.props.excludeScrollbar && clickedScrollbar(event)) return;
          var current = event.composed && event.composedPath && event.composedPath().shift() || event.target;

          if (findHighest(current, _this.componentNode, _this.props.outsideClickIgnoreClass) !== document) {
            return;
          }

          _this.__outsideClickHandler(event);
        };

        events.forEach(function (eventName) {
          document.addEventListener(eventName, handlersMap[_this._uid], getEventHandlerOptions(_assertThisInitialized(_this), eventName));
        });
      };

      _this.disableOnClickOutside = function () {
        delete enabledInstances[_this._uid];
        var fn = handlersMap[_this._uid];

        if (fn && typeof document !== 'undefined') {
          var events = _this.props.eventTypes;

          if (!events.forEach) {
            events = [events];
          }

          events.forEach(function (eventName) {
            return document.removeEventListener(eventName, fn, getEventHandlerOptions(_assertThisInitialized(_this), eventName));
          });
          delete handlersMap[_this._uid];
        }
      };

      _this.getRef = function (ref) {
        return _this.instanceRef = ref;
      };

      _this._uid = uid();
      _this.initTimeStamp = performance.now();
      return _this;
    }
    /**
     * Access the WrappedComponent's instance.
     */


    var _proto = onClickOutside.prototype;

    _proto.getInstance = function getInstance() {
      if (WrappedComponent.prototype && !WrappedComponent.prototype.isReactComponent) {
        return this;
      }

      var ref = this.instanceRef;
      return ref.getInstance ? ref.getInstance() : ref;
    };

    /**
     * Add click listeners to the current document,
     * linked to this component's state.
     */
    _proto.componentDidMount = function componentDidMount() {
      // If we are in an environment without a DOM such
      // as shallow rendering or snapshots then we exit
      // early to prevent any unhandled errors being thrown.
      if (typeof document === 'undefined' || !document.createElement) {
        return;
      }

      var instance = this.getInstance();

      if (config && typeof config.handleClickOutside === 'function') {
        this.__clickOutsideHandlerProp = config.handleClickOutside(instance);

        if (typeof this.__clickOutsideHandlerProp !== 'function') {
          throw new Error("WrappedComponent: " + componentName + " lacks a function for processing outside click events specified by the handleClickOutside config option.");
        }
      }

      this.componentNode = this.__getComponentNode(); // return early so we dont initiate onClickOutside

      if (this.props.disableOnClickOutside) return;
      this.enableOnClickOutside();
    };

    _proto.componentDidUpdate = function componentDidUpdate() {
      this.componentNode = this.__getComponentNode();
    }
    /**
     * Remove all document's event listeners for this component
     */
    ;

    _proto.componentWillUnmount = function componentWillUnmount() {
      this.disableOnClickOutside();
    }
    /**
     * Can be called to explicitly enable event listening
     * for clicks and touches outside of this element.
     */
    ;

    /**
     * Pass-through render
     */
    _proto.render = function render() {
      // eslint-disable-next-line no-unused-vars
      var _this$props = this.props;
          _this$props.excludeScrollbar;
          var props = _objectWithoutPropertiesLoose$2(_this$props, ["excludeScrollbar"]);

      if (WrappedComponent.prototype && WrappedComponent.prototype.isReactComponent) {
        props.ref = this.getRef;
      } else {
        props.wrappedRef = this.getRef;
      }

      props.disableOnClickOutside = this.disableOnClickOutside;
      props.enableOnClickOutside = this.enableOnClickOutside;
      return createElement(WrappedComponent, props);
    };

    return onClickOutside;
  }(Component), _class.displayName = "OnClickOutside(" + componentName + ")", _class.defaultProps = {
    eventTypes: ['mousedown', 'touchstart'],
    excludeScrollbar: config && config.excludeScrollbar || false,
    outsideClickIgnoreClass: IGNORE_CLASS_NAME,
    preventDefault: false,
    stopPropagation: false
  }, _class.getClass = function () {
    return WrappedComponent.getClass ? WrappedComponent.getClass() : WrappedComponent;
  }, _temp;
}

var ManagerReferenceNodeContext = React.createContext();
var ManagerReferenceNodeSetterContext = React.createContext();
function Manager(_ref) {
  var children = _ref.children;

  var _React$useState = React.useState(null),
      referenceNode = _React$useState[0],
      setReferenceNode = _React$useState[1];

  var hasUnmounted = React.useRef(false);
  React.useEffect(function () {
    return function () {
      hasUnmounted.current = true;
    };
  }, []);
  var handleSetReferenceNode = React.useCallback(function (node) {
    if (!hasUnmounted.current) {
      setReferenceNode(node);
    }
  }, []);
  return /*#__PURE__*/React.createElement(ManagerReferenceNodeContext.Provider, {
    value: referenceNode
  }, /*#__PURE__*/React.createElement(ManagerReferenceNodeSetterContext.Provider, {
    value: handleSetReferenceNode
  }, children));
}

/**
 * Takes an argument and if it's an array, returns the first item in the array,
 * otherwise returns the argument. Used for Preact compatibility.
 */
var unwrapArray = function unwrapArray(arg) {
  return Array.isArray(arg) ? arg[0] : arg;
};
/**
 * Takes a maybe-undefined function and arbitrary args and invokes the function
 * only if it is defined.
 */

var safeInvoke = function safeInvoke(fn) {
  if (typeof fn === 'function') {
    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
      args[_key - 1] = arguments[_key];
    }

    return fn.apply(void 0, args);
  }
};
/**
 * Sets a ref using either a ref callback or a ref object
 */

var setRef = function setRef(ref, node) {
  // if its a function call it
  if (typeof ref === 'function') {
    return safeInvoke(ref, node);
  } // otherwise we should treat it as a ref object
  else if (ref != null) {
      ref.current = node;
    }
};
/**
 * Simple ponyfill for Object.fromEntries
 */

var fromEntries = function fromEntries(entries) {
  return entries.reduce(function (acc, _ref) {
    var key = _ref[0],
        value = _ref[1];
    acc[key] = value;
    return acc;
  }, {});
};
/**
 * Small wrapper around `useLayoutEffect` to get rid of the warning on SSR envs
 */

var useIsomorphicLayoutEffect = typeof window !== 'undefined' && window.document && window.document.createElement ? React.useLayoutEffect : React.useEffect;

var top = 'top';
var bottom = 'bottom';
var right = 'right';
var left = 'left';
var auto = 'auto';
var basePlacements = [top, bottom, right, left];
var start = 'start';
var end = 'end';
var clippingParents = 'clippingParents';
var viewport = 'viewport';
var popper = 'popper';
var reference = 'reference';
var variationPlacements = /*#__PURE__*/basePlacements.reduce(function (acc, placement) {
  return acc.concat([placement + "-" + start, placement + "-" + end]);
}, []);
var placements = /*#__PURE__*/[].concat(basePlacements, [auto]).reduce(function (acc, placement) {
  return acc.concat([placement, placement + "-" + start, placement + "-" + end]);
}, []); // modifiers that need to read the DOM

var beforeRead = 'beforeRead';
var read = 'read';
var afterRead = 'afterRead'; // pure-logic modifiers

var beforeMain = 'beforeMain';
var main = 'main';
var afterMain = 'afterMain'; // modifier with the purpose to write to the DOM (or write into a framework state)

var beforeWrite = 'beforeWrite';
var write = 'write';
var afterWrite = 'afterWrite';
var modifierPhases = [beforeRead, read, afterRead, beforeMain, main, afterMain, beforeWrite, write, afterWrite];

function getNodeName(element) {
  return element ? (element.nodeName || '').toLowerCase() : null;
}

function getWindow(node) {
  if (node == null) {
    return window;
  }

  if (node.toString() !== '[object Window]') {
    var ownerDocument = node.ownerDocument;
    return ownerDocument ? ownerDocument.defaultView || window : window;
  }

  return node;
}

function isElement$1(node) {
  var OwnElement = getWindow(node).Element;
  return node instanceof OwnElement || node instanceof Element;
}

function isHTMLElement(node) {
  var OwnElement = getWindow(node).HTMLElement;
  return node instanceof OwnElement || node instanceof HTMLElement;
}

function isShadowRoot(node) {
  // IE 11 has no ShadowRoot
  if (typeof ShadowRoot === 'undefined') {
    return false;
  }

  var OwnElement = getWindow(node).ShadowRoot;
  return node instanceof OwnElement || node instanceof ShadowRoot;
}

// and applies them to the HTMLElements such as popper and arrow

function applyStyles(_ref) {
  var state = _ref.state;
  Object.keys(state.elements).forEach(function (name) {
    var style = state.styles[name] || {};
    var attributes = state.attributes[name] || {};
    var element = state.elements[name]; // arrow is optional + virtual elements

    if (!isHTMLElement(element) || !getNodeName(element)) {
      return;
    } // Flow doesn't support to extend this property, but it's the most
    // effective way to apply styles to an HTMLElement
    // $FlowFixMe[cannot-write]


    Object.assign(element.style, style);
    Object.keys(attributes).forEach(function (name) {
      var value = attributes[name];

      if (value === false) {
        element.removeAttribute(name);
      } else {
        element.setAttribute(name, value === true ? '' : value);
      }
    });
  });
}

function effect$2(_ref2) {
  var state = _ref2.state;
  var initialStyles = {
    popper: {
      position: state.options.strategy,
      left: '0',
      top: '0',
      margin: '0'
    },
    arrow: {
      position: 'absolute'
    },
    reference: {}
  };
  Object.assign(state.elements.popper.style, initialStyles.popper);
  state.styles = initialStyles;

  if (state.elements.arrow) {
    Object.assign(state.elements.arrow.style, initialStyles.arrow);
  }

  return function () {
    Object.keys(state.elements).forEach(function (name) {
      var element = state.elements[name];
      var attributes = state.attributes[name] || {};
      var styleProperties = Object.keys(state.styles.hasOwnProperty(name) ? state.styles[name] : initialStyles[name]); // Set all values to an empty string to unset them

      var style = styleProperties.reduce(function (style, property) {
        style[property] = '';
        return style;
      }, {}); // arrow is optional + virtual elements

      if (!isHTMLElement(element) || !getNodeName(element)) {
        return;
      }

      Object.assign(element.style, style);
      Object.keys(attributes).forEach(function (attribute) {
        element.removeAttribute(attribute);
      });
    });
  };
} // eslint-disable-next-line import/no-unused-modules


var applyStyles$1 = {
  name: 'applyStyles',
  enabled: true,
  phase: 'write',
  fn: applyStyles,
  effect: effect$2,
  requires: ['computeStyles']
};

function getBasePlacement(placement) {
  return placement.split('-')[0];
}

var max = Math.max;
var min = Math.min;
var round = Math.round;

function getUAString() {
  var uaData = navigator.userAgentData;

  if (uaData != null && uaData.brands && Array.isArray(uaData.brands)) {
    return uaData.brands.map(function (item) {
      return item.brand + "/" + item.version;
    }).join(' ');
  }

  return navigator.userAgent;
}

function isLayoutViewport() {
  return !/^((?!chrome|android).)*safari/i.test(getUAString());
}

function getBoundingClientRect(element, includeScale, isFixedStrategy) {
  if (includeScale === void 0) {
    includeScale = false;
  }

  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }

  var clientRect = element.getBoundingClientRect();
  var scaleX = 1;
  var scaleY = 1;

  if (includeScale && isHTMLElement(element)) {
    scaleX = element.offsetWidth > 0 ? round(clientRect.width) / element.offsetWidth || 1 : 1;
    scaleY = element.offsetHeight > 0 ? round(clientRect.height) / element.offsetHeight || 1 : 1;
  }

  var _ref = isElement$1(element) ? getWindow(element) : window,
      visualViewport = _ref.visualViewport;

  var addVisualOffsets = !isLayoutViewport() && isFixedStrategy;
  var x = (clientRect.left + (addVisualOffsets && visualViewport ? visualViewport.offsetLeft : 0)) / scaleX;
  var y = (clientRect.top + (addVisualOffsets && visualViewport ? visualViewport.offsetTop : 0)) / scaleY;
  var width = clientRect.width / scaleX;
  var height = clientRect.height / scaleY;
  return {
    width: width,
    height: height,
    top: y,
    right: x + width,
    bottom: y + height,
    left: x,
    x: x,
    y: y
  };
}

// means it doesn't take into account transforms.

function getLayoutRect(element) {
  var clientRect = getBoundingClientRect(element); // Use the clientRect sizes if it's not been transformed.
  // Fixes https://github.com/popperjs/popper-core/issues/1223

  var width = element.offsetWidth;
  var height = element.offsetHeight;

  if (Math.abs(clientRect.width - width) <= 1) {
    width = clientRect.width;
  }

  if (Math.abs(clientRect.height - height) <= 1) {
    height = clientRect.height;
  }

  return {
    x: element.offsetLeft,
    y: element.offsetTop,
    width: width,
    height: height
  };
}

function contains(parent, child) {
  var rootNode = child.getRootNode && child.getRootNode(); // First, attempt with faster native method

  if (parent.contains(child)) {
    return true;
  } // then fallback to custom implementation with Shadow DOM support
  else if (rootNode && isShadowRoot(rootNode)) {
      var next = child;

      do {
        if (next && parent.isSameNode(next)) {
          return true;
        } // $FlowFixMe[prop-missing]: need a better way to handle this...


        next = next.parentNode || next.host;
      } while (next);
    } // Give up, the result is false


  return false;
}

function getComputedStyle(element) {
  return getWindow(element).getComputedStyle(element);
}

function isTableElement(element) {
  return ['table', 'td', 'th'].indexOf(getNodeName(element)) >= 0;
}

function getDocumentElement(element) {
  // $FlowFixMe[incompatible-return]: assume body is always available
  return ((isElement$1(element) ? element.ownerDocument : // $FlowFixMe[prop-missing]
  element.document) || window.document).documentElement;
}

function getParentNode(element) {
  if (getNodeName(element) === 'html') {
    return element;
  }

  return (// this is a quicker (but less type safe) way to save quite some bytes from the bundle
    // $FlowFixMe[incompatible-return]
    // $FlowFixMe[prop-missing]
    element.assignedSlot || // step into the shadow DOM of the parent of a slotted node
    element.parentNode || ( // DOM Element detected
    isShadowRoot(element) ? element.host : null) || // ShadowRoot detected
    // $FlowFixMe[incompatible-call]: HTMLElement is a Node
    getDocumentElement(element) // fallback

  );
}

function getTrueOffsetParent(element) {
  if (!isHTMLElement(element) || // https://github.com/popperjs/popper-core/issues/837
  getComputedStyle(element).position === 'fixed') {
    return null;
  }

  return element.offsetParent;
} // `.offsetParent` reports `null` for fixed elements, while absolute elements
// return the containing block


function getContainingBlock(element) {
  var isFirefox = /firefox/i.test(getUAString());
  var isIE = /Trident/i.test(getUAString());

  if (isIE && isHTMLElement(element)) {
    // In IE 9, 10 and 11 fixed elements containing block is always established by the viewport
    var elementCss = getComputedStyle(element);

    if (elementCss.position === 'fixed') {
      return null;
    }
  }

  var currentNode = getParentNode(element);

  if (isShadowRoot(currentNode)) {
    currentNode = currentNode.host;
  }

  while (isHTMLElement(currentNode) && ['html', 'body'].indexOf(getNodeName(currentNode)) < 0) {
    var css = getComputedStyle(currentNode); // This is non-exhaustive but covers the most common CSS properties that
    // create a containing block.
    // https://developer.mozilla.org/en-US/docs/Web/CSS/Containing_block#identifying_the_containing_block

    if (css.transform !== 'none' || css.perspective !== 'none' || css.contain === 'paint' || ['transform', 'perspective'].indexOf(css.willChange) !== -1 || isFirefox && css.willChange === 'filter' || isFirefox && css.filter && css.filter !== 'none') {
      return currentNode;
    } else {
      currentNode = currentNode.parentNode;
    }
  }

  return null;
} // Gets the closest ancestor positioned element. Handles some edge cases,
// such as table ancestors and cross browser bugs.


function getOffsetParent(element) {
  var window = getWindow(element);
  var offsetParent = getTrueOffsetParent(element);

  while (offsetParent && isTableElement(offsetParent) && getComputedStyle(offsetParent).position === 'static') {
    offsetParent = getTrueOffsetParent(offsetParent);
  }

  if (offsetParent && (getNodeName(offsetParent) === 'html' || getNodeName(offsetParent) === 'body' && getComputedStyle(offsetParent).position === 'static')) {
    return window;
  }

  return offsetParent || getContainingBlock(element) || window;
}

function getMainAxisFromPlacement(placement) {
  return ['top', 'bottom'].indexOf(placement) >= 0 ? 'x' : 'y';
}

function within(min$1, value, max$1) {
  return max(min$1, min(value, max$1));
}
function withinMaxClamp(min, value, max) {
  var v = within(min, value, max);
  return v > max ? max : v;
}

function getFreshSideObject() {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0
  };
}

function mergePaddingObject(paddingObject) {
  return Object.assign({}, getFreshSideObject(), paddingObject);
}

function expandToHashMap(value, keys) {
  return keys.reduce(function (hashMap, key) {
    hashMap[key] = value;
    return hashMap;
  }, {});
}

var toPaddingObject = function toPaddingObject(padding, state) {
  padding = typeof padding === 'function' ? padding(Object.assign({}, state.rects, {
    placement: state.placement
  })) : padding;
  return mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
};

function arrow(_ref) {
  var _state$modifiersData$;

  var state = _ref.state,
      name = _ref.name,
      options = _ref.options;
  var arrowElement = state.elements.arrow;
  var popperOffsets = state.modifiersData.popperOffsets;
  var basePlacement = getBasePlacement(state.placement);
  var axis = getMainAxisFromPlacement(basePlacement);
  var isVertical = [left, right].indexOf(basePlacement) >= 0;
  var len = isVertical ? 'height' : 'width';

  if (!arrowElement || !popperOffsets) {
    return;
  }

  var paddingObject = toPaddingObject(options.padding, state);
  var arrowRect = getLayoutRect(arrowElement);
  var minProp = axis === 'y' ? top : left;
  var maxProp = axis === 'y' ? bottom : right;
  var endDiff = state.rects.reference[len] + state.rects.reference[axis] - popperOffsets[axis] - state.rects.popper[len];
  var startDiff = popperOffsets[axis] - state.rects.reference[axis];
  var arrowOffsetParent = getOffsetParent(arrowElement);
  var clientSize = arrowOffsetParent ? axis === 'y' ? arrowOffsetParent.clientHeight || 0 : arrowOffsetParent.clientWidth || 0 : 0;
  var centerToReference = endDiff / 2 - startDiff / 2; // Make sure the arrow doesn't overflow the popper if the center point is
  // outside of the popper bounds

  var min = paddingObject[minProp];
  var max = clientSize - arrowRect[len] - paddingObject[maxProp];
  var center = clientSize / 2 - arrowRect[len] / 2 + centerToReference;
  var offset = within(min, center, max); // Prevents breaking syntax highlighting...

  var axisProp = axis;
  state.modifiersData[name] = (_state$modifiersData$ = {}, _state$modifiersData$[axisProp] = offset, _state$modifiersData$.centerOffset = offset - center, _state$modifiersData$);
}

function effect$1(_ref2) {
  var state = _ref2.state,
      options = _ref2.options;
  var _options$element = options.element,
      arrowElement = _options$element === void 0 ? '[data-popper-arrow]' : _options$element;

  if (arrowElement == null) {
    return;
  } // CSS selector


  if (typeof arrowElement === 'string') {
    arrowElement = state.elements.popper.querySelector(arrowElement);

    if (!arrowElement) {
      return;
    }
  }

  if (!contains(state.elements.popper, arrowElement)) {
    return;
  }

  state.elements.arrow = arrowElement;
} // eslint-disable-next-line import/no-unused-modules


var arrow$1 = {
  name: 'arrow',
  enabled: true,
  phase: 'main',
  fn: arrow,
  effect: effect$1,
  requires: ['popperOffsets'],
  requiresIfExists: ['preventOverflow']
};

function getVariation(placement) {
  return placement.split('-')[1];
}

var unsetSides = {
  top: 'auto',
  right: 'auto',
  bottom: 'auto',
  left: 'auto'
}; // Round the offsets to the nearest suitable subpixel based on the DPR.
// Zooming can change the DPR, but it seems to report a value that will
// cleanly divide the values into the appropriate subpixels.

function roundOffsetsByDPR(_ref, win) {
  var x = _ref.x,
      y = _ref.y;
  var dpr = win.devicePixelRatio || 1;
  return {
    x: round(x * dpr) / dpr || 0,
    y: round(y * dpr) / dpr || 0
  };
}

function mapToStyles(_ref2) {
  var _Object$assign2;

  var popper = _ref2.popper,
      popperRect = _ref2.popperRect,
      placement = _ref2.placement,
      variation = _ref2.variation,
      offsets = _ref2.offsets,
      position = _ref2.position,
      gpuAcceleration = _ref2.gpuAcceleration,
      adaptive = _ref2.adaptive,
      roundOffsets = _ref2.roundOffsets,
      isFixed = _ref2.isFixed;
  var _offsets$x = offsets.x,
      x = _offsets$x === void 0 ? 0 : _offsets$x,
      _offsets$y = offsets.y,
      y = _offsets$y === void 0 ? 0 : _offsets$y;

  var _ref3 = typeof roundOffsets === 'function' ? roundOffsets({
    x: x,
    y: y
  }) : {
    x: x,
    y: y
  };

  x = _ref3.x;
  y = _ref3.y;
  var hasX = offsets.hasOwnProperty('x');
  var hasY = offsets.hasOwnProperty('y');
  var sideX = left;
  var sideY = top;
  var win = window;

  if (adaptive) {
    var offsetParent = getOffsetParent(popper);
    var heightProp = 'clientHeight';
    var widthProp = 'clientWidth';

    if (offsetParent === getWindow(popper)) {
      offsetParent = getDocumentElement(popper);

      if (getComputedStyle(offsetParent).position !== 'static' && position === 'absolute') {
        heightProp = 'scrollHeight';
        widthProp = 'scrollWidth';
      }
    } // $FlowFixMe[incompatible-cast]: force type refinement, we compare offsetParent with window above, but Flow doesn't detect it


    offsetParent = offsetParent;

    if (placement === top || (placement === left || placement === right) && variation === end) {
      sideY = bottom;
      var offsetY = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.height : // $FlowFixMe[prop-missing]
      offsetParent[heightProp];
      y -= offsetY - popperRect.height;
      y *= gpuAcceleration ? 1 : -1;
    }

    if (placement === left || (placement === top || placement === bottom) && variation === end) {
      sideX = right;
      var offsetX = isFixed && offsetParent === win && win.visualViewport ? win.visualViewport.width : // $FlowFixMe[prop-missing]
      offsetParent[widthProp];
      x -= offsetX - popperRect.width;
      x *= gpuAcceleration ? 1 : -1;
    }
  }

  var commonStyles = Object.assign({
    position: position
  }, adaptive && unsetSides);

  var _ref4 = roundOffsets === true ? roundOffsetsByDPR({
    x: x,
    y: y
  }, getWindow(popper)) : {
    x: x,
    y: y
  };

  x = _ref4.x;
  y = _ref4.y;

  if (gpuAcceleration) {
    var _Object$assign;

    return Object.assign({}, commonStyles, (_Object$assign = {}, _Object$assign[sideY] = hasY ? '0' : '', _Object$assign[sideX] = hasX ? '0' : '', _Object$assign.transform = (win.devicePixelRatio || 1) <= 1 ? "translate(" + x + "px, " + y + "px)" : "translate3d(" + x + "px, " + y + "px, 0)", _Object$assign));
  }

  return Object.assign({}, commonStyles, (_Object$assign2 = {}, _Object$assign2[sideY] = hasY ? y + "px" : '', _Object$assign2[sideX] = hasX ? x + "px" : '', _Object$assign2.transform = '', _Object$assign2));
}

function computeStyles(_ref5) {
  var state = _ref5.state,
      options = _ref5.options;
  var _options$gpuAccelerat = options.gpuAcceleration,
      gpuAcceleration = _options$gpuAccelerat === void 0 ? true : _options$gpuAccelerat,
      _options$adaptive = options.adaptive,
      adaptive = _options$adaptive === void 0 ? true : _options$adaptive,
      _options$roundOffsets = options.roundOffsets,
      roundOffsets = _options$roundOffsets === void 0 ? true : _options$roundOffsets;
  var commonStyles = {
    placement: getBasePlacement(state.placement),
    variation: getVariation(state.placement),
    popper: state.elements.popper,
    popperRect: state.rects.popper,
    gpuAcceleration: gpuAcceleration,
    isFixed: state.options.strategy === 'fixed'
  };

  if (state.modifiersData.popperOffsets != null) {
    state.styles.popper = Object.assign({}, state.styles.popper, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.popperOffsets,
      position: state.options.strategy,
      adaptive: adaptive,
      roundOffsets: roundOffsets
    })));
  }

  if (state.modifiersData.arrow != null) {
    state.styles.arrow = Object.assign({}, state.styles.arrow, mapToStyles(Object.assign({}, commonStyles, {
      offsets: state.modifiersData.arrow,
      position: 'absolute',
      adaptive: false,
      roundOffsets: roundOffsets
    })));
  }

  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-placement': state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var computeStyles$1 = {
  name: 'computeStyles',
  enabled: true,
  phase: 'beforeWrite',
  fn: computeStyles,
  data: {}
};

var passive = {
  passive: true
};

function effect(_ref) {
  var state = _ref.state,
      instance = _ref.instance,
      options = _ref.options;
  var _options$scroll = options.scroll,
      scroll = _options$scroll === void 0 ? true : _options$scroll,
      _options$resize = options.resize,
      resize = _options$resize === void 0 ? true : _options$resize;
  var window = getWindow(state.elements.popper);
  var scrollParents = [].concat(state.scrollParents.reference, state.scrollParents.popper);

  if (scroll) {
    scrollParents.forEach(function (scrollParent) {
      scrollParent.addEventListener('scroll', instance.update, passive);
    });
  }

  if (resize) {
    window.addEventListener('resize', instance.update, passive);
  }

  return function () {
    if (scroll) {
      scrollParents.forEach(function (scrollParent) {
        scrollParent.removeEventListener('scroll', instance.update, passive);
      });
    }

    if (resize) {
      window.removeEventListener('resize', instance.update, passive);
    }
  };
} // eslint-disable-next-line import/no-unused-modules


var eventListeners = {
  name: 'eventListeners',
  enabled: true,
  phase: 'write',
  fn: function fn() {},
  effect: effect,
  data: {}
};

var hash$1 = {
  left: 'right',
  right: 'left',
  bottom: 'top',
  top: 'bottom'
};
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, function (matched) {
    return hash$1[matched];
  });
}

var hash = {
  start: 'end',
  end: 'start'
};
function getOppositeVariationPlacement(placement) {
  return placement.replace(/start|end/g, function (matched) {
    return hash[matched];
  });
}

function getWindowScroll(node) {
  var win = getWindow(node);
  var scrollLeft = win.pageXOffset;
  var scrollTop = win.pageYOffset;
  return {
    scrollLeft: scrollLeft,
    scrollTop: scrollTop
  };
}

function getWindowScrollBarX(element) {
  // If <html> has a CSS width greater than the viewport, then this will be
  // incorrect for RTL.
  // Popper 1 is broken in this case and never had a bug report so let's assume
  // it's not an issue. I don't think anyone ever specifies width on <html>
  // anyway.
  // Browsers where the left scrollbar doesn't cause an issue report `0` for
  // this (e.g. Edge 2019, IE11, Safari)
  return getBoundingClientRect(getDocumentElement(element)).left + getWindowScroll(element).scrollLeft;
}

function getViewportRect(element, strategy) {
  var win = getWindow(element);
  var html = getDocumentElement(element);
  var visualViewport = win.visualViewport;
  var width = html.clientWidth;
  var height = html.clientHeight;
  var x = 0;
  var y = 0;

  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    var layoutViewport = isLayoutViewport();

    if (layoutViewport || !layoutViewport && strategy === 'fixed') {
      x = visualViewport.offsetLeft;
      y = visualViewport.offsetTop;
    }
  }

  return {
    width: width,
    height: height,
    x: x + getWindowScrollBarX(element),
    y: y
  };
}

// of the `<html>` and `<body>` rect bounds if horizontally scrollable

function getDocumentRect(element) {
  var _element$ownerDocumen;

  var html = getDocumentElement(element);
  var winScroll = getWindowScroll(element);
  var body = (_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body;
  var width = max(html.scrollWidth, html.clientWidth, body ? body.scrollWidth : 0, body ? body.clientWidth : 0);
  var height = max(html.scrollHeight, html.clientHeight, body ? body.scrollHeight : 0, body ? body.clientHeight : 0);
  var x = -winScroll.scrollLeft + getWindowScrollBarX(element);
  var y = -winScroll.scrollTop;

  if (getComputedStyle(body || html).direction === 'rtl') {
    x += max(html.clientWidth, body ? body.clientWidth : 0) - width;
  }

  return {
    width: width,
    height: height,
    x: x,
    y: y
  };
}

function isScrollParent(element) {
  // Firefox wants us to check `-x` and `-y` variations as well
  var _getComputedStyle = getComputedStyle(element),
      overflow = _getComputedStyle.overflow,
      overflowX = _getComputedStyle.overflowX,
      overflowY = _getComputedStyle.overflowY;

  return /auto|scroll|overlay|hidden/.test(overflow + overflowY + overflowX);
}

function getScrollParent(node) {
  if (['html', 'body', '#document'].indexOf(getNodeName(node)) >= 0) {
    // $FlowFixMe[incompatible-return]: assume body is always available
    return node.ownerDocument.body;
  }

  if (isHTMLElement(node) && isScrollParent(node)) {
    return node;
  }

  return getScrollParent(getParentNode(node));
}

/*
given a DOM element, return the list of all scroll parents, up the list of ancesors
until we get to the top window object. This list is what we attach scroll listeners
to, because if any of these parent elements scroll, we'll need to re-calculate the
reference element's position.
*/

function listScrollParents(element, list) {
  var _element$ownerDocumen;

  if (list === void 0) {
    list = [];
  }

  var scrollParent = getScrollParent(element);
  var isBody = scrollParent === ((_element$ownerDocumen = element.ownerDocument) == null ? void 0 : _element$ownerDocumen.body);
  var win = getWindow(scrollParent);
  var target = isBody ? [win].concat(win.visualViewport || [], isScrollParent(scrollParent) ? scrollParent : []) : scrollParent;
  var updatedList = list.concat(target);
  return isBody ? updatedList : // $FlowFixMe[incompatible-call]: isBody tells us target will be an HTMLElement here
  updatedList.concat(listScrollParents(getParentNode(target)));
}

function rectToClientRect(rect) {
  return Object.assign({}, rect, {
    left: rect.x,
    top: rect.y,
    right: rect.x + rect.width,
    bottom: rect.y + rect.height
  });
}

function getInnerBoundingClientRect(element, strategy) {
  var rect = getBoundingClientRect(element, false, strategy === 'fixed');
  rect.top = rect.top + element.clientTop;
  rect.left = rect.left + element.clientLeft;
  rect.bottom = rect.top + element.clientHeight;
  rect.right = rect.left + element.clientWidth;
  rect.width = element.clientWidth;
  rect.height = element.clientHeight;
  rect.x = rect.left;
  rect.y = rect.top;
  return rect;
}

function getClientRectFromMixedType(element, clippingParent, strategy) {
  return clippingParent === viewport ? rectToClientRect(getViewportRect(element, strategy)) : isElement$1(clippingParent) ? getInnerBoundingClientRect(clippingParent, strategy) : rectToClientRect(getDocumentRect(getDocumentElement(element)));
} // A "clipping parent" is an overflowable container with the characteristic of
// clipping (or hiding) overflowing elements with a position different from
// `initial`


function getClippingParents(element) {
  var clippingParents = listScrollParents(getParentNode(element));
  var canEscapeClipping = ['absolute', 'fixed'].indexOf(getComputedStyle(element).position) >= 0;
  var clipperElement = canEscapeClipping && isHTMLElement(element) ? getOffsetParent(element) : element;

  if (!isElement$1(clipperElement)) {
    return [];
  } // $FlowFixMe[incompatible-return]: https://github.com/facebook/flow/issues/1414


  return clippingParents.filter(function (clippingParent) {
    return isElement$1(clippingParent) && contains(clippingParent, clipperElement) && getNodeName(clippingParent) !== 'body';
  });
} // Gets the maximum area that the element is visible in due to any number of
// clipping parents


function getClippingRect(element, boundary, rootBoundary, strategy) {
  var mainClippingParents = boundary === 'clippingParents' ? getClippingParents(element) : [].concat(boundary);
  var clippingParents = [].concat(mainClippingParents, [rootBoundary]);
  var firstClippingParent = clippingParents[0];
  var clippingRect = clippingParents.reduce(function (accRect, clippingParent) {
    var rect = getClientRectFromMixedType(element, clippingParent, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromMixedType(element, firstClippingParent, strategy));
  clippingRect.width = clippingRect.right - clippingRect.left;
  clippingRect.height = clippingRect.bottom - clippingRect.top;
  clippingRect.x = clippingRect.left;
  clippingRect.y = clippingRect.top;
  return clippingRect;
}

function computeOffsets(_ref) {
  var reference = _ref.reference,
      element = _ref.element,
      placement = _ref.placement;
  var basePlacement = placement ? getBasePlacement(placement) : null;
  var variation = placement ? getVariation(placement) : null;
  var commonX = reference.x + reference.width / 2 - element.width / 2;
  var commonY = reference.y + reference.height / 2 - element.height / 2;
  var offsets;

  switch (basePlacement) {
    case top:
      offsets = {
        x: commonX,
        y: reference.y - element.height
      };
      break;

    case bottom:
      offsets = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;

    case right:
      offsets = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;

    case left:
      offsets = {
        x: reference.x - element.width,
        y: commonY
      };
      break;

    default:
      offsets = {
        x: reference.x,
        y: reference.y
      };
  }

  var mainAxis = basePlacement ? getMainAxisFromPlacement(basePlacement) : null;

  if (mainAxis != null) {
    var len = mainAxis === 'y' ? 'height' : 'width';

    switch (variation) {
      case start:
        offsets[mainAxis] = offsets[mainAxis] - (reference[len] / 2 - element[len] / 2);
        break;

      case end:
        offsets[mainAxis] = offsets[mainAxis] + (reference[len] / 2 - element[len] / 2);
        break;
    }
  }

  return offsets;
}

function detectOverflow(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      _options$placement = _options.placement,
      placement = _options$placement === void 0 ? state.placement : _options$placement,
      _options$strategy = _options.strategy,
      strategy = _options$strategy === void 0 ? state.strategy : _options$strategy,
      _options$boundary = _options.boundary,
      boundary = _options$boundary === void 0 ? clippingParents : _options$boundary,
      _options$rootBoundary = _options.rootBoundary,
      rootBoundary = _options$rootBoundary === void 0 ? viewport : _options$rootBoundary,
      _options$elementConte = _options.elementContext,
      elementContext = _options$elementConte === void 0 ? popper : _options$elementConte,
      _options$altBoundary = _options.altBoundary,
      altBoundary = _options$altBoundary === void 0 ? false : _options$altBoundary,
      _options$padding = _options.padding,
      padding = _options$padding === void 0 ? 0 : _options$padding;
  var paddingObject = mergePaddingObject(typeof padding !== 'number' ? padding : expandToHashMap(padding, basePlacements));
  var altContext = elementContext === popper ? reference : popper;
  var popperRect = state.rects.popper;
  var element = state.elements[altBoundary ? altContext : elementContext];
  var clippingClientRect = getClippingRect(isElement$1(element) ? element : element.contextElement || getDocumentElement(state.elements.popper), boundary, rootBoundary, strategy);
  var referenceClientRect = getBoundingClientRect(state.elements.reference);
  var popperOffsets = computeOffsets({
    reference: referenceClientRect,
    element: popperRect,
    strategy: 'absolute',
    placement: placement
  });
  var popperClientRect = rectToClientRect(Object.assign({}, popperRect, popperOffsets));
  var elementClientRect = elementContext === popper ? popperClientRect : referenceClientRect; // positive = overflowing the clipping rect
  // 0 or negative = within the clipping rect

  var overflowOffsets = {
    top: clippingClientRect.top - elementClientRect.top + paddingObject.top,
    bottom: elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom,
    left: clippingClientRect.left - elementClientRect.left + paddingObject.left,
    right: elementClientRect.right - clippingClientRect.right + paddingObject.right
  };
  var offsetData = state.modifiersData.offset; // Offsets can be applied only to the popper element

  if (elementContext === popper && offsetData) {
    var offset = offsetData[placement];
    Object.keys(overflowOffsets).forEach(function (key) {
      var multiply = [right, bottom].indexOf(key) >= 0 ? 1 : -1;
      var axis = [top, bottom].indexOf(key) >= 0 ? 'y' : 'x';
      overflowOffsets[key] += offset[axis] * multiply;
    });
  }

  return overflowOffsets;
}

function computeAutoPlacement(state, options) {
  if (options === void 0) {
    options = {};
  }

  var _options = options,
      placement = _options.placement,
      boundary = _options.boundary,
      rootBoundary = _options.rootBoundary,
      padding = _options.padding,
      flipVariations = _options.flipVariations,
      _options$allowedAutoP = _options.allowedAutoPlacements,
      allowedAutoPlacements = _options$allowedAutoP === void 0 ? placements : _options$allowedAutoP;
  var variation = getVariation(placement);
  var placements$1 = variation ? flipVariations ? variationPlacements : variationPlacements.filter(function (placement) {
    return getVariation(placement) === variation;
  }) : basePlacements;
  var allowedPlacements = placements$1.filter(function (placement) {
    return allowedAutoPlacements.indexOf(placement) >= 0;
  });

  if (allowedPlacements.length === 0) {
    allowedPlacements = placements$1;
  } // $FlowFixMe[incompatible-type]: Flow seems to have problems with two array unions...


  var overflows = allowedPlacements.reduce(function (acc, placement) {
    acc[placement] = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding
    })[getBasePlacement(placement)];
    return acc;
  }, {});
  return Object.keys(overflows).sort(function (a, b) {
    return overflows[a] - overflows[b];
  });
}

function getExpandedFallbackPlacements(placement) {
  if (getBasePlacement(placement) === auto) {
    return [];
  }

  var oppositePlacement = getOppositePlacement(placement);
  return [getOppositeVariationPlacement(placement), oppositePlacement, getOppositeVariationPlacement(oppositePlacement)];
}

function flip(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;

  if (state.modifiersData[name]._skip) {
    return;
  }

  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? true : _options$altAxis,
      specifiedFallbackPlacements = options.fallbackPlacements,
      padding = options.padding,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      _options$flipVariatio = options.flipVariations,
      flipVariations = _options$flipVariatio === void 0 ? true : _options$flipVariatio,
      allowedAutoPlacements = options.allowedAutoPlacements;
  var preferredPlacement = state.options.placement;
  var basePlacement = getBasePlacement(preferredPlacement);
  var isBasePlacement = basePlacement === preferredPlacement;
  var fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipVariations ? [getOppositePlacement(preferredPlacement)] : getExpandedFallbackPlacements(preferredPlacement));
  var placements = [preferredPlacement].concat(fallbackPlacements).reduce(function (acc, placement) {
    return acc.concat(getBasePlacement(placement) === auto ? computeAutoPlacement(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      padding: padding,
      flipVariations: flipVariations,
      allowedAutoPlacements: allowedAutoPlacements
    }) : placement);
  }, []);
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var checksMap = new Map();
  var makeFallbackChecks = true;
  var firstFittingPlacement = placements[0];

  for (var i = 0; i < placements.length; i++) {
    var placement = placements[i];

    var _basePlacement = getBasePlacement(placement);

    var isStartVariation = getVariation(placement) === start;
    var isVertical = [top, bottom].indexOf(_basePlacement) >= 0;
    var len = isVertical ? 'width' : 'height';
    var overflow = detectOverflow(state, {
      placement: placement,
      boundary: boundary,
      rootBoundary: rootBoundary,
      altBoundary: altBoundary,
      padding: padding
    });
    var mainVariationSide = isVertical ? isStartVariation ? right : left : isStartVariation ? bottom : top;

    if (referenceRect[len] > popperRect[len]) {
      mainVariationSide = getOppositePlacement(mainVariationSide);
    }

    var altVariationSide = getOppositePlacement(mainVariationSide);
    var checks = [];

    if (checkMainAxis) {
      checks.push(overflow[_basePlacement] <= 0);
    }

    if (checkAltAxis) {
      checks.push(overflow[mainVariationSide] <= 0, overflow[altVariationSide] <= 0);
    }

    if (checks.every(function (check) {
      return check;
    })) {
      firstFittingPlacement = placement;
      makeFallbackChecks = false;
      break;
    }

    checksMap.set(placement, checks);
  }

  if (makeFallbackChecks) {
    // `2` may be desired in some cases – research later
    var numberOfChecks = flipVariations ? 3 : 1;

    var _loop = function _loop(_i) {
      var fittingPlacement = placements.find(function (placement) {
        var checks = checksMap.get(placement);

        if (checks) {
          return checks.slice(0, _i).every(function (check) {
            return check;
          });
        }
      });

      if (fittingPlacement) {
        firstFittingPlacement = fittingPlacement;
        return "break";
      }
    };

    for (var _i = numberOfChecks; _i > 0; _i--) {
      var _ret = _loop(_i);

      if (_ret === "break") break;
    }
  }

  if (state.placement !== firstFittingPlacement) {
    state.modifiersData[name]._skip = true;
    state.placement = firstFittingPlacement;
    state.reset = true;
  }
} // eslint-disable-next-line import/no-unused-modules


var flip$1 = {
  name: 'flip',
  enabled: true,
  phase: 'main',
  fn: flip,
  requiresIfExists: ['offset'],
  data: {
    _skip: false
  }
};

function getSideOffsets(overflow, rect, preventedOffsets) {
  if (preventedOffsets === void 0) {
    preventedOffsets = {
      x: 0,
      y: 0
    };
  }

  return {
    top: overflow.top - rect.height - preventedOffsets.y,
    right: overflow.right - rect.width + preventedOffsets.x,
    bottom: overflow.bottom - rect.height + preventedOffsets.y,
    left: overflow.left - rect.width - preventedOffsets.x
  };
}

function isAnySideFullyClipped(overflow) {
  return [top, right, bottom, left].some(function (side) {
    return overflow[side] >= 0;
  });
}

function hide(_ref) {
  var state = _ref.state,
      name = _ref.name;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var preventedOffsets = state.modifiersData.preventOverflow;
  var referenceOverflow = detectOverflow(state, {
    elementContext: 'reference'
  });
  var popperAltOverflow = detectOverflow(state, {
    altBoundary: true
  });
  var referenceClippingOffsets = getSideOffsets(referenceOverflow, referenceRect);
  var popperEscapeOffsets = getSideOffsets(popperAltOverflow, popperRect, preventedOffsets);
  var isReferenceHidden = isAnySideFullyClipped(referenceClippingOffsets);
  var hasPopperEscaped = isAnySideFullyClipped(popperEscapeOffsets);
  state.modifiersData[name] = {
    referenceClippingOffsets: referenceClippingOffsets,
    popperEscapeOffsets: popperEscapeOffsets,
    isReferenceHidden: isReferenceHidden,
    hasPopperEscaped: hasPopperEscaped
  };
  state.attributes.popper = Object.assign({}, state.attributes.popper, {
    'data-popper-reference-hidden': isReferenceHidden,
    'data-popper-escaped': hasPopperEscaped
  });
} // eslint-disable-next-line import/no-unused-modules


var hide$1 = {
  name: 'hide',
  enabled: true,
  phase: 'main',
  requiresIfExists: ['preventOverflow'],
  fn: hide
};

function distanceAndSkiddingToXY(placement, rects, offset) {
  var basePlacement = getBasePlacement(placement);
  var invertDistance = [left, top].indexOf(basePlacement) >= 0 ? -1 : 1;

  var _ref = typeof offset === 'function' ? offset(Object.assign({}, rects, {
    placement: placement
  })) : offset,
      skidding = _ref[0],
      distance = _ref[1];

  skidding = skidding || 0;
  distance = (distance || 0) * invertDistance;
  return [left, right].indexOf(basePlacement) >= 0 ? {
    x: distance,
    y: skidding
  } : {
    x: skidding,
    y: distance
  };
}

function offset(_ref2) {
  var state = _ref2.state,
      options = _ref2.options,
      name = _ref2.name;
  var _options$offset = options.offset,
      offset = _options$offset === void 0 ? [0, 0] : _options$offset;
  var data = placements.reduce(function (acc, placement) {
    acc[placement] = distanceAndSkiddingToXY(placement, state.rects, offset);
    return acc;
  }, {});
  var _data$state$placement = data[state.placement],
      x = _data$state$placement.x,
      y = _data$state$placement.y;

  if (state.modifiersData.popperOffsets != null) {
    state.modifiersData.popperOffsets.x += x;
    state.modifiersData.popperOffsets.y += y;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var offset$1 = {
  name: 'offset',
  enabled: true,
  phase: 'main',
  requires: ['popperOffsets'],
  fn: offset
};

function popperOffsets(_ref) {
  var state = _ref.state,
      name = _ref.name;
  // Offsets are the actual position the popper needs to have to be
  // properly positioned near its reference element
  // This is the most basic placement, and will be adjusted by
  // the modifiers in the next step
  state.modifiersData[name] = computeOffsets({
    reference: state.rects.reference,
    element: state.rects.popper,
    strategy: 'absolute',
    placement: state.placement
  });
} // eslint-disable-next-line import/no-unused-modules


var popperOffsets$1 = {
  name: 'popperOffsets',
  enabled: true,
  phase: 'read',
  fn: popperOffsets,
  data: {}
};

function getAltAxis(axis) {
  return axis === 'x' ? 'y' : 'x';
}

function preventOverflow(_ref) {
  var state = _ref.state,
      options = _ref.options,
      name = _ref.name;
  var _options$mainAxis = options.mainAxis,
      checkMainAxis = _options$mainAxis === void 0 ? true : _options$mainAxis,
      _options$altAxis = options.altAxis,
      checkAltAxis = _options$altAxis === void 0 ? false : _options$altAxis,
      boundary = options.boundary,
      rootBoundary = options.rootBoundary,
      altBoundary = options.altBoundary,
      padding = options.padding,
      _options$tether = options.tether,
      tether = _options$tether === void 0 ? true : _options$tether,
      _options$tetherOffset = options.tetherOffset,
      tetherOffset = _options$tetherOffset === void 0 ? 0 : _options$tetherOffset;
  var overflow = detectOverflow(state, {
    boundary: boundary,
    rootBoundary: rootBoundary,
    padding: padding,
    altBoundary: altBoundary
  });
  var basePlacement = getBasePlacement(state.placement);
  var variation = getVariation(state.placement);
  var isBasePlacement = !variation;
  var mainAxis = getMainAxisFromPlacement(basePlacement);
  var altAxis = getAltAxis(mainAxis);
  var popperOffsets = state.modifiersData.popperOffsets;
  var referenceRect = state.rects.reference;
  var popperRect = state.rects.popper;
  var tetherOffsetValue = typeof tetherOffset === 'function' ? tetherOffset(Object.assign({}, state.rects, {
    placement: state.placement
  })) : tetherOffset;
  var normalizedTetherOffsetValue = typeof tetherOffsetValue === 'number' ? {
    mainAxis: tetherOffsetValue,
    altAxis: tetherOffsetValue
  } : Object.assign({
    mainAxis: 0,
    altAxis: 0
  }, tetherOffsetValue);
  var offsetModifierState = state.modifiersData.offset ? state.modifiersData.offset[state.placement] : null;
  var data = {
    x: 0,
    y: 0
  };

  if (!popperOffsets) {
    return;
  }

  if (checkMainAxis) {
    var _offsetModifierState$;

    var mainSide = mainAxis === 'y' ? top : left;
    var altSide = mainAxis === 'y' ? bottom : right;
    var len = mainAxis === 'y' ? 'height' : 'width';
    var offset = popperOffsets[mainAxis];
    var min$1 = offset + overflow[mainSide];
    var max$1 = offset - overflow[altSide];
    var additive = tether ? -popperRect[len] / 2 : 0;
    var minLen = variation === start ? referenceRect[len] : popperRect[len];
    var maxLen = variation === start ? -popperRect[len] : -referenceRect[len]; // We need to include the arrow in the calculation so the arrow doesn't go
    // outside the reference bounds

    var arrowElement = state.elements.arrow;
    var arrowRect = tether && arrowElement ? getLayoutRect(arrowElement) : {
      width: 0,
      height: 0
    };
    var arrowPaddingObject = state.modifiersData['arrow#persistent'] ? state.modifiersData['arrow#persistent'].padding : getFreshSideObject();
    var arrowPaddingMin = arrowPaddingObject[mainSide];
    var arrowPaddingMax = arrowPaddingObject[altSide]; // If the reference length is smaller than the arrow length, we don't want
    // to include its full size in the calculation. If the reference is small
    // and near the edge of a boundary, the popper can overflow even if the
    // reference is not overflowing as well (e.g. virtual elements with no
    // width or height)

    var arrowLen = within(0, referenceRect[len], arrowRect[len]);
    var minOffset = isBasePlacement ? referenceRect[len] / 2 - additive - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis : minLen - arrowLen - arrowPaddingMin - normalizedTetherOffsetValue.mainAxis;
    var maxOffset = isBasePlacement ? -referenceRect[len] / 2 + additive + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis : maxLen + arrowLen + arrowPaddingMax + normalizedTetherOffsetValue.mainAxis;
    var arrowOffsetParent = state.elements.arrow && getOffsetParent(state.elements.arrow);
    var clientOffset = arrowOffsetParent ? mainAxis === 'y' ? arrowOffsetParent.clientTop || 0 : arrowOffsetParent.clientLeft || 0 : 0;
    var offsetModifierValue = (_offsetModifierState$ = offsetModifierState == null ? void 0 : offsetModifierState[mainAxis]) != null ? _offsetModifierState$ : 0;
    var tetherMin = offset + minOffset - offsetModifierValue - clientOffset;
    var tetherMax = offset + maxOffset - offsetModifierValue;
    var preventedOffset = within(tether ? min(min$1, tetherMin) : min$1, offset, tether ? max(max$1, tetherMax) : max$1);
    popperOffsets[mainAxis] = preventedOffset;
    data[mainAxis] = preventedOffset - offset;
  }

  if (checkAltAxis) {
    var _offsetModifierState$2;

    var _mainSide = mainAxis === 'x' ? top : left;

    var _altSide = mainAxis === 'x' ? bottom : right;

    var _offset = popperOffsets[altAxis];

    var _len = altAxis === 'y' ? 'height' : 'width';

    var _min = _offset + overflow[_mainSide];

    var _max = _offset - overflow[_altSide];

    var isOriginSide = [top, left].indexOf(basePlacement) !== -1;

    var _offsetModifierValue = (_offsetModifierState$2 = offsetModifierState == null ? void 0 : offsetModifierState[altAxis]) != null ? _offsetModifierState$2 : 0;

    var _tetherMin = isOriginSide ? _min : _offset - referenceRect[_len] - popperRect[_len] - _offsetModifierValue + normalizedTetherOffsetValue.altAxis;

    var _tetherMax = isOriginSide ? _offset + referenceRect[_len] + popperRect[_len] - _offsetModifierValue - normalizedTetherOffsetValue.altAxis : _max;

    var _preventedOffset = tether && isOriginSide ? withinMaxClamp(_tetherMin, _offset, _tetherMax) : within(tether ? _tetherMin : _min, _offset, tether ? _tetherMax : _max);

    popperOffsets[altAxis] = _preventedOffset;
    data[altAxis] = _preventedOffset - _offset;
  }

  state.modifiersData[name] = data;
} // eslint-disable-next-line import/no-unused-modules


var preventOverflow$1 = {
  name: 'preventOverflow',
  enabled: true,
  phase: 'main',
  fn: preventOverflow,
  requiresIfExists: ['offset']
};

function getHTMLElementScroll(element) {
  return {
    scrollLeft: element.scrollLeft,
    scrollTop: element.scrollTop
  };
}

function getNodeScroll(node) {
  if (node === getWindow(node) || !isHTMLElement(node)) {
    return getWindowScroll(node);
  } else {
    return getHTMLElementScroll(node);
  }
}

function isElementScaled(element) {
  var rect = element.getBoundingClientRect();
  var scaleX = round(rect.width) / element.offsetWidth || 1;
  var scaleY = round(rect.height) / element.offsetHeight || 1;
  return scaleX !== 1 || scaleY !== 1;
} // Returns the composite rect of an element relative to its offsetParent.
// Composite means it takes into account transforms as well as layout.


function getCompositeRect(elementOrVirtualElement, offsetParent, isFixed) {
  if (isFixed === void 0) {
    isFixed = false;
  }

  var isOffsetParentAnElement = isHTMLElement(offsetParent);
  var offsetParentIsScaled = isHTMLElement(offsetParent) && isElementScaled(offsetParent);
  var documentElement = getDocumentElement(offsetParent);
  var rect = getBoundingClientRect(elementOrVirtualElement, offsetParentIsScaled, isFixed);
  var scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  var offsets = {
    x: 0,
    y: 0
  };

  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== 'body' || // https://github.com/popperjs/popper-core/issues/1078
    isScrollParent(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }

    if (isHTMLElement(offsetParent)) {
      offsets = getBoundingClientRect(offsetParent, true);
      offsets.x += offsetParent.clientLeft;
      offsets.y += offsetParent.clientTop;
    } else if (documentElement) {
      offsets.x = getWindowScrollBarX(documentElement);
    }
  }

  return {
    x: rect.left + scroll.scrollLeft - offsets.x,
    y: rect.top + scroll.scrollTop - offsets.y,
    width: rect.width,
    height: rect.height
  };
}

function order(modifiers) {
  var map = new Map();
  var visited = new Set();
  var result = [];
  modifiers.forEach(function (modifier) {
    map.set(modifier.name, modifier);
  }); // On visiting object, check for its dependencies and visit them recursively

  function sort(modifier) {
    visited.add(modifier.name);
    var requires = [].concat(modifier.requires || [], modifier.requiresIfExists || []);
    requires.forEach(function (dep) {
      if (!visited.has(dep)) {
        var depModifier = map.get(dep);

        if (depModifier) {
          sort(depModifier);
        }
      }
    });
    result.push(modifier);
  }

  modifiers.forEach(function (modifier) {
    if (!visited.has(modifier.name)) {
      // check for visited object
      sort(modifier);
    }
  });
  return result;
}

function orderModifiers(modifiers) {
  // order based on dependencies
  var orderedModifiers = order(modifiers); // order based on phase

  return modifierPhases.reduce(function (acc, phase) {
    return acc.concat(orderedModifiers.filter(function (modifier) {
      return modifier.phase === phase;
    }));
  }, []);
}

function debounce(fn) {
  var pending;
  return function () {
    if (!pending) {
      pending = new Promise(function (resolve) {
        Promise.resolve().then(function () {
          pending = undefined;
          resolve(fn());
        });
      });
    }

    return pending;
  };
}

function mergeByName(modifiers) {
  var merged = modifiers.reduce(function (merged, current) {
    var existing = merged[current.name];
    merged[current.name] = existing ? Object.assign({}, existing, current, {
      options: Object.assign({}, existing.options, current.options),
      data: Object.assign({}, existing.data, current.data)
    }) : current;
    return merged;
  }, {}); // IE11 does not support Object.values

  return Object.keys(merged).map(function (key) {
    return merged[key];
  });
}

var DEFAULT_OPTIONS = {
  placement: 'bottom',
  modifiers: [],
  strategy: 'absolute'
};

function areValidElements() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  return !args.some(function (element) {
    return !(element && typeof element.getBoundingClientRect === 'function');
  });
}

function popperGenerator(generatorOptions) {
  if (generatorOptions === void 0) {
    generatorOptions = {};
  }

  var _generatorOptions = generatorOptions,
      _generatorOptions$def = _generatorOptions.defaultModifiers,
      defaultModifiers = _generatorOptions$def === void 0 ? [] : _generatorOptions$def,
      _generatorOptions$def2 = _generatorOptions.defaultOptions,
      defaultOptions = _generatorOptions$def2 === void 0 ? DEFAULT_OPTIONS : _generatorOptions$def2;
  return function createPopper(reference, popper, options) {
    if (options === void 0) {
      options = defaultOptions;
    }

    var state = {
      placement: 'bottom',
      orderedModifiers: [],
      options: Object.assign({}, DEFAULT_OPTIONS, defaultOptions),
      modifiersData: {},
      elements: {
        reference: reference,
        popper: popper
      },
      attributes: {},
      styles: {}
    };
    var effectCleanupFns = [];
    var isDestroyed = false;
    var instance = {
      state: state,
      setOptions: function setOptions(setOptionsAction) {
        var options = typeof setOptionsAction === 'function' ? setOptionsAction(state.options) : setOptionsAction;
        cleanupModifierEffects();
        state.options = Object.assign({}, defaultOptions, state.options, options);
        state.scrollParents = {
          reference: isElement$1(reference) ? listScrollParents(reference) : reference.contextElement ? listScrollParents(reference.contextElement) : [],
          popper: listScrollParents(popper)
        }; // Orders the modifiers based on their dependencies and `phase`
        // properties

        var orderedModifiers = orderModifiers(mergeByName([].concat(defaultModifiers, state.options.modifiers))); // Strip out disabled modifiers

        state.orderedModifiers = orderedModifiers.filter(function (m) {
          return m.enabled;
        });
        runModifierEffects();
        return instance.update();
      },
      // Sync update – it will always be executed, even if not necessary. This
      // is useful for low frequency updates where sync behavior simplifies the
      // logic.
      // For high frequency updates (e.g. `resize` and `scroll` events), always
      // prefer the async Popper#update method
      forceUpdate: function forceUpdate() {
        if (isDestroyed) {
          return;
        }

        var _state$elements = state.elements,
            reference = _state$elements.reference,
            popper = _state$elements.popper; // Don't proceed if `reference` or `popper` are not valid elements
        // anymore

        if (!areValidElements(reference, popper)) {
          return;
        } // Store the reference and popper rects to be read by modifiers


        state.rects = {
          reference: getCompositeRect(reference, getOffsetParent(popper), state.options.strategy === 'fixed'),
          popper: getLayoutRect(popper)
        }; // Modifiers have the ability to reset the current update cycle. The
        // most common use case for this is the `flip` modifier changing the
        // placement, which then needs to re-run all the modifiers, because the
        // logic was previously ran for the previous placement and is therefore
        // stale/incorrect

        state.reset = false;
        state.placement = state.options.placement; // On each update cycle, the `modifiersData` property for each modifier
        // is filled with the initial data specified by the modifier. This means
        // it doesn't persist and is fresh on each update.
        // To ensure persistent data, use `${name}#persistent`

        state.orderedModifiers.forEach(function (modifier) {
          return state.modifiersData[modifier.name] = Object.assign({}, modifier.data);
        });

        for (var index = 0; index < state.orderedModifiers.length; index++) {
          if (state.reset === true) {
            state.reset = false;
            index = -1;
            continue;
          }

          var _state$orderedModifie = state.orderedModifiers[index],
              fn = _state$orderedModifie.fn,
              _state$orderedModifie2 = _state$orderedModifie.options,
              _options = _state$orderedModifie2 === void 0 ? {} : _state$orderedModifie2,
              name = _state$orderedModifie.name;

          if (typeof fn === 'function') {
            state = fn({
              state: state,
              options: _options,
              name: name,
              instance: instance
            }) || state;
          }
        }
      },
      // Async and optimistically optimized update – it will not be executed if
      // not necessary (debounced to run at most once-per-tick)
      update: debounce(function () {
        return new Promise(function (resolve) {
          instance.forceUpdate();
          resolve(state);
        });
      }),
      destroy: function destroy() {
        cleanupModifierEffects();
        isDestroyed = true;
      }
    };

    if (!areValidElements(reference, popper)) {
      return instance;
    }

    instance.setOptions(options).then(function (state) {
      if (!isDestroyed && options.onFirstUpdate) {
        options.onFirstUpdate(state);
      }
    }); // Modifiers have the ability to execute arbitrary code before the first
    // update cycle runs. They will be executed in the same order as the update
    // cycle. This is useful when a modifier adds some persistent data that
    // other modifiers need to use, but the modifier is run after the dependent
    // one.

    function runModifierEffects() {
      state.orderedModifiers.forEach(function (_ref) {
        var name = _ref.name,
            _ref$options = _ref.options,
            options = _ref$options === void 0 ? {} : _ref$options,
            effect = _ref.effect;

        if (typeof effect === 'function') {
          var cleanupFn = effect({
            state: state,
            name: name,
            instance: instance,
            options: options
          });

          var noopFn = function noopFn() {};

          effectCleanupFns.push(cleanupFn || noopFn);
        }
      });
    }

    function cleanupModifierEffects() {
      effectCleanupFns.forEach(function (fn) {
        return fn();
      });
      effectCleanupFns = [];
    }

    return instance;
  };
}

var defaultModifiers = [eventListeners, popperOffsets$1, computeStyles$1, applyStyles$1, offset$1, flip$1, preventOverflow$1, arrow$1, hide$1];
var createPopper = /*#__PURE__*/popperGenerator({
  defaultModifiers: defaultModifiers
}); // eslint-disable-next-line import/no-unused-modules

/* global Map:readonly, Set:readonly, ArrayBuffer:readonly */

var hasElementType = typeof Element !== 'undefined';
var hasMap = typeof Map === 'function';
var hasSet = typeof Set === 'function';
var hasArrayBuffer = typeof ArrayBuffer === 'function' && !!ArrayBuffer.isView;

// Note: We **don't** need `envHasBigInt64Array` in fde es6/index.js

function equal(a, b) {
  // START: fast-deep-equal es6/index.js 3.1.3
  if (a === b) return true;

  if (a && b && typeof a == 'object' && typeof b == 'object') {
    if (a.constructor !== b.constructor) return false;

    var length, i, keys;
    if (Array.isArray(a)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (!equal(a[i], b[i])) return false;
      return true;
    }

    // START: Modifications:
    // 1. Extra `has<Type> &&` helpers in initial condition allow es6 code
    //    to co-exist with es5.
    // 2. Replace `for of` with es5 compliant iteration using `for`.
    //    Basically, take:
    //
    //    ```js
    //    for (i of a.entries())
    //      if (!b.has(i[0])) return false;
    //    ```
    //
    //    ... and convert to:
    //
    //    ```js
    //    it = a.entries();
    //    while (!(i = it.next()).done)
    //      if (!b.has(i.value[0])) return false;
    //    ```
    //
    //    **Note**: `i` access switches to `i.value`.
    var it;
    if (hasMap && (a instanceof Map) && (b instanceof Map)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!equal(i.value[1], b.get(i.value[0]))) return false;
      return true;
    }

    if (hasSet && (a instanceof Set) && (b instanceof Set)) {
      if (a.size !== b.size) return false;
      it = a.entries();
      while (!(i = it.next()).done)
        if (!b.has(i.value[0])) return false;
      return true;
    }
    // END: Modifications

    if (hasArrayBuffer && ArrayBuffer.isView(a) && ArrayBuffer.isView(b)) {
      length = a.length;
      if (length != b.length) return false;
      for (i = length; i-- !== 0;)
        if (a[i] !== b[i]) return false;
      return true;
    }

    if (a.constructor === RegExp) return a.source === b.source && a.flags === b.flags;
    // START: Modifications:
    // Apply guards for `Object.create(null)` handling. See:
    // - https://github.com/FormidableLabs/react-fast-compare/issues/64
    // - https://github.com/epoberezkin/fast-deep-equal/issues/49
    if (a.valueOf !== Object.prototype.valueOf && typeof a.valueOf === 'function' && typeof b.valueOf === 'function') return a.valueOf() === b.valueOf();
    if (a.toString !== Object.prototype.toString && typeof a.toString === 'function' && typeof b.toString === 'function') return a.toString() === b.toString();
    // END: Modifications

    keys = Object.keys(a);
    length = keys.length;
    if (length !== Object.keys(b).length) return false;

    for (i = length; i-- !== 0;)
      if (!Object.prototype.hasOwnProperty.call(b, keys[i])) return false;
    // END: fast-deep-equal

    // START: react-fast-compare
    // custom handling for DOM elements
    if (hasElementType && a instanceof Element) return false;

    // custom handling for React/Preact
    for (i = length; i-- !== 0;) {
      if ((keys[i] === '_owner' || keys[i] === '__v' || keys[i] === '__o') && a.$$typeof) {
        // React-specific: avoid traversing React elements' _owner
        // Preact-specific: avoid traversing Preact elements' __v and __o
        //    __v = $_original / $_vnode
        //    __o = $_owner
        // These properties contain circular references and are not needed when
        // comparing the actual elements (and not their owners)
        // .$$typeof and ._store on just reasonable markers of elements

        continue;
      }

      // all other properties should be traversed as usual
      if (!equal(a[keys[i]], b[keys[i]])) return false;
    }
    // END: react-fast-compare

    // START: fast-deep-equal
    return true;
  }

  return a !== a && b !== b;
}
// end fast-deep-equal

var reactFastCompare = function isEqual(a, b) {
  try {
    return equal(a, b);
  } catch (error) {
    if (((error.message || '').match(/stack|recursion/i))) {
      // warn on circular references, don't crash
      // browsers give this different errors name and messages:
      // chrome/safari: "RangeError", "Maximum call stack size exceeded"
      // firefox: "InternalError", too much recursion"
      // edge: "Error", "Out of stack space"
      console.warn('react-fast-compare cannot handle circular refs');
      return false;
    }
    // some other error. we should definitely know about these
    throw error;
  }
};

var EMPTY_MODIFIERS$1 = [];
var usePopper = function usePopper(referenceElement, popperElement, options) {
  if (options === void 0) {
    options = {};
  }

  var prevOptions = React.useRef(null);
  var optionsWithDefaults = {
    onFirstUpdate: options.onFirstUpdate,
    placement: options.placement || 'bottom',
    strategy: options.strategy || 'absolute',
    modifiers: options.modifiers || EMPTY_MODIFIERS$1
  };

  var _React$useState = React.useState({
    styles: {
      popper: {
        position: optionsWithDefaults.strategy,
        left: '0',
        top: '0'
      },
      arrow: {
        position: 'absolute'
      }
    },
    attributes: {}
  }),
      state = _React$useState[0],
      setState = _React$useState[1];

  var updateStateModifier = React.useMemo(function () {
    return {
      name: 'updateState',
      enabled: true,
      phase: 'write',
      fn: function fn(_ref) {
        var state = _ref.state;
        var elements = Object.keys(state.elements);
        ReactDOM.flushSync(function () {
          setState({
            styles: fromEntries(elements.map(function (element) {
              return [element, state.styles[element] || {}];
            })),
            attributes: fromEntries(elements.map(function (element) {
              return [element, state.attributes[element]];
            }))
          });
        });
      },
      requires: ['computeStyles']
    };
  }, []);
  var popperOptions = React.useMemo(function () {
    var newOptions = {
      onFirstUpdate: optionsWithDefaults.onFirstUpdate,
      placement: optionsWithDefaults.placement,
      strategy: optionsWithDefaults.strategy,
      modifiers: [].concat(optionsWithDefaults.modifiers, [updateStateModifier, {
        name: 'applyStyles',
        enabled: false
      }])
    };

    if (reactFastCompare(prevOptions.current, newOptions)) {
      return prevOptions.current || newOptions;
    } else {
      prevOptions.current = newOptions;
      return newOptions;
    }
  }, [optionsWithDefaults.onFirstUpdate, optionsWithDefaults.placement, optionsWithDefaults.strategy, optionsWithDefaults.modifiers, updateStateModifier]);
  var popperInstanceRef = React.useRef();
  useIsomorphicLayoutEffect(function () {
    if (popperInstanceRef.current) {
      popperInstanceRef.current.setOptions(popperOptions);
    }
  }, [popperOptions]);
  useIsomorphicLayoutEffect(function () {
    if (referenceElement == null || popperElement == null) {
      return;
    }

    var createPopper$1 = options.createPopper || createPopper;
    var popperInstance = createPopper$1(referenceElement, popperElement, popperOptions);
    popperInstanceRef.current = popperInstance;
    return function () {
      popperInstance.destroy();
      popperInstanceRef.current = null;
    };
  }, [referenceElement, popperElement, options.createPopper]);
  return {
    state: popperInstanceRef.current ? popperInstanceRef.current.state : null,
    styles: state.styles,
    attributes: state.attributes,
    update: popperInstanceRef.current ? popperInstanceRef.current.update : null,
    forceUpdate: popperInstanceRef.current ? popperInstanceRef.current.forceUpdate : null
  };
};

var NOOP = function NOOP() {
  return void 0;
};

var NOOP_PROMISE = function NOOP_PROMISE() {
  return Promise.resolve(null);
};

var EMPTY_MODIFIERS = [];
function Popper(_ref) {
  var _ref$placement = _ref.placement,
      placement = _ref$placement === void 0 ? 'bottom' : _ref$placement,
      _ref$strategy = _ref.strategy,
      strategy = _ref$strategy === void 0 ? 'absolute' : _ref$strategy,
      _ref$modifiers = _ref.modifiers,
      modifiers = _ref$modifiers === void 0 ? EMPTY_MODIFIERS : _ref$modifiers,
      referenceElement = _ref.referenceElement,
      onFirstUpdate = _ref.onFirstUpdate,
      innerRef = _ref.innerRef,
      children = _ref.children;
  var referenceNode = React.useContext(ManagerReferenceNodeContext);

  var _React$useState = React.useState(null),
      popperElement = _React$useState[0],
      setPopperElement = _React$useState[1];

  var _React$useState2 = React.useState(null),
      arrowElement = _React$useState2[0],
      setArrowElement = _React$useState2[1];

  React.useEffect(function () {
    setRef(innerRef, popperElement);
  }, [innerRef, popperElement]);
  var options = React.useMemo(function () {
    return {
      placement: placement,
      strategy: strategy,
      onFirstUpdate: onFirstUpdate,
      modifiers: [].concat(modifiers, [{
        name: 'arrow',
        enabled: arrowElement != null,
        options: {
          element: arrowElement
        }
      }])
    };
  }, [placement, strategy, onFirstUpdate, modifiers, arrowElement]);

  var _usePopper = usePopper(referenceElement || referenceNode, popperElement, options),
      state = _usePopper.state,
      styles = _usePopper.styles,
      forceUpdate = _usePopper.forceUpdate,
      update = _usePopper.update;

  var childrenProps = React.useMemo(function () {
    return {
      ref: setPopperElement,
      style: styles.popper,
      placement: state ? state.placement : placement,
      hasPopperEscaped: state && state.modifiersData.hide ? state.modifiersData.hide.hasPopperEscaped : null,
      isReferenceHidden: state && state.modifiersData.hide ? state.modifiersData.hide.isReferenceHidden : null,
      arrowProps: {
        style: styles.arrow,
        ref: setArrowElement
      },
      forceUpdate: forceUpdate || NOOP,
      update: update || NOOP_PROMISE
    };
  }, [setPopperElement, setArrowElement, placement, state, styles, update, forceUpdate]);
  return unwrapArray(children)(childrenProps);
}

/**
 * Copyright (c) 2014-present, Facebook, Inc.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */

/**
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 */

var __DEV__ = process.env.NODE_ENV !== 'production';

var warning = function() {};

if (__DEV__) {
  var printWarning = function printWarning(format, args) {
    var len = arguments.length;
    args = new Array(len > 1 ? len - 1 : 0);
    for (var key = 1; key < len; key++) {
      args[key - 1] = arguments[key];
    }
    var argIndex = 0;
    var message = 'Warning: ' +
      format.replace(/%s/g, function() {
        return args[argIndex++];
      });
    if (typeof console !== 'undefined') {
      console.error(message);
    }
    try {
      // --- Welcome to debugging React ---
      // This error was thrown as a convenience so that you can use this stack
      // to find the callsite that caused this warning to fire.
      throw new Error(message);
    } catch (x) {}
  };

  warning = function(condition, format, args) {
    var len = arguments.length;
    args = new Array(len > 2 ? len - 2 : 0);
    for (var key = 2; key < len; key++) {
      args[key - 2] = arguments[key];
    }
    if (format === undefined) {
      throw new Error(
          '`warning(condition, format, ...args)` requires a warning ' +
          'message argument'
      );
    }
    if (!condition) {
      printWarning.apply(null, [format].concat(args));
    }
  };
}

var warning_1 = warning;

function Reference(_ref) {
  var children = _ref.children,
      innerRef = _ref.innerRef;
  var setReferenceNode = React.useContext(ManagerReferenceNodeSetterContext);
  var refHandler = React.useCallback(function (node) {
    setRef(innerRef, node);
    safeInvoke(setReferenceNode, node);
  }, [innerRef, setReferenceNode]); // ran on unmount
  // eslint-disable-next-line react-hooks/exhaustive-deps

  React.useEffect(function () {
    return function () {
      return setRef(innerRef, null);
    };
  }, []);
  React.useEffect(function () {
    warning_1(Boolean(setReferenceNode), '`Reference` should not be used outside of a `Manager` component.');
  }, [setReferenceNode]);
  return unwrapArray(children)({
    ref: refHandler
  });
}

/**
 * @name set
 * @category Common Helpers
 * @summary Set date values to a given date.
 *
 * @description
 * Set date values to a given date.
 *
 * Sets time values to date from object `values`.
 * A value is not set if it is undefined or null or doesn't exist in `values`.
 *
 * Note about bundle size: `set` does not internally use `setX` functions from date-fns but instead opts
 * to use native `Date#setX` methods. If you use this function, you may not want to include the
 * other `setX` functions that date-fns provides if you are concerned about the bundle size.
 *
 * @param {Date|Number} date - the date to be changed
 * @param {Object} values - an object with options
 * @param {Number} [values.year] - the number of years to be set
 * @param {Number} [values.month] - the number of months to be set
 * @param {Number} [values.date] - the number of days to be set
 * @param {Number} [values.hours] - the number of hours to be set
 * @param {Number} [values.minutes] - the number of minutes to be set
 * @param {Number} [values.seconds] - the number of seconds to be set
 * @param {Number} [values.milliseconds] - the number of milliseconds to be set
 * @returns {Date} the new date with options set
 * @throws {TypeError} 2 arguments required
 * @throws {RangeError} `values` must be an object
 *
 * @example
 * // Transform 1 September 2014 into 20 October 2015 in a single line:
 * const result = set(new Date(2014, 8, 20), { year: 2015, month: 9, date: 20 })
 * //=> Tue Oct 20 2015 00:00:00
 *
 * @example
 * // Set 12 PM to 1 September 2014 01:23:45 to 1 September 2014 12:00:00:
 * const result = set(new Date(2014, 8, 1, 1, 23, 45), { hours: 12 })
 * //=> Mon Sep 01 2014 12:23:45
 */
function set(dirtyDate, values) {
  requiredArgs(2, arguments);
  if (_typeof(values) !== 'object' || values === null) {
    throw new RangeError('values parameter must be an object');
  }
  var date = toDate(dirtyDate);

  // Check if date is Invalid Date because Date.prototype.setFullYear ignores the value of Invalid Date
  if (isNaN(date.getTime())) {
    return new Date(NaN);
  }
  if (values.year != null) {
    date.setFullYear(values.year);
  }
  if (values.month != null) {
    date = setMonth(date, values.month);
  }
  if (values.date != null) {
    date.setDate(toInteger(values.date));
  }
  if (values.hours != null) {
    date.setHours(toInteger(values.hours));
  }
  if (values.minutes != null) {
    date.setMinutes(toInteger(values.minutes));
  }
  if (values.seconds != null) {
    date.setSeconds(toInteger(values.seconds));
  }
  if (values.milliseconds != null) {
    date.setMilliseconds(toInteger(values.milliseconds));
  }
  return date;
}

function le(e,t){var r=Object.keys(e);if(Object.getOwnPropertySymbols){var n=Object.getOwnPropertySymbols(e);t&&(n=n.filter((function(t){return Object.getOwnPropertyDescriptor(e,t).enumerable}))),r.push.apply(r,n);}return r}function de(e){for(var t=1;t<arguments.length;t++){var r=null!=arguments[t]?arguments[t]:{};t%2?le(Object(r),!0).forEach((function(t){ye(e,t,r[t]);})):Object.getOwnPropertyDescriptors?Object.defineProperties(e,Object.getOwnPropertyDescriptors(r)):le(Object(r)).forEach((function(t){Object.defineProperty(e,t,Object.getOwnPropertyDescriptor(r,t));}));}return e}function ue(e){return ue="function"==typeof Symbol&&"symbol"==typeof Symbol.iterator?function(e){return typeof e}:function(e){return e&&"function"==typeof Symbol&&e.constructor===Symbol&&e!==Symbol.prototype?"symbol":typeof e},ue(e)}function he(e,t){if(!(e instanceof t))throw new TypeError("Cannot call a class as a function")}function me(e,t){for(var r=0;r<t.length;r++){var n=t[r];n.enumerable=n.enumerable||!1,n.configurable=!0,"value"in n&&(n.writable=!0),Object.defineProperty(e,_e(n.key),n);}}function fe(e,t,r){return t&&me(e.prototype,t),r&&me(e,r),Object.defineProperty(e,"prototype",{writable:!1}),e}function ye(e,t,r){return (t=_e(t))in e?Object.defineProperty(e,t,{value:r,enumerable:!0,configurable:!0,writable:!0}):e[t]=r,e}function ve(){return ve=Object.assign?Object.assign.bind():function(e){for(var t=1;t<arguments.length;t++){var r=arguments[t];for(var n in r)Object.prototype.hasOwnProperty.call(r,n)&&(e[n]=r[n]);}return e},ve.apply(this,arguments)}function De(e,t){if("function"!=typeof t&&null!==t)throw new TypeError("Super expression must either be null or a function");e.prototype=Object.create(t&&t.prototype,{constructor:{value:e,writable:!0,configurable:!0}}),Object.defineProperty(e,"prototype",{writable:!1}),t&&ke(e,t);}function ge(e){return ge=Object.setPrototypeOf?Object.getPrototypeOf.bind():function(e){return e.__proto__||Object.getPrototypeOf(e)},ge(e)}function ke(e,t){return ke=Object.setPrototypeOf?Object.setPrototypeOf.bind():function(e,t){return e.__proto__=t,e},ke(e,t)}function we(e){if(void 0===e)throw new ReferenceError("this hasn't been initialised - super() hasn't been called");return e}function be(e){var t=function(){if("undefined"==typeof Reflect||!Reflect.construct)return !1;if(Reflect.construct.sham)return !1;if("function"==typeof Proxy)return !0;try{return Boolean.prototype.valueOf.call(Reflect.construct(Boolean,[],(function(){}))),!0}catch(e){return !1}}();return function(){var r,n=ge(e);if(t){var o=ge(this).constructor;r=Reflect.construct(n,arguments,o);}else r=n.apply(this,arguments);return function(e,t){if(t&&("object"==typeof t||"function"==typeof t))return t;if(void 0!==t)throw new TypeError("Derived constructors may only return object or undefined");return we(e)}(this,r)}}function Se(e){return function(e){if(Array.isArray(e))return Ce(e)}(e)||function(e){if("undefined"!=typeof Symbol&&null!=e[Symbol.iterator]||null!=e["@@iterator"])return Array.from(e)}(e)||function(e,t){if(!e)return;if("string"==typeof e)return Ce(e,t);var r=Object.prototype.toString.call(e).slice(8,-1);"Object"===r&&e.constructor&&(r=e.constructor.name);if("Map"===r||"Set"===r)return Array.from(e);if("Arguments"===r||/^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(r))return Ce(e,t)}(e)||function(){throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.")}()}function Ce(e,t){(null==t||t>e.length)&&(t=e.length);for(var r=0,n=new Array(t);r<t;r++)n[r]=e[r];return n}function _e(e){var t=function(e,t){if("object"!=typeof e||null===e)return e;var r=e[Symbol.toPrimitive];if(void 0!==r){var n=r.call(e,t||"default");if("object"!=typeof n)return n;throw new TypeError("@@toPrimitive must return a primitive value.")}return ("string"===t?String:Number)(e)}(e,"string");return "symbol"==typeof t?t:String(t)}var Me=function(e,t){switch(e){case"P":return t.date({width:"short"});case"PP":return t.date({width:"medium"});case"PPP":return t.date({width:"long"});default:return t.date({width:"full"})}},Pe=function(e,t){switch(e){case"p":return t.time({width:"short"});case"pp":return t.time({width:"medium"});case"ppp":return t.time({width:"long"});default:return t.time({width:"full"})}},Ee={p:Pe,P:function(e,t){var r,n=e.match(/(P+)(p+)?/)||[],o=n[1],a=n[2];if(!a)return Me(e,t);switch(o){case"P":r=t.dateTime({width:"short"});break;case"PP":r=t.dateTime({width:"medium"});break;case"PPP":r=t.dateTime({width:"long"});break;default:r=t.dateTime({width:"full"});}return r.replace("{{date}}",Me(o,t)).replace("{{time}}",Pe(a,t))}},Ne=12,xe=/P+p+|P+|p+|''|'(''|[^'])+('|$)|./g;function Ye(e){var t=e?"string"==typeof e||e instanceof String?parseISO(e):toDate(e):new Date;return Te(t)?t:null}function Te(e,t){return t=t||new Date("1/1/1000"),isValid$1(e)&&!isBefore(e,t)}function Ie(e,t,r){if("en"===r)return format(e,t,{awareOfUnicodeTokens:!0});var n=Ge(r);return r&&!n&&console.warn('A locale object was not found for the provided string ["'.concat(r,'"].')),!n&&$e()&&Ge($e())&&(n=Ge($e())),format(e,t,{locale:n||null,awareOfUnicodeTokens:!0})}function Oe(e,t){var r=t.dateFormat,n=t.locale;return e&&Ie(e,Array.isArray(r)?r[0]:r,n)||""}function Re(e,t){var r=t.hour,n=void 0===r?0:r,o=t.minute,a=void 0===o?0:o,s=t.second;return setHours(setMinutes(setSeconds(e,void 0===s?0:s),a),n)}function Le(e,t,r){var n=Ge(t||$e());return startOfWeek(e,{locale:n,weekStartsOn:r})}function Fe(e){return startOfMonth(e)}function Ae(e){return startOfYear(e)}function We(e){return startOfQuarter(e)}function Ke(){return startOfDay(Ye())}function Be(e,t){return e&&t?isSameYear(e,t):!e&&!t}function Qe(e,t){return e&&t?isSameMonth(e,t):!e&&!t}function He(e,t){return e&&t?isSameQuarter(e,t):!e&&!t}function je(e,t){return e&&t?isSameDay(e,t):!e&&!t}function Ve(e,t){return e&&t?isEqual(e,t):!e&&!t}function qe(e,t,r){var n,o=startOfDay(t),a=endOfDay(r);try{n=isWithinInterval(e,{start:o,end:a});}catch(e){n=!1;}return n}function Ue(e,t){var r="undefined"!=typeof window?window:globalThis;r.__localeData__||(r.__localeData__={}),r.__localeData__[e]=t;}function $e(){return ("undefined"!=typeof window?window:globalThis).__localeId__}function Ge(e){if("string"==typeof e){var t="undefined"!=typeof window?window:globalThis;return t.__localeData__?t.__localeData__[e]:null}return e}function Je(e,t){return Ie(setMonth(Ye(),e),"LLLL",t)}function Xe(e,t){return Ie(setMonth(Ye(),e),"LLL",t)}function Ze(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,o=t.excludeDates,a=t.excludeDateIntervals,s=t.includeDates,i=t.includeDateIntervals,p=t.filterDate;return it(e,{minDate:r,maxDate:n})||o&&o.some((function(t){return je(e,t)}))||a&&a.some((function(t){var r=t.start,n=t.end;return isWithinInterval(e,{start:r,end:n})}))||s&&!s.some((function(t){return je(e,t)}))||i&&!i.some((function(t){var r=t.start,n=t.end;return isWithinInterval(e,{start:r,end:n})}))||p&&!p(Ye(e))||!1}function et(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.excludeDates,n=t.excludeDateIntervals;return n&&n.length>0?n.some((function(t){var r=t.start,n=t.end;return isWithinInterval(e,{start:r,end:n})})):r&&r.some((function(t){return je(e,t)}))||!1}function tt(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,o=t.excludeDates,a=t.includeDates,s=t.filterDate;return it(e,{minDate:startOfMonth(r),maxDate:endOfMonth(n)})||o&&o.some((function(t){return Qe(e,t)}))||a&&!a.some((function(t){return Qe(e,t)}))||s&&!s(Ye(e))||!1}function rt(e,t,r,n){var o=getYear(e),a=getMonth(e),s=getYear(t),i=getMonth(t),p=getYear(n);return o===s&&o===p?a<=r&&r<=i:o<s?p===o&&a<=r||p===s&&i>=r||p<s&&p>o:void 0}function nt(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,o=t.excludeDates,a=t.includeDates,s=t.filterDate;return it(e,{minDate:r,maxDate:n})||o&&o.some((function(t){return He(e,t)}))||a&&!a.some((function(t){return He(e,t)}))||s&&!s(Ye(e))||!1}function ot(e,t,r){if(!isValid$1(t)||!isValid$1(r))return !1;var n=getYear(t),a=getYear(r);return n<=e&&a>=e}function at(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate,o=t.excludeDates,a=t.includeDates,s=t.filterDate,i=new Date(e,0,1);return it(i,{minDate:startOfYear(r),maxDate:endOfYear(n)})||o&&o.some((function(e){return Be(i,e)}))||a&&!a.some((function(e){return Be(i,e)}))||s&&!s(Ye(i))||!1}function st(e,t,r,n){var o=getYear(e),a=getQuarter(e),s=getYear(t),i=getQuarter(t),p=getYear(n);return o===s&&o===p?a<=r&&r<=i:o<s?p===o&&a<=r||p===s&&i>=r||p<s&&p>o:void 0}function it(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.maxDate;return r&&differenceInCalendarDays(e,r)<0||n&&differenceInCalendarDays(e,n)>0}function pt(e,t){return t.some((function(t){return getHours(t)===getHours(e)&&getMinutes(t)===getMinutes(e)}))}function ct(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.excludeTimes,n=t.includeTimes,o=t.filterTime;return r&&pt(e,r)||n&&!pt(e,n)||o&&!o(e)||!1}function lt(e,t){var r=t.minTime,n=t.maxTime;if(!r||!n)throw new Error("Both minTime and maxTime props required");var o,a=Ye(),s=setHours(setMinutes(a,getMinutes(e)),getHours(e)),i=setHours(setMinutes(a,getMinutes(r)),getHours(r)),p=setHours(setMinutes(a,getMinutes(n)),getHours(n));try{o=!isWithinInterval(s,{start:i,end:p});}catch(e){o=!1;}return o}function dt(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.includeDates,o=subMonths(e,1);return r&&differenceInCalendarMonths(r,o)>0||n&&n.every((function(e){return differenceInCalendarMonths(e,o)>0}))||!1}function ut(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,n=t.includeDates,o=addMonths(e,1);return r&&differenceInCalendarMonths(o,r)>0||n&&n.every((function(e){return differenceInCalendarMonths(o,e)>0}))||!1}function ht(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.includeDates,o=subYears(e,1);return r&&differenceInCalendarYears(r,o)>0||n&&n.every((function(e){return differenceInCalendarYears(e,o)>0}))||!1}function mt(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,n=t.includeDates,o=addYears(e,1);return r&&differenceInCalendarYears(o,r)>0||n&&n.every((function(e){return differenceInCalendarYears(o,e)>0}))||!1}function ft(e){var t=e.minDate,r=e.includeDates;if(r&&t){var n=r.filter((function(e){return differenceInCalendarDays(e,t)>=0}));return min$1(n)}return r?min$1(r):t}function yt(e){var t=e.maxDate,r=e.includeDates;if(r&&t){var n=r.filter((function(e){return differenceInCalendarDays(e,t)<=0}));return max$1(n)}return r?max$1(r):t}function vt(){for(var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"react-datepicker__day--highlighted",r=new Map,o=0,a=e.length;o<a;o++){var s=e[o];if(isDate(s)){var i=Ie(s,"MM.dd.yyyy"),p=r.get(i)||[];p.includes(t)||(p.push(t),r.set(i,p));}else if("object"===ue(s)){var c=Object.keys(s),l=c[0],d=s[c[0]];if("string"==typeof l&&d.constructor===Array)for(var u=0,h=d.length;u<h;u++){var m=Ie(d[u],"MM.dd.yyyy"),f=r.get(m)||[];f.includes(l)||(f.push(l),r.set(m,f));}}}return r}function Dt(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:[],t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:"react-datepicker__day--holidays",r=new Map;return e.forEach((function(e){var o=e.date,a=e.holidayName;if(isDate(o)){var s=Ie(o,"MM.dd.yyyy"),i=r.get(s)||{};if(!("className"in i)||i.className!==t||(p=i.holidayNames,c=[a],p.length!==c.length||!p.every((function(e,t){return e===c[t]})))){var p,c;i.className=t;var l=i.holidayNames;i.holidayNames=l?[].concat(Se(l),[a]):[a],r.set(s,i);}}})),r}function gt(e,t,r,n,o){for(var a=o.length,p=[],c=0;c<a;c++){var l=addMinutes(addHours(e,getHours(o[c])),getMinutes(o[c])),d=addMinutes(e,(r+1)*n);isAfter(l,t)&&isBefore(l,d)&&p.push(o[c]);}return p}function kt(e){return e<10?"0".concat(e):"".concat(e)}function wt(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:Ne,r=Math.ceil(getYear(e)/t)*t;return {startPeriod:r-(t-1),endPeriod:r}}function bt(e){var t=e.getSeconds(),r=e.getMilliseconds();return toDate(e.getTime()-1e3*t-r)}function St(e,t,r,n){for(var o=[],a=0;a<2*t+1;a++){var s=e+t-a,i=!0;r&&(i=getYear(r)<=s),n&&i&&(i=getYear(n)>=s),i&&o.push(s);}return o}var Ct=onClickOutsideHOC(function(n){De(a,React__default.Component);var o=be(a);function a(r){var n;he(this,a),ye(we(n=o.call(this,r)),"renderOptions",(function(){var t=n.props.year,r=n.state.yearsList.map((function(r){return React__default.createElement("div",{className:t===r?"react-datepicker__year-option react-datepicker__year-option--selected_year":"react-datepicker__year-option",key:r,onClick:n.onChange.bind(we(n),r),"aria-selected":t===r?"true":void 0},t===r?React__default.createElement("span",{className:"react-datepicker__year-option--selected"},"✓"):"",r)})),o=n.props.minDate?getYear(n.props.minDate):null,a=n.props.maxDate?getYear(n.props.maxDate):null;return a&&n.state.yearsList.find((function(e){return e===a}))||r.unshift(React__default.createElement("div",{className:"react-datepicker__year-option",key:"upcoming",onClick:n.incrementYears},React__default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-upcoming"}))),o&&n.state.yearsList.find((function(e){return e===o}))||r.push(React__default.createElement("div",{className:"react-datepicker__year-option",key:"previous",onClick:n.decrementYears},React__default.createElement("a",{className:"react-datepicker__navigation react-datepicker__navigation--years react-datepicker__navigation--years-previous"}))),r})),ye(we(n),"onChange",(function(e){n.props.onChange(e);})),ye(we(n),"handleClickOutside",(function(){n.props.onCancel();})),ye(we(n),"shiftYears",(function(e){var t=n.state.yearsList.map((function(t){return t+e}));n.setState({yearsList:t});})),ye(we(n),"incrementYears",(function(){return n.shiftYears(1)})),ye(we(n),"decrementYears",(function(){return n.shiftYears(-1)}));var s=r.yearDropdownItemNumber,i=r.scrollableYearDropdown,p=s||(i?10:5);return n.state={yearsList:St(n.props.year,p,n.props.minDate,n.props.maxDate)},n.dropdownRef=createRef(),n}return fe(a,[{key:"componentDidMount",value:function(){var e=this.dropdownRef.current;if(e){var t=e.children?Array.from(e.children):null,r=t?t.find((function(e){return e.ariaSelected})):null;e.scrollTop=r?r.offsetTop+(r.clientHeight-e.clientHeight)/2:(e.scrollHeight-e.clientHeight)/2;}}},{key:"render",value:function(){var t=classnames({"react-datepicker__year-dropdown":!0,"react-datepicker__year-dropdown--scrollable":this.props.scrollableYearDropdown});return React__default.createElement("div",{className:t,ref:this.dropdownRef},this.renderOptions())}}]),a}()),_t=function(t){De(n,React__default.Component);var r=be(n);function n(){var t;he(this,n);for(var o=arguments.length,a=new Array(o),s=0;s<o;s++)a[s]=arguments[s];return ye(we(t=r.call.apply(r,[this].concat(a))),"state",{dropdownVisible:!1}),ye(we(t),"renderSelectOptions",(function(){for(var r=t.props.minDate?getYear(t.props.minDate):1900,n=t.props.maxDate?getYear(t.props.maxDate):2100,o=[],a=r;a<=n;a++)o.push(React__default.createElement("option",{key:a,value:a},a));return o})),ye(we(t),"onSelectChange",(function(e){t.onChange(e.target.value);})),ye(we(t),"renderSelectMode",(function(){return React__default.createElement("select",{value:t.props.year,className:"react-datepicker__year-select",onChange:t.onSelectChange},t.renderSelectOptions())})),ye(we(t),"renderReadView",(function(r){return React__default.createElement("div",{key:"read",style:{visibility:r?"visible":"hidden"},className:"react-datepicker__year-read-view",onClick:function(e){return t.toggleDropdown(e)}},React__default.createElement("span",{className:"react-datepicker__year-read-view--down-arrow"}),React__default.createElement("span",{className:"react-datepicker__year-read-view--selected-year"},t.props.year))})),ye(we(t),"renderDropdown",(function(){return React__default.createElement(Ct,{key:"dropdown",year:t.props.year,onChange:t.onChange,onCancel:t.toggleDropdown,minDate:t.props.minDate,maxDate:t.props.maxDate,scrollableYearDropdown:t.props.scrollableYearDropdown,yearDropdownItemNumber:t.props.yearDropdownItemNumber})})),ye(we(t),"renderScrollMode",(function(){var e=t.state.dropdownVisible,r=[t.renderReadView(!e)];return e&&r.unshift(t.renderDropdown()),r})),ye(we(t),"onChange",(function(e){t.toggleDropdown(),e!==t.props.year&&t.props.onChange(e);})),ye(we(t),"toggleDropdown",(function(e){t.setState({dropdownVisible:!t.state.dropdownVisible},(function(){t.props.adjustDateOnChange&&t.handleYearChange(t.props.date,e);}));})),ye(we(t),"handleYearChange",(function(e,r){t.onSelect(e,r),t.setOpen();})),ye(we(t),"onSelect",(function(e,r){t.props.onSelect&&t.props.onSelect(e,r);})),ye(we(t),"setOpen",(function(){t.props.setOpen&&t.props.setOpen(!0);})),t}return fe(n,[{key:"render",value:function(){var t;switch(this.props.dropdownMode){case"scroll":t=this.renderScrollMode();break;case"select":t=this.renderSelectMode();}return React__default.createElement("div",{className:"react-datepicker__year-dropdown-container react-datepicker__year-dropdown-container--".concat(this.props.dropdownMode)},t)}}]),n}(),Mt=onClickOutsideHOC(function(t){De(n,React__default.Component);var r=be(n);function n(){var t;he(this,n);for(var o=arguments.length,a=new Array(o),s=0;s<o;s++)a[s]=arguments[s];return ye(we(t=r.call.apply(r,[this].concat(a))),"isSelectedMonth",(function(e){return t.props.month===e})),ye(we(t),"renderOptions",(function(){return t.props.monthNames.map((function(r,n){return React__default.createElement("div",{className:t.isSelectedMonth(n)?"react-datepicker__month-option react-datepicker__month-option--selected_month":"react-datepicker__month-option",key:r,onClick:t.onChange.bind(we(t),n),"aria-selected":t.isSelectedMonth(n)?"true":void 0},t.isSelectedMonth(n)?React__default.createElement("span",{className:"react-datepicker__month-option--selected"},"✓"):"",r)}))})),ye(we(t),"onChange",(function(e){return t.props.onChange(e)})),ye(we(t),"handleClickOutside",(function(){return t.props.onCancel()})),t}return fe(n,[{key:"render",value:function(){return React__default.createElement("div",{className:"react-datepicker__month-dropdown"},this.renderOptions())}}]),n}()),Pt=function(t){De(n,React__default.Component);var r=be(n);function n(){var t;he(this,n);for(var o=arguments.length,a=new Array(o),s=0;s<o;s++)a[s]=arguments[s];return ye(we(t=r.call.apply(r,[this].concat(a))),"state",{dropdownVisible:!1}),ye(we(t),"renderSelectOptions",(function(t){return t.map((function(t,r){return React__default.createElement("option",{key:r,value:r},t)}))})),ye(we(t),"renderSelectMode",(function(r){return React__default.createElement("select",{value:t.props.month,className:"react-datepicker__month-select",onChange:function(e){return t.onChange(e.target.value)}},t.renderSelectOptions(r))})),ye(we(t),"renderReadView",(function(r,n){return React__default.createElement("div",{key:"read",style:{visibility:r?"visible":"hidden"},className:"react-datepicker__month-read-view",onClick:t.toggleDropdown},React__default.createElement("span",{className:"react-datepicker__month-read-view--down-arrow"}),React__default.createElement("span",{className:"react-datepicker__month-read-view--selected-month"},n[t.props.month]))})),ye(we(t),"renderDropdown",(function(r){return React__default.createElement(Mt,{key:"dropdown",month:t.props.month,monthNames:r,onChange:t.onChange,onCancel:t.toggleDropdown})})),ye(we(t),"renderScrollMode",(function(e){var r=t.state.dropdownVisible,n=[t.renderReadView(!r,e)];return r&&n.unshift(t.renderDropdown(e)),n})),ye(we(t),"onChange",(function(e){t.toggleDropdown(),e!==t.props.month&&t.props.onChange(e);})),ye(we(t),"toggleDropdown",(function(){return t.setState({dropdownVisible:!t.state.dropdownVisible})})),t}return fe(n,[{key:"render",value:function(){var t,r=this,n=[0,1,2,3,4,5,6,7,8,9,10,11].map(this.props.useShortMonthInDropdown?function(e){return Xe(e,r.props.locale)}:function(e){return Je(e,r.props.locale)});switch(this.props.dropdownMode){case"scroll":t=this.renderScrollMode(n);break;case"select":t=this.renderSelectMode(n);}return React__default.createElement("div",{className:"react-datepicker__month-dropdown-container react-datepicker__month-dropdown-container--".concat(this.props.dropdownMode)},t)}}]),n}();function Et(e,t){for(var r=[],n=Fe(e),o=Fe(t);!isAfter(n,o);)r.push(Ye(n)),n=addMonths(n,1);return r}var Nt=onClickOutsideHOC(function(t){De(o,React__default.Component);var n=be(o);function o(t){var r;return he(this,o),ye(we(r=n.call(this,t)),"renderOptions",(function(){return r.state.monthYearsList.map((function(t){var n=getTime(t),o=Be(r.props.date,t)&&Qe(r.props.date,t);return React__default.createElement("div",{className:o?"react-datepicker__month-year-option--selected_month-year":"react-datepicker__month-year-option",key:n,onClick:r.onChange.bind(we(r),n),"aria-selected":o?"true":void 0},o?React__default.createElement("span",{className:"react-datepicker__month-year-option--selected"},"✓"):"",Ie(t,r.props.dateFormat,r.props.locale))}))})),ye(we(r),"onChange",(function(e){return r.props.onChange(e)})),ye(we(r),"handleClickOutside",(function(){r.props.onCancel();})),r.state={monthYearsList:Et(r.props.minDate,r.props.maxDate)},r}return fe(o,[{key:"render",value:function(){var t=classnames({"react-datepicker__month-year-dropdown":!0,"react-datepicker__month-year-dropdown--scrollable":this.props.scrollableMonthYearDropdown});return React__default.createElement("div",{className:t},this.renderOptions())}}]),o}()),xt=function(t){De(n,React__default.Component);var r=be(n);function n(){var t;he(this,n);for(var o=arguments.length,a=new Array(o),s=0;s<o;s++)a[s]=arguments[s];return ye(we(t=r.call.apply(r,[this].concat(a))),"state",{dropdownVisible:!1}),ye(we(t),"renderSelectOptions",(function(){for(var r=Fe(t.props.minDate),n=Fe(t.props.maxDate),o=[];!isAfter(r,n);){var a=getTime(r);o.push(React__default.createElement("option",{key:a,value:a},Ie(r,t.props.dateFormat,t.props.locale))),r=addMonths(r,1);}return o})),ye(we(t),"onSelectChange",(function(e){t.onChange(e.target.value);})),ye(we(t),"renderSelectMode",(function(){return React__default.createElement("select",{value:getTime(Fe(t.props.date)),className:"react-datepicker__month-year-select",onChange:t.onSelectChange},t.renderSelectOptions())})),ye(we(t),"renderReadView",(function(r){var n=Ie(t.props.date,t.props.dateFormat,t.props.locale);return React__default.createElement("div",{key:"read",style:{visibility:r?"visible":"hidden"},className:"react-datepicker__month-year-read-view",onClick:function(e){return t.toggleDropdown(e)}},React__default.createElement("span",{className:"react-datepicker__month-year-read-view--down-arrow"}),React__default.createElement("span",{className:"react-datepicker__month-year-read-view--selected-month-year"},n))})),ye(we(t),"renderDropdown",(function(){return React__default.createElement(Nt,{key:"dropdown",date:t.props.date,dateFormat:t.props.dateFormat,onChange:t.onChange,onCancel:t.toggleDropdown,minDate:t.props.minDate,maxDate:t.props.maxDate,scrollableMonthYearDropdown:t.props.scrollableMonthYearDropdown,locale:t.props.locale})})),ye(we(t),"renderScrollMode",(function(){var e=t.state.dropdownVisible,r=[t.renderReadView(!e)];return e&&r.unshift(t.renderDropdown()),r})),ye(we(t),"onChange",(function(e){t.toggleDropdown();var r=Ye(parseInt(e));Be(t.props.date,r)&&Qe(t.props.date,r)||t.props.onChange(r);})),ye(we(t),"toggleDropdown",(function(){return t.setState({dropdownVisible:!t.state.dropdownVisible})})),t}return fe(n,[{key:"render",value:function(){var t;switch(this.props.dropdownMode){case"scroll":t=this.renderScrollMode();break;case"select":t=this.renderSelectMode();}return React__default.createElement("div",{className:"react-datepicker__month-year-dropdown-container react-datepicker__month-year-dropdown-container--".concat(this.props.dropdownMode)},t)}}]),n}(),Yt=function(t){De(o,React__default.Component);var n=be(o);function o(){var t;he(this,o);for(var a=arguments.length,s=new Array(a),i=0;i<a;i++)s[i]=arguments[i];return ye(we(t=n.call.apply(n,[this].concat(s))),"dayEl",React__default.createRef()),ye(we(t),"handleClick",(function(e){!t.isDisabled()&&t.props.onClick&&t.props.onClick(e);})),ye(we(t),"handleMouseEnter",(function(e){!t.isDisabled()&&t.props.onMouseEnter&&t.props.onMouseEnter(e);})),ye(we(t),"handleOnKeyDown",(function(e){" "===e.key&&(e.preventDefault(),e.key="Enter"),t.props.handleOnKeyDown(e);})),ye(we(t),"isSameDay",(function(e){return je(t.props.day,e)})),ye(we(t),"isKeyboardSelected",(function(){return !t.props.disabledKeyboardNavigation&&!(t.isSameDay(t.props.selected)||t.isSameWeek(t.props.selected))&&(t.isSameDay(t.props.preSelection)||t.isSameWeek(t.props.preSelection))})),ye(we(t),"isDisabled",(function(){return Ze(t.props.day,t.props)})),ye(we(t),"isExcluded",(function(){return et(t.props.day,t.props)})),ye(we(t),"isStartOfWeek",(function(){return je(t.props.day,Le(t.props.day,t.props.locale,t.props.calendarStartDay))})),ye(we(t),"isSameWeek",(function(e){return t.props.showWeekPicker&&je(e,Le(t.props.day,t.props.locale,t.props.calendarStartDay))})),ye(we(t),"getHighLightedClass",(function(){var e=t.props,r=e.day,n=e.highlightDates;if(!n)return !1;var o=Ie(r,"MM.dd.yyyy");return n.get(o)})),ye(we(t),"getHolidaysClass",(function(){var e=t.props,r=e.day,n=e.holidays;if(!n)return !1;var o=Ie(r,"MM.dd.yyyy");return n.has(o)?[n.get(o).className]:void 0})),ye(we(t),"isInRange",(function(){var e=t.props,r=e.day,n=e.startDate,o=e.endDate;return !(!n||!o)&&qe(r,n,o)})),ye(we(t),"isInSelectingRange",(function(){var e,r=t.props,n=r.day,o=r.selectsStart,a=r.selectsEnd,s=r.selectsRange,i=r.selectsDisabledDaysInRange,p=r.startDate,c=r.endDate,l=null!==(e=t.props.selectingDate)&&void 0!==e?e:t.props.preSelection;return !(!(o||a||s)||!l||!i&&t.isDisabled())&&(o&&c&&(isBefore(l,c)||Ve(l,c))?qe(n,l,c):(a&&p&&(isAfter(l,p)||Ve(l,p))||!(!s||!p||c||!isAfter(l,p)&&!Ve(l,p)))&&qe(n,p,l))})),ye(we(t),"isSelectingRangeStart",(function(){var e;if(!t.isInSelectingRange())return !1;var r=t.props,n=r.day,o=r.startDate,a=r.selectsStart,s=null!==(e=t.props.selectingDate)&&void 0!==e?e:t.props.preSelection;return je(n,a?s:o)})),ye(we(t),"isSelectingRangeEnd",(function(){var e;if(!t.isInSelectingRange())return !1;var r=t.props,n=r.day,o=r.endDate,a=r.selectsEnd,s=r.selectsRange,i=null!==(e=t.props.selectingDate)&&void 0!==e?e:t.props.preSelection;return je(n,a||s?i:o)})),ye(we(t),"isRangeStart",(function(){var e=t.props,r=e.day,n=e.startDate,o=e.endDate;return !(!n||!o)&&je(n,r)})),ye(we(t),"isRangeEnd",(function(){var e=t.props,r=e.day,n=e.startDate,o=e.endDate;return !(!n||!o)&&je(o,r)})),ye(we(t),"isWeekend",(function(){var e=getDay(t.props.day);return 0===e||6===e})),ye(we(t),"isAfterMonth",(function(){return void 0!==t.props.month&&(t.props.month+1)%12===getMonth(t.props.day)})),ye(we(t),"isBeforeMonth",(function(){return void 0!==t.props.month&&(getMonth(t.props.day)+1)%12===t.props.month})),ye(we(t),"isCurrentDay",(function(){return t.isSameDay(Ye())})),ye(we(t),"isSelected",(function(){return t.isSameDay(t.props.selected)||t.isSameWeek(t.props.selected)})),ye(we(t),"getClassNames",(function(e){var n,o=t.props.dayClassName?t.props.dayClassName(e):void 0;return classnames("react-datepicker__day",o,"react-datepicker__day--"+Ie(t.props.day,"ddd",n),{"react-datepicker__day--disabled":t.isDisabled(),"react-datepicker__day--excluded":t.isExcluded(),"react-datepicker__day--selected":t.isSelected(),"react-datepicker__day--keyboard-selected":t.isKeyboardSelected(),"react-datepicker__day--range-start":t.isRangeStart(),"react-datepicker__day--range-end":t.isRangeEnd(),"react-datepicker__day--in-range":t.isInRange(),"react-datepicker__day--in-selecting-range":t.isInSelectingRange(),"react-datepicker__day--selecting-range-start":t.isSelectingRangeStart(),"react-datepicker__day--selecting-range-end":t.isSelectingRangeEnd(),"react-datepicker__day--today":t.isCurrentDay(),"react-datepicker__day--weekend":t.isWeekend(),"react-datepicker__day--outside-month":t.isAfterMonth()||t.isBeforeMonth()},t.getHighLightedClass("react-datepicker__day--highlighted"),t.getHolidaysClass())})),ye(we(t),"getAriaLabel",(function(){var e=t.props,r=e.day,n=e.ariaLabelPrefixWhenEnabled,o=void 0===n?"Choose":n,a=e.ariaLabelPrefixWhenDisabled,s=void 0===a?"Not available":a,i=t.isDisabled()||t.isExcluded()?s:o;return "".concat(i," ").concat(Ie(r,"PPPP",t.props.locale))})),ye(we(t),"getTitle",(function(){var e=t.props,r=e.day,n=e.holidays,o=void 0===n?new Map:n,a=Ie(r,"MM.dd.yyyy");return o.has(a)&&o.get(a).holidayNames.length>0?o.get(a).holidayNames.join(", "):""})),ye(we(t),"getTabIndex",(function(e,r){var n=e||t.props.selected,o=r||t.props.preSelection;return (!t.props.showWeekPicker||!t.props.showWeekNumber&&t.isStartOfWeek())&&(t.isKeyboardSelected()||t.isSameDay(n)&&je(o,n))?0:-1})),ye(we(t),"handleFocusDay",(function(){var e,r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},n=!1;0===t.getTabIndex()&&!r.isInputFocused&&t.isSameDay(t.props.preSelection)&&(document.activeElement&&document.activeElement!==document.body||(n=!0),t.props.inline&&!t.props.shouldFocusDayInline&&(n=!1),t.props.containerRef&&t.props.containerRef.current&&t.props.containerRef.current.contains(document.activeElement)&&document.activeElement.classList.contains("react-datepicker__day")&&(n=!0),t.props.monthShowsDuplicateDaysEnd&&t.isAfterMonth()&&(n=!1),t.props.monthShowsDuplicateDaysStart&&t.isBeforeMonth()&&(n=!1)),n&&(null===(e=t.dayEl.current)||void 0===e||e.focus({preventScroll:!0}));})),ye(we(t),"renderDayContents",(function(){return t.props.monthShowsDuplicateDaysEnd&&t.isAfterMonth()||t.props.monthShowsDuplicateDaysStart&&t.isBeforeMonth()?null:t.props.renderDayContents?t.props.renderDayContents(getDate(t.props.day),t.props.day):getDate(t.props.day)})),ye(we(t),"render",(function(){return React__default.createElement("div",{ref:t.dayEl,className:t.getClassNames(t.props.day),onKeyDown:t.handleOnKeyDown,onClick:t.handleClick,onMouseEnter:t.handleMouseEnter,tabIndex:t.getTabIndex(),"aria-label":t.getAriaLabel(),role:"option",title:t.getTitle(),"aria-disabled":t.isDisabled(),"aria-current":t.isCurrentDay()?"date":void 0,"aria-selected":t.isSelected()||t.isInRange()},t.renderDayContents(),""!==t.getTitle()&&React__default.createElement("span",{className:"holiday-overlay"},t.getTitle()))})),t}return fe(o,[{key:"componentDidMount",value:function(){this.handleFocusDay();}},{key:"componentDidUpdate",value:function(e){this.handleFocusDay(e);}}]),o}(),Tt=function(t){De(o,React__default.Component);var n=be(o);function o(){var t;he(this,o);for(var r=arguments.length,a=new Array(r),s=0;s<r;s++)a[s]=arguments[s];return ye(we(t=n.call.apply(n,[this].concat(a))),"weekNumberEl",React__default.createRef()),ye(we(t),"handleClick",(function(e){t.props.onClick&&t.props.onClick(e);})),ye(we(t),"handleOnKeyDown",(function(e){" "===e.key&&(e.preventDefault(),e.key="Enter"),t.props.handleOnKeyDown(e);})),ye(we(t),"isKeyboardSelected",(function(){return !t.props.disabledKeyboardNavigation&&!je(t.props.date,t.props.selected)&&je(t.props.date,t.props.preSelection)})),ye(we(t),"getTabIndex",(function(){return t.props.showWeekPicker&&t.props.showWeekNumber&&(t.isKeyboardSelected()||je(t.props.date,t.props.selected)&&je(t.props.preSelection,t.props.selected))?0:-1})),ye(we(t),"handleFocusWeekNumber",(function(){var e=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=!1;0===t.getTabIndex()&&!e.isInputFocused&&je(t.props.date,t.props.preSelection)&&(document.activeElement&&document.activeElement!==document.body||(r=!0),t.props.inline&&!t.props.shouldFocusDayInline&&(r=!1),t.props.containerRef&&t.props.containerRef.current&&t.props.containerRef.current.contains(document.activeElement)&&document.activeElement&&document.activeElement.classList.contains("react-datepicker__week-number")&&(r=!0)),r&&t.weekNumberEl.current&&t.weekNumberEl.current.focus({preventScroll:!0});})),t}return fe(o,[{key:"componentDidMount",value:function(){this.handleFocusWeekNumber();}},{key:"componentDidUpdate",value:function(e){this.handleFocusWeekNumber(e);}},{key:"render",value:function(){var t=this.props,n=t.weekNumber,o=t.ariaLabelPrefix,a=void 0===o?"week ":o,s={"react-datepicker__week-number":!0,"react-datepicker__week-number--clickable":!!t.onClick,"react-datepicker__week-number--selected":je(this.props.date,this.props.selected),"react-datepicker__week-number--keyboard-selected":this.isKeyboardSelected()};return React__default.createElement("div",{ref:this.weekNumberEl,className:classnames(s),"aria-label":"".concat(a," ").concat(this.props.weekNumber),onClick:this.handleClick,onKeyDown:this.handleOnKeyDown,tabIndex:this.getTabIndex()},n)}}],[{key:"defaultProps",get:function(){return {ariaLabelPrefix:"week "}}}]),o}(),It=function(t){De(o,React__default.Component);var n=be(o);function o(){var t;he(this,o);for(var r=arguments.length,a=new Array(r),s=0;s<r;s++)a[s]=arguments[s];return ye(we(t=n.call.apply(n,[this].concat(a))),"handleDayClick",(function(e,r){t.props.onDayClick&&t.props.onDayClick(e,r);})),ye(we(t),"handleDayMouseEnter",(function(e){t.props.onDayMouseEnter&&t.props.onDayMouseEnter(e);})),ye(we(t),"handleWeekClick",(function(e,r,n){if("function"==typeof t.props.onWeekSelect&&t.props.onWeekSelect(e,r,n),t.props.showWeekPicker){var o=Le(e,t.props.locale,t.props.calendarStartDay);t.handleDayClick(o,n);}t.props.shouldCloseOnSelect&&t.props.setOpen(!1);})),ye(we(t),"formatWeekNumber",(function(e){return t.props.formatWeekNumber?t.props.formatWeekNumber(e):function(e,t){var r=t&&Ge(t)||$e()&&Ge($e());return getISOWeek(e,r?{locale:r}:null)}(e)})),ye(we(t),"renderDays",(function(){var r=Le(t.props.day,t.props.locale,t.props.calendarStartDay),n=[],o=t.formatWeekNumber(r);if(t.props.showWeekNumber){var a=t.props.onWeekSelect||t.props.showWeekPicker?t.handleWeekClick.bind(we(t),r,o):void 0;n.push(React__default.createElement(Tt,{key:"W",weekNumber:o,date:r,onClick:a,selected:t.props.selected,preSelection:t.props.preSelection,ariaLabelPrefix:t.props.ariaLabelPrefix,showWeekPicker:t.props.showWeekPicker,showWeekNumber:t.props.showWeekNumber,disabledKeyboardNavigation:t.props.disabledKeyboardNavigation,handleOnKeyDown:t.props.handleOnKeyDown,isInputFocused:t.props.isInputFocused,containerRef:t.props.containerRef}));}return n.concat([0,1,2,3,4,5,6].map((function(n){var o=addDays(r,n);return React__default.createElement(Yt,{ariaLabelPrefixWhenEnabled:t.props.chooseDayAriaLabelPrefix,ariaLabelPrefixWhenDisabled:t.props.disabledDayAriaLabelPrefix,key:o.valueOf(),day:o,month:t.props.month,onClick:t.handleDayClick.bind(we(t),o),onMouseEnter:t.handleDayMouseEnter.bind(we(t),o),minDate:t.props.minDate,maxDate:t.props.maxDate,excludeDates:t.props.excludeDates,excludeDateIntervals:t.props.excludeDateIntervals,includeDates:t.props.includeDates,includeDateIntervals:t.props.includeDateIntervals,highlightDates:t.props.highlightDates,holidays:t.props.holidays,selectingDate:t.props.selectingDate,filterDate:t.props.filterDate,preSelection:t.props.preSelection,selected:t.props.selected,selectsStart:t.props.selectsStart,selectsEnd:t.props.selectsEnd,selectsRange:t.props.selectsRange,showWeekPicker:t.props.showWeekPicker,showWeekNumber:t.props.showWeekNumber,selectsDisabledDaysInRange:t.props.selectsDisabledDaysInRange,startDate:t.props.startDate,endDate:t.props.endDate,dayClassName:t.props.dayClassName,renderDayContents:t.props.renderDayContents,disabledKeyboardNavigation:t.props.disabledKeyboardNavigation,handleOnKeyDown:t.props.handleOnKeyDown,isInputFocused:t.props.isInputFocused,containerRef:t.props.containerRef,inline:t.props.inline,shouldFocusDayInline:t.props.shouldFocusDayInline,monthShowsDuplicateDaysEnd:t.props.monthShowsDuplicateDaysEnd,monthShowsDuplicateDaysStart:t.props.monthShowsDuplicateDaysStart,locale:t.props.locale})})))})),ye(we(t),"startOfWeek",(function(){return Le(t.props.day,t.props.locale,t.props.calendarStartDay)})),ye(we(t),"isKeyboardSelected",(function(){return !t.props.disabledKeyboardNavigation&&!je(t.startOfWeek(),t.props.selected)&&je(t.startOfWeek(),t.props.preSelection)})),t}return fe(o,[{key:"render",value:function(){var t={"react-datepicker__week":!0,"react-datepicker__week--selected":je(this.startOfWeek(),this.props.selected),"react-datepicker__week--keyboard-selected":this.isKeyboardSelected()};return React__default.createElement("div",{className:classnames(t)},this.renderDays())}}],[{key:"defaultProps",get:function(){return {shouldCloseOnSelect:!0}}}]),o}(),Ot="two_columns",Rt="three_columns",Lt="four_columns",Ft=ye(ye(ye({},Ot,{grid:[[0,1],[2,3],[4,5],[6,7],[8,9],[10,11]],verticalNavigationOffset:2}),Rt,{grid:[[0,1,2],[3,4,5],[6,7,8],[9,10,11]],verticalNavigationOffset:3}),Lt,{grid:[[0,1,2,3],[4,5,6,7],[8,9,10,11]],verticalNavigationOffset:4});function At(e,t){return e?Lt:t?Ot:Rt}var Wt=function(t){De(o,React__default.Component);var n=be(o);function o(){var t;he(this,o);for(var a=arguments.length,s=new Array(a),i=0;i<a;i++)s[i]=arguments[i];return ye(we(t=n.call.apply(n,[this].concat(s))),"MONTH_REFS",Se(Array(12)).map((function(){return React__default.createRef()}))),ye(we(t),"QUARTER_REFS",Se(Array(4)).map((function(){return React__default.createRef()}))),ye(we(t),"isDisabled",(function(e){return Ze(e,t.props)})),ye(we(t),"isExcluded",(function(e){return et(e,t.props)})),ye(we(t),"handleDayClick",(function(e,r){t.props.onDayClick&&t.props.onDayClick(e,r,t.props.orderInDisplay);})),ye(we(t),"handleDayMouseEnter",(function(e){t.props.onDayMouseEnter&&t.props.onDayMouseEnter(e);})),ye(we(t),"handleMouseLeave",(function(){t.props.onMouseLeave&&t.props.onMouseLeave();})),ye(we(t),"isRangeStartMonth",(function(e){var r=t.props,n=r.day,o=r.startDate,a=r.endDate;return !(!o||!a)&&Qe(setMonth(n,e),o)})),ye(we(t),"isRangeStartQuarter",(function(e){var r=t.props,n=r.day,o=r.startDate,a=r.endDate;return !(!o||!a)&&He(setQuarter(n,e),o)})),ye(we(t),"isRangeEndMonth",(function(e){var r=t.props,n=r.day,o=r.startDate,a=r.endDate;return !(!o||!a)&&Qe(setMonth(n,e),a)})),ye(we(t),"isRangeEndQuarter",(function(e){var r=t.props,n=r.day,o=r.startDate,a=r.endDate;return !(!o||!a)&&He(setQuarter(n,e),a)})),ye(we(t),"isInSelectingRangeMonth",(function(e){var r,n=t.props,o=n.day,a=n.selectsStart,s=n.selectsEnd,i=n.selectsRange,p=n.startDate,c=n.endDate,l=null!==(r=t.props.selectingDate)&&void 0!==r?r:t.props.preSelection;return !(!(a||s||i)||!l)&&(a&&c?rt(l,c,e,o):(s&&p||!(!i||!p||c))&&rt(p,l,e,o))})),ye(we(t),"isSelectingMonthRangeStart",(function(e){var r;if(!t.isInSelectingRangeMonth(e))return !1;var n=t.props,o=n.day,a=n.startDate,s=n.selectsStart,i=setMonth(o,e),p=null!==(r=t.props.selectingDate)&&void 0!==r?r:t.props.preSelection;return Qe(i,s?p:a)})),ye(we(t),"isSelectingMonthRangeEnd",(function(e){var r;if(!t.isInSelectingRangeMonth(e))return !1;var n=t.props,o=n.day,a=n.endDate,s=n.selectsEnd,i=n.selectsRange,p=setMonth(o,e),c=null!==(r=t.props.selectingDate)&&void 0!==r?r:t.props.preSelection;return Qe(p,s||i?c:a)})),ye(we(t),"isInSelectingRangeQuarter",(function(e){var r,n=t.props,o=n.day,a=n.selectsStart,s=n.selectsEnd,i=n.selectsRange,p=n.startDate,c=n.endDate,l=null!==(r=t.props.selectingDate)&&void 0!==r?r:t.props.preSelection;return !(!(a||s||i)||!l)&&(a&&c?st(l,c,e,o):(s&&p||!(!i||!p||c))&&st(p,l,e,o))})),ye(we(t),"isWeekInMonth",(function(e){var r=t.props.day,n=addDays(e,6);return Qe(e,r)||Qe(n,r)})),ye(we(t),"isCurrentMonth",(function(e,t){return getYear(e)===getYear(Ye())&&t===getMonth(Ye())})),ye(we(t),"isCurrentQuarter",(function(e,t){return getYear(e)===getYear(Ye())&&t===getQuarter(Ye())})),ye(we(t),"isSelectedMonth",(function(e,t,r){return getMonth(r)===t&&getYear(e)===getYear(r)})),ye(we(t),"isSelectedQuarter",(function(e,t,r){return getQuarter(e)===t&&getYear(e)===getYear(r)})),ye(we(t),"renderWeeks",(function(){for(var r=[],n=t.props.fixedHeight,o=0,a=!1,s=Le(Fe(t.props.day),t.props.locale,t.props.calendarStartDay);r.push(React__default.createElement(It,{ariaLabelPrefix:t.props.weekAriaLabelPrefix,chooseDayAriaLabelPrefix:t.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:t.props.disabledDayAriaLabelPrefix,key:o,day:s,month:getMonth(t.props.day),onDayClick:t.handleDayClick,onDayMouseEnter:t.handleDayMouseEnter,onWeekSelect:t.props.onWeekSelect,formatWeekNumber:t.props.formatWeekNumber,locale:t.props.locale,minDate:t.props.minDate,maxDate:t.props.maxDate,excludeDates:t.props.excludeDates,excludeDateIntervals:t.props.excludeDateIntervals,includeDates:t.props.includeDates,includeDateIntervals:t.props.includeDateIntervals,inline:t.props.inline,shouldFocusDayInline:t.props.shouldFocusDayInline,highlightDates:t.props.highlightDates,holidays:t.props.holidays,selectingDate:t.props.selectingDate,filterDate:t.props.filterDate,preSelection:t.props.preSelection,selected:t.props.selected,selectsStart:t.props.selectsStart,selectsEnd:t.props.selectsEnd,selectsRange:t.props.selectsRange,selectsDisabledDaysInRange:t.props.selectsDisabledDaysInRange,showWeekNumber:t.props.showWeekNumbers,showWeekPicker:t.props.showWeekPicker,startDate:t.props.startDate,endDate:t.props.endDate,dayClassName:t.props.dayClassName,setOpen:t.props.setOpen,shouldCloseOnSelect:t.props.shouldCloseOnSelect,disabledKeyboardNavigation:t.props.disabledKeyboardNavigation,renderDayContents:t.props.renderDayContents,handleOnKeyDown:t.props.handleOnKeyDown,isInputFocused:t.props.isInputFocused,containerRef:t.props.containerRef,calendarStartDay:t.props.calendarStartDay,monthShowsDuplicateDaysEnd:t.props.monthShowsDuplicateDaysEnd,monthShowsDuplicateDaysStart:t.props.monthShowsDuplicateDaysStart})),!a;){o++,s=addWeeks(s,1);var i=n&&o>=6,p=!n&&!t.isWeekInMonth(s);if(i||p){if(!t.props.peekNextMonth)break;a=!0;}}return r})),ye(we(t),"onMonthClick",(function(e,r){t.handleDayClick(Fe(setMonth(t.props.day,r)),e);})),ye(we(t),"onMonthMouseEnter",(function(e){t.handleDayMouseEnter(Fe(setMonth(t.props.day,e)));})),ye(we(t),"handleMonthNavigation",(function(e,r){t.isDisabled(r)||t.isExcluded(r)||(t.props.setPreSelection(r),t.MONTH_REFS[e].current&&t.MONTH_REFS[e].current.focus());})),ye(we(t),"onMonthKeyDown",(function(e,r){var n=t.props,o=n.selected,a=n.preSelection,s=n.disabledKeyboardNavigation,i=n.showTwoColumnMonthYearPicker,p=n.showFourColumnMonthYearPicker,c=n.setPreSelection,d=e.key;if("Tab"!==d&&e.preventDefault(),!s){var u=At(p,i),h=Ft[u].verticalNavigationOffset,m=Ft[u].grid;switch(d){case"Enter":t.onMonthClick(e,r),c(o);break;case"ArrowRight":t.handleMonthNavigation(11===r?0:r+1,addMonths(a,1));break;case"ArrowLeft":t.handleMonthNavigation(0===r?11:r-1,subMonths(a,1));break;case"ArrowUp":t.handleMonthNavigation(m[0].includes(r)?r+12-h:r-h,subMonths(a,h));break;case"ArrowDown":t.handleMonthNavigation(m[m.length-1].includes(r)?r-12+h:r+h,addMonths(a,h));}}})),ye(we(t),"onQuarterClick",(function(e,r){t.handleDayClick(We(setQuarter(t.props.day,r)),e);})),ye(we(t),"onQuarterMouseEnter",(function(e){t.handleDayMouseEnter(We(setQuarter(t.props.day,e)));})),ye(we(t),"handleQuarterNavigation",(function(e,r){t.isDisabled(r)||t.isExcluded(r)||(t.props.setPreSelection(r),t.QUARTER_REFS[e-1].current&&t.QUARTER_REFS[e-1].current.focus());})),ye(we(t),"onQuarterKeyDown",(function(e,r){var n=e.key;if(!t.props.disabledKeyboardNavigation)switch(n){case"Enter":t.onQuarterClick(e,r),t.props.setPreSelection(t.props.selected);break;case"ArrowRight":t.handleQuarterNavigation(4===r?1:r+1,addQuarters(t.props.preSelection,1));break;case"ArrowLeft":t.handleQuarterNavigation(1===r?4:r-1,subQuarters(t.props.preSelection,1));}})),ye(we(t),"getMonthClassNames",(function(e){var n=t.props,o=n.day,a=n.startDate,s=n.endDate,i=n.selected,p=n.minDate,c=n.maxDate,l=n.preSelection,d=n.monthClassName,u=n.excludeDates,h=n.includeDates,m=d?d(setMonth(o,e)):void 0,f=setMonth(o,e);return classnames("react-datepicker__month-text","react-datepicker__month-".concat(e),m,{"react-datepicker__month-text--disabled":(p||c||u||h)&&tt(f,t.props),"react-datepicker__month-text--selected":t.isSelectedMonth(o,e,i),"react-datepicker__month-text--keyboard-selected":!t.props.disabledKeyboardNavigation&&getMonth(l)===e,"react-datepicker__month-text--in-selecting-range":t.isInSelectingRangeMonth(e),"react-datepicker__month-text--in-range":rt(a,s,e,o),"react-datepicker__month-text--range-start":t.isRangeStartMonth(e),"react-datepicker__month-text--range-end":t.isRangeEndMonth(e),"react-datepicker__month-text--selecting-range-start":t.isSelectingMonthRangeStart(e),"react-datepicker__month-text--selecting-range-end":t.isSelectingMonthRangeEnd(e),"react-datepicker__month-text--today":t.isCurrentMonth(o,e)})})),ye(we(t),"getTabIndex",(function(e){var r=getMonth(t.props.preSelection);return t.props.disabledKeyboardNavigation||e!==r?"-1":"0"})),ye(we(t),"getQuarterTabIndex",(function(e){var r=getQuarter(t.props.preSelection);return t.props.disabledKeyboardNavigation||e!==r?"-1":"0"})),ye(we(t),"getAriaLabel",(function(e){var r=t.props,n=r.chooseDayAriaLabelPrefix,o=void 0===n?"Choose":n,a=r.disabledDayAriaLabelPrefix,s=void 0===a?"Not available":a,i=r.day,p=setMonth(i,e),c=t.isDisabled(p)||t.isExcluded(p)?s:o;return "".concat(c," ").concat(Ie(p,"MMMM yyyy"))})),ye(we(t),"getQuarterClassNames",(function(e){var n=t.props,o=n.day,a=n.startDate,s=n.endDate,i=n.selected,p=n.minDate,c=n.maxDate,l=n.preSelection,d=n.disabledKeyboardNavigation;return classnames("react-datepicker__quarter-text","react-datepicker__quarter-".concat(e),{"react-datepicker__quarter-text--disabled":(p||c)&&nt(setQuarter(o,e),t.props),"react-datepicker__quarter-text--selected":t.isSelectedQuarter(o,e,i),"react-datepicker__quarter-text--keyboard-selected":!d&&getQuarter(l)===e,"react-datepicker__quarter-text--in-selecting-range":t.isInSelectingRangeQuarter(e),"react-datepicker__quarter-text--in-range":st(a,s,e,o),"react-datepicker__quarter-text--range-start":t.isRangeStartQuarter(e),"react-datepicker__quarter-text--range-end":t.isRangeEndQuarter(e)})})),ye(we(t),"getMonthContent",(function(e){var r=t.props,n=r.showFullMonthYearPicker,o=r.renderMonthContent,a=r.locale,s=r.day,i=Xe(e,a),p=Je(e,a);return o?o(e,i,p,s):n?p:i})),ye(we(t),"getQuarterContent",(function(e){var r=t.props,n=r.renderQuarterContent,o=function(e,t){return Ie(setQuarter(Ye(),e),"QQQ",t)}(e,r.locale);return n?n(e,o):o})),ye(we(t),"renderMonths",(function(){var r=t.props,n=r.showTwoColumnMonthYearPicker,o=r.showFourColumnMonthYearPicker,a=r.day,s=r.selected;return Ft[At(o,n)].grid.map((function(r,n){return React__default.createElement("div",{className:"react-datepicker__month-wrapper",key:n},r.map((function(r,n){return React__default.createElement("div",{ref:t.MONTH_REFS[r],key:n,onClick:function(e){t.onMonthClick(e,r);},onKeyDown:function(e){t.onMonthKeyDown(e,r);},onMouseEnter:function(){return t.onMonthMouseEnter(r)},tabIndex:t.getTabIndex(r),className:t.getMonthClassNames(r),role:"option","aria-label":t.getAriaLabel(r),"aria-current":t.isCurrentMonth(a,r)?"date":void 0,"aria-selected":t.isSelectedMonth(a,r,s)},t.getMonthContent(r))})))}))})),ye(we(t),"renderQuarters",(function(){var r=t.props,n=r.day,o=r.selected;return React__default.createElement("div",{className:"react-datepicker__quarter-wrapper"},[1,2,3,4].map((function(r,a){return React__default.createElement("div",{key:a,ref:t.QUARTER_REFS[a],role:"option",onClick:function(e){t.onQuarterClick(e,r);},onKeyDown:function(e){t.onQuarterKeyDown(e,r);},onMouseEnter:function(){return t.onQuarterMouseEnter(r)},className:t.getQuarterClassNames(r),"aria-selected":t.isSelectedQuarter(n,r,o),tabIndex:t.getQuarterTabIndex(r),"aria-current":t.isCurrentQuarter(n,r)?"date":void 0},t.getQuarterContent(r))})))})),ye(we(t),"getClassNames",(function(){var e=t.props,n=e.selectingDate,o=e.selectsStart,a=e.selectsEnd,s=e.showMonthYearPicker,i=e.showQuarterYearPicker,p=e.showWeekPicker;return classnames("react-datepicker__month",{"react-datepicker__month--selecting-range":n&&(o||a)},{"react-datepicker__monthPicker":s},{"react-datepicker__quarterPicker":i},{"react-datepicker__weekPicker":p})})),t}return fe(o,[{key:"render",value:function(){var t=this.props,r=t.showMonthYearPicker,n=t.showQuarterYearPicker,o=t.day,a=t.ariaLabelPrefix,s=void 0===a?"month ":a;return React__default.createElement("div",{className:this.getClassNames(),onMouseLeave:this.handleMouseLeave,"aria-label":"".concat(s," ").concat(Ie(o,"yyyy-MM")),role:"listbox"},r?this.renderMonths():n?this.renderQuarters():this.renderWeeks())}}]),o}(),Kt=function(t){De(n,React__default.Component);var r=be(n);function n(){var t;he(this,n);for(var o=arguments.length,a=new Array(o),i=0;i<o;i++)a[i]=arguments[i];return ye(we(t=r.call.apply(r,[this].concat(a))),"state",{height:null}),ye(we(t),"scrollToTheSelectedTime",(function(){requestAnimationFrame((function(){t.list&&(t.list.scrollTop=t.centerLi&&n.calcCenterPosition(t.props.monthRef?t.props.monthRef.clientHeight-t.header.clientHeight:t.list.clientHeight,t.centerLi));}));})),ye(we(t),"handleClick",(function(e){(t.props.minTime||t.props.maxTime)&&lt(e,t.props)||(t.props.excludeTimes||t.props.includeTimes||t.props.filterTime)&&ct(e,t.props)||t.props.onChange(e);})),ye(we(t),"isSelectedTime",(function(e){return t.props.selected&&(r=t.props.selected,n=e,bt(r).getTime()===bt(n).getTime());var r,n;})),ye(we(t),"isDisabledTime",(function(e){return (t.props.minTime||t.props.maxTime)&&lt(e,t.props)||(t.props.excludeTimes||t.props.includeTimes||t.props.filterTime)&&ct(e,t.props)})),ye(we(t),"liClasses",(function(e){var r=["react-datepicker__time-list-item",t.props.timeClassName?t.props.timeClassName(e):void 0];return t.isSelectedTime(e)&&r.push("react-datepicker__time-list-item--selected"),t.isDisabledTime(e)&&r.push("react-datepicker__time-list-item--disabled"),t.props.injectTimes&&(60*getHours(e)+getMinutes(e))%t.props.intervals!=0&&r.push("react-datepicker__time-list-item--injected"),r.join(" ")})),ye(we(t),"handleOnKeyDown",(function(e,r){" "===e.key&&(e.preventDefault(),e.key="Enter"),"ArrowUp"!==e.key&&"ArrowLeft"!==e.key||!e.target.previousSibling||(e.preventDefault(),e.target.previousSibling.focus()),"ArrowDown"!==e.key&&"ArrowRight"!==e.key||!e.target.nextSibling||(e.preventDefault(),e.target.nextSibling.focus()),"Enter"===e.key&&t.handleClick(r),t.props.handleOnKeyDown(e);})),ye(we(t),"renderTimes",(function(){for(var r=[],n=t.props.format?t.props.format:"p",o=t.props.intervals,a=t.props.selected||t.props.openToDate||Ye(),i=startOfDay(a),p=t.props.injectTimes&&t.props.injectTimes.sort((function(e,t){return e-t})),c=60*function(e){var t=new Date(e.getFullYear(),e.getMonth(),e.getDate()),r=new Date(e.getFullYear(),e.getMonth(),e.getDate(),24);return Math.round((+r-+t)/36e5)}(a),l=c/o,d=0;d<l;d++){var u=addMinutes(i,d*o);if(r.push(u),p){var h=gt(i,u,d,o,p);r=r.concat(h);}}var m=r.reduce((function(e,t){return t.getTime()<=a.getTime()?t:e}),r[0]);return r.map((function(r,o){return React__default.createElement("li",{key:o,onClick:t.handleClick.bind(we(t),r),className:t.liClasses(r),ref:function(e){r===m&&(t.centerLi=e);},onKeyDown:function(e){t.handleOnKeyDown(e,r);},tabIndex:r===m?0:-1,role:"option","aria-selected":t.isSelectedTime(r)?"true":void 0,"aria-disabled":t.isDisabledTime(r)?"true":void 0},Ie(r,n,t.props.locale))}))})),t}return fe(n,[{key:"componentDidMount",value:function(){this.scrollToTheSelectedTime(),this.props.monthRef&&this.header&&this.setState({height:this.props.monthRef.clientHeight-this.header.clientHeight});}},{key:"render",value:function(){var t=this,r=this.state.height;return React__default.createElement("div",{className:"react-datepicker__time-container ".concat(this.props.todayButton?"react-datepicker__time-container--with-today-button":"")},React__default.createElement("div",{className:"react-datepicker__header react-datepicker__header--time ".concat(this.props.showTimeSelectOnly?"react-datepicker__header--time--only":""),ref:function(e){t.header=e;}},React__default.createElement("div",{className:"react-datepicker-time__header"},this.props.timeCaption)),React__default.createElement("div",{className:"react-datepicker__time"},React__default.createElement("div",{className:"react-datepicker__time-box"},React__default.createElement("ul",{className:"react-datepicker__time-list",ref:function(e){t.list=e;},style:r?{height:r}:{},role:"listbox","aria-label":this.props.timeCaption},this.renderTimes()))))}}],[{key:"defaultProps",get:function(){return {intervals:30,onTimeChange:function(){},todayButton:null,timeCaption:"Time"}}}]),n}();ye(Kt,"calcCenterPosition",(function(e,t){return t.offsetTop-(e/2-t.clientHeight/2)}));var Bt=function(t){De(o,React__default.Component);var n=be(o);function o(t){var a;return he(this,o),ye(we(a=n.call(this,t)),"YEAR_REFS",Se(Array(a.props.yearItemNumber)).map((function(){return React__default.createRef()}))),ye(we(a),"isDisabled",(function(e){return Ze(e,a.props)})),ye(we(a),"isExcluded",(function(e){return et(e,a.props)})),ye(we(a),"selectingDate",(function(){var e;return null!==(e=a.props.selectingDate)&&void 0!==e?e:a.props.preSelection})),ye(we(a),"updateFocusOnPaginate",(function(e){var t=function(){this.YEAR_REFS[e].current.focus();}.bind(we(a));window.requestAnimationFrame(t);})),ye(we(a),"handleYearClick",(function(e,t){a.props.onDayClick&&a.props.onDayClick(e,t);})),ye(we(a),"handleYearNavigation",(function(e,t){var r=a.props,n=r.date,o=r.yearItemNumber,s=wt(n,o).startPeriod;a.isDisabled(t)||a.isExcluded(t)||(a.props.setPreSelection(t),e-s==-1?a.updateFocusOnPaginate(o-1):e-s===o?a.updateFocusOnPaginate(0):a.YEAR_REFS[e-s].current.focus());})),ye(we(a),"isSameDay",(function(e,t){return je(e,t)})),ye(we(a),"isCurrentYear",(function(e){return e===getYear(Ye())})),ye(we(a),"isRangeStart",(function(e){return a.props.startDate&&a.props.endDate&&Be(setYear(Ye(),e),a.props.startDate)})),ye(we(a),"isRangeEnd",(function(e){return a.props.startDate&&a.props.endDate&&Be(setYear(Ye(),e),a.props.endDate)})),ye(we(a),"isInRange",(function(e){return ot(e,a.props.startDate,a.props.endDate)})),ye(we(a),"isInSelectingRange",(function(e){var t=a.props,r=t.selectsStart,n=t.selectsEnd,o=t.selectsRange,s=t.startDate,i=t.endDate;return !(!(r||n||o)||!a.selectingDate())&&(r&&i?ot(e,a.selectingDate(),i):(n&&s||!(!o||!s||i))&&ot(e,s,a.selectingDate()))})),ye(we(a),"isSelectingRangeStart",(function(e){if(!a.isInSelectingRange(e))return !1;var t=a.props,r=t.startDate,n=t.selectsStart,o=setYear(Ye(),e);return Be(o,n?a.selectingDate():r)})),ye(we(a),"isSelectingRangeEnd",(function(e){if(!a.isInSelectingRange(e))return !1;var t=a.props,r=t.endDate,n=t.selectsEnd,o=t.selectsRange,s=setYear(Ye(),e);return Be(s,n||o?a.selectingDate():r)})),ye(we(a),"isKeyboardSelected",(function(e){var t=Ae(setYear(a.props.date,e));return !a.props.disabledKeyboardNavigation&&!a.props.inline&&!je(t,Ae(a.props.selected))&&je(t,Ae(a.props.preSelection))})),ye(we(a),"onYearClick",(function(e,t){var r=a.props.date;a.handleYearClick(Ae(setYear(r,t)),e);})),ye(we(a),"onYearKeyDown",(function(e,t){var r=e.key;if(!a.props.disabledKeyboardNavigation)switch(r){case"Enter":a.onYearClick(e,t),a.props.setPreSelection(a.props.selected);break;case"ArrowRight":a.handleYearNavigation(t+1,addYears(a.props.preSelection,1));break;case"ArrowLeft":a.handleYearNavigation(t-1,subYears(a.props.preSelection,1));}})),ye(we(a),"getYearClassNames",(function(e){var t=a.props,n=t.minDate,o=t.maxDate,s=t.selected,i=t.excludeDates,p=t.includeDates,c=t.filterDate;return classnames("react-datepicker__year-text",{"react-datepicker__year-text--selected":e===getYear(s),"react-datepicker__year-text--disabled":(n||o||i||p||c)&&at(e,a.props),"react-datepicker__year-text--keyboard-selected":a.isKeyboardSelected(e),"react-datepicker__year-text--range-start":a.isRangeStart(e),"react-datepicker__year-text--range-end":a.isRangeEnd(e),"react-datepicker__year-text--in-range":a.isInRange(e),"react-datepicker__year-text--in-selecting-range":a.isInSelectingRange(e),"react-datepicker__year-text--selecting-range-start":a.isSelectingRangeStart(e),"react-datepicker__year-text--selecting-range-end":a.isSelectingRangeEnd(e),"react-datepicker__year-text--today":a.isCurrentYear(e)})})),ye(we(a),"getYearTabIndex",(function(e){return a.props.disabledKeyboardNavigation?"-1":e===getYear(a.props.preSelection)?"0":"-1"})),ye(we(a),"getYearContainerClassNames",(function(){var e=a.props,t=e.selectingDate,n=e.selectsStart,o=e.selectsEnd,s=e.selectsRange;return classnames("react-datepicker__year",{"react-datepicker__year--selecting-range":t&&(n||o||s)})})),ye(we(a),"getYearContent",(function(e){return a.props.renderYearContent?a.props.renderYearContent(e):e})),a}return fe(o,[{key:"render",value:function(){for(var t=this,r=[],n=this.props,o=n.date,a=n.yearItemNumber,s=n.onYearMouseEnter,i=n.onYearMouseLeave,p=wt(o,a),c=p.startPeriod,l=p.endPeriod,d=function(n){r.push(React__default.createElement("div",{ref:t.YEAR_REFS[n-c],onClick:function(e){t.onYearClick(e,n);},onKeyDown:function(e){t.onYearKeyDown(e,n);},tabIndex:t.getYearTabIndex(n),className:t.getYearClassNames(n),onMouseEnter:function(e){return s(e,n)},onMouseLeave:function(e){return i(e,n)},key:n,"aria-current":t.isCurrentYear(n)?"date":void 0},t.getYearContent(n)));},u=c;u<=l;u++)d(u);return React__default.createElement("div",{className:this.getYearContainerClassNames()},React__default.createElement("div",{className:"react-datepicker__year-wrapper",onMouseLeave:this.props.clearSelectingDate},r))}}]),o}(),Qt=function(t){De(n,React__default.Component);var r=be(n);function n(t){var o;return he(this,n),ye(we(o=r.call(this,t)),"onTimeChange",(function(e){o.setState({time:e});var t=o.props.date,r=t instanceof Date&&!isNaN(t)?t:new Date;r.setHours(e.split(":")[0]),r.setMinutes(e.split(":")[1]),o.props.onChange(r);})),ye(we(o),"renderTimeInput",(function(){var t=o.state.time,r=o.props,n=r.date,a=r.timeString,s=r.customTimeInput;return s?React__default.cloneElement(s,{date:n,value:t,onChange:o.onTimeChange}):React__default.createElement("input",{type:"time",className:"react-datepicker-time__input",placeholder:"Time",name:"time-input",required:!0,value:t,onChange:function(e){o.onTimeChange(e.target.value||a);}})})),o.state={time:o.props.timeString},o}return fe(n,[{key:"render",value:function(){return React__default.createElement("div",{className:"react-datepicker__input-time-container"},React__default.createElement("div",{className:"react-datepicker-time__caption"},this.props.timeInputLabel),React__default.createElement("div",{className:"react-datepicker-time__input-container"},React__default.createElement("div",{className:"react-datepicker-time__input"},this.renderTimeInput())))}}],[{key:"getDerivedStateFromProps",value:function(e,t){return e.timeString!==t.time?{time:e.timeString}:null}}]),n}();function Ht(t){var r=t.className,n=t.children,o=t.showPopperArrow,a=t.arrowProps,s=void 0===a?{}:a;return React__default.createElement("div",{className:r},o&&React__default.createElement("div",ve({className:"react-datepicker__triangle"},s)),n)}var jt=["react-datepicker__year-select","react-datepicker__month-select","react-datepicker__month-year-select"],Vt=function(t){De(o,React__default.Component);var n=be(o);function o(t){var a;return he(this,o),ye(we(a=n.call(this,t)),"handleClickOutside",(function(e){a.props.onClickOutside(e);})),ye(we(a),"setClickOutsideRef",(function(){return a.containerRef.current})),ye(we(a),"handleDropdownFocus",(function(e){(function(){var e=((arguments.length>0&&void 0!==arguments[0]?arguments[0]:{}).className||"").split(/\s+/);return jt.some((function(t){return e.indexOf(t)>=0}))})(e.target)&&a.props.onDropdownFocus();})),ye(we(a),"getDateInView",(function(){var e=a.props,t=e.preSelection,r=e.selected,n=e.openToDate,o=ft(a.props),s=yt(a.props),i=Ye(),p=n||r||t;return p||(o&&isBefore(i,o)?o:s&&isAfter(i,s)?s:i)})),ye(we(a),"increaseMonth",(function(){a.setState((function(e){var t=e.date;return {date:addMonths(t,1)}}),(function(){return a.handleMonthChange(a.state.date)}));})),ye(we(a),"decreaseMonth",(function(){a.setState((function(e){var t=e.date;return {date:subMonths(t,1)}}),(function(){return a.handleMonthChange(a.state.date)}));})),ye(we(a),"handleDayClick",(function(e,t,r){a.props.onSelect(e,t,r),a.props.setPreSelection&&a.props.setPreSelection(e);})),ye(we(a),"handleDayMouseEnter",(function(e){a.setState({selectingDate:e}),a.props.onDayMouseEnter&&a.props.onDayMouseEnter(e);})),ye(we(a),"handleMonthMouseLeave",(function(){a.setState({selectingDate:null}),a.props.onMonthMouseLeave&&a.props.onMonthMouseLeave();})),ye(we(a),"handleYearMouseEnter",(function(e,t){a.setState({selectingDate:setYear(Ye(),t)}),a.props.onYearMouseEnter&&a.props.onYearMouseEnter(e,t);})),ye(we(a),"handleYearMouseLeave",(function(e,t){a.props.onYearMouseLeave&&a.props.onYearMouseLeave(e,t);})),ye(we(a),"handleYearChange",(function(e){a.props.onYearChange&&(a.props.onYearChange(e),a.setState({isRenderAriaLiveMessage:!0})),a.props.adjustDateOnChange&&(a.props.onSelect&&a.props.onSelect(e),a.props.setOpen&&a.props.setOpen(!0)),a.props.setPreSelection&&a.props.setPreSelection(e);})),ye(we(a),"handleMonthChange",(function(e){a.handleCustomMonthChange(e),a.props.adjustDateOnChange&&(a.props.onSelect&&a.props.onSelect(e),a.props.setOpen&&a.props.setOpen(!0)),a.props.setPreSelection&&a.props.setPreSelection(e);})),ye(we(a),"handleCustomMonthChange",(function(e){a.props.onMonthChange&&(a.props.onMonthChange(e),a.setState({isRenderAriaLiveMessage:!0}));})),ye(we(a),"handleMonthYearChange",(function(e){a.handleYearChange(e),a.handleMonthChange(e);})),ye(we(a),"changeYear",(function(e){a.setState((function(t){var r=t.date;return {date:setYear(r,e)}}),(function(){return a.handleYearChange(a.state.date)}));})),ye(we(a),"changeMonth",(function(e){a.setState((function(t){var r=t.date;return {date:setMonth(r,e)}}),(function(){return a.handleMonthChange(a.state.date)}));})),ye(we(a),"changeMonthYear",(function(e){a.setState((function(t){var r=t.date;return {date:setYear(setMonth(r,getMonth(e)),getYear(e))}}),(function(){return a.handleMonthYearChange(a.state.date)}));})),ye(we(a),"header",(function(){var t=Le(arguments.length>0&&void 0!==arguments[0]?arguments[0]:a.state.date,a.props.locale,a.props.calendarStartDay),n=[];return a.props.showWeekNumbers&&n.push(React__default.createElement("div",{key:"W",className:"react-datepicker__day-name"},a.props.weekLabel||"#")),n.concat([0,1,2,3,4,5,6].map((function(n){var o=addDays(t,n),s=a.formatWeekday(o,a.props.locale),i=a.props.weekDayClassName?a.props.weekDayClassName(o):void 0;return React__default.createElement("div",{key:n,className:classnames("react-datepicker__day-name",i)},s)})))})),ye(we(a),"formatWeekday",(function(e,t){return a.props.formatWeekDay?function(e,t,r){return t(Ie(e,"EEEE",r))}(e,a.props.formatWeekDay,t):a.props.useWeekdaysShort?function(e,t){return Ie(e,"EEE",t)}(e,t):function(e,t){return Ie(e,"EEEEEE",t)}(e,t)})),ye(we(a),"decreaseYear",(function(){a.setState((function(e){var t=e.date;return {date:subYears(t,a.props.showYearPicker?a.props.yearItemNumber:1)}}),(function(){return a.handleYearChange(a.state.date)}));})),ye(we(a),"clearSelectingDate",(function(){a.setState({selectingDate:null});})),ye(we(a),"renderPreviousButton",(function(){if(!a.props.renderCustomHeader){var t;switch(!0){case a.props.showMonthYearPicker:t=ht(a.state.date,a.props);break;case a.props.showYearPicker:t=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.minDate,n=t.yearItemNumber,o=void 0===n?Ne:n,a=wt(Ae(subYears(e,o)),o).endPeriod,s=r&&getYear(r);return s&&s>a||!1}(a.state.date,a.props);break;default:t=dt(a.state.date,a.props);}if((a.props.forceShowMonthNavigation||a.props.showDisabledMonthNavigation||!t)&&!a.props.showTimeSelectOnly){var r=["react-datepicker__navigation","react-datepicker__navigation--previous"],n=a.decreaseMonth;(a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker)&&(n=a.decreaseYear),t&&a.props.showDisabledMonthNavigation&&(r.push("react-datepicker__navigation--previous--disabled"),n=null);var o=a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker,s=a.props,i=s.previousMonthButtonLabel,p=s.previousYearButtonLabel,c=a.props,l=c.previousMonthAriaLabel,d=void 0===l?"string"==typeof i?i:"Previous Month":l,u=c.previousYearAriaLabel,h=void 0===u?"string"==typeof p?p:"Previous Year":u;return React__default.createElement("button",{type:"button",className:r.join(" "),onClick:n,onKeyDown:a.props.handleOnKeyDown,"aria-label":o?h:d},React__default.createElement("span",{className:["react-datepicker__navigation-icon","react-datepicker__navigation-icon--previous"].join(" ")},o?a.props.previousYearButtonLabel:a.props.previousMonthButtonLabel))}}})),ye(we(a),"increaseYear",(function(){a.setState((function(e){var t=e.date;return {date:addYears(t,a.props.showYearPicker?a.props.yearItemNumber:1)}}),(function(){return a.handleYearChange(a.state.date)}));})),ye(we(a),"renderNextButton",(function(){if(!a.props.renderCustomHeader){var t;switch(!0){case a.props.showMonthYearPicker:t=mt(a.state.date,a.props);break;case a.props.showYearPicker:t=function(e){var t=arguments.length>1&&void 0!==arguments[1]?arguments[1]:{},r=t.maxDate,n=t.yearItemNumber,o=void 0===n?Ne:n,a=wt(addYears(e,o),o).startPeriod,s=r&&getYear(r);return s&&s<a||!1}(a.state.date,a.props);break;default:t=ut(a.state.date,a.props);}if((a.props.forceShowMonthNavigation||a.props.showDisabledMonthNavigation||!t)&&!a.props.showTimeSelectOnly){var r=["react-datepicker__navigation","react-datepicker__navigation--next"];a.props.showTimeSelect&&r.push("react-datepicker__navigation--next--with-time"),a.props.todayButton&&r.push("react-datepicker__navigation--next--with-today-button");var n=a.increaseMonth;(a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker)&&(n=a.increaseYear),t&&a.props.showDisabledMonthNavigation&&(r.push("react-datepicker__navigation--next--disabled"),n=null);var o=a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker,s=a.props,i=s.nextMonthButtonLabel,p=s.nextYearButtonLabel,c=a.props,l=c.nextMonthAriaLabel,d=void 0===l?"string"==typeof i?i:"Next Month":l,h=c.nextYearAriaLabel,m=void 0===h?"string"==typeof p?p:"Next Year":h;return React__default.createElement("button",{type:"button",className:r.join(" "),onClick:n,onKeyDown:a.props.handleOnKeyDown,"aria-label":o?m:d},React__default.createElement("span",{className:["react-datepicker__navigation-icon","react-datepicker__navigation-icon--next"].join(" ")},o?a.props.nextYearButtonLabel:a.props.nextMonthButtonLabel))}}})),ye(we(a),"renderCurrentMonth",(function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:a.state.date,r=["react-datepicker__current-month"];return a.props.showYearDropdown&&r.push("react-datepicker__current-month--hasYearDropdown"),a.props.showMonthDropdown&&r.push("react-datepicker__current-month--hasMonthDropdown"),a.props.showMonthYearDropdown&&r.push("react-datepicker__current-month--hasMonthYearDropdown"),React__default.createElement("div",{className:r.join(" ")},Ie(t,a.props.dateFormat,a.props.locale))})),ye(we(a),"renderYearDropdown",(function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showYearDropdown&&!t)return React__default.createElement(_t,{adjustDateOnChange:a.props.adjustDateOnChange,date:a.state.date,onSelect:a.props.onSelect,setOpen:a.props.setOpen,dropdownMode:a.props.dropdownMode,onChange:a.changeYear,minDate:a.props.minDate,maxDate:a.props.maxDate,year:getYear(a.state.date),scrollableYearDropdown:a.props.scrollableYearDropdown,yearDropdownItemNumber:a.props.yearDropdownItemNumber})})),ye(we(a),"renderMonthDropdown",(function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showMonthDropdown&&!t)return React__default.createElement(Pt,{dropdownMode:a.props.dropdownMode,locale:a.props.locale,onChange:a.changeMonth,month:getMonth(a.state.date),useShortMonthInDropdown:a.props.useShortMonthInDropdown})})),ye(we(a),"renderMonthYearDropdown",(function(){var t=arguments.length>0&&void 0!==arguments[0]&&arguments[0];if(a.props.showMonthYearDropdown&&!t)return React__default.createElement(xt,{dropdownMode:a.props.dropdownMode,locale:a.props.locale,dateFormat:a.props.dateFormat,onChange:a.changeMonthYear,minDate:a.props.minDate,maxDate:a.props.maxDate,date:a.state.date,scrollableMonthYearDropdown:a.props.scrollableMonthYearDropdown})})),ye(we(a),"handleTodayButtonClick",(function(e){a.props.onSelect(Ke(),e),a.props.setPreSelection&&a.props.setPreSelection(Ke());})),ye(we(a),"renderTodayButton",(function(){if(a.props.todayButton&&!a.props.showTimeSelectOnly)return React__default.createElement("div",{className:"react-datepicker__today-button",onClick:function(e){return a.handleTodayButtonClick(e)}},a.props.todayButton)})),ye(we(a),"renderDefaultHeader",(function(t){var r=t.monthDate,n=t.i;return React__default.createElement("div",{className:"react-datepicker__header ".concat(a.props.showTimeSelect?"react-datepicker__header--has-time-select":"")},a.renderCurrentMonth(r),React__default.createElement("div",{className:"react-datepicker__header__dropdown react-datepicker__header__dropdown--".concat(a.props.dropdownMode),onFocus:a.handleDropdownFocus},a.renderMonthDropdown(0!==n),a.renderMonthYearDropdown(0!==n),a.renderYearDropdown(0!==n)),React__default.createElement("div",{className:"react-datepicker__day-names"},a.header(r)))})),ye(we(a),"renderCustomHeader",(function(){var t=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},r=t.monthDate,n=t.i;if(a.props.showTimeSelect&&!a.state.monthContainer||a.props.showTimeSelectOnly)return null;var o=dt(a.state.date,a.props),s=ut(a.state.date,a.props),i=ht(a.state.date,a.props),p=mt(a.state.date,a.props),c=!a.props.showMonthYearPicker&&!a.props.showQuarterYearPicker&&!a.props.showYearPicker;return React__default.createElement("div",{className:"react-datepicker__header react-datepicker__header--custom",onFocus:a.props.onDropdownFocus},a.props.renderCustomHeader(de(de({},a.state),{},{customHeaderCount:n,monthDate:r,changeMonth:a.changeMonth,changeYear:a.changeYear,decreaseMonth:a.decreaseMonth,increaseMonth:a.increaseMonth,decreaseYear:a.decreaseYear,increaseYear:a.increaseYear,prevMonthButtonDisabled:o,nextMonthButtonDisabled:s,prevYearButtonDisabled:i,nextYearButtonDisabled:p})),c&&React__default.createElement("div",{className:"react-datepicker__day-names"},a.header(r)))})),ye(we(a),"renderYearHeader",(function(){var t=a.state.date,r=a.props,n=r.showYearPicker,o=wt(t,r.yearItemNumber),s=o.startPeriod,i=o.endPeriod;return React__default.createElement("div",{className:"react-datepicker__header react-datepicker-year-header"},n?"".concat(s," - ").concat(i):getYear(t))})),ye(we(a),"renderHeader",(function(e){switch(!0){case void 0!==a.props.renderCustomHeader:return a.renderCustomHeader(e);case a.props.showMonthYearPicker||a.props.showQuarterYearPicker||a.props.showYearPicker:return a.renderYearHeader(e);default:return a.renderDefaultHeader(e)}})),ye(we(a),"renderMonths",(function(){var t;if(!a.props.showTimeSelectOnly&&!a.props.showYearPicker){for(var r=[],n=a.props.showPreviousMonths?a.props.monthsShown-1:0,o=subMonths(a.state.date,n),s=null!==(t=a.props.monthSelectedIn)&&void 0!==t?t:n,i=0;i<a.props.monthsShown;++i){var p=addMonths(o,i-s+n),c="month-".concat(i),d=i<a.props.monthsShown-1,u=i>0;r.push(React__default.createElement("div",{key:c,ref:function(e){a.monthContainer=e;},className:"react-datepicker__month-container"},a.renderHeader({monthDate:p,i:i}),React__default.createElement(Wt,{chooseDayAriaLabelPrefix:a.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:a.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:a.props.weekAriaLabelPrefix,ariaLabelPrefix:a.props.monthAriaLabelPrefix,onChange:a.changeMonthYear,day:p,dayClassName:a.props.dayClassName,calendarStartDay:a.props.calendarStartDay,monthClassName:a.props.monthClassName,onDayClick:a.handleDayClick,handleOnKeyDown:a.props.handleOnDayKeyDown,onDayMouseEnter:a.handleDayMouseEnter,onMouseLeave:a.handleMonthMouseLeave,onWeekSelect:a.props.onWeekSelect,orderInDisplay:i,formatWeekNumber:a.props.formatWeekNumber,locale:a.props.locale,minDate:a.props.minDate,maxDate:a.props.maxDate,excludeDates:a.props.excludeDates,excludeDateIntervals:a.props.excludeDateIntervals,highlightDates:a.props.highlightDates,holidays:a.props.holidays,selectingDate:a.state.selectingDate,includeDates:a.props.includeDates,includeDateIntervals:a.props.includeDateIntervals,inline:a.props.inline,shouldFocusDayInline:a.props.shouldFocusDayInline,fixedHeight:a.props.fixedHeight,filterDate:a.props.filterDate,preSelection:a.props.preSelection,setPreSelection:a.props.setPreSelection,selected:a.props.selected,selectsStart:a.props.selectsStart,selectsEnd:a.props.selectsEnd,selectsRange:a.props.selectsRange,selectsDisabledDaysInRange:a.props.selectsDisabledDaysInRange,showWeekNumbers:a.props.showWeekNumbers,startDate:a.props.startDate,endDate:a.props.endDate,peekNextMonth:a.props.peekNextMonth,setOpen:a.props.setOpen,shouldCloseOnSelect:a.props.shouldCloseOnSelect,renderDayContents:a.props.renderDayContents,renderMonthContent:a.props.renderMonthContent,renderQuarterContent:a.props.renderQuarterContent,renderYearContent:a.props.renderYearContent,disabledKeyboardNavigation:a.props.disabledKeyboardNavigation,showMonthYearPicker:a.props.showMonthYearPicker,showFullMonthYearPicker:a.props.showFullMonthYearPicker,showTwoColumnMonthYearPicker:a.props.showTwoColumnMonthYearPicker,showFourColumnMonthYearPicker:a.props.showFourColumnMonthYearPicker,showYearPicker:a.props.showYearPicker,showQuarterYearPicker:a.props.showQuarterYearPicker,showWeekPicker:a.props.showWeekPicker,isInputFocused:a.props.isInputFocused,containerRef:a.containerRef,monthShowsDuplicateDaysEnd:d,monthShowsDuplicateDaysStart:u})));}return r}})),ye(we(a),"renderYears",(function(){if(!a.props.showTimeSelectOnly)return a.props.showYearPicker?React__default.createElement("div",{className:"react-datepicker__year--container"},a.renderHeader(),React__default.createElement(Bt,ve({onDayClick:a.handleDayClick,selectingDate:a.state.selectingDate,clearSelectingDate:a.clearSelectingDate,date:a.state.date},a.props,{onYearMouseEnter:a.handleYearMouseEnter,onYearMouseLeave:a.handleYearMouseLeave}))):void 0})),ye(we(a),"renderTimeSection",(function(){if(a.props.showTimeSelect&&(a.state.monthContainer||a.props.showTimeSelectOnly))return React__default.createElement(Kt,{selected:a.props.selected,openToDate:a.props.openToDate,onChange:a.props.onTimeChange,timeClassName:a.props.timeClassName,format:a.props.timeFormat,includeTimes:a.props.includeTimes,intervals:a.props.timeIntervals,minTime:a.props.minTime,maxTime:a.props.maxTime,excludeTimes:a.props.excludeTimes,filterTime:a.props.filterTime,timeCaption:a.props.timeCaption,todayButton:a.props.todayButton,showMonthDropdown:a.props.showMonthDropdown,showMonthYearDropdown:a.props.showMonthYearDropdown,showYearDropdown:a.props.showYearDropdown,withPortal:a.props.withPortal,monthRef:a.state.monthContainer,injectTimes:a.props.injectTimes,locale:a.props.locale,handleOnKeyDown:a.props.handleOnKeyDown,showTimeSelectOnly:a.props.showTimeSelectOnly})})),ye(we(a),"renderInputTimeSection",(function(){var t=new Date(a.props.selected),r=Te(t)&&Boolean(a.props.selected)?"".concat(kt(t.getHours()),":").concat(kt(t.getMinutes())):"";if(a.props.showTimeInput)return React__default.createElement(Qt,{date:t,timeString:r,timeInputLabel:a.props.timeInputLabel,onChange:a.props.onTimeChange,customTimeInput:a.props.customTimeInput})})),ye(we(a),"renderAriaLiveRegion",(function(){var t,r=wt(a.state.date,a.props.yearItemNumber),n=r.startPeriod,o=r.endPeriod;return t=a.props.showYearPicker?"".concat(n," - ").concat(o):a.props.showMonthYearPicker||a.props.showQuarterYearPicker?getYear(a.state.date):"".concat(Je(getMonth(a.state.date),a.props.locale)," ").concat(getYear(a.state.date)),React__default.createElement("span",{role:"alert","aria-live":"polite",className:"react-datepicker__aria-live"},a.state.isRenderAriaLiveMessage&&t)})),ye(we(a),"renderChildren",(function(){if(a.props.children)return React__default.createElement("div",{className:"react-datepicker__children-container"},a.props.children)})),a.containerRef=React__default.createRef(),a.state={date:a.getDateInView(),selectingDate:null,monthContainer:null,isRenderAriaLiveMessage:!1},a}return fe(o,[{key:"componentDidMount",value:function(){var e=this;this.props.showTimeSelect&&(this.assignMonthContainer=void e.setState({monthContainer:e.monthContainer}));}},{key:"componentDidUpdate",value:function(e){var t=this;if(!this.props.preSelection||je(this.props.preSelection,e.preSelection)&&this.props.monthSelectedIn===e.monthSelectedIn)this.props.openToDate&&!je(this.props.openToDate,e.openToDate)&&this.setState({date:this.props.openToDate});else {var r=!Qe(this.state.date,this.props.preSelection);this.setState({date:this.props.preSelection},(function(){return r&&t.handleCustomMonthChange(t.state.date)}));}}},{key:"render",value:function(){var t=this.props.container||Ht;return React__default.createElement("div",{style:{display:"contents"},ref:this.containerRef},React__default.createElement(t,{className:classnames("react-datepicker",this.props.className,{"react-datepicker--time-only":this.props.showTimeSelectOnly}),showPopperArrow:this.props.showPopperArrow,arrowProps:this.props.arrowProps},this.renderAriaLiveRegion(),this.renderPreviousButton(),this.renderNextButton(),this.renderMonths(),this.renderYears(),this.renderTodayButton(),this.renderTimeSection(),this.renderInputTimeSection(),this.renderChildren()))}}],[{key:"defaultProps",get:function(){return {onDropdownFocus:function(){},monthsShown:1,forceShowMonthNavigation:!1,timeCaption:"Time",previousYearButtonLabel:"Previous Year",nextYearButtonLabel:"Next Year",previousMonthButtonLabel:"Previous Month",nextMonthButtonLabel:"Next Month",customTimeInput:null,yearItemNumber:Ne}}}]),o}(),qt=function(t){var r=t.icon,n=t.className,o=void 0===n?"":n,a=t.onClick,s="react-datepicker__calendar-icon";return React__default.isValidElement(r)?React__default.cloneElement(r,{className:"".concat(r.props.className||""," ").concat(s," ").concat(o),onClick:function(e){"function"==typeof r.props.onClick&&r.props.onClick(e),"function"==typeof a&&a(e);}}):"string"==typeof r?React__default.createElement("i",{className:"".concat(s," ").concat(r," ").concat(o),"aria-hidden":"true",onClick:a}):React__default.createElement("svg",{className:"".concat(s," ").concat(o),xmlns:"http://www.w3.org/2000/svg",viewBox:"0 0 448 512",onClick:a},React__default.createElement("path",{d:"M96 32V64H48C21.5 64 0 85.5 0 112v48H448V112c0-26.5-21.5-48-48-48H352V32c0-17.7-14.3-32-32-32s-32 14.3-32 32V64H160V32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192H0V464c0 26.5 21.5 48 48 48H400c26.5 0 48-21.5 48-48V192z"}))},Ut=function(t){De(n,React__default.Component);var r=be(n);function n(e){var t;return he(this,n),(t=r.call(this,e)).el=document.createElement("div"),t}return fe(n,[{key:"componentDidMount",value:function(){this.portalRoot=(this.props.portalHost||document).getElementById(this.props.portalId),this.portalRoot||(this.portalRoot=document.createElement("div"),this.portalRoot.setAttribute("id",this.props.portalId),(this.props.portalHost||document.body).appendChild(this.portalRoot)),this.portalRoot.appendChild(this.el);}},{key:"componentWillUnmount",value:function(){this.portalRoot.removeChild(this.el);}},{key:"render",value:function(){return ReactDOM__default.createPortal(this.props.children,this.el)}}]),n}(),zt=function(e){return !e.disabled&&-1!==e.tabIndex},$t=function(t){De(n,React__default.Component);var r=be(n);function n(t){var o;return he(this,n),ye(we(o=r.call(this,t)),"getTabChildren",(function(){return Array.prototype.slice.call(o.tabLoopRef.current.querySelectorAll("[tabindex], a, button, input, select, textarea"),1,-1).filter(zt)})),ye(we(o),"handleFocusStart",(function(){var e=o.getTabChildren();e&&e.length>1&&e[e.length-1].focus();})),ye(we(o),"handleFocusEnd",(function(){var e=o.getTabChildren();e&&e.length>1&&e[0].focus();})),o.tabLoopRef=React__default.createRef(),o}return fe(n,[{key:"render",value:function(){return this.props.enableTabLoop?React__default.createElement("div",{className:"react-datepicker__tab-loop",ref:this.tabLoopRef},React__default.createElement("div",{className:"react-datepicker__tab-loop__start",tabIndex:"0",onFocus:this.handleFocusStart}),this.props.children,React__default.createElement("div",{className:"react-datepicker__tab-loop__end",tabIndex:"0",onFocus:this.handleFocusEnd})):this.props.children}}],[{key:"defaultProps",get:function(){return {enableTabLoop:!0}}}]),n}(),Gt=function(t){De(o,React__default.Component);var n=be(o);function o(){return he(this,o),n.apply(this,arguments)}return fe(o,[{key:"render",value:function(){var t,n=this.props,o=n.className,a=n.wrapperClassName,s=n.hidePopper,i=n.popperComponent,p=n.popperModifiers,c=n.popperPlacement,l=n.popperProps,d=n.targetComponent,u=n.enableTabLoop,h=n.popperOnKeyDown,m=n.portalId,f=n.portalHost;if(!s){var y=classnames("react-datepicker-popper",o);t=React__default.createElement(Popper,ve({modifiers:p,placement:c},l),(function(t){var r=t.ref,n=t.style,o=t.placement,a=t.arrowProps;return React__default.createElement($t,{enableTabLoop:u},React__default.createElement("div",{ref:r,style:n,className:y,"data-placement":o,onKeyDown:h},React__default.cloneElement(i,{arrowProps:a})))}));}this.props.popperContainer&&(t=React__default.createElement(this.props.popperContainer,{},t)),m&&!s&&(t=React__default.createElement(Ut,{portalId:m,portalHost:f},t));var v=classnames("react-datepicker-wrapper",a);return React__default.createElement(Manager,{className:"react-datepicker-manager"},React__default.createElement(Reference,null,(function(t){var r=t.ref;return React__default.createElement("div",{ref:r,className:v},d)})),t)}}],[{key:"defaultProps",get:function(){return {hidePopper:!0,popperModifiers:[],popperProps:{},popperPlacement:"bottom-start"}}}]),o}(),Jt="react-datepicker-ignore-onclickoutside",Xt=onClickOutsideHOC(Vt);var Zt="Date input not valid.",er=function(t){De(s,React__default.Component);var a=be(s);function s(t){var i;return he(this,s),ye(we(i=a.call(this,t)),"getPreSelection",(function(){return i.props.openToDate?i.props.openToDate:i.props.selectsEnd&&i.props.startDate?i.props.startDate:i.props.selectsStart&&i.props.endDate?i.props.endDate:Ye()})),ye(we(i),"modifyHolidays",(function(){var e;return null===(e=i.props.holidays)||void 0===e?void 0:e.reduce((function(e,t){var r=new Date(t.date);return isValid$1(r)?[].concat(Se(e),[de(de({},t),{},{date:r})]):e}),[])})),ye(we(i),"calcInitialState",(function(){var e,t=i.getPreSelection(),r=ft(i.props),n=yt(i.props),o=r&&isBefore(t,startOfDay(r))?r:n&&isAfter(t,endOfDay(n))?n:t;return {open:i.props.startOpen||!1,preventFocus:!1,preSelection:null!==(e=i.props.selectsRange?i.props.startDate:i.props.selected)&&void 0!==e?e:o,highlightDates:vt(i.props.highlightDates),focused:!1,shouldFocusDayInline:!1,isRenderAriaLiveMessage:!1}})),ye(we(i),"clearPreventFocusTimeout",(function(){i.preventFocusTimeout&&clearTimeout(i.preventFocusTimeout);})),ye(we(i),"setFocus",(function(){i.input&&i.input.focus&&i.input.focus({preventScroll:!0});})),ye(we(i),"setBlur",(function(){i.input&&i.input.blur&&i.input.blur(),i.cancelFocusInput();})),ye(we(i),"setOpen",(function(e){var t=arguments.length>1&&void 0!==arguments[1]&&arguments[1];i.setState({open:e,preSelection:e&&i.state.open?i.state.preSelection:i.calcInitialState().preSelection,lastPreSelectChange:rr},(function(){e||i.setState((function(e){return {focused:!!t&&e.focused}}),(function(){!t&&i.setBlur(),i.setState({inputValue:null});}));}));})),ye(we(i),"inputOk",(function(){return isDate(i.state.preSelection)})),ye(we(i),"isCalendarOpen",(function(){return void 0===i.props.open?i.state.open&&!i.props.disabled&&!i.props.readOnly:i.props.open})),ye(we(i),"handleFocus",(function(e){i.state.preventFocus||(i.props.onFocus(e),i.props.preventOpenOnFocus||i.props.readOnly||i.setOpen(!0)),i.setState({focused:!0});})),ye(we(i),"sendFocusBackToInput",(function(){i.preventFocusTimeout&&i.clearPreventFocusTimeout(),i.setState({preventFocus:!0},(function(){i.preventFocusTimeout=setTimeout((function(){i.setFocus(),i.setState({preventFocus:!1});}));}));})),ye(we(i),"cancelFocusInput",(function(){clearTimeout(i.inputFocusTimeout),i.inputFocusTimeout=null;})),ye(we(i),"deferFocusInput",(function(){i.cancelFocusInput(),i.inputFocusTimeout=setTimeout((function(){return i.setFocus()}),1);})),ye(we(i),"handleDropdownFocus",(function(){i.cancelFocusInput();})),ye(we(i),"handleBlur",(function(e){(!i.state.open||i.props.withPortal||i.props.showTimeInput)&&i.props.onBlur(e),i.setState({focused:!1});})),ye(we(i),"handleCalendarClickOutside",(function(e){i.props.inline||i.setOpen(!1),i.props.onClickOutside(e),i.props.withPortal&&e.preventDefault();})),ye(we(i),"handleChange",(function(){for(var e=arguments.length,t=new Array(e),r=0;r<e;r++)t[r]=arguments[r];var n=t[0];if(!i.props.onChangeRaw||(i.props.onChangeRaw.apply(we(i),t),"function"==typeof n.isDefaultPrevented&&!n.isDefaultPrevented())){i.setState({inputValue:n.target.value,lastPreSelectChange:tr});var o,a,s,p,c,l,d,u,h=(o=n.target.value,a=i.props.dateFormat,s=i.props.locale,p=i.props.strictParsing,c=i.props.minDate,l=null,d=Ge(s)||Ge($e()),u=!0,Array.isArray(a)?(a.forEach((function(e){var t=parse(o,e,new Date,{locale:d});p&&(u=Te(t,c)&&o===Ie(t,e,s)),Te(t,c)&&u&&(l=t);})),l):(l=parse(o,a,new Date,{locale:d}),p?u=Te(l)&&o===Ie(l,a,s):Te(l)||(a=a.match(xe).map((function(e){var t=e[0];return "p"===t||"P"===t?d?(0, Ee[t])(e,d.formatLong):t:e})).join(""),o.length>0&&(l=parse(o,a.slice(0,o.length),new Date)),Te(l)||(l=new Date(o))),Te(l)&&u?l:null));i.props.showTimeSelectOnly&&i.props.selected&&h&&!je(h,i.props.selected)&&(h=set(i.props.selected,{hours:getHours(h),minutes:getMinutes(h),seconds:getSeconds(h)})),!h&&n.target.value||(i.props.showWeekPicker&&(h=Le(h,i.props.locale,i.props.calendarStartDay)),i.setSelected(h,n,!0));}})),ye(we(i),"handleSelect",(function(e,t,r){if(i.props.shouldCloseOnSelect&&!i.props.showTimeSelect&&i.sendFocusBackToInput(),i.props.onChangeRaw&&i.props.onChangeRaw(t),i.props.showWeekPicker&&(e=Le(e,i.props.locale,i.props.calendarStartDay)),i.setSelected(e,t,!1,r),i.props.showDateSelect&&i.setState({isRenderAriaLiveMessage:!0}),!i.props.shouldCloseOnSelect||i.props.showTimeSelect)i.setPreSelection(e);else if(!i.props.inline){i.props.selectsRange||i.setOpen(!1);var n=i.props,o=n.startDate,a=n.endDate;!o||a||isBefore(e,o)||i.setOpen(!1);}})),ye(we(i),"setSelected",(function(e,t,r,n){var o=e;if(i.props.showYearPicker){if(null!==o&&at(getYear(o),i.props))return}else if(i.props.showMonthYearPicker){if(null!==o&&tt(o,i.props))return}else if(null!==o&&Ze(o,i.props))return;var a=i.props,s=a.onChange,p=a.selectsRange,c=a.startDate,l=a.endDate;if(!Ve(i.props.selected,o)||i.props.allowSameDay||p)if(null!==o&&(!i.props.selected||r&&(i.props.showTimeSelect||i.props.showTimeSelectOnly||i.props.showTimeInput)||(o=Re(o,{hour:getHours(i.props.selected),minute:getMinutes(i.props.selected),second:getSeconds(i.props.selected)})),i.props.inline||i.setState({preSelection:o}),i.props.focusSelectedMonth||i.setState({monthSelectedIn:n})),p){var d=c&&!l,u=c&&l;!c&&!l?s([o,null],t):d&&(isBefore(o,c)?s([o,null],t):s([c,o],t)),u&&s([o,null],t);}else s(o,t);r||(i.props.onSelect(o,t),i.setState({inputValue:null}));})),ye(we(i),"setPreSelection",(function(e){var t=void 0!==i.props.minDate,r=void 0!==i.props.maxDate,n=!0;if(e){i.props.showWeekPicker&&(e=Le(e,i.props.locale,i.props.calendarStartDay));var o=startOfDay(e);if(t&&r)n=qe(e,i.props.minDate,i.props.maxDate);else if(t){var a=startOfDay(i.props.minDate);n=isAfter(e,a)||Ve(o,a);}else if(r){var s=endOfDay(i.props.maxDate);n=isBefore(e,s)||Ve(o,s);}}n&&i.setState({preSelection:e});})),ye(we(i),"toggleCalendar",(function(){i.setOpen(!i.state.open);})),ye(we(i),"handleTimeChange",(function(e){var t=i.props.selected?i.props.selected:i.getPreSelection(),r=i.props.selected?e:Re(t,{hour:getHours(e),minute:getMinutes(e)});i.setState({preSelection:r}),i.props.onChange(r),i.props.shouldCloseOnSelect&&(i.sendFocusBackToInput(),i.setOpen(!1)),i.props.showTimeInput&&i.setOpen(!0),(i.props.showTimeSelectOnly||i.props.showTimeSelect)&&i.setState({isRenderAriaLiveMessage:!0}),i.setState({inputValue:null});})),ye(we(i),"onInputClick",(function(){i.props.disabled||i.props.readOnly||i.setOpen(!0),i.props.onInputClick();})),ye(we(i),"onInputKeyDown",(function(e){i.props.onKeyDown(e);var t=e.key;if(i.state.open||i.props.inline||i.props.preventOpenOnFocus){if(i.state.open){if("ArrowDown"===t||"ArrowUp"===t){e.preventDefault();var r=i.props.showWeekPicker&&i.props.showWeekNumbers?'.react-datepicker__week-number[tabindex="0"]':'.react-datepicker__day[tabindex="0"]',n=i.calendar.componentNode&&i.calendar.componentNode.querySelector(r);return void(n&&n.focus({preventScroll:!0}))}var o=Ye(i.state.preSelection);"Enter"===t?(e.preventDefault(),i.inputOk()&&i.state.lastPreSelectChange===rr?(i.handleSelect(o,e),!i.props.shouldCloseOnSelect&&i.setPreSelection(o)):i.setOpen(!1)):"Escape"===t?(e.preventDefault(),i.sendFocusBackToInput(),i.setOpen(!1)):"Tab"===t&&i.setOpen(!1),i.inputOk()||i.props.onInputError({code:1,msg:Zt});}}else "ArrowDown"!==t&&"ArrowUp"!==t&&"Enter"!==t||i.onInputClick();})),ye(we(i),"onPortalKeyDown",(function(e){"Escape"===e.key&&(e.preventDefault(),i.setState({preventFocus:!0},(function(){i.setOpen(!1),setTimeout((function(){i.setFocus(),i.setState({preventFocus:!1});}));})));})),ye(we(i),"onDayKeyDown",(function(e){i.props.onKeyDown(e);var t=e.key,r=Ye(i.state.preSelection);if("Enter"===t)e.preventDefault(),i.handleSelect(r,e),!i.props.shouldCloseOnSelect&&i.setPreSelection(r);else if("Escape"===t)e.preventDefault(),i.setOpen(!1),i.inputOk()||i.props.onInputError({code:1,msg:Zt});else if(!i.props.disabledKeyboardNavigation){var n;switch(t){case"ArrowLeft":n=i.props.showWeekPicker?subWeeks(r,1):subDays(r,1);break;case"ArrowRight":n=i.props.showWeekPicker?addWeeks(r,1):addDays(r,1);break;case"ArrowUp":n=subWeeks(r,1);break;case"ArrowDown":n=addWeeks(r,1);break;case"PageUp":n=subMonths(r,1);break;case"PageDown":n=addMonths(r,1);break;case"Home":n=subYears(r,1);break;case"End":n=addYears(r,1);break;default:n=null;}if(!n)return void(i.props.onInputError&&i.props.onInputError({code:1,msg:Zt}));if(e.preventDefault(),i.setState({lastPreSelectChange:rr}),i.props.adjustDateOnChange&&i.setSelected(n),i.setPreSelection(n),i.props.inline){var o=getMonth(r),a=getMonth(n),s=getYear(r),d=getYear(n);o!==a||s!==d?i.setState({shouldFocusDayInline:!0}):i.setState({shouldFocusDayInline:!1});}}})),ye(we(i),"onPopperKeyDown",(function(e){"Escape"===e.key&&(e.preventDefault(),i.sendFocusBackToInput());})),ye(we(i),"onClearClick",(function(e){e&&e.preventDefault&&e.preventDefault(),i.sendFocusBackToInput(),i.props.selectsRange?i.props.onChange([null,null],e):i.props.onChange(null,e),i.setState({inputValue:null});})),ye(we(i),"clear",(function(){i.onClearClick();})),ye(we(i),"onScroll",(function(e){"boolean"==typeof i.props.closeOnScroll&&i.props.closeOnScroll?e.target!==document&&e.target!==document.documentElement&&e.target!==document.body||i.setOpen(!1):"function"==typeof i.props.closeOnScroll&&i.props.closeOnScroll(e)&&i.setOpen(!1);})),ye(we(i),"renderCalendar",(function(){return i.props.inline||i.isCalendarOpen()?React__default.createElement(Xt,{ref:function(e){i.calendar=e;},locale:i.props.locale,calendarStartDay:i.props.calendarStartDay,chooseDayAriaLabelPrefix:i.props.chooseDayAriaLabelPrefix,disabledDayAriaLabelPrefix:i.props.disabledDayAriaLabelPrefix,weekAriaLabelPrefix:i.props.weekAriaLabelPrefix,monthAriaLabelPrefix:i.props.monthAriaLabelPrefix,adjustDateOnChange:i.props.adjustDateOnChange,setOpen:i.setOpen,shouldCloseOnSelect:i.props.shouldCloseOnSelect,dateFormat:i.props.dateFormatCalendar,useWeekdaysShort:i.props.useWeekdaysShort,formatWeekDay:i.props.formatWeekDay,dropdownMode:i.props.dropdownMode,selected:i.props.selected,preSelection:i.state.preSelection,onSelect:i.handleSelect,onWeekSelect:i.props.onWeekSelect,openToDate:i.props.openToDate,minDate:i.props.minDate,maxDate:i.props.maxDate,selectsStart:i.props.selectsStart,selectsEnd:i.props.selectsEnd,selectsRange:i.props.selectsRange,startDate:i.props.startDate,endDate:i.props.endDate,excludeDates:i.props.excludeDates,excludeDateIntervals:i.props.excludeDateIntervals,filterDate:i.props.filterDate,onClickOutside:i.handleCalendarClickOutside,formatWeekNumber:i.props.formatWeekNumber,highlightDates:i.state.highlightDates,holidays:Dt(i.modifyHolidays()),includeDates:i.props.includeDates,includeDateIntervals:i.props.includeDateIntervals,includeTimes:i.props.includeTimes,injectTimes:i.props.injectTimes,inline:i.props.inline,shouldFocusDayInline:i.state.shouldFocusDayInline,peekNextMonth:i.props.peekNextMonth,showMonthDropdown:i.props.showMonthDropdown,showPreviousMonths:i.props.showPreviousMonths,useShortMonthInDropdown:i.props.useShortMonthInDropdown,showMonthYearDropdown:i.props.showMonthYearDropdown,showWeekNumbers:i.props.showWeekNumbers,showYearDropdown:i.props.showYearDropdown,withPortal:i.props.withPortal,forceShowMonthNavigation:i.props.forceShowMonthNavigation,showDisabledMonthNavigation:i.props.showDisabledMonthNavigation,scrollableYearDropdown:i.props.scrollableYearDropdown,scrollableMonthYearDropdown:i.props.scrollableMonthYearDropdown,todayButton:i.props.todayButton,weekLabel:i.props.weekLabel,outsideClickIgnoreClass:Jt,fixedHeight:i.props.fixedHeight,monthsShown:i.props.monthsShown,monthSelectedIn:i.state.monthSelectedIn,onDropdownFocus:i.handleDropdownFocus,onMonthChange:i.props.onMonthChange,onYearChange:i.props.onYearChange,dayClassName:i.props.dayClassName,weekDayClassName:i.props.weekDayClassName,monthClassName:i.props.monthClassName,timeClassName:i.props.timeClassName,showDateSelect:i.props.showDateSelect,showTimeSelect:i.props.showTimeSelect,showTimeSelectOnly:i.props.showTimeSelectOnly,onTimeChange:i.handleTimeChange,timeFormat:i.props.timeFormat,timeIntervals:i.props.timeIntervals,minTime:i.props.minTime,maxTime:i.props.maxTime,excludeTimes:i.props.excludeTimes,filterTime:i.props.filterTime,timeCaption:i.props.timeCaption,className:i.props.calendarClassName,container:i.props.calendarContainer,yearItemNumber:i.props.yearItemNumber,yearDropdownItemNumber:i.props.yearDropdownItemNumber,previousMonthAriaLabel:i.props.previousMonthAriaLabel,previousMonthButtonLabel:i.props.previousMonthButtonLabel,nextMonthAriaLabel:i.props.nextMonthAriaLabel,nextMonthButtonLabel:i.props.nextMonthButtonLabel,previousYearAriaLabel:i.props.previousYearAriaLabel,previousYearButtonLabel:i.props.previousYearButtonLabel,nextYearAriaLabel:i.props.nextYearAriaLabel,nextYearButtonLabel:i.props.nextYearButtonLabel,timeInputLabel:i.props.timeInputLabel,disabledKeyboardNavigation:i.props.disabledKeyboardNavigation,renderCustomHeader:i.props.renderCustomHeader,popperProps:i.props.popperProps,renderDayContents:i.props.renderDayContents,renderMonthContent:i.props.renderMonthContent,renderQuarterContent:i.props.renderQuarterContent,renderYearContent:i.props.renderYearContent,onDayMouseEnter:i.props.onDayMouseEnter,onMonthMouseLeave:i.props.onMonthMouseLeave,onYearMouseEnter:i.props.onYearMouseEnter,onYearMouseLeave:i.props.onYearMouseLeave,selectsDisabledDaysInRange:i.props.selectsDisabledDaysInRange,showTimeInput:i.props.showTimeInput,showMonthYearPicker:i.props.showMonthYearPicker,showFullMonthYearPicker:i.props.showFullMonthYearPicker,showTwoColumnMonthYearPicker:i.props.showTwoColumnMonthYearPicker,showFourColumnMonthYearPicker:i.props.showFourColumnMonthYearPicker,showYearPicker:i.props.showYearPicker,showQuarterYearPicker:i.props.showQuarterYearPicker,showWeekPicker:i.props.showWeekPicker,showPopperArrow:i.props.showPopperArrow,excludeScrollbar:i.props.excludeScrollbar,handleOnKeyDown:i.props.onKeyDown,handleOnDayKeyDown:i.onDayKeyDown,isInputFocused:i.state.focused,customTimeInput:i.props.customTimeInput,setPreSelection:i.setPreSelection},i.props.children):null})),ye(we(i),"renderAriaLiveRegion",(function(){var t,r=i.props,n=r.dateFormat,o=r.locale,a=i.props.showTimeInput||i.props.showTimeSelect?"PPPPp":"PPPP";return t=i.props.selectsRange?"Selected start date: ".concat(Oe(i.props.startDate,{dateFormat:a,locale:o}),". ").concat(i.props.endDate?"End date: "+Oe(i.props.endDate,{dateFormat:a,locale:o}):""):i.props.showTimeSelectOnly?"Selected time: ".concat(Oe(i.props.selected,{dateFormat:n,locale:o})):i.props.showYearPicker?"Selected year: ".concat(Oe(i.props.selected,{dateFormat:"yyyy",locale:o})):i.props.showMonthYearPicker?"Selected month: ".concat(Oe(i.props.selected,{dateFormat:"MMMM yyyy",locale:o})):i.props.showQuarterYearPicker?"Selected quarter: ".concat(Oe(i.props.selected,{dateFormat:"yyyy, QQQ",locale:o})):"Selected date: ".concat(Oe(i.props.selected,{dateFormat:a,locale:o})),React__default.createElement("span",{role:"alert","aria-live":"polite",className:"react-datepicker__aria-live"},t)})),ye(we(i),"renderDateInput",(function(){var t,n=classnames(i.props.className,ye({},Jt,i.state.open)),o=i.props.customInput||React__default.createElement("input",{type:"text"}),a=i.props.customInputRef||"ref",s="string"==typeof i.props.value?i.props.value:"string"==typeof i.state.inputValue?i.state.inputValue:i.props.selectsRange?function(e,t,r){if(!e)return "";var n=Oe(e,r),o=t?Oe(t,r):"";return "".concat(n," - ").concat(o)}(i.props.startDate,i.props.endDate,i.props):Oe(i.props.selected,i.props);return React__default.cloneElement(o,(ye(ye(ye(ye(ye(ye(ye(ye(ye(ye(t={},a,(function(e){i.input=e;})),"value",s),"onBlur",i.handleBlur),"onChange",i.handleChange),"onClick",i.onInputClick),"onFocus",i.handleFocus),"onKeyDown",i.onInputKeyDown),"id",i.props.id),"name",i.props.name),"form",i.props.form),ye(ye(ye(ye(ye(ye(ye(ye(ye(ye(t,"autoFocus",i.props.autoFocus),"placeholder",i.props.placeholderText),"disabled",i.props.disabled),"autoComplete",i.props.autoComplete),"className",classnames(o.props.className,n)),"title",i.props.title),"readOnly",i.props.readOnly),"required",i.props.required),"tabIndex",i.props.tabIndex),"aria-describedby",i.props.ariaDescribedBy),ye(ye(ye(t,"aria-invalid",i.props.ariaInvalid),"aria-labelledby",i.props.ariaLabelledBy),"aria-required",i.props.ariaRequired)))})),ye(we(i),"renderClearButton",(function(){var t=i.props,n=t.isClearable,o=t.disabled,a=t.selected,s=t.startDate,p=t.endDate,c=t.clearButtonTitle,l=t.clearButtonClassName,d=void 0===l?"":l,u=t.ariaLabelClose,h=void 0===u?"Close":u;return !n||null==a&&null==s&&null==p?null:React__default.createElement("button",{type:"button",className:classnames("react-datepicker__close-icon",d,{"react-datepicker__close-icon--disabled":o}),disabled:o,"aria-label":h,onClick:i.onClearClick,title:c,tabIndex:-1})})),i.state=i.calcInitialState(),i.preventFocusTimeout=null,i}return fe(s,[{key:"componentDidMount",value:function(){window.addEventListener("scroll",this.onScroll,!0);}},{key:"componentDidUpdate",value:function(e,t){var r,n;e.inline&&(r=e.selected,n=this.props.selected,r&&n?getMonth(r)!==getMonth(n)||getYear(r)!==getYear(n):r!==n)&&this.setPreSelection(this.props.selected),void 0!==this.state.monthSelectedIn&&e.monthsShown!==this.props.monthsShown&&this.setState({monthSelectedIn:0}),e.highlightDates!==this.props.highlightDates&&this.setState({highlightDates:vt(this.props.highlightDates)}),t.focused||Ve(e.selected,this.props.selected)||this.setState({inputValue:null}),t.open!==this.state.open&&(!1===t.open&&!0===this.state.open&&this.props.onCalendarOpen(),!0===t.open&&!1===this.state.open&&this.props.onCalendarClose());}},{key:"componentWillUnmount",value:function(){this.clearPreventFocusTimeout(),window.removeEventListener("scroll",this.onScroll,!0);}},{key:"renderInputContainer",value:function(){var t=this.props,r=t.showIcon,n=t.icon,o=t.calendarIconClassname,a=t.toggleCalendarOnIconClick,s=this.state.open;return React__default.createElement("div",{className:"react-datepicker__input-container".concat(r?" react-datepicker__view-calendar-icon":"")},r&&React__default.createElement(qt,ve({icon:n,className:"".concat(o," ").concat(s&&"react-datepicker-ignore-onclickoutside")},a?{onClick:this.toggleCalendar}:null)),this.state.isRenderAriaLiveMessage&&this.renderAriaLiveRegion(),this.renderDateInput(),this.renderClearButton())}},{key:"render",value:function(){var t=this.renderCalendar();if(this.props.inline)return t;if(this.props.withPortal){var r=this.state.open?React__default.createElement($t,{enableTabLoop:this.props.enableTabLoop},React__default.createElement("div",{className:"react-datepicker__portal",tabIndex:-1,onKeyDown:this.onPortalKeyDown},t)):null;return this.state.open&&this.props.portalId&&(r=React__default.createElement(Ut,{portalId:this.props.portalId,portalHost:this.props.portalHost},r)),React__default.createElement("div",null,this.renderInputContainer(),r)}return React__default.createElement(Gt,{className:this.props.popperClassName,wrapperClassName:this.props.wrapperClassName,hidePopper:!this.isCalendarOpen(),portalId:this.props.portalId,portalHost:this.props.portalHost,popperModifiers:this.props.popperModifiers,targetComponent:this.renderInputContainer(),popperContainer:this.props.popperContainer,popperComponent:t,popperPlacement:this.props.popperPlacement,popperProps:this.props.popperProps,popperOnKeyDown:this.onPopperKeyDown,enableTabLoop:this.props.enableTabLoop})}}],[{key:"defaultProps",get:function(){return {allowSameDay:!1,dateFormat:"MM/dd/yyyy",dateFormatCalendar:"LLLL yyyy",onChange:function(){},disabled:!1,disabledKeyboardNavigation:!1,dropdownMode:"scroll",onFocus:function(){},onBlur:function(){},onKeyDown:function(){},onInputClick:function(){},onSelect:function(){},onClickOutside:function(){},onMonthChange:function(){},onCalendarOpen:function(){},onCalendarClose:function(){},preventOpenOnFocus:!1,onYearChange:function(){},onInputError:function(){},monthsShown:1,readOnly:!1,withPortal:!1,selectsDisabledDaysInRange:!1,shouldCloseOnSelect:!0,showTimeSelect:!1,showTimeInput:!1,showPreviousMonths:!1,showMonthYearPicker:!1,showFullMonthYearPicker:!1,showTwoColumnMonthYearPicker:!1,showFourColumnMonthYearPicker:!1,showYearPicker:!1,showQuarterYearPicker:!1,showWeekPicker:!1,strictParsing:!1,timeIntervals:30,timeCaption:"Time",previousMonthAriaLabel:"Previous Month",previousMonthButtonLabel:"Previous Month",nextMonthAriaLabel:"Next Month",nextMonthButtonLabel:"Next Month",previousYearAriaLabel:"Previous Year",previousYearButtonLabel:"Previous Year",nextYearAriaLabel:"Next Year",nextYearButtonLabel:"Next Year",timeInputLabel:"Time",enableTabLoop:!0,yearItemNumber:Ne,focusSelectedMonth:!1,showPopperArrow:!0,excludeScrollbar:!0,customTimeInput:null,calendarStartDay:void 0,toggleCalendarOnIconClick:!1}}}]),s}(),tr="input",rr="navigate";

var formatDistanceLocale = {
  lessThanXSeconds: {
    one: 'menos de um segundo',
    other: 'menos de {{count}} segundos'
  },
  xSeconds: {
    one: '1 segundo',
    other: '{{count}} segundos'
  },
  halfAMinute: 'meio minuto',
  lessThanXMinutes: {
    one: 'menos de um minuto',
    other: 'menos de {{count}} minutos'
  },
  xMinutes: {
    one: '1 minuto',
    other: '{{count}} minutos'
  },
  aboutXHours: {
    one: 'cerca de 1 hora',
    other: 'cerca de {{count}} horas'
  },
  xHours: {
    one: '1 hora',
    other: '{{count}} horas'
  },
  xDays: {
    one: '1 dia',
    other: '{{count}} dias'
  },
  aboutXWeeks: {
    one: 'cerca de 1 semana',
    other: 'cerca de {{count}} semanas'
  },
  xWeeks: {
    one: '1 semana',
    other: '{{count}} semanas'
  },
  aboutXMonths: {
    one: 'cerca de 1 mês',
    other: 'cerca de {{count}} meses'
  },
  xMonths: {
    one: '1 mês',
    other: '{{count}} meses'
  },
  aboutXYears: {
    one: 'cerca de 1 ano',
    other: 'cerca de {{count}} anos'
  },
  xYears: {
    one: '1 ano',
    other: '{{count}} anos'
  },
  overXYears: {
    one: 'mais de 1 ano',
    other: 'mais de {{count}} anos'
  },
  almostXYears: {
    one: 'quase 1 ano',
    other: 'quase {{count}} anos'
  }
};
var formatDistance = function formatDistance(token, count, options) {
  var result;
  var tokenValue = formatDistanceLocale[token];
  if (typeof tokenValue === 'string') {
    result = tokenValue;
  } else if (count === 1) {
    result = tokenValue.one;
  } else {
    result = tokenValue.other.replace('{{count}}', String(count));
  }
  if (options !== null && options !== void 0 && options.addSuffix) {
    if (options.comparison && options.comparison > 0) {
      return 'em ' + result;
    } else {
      return 'há ' + result;
    }
  }
  return result;
};
var formatDistance$1 = formatDistance;

var dateFormats = {
  full: "EEEE, d 'de' MMMM 'de' y",
  long: "d 'de' MMMM 'de' y",
  medium: 'd MMM y',
  short: 'dd/MM/yyyy'
};
var timeFormats = {
  full: 'HH:mm:ss zzzz',
  long: 'HH:mm:ss z',
  medium: 'HH:mm:ss',
  short: 'HH:mm'
};
var dateTimeFormats = {
  full: "{{date}} 'às' {{time}}",
  long: "{{date}} 'às' {{time}}",
  medium: '{{date}}, {{time}}',
  short: '{{date}}, {{time}}'
};
var formatLong = {
  date: buildFormatLongFn({
    formats: dateFormats,
    defaultWidth: 'full'
  }),
  time: buildFormatLongFn({
    formats: timeFormats,
    defaultWidth: 'full'
  }),
  dateTime: buildFormatLongFn({
    formats: dateTimeFormats,
    defaultWidth: 'full'
  })
};
var formatLong$1 = formatLong;

var formatRelativeLocale = {
  lastWeek: function lastWeek(date) {
    var weekday = date.getUTCDay();
    var last = weekday === 0 || weekday === 6 ? 'último' : 'última';
    return "'" + last + "' eeee 'às' p";
  },
  yesterday: "'ontem às' p",
  today: "'hoje às' p",
  tomorrow: "'amanhã às' p",
  nextWeek: "eeee 'às' p",
  other: 'P'
};
var formatRelative = function formatRelative(token, date, _baseDate, _options) {
  var format = formatRelativeLocale[token];
  if (typeof format === 'function') {
    return format(date);
  }
  return format;
};
var formatRelative$1 = formatRelative;

var eraValues = {
  narrow: ['AC', 'DC'],
  abbreviated: ['AC', 'DC'],
  wide: ['antes de cristo', 'depois de cristo']
};
var quarterValues = {
  narrow: ['1', '2', '3', '4'],
  abbreviated: ['T1', 'T2', 'T3', 'T4'],
  wide: ['1º trimestre', '2º trimestre', '3º trimestre', '4º trimestre']
};
var monthValues = {
  narrow: ['j', 'f', 'm', 'a', 'm', 'j', 'j', 'a', 's', 'o', 'n', 'd'],
  abbreviated: ['jan', 'fev', 'mar', 'abr', 'mai', 'jun', 'jul', 'ago', 'set', 'out', 'nov', 'dez'],
  wide: ['janeiro', 'fevereiro', 'março', 'abril', 'maio', 'junho', 'julho', 'agosto', 'setembro', 'outubro', 'novembro', 'dezembro']
};
var dayValues = {
  narrow: ['D', 'S', 'T', 'Q', 'Q', 'S', 'S'],
  short: ['dom', 'seg', 'ter', 'qua', 'qui', 'sex', 'sab'],
  abbreviated: ['domingo', 'segunda', 'terça', 'quarta', 'quinta', 'sexta', 'sábado'],
  wide: ['domingo', 'segunda-feira', 'terça-feira', 'quarta-feira', 'quinta-feira', 'sexta-feira', 'sábado']
};
var dayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mn',
    noon: 'md',
    morning: 'manhã',
    afternoon: 'tarde',
    evening: 'tarde',
    night: 'noite'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'manhã',
    afternoon: 'tarde',
    evening: 'tarde',
    night: 'noite'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'manhã',
    afternoon: 'tarde',
    evening: 'tarde',
    night: 'noite'
  }
};
var formattingDayPeriodValues = {
  narrow: {
    am: 'a',
    pm: 'p',
    midnight: 'mn',
    noon: 'md',
    morning: 'da manhã',
    afternoon: 'da tarde',
    evening: 'da tarde',
    night: 'da noite'
  },
  abbreviated: {
    am: 'AM',
    pm: 'PM',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'da manhã',
    afternoon: 'da tarde',
    evening: 'da tarde',
    night: 'da noite'
  },
  wide: {
    am: 'a.m.',
    pm: 'p.m.',
    midnight: 'meia-noite',
    noon: 'meio-dia',
    morning: 'da manhã',
    afternoon: 'da tarde',
    evening: 'da tarde',
    night: 'da noite'
  }
};
var ordinalNumber = function ordinalNumber(dirtyNumber, options) {
  var number = Number(dirtyNumber);
  if ((options === null || options === void 0 ? void 0 : options.unit) === 'week') {
    return number + 'ª';
  }
  return number + 'º';
};
var localize = {
  ordinalNumber: ordinalNumber,
  era: buildLocalizeFn({
    values: eraValues,
    defaultWidth: 'wide'
  }),
  quarter: buildLocalizeFn({
    values: quarterValues,
    defaultWidth: 'wide',
    argumentCallback: function argumentCallback(quarter) {
      return quarter - 1;
    }
  }),
  month: buildLocalizeFn({
    values: monthValues,
    defaultWidth: 'wide'
  }),
  day: buildLocalizeFn({
    values: dayValues,
    defaultWidth: 'wide'
  }),
  dayPeriod: buildLocalizeFn({
    values: dayPeriodValues,
    defaultWidth: 'wide',
    formattingValues: formattingDayPeriodValues,
    defaultFormattingWidth: 'wide'
  })
};
var localize$1 = localize;

var matchOrdinalNumberPattern = /^(\d+)[ºªo]?/i;
var parseOrdinalNumberPattern = /\d+/i;
var matchEraPatterns = {
  narrow: /^(ac|dc|a|d)/i,
  abbreviated: /^(a\.?\s?c\.?|d\.?\s?c\.?)/i,
  wide: /^(antes de cristo|depois de cristo)/i
};
var parseEraPatterns = {
  any: [/^ac/i, /^dc/i],
  wide: [/^antes de cristo/i, /^depois de cristo/i]
};
var matchQuarterPatterns = {
  narrow: /^[1234]/i,
  abbreviated: /^T[1234]/i,
  wide: /^[1234](º)? trimestre/i
};
var parseQuarterPatterns = {
  any: [/1/i, /2/i, /3/i, /4/i]
};
var matchMonthPatterns = {
  narrow: /^[jfmajsond]/i,
  abbreviated: /^(jan|fev|mar|abr|mai|jun|jul|ago|set|out|nov|dez)/i,
  wide: /^(janeiro|fevereiro|março|abril|maio|junho|julho|agosto|setembro|outubro|novembro|dezembro)/i
};
var parseMonthPatterns = {
  narrow: [/^j/i, /^f/i, /^m/i, /^a/i, /^m/i, /^j/i, /^j/i, /^a/i, /^s/i, /^o/i, /^n/i, /^d/i],
  any: [/^ja/i, /^fev/i, /^mar/i, /^abr/i, /^mai/i, /^jun/i, /^jul/i, /^ago/i, /^set/i, /^out/i, /^nov/i, /^dez/i]
};
var matchDayPatterns = {
  narrow: /^(dom|[23456]ª?|s[aá]b)/i,
  short: /^(dom|[23456]ª?|s[aá]b)/i,
  abbreviated: /^(dom|seg|ter|qua|qui|sex|s[aá]b)/i,
  wide: /^(domingo|(segunda|ter[cç]a|quarta|quinta|sexta)([- ]feira)?|s[aá]bado)/i
};
var parseDayPatterns = {
  short: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  narrow: [/^d/i, /^2/i, /^3/i, /^4/i, /^5/i, /^6/i, /^s[aá]/i],
  any: [/^d/i, /^seg/i, /^t/i, /^qua/i, /^qui/i, /^sex/i, /^s[aá]b/i]
};
var matchDayPeriodPatterns = {
  narrow: /^(a|p|mn|md|(da) (manhã|tarde|noite))/i,
  any: /^([ap]\.?\s?m\.?|meia[-\s]noite|meio[-\s]dia|(da) (manhã|tarde|noite))/i
};
var parseDayPeriodPatterns = {
  any: {
    am: /^a/i,
    pm: /^p/i,
    midnight: /^mn|^meia[-\s]noite/i,
    noon: /^md|^meio[-\s]dia/i,
    morning: /manhã/i,
    afternoon: /tarde/i,
    evening: /tarde/i,
    night: /noite/i
  }
};
var match = {
  ordinalNumber: buildMatchPatternFn({
    matchPattern: matchOrdinalNumberPattern,
    parsePattern: parseOrdinalNumberPattern,
    valueCallback: function valueCallback(value) {
      return parseInt(value, 10);
    }
  }),
  era: buildMatchFn({
    matchPatterns: matchEraPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseEraPatterns,
    defaultParseWidth: 'any'
  }),
  quarter: buildMatchFn({
    matchPatterns: matchQuarterPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseQuarterPatterns,
    defaultParseWidth: 'any',
    valueCallback: function valueCallback(index) {
      return index + 1;
    }
  }),
  month: buildMatchFn({
    matchPatterns: matchMonthPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseMonthPatterns,
    defaultParseWidth: 'any'
  }),
  day: buildMatchFn({
    matchPatterns: matchDayPatterns,
    defaultMatchWidth: 'wide',
    parsePatterns: parseDayPatterns,
    defaultParseWidth: 'any'
  }),
  dayPeriod: buildMatchFn({
    matchPatterns: matchDayPeriodPatterns,
    defaultMatchWidth: 'any',
    parsePatterns: parseDayPeriodPatterns,
    defaultParseWidth: 'any'
  })
};
var match$1 = match;

/**
 * @type {Locale}
 * @category Locales
 * @summary Portuguese locale (Brazil).
 * @language Portuguese
 * @iso-639-2 por
 * @author Lucas Duailibe [@duailibe]{@link https://github.com/duailibe}
 * @author Yago Carballo [@yagocarballo]{@link https://github.com/YagoCarballo}
 */
var locale = {
  code: 'pt-BR',
  formatDistance: formatDistance$1,
  formatLong: formatLong$1,
  formatRelative: formatRelative$1,
  localize: localize$1,
  match: match$1,
  options: {
    weekStartsOn: 0 /* Sunday */,
    firstWeekContainsDate: 1
  }
};
var ptBR = locale;

var CalendarHeader = styled.div(templateObject_1$p || (templateObject_1$p = __makeTemplateObject(["\n  min-width: 140px;\n  margin: ", "px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  .flip-left {\n    transform: scaleX(-1);\n  }\n"], ["\n  min-width: 140px;\n  margin: ", "px;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n\n  .flip-left {\n    transform: scaleX(-1);\n  }\n"])), function (props) { return props.theme.global.gutterSpace / 2; });
var ChangingLabel = keyframes(templateObject_2$m || (templateObject_2$m = __makeTemplateObject(["\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n"], ["\n  from {\n    opacity: 0;\n    transform: translateY(20px);\n  }\n  to {\n    opacity: 1;\n    transform: translateY(0);\n  }\n"])));
var MesAno = styled.span(templateObject_3$m || (templateObject_3$m = __makeTemplateObject(["\n  font-size: ", ";\n  font-weight: 600;\n  text-transform: capitalize;\n  color: ", ";\n  animation: ", " 200ms ease-out forwards;\n"], ["\n  font-size: ", ";\n  font-weight: 600;\n  text-transform: capitalize;\n  color: ", ";\n  animation: ", " 200ms ease-out forwards;\n"])), function (props) { return props.theme.fontSizes[3]; }, function (props) { return props.theme.colors.grey900; }, ChangingLabel);
var Button = styled.button(templateObject_4$k || (templateObject_4$k = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: none;\n  border: 1px solid ", ";\n  border-radius: 4px;\n  padding: ", "px ", "px;\n  &:hover {\n    border: 1px solid ", ";\n  }\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  background: none;\n  border: 1px solid ", ";\n  border-radius: 4px;\n  padding: ", "px ", "px;\n  &:hover {\n    border: 1px solid ", ";\n  }\n"])), function (props) { return props.theme.colors.grey100; }, function (props) { return props.theme.global.gutterSpace / 2; }, function (props) { return props.theme.global.gutterSpace; }, function (props) { return props.theme.colors.grey400; });
var CleanDatePicker = styled.div(templateObject_5$h || (templateObject_5$h = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: ", "px;\n  border-radius: 50%;\n  background: ", ";\n  cursor: pointer;\n  transition: transform ease-in-out 0.2s;\n\n  &:hover {\n    transform: scale(1.2);\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: ", "px;\n  border-radius: 50%;\n  background: ", ";\n  cursor: pointer;\n  transition: transform ease-in-out 0.2s;\n\n  &:hover {\n    transform: scale(1.2);\n  }\n"])), function (props) { return props.theme.global.gutterSpace * 0.125; }, function (props) { return props.theme.colors.grey200; });
var templateObject_1$p, templateObject_2$m, templateObject_3$m, templateObject_4$k, templateObject_5$h;

var Calender = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path  d=\"M19,4H17V3a1,1,0,0,0-2,0V4H9V3A1,1,0,0,0,7,3V4H5A3,3,0,0,0,2,7V19a3,3,0,0,0,3,3H19a3,3,0,0,0,3-3V7A3,3,0,0,0,19,4Zm1,15a1,1,0,0,1-1,1H5a1,1,0,0,1-1-1V12H20Zm0-9H4V7A1,1,0,0,1,5,6H7V7A1,1,0,0,0,9,7V6h6V7a1,1,0,0,0,2,0V6h2a1,1,0,0,1,1,1Z\"/></svg>";

function isValid(date, minDate) {
    var resolveMinDate = minDate || new Date('1/1/1000');
    return isValid$1(date) && isAfter(date, resolveMinDate);
}
function newDate(value) {
    // eslint-disable-next-line no-nested-ternary
    var d = value ? (typeof value === 'string' || value instanceof String ? parseISO(value) : toDate(value)) : new Date();
    return isValid(d) ? d : null;
}
function isOutOfBounds(day, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.minDate, minDate = _c === void 0 ? null : _c, _d = _b.maxDate, maxDate = _d === void 0 ? null : _d;
    return (minDate && differenceInCalendarDays(day, minDate) < 0) || (maxDate && differenceInCalendarDays(day, maxDate) > 0);
}
var isDayDisabled = function (day, _a) {
    var _b = _a === void 0 ? {} : _a, _c = _b.minDate, minDate = _c === void 0 ? null : _c, _d = _b.maxDate, maxDate = _d === void 0 ? null : _d, _e = _b.filterDate, filterDate = _e === void 0 ? null : _e;
    return isOutOfBounds(day, { minDate: minDate, maxDate: maxDate }) || (filterDate && !filterDate(newDate(day))) || false;
};

var DatePickerCleanInput = function (props) {
    return (React__default.createElement(CleanDatePicker, __assign$2({ "data-testid": "clean-input" }, props),
        React__default.createElement(SvgIcon, { src: IconClose$1, fill: "grey700", width: 16, height: 16 })));
};

Ue('pt-BR', ptBR);
var Datepicker = function (props, ref) {
    var label = props.label, name = props.name, monthPicker = props.monthPicker, className = props.className, testId = props.testId, onChange = props.onChange, value = props.value, error = props.error, minDate = props.minDate, maxDate = props.maxDate, disabled = props.disabled, id = props.id, portalId = props.portalId, readOnly = props.readOnly, filterDate = props.filterDate, handleCleanDate = props.handleCleanDate, endIcon = props.endIcon, openToDate = props.openToDate, otherProps = __rest(props, ["label", "name", "monthPicker", "className", "testId", "onChange", "value", "error", "minDate", "maxDate", "disabled", "id", "portalId", "readOnly", "filterDate", "handleCleanDate", "endIcon", "openToDate"]);
    var _a = useState(null), selectedDate = _a[0], setSelectedDate = _a[1];
    useEffect(function () {
        setSelectedDate(value);
    }, [value]);
    var chars = function (string) {
        var parseDigits = (string.match(/\d+/g) || []).join('');
        return parseDigits.split('');
    };
    var _b = monthPicker
        ? {
            datepickerFormat: 'MM/yyyy',
            inputFormat: function (string) {
                return chars(string)
                    .reduce(function (r, v, index) { return (index === 2 || index === 6 ? r + "/" + v : "" + r + v); }, '')
                    .substr(0, 8);
            },
            placeholderFormat: 'mm/aaaa',
        }
        : {
            datepickerFormat: 'dd/MM/yyyy',
            inputFormat: function (string) {
                return chars(string)
                    .reduce(function (r, v, index) { return (index === 2 || index === 4 ? r + "/" + v : "" + r + v); }, '')
                    .substr(0, 10);
            },
            placeholderFormat: 'dd/mm/aaaa',
        }, datepickerFormat = _b.datepickerFormat, inputFormat = _b.inputFormat, placeholderFormat = _b.placeholderFormat;
    var changeDate = function (date) {
        var response = { target: { name: name, value: date } };
        setSelectedDate(date);
        if (onChange) {
            onChange(response);
        }
    };
    var handleBlur = function (e) {
        var response = { target: { name: name, value: '' } };
        var parsedDate = parse(e.target.value, 'P', new Date(), { locale: ptBR });
        if (!isValid(parsedDate)) {
            return onChange(response);
        }
        var dayDisabled = isDayDisabled(parsedDate, { minDate: minDate, maxDate: maxDate, filterDate: filterDate });
        if (dayDisabled) {
            return onChange(response);
        }
    };
    return (React__default.createElement("div", { "data-testid": "datepicker" },
        React__default.createElement(er, { openToDate: openToDate, className: "desktop-input " + className, locale: "pt-BR", calendarClassName: "datepicker-calendar", selected: typeof selectedDate === 'object' && selectedDate, onChange: changeDate, dateFormat: datepickerFormat, shouldCloseOnSelect: true, onBlur: handleBlur, showMonthYearPicker: monthPicker || false, useWeekdaysShort: true, placeholderText: placeholderFormat, name: name, filterDate: filterDate, autoComplete: "off", strictParsing: true, minDate: minDate, maxDate: maxDate, disabled: disabled, id: id, readOnly: (readOnly === null || readOnly === void 0 ? void 0 : readOnly.active) ? readOnly : readOnly === null || readOnly === void 0 ? void 0 : readOnly.active, portalId: portalId, popperModifiers: {
                preventOverflow: {
                    enabled: true,
                    escapeWithReference: false,
                    boundariesElement: 'viewport',
                },
            }, customInput: React__default.createElement(InputCustom, __assign$2({ ref: ref, formatDate: inputFormat, readOnly: readOnly, type: "text", name: name, label: label, testId: testId, error: error, startIcon: React__default.createElement(SvgIcon, { src: Calender, fill: "grey400", width: 20, height: 20 }), endIcon: selectedDate && handleCleanDate ? React__default.createElement(DatePickerCleanInput, { onClick: handleCleanDate }) : endIcon, actionEndIcon: Boolean(selectedDate && handleCleanDate && !disabled) }, otherProps)), renderCustomHeader: function (_a) {
                var date = _a.date, decreaseMonth = _a.decreaseMonth, increaseMonth = _a.increaseMonth, decreaseYear = _a.decreaseYear, increaseYear = _a.increaseYear;
                return (React__default.createElement(CalendarHeader, null,
                    React__default.createElement(Button, { type: "button", onClick: monthPicker ? decreaseYear : decreaseMonth },
                        React__default.createElement("svg", { width: "9", height: "12", viewBox: "0 0 6 9", fill: Colors.grey700, xmlns: "http://www.w3.org/2000/svg", className: "flip-left" },
                            React__default.createElement("path", { d: "M0.944726 0.519652C0.644726 0.819653 0.644726 1.26966 0.944726 1.56966L3.84473 4.46966L0.944727 7.36966C0.644727 7.66966 0.644727 8.11965 0.944727 8.41965C1.24473 8.71965 1.69473 8.71965 1.99473 8.41965L5.44473 4.96966C5.59473 4.81966 5.64473 4.61965 5.64473 4.41965C5.64473 4.21965 5.59473 4.01966 5.44473 3.86966L1.99473 0.419654C1.74473 0.219654 1.24473 0.219652 0.944726 0.519652Z" }))),
                    React__default.createElement(MesAno, null, monthPicker ? getYear(date) : format(date, 'MMMM', { locale: ptBR }) + " " + getYear(date)),
                    React__default.createElement(Button, { type: "button", onClick: monthPicker ? increaseYear : increaseMonth },
                        React__default.createElement("svg", { width: "9", height: "12", viewBox: "0 0 6 9", fill: Colors.grey700, xmlns: "http://www.w3.org/2000/svg" },
                            React__default.createElement("path", { d: "M0.944726 0.519652C0.644726 0.819653 0.644726 1.26966 0.944726 1.56966L3.84473 4.46966L0.944727 7.36966C0.644727 7.66966 0.644727 8.11965 0.944727 8.41965C1.24473 8.71965 1.69473 8.71965 1.99473 8.41965L5.44473 4.96966C5.59473 4.81966 5.64473 4.61965 5.64473 4.41965C5.64473 4.21965 5.59473 4.01966 5.44473 3.86966L1.99473 0.419654C1.74473 0.219654 1.24473 0.219652 0.944726 0.519652Z" })))));
            } })));
};
var InputCustom = forwardRef(function (props, ref) {
    var rifm = useRifm({
        value: props.value || '',
        onChange: function (e) {
            var response = { target: { value: e } };
            if (props.onChange) {
                props.onChange(response);
            }
        },
        format: props.formatDate,
    });
    return React__default.createElement(Input$1, __assign$2({ name: props.name, type: "text", ref: ref }, props, { onChange: rifm.onChange, value: rifm.value }));
});
var Datepicker$1 = forwardRef(Datepicker);

var RadioSizes = function (size, error) {
    var borderColor = (!error && Colors.grey400) || Colors.red700;
    var border = css(templateObject_1$o || (templateObject_1$o = __makeTemplateObject(["\n    border: 1px solid ", ";\n    border-radius: 100%;\n  "], ["\n    border: 1px solid ", ";\n    border-radius: 100%;\n  "])), borderColor);
    var sizes = {
        large: css(templateObject_2$l || (templateObject_2$l = __makeTemplateObject(["\n      ", "\n      width: 16px;\n      height: 16px;\n      flex: 0 0 16px;\n    "], ["\n      ", "\n      width: 16px;\n      height: 16px;\n      flex: 0 0 16px;\n    "])), border),
        medium: css(templateObject_3$l || (templateObject_3$l = __makeTemplateObject(["\n      ", "\n      width: 20px;\n      height: 20px;\n      flex: 0 0 20px;\n    "], ["\n      ", "\n      width: 20px;\n      height: 20px;\n      flex: 0 0 20px;\n    "])), border),
        small: css(templateObject_4$j || (templateObject_4$j = __makeTemplateObject(["\n      ", ";\n      width: 16px;\n      height: 16px;\n      flex: 0 0 16px;\n    "], ["\n      ", ";\n      width: 16px;\n      height: 16px;\n      flex: 0 0 16px;\n    "])), border),
    };
    return sizes[size] || sizes['medium'];
};
var IconSizes = function (size) {
    var sizes = {
        large: '8',
        medium: '10',
        small: '8',
    };
    var value = (sizes[size] || sizes['medium']) + "px";
    return css(templateObject_5$g || (templateObject_5$g = __makeTemplateObject(["\n    width: ", ";\n    height: ", ";\n  "], ["\n    width: ", ";\n    height: ", ";\n  "])), value, value);
};
var RadioIcon = styled.div(templateObject_6$g || (templateObject_6$g = __makeTemplateObject(["\n  display: ", ";\n  background: ", ";\n  border-radius: 100%;\n  margin: 0;\n  ", ";\n"], ["\n  display: ", ";\n  background: ", ";\n  border-radius: 100%;\n  margin: 0;\n  ", ";\n"])), function (props) { return (props.checked ? 'block' : 'none'); }, Colors.grey400, function (props) { return IconSizes(props.size); });
var RadioInput = styled.div(templateObject_8$f || (templateObject_8$f = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  ", ";\n\n  ", "\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  cursor: pointer;\n  ", ";\n\n  ",
    "\n"])), function (props) { return RadioSizes(props.size, props.error); }, function (props) {
    return props.disabled && css(templateObject_7$g || (templateObject_7$g = __makeTemplateObject(["\n      background-color: ", ";\n      cursor: not-allowed;\n    "], ["\n      background-color: ", ";\n      cursor: not-allowed;\n    "])), props.theme.colors.grey200);
});
var HiddenInput = styled.input(templateObject_12$4 || (templateObject_12$4 = __makeTemplateObject(["\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n\n  &:checked + ", " ", " {\n    display: block;\n    background-color: ", ";\n    border-radius: 50%;\n\n    ", "\n\n    ", "\n  }\n\n  ", "\n"], ["\n  border: 0;\n  clip: rect(0 0 0 0);\n  height: 1px;\n  margin: -1px;\n  overflow: hidden;\n  padding: 0;\n  position: absolute;\n  white-space: nowrap;\n  width: 1px;\n\n  &:checked + ", " ", " {\n    display: block;\n    background-color: ", ";\n    border-radius: 50%;\n\n    ",
    "\n\n    ",
    "\n  }\n\n  ",
    "\n"])), RadioInput, RadioIcon, function (props) { return props.theme.colors.purple600; }, function (props) {
    return props.disabled && css(templateObject_9$a || (templateObject_9$a = __makeTemplateObject(["\n        background-color: ", ";\n      "], ["\n        background-color: ", ";\n      "])), props.theme.colors.grey400);
}, function (props) {
    return props.error && css(templateObject_10$8 || (templateObject_10$8 = __makeTemplateObject(["\n        background-color: ", ";\n      "], ["\n        background-color: ", ";\n      "])), props.theme.colors.red700);
}, function (props) {
    return props.disabled && css(templateObject_11$5 || (templateObject_11$5 = __makeTemplateObject(["\n      + ", " {\n        border: 1px solid ", ";\n        cursor: not-allowed;\n      }\n\n      &:checked + ", " {\n        border: 1px solid ", ";\n        cursor: not-allowed;\n      }\n    "], ["\n      + ", " {\n        border: 1px solid ", ";\n        cursor: not-allowed;\n      }\n\n      &:checked + ", " {\n        border: 1px solid ", ";\n        cursor: not-allowed;\n      }\n    "])), RadioInput, props.theme.colors.grey200, RadioInput, props.theme.colors.grey200);
});
var RadioGroupContainer = styled.div(templateObject_14$2 || (templateObject_14$2 = __makeTemplateObject(["\n  position: relative;\n\n  ", "\n"], ["\n  position: relative;\n\n  ",
    "\n"])), function (props) {
    return props.readOnly && css(templateObject_13$3 || (templateObject_13$3 = __makeTemplateObject(["\n      display: none;\n    "], ["\n      display: none;\n    "])));
});
var RadioGroupContent = styled.div(templateObject_17$2 || (templateObject_17$2 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  ", ";\n\n  ", "\n\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  ",
    ";\n\n  ",
    "\n\n  ",
    "\n"])), function (props) {
    return !props.autoHeight &&
        "\n  min-height: " + props.theme.forms.defaultHeight + "px;\n  ";
}, function (props) {
    return props.direction === 'horizontal' && css(templateObject_15$2 || (templateObject_15$2 = __makeTemplateObject(["\n      & > div:not(:last-child) label {\n        margin-right: ", "px;\n      }\n    "], ["\n      & > div:not(:last-child) label {\n        margin-right: ", "px;\n      }\n    "])), props.theme.global.gutterSpace);
}, function (props) {
    return props.direction === 'vertical' && css(templateObject_16$2 || (templateObject_16$2 = __makeTemplateObject(["\n      flex-flow: column;\n      align-items: flex-start;\n\n      & > div {\n        margin: ", "px 0 0 0;\n      }\n    "], ["\n      flex-flow: column;\n      align-items: flex-start;\n\n      & > div {\n        margin: ", "px 0 0 0;\n      }\n    "])), props.theme.global.gutterSpace / 2);
});
var templateObject_1$o, templateObject_2$l, templateObject_3$l, templateObject_4$j, templateObject_5$g, templateObject_6$g, templateObject_7$g, templateObject_8$f, templateObject_9$a, templateObject_10$8, templateObject_11$5, templateObject_12$4, templateObject_13$3, templateObject_14$2, templateObject_15$2, templateObject_16$2, templateObject_17$2;

var Radio = function (props, ref) {
    var name = props.name, label = props.label, size = props.size, testId = props.testId, error = props.error, className = props.className, value = props.value, onChange = props.onChange, disabled = props.disabled, otherProps = __rest(props, ["name", "label", "size", "testId", "error", "className", "value", "onChange", "disabled"]);
    var radioLabel = function (children) {
        if (label) {
            var text = label.text, position = label.position;
            var labelText = (React__default.createElement(LabelText, { position: position, size: label.size, error: !!error }, text));
            return (React__default.createElement(Label, { disabled: disabled },
                position === 'left' && labelText,
                children,
                (!position || position === 'right') && labelText));
        }
        return React__default.createElement(Label, null, children);
    };
    var handleChange = function (event) { return onChange && onChange(event); };
    return (React__default.createElement(Container$5, { className: className }, radioLabel([
        React__default.createElement(HiddenInput, __assign$2({ key: "input-hidden", type: "radio", value: value, disabled: disabled, name: name, "data-testid": testId, ref: ref, onChange: handleChange, error: !!error }, otherProps)),
        React__default.createElement(RadioInput, { key: "input-custom", size: size, error: !!error, disabled: disabled },
            React__default.createElement(RadioIcon, { "data-testid": "radio-icon", size: size })),
    ])));
};
var Radio$1 = forwardRef(Radio);

var RadioGroup = function (props) {
    var children = props.children, label = props.label, iconTooltip = props.iconTooltip, textTooltip = props.textTooltip, error = props.error, optional = props.optional, className = props.className, textHelper = props.textHelper, _a = props.direction, direction = _a === void 0 ? 'horizontal' : _a, readOnly = props.readOnly, testId = props.testId, autoHeight = props.autoHeight;
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(RadioGroupContainer, { className: className, readOnly: readOnly === null || readOnly === void 0 ? void 0 : readOnly.active },
            label && (React__default.createElement(StyledLabelContainer, null,
                React__default.createElement(StyledLabel, { as: "div", error: error, optional: optional },
                    label,
                    iconTooltip && textTooltip && (React__default.createElement(AgilizeTooltip, { title: textTooltip },
                        React__default.createElement(StyledIconInputContainer, { hasMarginLeft: true }, iconTooltip)))))),
            React__default.createElement(RadioGroupContent, { direction: direction, autoHeight: autoHeight }, children),
            ((error && typeof error === 'string') || textHelper) && React__default.createElement(StyledHelperInput, { error: error }, error || textHelper)),
        (readOnly === null || readOnly === void 0 ? void 0 : readOnly.active) && React__default.createElement(ReadOnlyField, { label: label, value: readOnly === null || readOnly === void 0 ? void 0 : readOnly.value, textTooltip: textTooltip, iconTooltip: iconTooltip, testId: testId })));
};

keyframes(templateObject_1$n || (templateObject_1$n = __makeTemplateObject(["\n  to {\n      stroke-dashoffset: 0;\n    }\n"], ["\n  to {\n      stroke-dashoffset: 0;\n    }\n"])));
keyframes(templateObject_2$k || (templateObject_2$k = __makeTemplateObject(["\n  from { opacity: 0;}\n  to { opacity: 1;}\n"], ["\n  from { opacity: 0;}\n  to { opacity: 1;}\n"])));
keyframes(templateObject_3$k || (templateObject_3$k = __makeTemplateObject(["\n  from { opacity: 0; transform: translateX(20px); }\n  to { opacity: 1;  transform: translateX(0px);}\n"], ["\n  from { opacity: 0; transform: translateX(20px); }\n  to { opacity: 1;  transform: translateX(0px);}\n"])));
var moveUp = keyframes(templateObject_4$i || (templateObject_4$i = __makeTemplateObject(["\n  0% { transform: translateY(0px);}\n  50% { transform: translateY(-3px);}\n  100% { transform: translateY(0px);}\n"], ["\n  0% { transform: translateY(0px);}\n  50% { transform: translateY(-3px);}\n  100% { transform: translateY(0px);}\n"])));
var animaFadeScaleIn = function (startScale) {
    if (startScale === void 0) { startScale = 0.7; }
    return keyframes(templateObject_5$f || (templateObject_5$f = __makeTemplateObject(["\n  from { opacity: 0; transform: scale(", ");}\n  to { opacity: 1; transform: scale(1);}\n"], ["\n  from { opacity: 0; transform: scale(", ");}\n  to { opacity: 1; transform: scale(1);}\n"])), startScale);
};
keyframes(templateObject_6$f || (templateObject_6$f = __makeTemplateObject(["\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n"], ["\n  from { transform: rotate(0deg); }\n  to { transform: rotate(360deg); }\n"])));
var increaseSizeFromLeft = keyframes(templateObject_7$f || (templateObject_7$f = __makeTemplateObject(["\n  from {\n    left: -5%;\n    width: 5%;\n  }\n  to {\n    left: 130%;\n    width: 100%;\n  }\n"], ["\n  from {\n    left: -5%;\n    width: 5%;\n  }\n  to {\n    left: 130%;\n    width: 100%;\n  }\n"])));
var increaseSizeToRight = keyframes(templateObject_8$e || (templateObject_8$e = __makeTemplateObject(["\n  from {\n    left: -80%;\n    width: 80%;\n  }\n  to {\n    left: 110%;\n    width: 10%;\n  }\n"], ["\n  from {\n    left: -80%;\n    width: 80%;\n  }\n  to {\n    left: 110%;\n    width: 10%;\n  }\n"])));
var fileToCloud = keyframes(templateObject_9$9 || (templateObject_9$9 = __makeTemplateObject(["\n  0% {\n    transform: rotate3d(0, 1, 1, 0deg);\n  }\n  50% {\n    opacity: 0.5;\n    transform: rotate3d(0, 1, 1, -60deg);\n  }\n  100% {\n    transform: rotate3d(0, 1, 1, 0deg);\n  }\n"], ["\n  0% {\n    transform: rotate3d(0, 1, 1, 0deg);\n  }\n  50% {\n    opacity: 0.5;\n    transform: rotate3d(0, 1, 1, -60deg);\n  }\n  100% {\n    transform: rotate3d(0, 1, 1, 0deg);\n  }\n"])));
var folderToCloud = keyframes(templateObject_10$7 || (templateObject_10$7 = __makeTemplateObject(["\n  0% {\n    transform: rotate3d(0, 1, 1, 0deg);\n  }\n  50% {\n    opacity: 0.5;\n    transform: rotate3d(0, 1, 1, 60deg);\n  }\n  100% {\n    transform: rotate3d(0, 1, 1, 0deg);\n  }\n"], ["\n  0% {\n    transform: rotate3d(0, 1, 1, 0deg);\n  }\n  50% {\n    opacity: 0.5;\n    transform: rotate3d(0, 1, 1, 60deg);\n  }\n  100% {\n    transform: rotate3d(0, 1, 1, 0deg);\n  }\n"])));
var templateObject_1$n, templateObject_2$k, templateObject_3$k, templateObject_4$i, templateObject_5$f, templateObject_6$f, templateObject_7$f, templateObject_8$e, templateObject_9$9, templateObject_10$7;

var ModalBackdrop$1 = styled.div(templateObject_1$m || (templateObject_1$m = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  outline: none;\n  padding: ", "px 0;\n  width: 100%;\n  min-height: 100vh;\n  z-index: -1;\n\n  @media print {\n    section {\n      box-shadow: none;\n    }\n  }\n"], ["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  outline: none;\n  padding: ", "px 0;\n  width: 100%;\n  min-height: 100vh;\n  z-index: -1;\n\n  @media print {\n    section {\n      box-shadow: none;\n    }\n  }\n"])), function (props) { return props.theme.global.gutterSpace * 1.5; });
var StyledBackdrop$1 = styled(Backdrop)(templateObject_2$j || (templateObject_2$j = __makeTemplateObject(["\n  &&.MuiBackdrop-root {\n    background-color: ", ";\n  }\n"], ["\n  &&.MuiBackdrop-root {\n    background-color: ", ";\n  }\n"])), function (props) { return rgba(props.theme.colors.grey700, 0.25); });
var ModalContainer$1 = styled.section(templateObject_4$h || (templateObject_4$h = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  flex-flow: column;\n  margin: auto;\n  background: ", ";\n  border-radius: ", "px;\n  width: ", ";\n  max-width: 90vw;\n  animation: ", " 100ms linear forwards;\n  box-shadow: 0px 2px 6px ", ";\n  outline: none;\n  transition: width 100ms ease-out;\n  z-index: 2;\n\n  ", "\n\n  &:active {\n    outline: none;\n  }\n"], ["\n  position: relative;\n  display: flex;\n  flex-flow: column;\n  margin: auto;\n  background: ", ";\n  border-radius: ", "px;\n  width: ", ";\n  max-width: 90vw;\n  animation: ", " 100ms linear forwards;\n  box-shadow: 0px 2px 6px ", ";\n  outline: none;\n  transition: width 100ms ease-out;\n  z-index: 2;\n\n  ",
    "\n\n  &:active {\n    outline: none;\n  }\n"])), function (props) { return props.theme.colors.white; }, function (props) { return props.theme.forms.borderRadius; }, function (props) { return props.theme.modal.size[props.size] + "px"; }, animaFadeScaleIn(0.95), function (props) { return rgba(props.theme.colors.grey400, 0.25); }, function (props) {
    return props.widthContainer && css(templateObject_3$j || (templateObject_3$j = __makeTemplateObject(["\n      width: ", ";\n    "], ["\n      width: ", ";\n    "])), props.widthContainer);
});
var CloseButton$1 = styled(FabButton)(templateObject_5$e || (templateObject_5$e = __makeTemplateObject(["\n  z-index: 1;\n  position: absolute;\n  right: ", "px;\n  top: ", "px;\n"], ["\n  z-index: 1;\n  position: absolute;\n  right: ", "px;\n  top: ", "px;\n"])), function (props) { return props.theme.global.gutterSpace * 0.75; }, function (props) { return props.theme.global.gutterSpace * 0.75; });
var ModalHeader$1 = styled.header(templateObject_7$e || (templateObject_7$e = __makeTemplateObject(["\n  display: flex;\n  padding: ", "px ", "px 0;\n  width: 100%;\n\n  @media print {\n    .no-print,\n    .no-print * {\n      display: none !important;\n    }\n  }\n\n  ", "\n"], ["\n  display: flex;\n  padding: ", "px ", "px 0;\n  width: 100%;\n\n  @media print {\n    .no-print,\n    .no-print * {\n      display: none !important;\n    }\n  }\n\n  ",
    "\n"])), function (props) { return props.theme.global.gutterSpace * 1.5; }, function (props) { return props.theme.global.gutterSpace * 1.5; }, function (props) {
    return props.hasHeaderLine && css(templateObject_6$e || (templateObject_6$e = __makeTemplateObject(["\n      padding: ", "px;\n      border-bottom: 1px solid ", ";\n\n      ", " {\n        top: ", "px;\n        right: ", "px;\n      }\n    "], ["\n      padding: ", "px;\n      border-bottom: 1px solid ", ";\n\n      ", " {\n        top: ", "px;\n        right: ", "px;\n      }\n    "])), props.theme.global.gutterSpace * 1.5, props.theme.colors.grey100, CloseButton$1, props.theme.global.gutterSpace, props.theme.global.gutterSpace);
});
var Title$2 = styled.h1(templateObject_8$d || (templateObject_8$d = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  margin: 0;\n  font-weight: 600;\n  padding: 0 ", "px 0 0;\n  font-size: ", ";\n  color: ", ";\n  line-height: 18px;\n"], ["\n  display: flex;\n  align-items: center;\n  margin: 0;\n  font-weight: 600;\n  padding: 0 ", "px 0 0;\n  font-size: ", ";\n  color: ", ";\n  line-height: 18px;\n"])), function (props) { return props.theme.global.gutterSpace * 2; }, function (props) { return props.theme.fontSizes[3]; }, function (props) { return props.theme.colors.grey900; });
var ModalContent$1 = styled.div(templateObject_9$8 || (templateObject_9$8 = __makeTemplateObject(["\n  padding: ", "px;\n  opacity: 1;\n  transition: opacity 100ms linear;\n\n  ", "\n"], ["\n  padding: ", "px;\n  opacity: 1;\n  transition: opacity 100ms linear;\n\n  ",
    "\n"])), function (props) { return (props.paddingContent ? props.paddingContent : props.theme.global.gutterSpace * 1.5); }, function (props) {
    return props.sizeIsChanging &&
        "\n    width: " + props.theme.modal.size[props.size] + "px;\n    max-width: 90vw;\n    transition: opacity 0ms linear;\n    opacity: 0;\n  ";
});
var ModalScroll = styled(Fade)(templateObject_10$6 || (templateObject_10$6 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n"], ["\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n"])));
var templateObject_1$m, templateObject_2$j, templateObject_3$j, templateObject_4$h, templateObject_5$e, templateObject_6$e, templateObject_7$e, templateObject_8$d, templateObject_9$8, templateObject_10$6;

var Modal = function (props) {
    var children = props.children, isOpen = props.isOpen, onClose = props.onClose, title = props.title, noCloseButton = props.noCloseButton, loading = props.loading, hasHeaderLine = props.hasHeaderLine, className = props.className, size = props.size, containerClassName = props.containerClassName, disableBackdropClick = props.disableBackdropClick, paddingContent = props.paddingContent, widthContainer = props.widthContainer;
    var _a = useState(false), sizeIsChanging = _a[0], setSizeIsChanging = _a[1];
    var titleAsString = typeof title === 'string';
    var prevSizeRed = useRef();
    useEffect(function () {
        if (prevSizeRed.current && size) {
            setSizeIsChanging(true);
            setTimeout(function () {
                setSizeIsChanging(false);
            }, 200);
        }
        prevSizeRed.current = size;
    }, [size]);
    var handleClose = function () {
        if (!loading) {
            onClose();
        }
    };
    var handleBackdrop = function () {
        if (!disableBackdropClick) {
            handleClose();
        }
    };
    return (React__default.createElement(MaterialModal, { disableEscapeKeyDown: disableBackdropClick, className: className, open: isOpen, onClose: handleClose, closeAfterTransition: true, disableBackdropClick: disableBackdropClick, BackdropComponent: StyledBackdrop$1, BackdropProps: {
            timeout: 500,
        } },
        React__default.createElement(ModalScroll, { in: isOpen },
            React__default.createElement(ModalBackdrop$1, { onClick: handleBackdrop },
                React__default.createElement(ModalContainer$1, { widthContainer: widthContainer, size: size || 'large', onClick: function (e) {
                        if (!disableBackdropClick) {
                            e.stopPropagation();
                        }
                    }, className: containerClassName },
                    (title || !noCloseButton) && (React__default.createElement(ModalHeader$1, { hasHeaderLine: hasHeaderLine },
                        titleAsString ? React__default.createElement(Title$2, null, title) : title,
                        !noCloseButton && React__default.createElement(CloseButton$1, { disabledBackgroundColor: true, onClick: handleClose, iconPath: IconClose$1, disabled: loading, className: "no-print" }))),
                    React__default.createElement(ModalContent$1, { sizeIsChanging: sizeIsChanging, size: size || 'large', paddingContent: paddingContent }, children))))));
};

/******************************************************************************
Copyright (c) Microsoft Corporation.

Permission to use, copy, modify, and/or distribute this software for any
purpose with or without fee is hereby granted.

THE SOFTWARE IS PROVIDED "AS IS" AND THE AUTHOR DISCLAIMS ALL WARRANTIES WITH
REGARD TO THIS SOFTWARE INCLUDING ALL IMPLIED WARRANTIES OF MERCHANTABILITY
AND FITNESS. IN NO EVENT SHALL THE AUTHOR BE LIABLE FOR ANY SPECIAL, DIRECT,
INDIRECT, OR CONSEQUENTIAL DAMAGES OR ANY DAMAGES WHATSOEVER RESULTING FROM
LOSS OF USE, DATA OR PROFITS, WHETHER IN AN ACTION OF CONTRACT, NEGLIGENCE OR
OTHER TORTIOUS ACTION, ARISING OUT OF OR IN CONNECTION WITH THE USE OR
PERFORMANCE OF THIS SOFTWARE.
***************************************************************************** */

function __awaiter(thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
}

function __generator(thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
}

function __read(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
}

/** @deprecated */
function __spread() {
    for (var ar = [], i = 0; i < arguments.length; i++)
        ar = ar.concat(__read(arguments[i]));
    return ar;
}

typeof SuppressedError === "function" ? SuppressedError : function (error, suppressed, message) {
    var e = new Error(message);
    return e.name = "SuppressedError", e.error = error, e.suppressed = suppressed, e;
};

var COMMON_MIME_TYPES = new Map([
    // https://developer.mozilla.org/en-US/docs/Web/HTTP/Basics_of_HTTP/MIME_types/Common_types
    ['aac', 'audio/aac'],
    ['abw', 'application/x-abiword'],
    ['arc', 'application/x-freearc'],
    ['avif', 'image/avif'],
    ['avi', 'video/x-msvideo'],
    ['azw', 'application/vnd.amazon.ebook'],
    ['bin', 'application/octet-stream'],
    ['bmp', 'image/bmp'],
    ['bz', 'application/x-bzip'],
    ['bz2', 'application/x-bzip2'],
    ['cda', 'application/x-cdf'],
    ['csh', 'application/x-csh'],
    ['css', 'text/css'],
    ['csv', 'text/csv'],
    ['doc', 'application/msword'],
    ['docx', 'application/vnd.openxmlformats-officedocument.wordprocessingml.document'],
    ['eot', 'application/vnd.ms-fontobject'],
    ['epub', 'application/epub+zip'],
    ['gz', 'application/gzip'],
    ['gif', 'image/gif'],
    ['htm', 'text/html'],
    ['html', 'text/html'],
    ['ico', 'image/vnd.microsoft.icon'],
    ['ics', 'text/calendar'],
    ['jar', 'application/java-archive'],
    ['jpeg', 'image/jpeg'],
    ['jpg', 'image/jpeg'],
    ['js', 'text/javascript'],
    ['json', 'application/json'],
    ['jsonld', 'application/ld+json'],
    ['mid', 'audio/midi'],
    ['midi', 'audio/midi'],
    ['mjs', 'text/javascript'],
    ['mp3', 'audio/mpeg'],
    ['mp4', 'video/mp4'],
    ['mpeg', 'video/mpeg'],
    ['mpkg', 'application/vnd.apple.installer+xml'],
    ['odp', 'application/vnd.oasis.opendocument.presentation'],
    ['ods', 'application/vnd.oasis.opendocument.spreadsheet'],
    ['odt', 'application/vnd.oasis.opendocument.text'],
    ['oga', 'audio/ogg'],
    ['ogv', 'video/ogg'],
    ['ogx', 'application/ogg'],
    ['opus', 'audio/opus'],
    ['otf', 'font/otf'],
    ['png', 'image/png'],
    ['pdf', 'application/pdf'],
    ['php', 'application/x-httpd-php'],
    ['ppt', 'application/vnd.ms-powerpoint'],
    ['pptx', 'application/vnd.openxmlformats-officedocument.presentationml.presentation'],
    ['rar', 'application/vnd.rar'],
    ['rtf', 'application/rtf'],
    ['sh', 'application/x-sh'],
    ['svg', 'image/svg+xml'],
    ['swf', 'application/x-shockwave-flash'],
    ['tar', 'application/x-tar'],
    ['tif', 'image/tiff'],
    ['tiff', 'image/tiff'],
    ['ts', 'video/mp2t'],
    ['ttf', 'font/ttf'],
    ['txt', 'text/plain'],
    ['vsd', 'application/vnd.visio'],
    ['wav', 'audio/wav'],
    ['weba', 'audio/webm'],
    ['webm', 'video/webm'],
    ['webp', 'image/webp'],
    ['woff', 'font/woff'],
    ['woff2', 'font/woff2'],
    ['xhtml', 'application/xhtml+xml'],
    ['xls', 'application/vnd.ms-excel'],
    ['xlsx', 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet'],
    ['xml', 'application/xml'],
    ['xul', 'application/vnd.mozilla.xul+xml'],
    ['zip', 'application/zip'],
    ['7z', 'application/x-7z-compressed'],
    // Others
    ['mkv', 'video/x-matroska'],
    ['mov', 'video/quicktime'],
    ['msg', 'application/vnd.ms-outlook']
]);
function toFileWithPath(file, path) {
    var f = withMimeType(file);
    if (typeof f.path !== 'string') { // on electron, path is already set to the absolute path
        var webkitRelativePath = file.webkitRelativePath;
        Object.defineProperty(f, 'path', {
            value: typeof path === 'string'
                ? path
                // If <input webkitdirectory> is set,
                // the File will have a {webkitRelativePath} property
                // https://developer.mozilla.org/en-US/docs/Web/API/HTMLInputElement/webkitdirectory
                : typeof webkitRelativePath === 'string' && webkitRelativePath.length > 0
                    ? webkitRelativePath
                    : file.name,
            writable: false,
            configurable: false,
            enumerable: true
        });
    }
    return f;
}
function withMimeType(file) {
    var name = file.name;
    var hasExtension = name && name.lastIndexOf('.') !== -1;
    if (hasExtension && !file.type) {
        var ext = name.split('.')
            .pop().toLowerCase();
        var type = COMMON_MIME_TYPES.get(ext);
        if (type) {
            Object.defineProperty(file, 'type', {
                value: type,
                writable: false,
                configurable: false,
                enumerable: true
            });
        }
    }
    return file;
}

var FILES_TO_IGNORE = [
    // Thumbnail cache files for macOS and Windows
    '.DS_Store',
    'Thumbs.db' // Windows
];
/**
 * Convert a DragEvent's DataTrasfer object to a list of File objects
 * NOTE: If some of the items are folders,
 * everything will be flattened and placed in the same list but the paths will be kept as a {path} property.
 *
 * EXPERIMENTAL: A list of https://developer.mozilla.org/en-US/docs/Web/API/FileSystemHandle objects can also be passed as an arg
 * and a list of File objects will be returned.
 *
 * @param evt
 */
function fromEvent(evt) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            if (isObject(evt) && isDataTransfer(evt)) {
                return [2 /*return*/, getDataTransferFiles(evt.dataTransfer, evt.type)];
            }
            else if (isChangeEvt(evt)) {
                return [2 /*return*/, getInputFiles(evt)];
            }
            else if (Array.isArray(evt) && evt.every(function (item) { return 'getFile' in item && typeof item.getFile === 'function'; })) {
                return [2 /*return*/, getFsHandleFiles(evt)];
            }
            return [2 /*return*/, []];
        });
    });
}
function isDataTransfer(value) {
    return isObject(value.dataTransfer);
}
function isChangeEvt(value) {
    return isObject(value) && isObject(value.target);
}
function isObject(v) {
    return typeof v === 'object' && v !== null;
}
function getInputFiles(evt) {
    return fromList(evt.target.files).map(function (file) { return toFileWithPath(file); });
}
// Ee expect each handle to be https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileHandle
function getFsHandleFiles(handles) {
    return __awaiter(this, void 0, void 0, function () {
        var files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0: return [4 /*yield*/, Promise.all(handles.map(function (h) { return h.getFile(); }))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, files.map(function (file) { return toFileWithPath(file); })];
            }
        });
    });
}
function getDataTransferFiles(dt, type) {
    return __awaiter(this, void 0, void 0, function () {
        var items, files;
        return __generator(this, function (_a) {
            switch (_a.label) {
                case 0:
                    if (dt === null) {
                        return [2 /*return*/, []];
                    }
                    if (!dt.items) return [3 /*break*/, 2];
                    items = fromList(dt.items)
                        .filter(function (item) { return item.kind === 'file'; });
                    // According to https://html.spec.whatwg.org/multipage/dnd.html#dndevents,
                    // only 'dragstart' and 'drop' has access to the data (source node)
                    if (type !== 'drop') {
                        return [2 /*return*/, items];
                    }
                    return [4 /*yield*/, Promise.all(items.map(toFilePromises))];
                case 1:
                    files = _a.sent();
                    return [2 /*return*/, noIgnoredFiles(flatten(files))];
                case 2: return [2 /*return*/, noIgnoredFiles(fromList(dt.files)
                        .map(function (file) { return toFileWithPath(file); }))];
            }
        });
    });
}
function noIgnoredFiles(files) {
    return files.filter(function (file) { return FILES_TO_IGNORE.indexOf(file.name) === -1; });
}
// IE11 does not support Array.from()
// https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/from#Browser_compatibility
// https://developer.mozilla.org/en-US/docs/Web/API/FileList
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItemList
function fromList(items) {
    if (items === null) {
        return [];
    }
    var files = [];
    // tslint:disable: prefer-for-of
    for (var i = 0; i < items.length; i++) {
        var file = items[i];
        files.push(file);
    }
    return files;
}
// https://developer.mozilla.org/en-US/docs/Web/API/DataTransferItem
function toFilePromises(item) {
    if (typeof item.webkitGetAsEntry !== 'function') {
        return fromDataTransferItem(item);
    }
    var entry = item.webkitGetAsEntry();
    // Safari supports dropping an image node from a different window and can be retrieved using
    // the DataTransferItem.getAsFile() API
    // NOTE: FileSystemEntry.file() throws if trying to get the file
    if (entry && entry.isDirectory) {
        return fromDirEntry(entry);
    }
    return fromDataTransferItem(item);
}
function flatten(items) {
    return items.reduce(function (acc, files) { return __spread(acc, (Array.isArray(files) ? flatten(files) : [files])); }, []);
}
function fromDataTransferItem(item) {
    var file = item.getAsFile();
    if (!file) {
        return Promise.reject(item + " is not a File");
    }
    var fwp = toFileWithPath(file);
    return Promise.resolve(fwp);
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemEntry
function fromEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, entry.isDirectory ? fromDirEntry(entry) : fromFileEntry(entry)];
        });
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry
function fromDirEntry(entry) {
    var reader = entry.createReader();
    return new Promise(function (resolve, reject) {
        var entries = [];
        function readEntries() {
            var _this = this;
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryEntry/createReader
            // https://developer.mozilla.org/en-US/docs/Web/API/FileSystemDirectoryReader/readEntries
            reader.readEntries(function (batch) { return __awaiter(_this, void 0, void 0, function () {
                var files, err_1, items;
                return __generator(this, function (_a) {
                    switch (_a.label) {
                        case 0:
                            if (!!batch.length) return [3 /*break*/, 5];
                            _a.label = 1;
                        case 1:
                            _a.trys.push([1, 3, , 4]);
                            return [4 /*yield*/, Promise.all(entries)];
                        case 2:
                            files = _a.sent();
                            resolve(files);
                            return [3 /*break*/, 4];
                        case 3:
                            err_1 = _a.sent();
                            reject(err_1);
                            return [3 /*break*/, 4];
                        case 4: return [3 /*break*/, 6];
                        case 5:
                            items = Promise.all(batch.map(fromEntry));
                            entries.push(items);
                            // Continue reading
                            readEntries();
                            _a.label = 6;
                        case 6: return [2 /*return*/];
                    }
                });
            }); }, function (err) {
                reject(err);
            });
        }
        readEntries();
    });
}
// https://developer.mozilla.org/en-US/docs/Web/API/FileSystemFileEntry
function fromFileEntry(entry) {
    return __awaiter(this, void 0, void 0, function () {
        return __generator(this, function (_a) {
            return [2 /*return*/, new Promise(function (resolve, reject) {
                    entry.file(function (file) {
                        var fwp = toFileWithPath(file, entry.fullPath);
                        resolve(fwp);
                    }, function (err) {
                        reject(err);
                    });
                })];
        });
    });
}

var es = createCommonjsModule(function (module, exports) {

exports.__esModule = true;

exports.default = function (file, acceptedFiles) {
  if (file && acceptedFiles) {
    var acceptedFilesArray = Array.isArray(acceptedFiles) ? acceptedFiles : acceptedFiles.split(',');

    if (acceptedFilesArray.length === 0) {
      return true;
    }

    var fileName = file.name || '';
    var mimeType = (file.type || '').toLowerCase();
    var baseMimeType = mimeType.replace(/\/.*$/, '');
    return acceptedFilesArray.some(function (type) {
      var validType = type.trim().toLowerCase();

      if (validType.charAt(0) === '.') {
        return fileName.toLowerCase().endsWith(validType);
      } else if (validType.endsWith('/*')) {
        // This is something like a image/* mime type
        return baseMimeType === validType.replace(/\/.*$/, '');
      }

      return mimeType === validType;
    });
  }

  return true;
};
});

var accepts = unwrapExports(es);

function ownKeys$1(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread$1(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys$1(Object(source), !0).forEach(function (key) { _defineProperty$1(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys$1(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty$1(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray$2(arr, i) { return _arrayWithHoles$2(arr) || _iterableToArrayLimit$2(arr, i) || _unsupportedIterableToArray$1(arr, i) || _nonIterableRest$2(); }

function _nonIterableRest$2() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray$1(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray$1(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray$1(o, minLen); }

function _arrayLikeToArray$1(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$2(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$2(arr) { if (Array.isArray(arr)) return arr; }

var FILE_INVALID_TYPE = 'file-invalid-type';
var FILE_TOO_LARGE = 'file-too-large';
var FILE_TOO_SMALL = 'file-too-small';
var TOO_MANY_FILES = 'too-many-files';

var getInvalidTypeRejectionErr = function getInvalidTypeRejectionErr(accept) {
  accept = Array.isArray(accept) && accept.length === 1 ? accept[0] : accept;
  var messageSuffix = Array.isArray(accept) ? "one of ".concat(accept.join(', ')) : accept;
  return {
    code: FILE_INVALID_TYPE,
    message: "File type must be ".concat(messageSuffix)
  };
};
var getTooLargeRejectionErr = function getTooLargeRejectionErr(maxSize) {
  return {
    code: FILE_TOO_LARGE,
    message: "File is larger than ".concat(maxSize, " ").concat(maxSize === 1 ? 'byte' : 'bytes')
  };
};
var getTooSmallRejectionErr = function getTooSmallRejectionErr(minSize) {
  return {
    code: FILE_TOO_SMALL,
    message: "File is smaller than ".concat(minSize, " ").concat(minSize === 1 ? 'byte' : 'bytes')
  };
};
var TOO_MANY_FILES_REJECTION = {
  code: TOO_MANY_FILES,
  message: 'Too many files'
}; // Firefox versions prior to 53 return a bogus MIME type for every file drag, so dragovers with
// that MIME type will always be accepted

function fileAccepted(file, accept) {
  var isAcceptable = file.type === 'application/x-moz-file' || accepts(file, accept);
  return [isAcceptable, isAcceptable ? null : getInvalidTypeRejectionErr(accept)];
}
function fileMatchSize(file, minSize, maxSize) {
  if (isDefined(file.size)) {
    if (isDefined(minSize) && isDefined(maxSize)) {
      if (file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
      if (file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];
    } else if (isDefined(minSize) && file.size < minSize) return [false, getTooSmallRejectionErr(minSize)];else if (isDefined(maxSize) && file.size > maxSize) return [false, getTooLargeRejectionErr(maxSize)];
  }

  return [true, null];
}

function isDefined(value) {
  return value !== undefined && value !== null;
}

function allFilesAccepted(_ref) {
  var files = _ref.files,
      accept = _ref.accept,
      minSize = _ref.minSize,
      maxSize = _ref.maxSize,
      multiple = _ref.multiple,
      maxFiles = _ref.maxFiles;

  if (!multiple && files.length > 1 || multiple && maxFiles >= 1 && files.length > maxFiles) {
    return false;
  }

  return files.every(function (file) {
    var _fileAccepted = fileAccepted(file, accept),
        _fileAccepted2 = _slicedToArray$2(_fileAccepted, 1),
        accepted = _fileAccepted2[0];

    var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
        _fileMatchSize2 = _slicedToArray$2(_fileMatchSize, 1),
        sizeMatch = _fileMatchSize2[0];

    return accepted && sizeMatch;
  });
} // React's synthetic events has event.isPropagationStopped,
// but to remain compatibility with other libs (Preact) fall back
// to check event.cancelBubble

function isPropagationStopped(event) {
  if (typeof event.isPropagationStopped === 'function') {
    return event.isPropagationStopped();
  } else if (typeof event.cancelBubble !== 'undefined') {
    return event.cancelBubble;
  }

  return false;
}
function isEvtWithFiles(event) {
  if (!event.dataTransfer) {
    return !!event.target && !!event.target.files;
  } // https://developer.mozilla.org/en-US/docs/Web/API/DataTransfer/types
  // https://developer.mozilla.org/en-US/docs/Web/API/HTML_Drag_and_Drop_API/Recommended_drag_types#file


  return Array.prototype.some.call(event.dataTransfer.types, function (type) {
    return type === 'Files' || type === 'application/x-moz-file';
  });
}

function onDocumentDragOver(event) {
  event.preventDefault();
}

function isIe(userAgent) {
  return userAgent.indexOf('MSIE') !== -1 || userAgent.indexOf('Trident/') !== -1;
}

function isEdge(userAgent) {
  return userAgent.indexOf('Edge/') !== -1;
}

function isIeOrEdge() {
  var userAgent = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : window.navigator.userAgent;
  return isIe(userAgent) || isEdge(userAgent);
}
/**
 * This is intended to be used to compose event handlers
 * They are executed in order until one of them calls `event.isPropagationStopped()`.
 * Note that the check is done on the first invoke too,
 * meaning that if propagation was stopped before invoking the fns,
 * no handlers will be executed.
 *
 * @param {Function} fns the event hanlder functions
 * @return {Function} the event handler to add to an element
 */

function composeEventHandlers() {
  for (var _len = arguments.length, fns = new Array(_len), _key = 0; _key < _len; _key++) {
    fns[_key] = arguments[_key];
  }

  return function (event) {
    for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
      args[_key2 - 1] = arguments[_key2];
    }

    return fns.some(function (fn) {
      if (!isPropagationStopped(event) && fn) {
        fn.apply(void 0, [event].concat(args));
      }

      return isPropagationStopped(event);
    });
  };
}
/**
 * canUseFileSystemAccessAPI checks if the [File System Access API](https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API)
 * is supported by the browser.
 * @returns {boolean}
 */

function canUseFileSystemAccessAPI() {
  return 'showOpenFilePicker' in window;
}
/**
 * filePickerOptionsTypes returns the {types} option for https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker
 * based on the accept attr (see https://github.com/react-dropzone/attr-accept)
 * E.g: converts ['image/*', 'text/*'] to {'image/*': [], 'text/*': []}
 * @param {string|string[]} accept
 */

function filePickerOptionsTypes(accept) {
  accept = typeof accept === 'string' ? accept.split(',') : accept;
  return [{
    description: 'everything',
    // TODO: Need to handle filtering more elegantly than this!
    accept: Array.isArray(accept) // Accept just MIME types as per spec
    // NOTE: accept can be https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input/file#unique_file_type_specifiers
    ? accept.filter(function (item) {
      return item === 'audio/*' || item === 'video/*' || item === 'image/*' || item === 'text/*' || /\w+\/[-+.\w]+/g.test(item);
    }).reduce(function (a, b) {
      return _objectSpread$1(_objectSpread$1({}, a), {}, _defineProperty$1({}, b, []));
    }, {}) : {}
  }];
}

var _excluded = ["children"],
    _excluded2 = ["open"],
    _excluded3 = ["refKey", "role", "onKeyDown", "onFocus", "onBlur", "onClick", "onDragEnter", "onDragOver", "onDragLeave", "onDrop"],
    _excluded4 = ["refKey", "onChange", "onClick"];

function _toConsumableArray$1(arr) { return _arrayWithoutHoles$1(arr) || _iterableToArray$1(arr) || _unsupportedIterableToArray(arr) || _nonIterableSpread$1(); }

function _nonIterableSpread$1() { throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _iterableToArray$1(iter) { if (typeof Symbol !== "undefined" && iter[Symbol.iterator] != null || iter["@@iterator"] != null) return Array.from(iter); }

function _arrayWithoutHoles$1(arr) { if (Array.isArray(arr)) return _arrayLikeToArray(arr); }

function _slicedToArray$1(arr, i) { return _arrayWithHoles$1(arr) || _iterableToArrayLimit$1(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest$1(); }

function _nonIterableRest$1() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit$1(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles$1(arr) { if (Array.isArray(arr)) return arr; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties$1(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose$1(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose$1(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
/**
 * Convenience wrapper component for the `useDropzone` hook
 *
 * ```jsx
 * <Dropzone>
 *   {({getRootProps, getInputProps}) => (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag 'n' drop some files here, or click to select files</p>
 *     </div>
 *   )}
 * </Dropzone>
 * ```
 */

var Dropzone = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var children = _ref.children,
      params = _objectWithoutProperties$1(_ref, _excluded);

  var _useDropzone = useDropzone(params),
      open = _useDropzone.open,
      props = _objectWithoutProperties$1(_useDropzone, _excluded2);

  useImperativeHandle(ref, function () {
    return {
      open: open
    };
  }, [open]); // TODO: Figure out why react-styleguidist cannot create docs if we don't return a jsx element

  return /*#__PURE__*/React__default.createElement(Fragment$2, null, children(_objectSpread(_objectSpread({}, props), {}, {
    open: open
  })));
});
Dropzone.displayName = 'Dropzone'; // Add default props for react-docgen

var defaultProps = {
  disabled: false,
  getFilesFromEvent: fromEvent,
  maxSize: Infinity,
  minSize: 0,
  multiple: true,
  maxFiles: 0,
  preventDropOnDocument: true,
  noClick: false,
  noKeyboard: false,
  noDrag: false,
  noDragEventsBubbling: false,
  validator: null,
  useFsAccessApi: false
};
Dropzone.defaultProps = defaultProps;
Dropzone.propTypes = {
  /**
   * Render function that exposes the dropzone state and prop getter fns
   *
   * @param {object} params
   * @param {Function} params.getRootProps Returns the props you should apply to the root drop container you render
   * @param {Function} params.getInputProps Returns the props you should apply to hidden file input you render
   * @param {Function} params.open Open the native file selection dialog
   * @param {boolean} params.isFocused Dropzone area is in focus
   * @param {boolean} params.isFileDialogActive File dialog is opened
   * @param {boolean} params.isDragActive Active drag is in progress
   * @param {boolean} params.isDragAccept Dragged files are accepted
   * @param {boolean} params.isDragReject Some dragged files are rejected
   * @param {File[]} params.draggedFiles Files in active drag
   * @param {File[]} params.acceptedFiles Accepted files
   * @param {FileRejection[]} params.fileRejections Rejected files and why they were rejected
   */
  children: PropTypes.func,

  /**
   * Set accepted file types.
   * See https://github.com/okonet/attr-accept for more information.
   * Keep in mind that mime type determination is not reliable across platforms. CSV files,
   * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
   * Windows. In some cases there might not be a mime type set at all.
   * See: https://github.com/react-dropzone/react-dropzone/issues/276
   */
  accept: PropTypes.oneOfType([PropTypes.string, PropTypes.arrayOf(PropTypes.string)]),

  /**
   * Allow drag 'n' drop (or selection from the file dialog) of multiple files
   */
  multiple: PropTypes.bool,

  /**
   * If false, allow dropped items to take over the current browser window
   */
  preventDropOnDocument: PropTypes.bool,

  /**
   * If true, disables click to open the native file selection dialog
   */
  noClick: PropTypes.bool,

  /**
   * If true, disables SPACE/ENTER to open the native file selection dialog.
   * Note that it also stops tracking the focus state.
   */
  noKeyboard: PropTypes.bool,

  /**
   * If true, disables drag 'n' drop
   */
  noDrag: PropTypes.bool,

  /**
   * If true, stops drag event propagation to parents
   */
  noDragEventsBubbling: PropTypes.bool,

  /**
   * Minimum file size (in bytes)
   */
  minSize: PropTypes.number,

  /**
   * Maximum file size (in bytes)
   */
  maxSize: PropTypes.number,

  /**
   * Maximum accepted number of files
   * The default value is 0 which means there is no limitation to how many files are accepted.
   */
  maxFiles: PropTypes.number,

  /**
   * Enable/disable the dropzone
   */
  disabled: PropTypes.bool,

  /**
   * Use this to provide a custom file aggregator
   *
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  getFilesFromEvent: PropTypes.func,

  /**
   * Cb for when closing the file dialog with no selection
   */
  onFileDialogCancel: PropTypes.func,

  /**
   * Cb for when opening the file dialog
   */
  onFileDialogOpen: PropTypes.func,

  /**
   * Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
   * to open the file picker instead of using an `<input type="file">` click event.
   */
  useFsAccessApi: PropTypes.bool,

  /**
   * Cb for when the `dragenter` event occurs.
   *
   * @param {DragEvent} event
   */
  onDragEnter: PropTypes.func,

  /**
   * Cb for when the `dragleave` event occurs
   *
   * @param {DragEvent} event
   */
  onDragLeave: PropTypes.func,

  /**
   * Cb for when the `dragover` event occurs
   *
   * @param {DragEvent} event
   */
  onDragOver: PropTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
   *
   * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
   * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
   * If `multiple` is set to false and additional files are dropped,
   * all files besides the first will be rejected.
   * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
   *
   * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
   * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
   *
   * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
   * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
   *
   * ```js
   * function onDrop(acceptedFiles) {
   *   const req = request.post('/upload')
   *   acceptedFiles.forEach(file => {
   *     req.attach(file.name, file)
   *   })
   *   req.end(callback)
   * }
   * ```
   *
   * @param {File[]} acceptedFiles
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
   */
  onDrop: PropTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are accepted, this callback is not invoked.
   *
   * @param {File[]} files
   * @param {(DragEvent|Event)} event
   */
  onDropAccepted: PropTypes.func,

  /**
   * Cb for when the `drop` event occurs.
   * Note that if no files are rejected, this callback is not invoked.
   *
   * @param {FileRejection[]} fileRejections
   * @param {(DragEvent|Event)} event
   */
  onDropRejected: PropTypes.func,

  /**
   * Custom validation function
   * @param {File} file
   * @returns {FileError|FileError[]}
   */
  validator: PropTypes.func
};
/**
 * A function that is invoked for the `dragenter`,
 * `dragover` and `dragleave` events.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dragCb
 * @param {DragEvent} event
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are not files (such as link, text, etc.).
 *
 * @callback dropCb
 * @param {File[]} acceptedFiles List of accepted files
 * @param {FileRejection[]} fileRejections List of rejected files and why they were rejected
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 * It is not invoked if the items are files (such as link, text, etc.).
 *
 * @callback dropAcceptedCb
 * @param {File[]} files List of accepted files that meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is invoked for the `drop` or input change event.
 *
 * @callback dropRejectedCb
 * @param {File[]} files List of rejected files that do not meet the given criteria
 * (`accept`, `multiple`, `minSize`, `maxSize`)
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 */

/**
 * A function that is used aggregate files,
 * in a asynchronous fashion, from drag or input change events.
 *
 * @callback getFilesFromEvent
 * @param {(DragEvent|Event)} event A drag event or input change event (if files were selected via the file dialog)
 * @returns {(File[]|Promise<File[]>)}
 */

/**
 * An object with the current dropzone state and some helper functions.
 *
 * @typedef {object} DropzoneState
 * @property {Function} getRootProps Returns the props you should apply to the root drop container you render
 * @property {Function} getInputProps Returns the props you should apply to hidden file input you render
 * @property {Function} open Open the native file selection dialog
 * @property {boolean} isFocused Dropzone area is in focus
 * @property {boolean} isFileDialogActive File dialog is opened
 * @property {boolean} isDragActive Active drag is in progress
 * @property {boolean} isDragAccept Dragged files are accepted
 * @property {boolean} isDragReject Some dragged files are rejected
 * @property {File[]} draggedFiles Files in active drag
 * @property {File[]} acceptedFiles Accepted files
 * @property {FileRejection[]} fileRejections Rejected files and why they were rejected
 */

var initialState = {
  isFocused: false,
  isFileDialogActive: false,
  isDragActive: false,
  isDragAccept: false,
  isDragReject: false,
  draggedFiles: [],
  acceptedFiles: [],
  fileRejections: []
};
/**
 * A React hook that creates a drag 'n' drop area.
 *
 * ```jsx
 * function MyDropzone(props) {
 *   const {getRootProps, getInputProps} = useDropzone({
 *     onDrop: acceptedFiles => {
 *       // do something with the File objects, e.g. upload to some server
 *     }
 *   });
 *   return (
 *     <div {...getRootProps()}>
 *       <input {...getInputProps()} />
 *       <p>Drag and drop some files here, or click to select files</p>
 *     </div>
 *   )
 * }
 * ```
 *
 * @function useDropzone
 *
 * @param {object} props
 * @param {string|string[]} [props.accept] Set accepted file types.
 * See https://github.com/okonet/attr-accept for more information.
 * Keep in mind that mime type determination is not reliable across platforms. CSV files,
 * for example, are reported as text/plain under macOS but as application/vnd.ms-excel under
 * Windows. In some cases there might not be a mime type set at all.
 * See: https://github.com/react-dropzone/react-dropzone/issues/276
 * @param {boolean} [props.multiple=true] Allow drag 'n' drop (or selection from the file dialog) of multiple files
 * @param {boolean} [props.preventDropOnDocument=true] If false, allow dropped items to take over the current browser window
 * @param {boolean} [props.noClick=false] If true, disables click to open the native file selection dialog
 * @param {boolean} [props.noKeyboard=false] If true, disables SPACE/ENTER to open the native file selection dialog.
 * Note that it also stops tracking the focus state.
 * @param {boolean} [props.noDrag=false] If true, disables drag 'n' drop
 * @param {boolean} [props.noDragEventsBubbling=false] If true, stops drag event propagation to parents
 * @param {number} [props.minSize=0] Minimum file size (in bytes)
 * @param {number} [props.maxSize=Infinity] Maximum file size (in bytes)
 * @param {boolean} [props.disabled=false] Enable/disable the dropzone
 * @param {getFilesFromEvent} [props.getFilesFromEvent] Use this to provide a custom file aggregator
 * @param {Function} [props.onFileDialogCancel] Cb for when closing the file dialog with no selection
 * @param {boolean} [props.useFsAccessApi] Set to true to use the https://developer.mozilla.org/en-US/docs/Web/API/File_System_Access_API
 * to open the file picker instead of using an `<input type="file">` click event.
 * @param {Function} [props.onFileDialogOpen] Cb for when opening the file dialog
 * @param {dragCb} [props.onDragEnter] Cb for when the `dragenter` event occurs.
 * @param {dragCb} [props.onDragLeave] Cb for when the `dragleave` event occurs
 * @param {dragCb} [props.onDragOver] Cb for when the `dragover` event occurs
 * @param {dropCb} [props.onDrop] Cb for when the `drop` event occurs.
 * Note that this callback is invoked after the `getFilesFromEvent` callback is done.
 *
 * Files are accepted or rejected based on the `accept`, `multiple`, `minSize` and `maxSize` props.
 * `accept` must be a valid [MIME type](http://www.iana.org/assignments/media-types/media-types.xhtml) according to [input element specification](https://www.w3.org/wiki/HTML/Elements/input/file) or a valid file extension.
 * If `multiple` is set to false and additional files are dropped,
 * all files besides the first will be rejected.
 * Any file which does not have a size in the [`minSize`, `maxSize`] range, will be rejected as well.
 *
 * Note that the `onDrop` callback will always be invoked regardless if the dropped files were accepted or rejected.
 * If you'd like to react to a specific scenario, use the `onDropAccepted`/`onDropRejected` props.
 *
 * `onDrop` will provide you with an array of [File](https://developer.mozilla.org/en-US/docs/Web/API/File) objects which you can then process and send to a server.
 * For example, with [SuperAgent](https://github.com/visionmedia/superagent) as a http/ajax library:
 *
 * ```js
 * function onDrop(acceptedFiles) {
 *   const req = request.post('/upload')
 *   acceptedFiles.forEach(file => {
 *     req.attach(file.name, file)
 *   })
 *   req.end(callback)
 * }
 * ```
 * @param {dropAcceptedCb} [props.onDropAccepted]
 * @param {dropRejectedCb} [props.onDropRejected]
 *
 * @returns {DropzoneState}
 */

function useDropzone() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  var _defaultProps$options = _objectSpread(_objectSpread({}, defaultProps), options),
      accept = _defaultProps$options.accept,
      disabled = _defaultProps$options.disabled,
      getFilesFromEvent = _defaultProps$options.getFilesFromEvent,
      maxSize = _defaultProps$options.maxSize,
      minSize = _defaultProps$options.minSize,
      multiple = _defaultProps$options.multiple,
      maxFiles = _defaultProps$options.maxFiles,
      onDragEnter = _defaultProps$options.onDragEnter,
      onDragLeave = _defaultProps$options.onDragLeave,
      onDragOver = _defaultProps$options.onDragOver,
      onDrop = _defaultProps$options.onDrop,
      onDropAccepted = _defaultProps$options.onDropAccepted,
      onDropRejected = _defaultProps$options.onDropRejected,
      onFileDialogCancel = _defaultProps$options.onFileDialogCancel,
      onFileDialogOpen = _defaultProps$options.onFileDialogOpen,
      useFsAccessApi = _defaultProps$options.useFsAccessApi,
      preventDropOnDocument = _defaultProps$options.preventDropOnDocument,
      noClick = _defaultProps$options.noClick,
      noKeyboard = _defaultProps$options.noKeyboard,
      noDrag = _defaultProps$options.noDrag,
      noDragEventsBubbling = _defaultProps$options.noDragEventsBubbling,
      validator = _defaultProps$options.validator;

  var onFileDialogOpenCb = useMemo(function () {
    return typeof onFileDialogOpen === 'function' ? onFileDialogOpen : noop;
  }, [onFileDialogOpen]);
  var onFileDialogCancelCb = useMemo(function () {
    return typeof onFileDialogCancel === 'function' ? onFileDialogCancel : noop;
  }, [onFileDialogCancel]);
  var rootRef = useRef(null);
  var inputRef = useRef(null);

  var _useReducer = useReducer(reducer, initialState),
      _useReducer2 = _slicedToArray$1(_useReducer, 2),
      state = _useReducer2[0],
      dispatch = _useReducer2[1];

  var isFocused = state.isFocused,
      isFileDialogActive = state.isFileDialogActive,
      draggedFiles = state.draggedFiles; // Update file dialog active state when the window is focused on

  var onWindowFocus = function onWindowFocus() {
    // Execute the timeout only if the file dialog is opened in the browser
    if (isFileDialogActive) {
      setTimeout(function () {
        if (inputRef.current) {
          var files = inputRef.current.files;

          if (!files.length) {
            dispatch({
              type: 'closeDialog'
            });
            onFileDialogCancelCb();
          }
        }
      }, 300);
    }
  };

  useEffect(function () {
    if (useFsAccessApi && canUseFileSystemAccessAPI()) {
      return function () {};
    }

    window.addEventListener('focus', onWindowFocus, false);
    return function () {
      window.removeEventListener('focus', onWindowFocus, false);
    };
  }, [inputRef, isFileDialogActive, onFileDialogCancelCb, useFsAccessApi]);
  var dragTargetsRef = useRef([]);

  var onDocumentDrop = function onDocumentDrop(event) {
    if (rootRef.current && rootRef.current.contains(event.target)) {
      // If we intercepted an event for our instance, let it propagate down to the instance's onDrop handler
      return;
    }

    event.preventDefault();
    dragTargetsRef.current = [];
  };

  useEffect(function () {
    if (preventDropOnDocument) {
      document.addEventListener('dragover', onDocumentDragOver, false);
      document.addEventListener('drop', onDocumentDrop, false);
    }

    return function () {
      if (preventDropOnDocument) {
        document.removeEventListener('dragover', onDocumentDragOver);
        document.removeEventListener('drop', onDocumentDrop);
      }
    };
  }, [rootRef, preventDropOnDocument]);
  var onDragEnterCb = useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [].concat(_toConsumableArray$1(dragTargetsRef.current), [event.target]);

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (draggedFiles) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        dispatch({
          draggedFiles: draggedFiles,
          isDragActive: true,
          type: 'setDraggedFiles'
        });

        if (onDragEnter) {
          onDragEnter(event);
        }
      });
    }
  }, [getFilesFromEvent, onDragEnter, noDragEventsBubbling]);
  var onDragOverCb = useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event);
    var hasFiles = isEvtWithFiles(event);

    if (hasFiles && event.dataTransfer) {
      try {
        event.dataTransfer.dropEffect = 'copy';
      } catch (_unused) {}
      /* eslint-disable-line no-empty */

    }

    if (hasFiles && onDragOver) {
      onDragOver(event);
    }

    return false;
  }, [onDragOver, noDragEventsBubbling]);
  var onDragLeaveCb = useCallback(function (event) {
    event.preventDefault();
    event.persist();
    stopPropagation(event); // Only deactivate once the dropzone and all children have been left

    var targets = dragTargetsRef.current.filter(function (target) {
      return rootRef.current && rootRef.current.contains(target);
    }); // Make sure to remove a target present multiple times only once
    // (Firefox may fire dragenter/dragleave multiple times on the same element)

    var targetIdx = targets.indexOf(event.target);

    if (targetIdx !== -1) {
      targets.splice(targetIdx, 1);
    }

    dragTargetsRef.current = targets;

    if (targets.length > 0) {
      return;
    }

    dispatch({
      isDragActive: false,
      type: 'setDraggedFiles',
      draggedFiles: []
    });

    if (isEvtWithFiles(event) && onDragLeave) {
      onDragLeave(event);
    }
  }, [rootRef, onDragLeave, noDragEventsBubbling]);
  var setFiles = useCallback(function (files, event) {
    var acceptedFiles = [];
    var fileRejections = [];
    files.forEach(function (file) {
      var _fileAccepted = fileAccepted(file, accept),
          _fileAccepted2 = _slicedToArray$1(_fileAccepted, 2),
          accepted = _fileAccepted2[0],
          acceptError = _fileAccepted2[1];

      var _fileMatchSize = fileMatchSize(file, minSize, maxSize),
          _fileMatchSize2 = _slicedToArray$1(_fileMatchSize, 2),
          sizeMatch = _fileMatchSize2[0],
          sizeError = _fileMatchSize2[1];

      var customErrors = validator ? validator(file) : null;

      if (accepted && sizeMatch && !customErrors) {
        acceptedFiles.push(file);
      } else {
        var errors = [acceptError, sizeError];

        if (customErrors) {
          errors = errors.concat(customErrors);
        }

        fileRejections.push({
          file: file,
          errors: errors.filter(function (e) {
            return e;
          })
        });
      }
    });

    if (!multiple && acceptedFiles.length > 1 || multiple && maxFiles >= 1 && acceptedFiles.length > maxFiles) {
      // Reject everything and empty accepted files
      acceptedFiles.forEach(function (file) {
        fileRejections.push({
          file: file,
          errors: [TOO_MANY_FILES_REJECTION]
        });
      });
      acceptedFiles.splice(0);
    }

    dispatch({
      acceptedFiles: acceptedFiles,
      fileRejections: fileRejections,
      type: 'setFiles'
    });

    if (onDrop) {
      onDrop(acceptedFiles, fileRejections, event);
    }

    if (fileRejections.length > 0 && onDropRejected) {
      onDropRejected(fileRejections, event);
    }

    if (acceptedFiles.length > 0 && onDropAccepted) {
      onDropAccepted(acceptedFiles, event);
    }
  }, [dispatch, multiple, accept, minSize, maxSize, maxFiles, onDrop, onDropAccepted, onDropRejected, validator]);
  var onDropCb = useCallback(function (event) {
    event.preventDefault(); // Persist here because we need the event later after getFilesFromEvent() is done

    event.persist();
    stopPropagation(event);
    dragTargetsRef.current = [];

    if (isEvtWithFiles(event)) {
      Promise.resolve(getFilesFromEvent(event)).then(function (files) {
        if (isPropagationStopped(event) && !noDragEventsBubbling) {
          return;
        }

        setFiles(files, event);
      });
    }

    dispatch({
      type: 'reset'
    });
  }, [getFilesFromEvent, setFiles, noDragEventsBubbling]); // Fn for opening the file dialog programmatically

  var openFileDialog = useCallback(function () {
    if (useFsAccessApi && canUseFileSystemAccessAPI()) {
      dispatch({
        type: 'openDialog'
      });
      onFileDialogOpenCb(); // https://developer.mozilla.org/en-US/docs/Web/API/window/showOpenFilePicker

      var opts = {
        multiple: multiple,
        types: filePickerOptionsTypes(accept)
      };
      window.showOpenFilePicker(opts).then(function (handles) {
        return getFilesFromEvent(handles);
      }).then(function (files) {
        return setFiles(files, null);
      }).catch(function (e) {
        return onFileDialogCancelCb(e);
      }).finally(function () {
        return dispatch({
          type: 'closeDialog'
        });
      });
      return;
    }

    if (inputRef.current) {
      dispatch({
        type: 'openDialog'
      });
      onFileDialogOpenCb();
      inputRef.current.value = null;
      inputRef.current.click();
    }
  }, [dispatch, onFileDialogOpenCb, onFileDialogCancelCb, useFsAccessApi, setFiles, accept, multiple]); // Cb to open the file dialog when SPACE/ENTER occurs on the dropzone

  var onKeyDownCb = useCallback(function (event) {
    // Ignore keyboard events bubbling up the DOM tree
    if (!rootRef.current || !rootRef.current.isEqualNode(event.target)) {
      return;
    }

    if (event.keyCode === 32 || event.keyCode === 13) {
      event.preventDefault();
      openFileDialog();
    }
  }, [rootRef, inputRef, openFileDialog]); // Update focus state for the dropzone

  var onFocusCb = useCallback(function () {
    dispatch({
      type: 'focus'
    });
  }, []);
  var onBlurCb = useCallback(function () {
    dispatch({
      type: 'blur'
    });
  }, []); // Cb to open the file dialog when click occurs on the dropzone

  var onClickCb = useCallback(function () {
    if (noClick) {
      return;
    } // In IE11/Edge the file-browser dialog is blocking, therefore, use setTimeout()
    // to ensure React can handle state changes
    // See: https://github.com/react-dropzone/react-dropzone/issues/450


    if (isIeOrEdge()) {
      setTimeout(openFileDialog, 0);
    } else {
      openFileDialog();
    }
  }, [inputRef, noClick, openFileDialog]);

  var composeHandler = function composeHandler(fn) {
    return disabled ? null : fn;
  };

  var composeKeyboardHandler = function composeKeyboardHandler(fn) {
    return noKeyboard ? null : composeHandler(fn);
  };

  var composeDragHandler = function composeDragHandler(fn) {
    return noDrag ? null : composeHandler(fn);
  };

  var stopPropagation = function stopPropagation(event) {
    if (noDragEventsBubbling) {
      event.stopPropagation();
    }
  };

  var getRootProps = useMemo(function () {
    return function () {
      var _ref2 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref2$refKey = _ref2.refKey,
          refKey = _ref2$refKey === void 0 ? 'ref' : _ref2$refKey,
          role = _ref2.role,
          onKeyDown = _ref2.onKeyDown,
          onFocus = _ref2.onFocus,
          onBlur = _ref2.onBlur,
          onClick = _ref2.onClick,
          onDragEnter = _ref2.onDragEnter,
          onDragOver = _ref2.onDragOver,
          onDragLeave = _ref2.onDragLeave,
          onDrop = _ref2.onDrop,
          rest = _objectWithoutProperties$1(_ref2, _excluded3);

      return _objectSpread(_objectSpread(_defineProperty({
        onKeyDown: composeKeyboardHandler(composeEventHandlers(onKeyDown, onKeyDownCb)),
        onFocus: composeKeyboardHandler(composeEventHandlers(onFocus, onFocusCb)),
        onBlur: composeKeyboardHandler(composeEventHandlers(onBlur, onBlurCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onClickCb)),
        onDragEnter: composeDragHandler(composeEventHandlers(onDragEnter, onDragEnterCb)),
        onDragOver: composeDragHandler(composeEventHandlers(onDragOver, onDragOverCb)),
        onDragLeave: composeDragHandler(composeEventHandlers(onDragLeave, onDragLeaveCb)),
        onDrop: composeDragHandler(composeEventHandlers(onDrop, onDropCb)),
        role: typeof role === 'string' && role !== '' ? role : 'button'
      }, refKey, rootRef), !disabled && !noKeyboard ? {
        tabIndex: 0
      } : {}), rest);
    };
  }, [rootRef, onKeyDownCb, onFocusCb, onBlurCb, onClickCb, onDragEnterCb, onDragOverCb, onDragLeaveCb, onDropCb, noKeyboard, noDrag, disabled]);
  var onInputElementClick = useCallback(function (event) {
    event.stopPropagation();
  }, []);
  var getInputProps = useMemo(function () {
    return function () {
      var _ref3 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
          _ref3$refKey = _ref3.refKey,
          refKey = _ref3$refKey === void 0 ? 'ref' : _ref3$refKey,
          onChange = _ref3.onChange,
          onClick = _ref3.onClick,
          rest = _objectWithoutProperties$1(_ref3, _excluded4);

      var inputProps = _defineProperty({
        accept: accept,
        multiple: multiple,
        type: 'file',
        style: {
          display: 'none'
        },
        onChange: composeHandler(composeEventHandlers(onChange, onDropCb)),
        onClick: composeHandler(composeEventHandlers(onClick, onInputElementClick)),
        autoComplete: 'off',
        tabIndex: -1
      }, refKey, inputRef);

      return _objectSpread(_objectSpread({}, inputProps), rest);
    };
  }, [inputRef, accept, multiple, onDropCb, disabled]);
  var fileCount = draggedFiles.length;
  var isDragAccept = fileCount > 0 && allFilesAccepted({
    files: draggedFiles,
    accept: accept,
    minSize: minSize,
    maxSize: maxSize,
    multiple: multiple,
    maxFiles: maxFiles
  });
  var isDragReject = fileCount > 0 && !isDragAccept;
  return _objectSpread(_objectSpread({}, state), {}, {
    isDragAccept: isDragAccept,
    isDragReject: isDragReject,
    isFocused: isFocused && !disabled,
    getRootProps: getRootProps,
    getInputProps: getInputProps,
    rootRef: rootRef,
    inputRef: inputRef,
    open: composeHandler(openFileDialog)
  });
}

function reducer(state, action) {
  /* istanbul ignore next */
  switch (action.type) {
    case 'focus':
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: true
      });

    case 'blur':
      return _objectSpread(_objectSpread({}, state), {}, {
        isFocused: false
      });

    case 'openDialog':
      return _objectSpread(_objectSpread({}, initialState), {}, {
        isFileDialogActive: true
      });

    case 'closeDialog':
      return _objectSpread(_objectSpread({}, state), {}, {
        isFileDialogActive: false
      });

    case 'setDraggedFiles':
      /* eslint no-case-declarations: 0 */
      var isDragActive = action.isDragActive,
          draggedFiles = action.draggedFiles;
      return _objectSpread(_objectSpread({}, state), {}, {
        draggedFiles: draggedFiles,
        isDragActive: isDragActive
      });

    case 'setFiles':
      return _objectSpread(_objectSpread({}, state), {}, {
        acceptedFiles: action.acceptedFiles,
        fileRejections: action.fileRejections
      });

    case 'reset':
      return _objectSpread({}, initialState);

    default:
      return state;
  }
}

function noop() {}

var FileWrapper = styled.div(templateObject_1$l || (templateObject_1$l = __makeTemplateObject(["\n  width: fit-content;\n  max-width: 100%;\n  outline: none;\n\n  input[type='file'] {\n    display: none;\n  }\n\n  &:focus {\n    border-color: ", ";\n  }\n"], ["\n  width: fit-content;\n  max-width: 100%;\n  outline: none;\n\n  input[type='file'] {\n    display: none;\n  }\n\n  &:focus {\n    border-color: ", ";\n  }\n"])), function (props) { return props.theme.colors.grey100; });
var FileLabel = styled.label(templateObject_4$g || (templateObject_4$g = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: nowrap;\n  padding: ", "px ", "px;\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", "px;\n  font-size: ", ";\n  color: ", ";\n  line-height: 18px;\n  cursor: pointer;\n  transition: background-color 250ms ease-out;\n  white-space: nowrap;\n\n  svg {\n    margin-right: ", "px;\n  }\n\n  ", "\n\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  flex-wrap: nowrap;\n  padding: ", "px ", "px;\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", "px;\n  font-size: ", ";\n  color: ", ";\n  line-height: 18px;\n  cursor: pointer;\n  transition: background-color 250ms ease-out;\n  white-space: nowrap;\n\n  svg {\n    margin-right: ", "px;\n  }\n\n  ",
    "\n\n  ",
    "\n"])), function (props) { return props.theme.global.gutterSpace / 2; }, function (props) { return props.theme.global.gutterSpace * 0.75; }, function (props) { return props.theme.colors.grey100; }, function (props) { return props.theme.colors.grey400; }, function (props) { return props.theme.forms.borderRadius; }, function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.colors.grey700; }, function (props) { return props.theme.global.gutterSpace * 0.5; }, function (props) {
    return props.disabled && css(templateObject_2$i || (templateObject_2$i = __makeTemplateObject(["\n      border: 1px solid ", ";\n      cursor: not-allowed;\n      color: ", ";\n      svg {\n        fill: ", ";\n      }\n    "], ["\n      border: 1px solid ", ";\n      cursor: not-allowed;\n      color: ", ";\n      svg {\n        fill: ", ";\n      }\n    "])), props.theme.colors.grey100, props.theme.colors.grey400, props.theme.colors.grey400);
}, function (props) {
    return !props.disabled && css(templateObject_3$i || (templateObject_3$i = __makeTemplateObject(["\n      &:active {\n        background-color: ", ";\n      }\n    "], ["\n      &:active {\n        background-color: ", ";\n      }\n    "])), curriedDarken$1(0.05, props.theme.colors.grey100));
});
var InputFileSelectedContainer = styled.div(templateObject_5$d || (templateObject_5$d = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  margin-left: ", "px;\n  min-width: 0;\n\n  ", " {\n    margin-top: ", "px;\n    margin-left: 0;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  margin-left: ", "px;\n  min-width: 0;\n\n  ", " {\n    margin-top: ", "px;\n    margin-left: 0;\n  }\n"])), function (props) { return props.theme.global.gutterSpace * 0.75; }, device.mobile, function (props) { return props.theme.global.gutterSpace * 0.5; });
var InputFileEmpty = styled.label(templateObject_6$d || (templateObject_6$d = __makeTemplateObject(["\n  margin-left: ", "px;\n  font-size: ", ";\n  font-style: italic;\n  color: ", ";\n  line-height: 18px;\n\n  ", " {\n    margin-left: 0;\n  }\n"], ["\n  margin-left: ", "px;\n  font-size: ", ";\n  font-style: italic;\n  color: ", ";\n  line-height: 18px;\n\n  ", " {\n    margin-left: 0;\n  }\n"])), function (props) { return props.theme.global.gutterSpace * 0.75; }, function (props) { return props.theme.fontSizes[1]; }, function (props) { return props.theme.colors.grey700; }, device.mobile);
var InputFileSelectedContent = styled.div(templateObject_7$d || (templateObject_7$d = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-width: 0;\n  margin-left: ", "px;\n  font-size: ", ";\n  color: ", ";\n  line-height: 18px;\n  overflow: hidden;\n"], ["\n  display: flex;\n  flex-direction: column;\n  justify-content: center;\n  min-width: 0;\n  margin-left: ", "px;\n  font-size: ", ";\n  color: ", ";\n  line-height: 18px;\n  overflow: hidden;\n"])), function (props) { return props.theme.global.gutterSpace * 0.75; }, function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.colors.grey400; });
var InputFileContent = styled.div(templateObject_8$c || (templateObject_8$c = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n\n  ", " {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n\n  ", " {\n    flex-direction: column;\n    align-items: flex-start;\n  }\n"])), device.mobile);
var DragAndDropFileWrapper = styled.div(templateObject_9$7 || (templateObject_9$7 = __makeTemplateObject(["\n  width: 100%;\n  outline: none;\n\n  input[type='file'] {\n    display: none;\n  }\n\n  &:focus {\n    border-color: ", ";\n  }\n"], ["\n  width: 100%;\n  outline: none;\n\n  input[type='file'] {\n    display: none;\n  }\n\n  &:focus {\n    border-color: ", ";\n  }\n"])), function (props) { return props.theme.colors.grey100; });
var DragAndDropIconContainer = styled.div(templateObject_10$5 || (templateObject_10$5 = __makeTemplateObject(["\n  margin-bottom: ", "px;\n"], ["\n  margin-bottom: ", "px;\n"])), function (props) { return props.theme.global.gutterSpace; });
var DragAndDropFileLabel = styled.label(templateObject_14$1 || (templateObject_14$1 = __makeTemplateObject(["\n  display: ", ";\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  border: 2px dashed ", ";\n  border-radius: ", "px;\n  cursor: pointer;\n  transition: background-color 250ms ease-out;\n  background-color: ", ";\n\n  :hover {\n    ", " {\n      .arrow {\n        animation: ", " 1.2s 0.5s infinite;\n      }\n      .file {\n        animation: ", " 3s 0.5s infinite;\n      }\n      .folder {\n        transform-origin: 100% 0;\n        animation: ", " 3s 1s infinite;\n      }\n    }\n  }\n\n  ", "\n\n  ", ";\n\n  ", "\n"], ["\n  display: ", ";\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  width: 100%;\n  height: 100%;\n  border: 2px dashed ", ";\n  border-radius: ", "px;\n  cursor: pointer;\n  transition: background-color 250ms ease-out;\n  background-color: ", ";\n\n  :hover {\n    ", " {\n      .arrow {\n        animation: ", " 1.2s 0.5s infinite;\n      }\n      .file {\n        animation: ", " 3s 0.5s infinite;\n      }\n      .folder {\n        transform-origin: 100% 0;\n        animation: ", " 3s 1s infinite;\n      }\n    }\n  }\n\n  ",
    "\n\n  ",
    ";\n\n  ",
    "\n"])), function (props) { return (props.showFileProgress ? 'none' : 'flex'); }, function (props) { return (props.colorBorder ? props.colorBorder : props.theme.colors.purple400); }, function (props) { return props.theme.forms.borderRadius; }, function (props) { return props.background; }, DragAndDropIconContainer, moveUp, fileToCloud, folderToCloud, function (props) {
    return !props.disabled && css(templateObject_11$4 || (templateObject_11$4 = __makeTemplateObject(["\n      &:hover {\n        background-color: ", ";\n        border-color: ", ";\n        svg path {\n          fill: ", ";\n        }\n      }\n    "], ["\n      &:hover {\n        background-color: ", ";\n        border-color: ", ";\n        svg path {\n          fill: ", ";\n        }\n      }\n    "])), props.backgroundHover ? props.backgroundHover : props.theme.colors.purple100, props.hoverBorderColor, props.fillHover);
}, function (props) {
    return props.isDragging && css(templateObject_12$3 || (templateObject_12$3 = __makeTemplateObject(["\n      background-color: ", ";\n      border-color: ", ";\n    "], ["\n      background-color: ", ";\n      border-color: ", ";\n    "])), props.theme.colors.purple100, props.theme.colors.purple600);
}, function (props) {
    return props.disabled && css(templateObject_13$2 || (templateObject_13$2 = __makeTemplateObject(["\n      background-color: ", ";\n      border: 2px solid ", ";\n      cursor: not-allowed;\n      color: ", ";\n\n      svg {\n        fill: ", ";\n      }\n    "], ["\n      background-color: ", ";\n      border: 2px solid ", ";\n      cursor: not-allowed;\n      color: ", ";\n\n      svg {\n        fill: ", ";\n      }\n    "])), props.theme.colors.grey100, props.theme.colors.grey100, props.theme.colors.grey400, props.theme.colors.grey400);
});
var DragAndDropTitleMessage = styled.div(templateObject_16$1 || (templateObject_16$1 = __makeTemplateObject(["\n  margin-bottom: ", "px;\n  color: ", ";\n  line-height: 18px;\n  font-size: ", ";\n  font-weight: 600;\n  text-align: center;\n\n  ", "\n"], ["\n  margin-bottom: ", "px;\n  color: ", ";\n  line-height: 18px;\n  font-size: ", ";\n  font-weight: 600;\n  text-align: center;\n\n  ",
    "\n"])), function (props) { return props.theme.global.gutterSpace / 4; }, function (props) { return props.theme.colors.grey700; }, function (props) { return props.theme.fontSizes[2]; }, function (props) {
    return props.disabled && css(templateObject_15$1 || (templateObject_15$1 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), props.theme.colors.grey400);
});
var DragAndDropSubTitleMessage = styled.div(templateObject_18 || (templateObject_18 = __makeTemplateObject(["\n  margin-bottom: ", "px;\n  color: ", ";\n  line-height: 18px;\n  font-size: ", ";\n\n  ", "\n"], ["\n  margin-bottom: ", "px;\n  color: ", ";\n  line-height: 18px;\n  font-size: ", ";\n\n  ",
    "\n"])), function (props) { return props.theme.global.gutterSpace / 4; }, function (props) { return props.theme.colors.grey700; }, function (props) { return props.theme.fontSizes[1]; }, function (props) {
    return props.disabled && css(templateObject_17$1 || (templateObject_17$1 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), props.theme.colors.grey400);
});
var DragAndDropLink = styled.span(templateObject_20 || (templateObject_20 = __makeTemplateObject(["\n  font-size: ", ";\n  color: ", ";\n  text-decoration: underline;\n\n  ", "\n"], ["\n  font-size: ", ";\n  color: ", ";\n  text-decoration: underline;\n\n  ",
    "\n"])), function (props) { return props.theme.fontSizes[1]; }, function (props) { return props.theme.colors.purple600; }, function (props) {
    return props.disabled && css(templateObject_19 || (templateObject_19 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), props.theme.colors.grey400);
});
var DragAndDropLabelContainer = styled.div(templateObject_21 || (templateObject_21 = __makeTemplateObject(["\n  margin-bottom: ", "px;\n"], ["\n  margin-bottom: ", "px;\n"])), function (props) { return props.theme.global.gutterSpace * 0.75; });
var DragAndDropLabel = styled.label(templateObject_22 || (templateObject_22 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  font-size: ", ";\n  font-weight: 600;\n  line-height: 18px;\n  color: ", ";\n\n  svg:first-child {\n    margin-right: ", "px;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  font-size: ", ";\n  font-weight: 600;\n  line-height: 18px;\n  color: ", ";\n\n  svg:first-child {\n    margin-right: ", "px;\n  }\n"])), function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.colors.grey700; }, function (props) { return props.theme.global.gutterSpace / 2; });
var DragAndDropInputError = styled.div(templateObject_24 || (templateObject_24 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: ", ";\n  color: ", ";\n  line-height: 18px;\n\n  ", " {\n    flex-direction: column;\n  }\n\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: ", ";\n  color: ", ";\n  line-height: 18px;\n\n  ", " {\n    flex-direction: column;\n  }\n\n  ",
    "\n"])), function (props) { return props.theme.fontSizes[1]; }, function (props) { return props.theme.colors.grey400; }, device.mobile, function (props) {
    return props.error && css(templateObject_23 || (templateObject_23 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), props.theme.colors.red700);
});
var DragAndDropInfoContainer = styled.div(templateObject_27 || (templateObject_27 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding: ", "px;\n  opacity: 1;\n  transition: opacity 150ms ease-in-out;\n\n  ", "\n\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  padding: ", "px;\n  opacity: 1;\n  transition: opacity 150ms ease-in-out;\n\n  ",
    "\n\n  ",
    "\n"])), function (props) { return props.theme.global.gutterSpace * 2; }, function (props) {
    return !props.isHorizontal && css(templateObject_25 || (templateObject_25 = __makeTemplateObject(["\n      flex-direction: column;\n    "], ["\n      flex-direction: column;\n    "])));
}, function (props) {
    return props.isLoading && css(templateObject_26 || (templateObject_26 = __makeTemplateObject(["\n      opacity: 0;\n    "], ["\n      opacity: 0;\n    "])));
});
var DragAndDropInputFileContainer = styled.div(templateObject_28 || (templateObject_28 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var DragAndDropLoadingContainer = styled.div(templateObject_32 || (templateObject_32 = __makeTemplateObject(["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 50%;\n\n  ", "\n\n  ", "\n"], ["\n  position: absolute;\n  width: 100%;\n  height: 100%;\n  top: 50%;\n\n  ",
    "\n\n  ",
    "\n"])), function (props) {
    return props.isProgress && css(templateObject_30 || (templateObject_30 = __makeTemplateObject(["\n      ", "\n      transform: translateX(25%);\n    "], ["\n      ",
        "\n      transform: translateX(25%);\n    "])), !props.hasLoadingProgress && css(templateObject_29 || (templateObject_29 = __makeTemplateObject(["\n        top: calc(50% - 19px);\n      "], ["\n        top: calc(50% - 19px);\n      "]))));
}, function (props) {
    return props.hasLoadingProgress && css(templateObject_31 || (templateObject_31 = __makeTemplateObject(["\n      top: 35%;\n    "], ["\n      top: 35%;\n    "])));
});
var DragAndDropInputFileSelectedContent = styled.div(templateObject_34 || (templateObject_34 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  width: 100%;\n  padding: ", "px;\n  font-size: ", ";\n  color: ", ";\n  line-height: 18px;\n  opacity: 1;\n  transition: opacity 150ms ease-in-out;\n  max-height: 300px;\n  overflow: auto;\n\n  ", "\n"], ["\n  position: relative;\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  width: 100%;\n  padding: ", "px;\n  font-size: ", ";\n  color: ", ";\n  line-height: 18px;\n  opacity: 1;\n  transition: opacity 150ms ease-in-out;\n  max-height: 300px;\n  overflow: auto;\n\n  ",
    "\n"])), function (props) { return props.theme.global.gutterSpace; }, function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.colors.grey400; }, function (props) {
    return props.isLoading && css(templateObject_33 || (templateObject_33 = __makeTemplateObject(["\n      opacity: 0;\n    "], ["\n      opacity: 0;\n    "])));
});
var DragAndDropFileButtonClear = styled(FabButton)(templateObject_36 || (templateObject_36 = __makeTemplateObject(["\n  opacity: 0;\n  position: absolute;\n  top: -4px;\n  right: -4px;\n  padding: 0;\n  background-color: ", ";\n  border-radius: 50%;\n  transition: opacity 250ms, box-shadow 250ms ease-out;\n\n  &:hover {\n    box-shadow: 0px 0px 2px 0px ", ";\n  }\n\n  ", "\n"], ["\n  opacity: 0;\n  position: absolute;\n  top: -4px;\n  right: -4px;\n  padding: 0;\n  background-color: ", ";\n  border-radius: 50%;\n  transition: opacity 250ms, box-shadow 250ms ease-out;\n\n  &:hover {\n    box-shadow: 0px 0px 2px 0px ", ";\n  }\n\n  ",
    "\n"])), function (props) { return props.theme.colors.grey100; }, function (props) { return rgba(props.theme.colors.grey700, 0.4); }, function (props) {
    return props.disabled && css(templateObject_35 || (templateObject_35 = __makeTemplateObject(["\n      display: none;\n    "], ["\n      display: none;\n    "])));
});
var DragAndDropUploadedFile = styled.div(templateObject_37 || (templateObject_37 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  min-width: 110px;\n  height: 80px;\n  margin: 14px;\n  line-height: 18px;\n  font-weight: 800;\n  border-radius: ", "px;\n  background-color: ", ";\n  color: ", ";\n  text-transform: uppercase;\n  font-size: ", ";\n  cursor: default;\n\n  span {\n    color: ", ";\n    padding-top: ", "px;\n  }\n\n  &:hover {\n    ", " {\n      opacity: 1;\n    }\n  }\n"], ["\n  position: relative;\n  display: flex;\n  justify-content: center;\n  min-width: 110px;\n  height: 80px;\n  margin: 14px;\n  line-height: 18px;\n  font-weight: 800;\n  border-radius: ", "px;\n  background-color: ", ";\n  color: ", ";\n  text-transform: uppercase;\n  font-size: ", ";\n  cursor: default;\n\n  span {\n    color: ", ";\n    padding-top: ", "px;\n  }\n\n  &:hover {\n    ", " {\n      opacity: 1;\n    }\n  }\n"])), function (props) { return props.theme.forms.borderRadius; }, function (props) { return props.theme.colors.grey200; }, function (props) { return props.theme.colors.grey400; }, function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.colors.grey700; }, function (props) { return props.theme.global.gutterSpace; }, DragAndDropFileButtonClear);
var DragAndDropFileName = styled.div(templateObject_38 || (templateObject_38 = __makeTemplateObject(["\n  position: absolute;\n  top: 50%;\n  max-width: 85px;\n  padding: 0 ", "px;\n  background-color: ", ";\n  color: ", ";\n  font-size: ", ";\n  border-radius: ", "px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: center;\n  z-index: 2;\n  transition: max-width 200ms, overflow 200ms, text-overflow 200ms ease;\n\n  &:hover {\n    max-width: fit-content;\n    overflow: inherit;\n    text-overflow: inherit;\n  }\n"], ["\n  position: absolute;\n  top: 50%;\n  max-width: 85px;\n  padding: 0 ", "px;\n  background-color: ", ";\n  color: ", ";\n  font-size: ", ";\n  border-radius: ", "px;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n  text-align: center;\n  z-index: 2;\n  transition: max-width 200ms, overflow 200ms, text-overflow 200ms ease;\n\n  &:hover {\n    max-width: fit-content;\n    overflow: inherit;\n    text-overflow: inherit;\n  }\n"])), function (props) { return props.theme.global.gutterSpace / 4; }, function (props) { return props.theme.colors.grey100; }, function (props) { return props.theme.colors.grey700; }, function (props) { return props.theme.fontSizes[0]; }, function (props) { return props.theme.forms.borderRadius / 2; });
var LoadingHeight = '16px';
var ContainerBasicLoading = styled.div(templateObject_39 || (templateObject_39 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  width: 100%;\n  height: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  position: relative;\n  width: 100%;\n  height: ", ";\n"])), LoadingHeight);
var LoadingTitle = styled.span(templateObject_40 || (templateObject_40 = __makeTemplateObject(["\n  font-size: ", ";\n  color: ", ";\n  margin-bottom: ", "px;\n"], ["\n  font-size: ", ";\n  color: ", ";\n  margin-bottom: ", "px;\n"])), function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.colors.grey400; }, function (props) { return props.theme.global.gutterSpace * 0.75; });
var Slider$2 = styled.div(templateObject_41 || (templateObject_41 = __makeTemplateObject(["\n  position: absolute;\n  width: 50%;\n  height: ", ";\n  overflow-x: hidden;\n  background-color: ", ";\n  border-radius: ", "px;\n"], ["\n  position: absolute;\n  width: 50%;\n  height: ", ";\n  overflow-x: hidden;\n  background-color: ", ";\n  border-radius: ", "px;\n"])), LoadingHeight, function (props) { return props.theme.colors.grey100; }, function (props) { return props.theme.forms.borderRadius; });
var Line = styled.div(templateObject_42 || (templateObject_42 = __makeTemplateObject(["\n  position: absolute;\n  background-color: ", ";\n  width: 150%;\n  height: ", ";\n  border-radius: ", "px;\n"], ["\n  position: absolute;\n  background-color: ", ";\n  width: 150%;\n  height: ", ";\n  border-radius: ", "px;\n"])), function (props) { return props.theme.colors.grey200; }, LoadingHeight, function (props) { return props.theme.forms.borderRadius; });
var SubLine = styled.div(templateObject_45 || (templateObject_45 = __makeTemplateObject(["\n  position: absolute;\n  background-color: ", ";\n  height: ", ";\n  border-radius: ", "px;\n\n  ", "\n\n  ", "\n"], ["\n  position: absolute;\n  background-color: ", ";\n  height: ", ";\n  border-radius: ", "px;\n\n  ",
    "\n\n  ",
    "\n"])), function (props) { return props.theme.colors.green400; }, LoadingHeight, function (props) { return props.theme.forms.borderRadius; }, function (props) {
    return props.direction === 'increase' && css(templateObject_43 || (templateObject_43 = __makeTemplateObject(["\n      animation: ", " 2s infinite;\n    "], ["\n      animation: ", " 2s infinite;\n    "])), increaseSizeFromLeft);
}, function (props) {
    return props.direction === 'decrease' && css(templateObject_44 || (templateObject_44 = __makeTemplateObject(["\n      animation: ", " 2s 0.5s infinite;\n    "], ["\n      animation: ", " 2s 0.5s infinite;\n    "])), increaseSizeToRight);
});
var ProgressBarContainer = styled.div(templateObject_46 || (templateObject_46 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var ProgressBar$1 = styled.div(templateObject_47 || (templateObject_47 = __makeTemplateObject(["\n  width: 50%;\n  background-color: ", ";\n  border-radius: ", "px;\n  line-height: 18px;\n"], ["\n  width: 50%;\n  background-color: ", ";\n  border-radius: ", "px;\n  line-height: 18px;\n"])), function (props) { return props.theme.colors.grey200; }, function (props) { return props.theme.forms.borderRadius * 2; });
var Percent$1 = styled.div(templateObject_50 || (templateObject_50 = __makeTemplateObject(["\n  height: ", ";\n  border-radius: ", "px;\n\n  ", "\n\n  ", "\n"], ["\n  height: ", ";\n  border-radius: ", "px;\n\n  ",
    "\n\n  ",
    "\n"])), LoadingHeight, function (props) { return props.theme.forms.borderRadius; }, function (props) {
    return props.loadingProgress > 0 && css(templateObject_48 || (templateObject_48 = __makeTemplateObject(["\n      transition: width 300ms linear;\n    "], ["\n      transition: width 300ms linear;\n    "])));
}, function (props) {
    return props.loadingProgressError && css(templateObject_49 || (templateObject_49 = __makeTemplateObject(["\n      background-color: ", ";\n    "], ["\n      background-color: ", ";\n    "])), props.theme.colors.red100);
});
var PercentValue$1 = styled.div(templateObject_51 || (templateObject_51 = __makeTemplateObject(["\n  width: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  span {\n    font-size: ", ";\n    color: ", ";\n    margin-top: ", "px;\n  }\n"], ["\n  width: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  span {\n    font-size: ", ";\n    color: ", ";\n    margin-top: ", "px;\n  }\n"])), function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.colors.grey400; }, function (props) { return props.theme.global.gutterSpace / 2; });
var LoadingTitleContainer = styled.div(templateObject_52 || (templateObject_52 = __makeTemplateObject(["\n  width: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  width: 50%;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var FileName = styled.div(templateObject_53 || (templateObject_53 = __makeTemplateObject(["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"], ["\n  overflow: hidden;\n  text-overflow: ellipsis;\n  white-space: nowrap;\n"])));
var ContainerLoadExtract = styled.div(templateObject_54 || (templateObject_54 = __makeTemplateObject(["\n  background: rgba(248, 248, 249, 1);\n  padding: 16px;\n  border-radius: 8px;\n  display: ", ";\n  gap: 12px;\n  align-items: center;\n"], ["\n  background: rgba(248, 248, 249, 1);\n  padding: 16px;\n  border-radius: 8px;\n  display: ", ";\n  gap: 12px;\n  align-items: center;\n"])), function (props) { return (props.hasFile ? 'flex' : 'none'); });
var ClearBtn = styled.button(templateObject_55 || (templateObject_55 = __makeTemplateObject(["\n  padding: 0;\n  margin: 0;\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  background-color: rgba(255, 255, 255, 1);\n  border: 1px solid rgba(235, 233, 237, 1);\n  box-shadow: 0 1px 2px rgba(239, 238, 242, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"], ["\n  padding: 0;\n  margin: 0;\n  width: 36px;\n  height: 36px;\n  border-radius: 8px;\n  background-color: rgba(255, 255, 255, 1);\n  border: 1px solid rgba(235, 233, 237, 1);\n  box-shadow: 0 1px 2px rgba(239, 238, 242, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n"])));
var animLoadingProgress = keyframes(templateObject_56 || (templateObject_56 = __makeTemplateObject(["\n  0% {\n    display: flex;\n    opacity: 1;\n  }\n\n  80% {\n    opacity: 0;\n  }\n  100% {\n    display: none;\n    opacity: 0;\n  }\n"], ["\n  0% {\n    display: flex;\n    opacity: 1;\n  }\n\n  80% {\n    opacity: 0;\n  }\n  100% {\n    display: none;\n    opacity: 0;\n  }\n"])));
var LoadingContainer = styled.div(templateObject_57 || (templateObject_57 = __makeTemplateObject(["\n  height: 4px;\n  border-radius: 2px;\n  background-color: rgba(235, 233, 237, 1);\n  overflow: hidden;\n\n  animation: ", " 0.5s ease-in-out 2s forwards;\n"], ["\n  height: 4px;\n  border-radius: 2px;\n  background-color: rgba(235, 233, 237, 1);\n  overflow: hidden;\n\n  animation: ", " 0.5s ease-in-out 2s forwards;\n"])), function (props) { return (props.progressFile ? animLoadingProgress : ''); });
var LoadingProgress = styled.div(templateObject_58 || (templateObject_58 = __makeTemplateObject(["\n  background-color: rgba(116, 74, 181, 1);\n  height: 4px;\n  width: ", "%;\n  border-radius: 2px;\n  transition: width 500ms linear;\n  transition-delay: 200ms;\n"], ["\n  background-color: rgba(116, 74, 181, 1);\n  height: 4px;\n  width: ", "%;\n  border-radius: 2px;\n  transition: width 500ms linear;\n  transition-delay: 200ms;\n"])), function (props) { return (props.progressFile ? props.progressFile : 0); });
var animSizeFile = keyframes(templateObject_59 || (templateObject_59 = __makeTemplateObject(["\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"], ["\n  0% {\n    opacity: 0;\n  }\n  100% {\n    opacity: 1;\n  }\n"])));
var SizeFile = styled.span(templateObject_60 || (templateObject_60 = __makeTemplateObject(["\n  position: absolute;\n  bottom: 0;\n  font-family: 'Inter';\n  color: rgba(115, 110, 122, 1);\n  font-size: 14px;\n  margin-top: 4px;\n  opacity: 0;\n\n  animation: ", " 0.5s ease-in-out 2s forwards;\n"], ["\n  position: absolute;\n  bottom: 0;\n  font-family: 'Inter';\n  color: rgba(115, 110, 122, 1);\n  font-size: 14px;\n  margin-top: 4px;\n  opacity: 0;\n\n  animation: ", " 0.5s ease-in-out 2s forwards;\n"])), function (props) { return (props.progressFile ? animSizeFile : ''); });
var templateObject_1$l, templateObject_2$i, templateObject_3$i, templateObject_4$g, templateObject_5$d, templateObject_6$d, templateObject_7$d, templateObject_8$c, templateObject_9$7, templateObject_10$5, templateObject_11$4, templateObject_12$3, templateObject_13$2, templateObject_14$1, templateObject_15$1, templateObject_16$1, templateObject_17$1, templateObject_18, templateObject_19, templateObject_20, templateObject_21, templateObject_22, templateObject_23, templateObject_24, templateObject_25, templateObject_26, templateObject_27, templateObject_28, templateObject_29, templateObject_30, templateObject_31, templateObject_32, templateObject_33, templateObject_34, templateObject_35, templateObject_36, templateObject_37, templateObject_38, templateObject_39, templateObject_40, templateObject_41, templateObject_42, templateObject_43, templateObject_44, templateObject_45, templateObject_46, templateObject_47, templateObject_48, templateObject_49, templateObject_50, templateObject_51, templateObject_52, templateObject_53, templateObject_54, templateObject_55, templateObject_56, templateObject_57, templateObject_58, templateObject_59, templateObject_60;

var IconPaperClip = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path  d=\"M18.08,12.42,11.9,18.61a4.25,4.25,0,0,1-6-6l8-8a2.57,2.57,0,0,1,3.54,0,2.52,2.52,0,0,1,0,3.54l-6.9,6.89A.75.75,0,1,1,9.42,14l5.13-5.12a1,1,0,0,0-1.42-1.42L8,12.6a2.74,2.74,0,0,0,0,3.89,2.82,2.82,0,0,0,3.89,0l6.89-6.9a4.5,4.5,0,0,0-6.36-6.36l-8,8A6.25,6.25,0,0,0,13.31,20l6.19-6.18a1,1,0,1,0-1.42-1.42Z\"/></svg>";

var File$1 = function (props, ref) {
    var testId = props.testId, acceptedFilesTypes = props.acceptedFilesTypes, name = props.name, placeholder = props.placeholder, onChange = props.onChange, loading = props.loading, multiple = props.multiple, disabled = props.disabled, onDragging = props.onDragging, error = props.error, label = props.label, required = props.required, optional = props.optional, className = props.className, textHelper = props.textHelper, iconTooltip = props.iconTooltip, textTooltip = props.textTooltip, labelExtension = props.labelExtension, showSelectedFiles = props.showSelectedFiles;
    var _a = useState([]), files = _a[0], setFiles = _a[1];
    var _b = useState(true), isFileAllowed = _b[0], setIsFileAllowed = _b[1];
    var inputFileRef = useRef(null);
    var onDrop = useCallback(function (acceptedFiles) {
        setFiles(acceptedFiles);
        if (onChange) {
            onChange(acceptedFiles);
        }
    }, []);
    var onDrag = function (enter) { return function () {
        if (onDragging) {
            onDragging(enter);
        }
    }; };
    var onDropValidation = function (isValid) { return function () { return setIsFileAllowed(isValid); }; };
    var handleClear = function (event) {
        if (event) {
            event.stopPropagation();
        }
        setIsFileAllowed(true);
        setFiles([]);
        if (onChange) {
            onChange(undefined);
        }
        inputFileRef.current.value = '';
    };
    useImperativeHandle(ref, function () { return ({
        clear: function () { return handleClear(); },
    }); }, [ref]);
    var DropZoneDefaultProps = {
        onDrop: onDrop,
        multiple: multiple || false,
        onDragEnter: onDrag(true),
        onDragLeave: onDrag(false),
        onDropAccepted: onDropValidation(true),
        onDropRejected: onDropValidation(false),
        disabled: disabled,
    };
    var _c = useDropzone(acceptedFilesTypes ? __assign$2(__assign$2({}, DropZoneDefaultProps), { accept: acceptedFilesTypes }) : __assign$2({}, DropZoneDefaultProps)), getRootProps = _c.getRootProps, getInputProps = _c.getInputProps;
    var InputFileSelected = files && files.length > 0 ? (React__default.createElement(InputFileSelectedContainer, null,
        React__default.createElement(FabButton, { testId: "remove-file", onClick: handleClear, iconPath: IconClose$1, size: "small", tooltipTitle: "Remover anexo", disabled: disabled || loading }),
        showSelectedFiles && (React__default.createElement(InputFileSelectedContent, null, files.map(function (file, index) { return (React__default.createElement(FileName, { key: file.name + index, "data-testid": "name" }, file.name)); }))))) : (React__default.createElement(InputFileEmpty, { "data-testid": "name" }, "Nenhum arquivo selecionado."));
    var InputFile = (React__default.createElement(FileLabel, { disabled: disabled || loading, htmlFor: name },
        React__default.createElement(SvgIcon, { src: IconPaperClip, width: 20, height: 20, fill: "grey700" }),
        placeholder || 'Escolha arquivo',
        React__default.createElement("input", __assign$2({ "data-testid": testId }, getInputProps(), { type: "file", name: name, id: name, ref: inputFileRef, disabled: disabled || loading, required: required }))));
    var InputLabel = (React__default.createElement(React__default.Fragment, null, label && (React__default.createElement(StyledLabel, { htmlFor: name, error: error, optional: optional, disabled: disabled || loading },
        label,
        iconTooltip && textTooltip && (React__default.createElement(AgilizeTooltip, { title: textTooltip },
            React__default.createElement(StyledIconInputContainer, null, iconTooltip)))))));
    var InputErrorText = (React__default.createElement(React__default.Fragment, null,
        !error && (React__default.createElement(StyledHelperInput, { error: !isFileAllowed }, labelExtension || (React__default.createElement(React__default.Fragment, null,
            "Formatos v\u00E1lidos: ",
            React__default.createElement("strong", null, acceptedFilesTypes || 'pdf, xml'))))),
        error && (React__default.createElement(StyledHelperInput, { error: !!error, "data-testid": "external-error" }, error || textHelper))));
    return (React__default.createElement("div", { className: className },
        React__default.createElement(FileWrapper, __assign$2({}, getRootProps()),
            InputLabel,
            React__default.createElement(InputFileContent, null,
                InputFile,
                InputFileSelected)),
        InputErrorText));
};
var InputFile = forwardRef(File$1);

var IconUpload = "<svg width=\"80\" height=\"81\" viewBox=\"0 0 80 81\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n  <path d=\"M40 80.8984C62.0914 80.8984 80 62.9898 80 40.8984C80 18.807 62.0914 0.898438 40 0.898438C17.9086 0.898438 0 18.807 0 40.8984C0 62.9898 17.9086 80.8984 40 80.8984Z\" fill=\"#FBF8FF\"/>\n  <path d=\"M40 74.7969C46.6274 74.7969 52 74.1253 52 73.2969C52 72.4684 46.6274 71.7969 40 71.7969C33.3726 71.7969 28 72.4684 28 73.2969C28 74.1253 33.3726 74.7969 40 74.7969Z\" fill=\"#FBF8FF\"/>\n  \n  <g class=\"folder\">\n    <path d=\"M62.253 65.6437C62.1921 65.87 62.0438 66.063 61.8408 66.1802C61.6377 66.2973 61.3965 66.3292 61.17 66.2687L46.653 62.3787C46.5408 62.3487 46.4355 62.2969 46.3434 62.2263C46.2512 62.1556 46.1738 62.0675 46.1158 61.9669C46.0577 61.8662 46.0201 61.7552 46.005 61.64C45.99 61.5248 45.9978 61.4078 46.028 61.2957L49 50.1987C49.03 50.0865 49.0819 49.9814 49.1526 49.8892C49.2233 49.7971 49.3114 49.7198 49.412 49.6618C49.5126 49.6038 49.6236 49.5661 49.7387 49.551C49.8539 49.5359 49.9708 49.5436 50.083 49.5737L52.645 50.2597L53.895 52.4257L64.143 55.1707C64.3692 55.2318 64.562 55.3801 64.6791 55.5831C64.7963 55.7861 64.8282 56.0272 64.768 56.2537L62.253 65.6437Z\" fill=\"white\"/>\n    <path d=\"M62.253 65.6437C62.1921 65.87 62.0438 66.063 61.8408 66.1802C61.6377 66.2973 61.3965 66.3292 61.17 66.2687L46.653 62.3787C46.5408 62.3487 46.4355 62.2969 46.3434 62.2263C46.2512 62.1556 46.1738 62.0675 46.1158 61.9669C46.0577 61.8662 46.0201 61.7552 46.005 61.64C45.99 61.5248 45.9978 61.4078 46.028 61.2957L49 50.1987C49.03 50.0865 49.0819 49.9814 49.1526 49.8892C49.2233 49.7971 49.3114 49.7198 49.412 49.6618C49.5126 49.6038 49.6236 49.5661 49.7387 49.551C49.8539 49.5359 49.9708 49.5436 50.083 49.5737L52.645 50.2597L53.895 52.4257L64.143 55.1707C64.3692 55.2318 64.562 55.3801 64.6791 55.5831C64.7963 55.7861 64.8282 56.0272 64.768 56.2537L62.253 65.6437Z\" stroke=\"#7A4DBF\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  </g>\n  \n  <g class=\"file\">\n    <path d=\"M33.785 63.1159C33.8161 63.2319 33.8241 63.353 33.8084 63.4722C33.7928 63.5914 33.7538 63.7063 33.6937 63.8104C33.6336 63.9145 33.5536 64.0057 33.4583 64.0789C33.3629 64.1521 33.2541 64.2058 33.138 64.2369L21.259 67.4198C21.1429 67.451 21.0218 67.459 20.9026 67.4433C20.7834 67.4277 20.6685 67.3887 20.5644 67.3286C20.4603 67.2685 20.3691 67.1885 20.2959 67.0932C20.2227 66.9978 20.1691 66.889 20.138 66.7729L16.345 52.6199C16.2823 52.3851 16.3154 52.1352 16.4369 51.9248C16.5584 51.7145 16.7584 51.5609 16.993 51.4979L25.207 49.2979L30.975 52.6279L33.785 63.1159Z\" fill=\"white\" stroke=\"#7A4DBF\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n    <path d=\"M25.207 49.2969L26.426 53.8459L30.975 52.6269L25.207 49.2969Z\" fill=\"white\" stroke=\"#7A4DBF\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  </g>\n\n  <path d=\"M59.732 26.1305C60.0725 24.7396 59.9727 23.2774 59.4463 21.9457C58.92 20.614 57.9931 19.4786 56.7938 18.6964C55.5944 17.9141 54.1817 17.5236 52.7508 17.5788C51.32 17.634 49.9416 18.1322 48.806 19.0045C46.9656 16.8343 44.5032 15.2817 41.7517 14.5564C39.0002 13.8312 36.0924 13.9684 33.4214 14.9494C30.7504 15.9305 28.4451 17.7081 26.8171 20.0419C25.1892 22.3756 24.3172 25.153 24.319 27.9985C24.319 28.0285 24.319 28.0575 24.319 28.0865C24.0315 28.0385 23.7413 28.0091 23.45 27.9985C21.6067 27.9985 19.839 28.7307 18.5356 30.0341C17.2322 31.3375 16.5 33.1052 16.5 34.9485C16.5 36.7917 17.2322 38.5595 18.5356 39.8629C19.839 41.1662 21.6067 41.8985 23.45 41.8985H54.725C56.569 41.9011 58.3659 41.3161 59.8549 40.2283C61.3439 39.1405 62.4476 37.6065 63.0057 35.849C63.5638 34.0914 63.5473 32.2017 62.9586 30.4542C62.37 28.7066 61.2398 27.1921 59.732 26.1305Z\" fill=\"white\"/>\n  <path d=\"M59.732 26.1305C60.0725 24.7396 59.9727 23.2774 59.4463 21.9457C58.92 20.614 57.9931 19.4786 56.7938 18.6964C55.5944 17.9141 54.1817 17.5236 52.7508 17.5788C51.32 17.634 49.9416 18.1322 48.806 19.0045C46.9656 16.8343 44.5032 15.2817 41.7517 14.5564C39.0002 13.8312 36.0924 13.9684 33.4214 14.9494C30.7504 15.9305 28.4451 17.7081 26.8171 20.0419C25.1892 22.3756 24.3172 25.153 24.319 27.9985C24.319 28.0285 24.319 28.0575 24.319 28.0865C24.0315 28.0385 23.7413 28.0091 23.45 27.9985C21.6067 27.9985 19.839 28.7307 18.5356 30.0341C17.2322 31.3375 16.5 33.1052 16.5 34.9485C16.5 36.7917 17.2322 38.5595 18.5356 39.8629C19.839 41.1662 21.6067 41.8985 23.45 41.8985H54.725C56.569 41.9011 58.3659 41.3161 59.8549 40.2283C61.3439 39.1405 62.4476 37.6065 63.0057 35.849C63.5638 34.0914 63.5473 32.2017 62.9586 30.4542C62.37 28.7066 61.2398 27.1921 59.732 26.1305V26.1305Z\" stroke=\"#7A4DBF\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n  \n  <g class=\"arrow\">\n    <path d=\"M48.3267 36.3125C48.1409 36.4983 47.9204 36.6457 47.6777 36.7463C47.435 36.8468 47.1749 36.8986 46.9122 36.8986C46.6495 36.8986 46.3893 36.8468 46.1466 36.7463C45.9039 36.6457 45.6834 36.4983 45.4977 36.3125L42.4127 33.2265V51.3985C42.4127 52.0616 42.1493 52.6974 41.6804 53.1663C41.2116 53.6351 40.5757 53.8985 39.9127 53.8985C39.2496 53.8985 38.6137 53.6351 38.1449 53.1663C37.6761 52.6974 37.4127 52.0616 37.4127 51.3985V33.2265L34.3267 36.3125C34.1428 36.506 33.922 36.6607 33.6773 36.7676C33.4327 36.8744 33.1691 36.9312 32.9022 36.9346C32.6353 36.9379 32.3704 36.8878 32.1231 36.7872C31.8758 36.6866 31.6512 36.5375 31.4625 36.3487C31.2738 36.1599 31.1247 35.9352 31.0242 35.6879C30.9237 35.4406 30.8737 35.1757 30.8771 34.9088C30.8806 34.6418 30.9375 34.3783 31.0444 34.1337C31.1513 33.8891 31.3061 33.6683 31.4997 33.4845L38.4997 26.4845C38.6854 26.2987 38.9059 26.1513 39.1486 26.0508C39.3913 25.9502 39.6515 25.8984 39.9142 25.8984C40.1769 25.8984 40.437 25.9502 40.6797 26.0508C40.9224 26.1513 41.1429 26.2987 41.3287 26.4845L48.3287 33.4845C48.7033 33.8598 48.9136 34.3686 48.9132 34.8989C48.9129 35.4293 48.7019 35.9377 48.3267 36.3125Z\" fill=\"#FBF8FF\"/>\n    <path d=\"M48.3267 36.3125C48.1409 36.4983 47.9204 36.6457 47.6777 36.7463C47.435 36.8468 47.1749 36.8986 46.9122 36.8986C46.6495 36.8986 46.3893 36.8468 46.1466 36.7463C45.9039 36.6457 45.6834 36.4983 45.4977 36.3125L42.4127 33.2265V51.3985C42.4127 52.0616 42.1493 52.6974 41.6804 53.1663C41.2116 53.6351 40.5757 53.8985 39.9127 53.8985C39.2496 53.8985 38.6137 53.6351 38.1449 53.1663C37.6761 52.6974 37.4127 52.0616 37.4127 51.3985V33.2265L34.3267 36.3125C34.1428 36.506 33.922 36.6607 33.6773 36.7676C33.4327 36.8744 33.1691 36.9312 32.9022 36.9346C32.6353 36.9379 32.3704 36.8878 32.1231 36.7872C31.8758 36.6866 31.6512 36.5375 31.4625 36.3487C31.2738 36.1599 31.1247 35.9352 31.0242 35.6879C30.9237 35.4406 30.8737 35.1757 30.8771 34.9088C30.8806 34.6418 30.9375 34.3783 31.0444 34.1337C31.1513 33.8891 31.3061 33.6683 31.4997 33.4845L38.4997 26.4845C38.6854 26.2987 38.9059 26.1513 39.1486 26.0508C39.3913 25.9502 39.6515 25.8984 39.9142 25.8984C40.1769 25.8984 40.437 25.9502 40.6797 26.0508C40.9224 26.1513 41.1429 26.2987 41.3287 26.4845L48.3287 33.4845C48.7033 33.8598 48.9136 34.3686 48.9132 34.8989C48.9129 35.4293 48.7019 35.9377 48.3267 36.3125Z\" stroke=\"#7A4DBF\" stroke-width=\"1.5\" stroke-linejoin=\"round\"/>\n  </g>\n</svg>";

var ExtractIcon = "<svg width=\"24\" height=\"24\" viewBox=\"0 0 24 24\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M21.75 21.75C21.75 22.1478 21.592 22.5294 21.3107 22.8107C21.0294 23.092 20.6478 23.25 20.25 23.25H3.75C3.35218 23.25 2.97064 23.092 2.68934 22.8107C2.40804 22.5294 2.25 22.1478 2.25 21.75V2.25C2.25 1.85218 2.40804 1.47064 2.68934 1.18934C2.97064 0.908035 3.35218 0.75 3.75 0.75H14.379C14.7765 0.750085 15.1578 0.907982 15.439 1.189L21.311 7.061C21.592 7.3422 21.7499 7.72345 21.75 8.121V21.75Z\" stroke=\"#434048\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M21.75 8.25H15.75C15.3522 8.25 14.9706 8.09197 14.6893 7.81066C14.408 7.52936 14.25 7.14782 14.25 6.75V0.75\" stroke=\"#434048\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M6.2 11.5941C6.41657 11.8786 6.69852 12.1066 7.02195 12.2589C7.34539 12.4112 7.70078 12.4833 8.058 12.4691C9.197 12.4691 10.121 11.7761 10.121 10.9221C10.121 10.0681 9.2 9.37612 8.062 9.37612C6.924 9.37612 6 8.68312 6 7.82812C6 6.97312 6.924 6.28112 8.062 6.28112C8.41926 6.26664 8.77473 6.33863 9.09821 6.49096C9.42169 6.6433 9.7036 6.87148 9.92 7.15612\" stroke=\"#434048\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M8.062 12.4692V13.5002\" stroke=\"#434048\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M8.062 5.25V6.281\" stroke=\"#434048\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M12 15H18\" stroke=\"#434048\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M6.75 19.5H18\" stroke=\"#434048\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n</svg>";

var CloseIcon = "<svg width=\"16\" height=\"16\" viewBox=\"0 0 16 16\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M3 13L13 3\" stroke=\"#434048\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M13 13L3 3\" stroke=\"#434048\" stroke-width=\"2\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n</svg>";

var TrashIcon = "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M0.833374 4.16699H19.1667\" stroke=\"#434048\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M11.875 0.833496H8.125C7.79348 0.833496 7.47554 0.965192 7.24112 1.19961C7.0067 1.43403 6.875 1.75198 6.875 2.0835V4.16683H13.125V2.0835C13.125 1.75198 12.9933 1.43403 12.7589 1.19961C12.5245 0.965192 12.2065 0.833496 11.875 0.833496Z\" stroke=\"#434048\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M8.125 14.792V8.54199\" stroke=\"#434048\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M11.875 14.792V8.54199\" stroke=\"#434048\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n<path d=\"M15.7167 18.017C15.6935 18.3302 15.5525 18.6229 15.3221 18.8363C15.0917 19.0497 14.789 19.1678 14.475 19.167H5.525C5.21097 19.1678 4.90828 19.0497 4.67789 18.8363C4.4475 18.6229 4.30652 18.3302 4.28333 18.017L3.125 4.16699H16.875L15.7167 18.017Z\" stroke=\"#434048\" stroke-width=\"1.5\" stroke-linecap=\"round\" stroke-linejoin=\"round\"/>\n</svg>";

var File = function (props, ref) {
    var _a, _b;
    var testId = props.testId, acceptedFilesTypes = props.acceptedFilesTypes, name = props.name, placeholder = props.placeholder, onChange = props.onChange, onError = props.onError, multiple = props.multiple, disabled = props.disabled, onDragging = props.onDragging, error = props.error, label = props.label, required = props.required, optional = props.optional, className = props.className, textHelper = props.textHelper, iconTooltip = props.iconTooltip, textTooltip = props.textTooltip, labelExtension = props.labelExtension, showSelectedFiles = props.showSelectedFiles, loading = props.loading, loadingProgress = props.loadingProgress, loadingProgressTitle = props.loadingProgressTitle, loadingProgressError = props.loadingProgressError, value = props.value, toggleClear = props.toggleClear, customIcon = props.customIcon, customIconWidth = props.customIconWidth, customIconHeight = props.customIconHeight, customText = props.customText, colorBorder = props.colorBorder, background = props.background, backgroundHover = props.backgroundHover, hoverBorderColor = props.hoverBorderColor, fillHover = props.fillHover, showFileProgress = props.showFileProgress;
    var _c = useState([]), files = _c[0], setFiles = _c[1];
    var _d = useState([]), tempfiles = _d[0], setTempFiles = _d[1];
    var _e = useState(true), isFileAllowed = _e[0], setIsFileAllowed = _e[1];
    var _f = useState(false), isDragging = _f[0], setIsDragging = _f[1];
    var inputFileRef = useRef(null);
    var _g = useState(false), hasFiles = _g[0], setHasFiles = _g[1];
    var _h = useState(false), showTrashBtn = _h[0], setShowTrashBtn = _h[1];
    var onDrop = useCallback(function (acceptedFiles) {
        if (!multiple) {
            if (onChange) {
                onChange(acceptedFiles);
            }
            setFiles(acceptedFiles);
            return setIsDragging(false);
        }
        setTempFiles(acceptedFiles);
        return setIsDragging(false);
    }, []);
    useEffect(function () {
        var newFiles = __spreadArrays(files, tempfiles);
        setFiles(newFiles);
        if (onChange) {
            onChange(newFiles);
        }
    }, [tempfiles]);
    var onDrag = function (enter) { return function () {
        setIsDragging(enter);
        if (onDragging) {
            onDragging(enter);
        }
    }; };
    var handleChangeError = function (isValid) {
        setIsFileAllowed(isValid);
        if (onError) {
            onError(!isValid);
        }
    };
    var onDropValidation = function (isValid) { return function () { return handleChangeError(isValid); }; };
    var handleClear = function (event) {
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }
        handleChangeError(true);
        setFiles([]);
        setHasFiles(false);
        setShowTrashBtn(false);
        if (onChange) {
            onChange(undefined);
        }
        inputFileRef.current.value = '';
    };
    useEffect(function () {
        handleClear();
    }, [toggleClear]);
    useEffect(function () {
        if ((files === null || files === void 0 ? void 0 : files.length) > 0) {
            setTimeout(function () {
                setHasFiles(true);
            }, 100);
            setTimeout(function () {
                setShowTrashBtn(true);
            }, 1000);
        }
    }, [files]);
    var handleRemoveFile = function (fileIndex) { return function (event) {
        if (event) {
            event.stopPropagation();
            event.preventDefault();
        }
        var removedFiles = files.filter(function (_, index) { return fileIndex !== index; });
        handleChangeError(true);
        setFiles(removedFiles);
        if (onChange) {
            onChange(removedFiles);
        }
        if (removedFiles.length <= 0) {
            inputFileRef.current.value = '';
        }
    }; };
    useImperativeHandle(ref, function () { return ({
        clear: function () { return handleClear(); },
    }); }, [ref]);
    var DropZoneDefaultProps = {
        onDrop: onDrop,
        multiple: multiple || false,
        onDragEnter: onDrag(true),
        onDragLeave: onDrag(false),
        onDropAccepted: onDropValidation(true),
        onDropRejected: onDropValidation(false),
        disabled: disabled,
    };
    var _j = useDropzone(acceptedFilesTypes ? __assign$2(__assign$2({}, DropZoneDefaultProps), { accept: acceptedFilesTypes }) : __assign$2({}, DropZoneDefaultProps)), getRootProps = _j.getRootProps, getInputProps = _j.getInputProps;
    var DragAndDropInputLabel = (React__default.createElement(React__default.Fragment, null, label && (React__default.createElement(DragAndDropLabelContainer, null,
        React__default.createElement(DragAndDropLabel, { htmlFor: name, error: error, optional: optional, disabled: disabled || loading },
            React__default.createElement(SvgIcon, { src: IconPaperClip, width: 20, height: 20, fill: "grey700" }),
            label,
            iconTooltip && textTooltip && (React__default.createElement(AgilizeTooltip, { title: textTooltip },
                React__default.createElement(StyledIconInputContainer, null, iconTooltip))))))));
    var DragAndDropInputErrorText = (React__default.createElement(React__default.Fragment, null,
        !error && !customText && (React__default.createElement(DragAndDropInputError, { error: !isFileAllowed }, labelExtension || (React__default.createElement(React__default.Fragment, null,
            "Formatos:\u00A0 ",
            React__default.createElement("strong", null, acceptedFilesTypes || 'todos'),
            !isFileAllowed && (React__default.createElement(React__default.Fragment, null,
                "\u00A0 ",
                React__default.createElement(SvgIcon, { src: XCircle, width: 16, height: 16, fill: "red700" }))))))),
        error && (React__default.createElement(DragAndDropInputError, { error: !!error, "data-testid": "external-error" }, error || textHelper))));
    var DragAndDropInfo = files && files.length <= 0 && (React__default.createElement(DragAndDropInfoContainer, { isLoading: loading },
        React__default.createElement(DragAndDropIconContainer, null,
            React__default.createElement(SvgIcon, { src: customIcon || IconUpload, width: customIconWidth || 80, height: customIconHeight || 80 })),
        customText && customText,
        !customText && (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(DragAndDropTitleMessage, { disabled: disabled || loading }, placeholder || 'Arraste e solte os arquivos'),
            React__default.createElement(DragAndDropSubTitleMessage, { isDragging: isDragging, disabled: disabled || loading },
                "ou ",
                React__default.createElement(DragAndDropLink, { disabled: disabled || loading }, "clique"),
                " para procurar"))),
        DragAndDropInputErrorText));
    useEffect(function () {
        if ((value === null || value === void 0 ? void 0 : value.length) > 0) {
            setFiles(__spreadArrays(value));
        }
    }, [value]);
    var DragAndDropInputFileSelected = files && files.length > 0 && showSelectedFiles && (React__default.createElement(DragAndDropInputFileSelectedContent, { isLoading: loading, hasInfinityOverlay: files && files.length > 6 }, files.map(function (file, index) {
        var splitName = file.name.split('.');
        var fileName = splitName[0];
        var extension = splitName[1] || '-';
        return (React__default.createElement(DragAndDropUploadedFile, { key: file.name + index, "data-testid": "name" },
            React__default.createElement("span", null, extension),
            React__default.createElement(DragAndDropFileName, null, fileName),
            React__default.createElement(DragAndDropFileButtonClear, { disabled: disabled, testId: "remove-file", iconWidth: 16, iconHeight: 16, onClick: handleRemoveFile(index), iconPath: IconClose$1, noGutter: true, fill: theme.colors.red700, backgroundColor: theme.colors.grey100 })));
    })));
    var DragAndDropContent = (React__default.createElement(React__default.Fragment, null,
        DragAndDropInfo,
        DragAndDropInputFileSelected));
    var DragAndDropLoading = loading && (React__default.createElement(DragAndDropLoadingContainer, { isProgress: loadingProgress !== undefined, hasLoadingProgress: !!loadingProgressTitle },
        React__default.createElement(LoadingTitleContainer, null,
            React__default.createElement(LoadingTitle, null, loadingProgressTitle && loadingProgressTitle)),
        loadingProgress === undefined ? (React__default.createElement(ContainerBasicLoading, null,
            React__default.createElement(Slider$2, null,
                React__default.createElement(Line, null),
                React__default.createElement(SubLine, { direction: "increase" }),
                React__default.createElement(SubLine, { direction: "decrease" })))) : (React__default.createElement(ProgressBarContainer, null,
            React__default.createElement(ProgressBar$1, null,
                React__default.createElement(Percent$1, { style: { width: loadingProgress + "%" || '0%', backgroundColor: loadingProgress === 100 ? theme.colors.green700 : theme.colors.green400 }, loadingProgressError: loadingProgressError, loadingProgress: loadingProgress })),
            !loadingProgressError && (React__default.createElement(PercentValue$1, null,
                React__default.createElement("span", null,
                    loadingProgress,
                    "%")))))));
    var DragAndDropInput = (React__default.createElement("input", __assign$2({ "data-testid": testId }, getInputProps(), { type: "file", name: name, id: name, ref: inputFileRef, disabled: disabled || loading, required: required })));
    var DragAndDropInputFile = (React__default.createElement(DragAndDropInputFileContainer, null,
        DragAndDropLoading,
        React__default.createElement(ContainerLoadExtract, { hasFile: showFileProgress && (files === null || files === void 0 ? void 0 : files.length) },
            React__default.createElement(SvgIcon, { src: ExtractIcon, width: 24, height: 24 }),
            React__default.createElement("div", { style: { flex: 1, display: 'flex', flexDirection: 'column', justifyContent: 'space-between', height: 35, position: 'relative' } },
                React__default.createElement("span", { style: { fontFamily: 'Inter', fontSize: 14, fontWeight: 500, color: 'rgba(58, 54, 61, 1)' } }, (_a = files[0]) === null || _a === void 0 ? void 0 : _a.name),
                React__default.createElement(LoadingContainer, { progressFile: hasFiles },
                    React__default.createElement(LoadingProgress, { progressFile: hasFiles ? 100 : 0 })),
                React__default.createElement(SizeFile, { progressFile: hasFiles },
                    ((_b = files[0]) === null || _b === void 0 ? void 0 : _b.size) / 1024,
                    " KB")),
            React__default.createElement("div", null,
                React__default.createElement(ClearBtn, { onClick: handleClear }, showTrashBtn ? React__default.createElement(SvgIcon, { src: TrashIcon, width: 24, height: 24 }) : React__default.createElement(SvgIcon, { src: CloseIcon, width: 24, height: 24 })))),
        React__default.createElement(DragAndDropFileLabel, { showFileProgress: showFileProgress && (files === null || files === void 0 ? void 0 : files.length) > 0, disabled: disabled || loading, htmlFor: name, isDragging: isDragging, colorBorder: colorBorder, background: background, backgroundHover: backgroundHover, hoverBorderColor: hoverBorderColor, fillHover: fillHover },
            DragAndDropContent,
            DragAndDropInput)));
    return (React__default.createElement("div", { className: className },
        React__default.createElement(DragAndDropFileWrapper, __assign$2({}, getRootProps(), { "data-testid": "drag-and-drop" }),
            DragAndDropInputLabel,
            DragAndDropInputFile)));
};
var DragAndDrop = forwardRef(File);

var ArrowDown = styled.div(templateObject_1$k || (templateObject_1$k = __makeTemplateObject(["\n  position: relative;\n  background: ", ";\n\n  &:after {\n    content: '';\n    position: absolute;\n    width: 0;\n    height: 0;\n    margin-left: ", "px;\n    top: -7px;\n    box-sizing: border-box;\n    border-top: 10px solid ", ";\n    border-right: 10px solid ", ";\n    border-bottom: 10px solid transparent;\n    border-left: 10px solid transparent;\n    transform-origin: 50%;\n    transform: rotate(-45deg);\n    box-shadow: 2px -2px 3px ", ";\n    z-index: 10;\n    border-radius: 4px;\n  }\n"], ["\n  position: relative;\n  background: ", ";\n\n  &:after {\n    content: '';\n    position: absolute;\n    width: 0;\n    height: 0;\n    margin-left: ", "px;\n    top: -7px;\n    box-sizing: border-box;\n    border-top: 10px solid ", ";\n    border-right: 10px solid ", ";\n    border-bottom: 10px solid transparent;\n    border-left: 10px solid transparent;\n    transform-origin: 50%;\n    transform: rotate(-45deg);\n    box-shadow: 2px -2px 3px ", ";\n    z-index: 10;\n    border-radius: 4px;\n  }\n"])), function (props) { return props.theme.colors.white; }, function (props) { return props.theme.global.gutterSpace * 0.875; }, function (props) { return props.theme.colors.white; }, function (props) { return props.theme.colors.white; }, function (props) { return rgba(props.theme.colors.grey400, 0.08); });
var StyledPopper$1 = styled(Popper$1)(templateObject_2$h || (templateObject_2$h = __makeTemplateObject(["\n  font-family: ", ";\n  z-index: 9;\n"], ["\n  font-family: ", ";\n  z-index: 9;\n"])), function (props) { return props.theme.global.defaultFont; });
var PopperContainer = styled.div(templateObject_3$h || (templateObject_3$h = __makeTemplateObject(["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  width: ", "px;\n  max-height: ", "px;\n  background-color: ", ";\n  box-shadow: 0px 2px 6px ", ";\n  border-radius: 8px;\n"], ["\n  display: flex;\n  justify-content: center;\n  align-items: center;\n  flex-direction: column;\n  width: ", "px;\n  max-height: ", "px;\n  background-color: ", ";\n  box-shadow: 0px 2px 6px ", ";\n  border-radius: 8px;\n"])), function (props) { return props.width; }, function (props) { return props.maxHeight; }, function (props) { return props.theme.colors.white; }, function (props) { return rgba(props.theme.colors.grey400, 0.2); });
var PopperContent = styled.div(templateObject_4$f || (templateObject_4$f = __makeTemplateObject(["\n  width: 100%;\n  overflow-y: auto;\n"], ["\n  width: 100%;\n  overflow-y: auto;\n"])));
var HeaderDropdownmWithTitle = styled.div(templateObject_5$c || (templateObject_5$c = __makeTemplateObject(["\n  width: 100%;\n  padding: ", "px;\n  border-bottom: 1px solid ", ";\n  font-weight: 600;\n  font-size: 2rem;\n\n  svg {\n    margin-right: ", "px;\n  }\n"], ["\n  width: 100%;\n  padding: ", "px;\n  border-bottom: 1px solid ", ";\n  font-weight: 600;\n  font-size: 2rem;\n\n  svg {\n    margin-right: ", "px;\n  }\n"])), function (props) { return props.theme.global.gutterSpace * 1.5; }, function (props) { return props.theme.colors.grey100; }, function (props) { return Math.round(props.theme.global.gutterSpace * 0.6); });
var HeaderDropdownm = styled.div(templateObject_6$c || (templateObject_6$c = __makeTemplateObject(["\n  width: 100%;\n  border-bottom: 1px solid ", ";\n"], ["\n  width: 100%;\n  border-bottom: 1px solid ", ";\n"])), function (props) { return props.theme.colors.grey100; });
var FooterDropdown = styled.div(templateObject_7$c || (templateObject_7$c = __makeTemplateObject(["\n  width: 100%;\n  border-top: 1px solid ", ";\n"], ["\n  width: 100%;\n  border-top: 1px solid ", ";\n"])), function (props) { return props.theme.colors.grey100; });
var TitleContainer = styled.div(templateObject_8$b || (templateObject_8$b = __makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n"], ["\n  display: flex;\n  flex-direction: row;\n"])));
var templateObject_1$k, templateObject_2$h, templateObject_3$h, templateObject_4$f, templateObject_5$c, templateObject_6$c, templateObject_7$c, templateObject_8$b;

var MenuDropdown = function (props) {
    var children = props.children, hasArrow = props.hasArrow, title = props.title, iconButton = props.iconButton, header = props.header, footer = props.footer, width = props.width, maxHeight = props.maxHeight, testId = props.testId, className = props.className;
    var _a = useState(false), open = _a[0], setOpen = _a[1];
    var _b = useState(), anchorElement = _b[0], setAchorElement = _b[1];
    var _c = useState(), arrowRef = _c[0], setArrowRef = _c[1];
    var dropdownRef = useRef(null);
    var handleOpened = function () {
        setOpen(!open);
    };
    var handleAnchor = function (event) {
        setAchorElement(event.currentTarget);
        handleOpened();
    };
    var handleClickAway = function () {
        handleOpened();
    };
    var handleArrowRef = function (node) {
        setArrowRef(node);
    };
    return (React__default.createElement("div", { "data-testid": testId, className: className },
        anchorElement && (React__default.createElement(StyledPopper$1, { placement: "bottom", open: open, anchorEl: anchorElement, transition: true, modifiers: {
                flip: {
                    enabled: false,
                },
                arrow: {
                    enabled: hasArrow,
                    element: arrowRef,
                },
                preventOverflow: {
                    enabled: 'hide',
                    boundariesElement: 'scrollParent',
                },
            } },
            React__default.createElement(ClickAwayListener, { onClickAway: handleClickAway },
                React__default.createElement(PopperContainer, { ref: dropdownRef, width: width || 320, maxHeight: maxHeight || 464 },
                    title && !header && (React__default.createElement(HeaderDropdownmWithTitle, null,
                        React__default.createElement(TitleContainer, null,
                            iconButton && React__default.createElement(SvgIcon, { src: iconButton.iconButtonPath, fill: iconButton.iconColor, width: 20, height: 20 }),
                            title))),
                    header && React__default.createElement(HeaderDropdownm, null, header),
                    React__default.createElement(PopperContent, null, children),
                    footer && React__default.createElement(FooterDropdown, null, footer))))),
        iconButton && React__default.createElement(FabButton, { iconPath: iconButton.iconButtonPath, onClick: handleAnchor, disabled: iconButton.disabled }),
        hasArrow && open && React__default.createElement(ArrowDown, { ref: handleArrowRef })));
};

var StyledHR$1 = styled.div(templateObject_1$j || (templateObject_1$j = __makeTemplateObject(["\n  border-bottom: 1px solid ", ";\n  margin: ", "px 0;\n"], ["\n  border-bottom: 1px solid ", ";\n  margin: ", "px 0;\n"])), function (props) { return props.theme.colors.grey100; }, function (props) { return props.theme.global.gutterSpace / 4; });
var templateObject_1$j;

var IconMore = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path  d=\"M12,10a2,2,0,1,0,2,2A2,2,0,0,0,12,10ZM5,10a2,2,0,1,0,2,2A2,2,0,0,0,5,10Zm14,0a2,2,0,1,0,2,2A2,2,0,0,0,19,10Z\"/></svg>";

var ActionsDropdown = function (props) {
    var options = props.options, itemHeight = props.itemHeight, itemWidth = props.itemWidth, icon = props.icon, disabled = props.disabled, anchorOriginVertical = props.anchorOriginVertical, anchorOriginHorizontal = props.anchorOriginHorizontal, anchorTransformHorizontal = props.anchorTransformHorizontal, anchorTransformVertical = props.anchorTransformVertical, handleOptionClick = props.handleOptionClick, children = props.children, hasOptionSeparator = props.hasOptionSeparator, size = props.size, color = props.color, className = props.className, testId = props.testId, disabledBackgroundColor = props.disabledBackgroundColor, onClickAction = props.onClickAction, onCloseAction = props.onCloseAction;
    var _a = useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var _b = useState(false), exited = _b[0], setExited = _b[1];
    var open = Boolean(anchorEl);
    var StyledMenuItem = withStyles(function () { return ({
        root: {
            fontSize: '1.4rem',
            color: theme.colors.grey700,
            borderRadius: theme.forms.borderRadius / 2,
            fontFamily: theme.global.defaultFont,
            padding: theme.global.gutterSpace / 4 + "px " + theme.global.gutterSpace / 2 + "px",
            '&:hover': {
                backgroundColor: theme.colors.grey100,
            },
        },
    }); })(MenuItem);
    var handleOpenDropdown = function (event) {
        event.stopPropagation();
        event.preventDefault();
        setExited(true);
        setAnchorEl(event.currentTarget);
        if (onClickAction) {
            onClickAction();
        }
    };
    var handleClose = function (event) {
        event.stopPropagation();
        event.preventDefault();
        setAnchorEl(null);
        if (onCloseAction) {
            onCloseAction();
        }
    };
    var handleClick = function (action) { return function (event) {
        event.stopPropagation();
        event.preventDefault();
        handleOptionClick(action);
        handleClose(event);
    }; };
    var handleExited = function () { return setExited(false); };
    return (React__default.createElement(React__default.Fragment, null,
        !children && (React__default.createElement(FabButton, { iconPath: icon || IconMore, disabled: disabled, "aria-label": "more", "aria-controls": "long-menu", "aria-haspopup": "true", onClick: handleOpenDropdown, size: size || 'default', color: color || 'default', testId: testId || 'simple-dropdown-iconButton', className: className, disabledBackgroundColor: disabledBackgroundColor })),
        children && (React__default.createElement(Box, { width: "fit-content", "aria-label": "more", "aria-controls": "long-menu", "aria-haspopup": "true", "data-testid": testId || 'simple-dropdown-iconButton', className: className, onClick: !disabled && handleOpenDropdown }, children && children)),
        exited && (React__default.createElement(Menu$1, { "data-testid": "simple-dropdown", id: "long-menu", anchorEl: anchorEl, keepMounted: true, elevation: 2, open: open, getContentAnchorEl: null, onClose: handleClose, onExited: handleExited, anchorOrigin: {
                vertical: anchorOriginVertical,
                horizontal: anchorOriginHorizontal,
            }, transformOrigin: {
                vertical: anchorTransformVertical,
                horizontal: anchorTransformHorizontal,
            }, PaperProps: {
                style: {
                    boxShadow: "0px 2px 4px rgba(" + theme.colors.grey100 + ", 0.3)",
                    borderRadius: theme.forms.borderRadius,
                    maxHeight: itemHeight ? itemHeight * 4 : 'auto',
                    width: itemWidth || 'auto',
                    color: theme.colors.red400,
                    padding: theme.global.gutterSpace / 2,
                },
            }, MenuListProps: {
                style: {
                    paddingTop: 0,
                    paddingBottom: 0,
                },
            } },
            options.map(function (option) {
                return !option.inSeparator && (React__default.createElement(StyledMenuItem, { key: option.action, selected: option.title === 'Pyxis', onClick: handleClick(option.action), "data-testid": "simple-dropdown-content" }, option.title));
            }),
            hasOptionSeparator && (React__default.createElement("div", null,
                React__default.createElement(StyledHR$1, null),
                options.map(function (option) {
                    return option.inSeparator && (React__default.createElement(StyledMenuItem, { key: option.action, selected: option.title === 'Pyxis', onClick: handleClick(option.action), "data-testid": "simple-dropdown-content" }, option.title));
                })))))));
};

var StyledHR = styled.div(templateObject_1$i || (templateObject_1$i = __makeTemplateObject(["\n  border-bottom: 1px solid ", ";\n  margin: ", "px 0;\n"], ["\n  border-bottom: 1px solid ", ";\n  margin: ", "px 0;\n"])), function (props) { return props.theme.colors.grey100; }, function (props) { return props.theme.global.gutterSpace / 4; });
var StyledPopper = styled(Popper$1)(templateObject_2$g || (templateObject_2$g = __makeTemplateObject(["\n  z-index: ", ";\n"], ["\n  z-index: ", ";\n"])), function (props) { return props.zIndex || props.theme.zIndex.dropdownList; });
var FloatingDrop = styled.div(templateObject_3$g || (templateObject_3$g = __makeTemplateObject(["\n  border-radius: ", "px;\n  max-height: ", ";\n  width: ", ";\n  padding: ", "px;\n  z-index: ", ";\n  background-color: ", ";\n  box-shadow: 0 2px 4px ", ";\n  overflow-y: auto;\n"], ["\n  border-radius: ", "px;\n  max-height: ", ";\n  width: ", ";\n  padding: ", "px;\n  z-index: ", ";\n  background-color: ", ";\n  box-shadow: 0 2px 4px ", ";\n  overflow-y: auto;\n"])), function (props) { return props.theme.forms.borderRadius; }, function (props) { return (props.$itemHeight ? props.$itemHeight * 4 + "px" : 'auto'); }, function (props) { return (props.$itemWidth ? props.$itemWidth + "px" : 'auto'); }, function (props) { return props.theme.global.gutterSpace / 2; }, function (props) { return props.theme.zIndex.dropdownList; }, function (props) { return props.theme.colors.white; }, function (props) { return rgba(props.theme.colors.grey700, 0.3); });
var StyledMenuItem = styled.div(templateObject_4$e || (templateObject_4$e = __makeTemplateObject(["\n  font-size: ", ";\n  color: ", ";\n  border-radius: ", "px;\n  font-family: ", ";\n  padding: ", "px ", "px;\n  cursor: pointer;\n  transition: background-color 200ms ease-in-out;\n\n  &&:hover {\n    background-color: ", ";\n  }\n\n  ", "\n"], ["\n  font-size: ", ";\n  color: ", ";\n  border-radius: ", "px;\n  font-family: ", ";\n  padding: ", "px ", "px;\n  cursor: pointer;\n  transition: background-color 200ms ease-in-out;\n\n  &&:hover {\n    background-color: ", ";\n  }\n\n  ",
    "\n"])), function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.colors.grey700; }, function (props) { return props.theme.forms.borderRadius / 2; }, function (props) { return props.theme.global.defaultFont; }, function (props) { return props.theme.global.gutterSpace / 4; }, function (props) { return props.theme.global.gutterSpace / 2; }, function (props) { return props.theme.colors.grey100; }, function (props) {
    return props.disabled &&
        "\n    &&, && > div{\n      cursor: default;\n      color: " + props.theme.colors.grey400 + ";\n      \n      &&:hover {\n          background-color: transparent;\n      }\n    }\n  ";
});
var templateObject_1$i, templateObject_2$g, templateObject_3$g, templateObject_4$e;

var FloatingMenu = function (props) {
    var options = props.options, itemHeight = props.itemHeight, itemWidth = props.itemWidth, icon = props.icon, disabled = props.disabled, handleOptionClick = props.handleOptionClick, children = props.children, hasOptionSeparator = props.hasOptionSeparator, size = props.size, color = props.color, className = props.className, testId = props.testId, disabledBackgroundColor = props.disabledBackgroundColor, onClickAction = props.onClickAction, onCloseAction = props.onCloseAction, placement = props.placement, transformOrigin = props.transformOrigin, loading = props.loading, zIndex = props.zIndex;
    var _a = useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var open = Boolean(anchorEl);
    var handleOpenDropdown = function (event) {
        setAnchorEl(anchorEl ? null : event.currentTarget);
        if (onClickAction) {
            onClickAction();
        }
    };
    var handleClose = function () {
        if (anchorEl) {
            setAnchorEl(null);
        }
        if (onCloseAction) {
            onCloseAction();
        }
    };
    var handleClick = function (action, isDisabled) { return function () {
        if (!isDisabled) {
            handleOptionClick(action);
            handleClose();
        }
    }; };
    return (React__default.createElement(React__default.Fragment, null,
        !children && (React__default.createElement(FabButton, { iconPath: icon || IconMore, disabled: disabled || loading, "aria-label": "more", "aria-controls": "long-menu", "aria-haspopup": "true", onClick: handleOpenDropdown, size: size || 'default', color: color || 'default', testId: testId || 'simple-dropdown-iconButton', className: className, disabledBackgroundColor: disabledBackgroundColor, loading: loading })),
        children && (React__default.createElement(Box, { width: "fit-content", "aria-label": "more", "aria-controls": "long-menu", "aria-haspopup": "true", "aria-expanded": open ? 'true' : 'false', "data-testid": testId || 'simple-dropdown-iconButton', className: className, onClick: !disabled && handleOpenDropdown }, children && children)),
        React__default.createElement(StyledPopper, { zIndex: zIndex, open: open, anchorEl: anchorEl, placement: placement || 'bottom', modifiers: {
                flip: {
                    enabled: true,
                },
                preventOverflow: {
                    enabled: true,
                    boundariesElement: 'scrollParent',
                },
            }, transition: true },
            React__default.createElement(ClickAwayListener$1, { onClickAway: handleClose },
                React__default.createElement(Grow, { in: open, style: { transformOrigin: transformOrigin || 'center 0' } },
                    React__default.createElement(FloatingDrop, { "$itemHeight": itemHeight, "$itemWidth": itemWidth, "data-testid": "simple-dropdown" }, options.map(function (option) { return (React__default.createElement(React__default.Fragment, { key: option.action },
                        hasOptionSeparator && option.inSeparator && React__default.createElement(StyledHR, null),
                        React__default.createElement(StyledMenuItem, { selected: option.title === 'Pyxis', onClick: handleClick(option.action, option.disabled), disabled: option.disabled, "data-testid": "simple-dropdown-content", role: "menuitem" }, option.title))); })))))));
};

var _curry = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports["default"] = curry;
// Type definitions taken from https://github.com/gcanti/flow-static-land/blob/master/src/Fun.js
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-unused-vars
// eslint-disable-next-line no-redeclare
function curried(f, length, acc) {
  return function fn() {
    // eslint-disable-next-line prefer-rest-params
    var combined = acc.concat(Array.prototype.slice.call(arguments));
    return combined.length >= length ? f.apply(this, combined) : curried(f, length, combined);
  };
}

// eslint-disable-next-line no-redeclare
function curry(f) {
  // eslint-disable-line no-redeclare
  return curried(f, f.length, []);
}
module.exports = exports.default;
});

unwrapExports(_curry);

var _guard = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports["default"] = void 0;
function guard(lowerBoundary, upperBoundary, value) {
  return Math.max(lowerBoundary, Math.min(upperBoundary, value));
}
exports["default"] = guard;
module.exports = exports.default;
});

unwrapExports(_guard);

var _hslToRgb = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports["default"] = void 0;
function colorToInt(color) {
  return Math.round(color * 255);
}
function convertToInt(red, green, blue) {
  return colorToInt(red) + "," + colorToInt(green) + "," + colorToInt(blue);
}
function hslToRgb(hue, saturation, lightness, convert) {
  if (convert === void 0) {
    convert = convertToInt;
  }
  if (saturation === 0) {
    // achromatic
    return convert(lightness, lightness, lightness);
  }

  // formulae from https://en.wikipedia.org/wiki/HSL_and_HSV
  var huePrime = (hue % 360 + 360) % 360 / 60;
  var chroma = (1 - Math.abs(2 * lightness - 1)) * saturation;
  var secondComponent = chroma * (1 - Math.abs(huePrime % 2 - 1));
  var red = 0;
  var green = 0;
  var blue = 0;
  if (huePrime >= 0 && huePrime < 1) {
    red = chroma;
    green = secondComponent;
  } else if (huePrime >= 1 && huePrime < 2) {
    red = secondComponent;
    green = chroma;
  } else if (huePrime >= 2 && huePrime < 3) {
    green = chroma;
    blue = secondComponent;
  } else if (huePrime >= 3 && huePrime < 4) {
    green = secondComponent;
    blue = chroma;
  } else if (huePrime >= 4 && huePrime < 5) {
    red = secondComponent;
    blue = chroma;
  } else if (huePrime >= 5 && huePrime < 6) {
    red = chroma;
    blue = secondComponent;
  }
  var lightnessModification = lightness - chroma / 2;
  var finalRed = red + lightnessModification;
  var finalGreen = green + lightnessModification;
  var finalBlue = blue + lightnessModification;
  return convert(finalRed, finalGreen, finalBlue);
}
exports["default"] = hslToRgb;
module.exports = exports.default;
});

unwrapExports(_hslToRgb);

var _nameToHex = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports["default"] = void 0;
var namedColorMap = {
  aliceblue: 'f0f8ff',
  antiquewhite: 'faebd7',
  aqua: '00ffff',
  aquamarine: '7fffd4',
  azure: 'f0ffff',
  beige: 'f5f5dc',
  bisque: 'ffe4c4',
  black: '000',
  blanchedalmond: 'ffebcd',
  blue: '0000ff',
  blueviolet: '8a2be2',
  brown: 'a52a2a',
  burlywood: 'deb887',
  cadetblue: '5f9ea0',
  chartreuse: '7fff00',
  chocolate: 'd2691e',
  coral: 'ff7f50',
  cornflowerblue: '6495ed',
  cornsilk: 'fff8dc',
  crimson: 'dc143c',
  cyan: '00ffff',
  darkblue: '00008b',
  darkcyan: '008b8b',
  darkgoldenrod: 'b8860b',
  darkgray: 'a9a9a9',
  darkgreen: '006400',
  darkgrey: 'a9a9a9',
  darkkhaki: 'bdb76b',
  darkmagenta: '8b008b',
  darkolivegreen: '556b2f',
  darkorange: 'ff8c00',
  darkorchid: '9932cc',
  darkred: '8b0000',
  darksalmon: 'e9967a',
  darkseagreen: '8fbc8f',
  darkslateblue: '483d8b',
  darkslategray: '2f4f4f',
  darkslategrey: '2f4f4f',
  darkturquoise: '00ced1',
  darkviolet: '9400d3',
  deeppink: 'ff1493',
  deepskyblue: '00bfff',
  dimgray: '696969',
  dimgrey: '696969',
  dodgerblue: '1e90ff',
  firebrick: 'b22222',
  floralwhite: 'fffaf0',
  forestgreen: '228b22',
  fuchsia: 'ff00ff',
  gainsboro: 'dcdcdc',
  ghostwhite: 'f8f8ff',
  gold: 'ffd700',
  goldenrod: 'daa520',
  gray: '808080',
  green: '008000',
  greenyellow: 'adff2f',
  grey: '808080',
  honeydew: 'f0fff0',
  hotpink: 'ff69b4',
  indianred: 'cd5c5c',
  indigo: '4b0082',
  ivory: 'fffff0',
  khaki: 'f0e68c',
  lavender: 'e6e6fa',
  lavenderblush: 'fff0f5',
  lawngreen: '7cfc00',
  lemonchiffon: 'fffacd',
  lightblue: 'add8e6',
  lightcoral: 'f08080',
  lightcyan: 'e0ffff',
  lightgoldenrodyellow: 'fafad2',
  lightgray: 'd3d3d3',
  lightgreen: '90ee90',
  lightgrey: 'd3d3d3',
  lightpink: 'ffb6c1',
  lightsalmon: 'ffa07a',
  lightseagreen: '20b2aa',
  lightskyblue: '87cefa',
  lightslategray: '789',
  lightslategrey: '789',
  lightsteelblue: 'b0c4de',
  lightyellow: 'ffffe0',
  lime: '0f0',
  limegreen: '32cd32',
  linen: 'faf0e6',
  magenta: 'f0f',
  maroon: '800000',
  mediumaquamarine: '66cdaa',
  mediumblue: '0000cd',
  mediumorchid: 'ba55d3',
  mediumpurple: '9370db',
  mediumseagreen: '3cb371',
  mediumslateblue: '7b68ee',
  mediumspringgreen: '00fa9a',
  mediumturquoise: '48d1cc',
  mediumvioletred: 'c71585',
  midnightblue: '191970',
  mintcream: 'f5fffa',
  mistyrose: 'ffe4e1',
  moccasin: 'ffe4b5',
  navajowhite: 'ffdead',
  navy: '000080',
  oldlace: 'fdf5e6',
  olive: '808000',
  olivedrab: '6b8e23',
  orange: 'ffa500',
  orangered: 'ff4500',
  orchid: 'da70d6',
  palegoldenrod: 'eee8aa',
  palegreen: '98fb98',
  paleturquoise: 'afeeee',
  palevioletred: 'db7093',
  papayawhip: 'ffefd5',
  peachpuff: 'ffdab9',
  peru: 'cd853f',
  pink: 'ffc0cb',
  plum: 'dda0dd',
  powderblue: 'b0e0e6',
  purple: '800080',
  rebeccapurple: '639',
  red: 'f00',
  rosybrown: 'bc8f8f',
  royalblue: '4169e1',
  saddlebrown: '8b4513',
  salmon: 'fa8072',
  sandybrown: 'f4a460',
  seagreen: '2e8b57',
  seashell: 'fff5ee',
  sienna: 'a0522d',
  silver: 'c0c0c0',
  skyblue: '87ceeb',
  slateblue: '6a5acd',
  slategray: '708090',
  slategrey: '708090',
  snow: 'fffafa',
  springgreen: '00ff7f',
  steelblue: '4682b4',
  tan: 'd2b48c',
  teal: '008080',
  thistle: 'd8bfd8',
  tomato: 'ff6347',
  turquoise: '40e0d0',
  violet: 'ee82ee',
  wheat: 'f5deb3',
  white: 'fff',
  whitesmoke: 'f5f5f5',
  yellow: 'ff0',
  yellowgreen: '9acd32'
};

/**
 * Checks if a string is a CSS named color and returns its equivalent hex value, otherwise returns the original color.
 * @private
 */
function nameToHex(color) {
  if (typeof color !== 'string') return color;
  var normalizedColorName = color.toLowerCase();
  return namedColorMap[normalizedColorName] ? "#" + namedColorMap[normalizedColorName] : color;
}
exports["default"] = nameToHex;
module.exports = exports.default;
});

unwrapExports(_nameToHex);

var _errors = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports["default"] = void 0;
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; _setPrototypeOf(subClass, superClass); }
function _wrapNativeSuper(Class) { var _cache = typeof Map === "function" ? new Map() : undefined; _wrapNativeSuper = function _wrapNativeSuper(Class) { if (Class === null || !_isNativeFunction(Class)) return Class; if (typeof Class !== "function") { throw new TypeError("Super expression must either be null or a function"); } if (typeof _cache !== "undefined") { if (_cache.has(Class)) return _cache.get(Class); _cache.set(Class, Wrapper); } function Wrapper() { return _construct(Class, arguments, _getPrototypeOf(this).constructor); } Wrapper.prototype = Object.create(Class.prototype, { constructor: { value: Wrapper, enumerable: false, writable: true, configurable: true } }); return _setPrototypeOf(Wrapper, Class); }; return _wrapNativeSuper(Class); }
function _construct(t, e, r) { if (_isNativeReflectConstruct()) return Reflect.construct.apply(null, arguments); var o = [null]; o.push.apply(o, e); var p = new (t.bind.apply(t, o))(); return r && _setPrototypeOf(p, r.prototype), p; }
function _isNativeReflectConstruct() { try { var t = !Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); } catch (t) {} return (_isNativeReflectConstruct = function _isNativeReflectConstruct() { return !!t; })(); }
function _isNativeFunction(fn) { try { return Function.toString.call(fn).indexOf("[native code]") !== -1; } catch (e) { return typeof fn === "function"; } }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
// based on https://github.com/styled-components/styled-components/blob/fcf6f3804c57a14dd7984dfab7bc06ee2edca044/src/utils/error.js
/**
 * Parse errors.md and turn it into a simple hash of code: message
 * @private
 */
var ERRORS = {
  "1": "Passed invalid arguments to hsl, please pass multiple numbers e.g. hsl(360, 0.75, 0.4) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75 }).\n\n",
  "2": "Passed invalid arguments to hsla, please pass multiple numbers e.g. hsla(360, 0.75, 0.4, 0.7) or an object e.g. rgb({ hue: 255, saturation: 0.4, lightness: 0.75, alpha: 0.7 }).\n\n",
  "3": "Passed an incorrect argument to a color function, please pass a string representation of a color.\n\n",
  "4": "Couldn't generate valid rgb string from %s, it returned %s.\n\n",
  "5": "Couldn't parse the color string. Please provide the color as a string in hex, rgb, rgba, hsl or hsla notation.\n\n",
  "6": "Passed invalid arguments to rgb, please pass multiple numbers e.g. rgb(255, 205, 100) or an object e.g. rgb({ red: 255, green: 205, blue: 100 }).\n\n",
  "7": "Passed invalid arguments to rgba, please pass multiple numbers e.g. rgb(255, 205, 100, 0.75) or an object e.g. rgb({ red: 255, green: 205, blue: 100, alpha: 0.75 }).\n\n",
  "8": "Passed invalid argument to toColorString, please pass a RgbColor, RgbaColor, HslColor or HslaColor object.\n\n",
  "9": "Please provide a number of steps to the modularScale helper.\n\n",
  "10": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "11": "Invalid value passed as base to modularScale, expected number or em string but got \"%s\"\n\n",
  "12": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got \"%s\" instead.\n\n",
  "13": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got \"%s\" instead.\n\n",
  "14": "Passed invalid pixel value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "15": "Passed invalid base value (\"%s\") to %s(), please pass a value like \"12px\" or 12.\n\n",
  "16": "You must provide a template to this method.\n\n",
  "17": "You passed an unsupported selector state to this method.\n\n",
  "18": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "19": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "20": "expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "21": "expects the objects in the first argument array to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "22": "expects the first argument object to have the properties `prop`, `fromSize`, and `toSize`.\n\n",
  "23": "fontFace expects a name of a font-family.\n\n",
  "24": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "25": "fontFace expects localFonts to be an array.\n\n",
  "26": "fontFace expects fileFormats to be an array.\n\n",
  "27": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "28": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "29": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "30": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "31": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation\n\n",
  "32": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s')\n\n",
  "33": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation\n\n",
  "34": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "35": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "36": "Property must be a string value.\n\n",
  "37": "Syntax Error at %s.\n\n",
  "38": "Formula contains a function that needs parentheses at %s.\n\n",
  "39": "Formula is missing closing parenthesis at %s.\n\n",
  "40": "Formula has too many closing parentheses at %s.\n\n",
  "41": "All values in a formula must have the same unit or be unitless.\n\n",
  "42": "Please provide a number of steps to the modularScale helper.\n\n",
  "43": "Please pass a number or one of the predefined scales to the modularScale helper as the ratio.\n\n",
  "44": "Invalid value passed as base to modularScale, expected number or em/rem string but got %s.\n\n",
  "45": "Passed invalid argument to hslToColorString, please pass a HslColor or HslaColor object.\n\n",
  "46": "Passed invalid argument to rgbToColorString, please pass a RgbColor or RgbaColor object.\n\n",
  "47": "minScreen and maxScreen must be provided as stringified numbers with the same units.\n\n",
  "48": "fromSize and toSize must be provided as stringified numbers with the same units.\n\n",
  "49": "Expects either an array of objects or a single object with the properties prop, fromSize, and toSize.\n\n",
  "50": "Expects the objects in the first argument array to have the properties prop, fromSize, and toSize.\n\n",
  "51": "Expects the first argument object to have the properties prop, fromSize, and toSize.\n\n",
  "52": "fontFace expects either the path to the font file(s) or a name of a local copy.\n\n",
  "53": "fontFace expects localFonts to be an array.\n\n",
  "54": "fontFace expects fileFormats to be an array.\n\n",
  "55": "fontFace expects a name of a font-family.\n\n",
  "56": "linearGradient requries at least 2 color-stops to properly render.\n\n",
  "57": "radialGradient requries at least 2 color-stops to properly render.\n\n",
  "58": "Please supply a filename to retinaImage() as the first argument.\n\n",
  "59": "Passed invalid argument to triangle, please pass correct pointingDirection e.g. 'right'.\n\n",
  "60": "Passed an invalid value to `height` or `width`. Please provide a pixel based unit.\n\n",
  "61": "Property must be a string value.\n\n",
  "62": "borderRadius expects a radius value as a string or number as the second argument.\n\n",
  "63": "borderRadius expects one of \"top\", \"bottom\", \"left\" or \"right\" as the first argument.\n\n",
  "64": "The animation shorthand only takes 8 arguments. See the specification for more information: http://mdn.io/animation.\n\n",
  "65": "To pass multiple animations please supply them in arrays, e.g. animation(['rotate', '2s'], ['move', '1s'])\\nTo pass a single animation please supply them in simple values, e.g. animation('rotate', '2s').\n\n",
  "66": "The animation shorthand arrays can only have 8 elements. See the specification for more information: http://mdn.io/animation.\n\n",
  "67": "You must provide a template to this method.\n\n",
  "68": "You passed an unsupported selector state to this method.\n\n",
  "69": "Expected a string ending in \"px\" or a number passed as the first argument to %s(), got %s instead.\n\n",
  "70": "Expected a string ending in \"px\" or a number passed as the second argument to %s(), got %s instead.\n\n",
  "71": "Passed invalid pixel value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
  "72": "Passed invalid base value %s to %s(), please pass a value like \"12px\" or 12.\n\n",
  "73": "Please provide a valid CSS variable.\n\n",
  "74": "CSS variable not found and no default was provided.\n\n",
  "75": "important requires a valid style object, got a %s instead.\n\n",
  "76": "fromSize and toSize must be provided as stringified numbers with the same units as minScreen and maxScreen.\n\n",
  "77": "remToPx expects a value in \"rem\" but you provided it in \"%s\".\n\n",
  "78": "base must be set in \"px\" or \"%\" but you set it in \"%s\".\n"
};

/**
 * super basic version of sprintf
 * @private
 */
function format() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }
  var a = args[0];
  var b = [];
  var c;
  for (c = 1; c < args.length; c += 1) {
    b.push(args[c]);
  }
  b.forEach(function (d) {
    a = a.replace(/%[a-z]/, d);
  });
  return a;
}

/**
 * Create an error file out of errors.md for development and a simple web link to the full errors
 * in production mode.
 * @private
 */
exports["default"] = /*#__PURE__*/function (_Error) {
  _inheritsLoose(PolishedError, _Error);
  function PolishedError(code) {
    var _this;
    if (process.env.NODE_ENV === 'production') {
      _this = _Error.call(this, "An error occurred. See https://github.com/styled-components/polished/blob/main/src/internalHelpers/errors.md#" + code + " for more information.") || this;
    } else {
      for (var _len2 = arguments.length, args = new Array(_len2 > 1 ? _len2 - 1 : 0), _key2 = 1; _key2 < _len2; _key2++) {
        args[_key2 - 1] = arguments[_key2];
      }
      _this = _Error.call(this, format.apply(void 0, [ERRORS[code]].concat(args))) || this;
    }
    return _assertThisInitialized(_this);
  }
  return PolishedError;
}( /*#__PURE__*/_wrapNativeSuper(Error));
module.exports = exports.default;
});

unwrapExports(_errors);

var require$$1$5 = _hslToRgb;

var require$$1$4 = _nameToHex;

var require$$4 = _errors;

var parseToRgb_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports["default"] = parseToRgb;
var _hslToRgb = _interopRequireDefault(require$$1$5);
var _nameToHex = _interopRequireDefault(require$$1$4);
var _errors = _interopRequireDefault(require$$4);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var hexRegex = /^#[a-fA-F0-9]{6}$/;
var hexRgbaRegex = /^#[a-fA-F0-9]{8}$/;
var reducedHexRegex = /^#[a-fA-F0-9]{3}$/;
var reducedRgbaHexRegex = /^#[a-fA-F0-9]{4}$/;
var rgbRegex = /^rgb\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*\)$/i;
var rgbaRegex = /^rgb(?:a)?\(\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,)?\s*(\d{1,3})\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;
var hslRegex = /^hsl\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*\)$/i;
var hslaRegex = /^hsl(?:a)?\(\s*(\d{0,3}[.]?[0-9]+(?:deg)?)\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,)?\s*(\d{1,3}[.]?[0-9]?)%\s*(?:,|\/)\s*([-+]?\d*[.]?\d+[%]?)\s*\)$/i;

/**
 * Returns an RgbColor or RgbaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a RgbColor or RgbaColor object back to a string.
 *
 * @example
 * // Assigns `{ red: 255, green: 0, blue: 0 }` to color1
 * const color1 = parseToRgb('rgb(255, 0, 0)');
 * // Assigns `{ red: 92, green: 102, blue: 112, alpha: 0.75 }` to color2
 * const color2 = parseToRgb('hsla(210, 10%, 40%, 0.75)');
 */
function parseToRgb(color) {
  if (typeof color !== 'string') {
    throw new _errors["default"](3);
  }
  var normalizedColor = (0, _nameToHex["default"])(color);
  if (normalizedColor.match(hexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16)
    };
  }
  if (normalizedColor.match(hexRgbaRegex)) {
    var alpha = parseFloat((parseInt("" + normalizedColor[7] + normalizedColor[8], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[2], 16),
      green: parseInt("" + normalizedColor[3] + normalizedColor[4], 16),
      blue: parseInt("" + normalizedColor[5] + normalizedColor[6], 16),
      alpha: alpha
    };
  }
  if (normalizedColor.match(reducedHexRegex)) {
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16)
    };
  }
  if (normalizedColor.match(reducedRgbaHexRegex)) {
    var _alpha = parseFloat((parseInt("" + normalizedColor[4] + normalizedColor[4], 16) / 255).toFixed(2));
    return {
      red: parseInt("" + normalizedColor[1] + normalizedColor[1], 16),
      green: parseInt("" + normalizedColor[2] + normalizedColor[2], 16),
      blue: parseInt("" + normalizedColor[3] + normalizedColor[3], 16),
      alpha: _alpha
    };
  }
  var rgbMatched = rgbRegex.exec(normalizedColor);
  if (rgbMatched) {
    return {
      red: parseInt("" + rgbMatched[1], 10),
      green: parseInt("" + rgbMatched[2], 10),
      blue: parseInt("" + rgbMatched[3], 10)
    };
  }
  var rgbaMatched = rgbaRegex.exec(normalizedColor.substring(0, 50));
  if (rgbaMatched) {
    return {
      red: parseInt("" + rgbaMatched[1], 10),
      green: parseInt("" + rgbaMatched[2], 10),
      blue: parseInt("" + rgbaMatched[3], 10),
      alpha: parseFloat("" + rgbaMatched[4]) > 1 ? parseFloat("" + rgbaMatched[4]) / 100 : parseFloat("" + rgbaMatched[4])
    };
  }
  var hslMatched = hslRegex.exec(normalizedColor);
  if (hslMatched) {
    var hue = parseInt("" + hslMatched[1], 10);
    var saturation = parseInt("" + hslMatched[2], 10) / 100;
    var lightness = parseInt("" + hslMatched[3], 10) / 100;
    var rgbColorString = "rgb(" + (0, _hslToRgb["default"])(hue, saturation, lightness) + ")";
    var hslRgbMatched = rgbRegex.exec(rgbColorString);
    if (!hslRgbMatched) {
      throw new _errors["default"](4, normalizedColor, rgbColorString);
    }
    return {
      red: parseInt("" + hslRgbMatched[1], 10),
      green: parseInt("" + hslRgbMatched[2], 10),
      blue: parseInt("" + hslRgbMatched[3], 10)
    };
  }
  var hslaMatched = hslaRegex.exec(normalizedColor.substring(0, 50));
  if (hslaMatched) {
    var _hue = parseInt("" + hslaMatched[1], 10);
    var _saturation = parseInt("" + hslaMatched[2], 10) / 100;
    var _lightness = parseInt("" + hslaMatched[3], 10) / 100;
    var _rgbColorString = "rgb(" + (0, _hslToRgb["default"])(_hue, _saturation, _lightness) + ")";
    var _hslRgbMatched = rgbRegex.exec(_rgbColorString);
    if (!_hslRgbMatched) {
      throw new _errors["default"](4, normalizedColor, _rgbColorString);
    }
    return {
      red: parseInt("" + _hslRgbMatched[1], 10),
      green: parseInt("" + _hslRgbMatched[2], 10),
      blue: parseInt("" + _hslRgbMatched[3], 10),
      alpha: parseFloat("" + hslaMatched[4]) > 1 ? parseFloat("" + hslaMatched[4]) / 100 : parseFloat("" + hslaMatched[4])
    };
  }
  throw new _errors["default"](5);
}
module.exports = exports.default;
});

unwrapExports(parseToRgb_1);

var _rgbToHsl = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports["default"] = void 0;
function rgbToHsl(color) {
  // make sure rgb are contained in a set of [0, 255]
  var red = color.red / 255;
  var green = color.green / 255;
  var blue = color.blue / 255;
  var max = Math.max(red, green, blue);
  var min = Math.min(red, green, blue);
  var lightness = (max + min) / 2;
  if (max === min) {
    // achromatic
    if (color.alpha !== undefined) {
      return {
        hue: 0,
        saturation: 0,
        lightness: lightness,
        alpha: color.alpha
      };
    } else {
      return {
        hue: 0,
        saturation: 0,
        lightness: lightness
      };
    }
  }
  var hue;
  var delta = max - min;
  var saturation = lightness > 0.5 ? delta / (2 - max - min) : delta / (max + min);
  switch (max) {
    case red:
      hue = (green - blue) / delta + (green < blue ? 6 : 0);
      break;
    case green:
      hue = (blue - red) / delta + 2;
      break;
    default:
      // blue case
      hue = (red - green) / delta + 4;
      break;
  }
  hue *= 60;
  if (color.alpha !== undefined) {
    return {
      hue: hue,
      saturation: saturation,
      lightness: lightness,
      alpha: color.alpha
    };
  }
  return {
    hue: hue,
    saturation: saturation,
    lightness: lightness
  };
}
exports["default"] = rgbToHsl;
module.exports = exports.default;
});

unwrapExports(_rgbToHsl);

var require$$0$4 = parseToRgb_1;

var require$$1$3 = _rgbToHsl;

var parseToHsl_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports["default"] = parseToHsl;
var _parseToRgb = _interopRequireDefault(require$$0$4);
var _rgbToHsl = _interopRequireDefault(require$$1$3);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/**
 * Returns an HslColor or HslaColor object. This utility function is only useful
 * if want to extract a color component. With the color util `toColorString` you
 * can convert a HslColor or HslaColor object back to a string.
 *
 * @example
 * // Assigns `{ hue: 0, saturation: 1, lightness: 0.5 }` to color1
 * const color1 = parseToHsl('rgb(255, 0, 0)');
 * // Assigns `{ hue: 128, saturation: 1, lightness: 0.5, alpha: 0.75 }` to color2
 * const color2 = parseToHsl('hsla(128, 100%, 50%, 0.75)');
 */
function parseToHsl(color) {
  // Note: At a later stage we can optimize this function as right now a hsl
  // color would be parsed converted to rgb values and converted back to hsl.
  return (0, _rgbToHsl["default"])((0, _parseToRgb["default"])(color));
}
module.exports = exports.default;
});

unwrapExports(parseToHsl_1);

var _reduceHexValue = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports["default"] = void 0;
/**
 * Reduces hex values if possible e.g. #ff8866 to #f86
 * @private
 */
var reduceHexValue = function reduceHexValue(value) {
  if (value.length === 7 && value[1] === value[2] && value[3] === value[4] && value[5] === value[6]) {
    return "#" + value[1] + value[3] + value[5];
  }
  return value;
};
exports["default"] = reduceHexValue;
module.exports = exports.default;
});

unwrapExports(_reduceHexValue);

var _numberToHex = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports["default"] = void 0;
function numberToHex(value) {
  var hex = value.toString(16);
  return hex.length === 1 ? "0" + hex : hex;
}
exports["default"] = numberToHex;
module.exports = exports.default;
});

unwrapExports(_numberToHex);

var require$$0$3 = _reduceHexValue;

var require$$1$2 = _numberToHex;

var _hslToHex = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports["default"] = void 0;
var _hslToRgb = _interopRequireDefault(require$$1$5);
var _reduceHexValue = _interopRequireDefault(require$$0$3);
var _numberToHex = _interopRequireDefault(require$$1$2);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function colorToHex(color) {
  return (0, _numberToHex["default"])(Math.round(color * 255));
}
function convertToHex(red, green, blue) {
  return (0, _reduceHexValue["default"])("#" + colorToHex(red) + colorToHex(green) + colorToHex(blue));
}
function hslToHex(hue, saturation, lightness) {
  return (0, _hslToRgb["default"])(hue, saturation, lightness, convertToHex);
}
exports["default"] = hslToHex;
module.exports = exports.default;
});

unwrapExports(_hslToHex);

var require$$0$2 = _hslToHex;

var hsl_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports["default"] = hsl;
var _hslToHex = _interopRequireDefault(require$$0$2);
var _errors = _interopRequireDefault(require$$4);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsl(359, 0.75, 0.4),
 *   background: hsl({ hue: 360, saturation: 0.75, lightness: 0.4 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsl(359, 0.75, 0.4)};
 *   background: ${hsl({ hue: 360, saturation: 0.75, lightness: 0.4 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#b3191c";
 *   background: "#b3191c";
 * }
 */
function hsl(value, saturation, lightness) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number') {
    return (0, _hslToHex["default"])(value, saturation, lightness);
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined) {
    return (0, _hslToHex["default"])(value.hue, value.saturation, value.lightness);
  }
  throw new _errors["default"](1);
}
module.exports = exports.default;
});

unwrapExports(hsl_1);

var hsla_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports["default"] = hsla;
var _hslToHex = _interopRequireDefault(require$$0$2);
var _hslToRgb = _interopRequireDefault(require$$1$5);
var _errors = _interopRequireDefault(require$$4);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: hsla(359, 0.75, 0.4, 0.7),
 *   background: hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 }),
 *   background: hsla(359, 0.75, 0.4, 1),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${hsla(359, 0.75, 0.4, 0.7)};
 *   background: ${hsla({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0,7 })};
 *   background: ${hsla(359, 0.75, 0.4, 1)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(179,25,28,0.7)";
 *   background: "rgba(179,25,28,0.7)";
 *   background: "#b3191c";
 * }
 */
function hsla(value, saturation, lightness, alpha) {
  if (typeof value === 'number' && typeof saturation === 'number' && typeof lightness === 'number' && typeof alpha === 'number') {
    return alpha >= 1 ? (0, _hslToHex["default"])(value, saturation, lightness) : "rgba(" + (0, _hslToRgb["default"])(value, saturation, lightness) + "," + alpha + ")";
  } else if (typeof value === 'object' && saturation === undefined && lightness === undefined && alpha === undefined) {
    return value.alpha >= 1 ? (0, _hslToHex["default"])(value.hue, value.saturation, value.lightness) : "rgba(" + (0, _hslToRgb["default"])(value.hue, value.saturation, value.lightness) + "," + value.alpha + ")";
  }
  throw new _errors["default"](2);
}
module.exports = exports.default;
});

unwrapExports(hsla_1);

var rgb_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports["default"] = rgb;
var _reduceHexValue = _interopRequireDefault(require$$0$3);
var _numberToHex = _interopRequireDefault(require$$1$2);
var _errors = _interopRequireDefault(require$$4);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/**
 * Returns a string value for the color. The returned result is the smallest possible hex notation.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgb(255, 205, 100),
 *   background: rgb({ red: 255, green: 205, blue: 100 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgb(255, 205, 100)};
 *   background: ${rgb({ red: 255, green: 205, blue: 100 })};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#ffcd64";
 *   background: "#ffcd64";
 * }
 */
function rgb(value, green, blue) {
  if (typeof value === 'number' && typeof green === 'number' && typeof blue === 'number') {
    return (0, _reduceHexValue["default"])("#" + (0, _numberToHex["default"])(value) + (0, _numberToHex["default"])(green) + (0, _numberToHex["default"])(blue));
  } else if (typeof value === 'object' && green === undefined && blue === undefined) {
    return (0, _reduceHexValue["default"])("#" + (0, _numberToHex["default"])(value.red) + (0, _numberToHex["default"])(value.green) + (0, _numberToHex["default"])(value.blue));
  }
  throw new _errors["default"](6);
}
module.exports = exports.default;
});

unwrapExports(rgb_1);

var require$$2$1 = rgb_1;

var rgba_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports["default"] = rgba;
var _parseToRgb = _interopRequireDefault(require$$0$4);
var _rgb = _interopRequireDefault(require$$2$1);
var _errors = _interopRequireDefault(require$$4);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
/**
 * Returns a string value for the color. The returned result is the smallest possible rgba or hex notation.
 *
 * Can also be used to fade a color by passing a hex value or named CSS color along with an alpha value.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: rgba(255, 205, 100, 0.7),
 *   background: rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 }),
 *   background: rgba(255, 205, 100, 1),
 *   background: rgba('#ffffff', 0.4),
 *   background: rgba('black', 0.7),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${rgba(255, 205, 100, 0.7)};
 *   background: ${rgba({ red: 255, green: 205, blue: 100, alpha: 0.7 })};
 *   background: ${rgba(255, 205, 100, 1)};
 *   background: ${rgba('#ffffff', 0.4)};
 *   background: ${rgba('black', 0.7)};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "rgba(255,205,100,0.7)";
 *   background: "rgba(255,205,100,0.7)";
 *   background: "#ffcd64";
 *   background: "rgba(255,255,255,0.4)";
 *   background: "rgba(0,0,0,0.7)";
 * }
 */
function rgba(firstValue, secondValue, thirdValue, fourthValue) {
  if (typeof firstValue === 'string' && typeof secondValue === 'number') {
    var rgbValue = (0, _parseToRgb["default"])(firstValue);
    return "rgba(" + rgbValue.red + "," + rgbValue.green + "," + rgbValue.blue + "," + secondValue + ")";
  } else if (typeof firstValue === 'number' && typeof secondValue === 'number' && typeof thirdValue === 'number' && typeof fourthValue === 'number') {
    return fourthValue >= 1 ? (0, _rgb["default"])(firstValue, secondValue, thirdValue) : "rgba(" + firstValue + "," + secondValue + "," + thirdValue + "," + fourthValue + ")";
  } else if (typeof firstValue === 'object' && secondValue === undefined && thirdValue === undefined && fourthValue === undefined) {
    return firstValue.alpha >= 1 ? (0, _rgb["default"])(firstValue.red, firstValue.green, firstValue.blue) : "rgba(" + firstValue.red + "," + firstValue.green + "," + firstValue.blue + "," + firstValue.alpha + ")";
  }
  throw new _errors["default"](7);
}
module.exports = exports.default;
});

unwrapExports(rgba_1);

var require$$0$1 = hsl_1;

var require$$1$1 = hsla_1;

var require$$3$1 = rgba_1;

var toColorString_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports["default"] = toColorString;
var _hsl = _interopRequireDefault(require$$0$1);
var _hsla = _interopRequireDefault(require$$1$1);
var _rgb = _interopRequireDefault(require$$2$1);
var _rgba = _interopRequireDefault(require$$3$1);
var _errors = _interopRequireDefault(require$$4);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
var isRgb = function isRgb(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var isRgba = function isRgba(color) {
  return typeof color.red === 'number' && typeof color.green === 'number' && typeof color.blue === 'number' && typeof color.alpha === 'number';
};
var isHsl = function isHsl(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && (typeof color.alpha !== 'number' || typeof color.alpha === 'undefined');
};
var isHsla = function isHsla(color) {
  return typeof color.hue === 'number' && typeof color.saturation === 'number' && typeof color.lightness === 'number' && typeof color.alpha === 'number';
};

/**
 * Converts a RgbColor, RgbaColor, HslColor or HslaColor object to a color string.
 * This util is useful in case you only know on runtime which color object is
 * used. Otherwise we recommend to rely on `rgb`, `rgba`, `hsl` or `hsla`.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: toColorString({ red: 255, green: 205, blue: 100 }),
 *   background: toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 }),
 *   background: toColorString({ hue: 240, saturation: 1, lightness: 0.5 }),
 *   background: toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 }),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${toColorString({ red: 255, green: 205, blue: 100 })};
 *   background: ${toColorString({ red: 255, green: 205, blue: 100, alpha: 0.72 })};
 *   background: ${toColorString({ hue: 240, saturation: 1, lightness: 0.5 })};
 *   background: ${toColorString({ hue: 360, saturation: 0.75, lightness: 0.4, alpha: 0.72 })};
 * `
 *
 * // CSS in JS Output
 * element {
 *   background: "#ffcd64";
 *   background: "rgba(255,205,100,0.72)";
 *   background: "#00f";
 *   background: "rgba(179,25,25,0.72)";
 * }
 */

function toColorString(color) {
  if (typeof color !== 'object') throw new _errors["default"](8);
  if (isRgba(color)) return (0, _rgba["default"])(color);
  if (isRgb(color)) return (0, _rgb["default"])(color);
  if (isHsla(color)) return (0, _hsla["default"])(color);
  if (isHsl(color)) return (0, _hsl["default"])(color);
  throw new _errors["default"](8);
}
module.exports = exports.default;
});

unwrapExports(toColorString_1);

var require$$0 = _curry;

var require$$1 = _guard;

var require$$2 = parseToHsl_1;

var require$$3 = toColorString_1;

var lighten_1 = createCommonjsModule(function (module, exports) {

exports.__esModule = true;
exports["default"] = void 0;
var _curry = _interopRequireDefault(require$$0);
var _guard = _interopRequireDefault(require$$1);
var _parseToHsl = _interopRequireDefault(require$$2);
var _toColorString = _interopRequireDefault(require$$3);
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
/**
 * Returns a string value for the lightened color.
 *
 * @example
 * // Styles as object usage
 * const styles = {
 *   background: lighten(0.2, '#CCCD64'),
 *   background: lighten('0.2', 'rgba(204,205,100,0.7)'),
 * }
 *
 * // styled-components usage
 * const div = styled.div`
 *   background: ${lighten(0.2, '#FFCD64')};
 *   background: ${lighten('0.2', 'rgba(204,205,100,0.7)')};
 * `
 *
 * // CSS in JS Output
 *
 * element {
 *   background: "#e5e6b1";
 *   background: "rgba(229,230,177,0.7)";
 * }
 */
function lighten(amount, color) {
  if (color === 'transparent') return color;
  var hslColor = (0, _parseToHsl["default"])(color);
  return (0, _toColorString["default"])(_extends({}, hslColor, {
    lightness: (0, _guard["default"])(0, 1, hslColor.lightness + parseFloat(amount))
  }));
}

// prettier-ignore
var curriedLighten = (0, _curry["default"] /* ::<number | string, string, string> */)(lighten);
exports["default"] = curriedLighten;
module.exports = exports.default;
});

var lighten = unwrapExports(lighten_1);

var SwitchDefault = withStyles$1(function () {
    return createStyles$1({
        root: {
            width: 32,
            height: 20,
            padding: 0,
            display: 'flex',
        },
        switchBase: {
            padding: 2,
            color: theme.colors.white,
            '&$checked': {
                transform: 'translateX(12px)',
                color: "" + theme.colors.white,
                '& + $track': {
                    opacity: 1,
                },
            },
        },
        thumb: {
            width: 16,
            height: 16,
            boxShadow: 'none',
        },
        track: {
            border: "1px solid " + theme.colors.grey400,
            borderRadius: theme.forms.borderRadius * 1.5 + "px",
            opacity: 1,
            backgroundColor: "" + theme.colors.grey400,
        },
        checked: {},
    });
})(Switch$2);
var switchColors = function (color) {
    var backgroundColors = {
        primary: theme.colors.purple600,
        confirm: theme.colors.green500,
    };
    return backgroundColors[color || 'primary'];
};
var SwitchStyled = styled(SwitchDefault)(templateObject_6$b || (templateObject_6$b = __makeTemplateObject(["\n  .MuiIconButton-root:hover {\n    background-color: unset;\n  }\n\n  ", "\n\n  ", "\n\n    ", "\n"], ["\n  .MuiIconButton-root:hover {\n    background-color: unset;\n  }\n\n  ",
    "\n\n  ",
    "\n\n    ",
    "\n"])), function (props) {
    return props.checked && css(templateObject_1$h || (templateObject_1$h = __makeTemplateObject(["\n      .MuiIconButton-label {\n        background-color: ", ";\n        border-radius: 50%;\n      }\n      .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {\n        background-color: ", ";\n        border-color: ", ";\n      }\n    "], ["\n      .MuiIconButton-label {\n        background-color: ", ";\n        border-radius: 50%;\n      }\n      .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track {\n        background-color: ", ";\n        border-color: ", ";\n      }\n    "])), props.theme.colors.grey400, switchColors(props.color), switchColors(props.color));
}, function (props) {
    return props.disabled && css(templateObject_3$f || (templateObject_3$f = __makeTemplateObject(["\n      .MuiIconButton-label {\n        background-color: ", ";\n        border-radius: 50%;\n      }\n\n      .MuiSwitch-thumb {\n        background-color: ", ";\n      }\n      .MuiSwitch-switchBase.Mui-disabled + .MuiSwitch-track {\n        opacity: 1;\n        background-color: ", ";\n        border: 1px solid ", ";\n      }\n\n      ", "\n    "], ["\n      .MuiIconButton-label {\n        background-color: ", ";\n        border-radius: 50%;\n      }\n\n      .MuiSwitch-thumb {\n        background-color: ", ";\n      }\n      .MuiSwitch-switchBase.Mui-disabled + .MuiSwitch-track {\n        opacity: 1;\n        background-color: ", ";\n        border: 1px solid ", ";\n      }\n\n      ",
        "\n    "])), props.theme.colors.grey400, props.theme.colors.white, props.theme.colors.grey200, props.theme.colors.grey200, props.checked && css(templateObject_2$f || (templateObject_2$f = __makeTemplateObject(["\n        .MuiIconButton-label {\n          background-color: ", ";\n          border-radius: 50%;\n        }\n        .MuiSwitch-thumb {\n          background-color: ", ";\n        }\n        .MuiSwitch-switchBase.Mui-disabled + .MuiSwitch-track {\n          opacity: 1;\n          background-color: ", ";\n          border: 1px solid ", ";\n        }\n      "], ["\n        .MuiIconButton-label {\n          background-color: ", ";\n          border-radius: 50%;\n        }\n        .MuiSwitch-thumb {\n          background-color: ", ";\n        }\n        .MuiSwitch-switchBase.Mui-disabled + .MuiSwitch-track {\n          opacity: 1;\n          background-color: ", ";\n          border: 1px solid ", ";\n        }\n      "])), props.theme.colors.grey400, props.theme.colors.white, lighten(0.2, switchColors(props.color)), lighten(0.2, switchColors(props.color))));
}, function (props) {
    return props.error && css(templateObject_5$b || (templateObject_5$b = __makeTemplateObject(["\n      .MuiSwitch-thumb {\n        background-color: ", ";\n      }\n\n      .MuiSwitch-track {\n        background-color: ", ";\n        border: 1px solid ", ";\n      }\n\n      ", "\n    "], ["\n      .MuiSwitch-thumb {\n        background-color: ", ";\n      }\n\n      .MuiSwitch-track {\n        background-color: ", ";\n        border: 1px solid ", ";\n      }\n\n      ",
        "\n    "])), props.theme.colors.red700, props.theme.colors.white, props.theme.colors.red700, props.checked && css(templateObject_4$d || (templateObject_4$d = __makeTemplateObject(["\n        &&& {\n          .MuiSwitch-thumb {\n            background-color: ", ";\n          }\n          .MuiSwitch-track {\n            background-color: ", ";\n            border: 1px solid ", ";\n          }\n        }\n      "], ["\n        &&& {\n          .MuiSwitch-thumb {\n            background-color: ", ";\n          }\n          .MuiSwitch-track {\n            background-color: ", ";\n            border: 1px solid ", ";\n          }\n        }\n      "])), props.theme.colors.white, props.theme.colors.red700, props.theme.colors.red700));
});
var Container$1 = styled.div(templateObject_8$a || (templateObject_8$a = __makeTemplateObject(["\n  ", "\n"], ["\n  ",
    "\n"])), function (props) {
    return props.readOnly && css(templateObject_7$b || (templateObject_7$b = __makeTemplateObject(["\n      display: none;\n    "], ["\n      display: none;\n    "])));
});
var templateObject_1$h, templateObject_2$f, templateObject_3$f, templateObject_4$d, templateObject_5$b, templateObject_6$b, templateObject_7$b, templateObject_8$a;

var Switch = function (props, ref) {
    var onChange = props.onChange, readOnly = props.readOnly, label = props.label, className = props.className, testId = props.testId, textHelper = props.textHelper, error = props.error, checked = props.checked, controled = props.controled, otherProps = __rest(props, ["onChange", "readOnly", "label", "className", "testId", "textHelper", "error", "checked", "controled"]);
    var _a = useState(checked || false), checkedOn = _a[0], setCheckedOn = _a[1];
    var handleSwitch = function (event) {
        if (onChange) {
            onChange(event.target.checked);
        }
        if (!controled) {
            setCheckedOn(event.target.checked);
        }
    };
    var switchLabel = function (children) {
        if (label) {
            var text = label.text, position = label.position;
            var labelText = (React__default.createElement(LabelText, { position: position, size: label.size, error: !!error }, text));
            return (React__default.createElement(Label, { htmlFor: otherProps.id, disabled: otherProps.disabled },
                position === 'left' && labelText,
                children,
                (!position || position === 'right') && labelText));
        }
        return React__default.Children.map(children, function (child) { return React__default.cloneElement(child, { onClick: handleSwitch }); });
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(Container$1, { className: className, readOnly: readOnly === null || readOnly === void 0 ? void 0 : readOnly.active },
            switchLabel([
                React__default.createElement(SwitchStyled, __assign$2({ key: "switch", "data-testid": testId, ref: ref, checked: controled ? checked : checkedOn, onChange: handleSwitch, error: error }, otherProps)),
            ]),
            ((error && typeof error === 'string') || textHelper) && React__default.createElement(StyledHelperInput, { error: error }, error || textHelper)),
        (readOnly === null || readOnly === void 0 ? void 0 : readOnly.active) && React__default.createElement(ReadOnlyField, { label: label.text, value: readOnly === null || readOnly === void 0 ? void 0 : readOnly.value, testId: testId })));
};
var Switch$1 = forwardRef(Switch);

var StyledCard = styled.div(templateObject_2$e || (templateObject_2$e = __makeTemplateObject(["\n  width: 100%;\n  padding: ", "px;\n  border-radius: ", "px;\n  background-color: ", ";\n  box-shadow: 0px 2px 5px ", ";\n\n  ", "\n"], ["\n  width: 100%;\n  padding: ", "px;\n  border-radius: ", "px;\n  background-color: ", ";\n  box-shadow: 0px 2px 5px ", ";\n\n  ",
    "\n"])), function (props) { return props.theme.global.gutterSpace; }, function (props) { return props.theme.forms.borderRadius; }, function (props) { return props.theme.colors.white; }, function (props) { return rgba(props.theme.colors.grey400, 0.25); }, function (props) {
    return props.isForm && css(templateObject_1$g || (templateObject_1$g = __makeTemplateObject(["\n      padding: ", "px;\n    "], ["\n      padding: ", "px;\n    "])), props.theme.global.gutterSpace * 1.5);
});
var CardTitle = styled.h1(templateObject_3$e || (templateObject_3$e = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  margin-bottom: ", "px;\n  line-height: 19px;\n  font-size: ", ";\n  font-weight: 600;\n  color: ", ";\n\n  svg:first-child {\n    margin-right: ", "px;\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  margin-bottom: ", "px;\n  line-height: 19px;\n  font-size: ", ";\n  font-weight: 600;\n  color: ", ";\n\n  svg:first-child {\n    margin-right: ", "px;\n  }\n"])), function (props) { return (props.noGutterTitle ? '0' : props.theme.global.gutterSpace / 2); }, function (props) { return props.theme.fontSizes[3]; }, function (props) { return props.theme.colors.grey900; }, function (props) { return props.theme.global.gutterSpace / 2; });
var CardDescription = styled.div(templateObject_4$c || (templateObject_4$c = __makeTemplateObject(["\n  width: 100%;\n  line-height: 18px;\n  font-size: ", ";\n  color: ", ";\n"], ["\n  width: 100%;\n  line-height: 18px;\n  font-size: ", ";\n  color: ", ";\n"])), function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.colors.grey700; });
var templateObject_1$g, templateObject_2$e, templateObject_3$e, templateObject_4$c;

var Card = function (props) {
    var className = props.className, testId = props.testId, title = props.title, noGutterTitle = props.noGutterTitle, children = props.children, icon = props.icon, actions = props.actions, isForm = props.isForm;
    return (React__default.createElement(StyledCard, { className: className, "data-testid": testId, hasIcon: !!icon, isForm: isForm },
        React__default.createElement(CardTitle, { noGutterTitle: noGutterTitle },
            icon,
            title),
        React__default.createElement(CardDescription, null, children),
        actions && React__default.createElement("div", null, actions)));
};

var Tabs = styled(Tabs$1)(templateObject_1$f || (templateObject_1$f = __makeTemplateObject(["\n  overflow-x: auto;\n  &.MuiTabs-root {\n    min-height: unset;\n    border-radius: ", "px;\n  }\n\n  & .MuiTabs-flexContainer {\n    border-radius: ", "px;\n    background-color: ", ";\n  }\n  && {\n    button {\n      padding: ", "px ", "px;\n      min-width: unset;\n      min-height: unset;\n      font-size: ", ";\n      line-height: ", "px;\n      text-transform: none;\n      font-family: ", ";\n      color: ", ";\n      opacity: 1;\n      transition: box-shadow 100ms, background-color 200ms ease-in-out;\n      background-color: ", ";\n      border-radius: ", ";\n\n      &.MuiTab-textColorInherit {\n        border-radius: ", "px;\n      }\n\n      &:hover {\n        background-color: ", ";\n      }\n\n      &.Mui-selected {\n        color: white;\n        border-radius: ", "px;\n        background-color: ", ";\n        font-weight: 600;\n        &:hover {\n          background-color: ", ";\n        }\n      }\n    }\n  }\n"], ["\n  overflow-x: auto;\n  &.MuiTabs-root {\n    min-height: unset;\n    border-radius: ", "px;\n  }\n\n  & .MuiTabs-flexContainer {\n    border-radius: ", "px;\n    background-color: ", ";\n  }\n  && {\n    button {\n      padding: ", "px ", "px;\n      min-width: unset;\n      min-height: unset;\n      font-size: ", ";\n      line-height: ", "px;\n      text-transform: none;\n      font-family: ", ";\n      color: ", ";\n      opacity: 1;\n      transition: box-shadow 100ms, background-color 200ms ease-in-out;\n      background-color: ", ";\n      border-radius: ", ";\n\n      &.MuiTab-textColorInherit {\n        border-radius: ", "px;\n      }\n\n      &:hover {\n        background-color: ", ";\n      }\n\n      &.Mui-selected {\n        color: white;\n        border-radius: ", "px;\n        background-color: ", ";\n        font-weight: 600;\n        &:hover {\n          background-color: ", ";\n        }\n      }\n    }\n  }\n"])), function (props) { return props.theme.forms.borderRadius * 2.5; }, function (props) { return props.theme.forms.borderRadius * 2.5; }, function (props) { return props.theme.colors.grey100; }, function (props) { return props.theme.global.gutterSpace * 0.75; }, function (props) { return props.theme.global.gutterSpace * 2; }, function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.global.gutterSpace; }, function (props) { return props.theme.global.defaultFont; }, function (props) { return props.theme.colors.grey700; }, function (props) { return props.theme.colors.grey100; }, function (props) { return props.theme.colors.white; }, function (props) { return props.theme.forms.borderRadius * 2.5; }, curriedDarken$1(0.05, "" + theme.colors.grey100), function (props) { return props.theme.forms.borderRadius * 2.5; }, function (props) { return props.theme.colors.purple600; }, curriedDarken$1(0.05, "" + theme.colors.purple600));
var LabelContainer = styled.div(templateObject_2$d || (templateObject_2$d = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var BadgeContainer = styled.div(templateObject_4$b || (templateObject_4$b = __makeTemplateObject(["\n  position: absolute;\n  top: -11px;\n  right: -24px;\n\n  ", "\n"], ["\n  position: absolute;\n  top: -11px;\n  right: -24px;\n\n  ",
    "\n"])), function (props) {
    return !props.hasChildren && css(templateObject_3$d || (templateObject_3$d = __makeTemplateObject(["\n      top: -10px;\n      right: -10px;\n    "], ["\n      top: -10px;\n      right: -10px;\n    "])));
});
var templateObject_1$f, templateObject_2$d, templateObject_3$d, templateObject_4$b;

var SimpleTabs = function (props) {
    var testId = props.testId, children = props.children, className = props.className, others = __rest(props, ["testId", "children", "className"]);
    return (React__default.createElement(Tabs, __assign$2({}, others, { TabIndicatorProps: { style: { height: 0 } }, "data-testid": testId, "aria-label": "agilize tab", className: className }), children));
};

var TabPanel = function (props) {
    var value = props.value, index = props.index, children = props.children, testId = props.testId, className = props.className;
    return (React__default.createElement("div", { role: "tabpanel", hidden: value !== index, "data-testid": testId, id: "simple-tabpanel-" + index, "aria-labelledby": "simple-tab-" + index, className: className }, value === index && children));
};

var TabLabel = function (props) {
    var testId = props.testId, badge = props.badge, label = props.label, otherProps = __rest(props, ["testId", "badge", "label"]);
    var renderLabel = function () {
        if (badge) {
            return (React__default.createElement(LabelContainer, null,
                label,
                React__default.createElement(BadgeContainer, { hasChildren: !!badge.children },
                    React__default.createElement(Badge, __assign$2({}, badge)))));
        }
        return label;
    };
    return React__default.createElement(Tab, __assign$2({ "data-testid": testId, label: renderLabel() }, otherProps));
};

function _arrayWithHoles(r) {
  if (Array.isArray(r)) return r;
}

function _iterableToArrayLimit(r, l) {
  var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (null != t) {
    var e,
      n,
      i,
      u,
      a = [],
      f = !0,
      o = !1;
    try {
      if (i = (t = t.call(r)).next, 0 === l) {
        if (Object(t) !== t) return;
        f = !1;
      } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0);
    } catch (r) {
      o = !0, n = r;
    } finally {
      try {
        if (!f && null != t["return"] && (u = t["return"](), Object(u) !== u)) return;
      } finally {
        if (o) throw n;
      }
    }
    return a;
  }
}

function _nonIterableRest() {
  throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _slicedToArray(r, e) {
  return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray$2(r, e) || _nonIterableRest();
}

// Give up on IE 11 support for this feature

function stripDiacritics(string) {
  return typeof string.normalize !== 'undefined' ? string.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : string;
}

function createFilterOptions() {
  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var _config$ignoreAccents = config.ignoreAccents,
      ignoreAccents = _config$ignoreAccents === void 0 ? true : _config$ignoreAccents,
      _config$ignoreCase = config.ignoreCase,
      ignoreCase = _config$ignoreCase === void 0 ? true : _config$ignoreCase,
      limit = config.limit,
      _config$matchFrom = config.matchFrom,
      matchFrom = _config$matchFrom === void 0 ? 'any' : _config$matchFrom,
      stringify = config.stringify,
      _config$trim = config.trim,
      trim = _config$trim === void 0 ? false : _config$trim;
  return function (options, _ref) {
    var inputValue = _ref.inputValue,
        getOptionLabel = _ref.getOptionLabel;
    var input = trim ? inputValue.trim() : inputValue;

    if (ignoreCase) {
      input = input.toLowerCase();
    }

    if (ignoreAccents) {
      input = stripDiacritics(input);
    }

    var filteredOptions = options.filter(function (option) {
      var candidate = (stringify || getOptionLabel)(option);

      if (ignoreCase) {
        candidate = candidate.toLowerCase();
      }

      if (ignoreAccents) {
        candidate = stripDiacritics(candidate);
      }

      return matchFrom === 'start' ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
    });
    return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
  };
} // To replace with .findIndex() once we stop IE 11 support.

function findIndex(array, comp) {
  for (var i = 0; i < array.length; i += 1) {
    if (comp(array[i])) {
      return i;
    }
  }

  return -1;
}

var defaultFilterOptions = createFilterOptions(); // Number of options to jump in list box when pageup and pagedown keys are used.

var pageSize = 5;
function useAutocomplete(props) {
  var _props$autoComplete = props.autoComplete,
      autoComplete = _props$autoComplete === void 0 ? false : _props$autoComplete,
      _props$autoHighlight = props.autoHighlight,
      autoHighlight = _props$autoHighlight === void 0 ? false : _props$autoHighlight,
      _props$autoSelect = props.autoSelect,
      autoSelect = _props$autoSelect === void 0 ? false : _props$autoSelect,
      _props$blurOnSelect = props.blurOnSelect,
      blurOnSelect = _props$blurOnSelect === void 0 ? false : _props$blurOnSelect,
      _props$clearOnBlur = props.clearOnBlur,
      clearOnBlur = _props$clearOnBlur === void 0 ? !props.freeSolo : _props$clearOnBlur,
      _props$clearOnEscape = props.clearOnEscape,
      clearOnEscape = _props$clearOnEscape === void 0 ? false : _props$clearOnEscape,
      _props$componentName = props.componentName,
      componentName = _props$componentName === void 0 ? 'useAutocomplete' : _props$componentName,
      _props$debug = props.debug,
      debug = _props$debug === void 0 ? false : _props$debug,
      _props$defaultValue = props.defaultValue,
      defaultValue = _props$defaultValue === void 0 ? props.multiple ? [] : null : _props$defaultValue,
      _props$disableClearab = props.disableClearable,
      disableClearable = _props$disableClearab === void 0 ? false : _props$disableClearab,
      _props$disableCloseOn = props.disableCloseOnSelect,
      disableCloseOnSelect = _props$disableCloseOn === void 0 ? false : _props$disableCloseOn,
      _props$disabledItemsF = props.disabledItemsFocusable,
      disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF,
      _props$disableListWra = props.disableListWrap,
      disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra,
      _props$filterOptions = props.filterOptions,
      filterOptions = _props$filterOptions === void 0 ? defaultFilterOptions : _props$filterOptions,
      _props$filterSelected = props.filterSelectedOptions,
      filterSelectedOptions = _props$filterSelected === void 0 ? false : _props$filterSelected,
      _props$freeSolo = props.freeSolo,
      freeSolo = _props$freeSolo === void 0 ? false : _props$freeSolo,
      getOptionDisabled = props.getOptionDisabled,
      _props$getOptionLabel = props.getOptionLabel,
      getOptionLabelProp = _props$getOptionLabel === void 0 ? function (option) {
    return option;
  } : _props$getOptionLabel,
      _props$getOptionSelec = props.getOptionSelected,
      getOptionSelected = _props$getOptionSelec === void 0 ? function (option, value) {
    return option === value;
  } : _props$getOptionSelec,
      groupBy = props.groupBy,
      _props$handleHomeEndK = props.handleHomeEndKeys,
      handleHomeEndKeys = _props$handleHomeEndK === void 0 ? !props.freeSolo : _props$handleHomeEndK,
      idProp = props.id,
      _props$includeInputIn = props.includeInputInList,
      includeInputInList = _props$includeInputIn === void 0 ? false : _props$includeInputIn,
      inputValueProp = props.inputValue,
      _props$multiple = props.multiple,
      multiple = _props$multiple === void 0 ? false : _props$multiple,
      onChange = props.onChange,
      onClose = props.onClose,
      onHighlightChange = props.onHighlightChange,
      onInputChange = props.onInputChange,
      onOpen = props.onOpen,
      openProp = props.open,
      _props$openOnFocus = props.openOnFocus,
      openOnFocus = _props$openOnFocus === void 0 ? false : _props$openOnFocus,
      options = props.options,
      _props$selectOnFocus = props.selectOnFocus,
      selectOnFocus = _props$selectOnFocus === void 0 ? !props.freeSolo : _props$selectOnFocus,
      valueProp = props.value;
  var id = unstable_useId(idProp);
  var getOptionLabel = getOptionLabelProp;

  if (process.env.NODE_ENV !== 'production') {
    getOptionLabel = function getOptionLabel(option) {
      var optionLabel = getOptionLabelProp(option);

      if (typeof optionLabel !== 'string') {
        var erroneousReturn = optionLabel === undefined ? 'undefined' : "".concat(_typeof(optionLabel), " (").concat(optionLabel, ")");
        console.error("Material-UI: The `getOptionLabel` method of ".concat(componentName, " returned ").concat(erroneousReturn, " instead of a string for ").concat(JSON.stringify(option), "."));
      }

      return optionLabel;
    };
  }

  var ignoreFocus = React.useRef(false);
  var firstFocus = React.useRef(true);
  var inputRef = React.useRef(null);
  var listboxRef = React.useRef(null);

  var _React$useState = React.useState(null),
      anchorEl = _React$useState[0],
      setAnchorEl = _React$useState[1];

  var _React$useState2 = React.useState(-1),
      focusedTag = _React$useState2[0],
      setFocusedTag = _React$useState2[1];

  var defaultHighlighted = autoHighlight ? 0 : -1;
  var highlightedIndexRef = React.useRef(defaultHighlighted);

  var _useControlled = useControlled({
    controlled: valueProp,
    default: defaultValue,
    name: componentName
  }),
      _useControlled2 = _slicedToArray(_useControlled, 2),
      value = _useControlled2[0],
      setValue = _useControlled2[1];

  var _useControlled3 = useControlled({
    controlled: inputValueProp,
    default: '',
    name: componentName,
    state: 'inputValue'
  }),
      _useControlled4 = _slicedToArray(_useControlled3, 2),
      inputValue = _useControlled4[0],
      setInputValue = _useControlled4[1];

  var _React$useState3 = React.useState(false),
      focused = _React$useState3[0],
      setFocused = _React$useState3[1];

  var resetInputValue = useEventCallback(function (event, newValue) {
    var newInputValue;

    if (multiple) {
      newInputValue = '';
    } else if (newValue == null) {
      newInputValue = '';
    } else {
      var optionLabel = getOptionLabel(newValue);
      newInputValue = typeof optionLabel === 'string' ? optionLabel : '';
    }

    if (inputValue === newInputValue) {
      return;
    }

    setInputValue(newInputValue);

    if (onInputChange) {
      onInputChange(event, newInputValue, 'reset');
    }
  });
  React.useEffect(function () {
    resetInputValue(null, value);
  }, [value, resetInputValue]);

  var _useControlled5 = useControlled({
    controlled: openProp,
    default: false,
    name: componentName,
    state: 'open'
  }),
      _useControlled6 = _slicedToArray(_useControlled5, 2),
      open = _useControlled6[0],
      setOpenState = _useControlled6[1];

  var inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
  var popupOpen = open;
  var filteredOptions = popupOpen ? filterOptions(options.filter(function (option) {
    if (filterSelectedOptions && (multiple ? value : [value]).some(function (value2) {
      return value2 !== null && getOptionSelected(option, value2);
    })) {
      return false;
    }

    return true;
  }), // we use the empty string to manipulate `filterOptions` to not filter any options
  // i.e. the filter predicate always returns true
  {
    inputValue: inputValueIsSelectedValue ? '' : inputValue,
    getOptionLabel: getOptionLabel
  }) : [];

  if (process.env.NODE_ENV !== 'production') {
    if (value !== null && !freeSolo && options.length > 0) {
      var missingValue = (multiple ? value : [value]).filter(function (value2) {
        return !options.some(function (option) {
          return getOptionSelected(option, value2);
        });
      });

      if (missingValue.length > 0) {
        console.warn(["Material-UI: The value provided to ".concat(componentName, " is invalid."), "None of the options match with `".concat(missingValue.length > 1 ? JSON.stringify(missingValue) : JSON.stringify(missingValue[0]), "`."), 'You can use the `getOptionSelected` prop to customize the equality test.'].join('\n'));
      }
    }
  }

  var focusTag = useEventCallback(function (tagToFocus) {
    if (tagToFocus === -1) {
      inputRef.current.focus();
    } else {
      anchorEl.querySelector("[data-tag-index=\"".concat(tagToFocus, "\"]")).focus();
    }
  }); // Ensure the focusedTag is never inconsistent

  React.useEffect(function () {
    if (multiple && focusedTag > value.length - 1) {
      setFocusedTag(-1);
      focusTag(-1);
    }
  }, [value, multiple, focusedTag, focusTag]);

  function validOptionIndex(index, direction) {
    if (!listboxRef.current || index === -1) {
      return -1;
    }

    var nextFocus = index;

    while (true) {
      // Out of range
      if (direction === 'next' && nextFocus === filteredOptions.length || direction === 'previous' && nextFocus === -1) {
        return -1;
      }

      var option = listboxRef.current.querySelector("[data-option-index=\"".concat(nextFocus, "\"]")); // Same logic as MenuList.js

      var nextFocusDisabled = disabledItemsFocusable ? false : option && (option.disabled || option.getAttribute('aria-disabled') === 'true');

      if (option && !option.hasAttribute('tabindex') || nextFocusDisabled) {
        // Move to the next element.
        nextFocus += direction === 'next' ? 1 : -1;
      } else {
        return nextFocus;
      }
    }
  }

  var setHighlightedIndex = useEventCallback(function (_ref2) {
    var event = _ref2.event,
        index = _ref2.index,
        _ref2$reason = _ref2.reason,
        reason = _ref2$reason === void 0 ? 'auto' : _ref2$reason;
    highlightedIndexRef.current = index; // does the index exist?

    if (index === -1) {
      inputRef.current.removeAttribute('aria-activedescendant');
    } else {
      inputRef.current.setAttribute('aria-activedescendant', "".concat(id, "-option-").concat(index));
    }

    if (onHighlightChange) {
      onHighlightChange(event, index === -1 ? null : filteredOptions[index], reason);
    }

    if (!listboxRef.current) {
      return;
    }

    var prev = listboxRef.current.querySelector('[data-focus]');

    if (prev) {
      prev.removeAttribute('data-focus');
    }

    var listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]'); // "No results"

    if (!listboxNode) {
      return;
    }

    if (index === -1) {
      listboxNode.scrollTop = 0;
      return;
    }

    var option = listboxRef.current.querySelector("[data-option-index=\"".concat(index, "\"]"));

    if (!option) {
      return;
    }

    option.setAttribute('data-focus', 'true'); // Scroll active descendant into view.
    // Logic copied from https://www.w3.org/TR/wai-aria-practices/examples/listbox/js/listbox.js
    //
    // Consider this API instead once it has a better browser support:
    // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });

    if (listboxNode.scrollHeight > listboxNode.clientHeight && reason !== 'mouse') {
      var element = option;
      var scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
      var elementBottom = element.offsetTop + element.offsetHeight;

      if (elementBottom > scrollBottom) {
        listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
      } else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) {
        listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
      }
    }
  });
  var changeHighlightedIndex = useEventCallback(function (_ref3) {
    var event = _ref3.event,
        diff = _ref3.diff,
        _ref3$direction = _ref3.direction,
        direction = _ref3$direction === void 0 ? 'next' : _ref3$direction,
        _ref3$reason = _ref3.reason,
        reason = _ref3$reason === void 0 ? 'auto' : _ref3$reason;

    if (!popupOpen) {
      return;
    }

    var getNextIndex = function getNextIndex() {
      var maxIndex = filteredOptions.length - 1;

      if (diff === 'reset') {
        return defaultHighlighted;
      }

      if (diff === 'start') {
        return 0;
      }

      if (diff === 'end') {
        return maxIndex;
      }

      var newIndex = highlightedIndexRef.current + diff;

      if (newIndex < 0) {
        if (newIndex === -1 && includeInputInList) {
          return -1;
        }

        if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) {
          return 0;
        }

        return maxIndex;
      }

      if (newIndex > maxIndex) {
        if (newIndex === maxIndex + 1 && includeInputInList) {
          return -1;
        }

        if (disableListWrap || Math.abs(diff) > 1) {
          return maxIndex;
        }

        return 0;
      }

      return newIndex;
    };

    var nextIndex = validOptionIndex(getNextIndex(), direction);
    setHighlightedIndex({
      index: nextIndex,
      reason: reason,
      event: event
    }); // Sync the content of the input with the highlighted option.

    if (autoComplete && diff !== 'reset') {
      if (nextIndex === -1) {
        inputRef.current.value = inputValue;
      } else {
        var option = getOptionLabel(filteredOptions[nextIndex]);
        inputRef.current.value = option; // The portion of the selected suggestion that has not been typed by the user,
        // a completion string, appears inline after the input cursor in the textbox.

        var index = option.toLowerCase().indexOf(inputValue.toLowerCase());

        if (index === 0 && inputValue.length > 0) {
          inputRef.current.setSelectionRange(inputValue.length, option.length);
        }
      }
    }
  });
  var syncHighlightedIndex = React.useCallback(function () {
    if (!popupOpen) {
      return;
    }

    var valueItem = multiple ? value[0] : value; // The popup is empty, reset

    if (filteredOptions.length === 0 || valueItem == null) {
      changeHighlightedIndex({
        diff: 'reset'
      });
      return;
    }

    if (!listboxRef.current) {
      return;
    } // Synchronize the value with the highlighted index


    if (!filterSelectedOptions && valueItem != null) {
      var currentOption = filteredOptions[highlightedIndexRef.current]; // Keep the current highlighted index if possible

      if (multiple && currentOption && findIndex(value, function (val) {
        return getOptionSelected(currentOption, val);
      }) !== -1) {
        return;
      }

      var itemIndex = findIndex(filteredOptions, function (optionItem) {
        return getOptionSelected(optionItem, valueItem);
      });

      if (itemIndex === -1) {
        changeHighlightedIndex({
          diff: 'reset'
        });
      } else {
        setHighlightedIndex({
          index: itemIndex
        });
      }

      return;
    } // Prevent the highlighted index to leak outside the boundaries.


    if (highlightedIndexRef.current >= filteredOptions.length - 1) {
      setHighlightedIndex({
        index: filteredOptions.length - 1
      });
      return;
    } // Restore the focus to the previous index.


    setHighlightedIndex({
      index: highlightedIndexRef.current
    }); // Ignore filteredOptions (and options, getOptionSelected, getOptionLabel) not to break the scroll position
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [// Only sync the highlighted index when the option switch between empty and not
  // eslint-disable-next-line react-hooks/exhaustive-deps
  filteredOptions.length === 0, // Don't sync the highlighted index with the value when multiple
  // eslint-disable-next-line react-hooks/exhaustive-deps
  multiple ? false : value, filterSelectedOptions, changeHighlightedIndex, setHighlightedIndex, popupOpen, inputValue, multiple]);
  var handleListboxRef = useEventCallback(function (node) {
    setRef$1(listboxRef, node);

    if (!node) {
      return;
    }

    syncHighlightedIndex();
  });
  React.useEffect(function () {
    syncHighlightedIndex();
  }, [syncHighlightedIndex]);

  var handleOpen = function handleOpen(event) {
    if (open) {
      return;
    }

    setOpenState(true);

    if (onOpen) {
      onOpen(event);
    }
  };

  var handleClose = function handleClose(event, reason) {
    if (!open) {
      return;
    }

    setOpenState(false);

    if (onClose) {
      onClose(event, reason);
    }
  };

  var handleValue = function handleValue(event, newValue, reason, details) {
    if (value === newValue) {
      return;
    }

    if (onChange) {
      onChange(event, newValue, reason, details);
    }

    setValue(newValue);
  };

  var isTouch = React.useRef(false);

  var selectNewValue = function selectNewValue(event, option) {
    var reasonProp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'select-option';
    var origin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'options';
    var reason = reasonProp;
    var newValue = option;

    if (multiple) {
      newValue = Array.isArray(value) ? value.slice() : [];

      if (process.env.NODE_ENV !== 'production') {
        var matches = newValue.filter(function (val) {
          return getOptionSelected(option, val);
        });

        if (matches.length > 1) {
          console.error(["Material-UI: The `getOptionSelected` method of ".concat(componentName, " do not handle the arguments correctly."), "The component expects a single value to match a given option but found ".concat(matches.length, " matches.")].join('\n'));
        }
      }

      var itemIndex = findIndex(newValue, function (valueItem) {
        return getOptionSelected(option, valueItem);
      });

      if (itemIndex === -1) {
        newValue.push(option);
      } else if (origin !== 'freeSolo') {
        newValue.splice(itemIndex, 1);
        reason = 'remove-option';
      }
    }

    resetInputValue(event, newValue);
    handleValue(event, newValue, reason, {
      option: option
    });

    if (!disableCloseOnSelect) {
      handleClose(event, reason);
    }

    if (blurOnSelect === true || blurOnSelect === 'touch' && isTouch.current || blurOnSelect === 'mouse' && !isTouch.current) {
      inputRef.current.blur();
    }
  };

  function validTagIndex(index, direction) {
    if (index === -1) {
      return -1;
    }

    var nextFocus = index;

    while (true) {
      // Out of range
      if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) {
        return -1;
      }

      var option = anchorEl.querySelector("[data-tag-index=\"".concat(nextFocus, "\"]")); // Same logic as MenuList.js

      if (option && (!option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true')) {
        nextFocus += direction === 'next' ? 1 : -1;
      } else {
        return nextFocus;
      }
    }
  }

  var handleFocusTag = function handleFocusTag(event, direction) {
    if (!multiple) {
      return;
    }

    handleClose(event, 'toggleInput');
    var nextTag = focusedTag;

    if (focusedTag === -1) {
      if (inputValue === '' && direction === 'previous') {
        nextTag = value.length - 1;
      }
    } else {
      nextTag += direction === 'next' ? 1 : -1;

      if (nextTag < 0) {
        nextTag = 0;
      }

      if (nextTag === value.length) {
        nextTag = -1;
      }
    }

    nextTag = validTagIndex(nextTag, direction);
    setFocusedTag(nextTag);
    focusTag(nextTag);
  };

  var handleClear = function handleClear(event) {
    ignoreFocus.current = true;
    setInputValue('');

    if (onInputChange) {
      onInputChange(event, '', 'clear');
    }

    handleValue(event, multiple ? [] : null, 'clear');
  };

  var handleKeyDown = function handleKeyDown(other) {
    return function (event) {
      if (focusedTag !== -1 && ['ArrowLeft', 'ArrowRight'].indexOf(event.key) === -1) {
        setFocusedTag(-1);
        focusTag(-1);
      }

      switch (event.key) {
        case 'Home':
          if (popupOpen && handleHomeEndKeys) {
            // Prevent scroll of the page
            event.preventDefault();
            changeHighlightedIndex({
              diff: 'start',
              direction: 'next',
              reason: 'keyboard',
              event: event
            });
          }

          break;

        case 'End':
          if (popupOpen && handleHomeEndKeys) {
            // Prevent scroll of the page
            event.preventDefault();
            changeHighlightedIndex({
              diff: 'end',
              direction: 'previous',
              reason: 'keyboard',
              event: event
            });
          }

          break;

        case 'PageUp':
          // Prevent scroll of the page
          event.preventDefault();
          changeHighlightedIndex({
            diff: -pageSize,
            direction: 'previous',
            reason: 'keyboard',
            event: event
          });
          handleOpen(event);
          break;

        case 'PageDown':
          // Prevent scroll of the page
          event.preventDefault();
          changeHighlightedIndex({
            diff: pageSize,
            direction: 'next',
            reason: 'keyboard',
            event: event
          });
          handleOpen(event);
          break;

        case 'ArrowDown':
          // Prevent cursor move
          event.preventDefault();
          changeHighlightedIndex({
            diff: 1,
            direction: 'next',
            reason: 'keyboard',
            event: event
          });
          handleOpen(event);
          break;

        case 'ArrowUp':
          // Prevent cursor move
          event.preventDefault();
          changeHighlightedIndex({
            diff: -1,
            direction: 'previous',
            reason: 'keyboard',
            event: event
          });
          handleOpen(event);
          break;

        case 'ArrowLeft':
          handleFocusTag(event, 'previous');
          break;

        case 'ArrowRight':
          handleFocusTag(event, 'next');
          break;

        case 'Enter':
          // Wait until IME is settled.
          if (event.which === 229) {
            break;
          }

          if (highlightedIndexRef.current !== -1 && popupOpen) {
            var option = filteredOptions[highlightedIndexRef.current];
            var disabled = getOptionDisabled ? getOptionDisabled(option) : false; // We don't want to validate the form.

            event.preventDefault();

            if (disabled) {
              return;
            }

            selectNewValue(event, option, 'select-option'); // Move the selection to the end.

            if (autoComplete) {
              inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
            }
          } else if (freeSolo && inputValue !== '' && inputValueIsSelectedValue === false) {
            if (multiple) {
              // Allow people to add new values before they submit the form.
              event.preventDefault();
            }

            selectNewValue(event, inputValue, 'create-option', 'freeSolo');
          }

          break;

        case 'Escape':
          if (popupOpen) {
            // Avoid Opera to exit fullscreen mode.
            event.preventDefault(); // Avoid the Modal to handle the event.

            event.stopPropagation();
            handleClose(event, 'escape');
          } else if (clearOnEscape && (inputValue !== '' || multiple && value.length > 0)) {
            // Avoid Opera to exit fullscreen mode.
            event.preventDefault(); // Avoid the Modal to handle the event.

            event.stopPropagation();
            handleClear(event);
          }

          break;

        case 'Backspace':
          if (multiple && inputValue === '' && value.length > 0) {
            var index = focusedTag === -1 ? value.length - 1 : focusedTag;
            var newValue = value.slice();
            newValue.splice(index, 1);
            handleValue(event, newValue, 'remove-option', {
              option: value[index]
            });
          }

          break;
      }

      if (other.onKeyDown) {
        other.onKeyDown(event);
      }
    };
  };

  var handleFocus = function handleFocus(event) {
    setFocused(true);

    if (openOnFocus && !ignoreFocus.current) {
      handleOpen(event);
    }
  };

  var handleBlur = function handleBlur(event) {
    // Ignore the event when using the scrollbar with IE 11
    if (listboxRef.current !== null && document.activeElement === listboxRef.current.parentElement) {
      inputRef.current.focus();
      return;
    }

    setFocused(false);
    firstFocus.current = true;
    ignoreFocus.current = false;

    if (debug && inputValue !== '') {
      return;
    }

    if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) {
      selectNewValue(event, filteredOptions[highlightedIndexRef.current], 'blur');
    } else if (autoSelect && freeSolo && inputValue !== '') {
      selectNewValue(event, inputValue, 'blur', 'freeSolo');
    } else if (clearOnBlur) {
      resetInputValue(event, value);
    }

    handleClose(event, 'blur');
  };

  var handleInputChange = function handleInputChange(event) {
    var newValue = event.target.value;

    if (inputValue !== newValue) {
      setInputValue(newValue);

      if (onInputChange) {
        onInputChange(event, newValue, 'input');
      }
    }

    if (newValue === '') {
      if (!disableClearable && !multiple) {
        handleValue(event, null, 'clear');
      }
    } else {
      handleOpen(event);
    }
  };

  var handleOptionMouseOver = function handleOptionMouseOver(event) {
    setHighlightedIndex({
      event: event,
      index: Number(event.currentTarget.getAttribute('data-option-index')),
      reason: 'mouse'
    });
  };

  var handleOptionTouchStart = function handleOptionTouchStart() {
    isTouch.current = true;
  };

  var handleOptionClick = function handleOptionClick(event) {
    var index = Number(event.currentTarget.getAttribute('data-option-index'));
    selectNewValue(event, filteredOptions[index], 'select-option');
    isTouch.current = false;
  };

  var handleTagDelete = function handleTagDelete(index) {
    return function (event) {
      var newValue = value.slice();
      newValue.splice(index, 1);
      handleValue(event, newValue, 'remove-option', {
        option: value[index]
      });
    };
  };

  var handlePopupIndicator = function handlePopupIndicator(event) {
    if (open) {
      handleClose(event, 'toggleInput');
    } else {
      handleOpen(event);
    }
  }; // Prevent input blur when interacting with the combobox


  var handleMouseDown = function handleMouseDown(event) {
    if (event.target.getAttribute('id') !== id) {
      event.preventDefault();
    }
  }; // Focus the input when interacting with the combobox


  var handleClick = function handleClick() {
    inputRef.current.focus();

    if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) {
      inputRef.current.select();
    }

    firstFocus.current = false;
  };

  var handleInputMouseDown = function handleInputMouseDown(event) {
    if (inputValue === '' || !open) {
      handlePopupIndicator(event);
    }
  };

  var dirty = freeSolo && inputValue.length > 0;
  dirty = dirty || (multiple ? value.length > 0 : value !== null);
  var groupedOptions = filteredOptions;

  if (groupBy) {
    // used to keep track of key and indexes in the result array
    var indexBy = new Map();
    var warn = false;
    groupedOptions = filteredOptions.reduce(function (acc, option, index) {
      var group = groupBy(option);

      if (acc.length > 0 && acc[acc.length - 1].group === group) {
        acc[acc.length - 1].options.push(option);
      } else {
        if (process.env.NODE_ENV !== 'production') {
          if (indexBy.get(group) && !warn) {
            console.warn("Material-UI: The options provided combined with the `groupBy` method of ".concat(componentName, " returns duplicated headers."), 'You can solve the issue by sorting the options with the output of `groupBy`.');
            warn = true;
          }

          indexBy.set(group, true);
        }

        acc.push({
          key: index,
          index: index,
          group: group,
          options: [option]
        });
      }

      return acc;
    }, []);
  }

  return {
    getRootProps: function getRootProps() {
      var other = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
      return _extends({
        'aria-owns': popupOpen ? "".concat(id, "-popup") : null,
        role: 'combobox',
        'aria-expanded': popupOpen
      }, other, {
        onKeyDown: handleKeyDown(other),
        onMouseDown: handleMouseDown,
        onClick: handleClick
      });
    },
    getInputLabelProps: function getInputLabelProps() {
      return {
        id: "".concat(id, "-label"),
        htmlFor: id
      };
    },
    getInputProps: function getInputProps() {
      return {
        id: id,
        value: inputValue,
        onBlur: handleBlur,
        onFocus: handleFocus,
        onChange: handleInputChange,
        onMouseDown: handleInputMouseDown,
        // if open then this is handled imperativeley so don't let react override
        // only have an opinion about this when closed
        'aria-activedescendant': popupOpen ? '' : null,
        'aria-autocomplete': autoComplete ? 'both' : 'list',
        'aria-controls': popupOpen ? "".concat(id, "-popup") : null,
        // Disable browser's suggestion that might overlap with the popup.
        // Handle autocomplete but not autofill.
        autoComplete: 'off',
        ref: inputRef,
        autoCapitalize: 'none',
        spellCheck: 'false'
      };
    },
    getClearProps: function getClearProps() {
      return {
        tabIndex: -1,
        onClick: handleClear
      };
    },
    getPopupIndicatorProps: function getPopupIndicatorProps() {
      return {
        tabIndex: -1,
        onClick: handlePopupIndicator
      };
    },
    getTagProps: function getTagProps(_ref4) {
      var index = _ref4.index;
      return {
        key: index,
        'data-tag-index': index,
        tabIndex: -1,
        onDelete: handleTagDelete(index)
      };
    },
    getListboxProps: function getListboxProps() {
      return {
        role: 'listbox',
        id: "".concat(id, "-popup"),
        'aria-labelledby': "".concat(id, "-label"),
        ref: handleListboxRef,
        onMouseDown: function onMouseDown(event) {
          // Prevent blur
          event.preventDefault();
        }
      };
    },
    getOptionProps: function getOptionProps(_ref5) {
      var index = _ref5.index,
          option = _ref5.option;
      var selected = (multiple ? value : [value]).some(function (value2) {
        return value2 != null && getOptionSelected(option, value2);
      });
      var disabled = getOptionDisabled ? getOptionDisabled(option) : false;
      return {
        key: index,
        tabIndex: -1,
        role: 'option',
        id: "".concat(id, "-option-").concat(index),
        onMouseOver: handleOptionMouseOver,
        onClick: handleOptionClick,
        onTouchStart: handleOptionTouchStart,
        'data-option-index': index,
        'aria-disabled': disabled,
        'aria-selected': selected
      };
    },
    id: id,
    inputValue: inputValue,
    value: value,
    dirty: dirty,
    popupOpen: popupOpen,
    focused: focused || focusedTag !== -1,
    anchorEl: anchorEl,
    setAnchorEl: setAnchorEl,
    focusedTag: focusedTag,
    groupedOptions: groupedOptions
  };
}

var ContentDataList = styled.div(templateObject_1$e || (templateObject_1$e = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var ArrowButtonContainer = styled.div(templateObject_2$c || (templateObject_2$c = __makeTemplateObject(["\n  position: absolute;\n  right: 10px;\n  width: fit-content;\n  height: fit-content;\n  z-index: ", ";\n"], ["\n  position: absolute;\n  right: 10px;\n  width: fit-content;\n  height: fit-content;\n  z-index: ", ";\n"])), function (props) { return props.theme.zIndex.inputIcon; });
var ArrowButton = styled(FabButton)(templateObject_5$a || (templateObject_5$a = __makeTemplateObject(["\n  &&& {\n    padding: ", "px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    cursor: pointer;\n    transition: background-color 150ms ease-in;\n\n    svg {\n      transition: transform 150ms linear;\n      ", "\n    }\n\n    ", "\n  }\n"], ["\n  &&& {\n    padding: ", "px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: 50%;\n    cursor: pointer;\n    transition: background-color 150ms ease-in;\n\n    svg {\n      transition: transform 150ms linear;\n      ",
    "\n    }\n\n    ",
    "\n  }\n"])), function (props) { return Math.round(props.theme.global.gutterSpace * 0.45); }, function (props) {
    return props.isOpen && css(templateObject_3$c || (templateObject_3$c = __makeTemplateObject(["\n          transform: scale(-1);\n          transform-origin: center;\n        "], ["\n          transform: scale(-1);\n          transform-origin: center;\n        "])));
}, function (props) {
    return props.disabled && css(templateObject_4$a || (templateObject_4$a = __makeTemplateObject(["\n        cursor: not-allowed;\n        background-color: ", ";\n        svg {\n          fill: ", ";\n        }\n      "], ["\n        cursor: not-allowed;\n        background-color: ", ";\n        svg {\n          fill: ", ";\n        }\n      "])), props.theme.colors.grey200, props.theme.colors.grey700);
});
var DataLi = styled.li(templateObject_6$a || (templateObject_6$a = __makeTemplateObject(["\n  padding: ", "px ", "px;\n"], ["\n  padding: ", "px ", "px;\n"])), function (props) { return props.theme.global.gutterSpace / 2; }, function (props) { return props.theme.global.gutterSpace; });
var DataGroupLi = styled.li(templateObject_7$a || (templateObject_7$a = __makeTemplateObject(["\n  padding: 0;\n\n  & > div {\n    margin-top: ", "px;\n    padding: ", "px ", "px;\n    color: ", ";\n    text-transform: uppercase;\n    font-weight: 600;\n    font-size: ", ";\n    line-height: 120%;\n  }\n\n  ul {\n    list-style-type: none;\n    padding: 0;\n    margin: 0;\n  }\n\n  li {\n    padding-left: ", "px;\n  }\n"], ["\n  padding: 0;\n\n  & > div {\n    margin-top: ", "px;\n    padding: ", "px ", "px;\n    color: ", ";\n    text-transform: uppercase;\n    font-weight: 600;\n    font-size: ", ";\n    line-height: 120%;\n  }\n\n  ul {\n    list-style-type: none;\n    padding: 0;\n    margin: 0;\n  }\n\n  li {\n    padding-left: ", "px;\n  }\n"])), function (props) { return props.theme.global.gutterSpace * 0.25; }, function (props) { return props.theme.global.gutterSpace / 2; }, function (props) { return props.theme.global.gutterSpace; }, function (props) { return props.theme.colors.grey700; }, function (props) { return props.theme.fontSizes[1]; }, function (props) { return props.theme.global.gutterSpace * 2; });
var OptionLabel = styled.div(templateObject_10$4 || (templateObject_10$4 = __makeTemplateObject(["\n  position: relative;\n  font-size: ", ";\n  color: ", ";\n  display: flex;\n  align-items: center;\n  line-height: 120%;\n  font-weight: 500;\n  margin-bottom: ", "px;\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  position: relative;\n  font-size: ", ";\n  color: ", ";\n  display: flex;\n  align-items: center;\n  line-height: 120%;\n  font-weight: 500;\n  margin-bottom: ", "px;\n\n  ",
    "\n\n  ",
    "\n\n  ",
    "\n"])), function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.colors.grey900; }, function (props) { return props.theme.global.gutterSpace * 0.25; }, function (props) {
    return props.selected &&
        "\n    font-weight: bold;\n    color: " + props.theme.colors.grey900 + ";\n  ";
}, function (props) {
    return props.isEmptyOption && css(templateObject_8$9 || (templateObject_8$9 = __makeTemplateObject(["\n      color: ", ";\n      font-style: italic;\n    "], ["\n      color: ", ";\n      font-style: italic;\n    "])), props.theme.colors.grey400);
}, function (props) {
    return props.isCreateOption && css(templateObject_9$6 || (templateObject_9$6 = __makeTemplateObject(["\n      color: ", ";\n      font-weight: 400;\n      span {\n        margin-right: ", "px;\n        margin-top: -2px;\n        line-height: 0;\n      }\n\n      &::after {\n        content: '';\n        position: absolute;\n        top: -8px;\n        height: 1px;\n        width: 40%;\n        background-color: ", ";\n        left: 50%;\n        transform: translateX(-50%);\n      }\n    "], ["\n      color: ", ";\n      font-weight: 400;\n      span {\n        margin-right: ", "px;\n        margin-top: -2px;\n        line-height: 0;\n      }\n\n      &::after {\n        content: '';\n        position: absolute;\n        top: -8px;\n        height: 1px;\n        width: 40%;\n        background-color: ", ";\n        left: 50%;\n        transform: translateX(-50%);\n      }\n    "])), props.theme.colors.purple600, props.theme.global.gutterSpace / 4, props.theme.colors.grey100);
});
var OptionThumb = styled.img(templateObject_11$3 || (templateObject_11$3 = __makeTemplateObject(["\n  display: block;\n  border-radius: ", ";\n"], ["\n  display: block;\n  border-radius: ", ";\n"])), function (props) { return (props.thumbRadius ? props.thumbRadius + "px" : '50%'); });
var templateObject_1$e, templateObject_2$c, templateObject_3$c, templateObject_4$a, templateObject_5$a, templateObject_6$a, templateObject_7$a, templateObject_8$9, templateObject_9$6, templateObject_10$4, templateObject_11$3;

var IconPlus = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path  d=\"M19,11H13V5a1,1,0,0,0-2,0v6H5a1,1,0,0,0,0,2h6v6a1,1,0,0,0,2,0V13h6a1,1,0,0,0,0-2Z\"/></svg>";

var filter$1 = createFilterOptions({
    stringify: function (option) {
        var descriptionText = option.description ? renderToString(option.description) : '';
        return option.label + descriptionText;
    },
});
var DataList = function (props, ref) {
    var _a;
    var id = props.id, testId = props.testId, onChange = props.onChange, options = props.options, name = props.name, label = props.label, textHelper = props.textHelper, error = props.error, optional = props.optional, value = props.value, loading = props.loading, onCreateOption = props.onCreateOption, maxHeight = props.maxHeight, disabledCustomOptionCreate = props.disabledCustomOptionCreate, emptyOptionMessage = props.emptyOptionMessage, omitArrow = props.omitArrow, onChangeInput = props.onChangeInput, className = props.className, inputHeight = props.inputHeight, thumbRadius = props.thumbRadius, asSelect = props.asSelect, optionPaddingLeft = props.optionPaddingLeft, optionPaddingRight = props.optionPaddingRight, overflowYOptions = props.overflowYOptions, overflowXOptions = props.overflowXOptions, placeholder = props.placeholder, otherProps = __rest(props, ["id", "testId", "onChange", "options", "name", "label", "textHelper", "error", "optional", "value", "loading", "onCreateOption", "maxHeight", "disabledCustomOptionCreate", "emptyOptionMessage", "omitArrow", "onChangeInput", "className", "inputHeight", "thumbRadius", "asSelect", "optionPaddingLeft", "optionPaddingRight", "overflowYOptions", "overflowXOptions", "placeholder"]);
    var _b = useState(false), localLoading = _b[0], setLocalLoading = _b[1];
    var _c = useState(null), startIcon = _c[0], setStartIcon = _c[1];
    var useStyles = makeStyles(function () {
        return createStyles({
            container: {
                position: 'relative',
            },
            popper: {
                zIndex: theme.zIndex.dropdownList,
                marginTop: theme.global.gutterSpace / 2 + "px",
            },
            dropdownList: {
                margin: 0,
                padding: 0,
                width: '100%',
                maxHeight: maxHeight || '300px',
                boxShadow: theme.global.defaultShadow,
                backgroundColor: theme.colors.white,
                color: theme.colors.grey400,
                fontSize: theme.forms.defaultFontSize,
                border: "1px solid " + theme.colors.grey100,
                borderRadius: theme.forms.borderRadius + "px",
                listStyle: 'none',
                overflow: 'auto',
                overflowY: overflowYOptions || 'auto',
                overflowX: overflowXOptions || 'auto',
                zIndex: theme.zIndex.dropdownList,
            },
            option: {
                paddingLeft: optionPaddingLeft,
                paddingRight: optionPaddingRight,
                minHeight: 'auto',
                alignItems: 'flex-start',
                cursor: 'pointer',
                '&[aria-selected="true"]': {
                    backgroundColor: 'transparent',
                    color: theme.colors.grey400,
                },
                '&[data-focus="true"]': {
                    backgroundColor: theme.colors.purple100,
                    color: theme.colors.grey400,
                },
            },
            optionCreate: {
                '&:hover': {
                    backgroundColor: theme.colors.purple100,
                    color: theme.colors.grey400,
                },
            },
        });
    });
    useEffect(function () {
        setLocalLoading(!!loading);
    }, [loading]);
    var renderThumb = function (thumb, optionValue) {
        if (!optionValue || !thumb) {
            return null;
        }
        if (typeof thumb === 'string') {
            return React__default.createElement(OptionThumb, { src: thumb, width: 24, height: 24, "data-testid": "thumb-" + optionValue, thumbRadius: thumbRadius });
        }
        return React__default.cloneElement(thumb, { width: 24, height: 24, testId: "thumb-" + optionValue });
    };
    var handleChange = function (option) {
        if (onChange) {
            if (onCreateOption && option && option.isCreateOption) {
                return onCreateOption(option.value);
            }
            if (!option) {
                return onChange({ label: '', value: '' });
            }
            var changeLabel = option.label, changeValue = option.value, thumb = option.thumb;
            var optionThumb = renderThumb(thumb, changeValue);
            setStartIcon(optionThumb);
            return onChange({ label: changeLabel, value: changeValue, thumb: optionThumb });
        }
    };
    var classes = useStyles();
    var _d = useAutocomplete({
        options: __spreadArrays([{ label: '', value: '' }], (options || [])),
        value: value,
        onChange: function (_, newValue) { return handleChange(newValue); },
        getOptionLabel: function (option) {
            var notEmptyValue = option.value && option.value !== '';
            if (option.label && option.label !== '' && typeof option.label === 'string' && !option.label.includes('Adicionar ') && notEmptyValue) {
                return option.label;
            }
            if (notEmptyValue) {
                return option.value;
            }
            return '';
        },
        groupBy: function (option) { return option.groupedBy; },
        getOptionSelected: function (option, optionValue) { return option.value === optionValue.value; },
        filterOptions: function (currentOptions, params) {
            var normalized = filter$1(currentOptions, params);
            var filtered = normalized.filter(function (option) { return !option.hidden; });
            if (emptyOptionMessage && filtered.length <= 0) {
                filtered.push({
                    value: '',
                    label: emptyOptionMessage,
                    isEmptyOption: true,
                });
            }
            if (onCreateOption && params.inputValue !== '') {
                var optionsCreate = options.filter(function (option) { return option.isCreateOption; });
                if (disabledCustomOptionCreate) {
                    filtered.push.apply(filtered, optionsCreate);
                }
                else {
                    filtered.push({
                        value: params.inputValue,
                        label: "Adicionar \"" + params.inputValue + "\"",
                        isCreateOption: true,
                    });
                }
            }
            return filtered;
        },
        freeSolo: true,
        clearOnBlur: true,
        autoHighlight: true,
        openOnFocus: true,
        blurOnSelect: true,
    }), getRootProps = _d.getRootProps, getInputProps = _d.getInputProps, getListboxProps = _d.getListboxProps, getOptionProps = _d.getOptionProps, groupedOptions = _d.groupedOptions, popupOpen = _d.popupOpen, getPopupIndicatorProps = _d.getPopupIndicatorProps, anchorEl = _d.anchorEl, setAnchorEl = _d.setAnchorEl;
    var _e = getInputProps(), onChangeAutocomplete = _e.onChange, inputProps = __rest(_e, ["onChange"]);
    var onlyEmptyOption = groupedOptions.length === 1 && groupedOptions[0].label === '';
    var showArrow = !otherProps.endIcon && !omitArrow && !loading && !((_a = otherProps === null || otherProps === void 0 ? void 0 : otherProps.readOnly) === null || _a === void 0 ? void 0 : _a.active);
    var renderOption = function (option, index) {
        if (option.isEmptyOption) {
            return (React__default.createElement(DataLi, { key: option.label + index },
                React__default.createElement(OptionLabel, { isEmptyOption: true }, option.label)));
        }
        if (option.label) {
            var optionProps = getOptionProps({ option: option, index: index });
            return (React__default.createElement(DataLi, __assign$2({ key: option.label + index, className: classes.option }, optionProps),
                React__default.createElement(Box, { display: "flex", alignItems: "center" },
                    renderThumb(option.thumb, option.value),
                    React__default.createElement(Box, { ml: option.thumb ? 1 : 0 },
                        React__default.createElement(OptionLabel, { isCreateOption: option.isCreateOption, selected: !option.isCreateOption && optionProps['aria-selected'] && option.value !== '' },
                            option.isCreateOption && (React__default.createElement("span", null,
                                React__default.createElement(SvgIcon, { src: IconPlus, width: 13, height: 13, fill: "purple600" }))),
                            option.label),
                        option.description && (React__default.createElement(Box, { fontSize: theme.fontSizes[1], color: theme.colors.grey700, fontWeight: "300" }, option.description))))));
        }
        return null;
    };
    var renderGroup = function (args) {
        var children = args.children, key = args.key, group = args.group;
        return (React__default.createElement(DataGroupLi, { key: key },
            React__default.createElement("div", null, group),
            React__default.createElement("ul", null, children)));
    };
    var handleChangeInput = function (e) {
        var inputValue = e.currentTarget.value;
        if (!inputValue && startIcon) {
            setStartIcon(null);
        }
        if (onChangeInput) {
            onChangeInput(inputValue);
        }
        if (onChangeAutocomplete) {
            onChangeAutocomplete(e);
        }
    };
    return (React__default.createElement("div", { className: classes.container },
        React__default.createElement(ContentDataList, __assign$2({}, getRootProps(), { className: className }),
            React__default.createElement(Input$1, __assign$2({ placeholder: placeholder, height: inputHeight, startIcon: startIcon || (value === null || value === void 0 ? void 0 : value.thumb), asSelect: asSelect, type: "text", testId: testId, id: id, label: label, name: name, ref: ref, inputContainerRef: setAnchorEl, loading: localLoading, optional: optional, isDatalistOpen: popupOpen, error: !popupOpen && error, textHelper: !popupOpen && textHelper, autoComplete: "false", arrowDataList: showArrow && (React__default.createElement(ArrowButtonContainer, null,
                    React__default.createElement(ArrowButton, __assign$2({}, getPopupIndicatorProps(), { testId: "datalist-arrow", size: "small", isOpen: popupOpen, iconPath: IconArrowDown$1, iconWidth: 10, iconHeight: 10, disabled: otherProps.disabled, disabledBackgroundColor: true, backgroundColor: theme.colors.grey100, tabIndex: "-1" })))), onChange: handleChangeInput }, inputProps, otherProps))),
        groupedOptions.length > 0 && !onlyEmptyOption ? (React__default.createElement(Popper$1, { className: classes.popper, anchorEl: anchorEl, style: { width: anchorEl ? anchorEl.clientWidth : null }, open: true, disablePortal: true },
            React__default.createElement("ul", __assign$2({ className: classes.dropdownList }, getListboxProps()), groupedOptions.map(function (option, index) {
                if (option.group) {
                    return renderGroup({
                        key: option.key,
                        group: option.group,
                        children: option.options.map(function (groupedOption, groupedIndex) { return renderOption(groupedOption, option.index + groupedIndex); }),
                    });
                }
                return option.options.map(function (ungroupedOption, ungroupedIndex) { return renderOption(ungroupedOption, option.index + ungroupedIndex); });
            })))) : null));
};
var DataList$1 = forwardRef(DataList);

var DropListContainer = styled.div(templateObject_1$d || (templateObject_1$d = __makeTemplateObject(["\n  position: relative;\n  ", "\n"], ["\n  position: relative;\n  ",
    "\n"])), function (props) {
    return props.isOpen &&
        "\n      z-index: " + props.theme.zIndex.dropList + ";\n  ";
});
var SelectedItem = styled.button(templateObject_2$b || (templateObject_2$b = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  padding: ", "px ", "px;\n  width: 100%;\n  min-width: 270px;\n  min-height: 80px;\n  background-color: ", ";\n  border-radius: ", "px;\n  border: solid 1px ", ";\n  outline: none;\n  cursor: pointer;\n\n  ", "\n\n  &:focus {\n    outline: none;\n    border: 1px solid ", ";\n    box-shadow: 0px 0px 7px ", ";\n  }\n"], ["\n  display: flex;\n  align-items: center;\n  padding: ", "px ", "px;\n  width: 100%;\n  min-width: 270px;\n  min-height: 80px;\n  background-color: ", ";\n  border-radius: ", "px;\n  border: solid 1px ", ";\n  outline: none;\n  cursor: pointer;\n\n  ",
    "\n\n  &:focus {\n    outline: none;\n    border: 1px solid ", ";\n    box-shadow: 0px 0px 7px ", ";\n  }\n"])), function (props) { return props.theme.global.gutterSpace / 2; }, function (props) { return props.theme.global.gutterSpace; }, function (props) { return props.theme.colors.white; }, function (props) { return props.theme.forms.borderRadius; }, function (props) { return props.theme.colors.grey400; }, function (props) {
    return props.error &&
        "\n    border-color: " + props.theme.colors.red700 + ";\n  ";
}, function (props) { return rgba(props.theme.colors.purple400, 0.6); }, function (props) { return props.theme.colors.purple400; });
var OptionText = styled.div(templateObject_3$b || (templateObject_3$b = __makeTemplateObject(["\n  margin: auto ", "px;\n  height: 100%;\n  min-height: 100%;\n  display: flex;\n  justify-content: center;\n  flex: 1;\n  flex-direction: column;\n"], ["\n  margin: auto ", "px;\n  height: 100%;\n  min-height: 100%;\n  display: flex;\n  justify-content: center;\n  flex: 1;\n  flex-direction: column;\n"])), function (props) { return props.theme.global.gutterSpace * 0.5; });
var Information = styled.div(templateObject_4$9 || (templateObject_4$9 = __makeTemplateObject(["\n  width: calc(100% - 25px);\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  text-align: left;\n"], ["\n  width: calc(100% - 25px);\n  display: flex;\n  flex: 1;\n  flex-direction: column;\n  justify-content: flex-start;\n  align-items: flex-start;\n  text-align: left;\n"])));
var DropListIcon = styled.img(templateObject_5$9 || (templateObject_5$9 = __makeTemplateObject(["\n  width: 48px;\n  height: 48px;\n  border-radius: ", "px;\n\n  & + ", " {\n    padding: 0 ", "px;\n    width: calc(100% - 75px);\n  }\n"], ["\n  width: 48px;\n  height: 48px;\n  border-radius: ", "px;\n\n  & + ", " {\n    padding: 0 ", "px;\n    width: calc(100% - 75px);\n  }\n"])), function (props) { return props.theme.forms.borderRadius / 2; }, Information, function (props) { return props.theme.global.gutterSpace; });
var Title$1 = styled.div(templateObject_6$9 || (templateObject_6$9 = __makeTemplateObject(["\n  font-size: 1.8rem;\n  color: ", ";\n  width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"], ["\n  font-size: 1.8rem;\n  color: ", ";\n  width: 100%;\n  white-space: nowrap;\n  overflow: hidden;\n  text-overflow: ellipsis;\n"])), function (props) { return props.theme.colors.grey900; });
var Description = styled.div(templateObject_7$9 || (templateObject_7$9 = __makeTemplateObject(["\n  padding-top: 2px;\n  width: 100%;\n  font-weight: 300;\n  font-size: ", ";\n  color: ", ";\n"], ["\n  padding-top: 2px;\n  width: 100%;\n  font-weight: 300;\n  font-size: ", ";\n  color: ", ";\n"])), function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.colors.grey700; });
var ArrowDrop = styled.div(templateObject_8$8 || (templateObject_8$8 = __makeTemplateObject(["\n  width: 12px;\n  height: 100%;\n  transition: transform 150ms linear;\n\n  ", "\n\n  svg {\n    display: block;\n  }\n"], ["\n  width: 12px;\n  height: 100%;\n  transition: transform 150ms linear;\n\n  ",
    "\n\n  svg {\n    display: block;\n  }\n"])), function (props) {
    return props.isOpen &&
        "\n    transform: scale(-1);\n  ";
});
var Li = styled.li(templateObject_9$5 || (templateObject_9$5 = __makeTemplateObject(["\n  padding: ", "px ", "px;\n  display: flex;\n  align-items: center;\n"], ["\n  padding: ", "px ", "px;\n  display: flex;\n  align-items: center;\n"])), function (props) { return props.theme.global.gutterSpace / 2; }, function (props) { return props.theme.global.gutterSpace * 0.75; });
var templateObject_1$d, templateObject_2$b, templateObject_3$b, templateObject_4$9, templateObject_5$9, templateObject_6$9, templateObject_7$9, templateObject_8$8, templateObject_9$5;

var SkeletonStyles = styled.div(templateObject_1$c || (templateObject_1$c = __makeTemplateObject(["\n  ", "\n  ", "\n  border-radius: ", "px;\n  background-image: linear-gradient(-90deg, #e7edf1 0%, #f8f8f8 50%, #e7edf1 100%);\n  background-size: 400% 400%;\n  animation: shimmer 1.2s ease-in-out infinite;\n\n  @keyframes shimmer {\n    0% {\n      background-position: 0 0;\n    }\n    100% {\n      background-position: -135% 0;\n    }\n  }\n"], ["\n  ", "\n  ", "\n  border-radius: ", "px;\n  background-image: linear-gradient(-90deg, #e7edf1 0%, #f8f8f8 50%, #e7edf1 100%);\n  background-size: 400% 400%;\n  animation: shimmer 1.2s ease-in-out infinite;\n\n  @keyframes shimmer {\n    0% {\n      background-position: 0 0;\n    }\n    100% {\n      background-position: -135% 0;\n    }\n  }\n"])), space, layout, function (props) { return props.borderRadius || props.theme.forms.borderRadius; });
var templateObject_1$c;

var Skeleton = function (props) {
    var className = props.className, testId = props.testId, borderRadius = props.borderRadius, type = props.type, otherProps = __rest(props, ["className", "testId", "borderRadius", "type"]);
    if (type === 'Card') {
        return (React__default.createElement(React__default.Fragment, null,
            React__default.createElement(SkeletonStyles, __assign$2({ "data-testid": testId, className: className, height: 14, width: "100%", mb: theme.global.gutterSpace * 0.6 }, otherProps)),
            React__default.createElement(SkeletonStyles, __assign$2({ "data-testid": testId, className: className, height: 16, maxWidth: 100 }, otherProps))));
    }
    return React__default.createElement(SkeletonStyles, __assign$2({ "data-testid": testId, className: className, borderRadius: borderRadius }, otherProps));
};

var IconSearch = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path d=\"M21.71,20.29,18,16.61A9,9,0,1,0,16.61,18l3.68,3.68a1,1,0,0,0,1.42,0A1,1,0,0,0,21.71,20.29ZM11,18a7,7,0,1,1,7-7A7,7,0,0,1,11,18Z\"/></svg>";

var filter = createFilterOptions({
    stringify: function (option) {
        var descriptionText = option.description ? renderToString(option.description) : '';
        return option.label + descriptionText;
    },
});
var DropList = function (props, ref) {
    var id = props.id, testId = props.testId, onChange = props.onChange, options = props.options, name = props.name, label = props.label, textHelper = props.textHelper, error = props.error, optional = props.optional, value = props.value, loading = props.loading, onCreateOption = props.onCreateOption, maxHeight = props.maxHeight, disabledCustomOptionCreate = props.disabledCustomOptionCreate, emptyOptionMessage = props.emptyOptionMessage; props.omitArrow; var onChangeInput = props.onChangeInput, className = props.className, inputPlaceholder = props.inputPlaceholder, iconTooltip = props.iconTooltip, textTooltip = props.textTooltip, hideSkeletonIcon = props.hideSkeletonIcon, otherProps = __rest(props, ["id", "testId", "onChange", "options", "name", "label", "textHelper", "error", "optional", "value", "loading", "onCreateOption", "maxHeight", "disabledCustomOptionCreate", "emptyOptionMessage", "omitArrow", "onChangeInput", "className", "inputPlaceholder", "iconTooltip", "textTooltip", "hideSkeletonIcon"]);
    var disabled = otherProps.disabled;
    var _a = useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var _b = useState(), selectedOption = _b[0], setSelectedOption = _b[1];
    var handleClick = function (event) {
        event.preventDefault();
        if (anchorEl) {
            return setAnchorEl(null);
        }
        setAnchorEl(event.currentTarget);
    };
    var handleClose = function (event, reason) {
        if (reason === 'toggleInput') {
            return;
        }
        if (anchorEl) {
            anchorEl.focus();
        }
        setAnchorEl(null);
    };
    useEffect(function () {
        if (value) {
            var findOptionByValue = options.find(function (option) { return option.value === value.value; });
            setSelectedOption(findOptionByValue || value);
        }
    }, [value]);
    var isOpen = Boolean(anchorEl);
    var _c = useState(false), localLoading = _c[0], setLocalLoading = _c[1];
    var useStyles = makeStyles(function () {
        return createStyles({
            popper: {
                width: '100%',
            },
            container: {
                width: '100%',
                padding: theme.global.gutterSpace + "px",
                marginTop: theme.global.gutterSpace / 2 + "px",
                backgroundColor: theme.colors.white,
                borderRadius: 8,
                boxShadow: theme.global.defaultShadow,
            },
            dropdownList: {
                margin: theme.global.gutterSpace + "px 0 0 0",
                padding: 0,
                width: '100%',
                maxHeight: maxHeight || '300px',
                color: theme.colors.grey400,
                fontSize: theme.forms.defaultFontSize,
                listStyle: 'none',
                overflow: 'auto',
                zIndex: 2,
            },
            option: {
                minHeight: 'auto',
                minWidth: 'auto',
                alignItems: 'flex-start',
                padding: 8,
                cursor: 'pointer',
                '&[aria-selected="true"]': {
                    backgroundColor: 'transparent',
                    color: theme.colors.grey400,
                },
                '&[data-focus="true"]': {
                    backgroundColor: theme.colors.purple100,
                    color: theme.colors.grey400,
                },
            },
            optionCreate: {
                '&:hover': {
                    backgroundColor: theme.colors.purple100,
                    color: theme.colors.grey400,
                },
            },
        });
    });
    useEffect(function () {
        setLocalLoading(!!loading);
    }, [loading]);
    var handleChange = function (option) {
        if (onChange) {
            if (onCreateOption && option && option.isCreateOption) {
                return onCreateOption(option.value);
            }
            if (!option) {
                return onChange({ label: '', value: '' });
            }
            var changeLabel = option.label, changeValue = option.value;
            return onChange({ label: changeLabel, value: changeValue });
        }
    };
    var classes = useStyles();
    var _d = useAutocomplete({
        options: __spreadArrays([{ label: '', value: '' }], (options || [])),
        value: value,
        onChange: function (_, newValue) { return handleChange(newValue); },
        getOptionLabel: function (option) {
            var notEmptyValue = option.value && option.value !== '';
            if (option.label && option.label !== '' && typeof option.label === 'string' && !option.label.includes('Adicionar ') && notEmptyValue) {
                return option.label;
            }
            if (notEmptyValue) {
                return option.value;
            }
            return '';
        },
        getOptionSelected: function (option, optionValue) { return option.value === optionValue.value; },
        filterOptions: function (currentOptions, params) {
            var normalized = filter(currentOptions, params);
            var filtered = normalized.filter(function (option) { return !option.hidden; });
            if (emptyOptionMessage && filtered.length <= 0) {
                filtered.push({
                    value: '',
                    label: emptyOptionMessage,
                    isEmptyOption: true,
                    icon: null,
                });
            }
            if (onCreateOption && params.inputValue !== '') {
                var optionsCreate = options.filter(function (option) { return option.isCreateOption; });
                if (disabledCustomOptionCreate) {
                    filtered.push.apply(filtered, optionsCreate);
                }
                else {
                    filtered.push({
                        value: params.inputValue,
                        label: "Adicionar \"" + params.inputValue + "\"",
                        isCreateOption: true,
                    });
                }
            }
            return filtered;
        },
        onClose: handleClose,
        open: isOpen,
        freeSolo: true,
        clearOnBlur: true,
        autoHighlight: true,
        openOnFocus: true,
        blurOnSelect: true,
    }), getRootProps = _d.getRootProps, getInputProps = _d.getInputProps, getListboxProps = _d.getListboxProps, getOptionProps = _d.getOptionProps, groupedOptions = _d.groupedOptions;
    var _e = getInputProps(), onChangeAutocomplete = _e.onChange, inputProps = __rest(_e, ["onChange"]);
    var onlyEmptyOption = groupedOptions.length === 1 && groupedOptions[0].label === '';
    return (React__default.createElement(DropListContainer, { isOpen: isOpen },
        label && (React__default.createElement(StyledLabel, { htmlFor: id, error: error, optional: optional, disabled: disabled },
            label,
            iconTooltip && textTooltip && (React__default.createElement(Tooltip, { title: textTooltip, placement: "top" },
                React__default.createElement(StyledIconInputContainer, null, iconTooltip))),
            iconTooltip && !textTooltip && React__default.createElement(StyledIconInputContainer, { hasMarginLeft: true }, iconTooltip))),
        React__default.createElement(SelectedItem, { type: "button", onMouseDown: handleClick, "aria-describedby": id, error: error, "data-testid": "droplist-clickable" },
            loading ? React__default.createElement(React__default.Fragment, null, !hideSkeletonIcon && React__default.createElement(Skeleton, { height: 48, width: 48, mr: 2 })) : (selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.icon) && React__default.createElement(DropListIcon, { src: selectedOption.icon }),
            React__default.createElement(Information, null,
                React__default.createElement(Title$1, null, loading ? React__default.createElement(Skeleton, { height: 14, width: "60%", borderRadius: 2 }) : selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.label),
                React__default.createElement(Description, null, loading ? React__default.createElement(Skeleton, { height: 12, width: "75%", marginTop: 1, borderRadius: 2 }) : selectedOption === null || selectedOption === void 0 ? void 0 : selectedOption.description),
                React__default.createElement("input", { type: "hidden", ref: ref, "data-testid": testId, id: id, name: name })),
            React__default.createElement(ArrowDrop, { isOpen: isOpen },
                React__default.createElement(SvgIcon, { src: IconArrowDown$1, width: 12, height: 12, fill: "grey700" }))),
        ((error && typeof error === 'string') || textHelper) && (React__default.createElement(StyledHelperInput, { error: error, bottom: true }, error || textHelper)),
        React__default.createElement(Popper$2, { open: isOpen, anchorEl: anchorEl, placement: "bottom-start", disablePortal: true, className: classes.popper },
            React__default.createElement("div", { className: classes.container },
                React__default.createElement(ContentDataList, __assign$2({}, getRootProps(), { className: className }),
                    React__default.createElement(Input$1, __assign$2({ type: "text", loading: localLoading, optional: optional, autoComplete: "off", "data-testid": "droplist-input-search", placeholder: inputPlaceholder || 'Pesquisar', startIcon: React__default.createElement(SvgIcon, { src: IconSearch, fill: "grey700", width: 24, height: 24 }), onChange: function (e) {
                            if (onChangeInput) {
                                onChangeInput(e.currentTarget.value);
                            }
                            if (onChangeAutocomplete) {
                                onChangeAutocomplete(e);
                            }
                        }, autoFocus: true }, inputProps, otherProps))),
                groupedOptions.length > 0 && !onlyEmptyOption ? (React__default.createElement("ul", __assign$2({ className: classes.dropdownList }, getListboxProps()), groupedOptions.map(function (option, index) {
                    if (option.isEmptyOption) {
                        return (React__default.createElement(Li, { key: option.label + index },
                            React__default.createElement(OptionLabel, { isEmptyOption: true }, option.label)));
                    }
                    if (option.label) {
                        return (React__default.createElement(Li, __assign$2({ key: option.label + index, className: classes.option }, getOptionProps({ option: option, index: index })),
                            option.icon && React__default.createElement(DropListIcon, { src: option.icon }),
                            React__default.createElement(OptionText, null,
                                React__default.createElement(OptionLabel, { isCreateOption: option.isCreateOption, selected: !option.isCreateOption && getOptionProps({ option: option, index: index })['aria-selected'] && option.value !== '' },
                                    option.isCreateOption && (React__default.createElement("span", null,
                                        React__default.createElement(SvgIcon, { src: IconPlus, width: 13, height: 13, fill: "purple600" }))),
                                    option.label),
                                option.description && (React__default.createElement(Box, { fontSize: "1.4rem", color: theme.colors.grey700 }, option.description)))));
                    }
                    return null;
                }))) : null))));
};
var DropList$1 = forwardRef(DropList);

function _objectWithoutPropertiesLoose(r, e) {
  if (null == r) return {};
  var t = {};
  for (var n in r) if ({}.hasOwnProperty.call(r, n)) {
    if (e.includes(n)) continue;
    t[n] = r[n];
  }
  return t;
}

function _objectWithoutProperties(e, t) {
  if (null == e) return {};
  var o,
    r,
    i = _objectWithoutPropertiesLoose(e, t);
  if (Object.getOwnPropertySymbols) {
    var s = Object.getOwnPropertySymbols(e);
    for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]);
  }
  return i;
}

function r$1(e){var t,f,n="";if("string"==typeof e||"number"==typeof e)n+=e;else if("object"==typeof e)if(Array.isArray(e))for(t=0;t<e.length;t++)e[t]&&(f=r$1(e[t]))&&(n&&(n+=" "),n+=f);else for(t in e)e[t]&&(n&&(n+=" "),n+=t);return n}function clsx(){for(var e,t,f=0,n="";f<arguments.length;)(e=arguments[f++])&&(t=r$1(e))&&(n&&(n+=" "),n+=t);return n}

/** @license React v17.0.2
 * react-is.production.min.js
 *
 * Copyright (c) Facebook, Inc. and its affiliates.
 *
 * This source code is licensed under the MIT license found in the
 * LICENSE file in the root directory of this source tree.
 */
var b=60103,c=60106,d=60107,e=60108,f=60114,g=60109,h=60110,k=60112,l=60113,m=60120,n=60115,p=60116,q=60121,r=60122,u=60117,v=60129,w=60131;
if("function"===typeof Symbol&&Symbol.for){var x=Symbol.for;b=x("react.element");c=x("react.portal");d=x("react.fragment");e=x("react.strict_mode");f=x("react.profiler");g=x("react.provider");h=x("react.context");k=x("react.forward_ref");l=x("react.suspense");m=x("react.suspense_list");n=x("react.memo");p=x("react.lazy");q=x("react.block");r=x("react.server.block");u=x("react.fundamental");v=x("react.debug_trace_mode");w=x("react.legacy_hidden");}
function y(a){if("object"===typeof a&&null!==a){var t=a.$$typeof;switch(t){case b:switch(a=a.type,a){case d:case f:case e:case l:case m:return a;default:switch(a=a&&a.$$typeof,a){case h:case k:case p:case n:case g:return a;default:return t}}case c:return t}}}var z=g,A=b,B=k,C=d,D=p,E=n,F=c,G=f,H=e,I=l;var ContextConsumer=h;var ContextProvider=z;var Element$1=A;var ForwardRef=B;var Fragment=C;var Lazy=D;var Memo=E;var Portal=F;var Profiler=G;var StrictMode=H;
var Suspense=I;var isAsyncMode=function(){return !1};var isConcurrentMode=function(){return !1};var isContextConsumer=function(a){return y(a)===h};var isContextProvider=function(a){return y(a)===g};var isElement=function(a){return "object"===typeof a&&null!==a&&a.$$typeof===b};var isForwardRef=function(a){return y(a)===k};var isFragment=function(a){return y(a)===d};var isLazy=function(a){return y(a)===p};var isMemo=function(a){return y(a)===n};
var isPortal=function(a){return y(a)===c};var isProfiler=function(a){return y(a)===f};var isStrictMode=function(a){return y(a)===e};var isSuspense=function(a){return y(a)===l};var isValidElementType=function(a){return "string"===typeof a||"function"===typeof a||a===d||a===f||a===v||a===e||a===l||a===m||a===w||"object"===typeof a&&null!==a&&(a.$$typeof===p||a.$$typeof===n||a.$$typeof===g||a.$$typeof===h||a.$$typeof===k||a.$$typeof===u||a.$$typeof===q||a[0]===r)?!0:!1};
var typeOf=y;

var reactIs_production_min = {
	ContextConsumer: ContextConsumer,
	ContextProvider: ContextProvider,
	Element: Element$1,
	ForwardRef: ForwardRef,
	Fragment: Fragment,
	Lazy: Lazy,
	Memo: Memo,
	Portal: Portal,
	Profiler: Profiler,
	StrictMode: StrictMode,
	Suspense: Suspense,
	isAsyncMode: isAsyncMode,
	isConcurrentMode: isConcurrentMode,
	isContextConsumer: isContextConsumer,
	isContextProvider: isContextProvider,
	isElement: isElement,
	isForwardRef: isForwardRef,
	isFragment: isFragment,
	isLazy: isLazy,
	isMemo: isMemo,
	isPortal: isPortal,
	isProfiler: isProfiler,
	isStrictMode: isStrictMode,
	isSuspense: isSuspense,
	isValidElementType: isValidElementType,
	typeOf: typeOf
};

var reactIs_development = createCommonjsModule(function (module, exports) {

if (process.env.NODE_ENV !== "production") {
  (function() {

// ATTENTION
// When adding new symbols to this file,
// Please consider also adding to 'react-devtools-shared/src/backend/ReactSymbols'
// The Symbol used to tag the ReactElement-like types. If there is no native Symbol
// nor polyfill, then a plain number is used for performance.
var REACT_ELEMENT_TYPE = 0xeac7;
var REACT_PORTAL_TYPE = 0xeaca;
var REACT_FRAGMENT_TYPE = 0xeacb;
var REACT_STRICT_MODE_TYPE = 0xeacc;
var REACT_PROFILER_TYPE = 0xead2;
var REACT_PROVIDER_TYPE = 0xeacd;
var REACT_CONTEXT_TYPE = 0xeace;
var REACT_FORWARD_REF_TYPE = 0xead0;
var REACT_SUSPENSE_TYPE = 0xead1;
var REACT_SUSPENSE_LIST_TYPE = 0xead8;
var REACT_MEMO_TYPE = 0xead3;
var REACT_LAZY_TYPE = 0xead4;
var REACT_BLOCK_TYPE = 0xead9;
var REACT_SERVER_BLOCK_TYPE = 0xeada;
var REACT_FUNDAMENTAL_TYPE = 0xead5;
var REACT_DEBUG_TRACING_MODE_TYPE = 0xeae1;
var REACT_LEGACY_HIDDEN_TYPE = 0xeae3;

if (typeof Symbol === 'function' && Symbol.for) {
  var symbolFor = Symbol.for;
  REACT_ELEMENT_TYPE = symbolFor('react.element');
  REACT_PORTAL_TYPE = symbolFor('react.portal');
  REACT_FRAGMENT_TYPE = symbolFor('react.fragment');
  REACT_STRICT_MODE_TYPE = symbolFor('react.strict_mode');
  REACT_PROFILER_TYPE = symbolFor('react.profiler');
  REACT_PROVIDER_TYPE = symbolFor('react.provider');
  REACT_CONTEXT_TYPE = symbolFor('react.context');
  REACT_FORWARD_REF_TYPE = symbolFor('react.forward_ref');
  REACT_SUSPENSE_TYPE = symbolFor('react.suspense');
  REACT_SUSPENSE_LIST_TYPE = symbolFor('react.suspense_list');
  REACT_MEMO_TYPE = symbolFor('react.memo');
  REACT_LAZY_TYPE = symbolFor('react.lazy');
  REACT_BLOCK_TYPE = symbolFor('react.block');
  REACT_SERVER_BLOCK_TYPE = symbolFor('react.server.block');
  REACT_FUNDAMENTAL_TYPE = symbolFor('react.fundamental');
  symbolFor('react.scope');
  symbolFor('react.opaque.id');
  REACT_DEBUG_TRACING_MODE_TYPE = symbolFor('react.debug_trace_mode');
  symbolFor('react.offscreen');
  REACT_LEGACY_HIDDEN_TYPE = symbolFor('react.legacy_hidden');
}

// Filter certain DOM attributes (e.g. src, href) if their values are empty strings.

var enableScopeAPI = false; // Experimental Create Event Handle API.

function isValidElementType(type) {
  if (typeof type === 'string' || typeof type === 'function') {
    return true;
  } // Note: typeof might be other than 'symbol' or 'number' (e.g. if it's a polyfill).


  if (type === REACT_FRAGMENT_TYPE || type === REACT_PROFILER_TYPE || type === REACT_DEBUG_TRACING_MODE_TYPE || type === REACT_STRICT_MODE_TYPE || type === REACT_SUSPENSE_TYPE || type === REACT_SUSPENSE_LIST_TYPE || type === REACT_LEGACY_HIDDEN_TYPE || enableScopeAPI ) {
    return true;
  }

  if (typeof type === 'object' && type !== null) {
    if (type.$$typeof === REACT_LAZY_TYPE || type.$$typeof === REACT_MEMO_TYPE || type.$$typeof === REACT_PROVIDER_TYPE || type.$$typeof === REACT_CONTEXT_TYPE || type.$$typeof === REACT_FORWARD_REF_TYPE || type.$$typeof === REACT_FUNDAMENTAL_TYPE || type.$$typeof === REACT_BLOCK_TYPE || type[0] === REACT_SERVER_BLOCK_TYPE) {
      return true;
    }
  }

  return false;
}

function typeOf(object) {
  if (typeof object === 'object' && object !== null) {
    var $$typeof = object.$$typeof;

    switch ($$typeof) {
      case REACT_ELEMENT_TYPE:
        var type = object.type;

        switch (type) {
          case REACT_FRAGMENT_TYPE:
          case REACT_PROFILER_TYPE:
          case REACT_STRICT_MODE_TYPE:
          case REACT_SUSPENSE_TYPE:
          case REACT_SUSPENSE_LIST_TYPE:
            return type;

          default:
            var $$typeofType = type && type.$$typeof;

            switch ($$typeofType) {
              case REACT_CONTEXT_TYPE:
              case REACT_FORWARD_REF_TYPE:
              case REACT_LAZY_TYPE:
              case REACT_MEMO_TYPE:
              case REACT_PROVIDER_TYPE:
                return $$typeofType;

              default:
                return $$typeof;
            }

        }

      case REACT_PORTAL_TYPE:
        return $$typeof;
    }
  }

  return undefined;
}
var ContextConsumer = REACT_CONTEXT_TYPE;
var ContextProvider = REACT_PROVIDER_TYPE;
var Element = REACT_ELEMENT_TYPE;
var ForwardRef = REACT_FORWARD_REF_TYPE;
var Fragment = REACT_FRAGMENT_TYPE;
var Lazy = REACT_LAZY_TYPE;
var Memo = REACT_MEMO_TYPE;
var Portal = REACT_PORTAL_TYPE;
var Profiler = REACT_PROFILER_TYPE;
var StrictMode = REACT_STRICT_MODE_TYPE;
var Suspense = REACT_SUSPENSE_TYPE;
var hasWarnedAboutDeprecatedIsAsyncMode = false;
var hasWarnedAboutDeprecatedIsConcurrentMode = false; // AsyncMode should be deprecated

function isAsyncMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsAsyncMode) {
      hasWarnedAboutDeprecatedIsAsyncMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isAsyncMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
    }
  }

  return false;
}
function isConcurrentMode(object) {
  {
    if (!hasWarnedAboutDeprecatedIsConcurrentMode) {
      hasWarnedAboutDeprecatedIsConcurrentMode = true; // Using console['warn'] to evade Babel and ESLint

      console['warn']('The ReactIs.isConcurrentMode() alias has been deprecated, ' + 'and will be removed in React 18+.');
    }
  }

  return false;
}
function isContextConsumer(object) {
  return typeOf(object) === REACT_CONTEXT_TYPE;
}
function isContextProvider(object) {
  return typeOf(object) === REACT_PROVIDER_TYPE;
}
function isElement(object) {
  return typeof object === 'object' && object !== null && object.$$typeof === REACT_ELEMENT_TYPE;
}
function isForwardRef(object) {
  return typeOf(object) === REACT_FORWARD_REF_TYPE;
}
function isFragment(object) {
  return typeOf(object) === REACT_FRAGMENT_TYPE;
}
function isLazy(object) {
  return typeOf(object) === REACT_LAZY_TYPE;
}
function isMemo(object) {
  return typeOf(object) === REACT_MEMO_TYPE;
}
function isPortal(object) {
  return typeOf(object) === REACT_PORTAL_TYPE;
}
function isProfiler(object) {
  return typeOf(object) === REACT_PROFILER_TYPE;
}
function isStrictMode(object) {
  return typeOf(object) === REACT_STRICT_MODE_TYPE;
}
function isSuspense(object) {
  return typeOf(object) === REACT_SUSPENSE_TYPE;
}

exports.ContextConsumer = ContextConsumer;
exports.ContextProvider = ContextProvider;
exports.Element = Element;
exports.ForwardRef = ForwardRef;
exports.Fragment = Fragment;
exports.Lazy = Lazy;
exports.Memo = Memo;
exports.Portal = Portal;
exports.Profiler = Profiler;
exports.StrictMode = StrictMode;
exports.Suspense = Suspense;
exports.isAsyncMode = isAsyncMode;
exports.isConcurrentMode = isConcurrentMode;
exports.isContextConsumer = isContextConsumer;
exports.isContextProvider = isContextProvider;
exports.isElement = isElement;
exports.isForwardRef = isForwardRef;
exports.isFragment = isFragment;
exports.isLazy = isLazy;
exports.isMemo = isMemo;
exports.isPortal = isPortal;
exports.isProfiler = isProfiler;
exports.isStrictMode = isStrictMode;
exports.isSuspense = isSuspense;
exports.isValidElementType = isValidElementType;
exports.typeOf = typeOf;
  })();
}
});
reactIs_development.ContextConsumer;
reactIs_development.ContextProvider;
reactIs_development.Element;
reactIs_development.ForwardRef;
reactIs_development.Fragment;
reactIs_development.Lazy;
reactIs_development.Memo;
reactIs_development.Portal;
reactIs_development.Profiler;
reactIs_development.StrictMode;
reactIs_development.Suspense;
reactIs_development.isAsyncMode;
reactIs_development.isConcurrentMode;
reactIs_development.isContextConsumer;
reactIs_development.isContextProvider;
reactIs_development.isElement;
reactIs_development.isForwardRef;
reactIs_development.isFragment;
reactIs_development.isLazy;
reactIs_development.isMemo;
reactIs_development.isPortal;
reactIs_development.isProfiler;
reactIs_development.isStrictMode;
reactIs_development.isSuspense;
reactIs_development.isValidElementType;
reactIs_development.typeOf;

var reactIs = createCommonjsModule(function (module) {

if (process.env.NODE_ENV === 'production') {
  module.exports = reactIs_production_min;
} else {
  module.exports = reactIs_development;
}
});
reactIs.isElement;
reactIs.isValidElementType;
reactIs.ForwardRef;
reactIs.Memo;
var reactIs_5 = reactIs.isFragment;

function chainPropTypes(propType1, propType2) {
  if (process.env.NODE_ENV === 'production') {
    return function () {
      return null;
    };
  }

  return function validate() {
    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
  };
}

var SPACINGS = {
  small: -16,
  medium: null
};
var styles$2 = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: {
      display: 'flex'
    },

    /* Styles applied to the avatar elements. */
    avatar: {
      border: "2px solid ".concat(theme.palette.background.default),
      marginLeft: -8,
      '&:first-child': {
        marginLeft: 0
      }
    }
  };
};
var AvatarGroup = /*#__PURE__*/React.forwardRef(function AvatarGroup(props, ref) {
  var childrenProp = props.children,
      classes = props.classes,
      className = props.className,
      _props$max = props.max,
      max = _props$max === void 0 ? 5 : _props$max,
      _props$spacing = props.spacing,
      spacing = _props$spacing === void 0 ? 'medium' : _props$spacing,
      other = _objectWithoutProperties(props, ["children", "classes", "className", "max", "spacing"]);

  var clampedMax = max < 2 ? 2 : max;
  var children = React.Children.toArray(childrenProp).filter(function (child) {
    if (process.env.NODE_ENV !== 'production') {
      if (reactIs_5(child)) {
        console.error(["Material-UI: The AvatarGroup component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
      }
    }

    return /*#__PURE__*/React.isValidElement(child);
  });
  var extraAvatars = children.length > clampedMax ? children.length - clampedMax + 1 : 0;
  var marginLeft = spacing && SPACINGS[spacing] !== undefined ? SPACINGS[spacing] : -spacing;
  return /*#__PURE__*/React.createElement("div", _extends({
    className: clsx(classes.root, className),
    ref: ref
  }, other), children.slice(0, children.length - extraAvatars).map(function (child, index) {
    return /*#__PURE__*/React.cloneElement(child, {
      className: clsx(child.props.className, classes.avatar),
      style: _extends({
        zIndex: children.length - index,
        marginLeft: index === 0 ? undefined : marginLeft
      }, child.props.style)
    });
  }), extraAvatars ? /*#__PURE__*/React.createElement(Avatar, {
    className: classes.avatar,
    style: {
      zIndex: 0,
      marginLeft: marginLeft
    }
  }, "+", extraAvatars) : null);
});
process.env.NODE_ENV !== "production" ? AvatarGroup.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * The avatars to stack.
   */
  children: PropTypes.node,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * Max avatars to show before +x.
   */
  max: chainPropTypes(PropTypes.number, function (props) {
    if (props.max < 2) {
      throw new Error(['Material-UI: The prop `max` should be equal to 2 or above.', 'A value below is clamped to 2.'].join('\n'));
    }
  }),

  /**
   * Spacing between avatars.
   */
  spacing: PropTypes.oneOfType([PropTypes.oneOf(['medium', 'small']), PropTypes.number])
} : void 0;
var AvatarGroup$1 = withStyles$2(styles$2, {
  name: 'MuiAvatarGroup'
})(AvatarGroup);

function _arrayWithoutHoles(r) {
  if (Array.isArray(r)) return _arrayLikeToArray$2(r);
}

function _iterableToArray(r) {
  if ("undefined" != typeof Symbol && null != r[Symbol.iterator] || null != r["@@iterator"]) return Array.from(r);
}

function _nonIterableSpread() {
  throw new TypeError("Invalid attempt to spread non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}

function _toConsumableArray(r) {
  return _arrayWithoutHoles(r) || _iterableToArray(r) || _unsupportedIterableToArray$2(r) || _nonIterableSpread();
}

function usePagination() {
  var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};

  // keep default values in sync with @default tags in Pagination.propTypes
  var _props$boundaryCount = props.boundaryCount,
      boundaryCount = _props$boundaryCount === void 0 ? 1 : _props$boundaryCount,
      _props$componentName = props.componentName,
      componentName = _props$componentName === void 0 ? 'usePagination' : _props$componentName,
      _props$count = props.count,
      count = _props$count === void 0 ? 1 : _props$count,
      _props$defaultPage = props.defaultPage,
      defaultPage = _props$defaultPage === void 0 ? 1 : _props$defaultPage,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      _props$hideNextButton = props.hideNextButton,
      hideNextButton = _props$hideNextButton === void 0 ? false : _props$hideNextButton,
      _props$hidePrevButton = props.hidePrevButton,
      hidePrevButton = _props$hidePrevButton === void 0 ? false : _props$hidePrevButton,
      handleChange = props.onChange,
      pageProp = props.page,
      _props$showFirstButto = props.showFirstButton,
      showFirstButton = _props$showFirstButto === void 0 ? false : _props$showFirstButto,
      _props$showLastButton = props.showLastButton,
      showLastButton = _props$showLastButton === void 0 ? false : _props$showLastButton,
      _props$siblingCount = props.siblingCount,
      siblingCount = _props$siblingCount === void 0 ? 1 : _props$siblingCount,
      other = _objectWithoutProperties(props, ["boundaryCount", "componentName", "count", "defaultPage", "disabled", "hideNextButton", "hidePrevButton", "onChange", "page", "showFirstButton", "showLastButton", "siblingCount"]);

  var _useControlled = useControlled({
    controlled: pageProp,
    default: defaultPage,
    name: componentName,
    state: 'page'
  }),
      _useControlled2 = _slicedToArray(_useControlled, 2),
      page = _useControlled2[0],
      setPageState = _useControlled2[1];

  var handleClick = function handleClick(event, value) {
    if (!pageProp) {
      setPageState(value);
    }

    if (handleChange) {
      handleChange(event, value);
    }
  }; // https://dev.to/namirsab/comment/2050


  var range = function range(start, end) {
    var length = end - start + 1;
    return Array.from({
      length: length
    }, function (_, i) {
      return start + i;
    });
  };

  var startPages = range(1, Math.min(boundaryCount, count));
  var endPages = range(Math.max(count - boundaryCount + 1, boundaryCount + 1), count);
  var siblingsStart = Math.max(Math.min( // Natural start
  page - siblingCount, // Lower boundary when page is high
  count - boundaryCount - siblingCount * 2 - 1), // Greater than startPages
  boundaryCount + 2);
  var siblingsEnd = Math.min(Math.max( // Natural end
  page + siblingCount, // Upper boundary when page is low
  boundaryCount + siblingCount * 2 + 2), // Less than endPages
  endPages[0] - 2); // Basic list of items to render
  // e.g. itemList = ['first', 'previous', 1, 'ellipsis', 4, 5, 6, 'ellipsis', 10, 'next', 'last']

  var itemList = [].concat(_toConsumableArray(showFirstButton ? ['first'] : []), _toConsumableArray(hidePrevButton ? [] : ['previous']), _toConsumableArray(startPages), _toConsumableArray(siblingsStart > boundaryCount + 2 ? ['start-ellipsis'] : boundaryCount + 1 < count - boundaryCount ? [boundaryCount + 1] : []), _toConsumableArray(range(siblingsStart, siblingsEnd)), _toConsumableArray(siblingsEnd < count - boundaryCount - 1 ? ['end-ellipsis'] : count - boundaryCount > boundaryCount ? [count - boundaryCount] : []), _toConsumableArray(endPages), _toConsumableArray(hideNextButton ? [] : ['next']), _toConsumableArray(showLastButton ? ['last'] : [])); // Map the button type to its page number

  var buttonPage = function buttonPage(type) {
    switch (type) {
      case 'first':
        return 1;

      case 'previous':
        return page - 1;

      case 'next':
        return page + 1;

      case 'last':
        return count;

      default:
        return null;
    }
  }; // Convert the basic item list to PaginationItem props objects


  var items = itemList.map(function (item) {
    return typeof item === 'number' ? {
      onClick: function onClick(event) {
        handleClick(event, item);
      },
      type: 'page',
      page: item,
      selected: item === page,
      disabled: disabled,
      'aria-current': item === page ? 'true' : undefined
    } : {
      onClick: function onClick(event) {
        handleClick(event, buttonPage(item));
      },
      type: item,
      page: buttonPage(item),
      selected: false,
      disabled: disabled || item.indexOf('ellipsis') === -1 && (item === 'next' || item === 'last' ? page >= count : page <= 1)
    };
  });
  return _extends({
    items: items
  }, other);
}

/**
 * @ignore - internal component.
 */

var FirstPageIcon = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M18.41 16.59L13.82 12l4.59-4.59L17 6l-6 6 6 6zM6 6h2v12H6z"
}), 'FirstPage');

/**
 * @ignore - internal component.
 */

var LastPageIcon = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M5.59 7.41L10.18 12l-4.59 4.59L7 18l6-6-6-6zM16 6h2v12h-2z"
}), 'LastPage');

/**
 * @ignore - internal component.
 */

var NavigateBeforeIcon = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M15.41 7.41L14 6l-6 6 6 6 1.41-1.41L10.83 12z"
}), 'NavigateBefore');

/**
 * @ignore - internal component.
 */

var NavigateNextIcon = createSvgIcon( /*#__PURE__*/React.createElement("path", {
  d: "M10 6L8.59 7.41 13.17 12l-4.58 4.59L10 18l6-6z"
}), 'NavigateNext');

var styles$1 = function styles(theme) {
  return {
    /* Styles applied to the root element. */
    root: _extends({}, theme.typography.body2, {
      borderRadius: 32 / 2,
      textAlign: 'center',
      boxSizing: 'border-box',
      minWidth: 32,
      height: 32,
      padding: '0 6px',
      margin: '0 3px',
      color: theme.palette.text.primary
    }),

    /* Styles applied to the root element if `type="page"`. */
    page: {
      transition: theme.transitions.create(['color', 'background-color'], {
        duration: theme.transitions.duration.short
      }),
      '&:hover': {
        backgroundColor: theme.palette.action.hover,
        // Reset on touch devices, it doesn't add specificity
        '@media (hover: none)': {
          backgroundColor: 'transparent'
        }
      },
      '&$focusVisible': {
        backgroundColor: theme.palette.action.focus
      },
      '&$selected': {
        backgroundColor: theme.palette.action.selected,
        '&:hover, &$focusVisible': {
          backgroundColor: fade(theme.palette.action.selected, theme.palette.action.selectedOpacity + theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: theme.palette.action.selected
          }
        },
        '&$disabled': {
          opacity: 1,
          color: theme.palette.action.disabled,
          backgroundColor: theme.palette.action.selected
        }
      },
      '&$disabled': {
        opacity: theme.palette.action.disabledOpacity
      }
    },

    /* Styles applied applied to the root element if `size="small"`. */
    sizeSmall: {
      minWidth: 26,
      height: 26,
      borderRadius: 26 / 2,
      margin: '0 1px',
      padding: '0 4px',
      '& $icon': {
        fontSize: theme.typography.pxToRem(18)
      }
    },

    /* Styles applied applied to the root element if `size="large"`. */
    sizeLarge: {
      minWidth: 40,
      height: 40,
      borderRadius: 40 / 2,
      padding: '0 10px',
      fontSize: theme.typography.pxToRem(15),
      '& $icon': {
        fontSize: theme.typography.pxToRem(22)
      }
    },

    /* Styles applied to the root element if `variant="text"` and `color="primary"`. */
    textPrimary: {
      '&$selected': {
        color: theme.palette.primary.contrastText,
        backgroundColor: theme.palette.primary.main,
        '&:hover, &$focusVisible': {
          backgroundColor: theme.palette.primary.dark,
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: theme.palette.primary.main
          }
        },
        '&$disabled': {
          color: theme.palette.action.disabled
        }
      }
    },

    /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */
    textSecondary: {
      '&$selected': {
        color: theme.palette.secondary.contrastText,
        backgroundColor: theme.palette.secondary.main,
        '&:hover, &$focusVisible': {
          backgroundColor: theme.palette.secondary.dark,
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: theme.palette.secondary.main
          }
        },
        '&$disabled': {
          color: theme.palette.action.disabled
        }
      }
    },

    /* Styles applied to the root element if `outlined="true"`. */
    outlined: {
      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
      '&$selected': {
        '&$disabled': {
          border: "1px solid ".concat(theme.palette.action.disabledBackground)
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
    outlinedPrimary: {
      '&$selected': {
        color: theme.palette.primary.main,
        border: "1px solid ".concat(fade(theme.palette.primary.main, 0.5)),
        backgroundColor: fade(theme.palette.primary.main, theme.palette.action.activatedOpacity),
        '&:hover, &$focusVisible': {
          backgroundColor: fade(theme.palette.primary.main, theme.palette.action.activatedOpacity + theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        },
        '&$disabled': {
          color: theme.palette.action.disabled
        }
      }
    },

    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
    outlinedSecondary: {
      '&$selected': {
        color: theme.palette.secondary.main,
        border: "1px solid ".concat(fade(theme.palette.secondary.main, 0.5)),
        backgroundColor: fade(theme.palette.secondary.main, theme.palette.action.activatedOpacity),
        '&:hover, &$focusVisible': {
          backgroundColor: fade(theme.palette.secondary.main, theme.palette.action.activatedOpacity + theme.palette.action.hoverOpacity),
          // Reset on touch devices, it doesn't add specificity
          '@media (hover: none)': {
            backgroundColor: 'transparent'
          }
        },
        '&$disabled': {
          color: theme.palette.action.disabled
        }
      }
    },

    /* Styles applied to the root element if `rounded="true"`. */
    rounded: {
      borderRadius: theme.shape.borderRadius
    },

    /* Styles applied to the root element if `type="start-ellipsis"` or `type="end-ellipsis"`. */
    ellipsis: {
      height: 'auto',
      '&$disabled': {
        opacity: theme.palette.action.disabledOpacity
      }
    },

    /* Pseudo-class applied to the root element if keyboard focused. */
    focusVisible: {},

    /* Pseudo-class applied to the root element if `disabled={true}`. */
    disabled: {},

    /* Pseudo-class applied to the root element if `selected={true}`. */
    selected: {},

    /* Styles applied to the icon element. */
    icon: {
      fontSize: theme.typography.pxToRem(20),
      margin: '0 -8px'
    }
  };
};
var PaginationItem = /*#__PURE__*/React.forwardRef(function PaginationItem(props, ref) {
  var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'standard' : _props$color,
      component = props.component,
      _props$disabled = props.disabled,
      disabled = _props$disabled === void 0 ? false : _props$disabled,
      page = props.page,
      _props$selected = props.selected,
      selected = _props$selected === void 0 ? false : _props$selected,
      _props$shape = props.shape,
      shape = _props$shape === void 0 ? 'round' : _props$shape,
      _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$type = props.type,
      type = _props$type === void 0 ? 'page' : _props$type,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'text' : _props$variant,
      other = _objectWithoutProperties(props, ["classes", "className", "color", "component", "disabled", "page", "selected", "shape", "size", "type", "variant"]);

  var theme = useTheme();
  var normalizedIcons = theme.direction === 'rtl' ? {
    previous: NavigateNextIcon,
    next: NavigateBeforeIcon,
    last: FirstPageIcon,
    first: LastPageIcon
  } : {
    previous: NavigateBeforeIcon,
    next: NavigateNextIcon,
    first: FirstPageIcon,
    last: LastPageIcon
  };
  var Icon = normalizedIcons[type];
  return type === 'start-ellipsis' || type === 'end-ellipsis' ? /*#__PURE__*/React.createElement("div", {
    ref: ref,
    className: clsx(classes.root, classes.ellipsis, disabled && classes.disabled, size !== 'medium' && classes["size".concat(capitalize(size))])
  }, "\u2026") : /*#__PURE__*/React.createElement(ButtonBase, _extends({
    ref: ref,
    component: component,
    disabled: disabled,
    focusVisibleClassName: classes.focusVisible,
    className: clsx(classes.root, classes.page, classes[variant], classes[shape], className, color !== 'standard' && classes["".concat(variant).concat(capitalize(color))], disabled && classes.disabled, selected && classes.selected, size !== 'medium' && classes["size".concat(capitalize(size))])
  }, other), type === 'page' && page, Icon ? /*#__PURE__*/React.createElement(Icon, {
    className: classes.icon
  }) : null);
});
process.env.NODE_ENV !== "production" ? PaginationItem.propTypes = {
  /**
   * @ignore
   */
  classes: PropTypes.object.isRequired,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The active color.
   */
  color: PropTypes.oneOf(['standard', 'primary', 'secondary']),

  /**
   * The component used for the root node.
   * Either a string to use a HTML element or a component.
   */
  component: PropTypes
  /* @typescript-to-proptypes-ignore */
  .elementType,

  /**
   * If `true`, the item will be disabled.
   */
  disabled: PropTypes.bool,

  /**
   * The current page number.
   */
  page: PropTypes.number,

  /**
   * If `true` the pagination item is selected.
   */
  selected: PropTypes.bool,

  /**
   * The shape of the pagination item.
   */
  shape: PropTypes.oneOf(['round', 'rounded']),

  /**
   * The size of the pagination item.
   */
  size: PropTypes.oneOf(['small', 'medium', 'large']),

  /**
   * The type of pagination item.
   */
  type: PropTypes.oneOf(['page', 'first', 'last', 'next', 'previous', 'start-ellipsis', 'end-ellipsis']),

  /**
   * The pagination item variant.
   */
  variant: PropTypes.oneOf(['text', 'outlined'])
} : void 0;
var PaginationItem$1 = withStyles$2(styles$1, {
  name: 'MuiPaginationItem'
})(PaginationItem);

var styles = {
  /* Styles applied to the root element. */
  root: {},

  /* Styles applied to the ul element. */
  ul: {
    display: 'flex',
    flexWrap: 'wrap',
    alignItems: 'center',
    padding: 0,
    margin: 0,
    listStyle: 'none'
  }
};

function defaultGetAriaLabel(type, page, selected) {
  if (type === 'page') {
    return "".concat(selected ? '' : 'Go to ', "page ").concat(page);
  }

  return "Go to ".concat(type, " page");
}

var Pagination$1 = /*#__PURE__*/React.forwardRef(function Pagination(props, ref) {
  props.boundaryCount;
      var classes = props.classes,
      className = props.className,
      _props$color = props.color,
      color = _props$color === void 0 ? 'standard' : _props$color;
      props.count;
      props.defaultPage;
      props.disabled;
      var _props$getItemAriaLab = props.getItemAriaLabel,
      getItemAriaLabel = _props$getItemAriaLab === void 0 ? defaultGetAriaLabel : _props$getItemAriaLab;
      props.hideNextButton;
      props.hidePrevButton;
      props.onChange;
      props.page;
      var _props$renderItem = props.renderItem,
      renderItem = _props$renderItem === void 0 ? function (item) {
    return /*#__PURE__*/React.createElement(PaginationItem$1, item);
  } : _props$renderItem,
      _props$shape = props.shape,
      shape = _props$shape === void 0 ? 'round' : _props$shape;
      props.showFirstButton;
      props.showLastButton;
      props.siblingCount;
      var _props$size = props.size,
      size = _props$size === void 0 ? 'medium' : _props$size,
      _props$variant = props.variant,
      variant = _props$variant === void 0 ? 'text' : _props$variant,
      other = _objectWithoutProperties(props, ["boundaryCount", "classes", "className", "color", "count", "defaultPage", "disabled", "getItemAriaLabel", "hideNextButton", "hidePrevButton", "onChange", "page", "renderItem", "shape", "showFirstButton", "showLastButton", "siblingCount", "size", "variant"]);

  var _usePagination = usePagination(_extends({}, props, {
    componentName: 'Pagination'
  })),
      items = _usePagination.items;

  return /*#__PURE__*/React.createElement("nav", _extends({
    "aria-label": "pagination navigation",
    className: clsx(classes.root, className),
    ref: ref
  }, other), /*#__PURE__*/React.createElement("ul", {
    className: classes.ul
  }, items.map(function (item, index) {
    return /*#__PURE__*/React.createElement("li", {
      key: index
    }, renderItem(_extends({}, item, {
      color: color,
      'aria-label': getItemAriaLabel(item.type, item.page, item.selected),
      shape: shape,
      size: size,
      variant: variant
    })));
  })));
}); // @default tags synced with default values from usePagination

process.env.NODE_ENV !== "production" ? Pagination$1.propTypes = {
  // ----------------------------- Warning --------------------------------
  // | These PropTypes are generated from the TypeScript type definitions |
  // |     To update them edit the d.ts file and run "yarn proptypes"     |
  // ----------------------------------------------------------------------

  /**
   * Number of always visible pages at the beginning and end.
   * @default 1
   */
  boundaryCount: PropTypes.number,

  /**
   * Override or extend the styles applied to the component.
   * See [CSS API](#css) below for more details.
   */
  classes: PropTypes.object,

  /**
   * @ignore
   */
  className: PropTypes.string,

  /**
   * The active color.
   */
  color: PropTypes.oneOf(['primary', 'secondary', 'standard']),

  /**
   * The total number of pages.
   * @default 1
   */
  count: PropTypes.number,

  /**
   * The page selected by default when the component is uncontrolled.
   * @default 1
   */
  defaultPage: PropTypes.number,

  /**
   * If `true`, the pagination component will be disabled.
   * @default false
   */
  disabled: PropTypes.bool,

  /**
   * Accepts a function which returns a string value that provides a user-friendly name for the current page.
   *
   * For localization purposes, you can use the provided [translations](/guides/localization/).
   *
   * @param {string} type The link or button type to format ('page' | 'first' | 'last' | 'next' | 'previous'). Defaults to 'page'.
   * @param {number} page The page number to format.
   * @param {bool} selected If true, the current page is selected.
   * @returns {string}
   */
  getItemAriaLabel: PropTypes.func,

  /**
   * If `true`, hide the next-page button.
   * @default false
   */
  hideNextButton: PropTypes.bool,

  /**
   * If `true`, hide the previous-page button.
   * @default false
   */
  hidePrevButton: PropTypes.bool,

  /**
   * Callback fired when the page is changed.
   *
   * @param {object} event The event source of the callback.
   * @param {number} page The page selected.
   */
  onChange: PropTypes.func,

  /**
   * The current page.
   */
  page: PropTypes.number,

  /**
   * Render the item.
   *
   * @param {PaginationRenderItemParams} params The props to spread on a PaginationItem.
   * @returns {ReactNode}
   */
  renderItem: PropTypes.func,

  /**
   * The shape of the pagination items.
   */
  shape: PropTypes.oneOf(['round', 'rounded']),

  /**
   * If `true`, show the first-page button.
   * @default false
   */
  showFirstButton: PropTypes.bool,

  /**
   * If `true`, show the last-page button.
   * @default false
   */
  showLastButton: PropTypes.bool,

  /**
   * Number of always visible pages before and after the current page.
   * @default 1
   */
  siblingCount: PropTypes.number,

  /**
   * The size of the pagination component.
   */
  size: PropTypes.oneOf(['large', 'medium', 'small']),

  /**
   * The variant to use.
   */
  variant: PropTypes.oneOf(['outlined', 'text'])
} : void 0;
var Pagination$2 = withStyles$2(styles, {
  name: 'MuiPagination'
})(Pagination$1);

var MaterialPagination = styled(Pagination$2)(templateObject_7$8 || (templateObject_7$8 = __makeTemplateObject(["\n  && ul > li:first-child button {\n    ", "\n  }\n\n  && ul > li:last-child button {\n    ", "\n  }\n\n  && ul > li > div {\n    ", "\n  }\n\n  && {\n    button {\n      width: 20px;\n      height: 20px;\n      min-width: unset;\n      padding: ", "px ", "px;\n      text-align: center;\n      color: ", ";\n      font-size: ", ";\n      font-weight: 600;\n      transition: background-color 250ms ease-out;\n      border-radius: ", "px;\n      font-family: ", ";\n      margin: 0 ", "px;\n\n      svg {\n        color: ", ";\n      }\n      .Mui-disabled {\n        svg {\n          color: ", ";\n        }\n      }\n      &:hover {\n        background-color: ", ";\n      }\n\n      ", "\n    }\n\n    svg:first-of-type {\n      width: 16px;\n      height: 16px;\n    }\n    .Mui-selected,\n    .Mui-selected:hover {\n      color: ", ";\n      background-color: ", ";\n      font-weight: 600;\n\n      &:hover {\n        background-color: ", ";\n\n        ", "\n      }\n\n      ", "\n    }\n  }\n"], ["\n  && ul > li:first-child button {\n    ",
    "\n  }\n\n  && ul > li:last-child button {\n    ",
    "\n  }\n\n  && ul > li > div {\n    ",
    "\n  }\n\n  && {\n    button {\n      width: 20px;\n      height: 20px;\n      min-width: unset;\n      padding: ", "px ", "px;\n      text-align: center;\n      color: ", ";\n      font-size: ", ";\n      font-weight: 600;\n      transition: background-color 250ms ease-out;\n      border-radius: ", "px;\n      font-family: ", ";\n      margin: 0 ", "px;\n\n      svg {\n        color: ", ";\n      }\n      .Mui-disabled {\n        svg {\n          color: ", ";\n        }\n      }\n      &:hover {\n        background-color: ", ";\n      }\n\n      ",
    "\n    }\n\n    svg:first-of-type {\n      width: 16px;\n      height: 16px;\n    }\n    .Mui-selected,\n    .Mui-selected:hover {\n      color: ", ";\n      background-color: ", ";\n      font-weight: 600;\n\n      &:hover {\n        background-color: ", ";\n\n        ",
    "\n      }\n\n      ",
    "\n    }\n  }\n"])), function (props) {
    return props.squareStyle && css(templateObject_1$b || (templateObject_1$b = __makeTemplateObject(["\n        border-top-left-radius: 4px;\n        border-bottom-left-radius: 4px;\n      "], ["\n        border-top-left-radius: 4px;\n        border-bottom-left-radius: 4px;\n      "])));
}, function (props) {
    return props.squareStyle && css(templateObject_2$a || (templateObject_2$a = __makeTemplateObject(["\n        border-top-right-radius: 4px;\n        border-bottom-right-radius: 4px;\n      "], ["\n        border-top-right-radius: 4px;\n        border-bottom-right-radius: 4px;\n      "])));
}, function (props) {
    return props.squareStyle && css(templateObject_3$a || (templateObject_3$a = __makeTemplateObject(["\n        width: 36px;\n        height: 36px;\n        border-radius: 0;\n        margin: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        color: rgba(115, 110, 122, 1);\n        border: 1px solid rgba(235, 233, 237, 1);\n        font-size: 14px;\n      "], ["\n        width: 36px;\n        height: 36px;\n        border-radius: 0;\n        margin: 0;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n        color: rgba(115, 110, 122, 1);\n        border: 1px solid rgba(235, 233, 237, 1);\n        font-size: 14px;\n      "])));
}, function (props) { return Math.round(props.theme.global.gutterSpace * 0.2); }, function (props) { return props.theme.global.gutterSpace * 0.5; }, function (props) { return props.theme.colors.grey700; }, function (props) { return props.theme.fontSizes[1]; }, function (props) { return props.theme.forms.borderRadius / 2; }, function (props) { return props.theme.global.defaultFont; }, function (props) { return props.theme.global.gutterSpace / 4; }, function (props) { return props.theme.colors.grey700; }, function (props) { return props.theme.colors.grey100; }, function (props) { return props.theme.colors.grey100; }, function (props) {
    return props.squareStyle && css(templateObject_4$8 || (templateObject_4$8 = __makeTemplateObject(["\n          width: 36px;\n          height: 36px;\n          border-radius: 0;\n          border: 1px solid rgba(235, 233, 237, 1);\n          background-color: rgba(255, 255, 255, 1);\n          margin: 0;\n          color: rgba(115, 110, 122, 1);\n        "], ["\n          width: 36px;\n          height: 36px;\n          border-radius: 0;\n          border: 1px solid rgba(235, 233, 237, 1);\n          background-color: rgba(255, 255, 255, 1);\n          margin: 0;\n          color: rgba(115, 110, 122, 1);\n        "])));
}, function (props) { return props.theme.colors.white; }, function (props) { return props.theme.colors.purple600; }, function (props) { return curriedDarken$1(0.15, props.theme.colors.purple600); }, function (props) {
    return props.squareStyle && css(templateObject_5$8 || (templateObject_5$8 = __makeTemplateObject(["\n            background-color: ", ";\n          "], ["\n            background-color: ", ";\n          "])), curriedDarken$1(0.15, 'rgba(235, 233, 237, 1)'));
}, function (props) {
    return props.squareStyle && css(templateObject_6$8 || (templateObject_6$8 = __makeTemplateObject(["\n          background-color: rgba(235, 233, 237, 1);\n          color: rgba(58, 54, 61, 1);\n        "], ["\n          background-color: rgba(235, 233, 237, 1);\n          color: rgba(58, 54, 61, 1);\n        "])));
});
var templateObject_1$b, templateObject_2$a, templateObject_3$a, templateObject_4$8, templateObject_5$8, templateObject_6$8, templateObject_7$8;

var Pagination = function (props) {
    var testId = props.testId, squareStyle = props.squareStyle, others = __rest(props, ["testId", "squareStyle"]);
    return React__default.createElement(MaterialPagination, __assign$2({ "data-testid": testId, shape: "rounded", squareStyle: squareStyle }, others));
};

var Field = function (props) {
    var children = props.children, otherProps = __rest(props, ["children"]);
    return (React__default.createElement(Box, __assign$2({ paddingTop: theme.global.gutterSpace * 1.5 }, otherProps), children));
};

var height = 4;
var SliderField = styled.div(templateObject_3$9 || (templateObject_3$9 = __makeTemplateObject(["\n  max-width: 100%;\n\n  ", "\n\n  ", "\n"], ["\n  max-width: 100%;\n\n  ",
    "\n\n  ",
    "\n"])), function (props) {
    return props.horizontalLabel && css(templateObject_1$a || (templateObject_1$a = __makeTemplateObject(["\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      flex-wrap: wrap;\n\n      ", " {\n        flex-direction: column;\n        align-items: flex-start;\n        justify-content: flex-start;\n      }\n    "], ["\n      display: flex;\n      flex-direction: row;\n      justify-content: space-between;\n      flex-wrap: wrap;\n\n      ", " {\n        flex-direction: column;\n        align-items: flex-start;\n        justify-content: flex-start;\n      }\n    "])), device.mobile);
}, function (props) {
    return props.readOnly && css(templateObject_2$9 || (templateObject_2$9 = __makeTemplateObject(["\n      display: none;\n    "], ["\n      display: none;\n    "])));
});
var StyledSlider = styled(Slider$3)(templateObject_4$7 || (templateObject_4$7 = __makeTemplateObject(["\n  margin-bottom: 0px !important;\n  .MuiSlider {\n    &-rail {\n      height: ", "px;\n      background-color: ", ";\n      border-radius: ", "px;\n    }\n    &-track {\n      height: ", "px;\n      background-color: ", ";\n      border-radius: ", "px;\n    }\n    &-thumb,\n    &-thumb.Mui-disabled {\n      height: ", "px;\n      width: ", "px;\n      background-color: ", ";\n      margin-top: -", "px;\n      margin-left: -", "px;\n    }\n    &-markLabel {\n      display: none;\n    }\n    &-mark {\n      display: none;\n    }\n  }\n"], ["\n  margin-bottom: 0px !important;\n  .MuiSlider {\n    &-rail {\n      height: ", "px;\n      background-color: ", ";\n      border-radius: ", "px;\n    }\n    &-track {\n      height: ", "px;\n      background-color: ", ";\n      border-radius: ", "px;\n    }\n    &-thumb,\n    &-thumb.Mui-disabled {\n      height: ", "px;\n      width: ", "px;\n      background-color: ", ";\n      margin-top: -", "px;\n      margin-left: -", "px;\n    }\n    &-markLabel {\n      display: none;\n    }\n    &-mark {\n      display: none;\n    }\n  }\n"])), height, function (props) { return (props.error ? props.theme.colors.red400 : props.theme.colors.grey400); }, function (props) { return props.theme.forms.borderRadius; }, height, function (props) { return (props.disabled ? props.theme.colors.grey100 : props.theme.colors.purple400); }, function (props) { return props.theme.forms.borderRadius; }, height * 4, height * 4, function (props) { return (props.disabled ? props.theme.colors.grey400 : props.theme.colors.purple600); }, height * 1.5, height * 1.5);
var CustomInput = styled(InputMask$1)(templateObject_5$7 || (templateObject_5$7 = __makeTemplateObject(["\n  input {\n    width: 55px;\n    text-align: center;\n  }\n"], ["\n  input {\n    width: 55px;\n    text-align: center;\n  }\n"])));
styled.div(templateObject_6$7 || (templateObject_6$7 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  height: ", "px;\n  padding-left: ", "px;\n  font-size: 1.4rem;\n  font-weight: 600;\n"], ["\n  display: flex;\n  align-items: center;\n  height: ", "px;\n  padding-left: ", "px;\n  font-size: 1.4rem;\n  font-weight: 600;\n"])), function (props) { return props.theme.forms.defaultHeight; }, function (props) { return props.theme.global.gutterSpace / 4; });
var SliderContainer = styled.div(templateObject_7$7 || (templateObject_7$7 = __makeTemplateObject(["\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  padding-right: ", "px;\n\n  .MuiSlider-root {\n    padding: ", "px 0;\n  }\n"], ["\n  display: flex;\n  width: 100%;\n  flex-direction: column;\n  padding-right: ", "px;\n\n  .MuiSlider-root {\n    padding: ", "px 0;\n  }\n"])), function (props) { return (props.paddingRight ? props.theme.global.gutterSpace : 0); }, function (props) { return props.theme.global.gutterSpace; });
var Marks = styled.div(templateObject_8$7 || (templateObject_8$7 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  color: ", ";\n  font-family: ", ";\n  font-size: 1.4rem;\n"], ["\n  display: flex;\n  justify-content: space-between;\n  color: ", ";\n  font-family: ", ";\n  font-size: 1.4rem;\n"])), function (props) { return (props.error ? props.theme.colors.red400 : props.theme.colors.grey100); }, function (props) { return props.theme.global.defaultFont; });
var Mark = styled.span(templateObject_10$3 || (templateObject_10$3 = __makeTemplateObject(["\n  color: ", ";\n  cursor: pointer;\n\n  ", ";\n"], ["\n  color: ", ";\n  cursor: pointer;\n\n  ",
    ";\n"])), function (props) { return props.theme.colors.grey700; }, function (props) {
    return props.disabled && css(templateObject_9$4 || (templateObject_9$4 = __makeTemplateObject(["\n      cursor: not-allowed;\n      color: ", ";\n    "], ["\n      cursor: not-allowed;\n      color: ", ";\n    "])), props.theme.colors.grey700);
});
var InputContainer = styled.div(templateObject_11$2 || (templateObject_11$2 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var Container = styled.div(templateObject_13$1 || (templateObject_13$1 = __makeTemplateObject(["\n  width: 100%;\n\n  ", "\n"], ["\n  width: 100%;\n\n  ",
    "\n"])), function (props) {
    return props.horizontalLabel && css(templateObject_12$2 || (templateObject_12$2 = __makeTemplateObject(["\n      width: 50%;\n      ", " {\n        width: 100%;\n      }\n    "], ["\n      width: 50%;\n      ", " {\n        width: 100%;\n      }\n    "])), device.mobile);
});
var templateObject_1$a, templateObject_2$9, templateObject_3$9, templateObject_4$7, templateObject_5$7, templateObject_6$7, templateObject_7$7, templateObject_8$7, templateObject_9$4, templateObject_10$3, templateObject_11$2, templateObject_12$2, templateObject_13$1;

var Slider = function (props, ref) {
    var name = props.name, value = props.value, onChange = props.onChange, marks = props.marks, min = props.min, max = props.max, step = props.step, unitText = props.unitText, withInput = props.withInput, testId = props.testId, textHelper = props.textHelper, error = props.error, label = props.label, iconTooltip = props.iconTooltip, textTooltip = props.textTooltip, className = props.className, id = props.id, optional = props.optional, disabled = props.disabled, horizontalLabel = props.horizontalLabel, readOnly = props.readOnly;
    var handleChange = function (event, sliderValue) {
        var _a;
        var valueChanged = (_a = event === null || event === void 0 ? void 0 : event.target) === null || _a === void 0 ? void 0 : _a.value;
        if (onChange) {
            if (sliderValue) {
                return onChange(sliderValue);
            }
            if (valueChanged && !Number.isNaN(Number(valueChanged))) {
                var valueParsed = parseInt(valueChanged, 10);
                if (valueParsed <= max) {
                    return onChange(valueParsed);
                }
                return onChange(max);
            }
            return onChange(min);
        }
    };
    var handleBlur = function (event) {
        if (min !== undefined && value < min) {
            return handleChange(event, min);
        }
        if (max !== undefined && value > max) {
            return handleChange(event, max);
        }
    };
    return (React__default.createElement(React__default.Fragment, null,
        React__default.createElement(SliderField, { className: className, horizontalLabel: horizontalLabel, readOnly: readOnly === null || readOnly === void 0 ? void 0 : readOnly.active },
            (label || horizontalLabel) && (React__default.createElement(StyledLabelContainer, { horizontalLabel: horizontalLabel },
                label && (React__default.createElement(StyledLabel, { htmlFor: id, error: error, optional: optional, disabled: disabled },
                    label,
                    iconTooltip && textTooltip && (React__default.createElement(AgilizeTooltip, { title: textTooltip },
                        React__default.createElement(StyledIconInputContainer, null, iconTooltip))))),
                horizontalLabel && textHelper && (React__default.createElement(StyledHelperInput, { horizontalLabel: horizontalLabel, bottom: false }, textHelper)))),
            React__default.createElement(Container, { horizontalLabel: horizontalLabel },
                React__default.createElement(Box, { display: "flex", width: '100%' , pl: "7px" },
                    React__default.createElement(SliderContainer, { paddingRight: withInput || unitText },
                        React__default.createElement(StyledSlider, { name: name, "data-testid": testId, value: value, onChange: handleChange, step: step || 1, min: min, max: max, ref: ref, error: error, disabled: disabled }),
                        marks && (React__default.createElement(Marks, { error: error }, marks.map(function (mark) { return (React__default.createElement(Mark, { key: mark.label + "-" + mark.value, disabled: disabled, onClick: function (e) { return !disabled && handleChange(e, mark.value); } }, mark.label)); })))),
                    (withInput || unitText) && (React__default.createElement(InputContainer, null, withInput && (React__default.createElement(CustomInput, { "data-testid": testId + "-input", type: "number", id: id, value: value, onChange: handleChange, onBlur: handleBlur, min: min, max: max, error: error, disabled: disabled, suffix: unitText }))))),
                (error || textHelper) && (React__default.createElement(StyledHelperInput, { horizontalLabel: horizontalLabel, error: error, bottom: true }, error || textHelper)))),
        (readOnly === null || readOnly === void 0 ? void 0 : readOnly.active) && React__default.createElement(ReadOnlyField, { label: label, value: readOnly === null || readOnly === void 0 ? void 0 : readOnly.value, textTooltip: textTooltip, iconTooltip: iconTooltip, testId: testId })));
};
var Slider$1 = forwardRef(Slider);

var Table = styled.table(templateObject_1$9 || (templateObject_1$9 = __makeTemplateObject(["\n  table-layout: fixed;\n  border-collapse: separate;\n  width: 100%;\n"], ["\n  table-layout: fixed;\n  border-collapse: separate;\n  width: 100%;\n"])));
var THead = styled.thead(templateObject_2$8 || (templateObject_2$8 = __makeTemplateObject(["\n  display: table-header-group;\n  ", "\n"], ["\n  display: table-header-group;\n  ",
    "\n"])), function (props) {
    return !props.unresponsive &&
        "\n    " + device.mobile + " {\n      display: none;\n    }\n\n    " + device.tablet + " {\n      display: none;\n    }\n  ";
});
var TBody = styled(function (_a) {
    _a.loading; _a.condensed; _a.disabledZebraStripe; _a.unresponsive; var otherProps = __rest(_a, ["loading", "condensed", "disabledZebraStripe", "unresponsive"]);
    return React__default.createElement("tbody", __assign$2({}, otherProps));
})(templateObject_5$6 || (templateObject_5$6 = __makeTemplateObject(["\n  position: relative;\n  transition: opacity 100ms linear;\n\n  ", "\n\n  tr:nth-child(odd) {\n    ", "\n    ", "\n  }\n\n  ", " {\n    tr td:first-child {\n      padding-top: ", "px;\n    }\n    tr td:last-child {\n      padding-bottom: ", "px;\n      border-bottom: ", ";\n    }\n  }\n\n  ", "\n"], ["\n  position: relative;\n  transition: opacity 100ms linear;\n\n  ",
    "\n\n  tr:nth-child(odd) {\n    ",
    "\n    ",
    "\n  }\n\n  ", " {\n    tr td:first-child {\n      padding-top: ", "px;\n    }\n    tr td:last-child {\n      padding-bottom: ", "px;\n      border-bottom: ", ";\n    }\n  }\n\n  ",
    "\n"])), function (props) {
    return props.loading &&
        "\n    pointer-events: none;\n    opacity: 0.3;\n  ";
}, function (props) {
    return !props.disabledZebraStripe && css(templateObject_3$8 || (templateObject_3$8 = __makeTemplateObject(["\n        background-color: ", ";\n      "], ["\n        background-color: ", ";\n      "])), props.theme.colors.grey100);
}, function (props) {
    return !props.condensed && css(templateObject_4$6 || (templateObject_4$6 = __makeTemplateObject(["\n        td:first-child {\n          border-top-left-radius: ", "px;\n          border-bottom-left-radius: ", "px;\n        }\n        td:last-child {\n          border-top-right-radius: ", "px;\n          border-bottom-right-radius: ", "px;\n        }\n      "], ["\n        td:first-child {\n          border-top-left-radius: ", "px;\n          border-bottom-left-radius: ", "px;\n        }\n        td:last-child {\n          border-top-right-radius: ", "px;\n          border-bottom-right-radius: ", "px;\n        }\n      "])), props.theme.global.gutterSpace / 2, props.theme.global.gutterSpace / 2, props.theme.global.gutterSpace / 2, props.theme.global.gutterSpace / 2);
}, device.mobile, function (props) { return props.theme.global.gutterSpace; }, function (props) { return props.theme.global.gutterSpace; }, function (props) { return (props.disabledZebraStripe ? "1px solid " + props.theme.colors.grey200 : 'unset'); }, function (props) {
    return !props.unresponsive &&
        "\n      " + device.mobile + " {\n        td {\n          display: flex;\n          position: relative;\n          padding: " + props.theme.global.gutterSpace / 4 + "px " + props.theme.global.gutterSpace + "px;\n          text-align: left;\n          align-items: center;\n\n          &:before {\n            display: inline-block;\n          }\n\n          &:first-child {\n            padding: " + props.theme.global.gutterSpace / 2 + "px " + props.theme.global.gutterSpace + "px " + props.theme.global.gutterSpace / 4 + "px;\n          }\n          &:last-child {\n            padding: " + props.theme.global.gutterSpace / 4 + "px " + props.theme.global.gutterSpace + "px " + props.theme.global.gutterSpace / 2 + "px;\n          }\n        }\n      }\n\n      " + device.tablet + " {\n        td {\n          display: flex;\n          position: relative;\n          padding: " + props.theme.global.gutterSpace / 4 + "px " + props.theme.global.gutterSpace + "px;\n\n          &:before {\n            display: inline-block;\n          }\n\n          &:first-child {\n            padding: " + props.theme.global.gutterSpace / 2 + "px " + props.theme.global.gutterSpace + "px " + props.theme.global.gutterSpace / 4 + "px;\n          }\n          &:last-child {\n            padding: " + props.theme.global.gutterSpace / 4 + "px " + props.theme.global.gutterSpace + "px " + props.theme.global.gutterSpace / 2 + "px;\n          }\n        }\n      }\n  ";
});
var Tr = styled.tr(templateObject_6$6 || (templateObject_6$6 = __makeTemplateObject(["\n  border-top: 1px solid ", ";\n  &:first-child {\n    border-top: none;\n  }\n  ", "\n"], ["\n  border-top: 1px solid ", ";\n  &:first-child {\n    border-top: none;\n  }\n  ",
    "\n"])), function (props) { return props.theme.colors.grey100; }, function (props) {
    return props.height &&
        "\n    height: " + props.height + ";\n  ";
});
var Th = styled.th(templateObject_8$6 || (templateObject_8$6 = __makeTemplateObject(["\n  border: none;\n  text-align: left;\n  padding: 0 ", "px ", "px;\n\n  font-weight: 600;\n  font-size: ", ";\n  color: ", ";\n\n  ", " {\n    padding: 0 ", "px ", "px;\n  }\n  ", " {\n    padding: 0 ", "px ", "px;\n  }\n\n  ", "\n\n  ", "\n"], ["\n  border: none;\n  text-align: left;\n  padding: 0 ", "px ", "px;\n\n  font-weight: 600;\n  font-size: ", ";\n  color: ", ";\n\n  ", " {\n    padding: 0 ", "px ", "px;\n  }\n  ", " {\n    padding: 0 ", "px ", "px;\n  }\n\n  ",
    "\n\n  ",
    "\n"])), function (props) { return props.theme.global.gutterSpace * 0.5; }, function (props) { return props.theme.global.gutterSpace * 0.75; }, function (props) { return props.theme.fontSizes[1]; }, function (props) { return props.theme.colors.grey700; }, device.desktop, function (props) { return props.theme.global.gutterSpace * 1.5; }, function (props) { return props.theme.global.gutterSpace / 2; }, device.tablet, function (props) { return props.theme.global.gutterSpace * 1.5; }, function (props) { return props.theme.global.gutterSpace * 0.75; }, function (props) {
    return props.condensed && css(templateObject_7$6 || (templateObject_7$6 = __makeTemplateObject(["\n      color: ", ";\n      ", " {\n        padding: 0 0 ", "px 0;\n        border-bottom: 1px solid ", ";\n\n        &:not(:last-child) {\n          padding-right: ", "px;\n        }\n      }\n      ", " {\n        padding: 0 0 ", "px 0;\n        border-bottom: 1px solid ", ";\n\n        &:not(:last-child) {\n          padding-right: ", "px;\n        }\n      }\n    "], ["\n      color: ", ";\n      ", " {\n        padding: 0 0 ", "px 0;\n        border-bottom: 1px solid ", ";\n\n        &:not(:last-child) {\n          padding-right: ", "px;\n        }\n      }\n      ", " {\n        padding: 0 0 ", "px 0;\n        border-bottom: 1px solid ", ";\n\n        &:not(:last-child) {\n          padding-right: ", "px;\n        }\n      }\n    "])), props.theme.colors.grey700, device.desktop, props.theme.global.gutterSpace * 0.75, props.theme.colors.grey200, props.theme.global.gutterSpace * 1.5, device.tablet, props.theme.global.gutterSpace * 0.75, props.theme.colors.grey200, props.theme.global.gutterSpace * 1.5);
}, function (props) {
    return props.width &&
        "\n    width: " + props.width + ";\n  ";
});
var Td = styled.td(templateObject_10$2 || (templateObject_10$2 = __makeTemplateObject(["\n  padding: ", "px ", "px;\n  color: ", ";\n  font-weight: 400;\n  font-size: ", ";\n\n  &:before {\n    content: attr(data-th) ' ';\n    display: none;\n    padding-right: ", "px;\n    width: 40%;\n    font-weight: 600;\n    font-size: ", ";\n    color: ", ";\n  }\n\n  ", " {\n    &:not(first-child) {\n      padding: ", "px ", "px;\n    }\n  }\n  ", " {\n    padding: ", "px ", "px;\n  }\n\n  ", "\n"], ["\n  padding: ", "px ", "px;\n  color: ", ";\n  font-weight: 400;\n  font-size: ", ";\n\n  &:before {\n    content: attr(data-th) ' ';\n    display: none;\n    padding-right: ", "px;\n    width: 40%;\n    font-weight: 600;\n    font-size: ", ";\n    color: ", ";\n  }\n\n  ", " {\n    &:not(first-child) {\n      padding: ", "px ", "px;\n    }\n  }\n  ", " {\n    padding: ", "px ", "px;\n  }\n\n  ",
    "\n"])), function (props) { return props.theme.global.gutterSpace * 0.5; }, function (props) { return props.theme.global.gutterSpace * 0.75; }, function (props) { return props.theme.colors.grey700; }, function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.global.gutterSpace / 2; }, function (props) { return props.theme.fontSizes[1]; }, function (props) { return props.theme.colors.grey700; }, device.desktop, function (props) { return props.theme.global.gutterSpace; }, function (props) { return props.theme.global.gutterSpace * 1.5; }, device.tablet, function (props) { return props.theme.global.gutterSpace * 0.75; }, function (props) { return props.theme.global.gutterSpace * 1.5; }, function (props) {
    return props.condensed && css(templateObject_9$3 || (templateObject_9$3 = __makeTemplateObject(["\n      && {\n        ", " {\n          padding: ", "px 0;\n          border-bottom: 1px solid ", ";\n\n          &:not(:last-child) {\n            padding-right: ", "px;\n          }\n        }\n      }\n    "], ["\n      && {\n        ", " {\n          padding: ", "px 0;\n          border-bottom: 1px solid ", ";\n\n          &:not(:last-child) {\n            padding-right: ", "px;\n          }\n        }\n      }\n    "])), device.desktop, props.theme.global.gutterSpace * 1.125, props.theme.colors.grey200, props.theme.global.gutterSpace * 1.5);
});
var templateObject_1$9, templateObject_2$8, templateObject_3$8, templateObject_4$6, templateObject_5$6, templateObject_6$6, templateObject_7$6, templateObject_8$6, templateObject_9$3, templateObject_10$2;

var IconActive = "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M16.3 7.6L9.69995 14.2C9.39995 14.5 9.09995 14.5 8.79995 14.5C8.49995 14.5 8.19995 14.4 7.99995 14.2L4.19995 10.4C3.69995 9.9 3.69995 9.1 4.19995 8.7C4.69995 8.2 5.49995 8.2 5.99995 8.7L8.99995 11.7L14.7 6C15.2 5.5 16 5.5 16.5 6C17 6.5 16.8 7.1 16.3 7.6Z\" />\n</svg>";

var IconAway = "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M8.5 13.4C8.5 14.2 7.8 14.9 7 14.9C6.2 14.9 5.5 14.2 5.5 13.4V6.59998C5.5 5.79998 6.2 5.09998 7 5.09998C7.8 5.09998 8.5 5.79998 8.5 6.59998V13.4Z\" />\n<path d=\"M14.5 13.4C14.5 14.2 13.8 14.9 13 14.9C12.2 14.9 11.5 14.2 11.5 13.4V6.59998C11.5 5.79998 12.2 5.09998 13 5.09998C13.8 5.09998 14.5 5.79998 14.5 6.59998V13.4Z\" />\n</svg>";

var IconProcessing = "<svg width=\"20\" height=\"21\" viewBox=\"0 0 20 21\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M14.9 12.5C14.6 13 14.1 13.4 13.5 13.4C13.3 13.4 13.1 13.4 12.9 13.3L8.99995 11.3C8.49995 11 8.19995 10.5 8.19995 9.89996V5.39996C8.19995 4.59996 8.89995 3.89996 9.69995 3.89996C10.5 3.89996 11.2 4.59996 11.2 5.39996V8.99996L14.2 10.5C15 10.8 15.3 11.7 14.9 12.5Z\" />\n</svg>";

var IconPending = "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M8.6001 4.79999C8.6001 3.99999 9.3001 3.29999 10.1001 3.29999C10.9001 3.29999 11.6001 3.99999 11.6001 4.79999V10.4C11.6001 11.2 10.9001 11.9 10.1001 11.9C9.3001 11.9 8.6001 11.2 8.6001 10.4V4.79999Z\" />\n<path d=\"M11.3001 15.7C11.2001 15.9 11.1001 16 11.0001 16.2C10.7001 16.5 10.3001 16.6 10.0001 16.6C9.6001 16.6 9.2001 16.4 9.0001 16.2C8.8001 16 8.7001 15.9 8.7001 15.7C8.6001 15.5 8.6001 15.4 8.6001 15.1C8.6001 14.7 8.8001 14.3 9.0001 14.1C9.5001 13.6 10.5001 13.6 11.1001 14.1C11.4001 14.4 11.5001 14.8 11.5001 15.1C11.5001 15.3 11.4001 15.5 11.3001 15.7Z\" />\n</svg>";

var IconFired = "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M15.0001 13.3C15.5001 13.8 15.5001 14.6 15.0001 15.1C14.7001 15.4 14.4001 15.4 14.1001 15.4C13.8001 15.4 13.4001 15.3 13.2001 15.1L9.90012 11.8L6.80012 15C6.50012 15.3 6.20012 15.3 5.90012 15.3C5.60012 15.3 5.20012 15.2 5.00012 15C4.50012 14.5 4.50012 13.7 5.00012 13.2L8.20012 10L4.90012 6.8C4.50012 6.3 4.50012 5.5 5.00012 5C5.50012 4.5 6.30012 4.5 6.80012 5L10.0001 8.3L13.2001 5C13.7001 4.5 14.5001 4.5 15.0001 5C15.5001 5.5 15.5001 6.3 15.0001 6.8L11.8001 10L15.0001 13.3Z\" />\n</svg>";

var IconEdit = "<svg width=\"20\" height=\"20\" viewBox=\"0 0 20 20\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M15.6 5.59997H14.576L14.32 4.79997C14.154 4.33055 13.8462 3.92437 13.4391 3.6377C13.032 3.35102 12.5459 3.19805 12.048 3.19997H7.952C7.44924 3.20091 6.95947 3.35972 6.55181 3.65397C6.14416 3.94823 5.83921 4.36308 5.68 4.83997L5.424 5.63997H4.4C3.76348 5.63997 3.15303 5.89283 2.70294 6.34291C2.25286 6.793 2 7.40345 2 8.03997V14.44C2 15.0765 2.25286 15.6869 2.70294 16.137C3.15303 16.5871 3.76348 16.84 4.4 16.84H15.6C16.2365 16.84 16.847 16.5871 17.2971 16.137C17.7471 15.6869 18 15.0765 18 14.44V8.03997C18.0053 7.72145 17.9472 7.40505 17.8289 7.10924C17.7107 6.81343 17.5347 6.54411 17.3114 6.317C17.088 6.08988 16.8216 5.90951 16.5278 5.78641C16.234 5.6633 15.9186 5.59993 15.6 5.59997ZM16.4 14.4C16.4 14.6121 16.3157 14.8156 16.1657 14.9657C16.0157 15.1157 15.8122 15.2 15.6 15.2H4.4C4.18783 15.2 3.98434 15.1157 3.83431 14.9657C3.68429 14.8156 3.6 14.6121 3.6 14.4V7.99997C3.6 7.7878 3.68429 7.58431 3.83431 7.43428C3.98434 7.28426 4.18783 7.19997 4.4 7.19997H6C6.17445 7.20907 6.34709 7.16083 6.49155 7.0626C6.636 6.96437 6.74434 6.82155 6.8 6.65597L7.232 5.34397C7.28567 5.18507 7.38792 5.04706 7.5243 4.94944C7.66068 4.85182 7.82428 4.79954 7.992 4.79997H12.088C12.2557 4.79954 12.4193 4.85182 12.5557 4.94944C12.6921 5.04706 12.7943 5.18507 12.848 5.34397L13.28 6.65597C13.3313 6.80857 13.4275 6.94212 13.556 7.03918C13.6844 7.13623 13.8392 7.19227 14 7.19997H15.6C15.8122 7.19997 16.0157 7.28426 16.1657 7.43428C16.3157 7.58431 16.4 7.7878 16.4 7.99997V14.4ZM10 7.19997C9.3671 7.19997 8.74841 7.38765 8.22218 7.73927C7.69594 8.09089 7.28579 8.59066 7.04358 9.17538C6.80138 9.76011 6.73801 10.4035 6.86149 11.0243C6.98496 11.645 7.28973 12.2152 7.73726 12.6627C8.18479 13.1102 8.75497 13.415 9.37571 13.5385C9.99645 13.662 10.6399 13.5986 11.2246 13.3564C11.8093 13.1142 12.3091 12.704 12.6607 12.1778C13.0123 11.6516 13.2 11.0329 13.2 10.4C13.2 9.55128 12.8629 8.73734 12.2627 8.13723C11.6626 7.53711 10.8487 7.19997 10 7.19997ZM10 12C9.68355 12 9.37421 11.9061 9.11109 11.7303C8.84797 11.5545 8.64289 11.3046 8.52179 11.0123C8.40069 10.7199 8.36901 10.3982 8.43074 10.0878C8.49248 9.77746 8.64487 9.49236 8.86863 9.2686C9.09239 9.04484 9.37749 8.89245 9.68786 8.83071C9.99822 8.76898 10.3199 8.80066 10.6123 8.92176C10.9047 9.04286 11.1545 9.24794 11.3304 9.51106C11.5062 9.77418 11.6 10.0835 11.6 10.4C11.6 10.8243 11.4314 11.2313 11.1314 11.5313C10.8313 11.8314 10.4243 12 10 12Z\" fill=\"white\"/>\n</svg>";

// @ts-ignore
var AvatarSizes = {
    small: {
        width: 24,
        height: 24,
        fontSize: '0.9rem',
        lineHeight: 10,
    },
    medium: {
        width: 60,
        height: 60,
        fontSize: '2.4rem',
        lineHeight: 24,
    },
    large: {
        width: 100,
        height: 100,
        fontSize: '4rem',
        lineHeight: 48,
    },
};
var avatarColorByType = {
    active: 'green700',
    away: 'yellow700',
    processing: 'blue700',
    pending: 'red700',
    fired: 'grey400',
    edit: 'purple600',
};
var avatarIconByType = {
    active: IconActive,
    away: IconAway,
    processing: IconProcessing,
    pending: IconPending,
    fired: IconFired,
    edit: IconEdit,
};

var StyledAvatarContainer = styled.div(templateObject_1$8 || (templateObject_1$8 = __makeTemplateObject(["\n  position: relative;\n  width: fit-content;\n  height: 100%;\n"], ["\n  position: relative;\n  width: fit-content;\n  height: 100%;\n"])));
var StyleAvatar = css(templateObject_3$7 || (templateObject_3$7 = __makeTemplateObject(["\n  font-weight: 800;\n  background-color: ", ";\n  color: ", ";\n  border-radius: 50%;\n\n  ", "\n"], ["\n  font-weight: 800;\n  background-color: ", ";\n  color: ", ";\n  border-radius: 50%;\n\n  ",
    "\n"])), function (props) { return props.theme.colors.grey100; }, function (props) { return props.theme.colors.grey700; }, function (props) { return css(templateObject_2$7 || (templateObject_2$7 = __makeTemplateObject(["\n    width: ", "px;\n    height: ", "px;\n    font-size: ", ";\n    line-height: ", "px;\n  "], ["\n    width: ", "px;\n    height: ", "px;\n    font-size: ", ";\n    line-height: ", "px;\n  "])), AvatarSizes[props.size].width, AvatarSizes[props.size].height, AvatarSizes[props.size].fontSize, AvatarSizes[props.size].lineHeight); });
var StyledAvatarGroup = styled(AvatarGroup$1)(templateObject_4$5 || (templateObject_4$5 = __makeTemplateObject(["\n  .MuiAvatarGroup-avatar {\n    border-radius: 50%;\n    ", "\n    width: 28px;\n    height: 28px;\n    margin-left: -6px;\n  }\n"], ["\n  .MuiAvatarGroup-avatar {\n    border-radius: 50%;\n    ", "\n    width: 28px;\n    height: 28px;\n    margin-left: -6px;\n  }\n"])), StyleAvatar);
var StyledAvatar = styled(Avatar$1)(templateObject_6$5 || (templateObject_6$5 = __makeTemplateObject(["\n  && {\n    position: relative;\n    overflow: inherit;\n    ", "\n\n    img {\n      border-radius: 50%;\n      ", "\n    }\n  }\n"], ["\n  && {\n    position: relative;\n    overflow: inherit;\n    ", "\n\n    img {\n      border-radius: 50%;\n      ",
    "\n    }\n  }\n"])), StyleAvatar, function (props) {
    return props.type === 'fired' && css(templateObject_5$5 || (templateObject_5$5 = __makeTemplateObject(["\n          background-color: ", ";\n          opacity: 0.6;\n          filter: grayscale(100%);\n        "], ["\n          background-color: ", ";\n          opacity: 0.6;\n          filter: grayscale(100%);\n        "])), props.theme.colors.grey100);
});
var StyledTooltipContainer = styled(AgilizeTooltip)(templateObject_7$5 || (templateObject_7$5 = __makeTemplateObject(["\n  position: absolute;\n  bottom: 0;\n  right: 0;\n"], ["\n  position: absolute;\n  bottom: 0;\n  right: 0;\n"])));
var AvatarStatusContainer = styled.div(templateObject_8$5 || (templateObject_8$5 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: ", "px;\n  height: ", "px;\n  background-color: ", ";\n  border: 3px solid ", ";\n  border-radius: 50%;\n  z-index: 2;\n\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: ", "px;\n  height: ", "px;\n  background-color: ", ";\n  border: 3px solid ", ";\n  border-radius: 50%;\n  z-index: 2;\n\n  ",
    "\n"])), function (props) { return props.width; }, function (props) { return props.height; }, function (props) { return props.theme.colors[props.color]; }, function (props) { return props.theme.colors.white; }, function (props) {
    return props.styledHover &&
        "\n    &:hover {\n      cursor: pointer;\n      background-color: " + curriedDarken$1(0.05, props.theme.colors[props.color]) + ";\n    }\n  ";
});
var templateObject_1$8, templateObject_2$7, templateObject_3$7, templateObject_4$5, templateObject_5$5, templateObject_6$5, templateObject_7$5, templateObject_8$5;

var PlusCircle = "<svg xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path  d=\"M12,2A10,10,0,1,0,22,12,10,10,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8,8,0,0,1,12,20Zm4-9H13V8a1,1,0,0,0-2,0v3H8a1,1,0,0,0,0,2h3v3a1,1,0,0,0,2,0V13h3a1,1,0,0,0,0-2Z\"/></svg>";

var CustomAvatar = function (props) {
    var avatarData = props.avatarData, size = props.size, group = props.group, textTooltip = props.textTooltip, testId = props.testId, isAdding = props.isAdding, otherProps = __rest(props, ["avatarData", "size", "group", "textTooltip", "testId", "isAdding"]);
    var defaultSize = (group && 'small') || size || 'medium';
    var defaultStatusSize = size ? Math.round(AvatarSizes[size].height / 2.7) : 22;
    var defaultStatusIconSize = size ? Math.round(AvatarSizes[size].height / 4.2) : 14;
    var defaultLengthGroup = 3;
    var getAvatarInitials = function (name) {
        var _a = name.trim().split(' '), firstName = _a[0], rest = _a.slice(1);
        var formatedRest = rest.length > 0 ? rest : [firstName.length > 1 ? firstName[1] : ''];
        return {
            firstName: firstName,
            rest: __spreadArrays(formatedRest),
        };
    };
    var renderStatus = function (avatar) {
        var _a;
        if (avatar.status && !group && size !== 'small') {
            return (React__default.createElement(StyledTooltipContainer, { title: (_a = avatar.status) === null || _a === void 0 ? void 0 : _a.textTooltip },
                React__default.createElement(AvatarStatusContainer, { styledHover: avatar.status.type === 'edit', color: avatarColorByType[avatar.status.type], width: avatar.status.width || defaultStatusSize, height: avatar.status.height || defaultStatusSize },
                    React__default.createElement(SvgIcon, { src: avatar.status.icon || avatarIconByType[avatar.status.type], fill: "white", width: avatar.status.width * 0.7 || defaultStatusIconSize, height: avatar.status.height * 0.7 || defaultStatusIconSize }))));
        }
        return React__default.createElement(React__default.Fragment, null);
    };
    var renderAvatarItem = function (avatar, index) {
        var _a, _b;
        var _c = getAvatarInitials(avatar.name), firstName = _c.firstName, rest = _c.rest;
        return (React__default.createElement(StyledAvatarContainer, { key: index && "avatar-" + index },
            React__default.createElement(AgilizeTooltip, { title: textTooltip || (avatar === null || avatar === void 0 ? void 0 : avatar.textTooltip) || avatar.name },
                React__default.createElement(StyledAvatar, __assign$2({ key: "avatar-key-" + firstName, alt: avatar.name, src: (avatar === null || avatar === void 0 ? void 0 : avatar.image) || '', size: defaultSize, type: ((_a = avatar === null || avatar === void 0 ? void 0 : avatar.status) === null || _a === void 0 ? void 0 : _a.type) || 'active', "data-testid": "" + testId + (index || '') }, otherProps), isAdding ? (React__default.createElement(SvgIcon, { src: PlusCircle, fill: "purple600", width: 24, height: 24 })) : ("" + firstName.charAt(0) + (rest && ((_b = rest[rest.length - 1]) === null || _b === void 0 ? void 0 : _b.charAt(0)))))),
            !isAdding && renderStatus(avatar)));
    };
    var renderAvatar = function (avatarList) {
        if (Array.isArray(avatarList)) {
            return avatarList.map(function (avatar, index) { return renderAvatarItem(avatar, index); });
        }
        return renderAvatarItem(avatarList);
    };
    return (React__default.createElement(React__default.Fragment, null, group ? (React__default.createElement(StyledAvatarGroup, { size: defaultSize, max: group.maxLength || defaultLengthGroup }, renderAvatar(avatarData))) : (renderAvatar(avatarData))));
};

/* eslint-disable */
var isEmpty = function (obj) {
    for (var i in obj)
        return false;
    return true;
};

var animationSpeed = 350;
var transitionSpeed = 200;
var DotSize = 42;
var DotSmallSize = 16;
var StepperTitle = styled.span(templateObject_1$7 || (templateObject_1$7 = __makeTemplateObject(["\n  position: absolute;\n  top: 100%;\n  padding: ", "px 0 0;\n  width: ", "px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: ", ";\n  font-weight: normal;\n  text-align: center;\n  color: ", ";\n  transition: color ", "ms ease-out;\n\n  ", "\n\n  ", "\n  \n  ", "\n"], ["\n  position: absolute;\n  top: 100%;\n  padding: ", "px 0 0;\n  width: ", "px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  font-size: ", ";\n  font-weight: normal;\n  text-align: center;\n  color: ", ";\n  transition: color ", "ms ease-out;\n\n  ",
    "\n\n  ",
    "\n  \n  ",
    "\n"])), function (props) { return props.theme.global.gutterSpace / 2; }, DotSize * 2, function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.colors.grey700; }, transitionSpeed, function (props) {
    return props.active &&
        "\n    font-weight: 600;\n  ";
}, function (props) {
    return (props.status || props.active) &&
        "\n    color: " + props.theme.colors.purple600 + ";\n  ";
}, function (props) {
    return props.status === 'fail' &&
        "\n    color: " + props.theme.colors.red400 + ";\n  ";
});
var StepperDot = styled.div(templateObject_2$6 || (templateObject_2$6 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: ", "px;\n  height: ", "px;\n  background-color: ", ";\n  border-radius: 50%;\n  font-size: 1.5rem;\n  font-weight: 600;\n  line-height: 1.5rem;\n"], ["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  width: ", "px;\n  height: ", "px;\n  background-color: ", ";\n  border-radius: 50%;\n  font-size: 1.5rem;\n  font-weight: 600;\n  line-height: 1.5rem;\n"])), DotSize, DotSize, function (props) { return props.theme.colors.grey200; });
var stepperIconColors = function (active, status) {
    if (!active && !status) {
        return '';
    }
    var definitionColor = {
        done: 'purple400',
        incomplete: 'purple400',
        fail: 'red400',
        active: 'purple600',
    };
    return css(templateObject_3$6 || (templateObject_3$6 = __makeTemplateObject(["\n    background-color: ", ";\n    opacity: 1;\n    transform: scale(1);\n  "], ["\n    background-color: ", ";\n    opacity: 1;\n    transform: scale(1);\n  "])), function (props) { return props.theme.colors[definitionColor[active ? 'active' : status]]; });
};
var StepperIcon = styled(StepperDot)(templateObject_4$4 || (templateObject_4$4 = __makeTemplateObject(["\n  position: absolute;\n  z-index: 3;\n  transition: background-color 200ms ease-out, color 200ms ease-out ", "ms,\n    transform 200ms cubic-bezier(0.07, 0.68, 0.5, 1.8) ", "ms,\n    opacity 100ms ease-out ", "ms;\n  opacity: 0;\n  transform: scale(0.7);\n  color: ", ";\n\n  ", "\n\n  ", "\n  ", ";\n  svg {\n    opacity: 0;\n    animation: ", " 250ms cubic-bezier(0.07, 0.68, 0.5, 1.8) forwards;\n  }\n"], ["\n  position: absolute;\n  z-index: 3;\n  transition: background-color 200ms ease-out, color 200ms ease-out ", "ms,\n    transform 200ms cubic-bezier(0.07, 0.68, 0.5, 1.8) ", "ms,\n    opacity 100ms ease-out ", "ms;\n  opacity: 0;\n  transform: scale(0.7);\n  color: ", ";\n\n  ",
    "\n\n  ",
    "\n  ", ";\n  svg {\n    opacity: 0;\n    animation: ", " 250ms cubic-bezier(0.07, 0.68, 0.5, 1.8) forwards;\n  }\n"])), animationSpeed + transitionSpeed, animationSpeed + transitionSpeed / 2, animationSpeed + transitionSpeed / 2, function (props) { return props.theme.colors.white; }, function (props) {
    return props.noTransition &&
        "\n    transition: none;\n    }\n  ";
}, function (props) {
    return props.status &&
        "\n    & > span {display: none;}\n  ";
}, function (props) { return stepperIconColors(props.active, props.status); }, animaFadeScaleIn(0.5));
var StepperCount = styled.div(templateObject_5$4 || (templateObject_5$4 = __makeTemplateObject(["\n  position: relative;\n  z-index: 2;\n  color: ", ";\n"], ["\n  position: relative;\n  z-index: 2;\n  color: ", ";\n"])), function (props) { return props.theme.colors.grey700; });
var Step = styled.li(templateObject_6$4 || (templateObject_6$4 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n\n  &.active + & ", " {\n    transition: background-color 200ms ease-out, color 200ms ease-out 200ms, transform 200ms cubic-bezier(0.07, 0.68, 0.5, 1.8) 100ms,\n      opacity 200ms ease-out 200ms;\n  }\n\n  &:not(:first-child) {\n    flex: 1;\n\n    &:before {\n      content: '';\n      position: relative;\n      z-index: -1;\n      flex: 1;\n      margin: 0 -", "px;\n      height: 16px;\n      width: 100%;\n      background: linear-gradient(\n        to right,\n        ", " 0,\n        ", " calc(100% / 2),\n        ", " calc(100% / 2),\n        ", " 100%\n      );\n      background-size: 200% 100%;\n      background-position: 100% bottom;\n      transition: background ", "ms ease-out ", "ms;\n    }\n\n    ", "\n  }\n\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n\n  &.active + & ", " {\n    transition: background-color 200ms ease-out, color 200ms ease-out 200ms, transform 200ms cubic-bezier(0.07, 0.68, 0.5, 1.8) 100ms,\n      opacity 200ms ease-out 200ms;\n  }\n\n  &:not(:first-child) {\n    flex: 1;\n\n    &:before {\n      content: '';\n      position: relative;\n      z-index: -1;\n      flex: 1;\n      margin: 0 -", "px;\n      height: 16px;\n      width: 100%;\n      background: linear-gradient(\n        to right,\n        ", " 0,\n        ", " calc(100% / 2),\n        ", " calc(100% / 2),\n        ", " 100%\n      );\n      background-size: 200% 100%;\n      background-position: 100% bottom;\n      transition: background ", "ms ease-out ", "ms;\n    }\n\n    ",
    "\n  }\n\n  ",
    "\n"])), StepperIcon, DotSize / 2, function (props) { return props.theme.colors.purple400; }, function (props) { return props.theme.colors.purple400; }, function (props) { return props.theme.colors.grey200; }, function (props) { return props.theme.colors.grey200; }, animationSpeed, transitionSpeed, function (props) {
    return (props.active || props.status) &&
        "\n        &:before {\n            background-position: 0% bottom;\n        }\n    ";
}, function (props) {
    return props.noTransition &&
        "\n    &.active + & " + StepperIcon + " {\n        transition: none;\n    }\n    &:not(:first-child):before {\n    transition: none;\n    }\n  ";
});
var StepperList = styled.ul(templateObject_8$4 || (templateObject_8$4 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  list-style: none;\n  position: relative;\n  z-index: 1;\n\n  ", "\n\n  ", "\n"], ["\n  display: flex;\n  justify-content: space-between;\n  margin: 0;\n  padding: 0;\n  width: 100%;\n  list-style: none;\n  position: relative;\n  z-index: 1;\n\n  ",
    "\n\n  ",
    "\n"])), function (props) {
    return props.status === 'completed' && css(templateObject_7$4 || (templateObject_7$4 = __makeTemplateObject(["\n      ", " {\n        &:before {\n          background: linear-gradient(to right, ", " 0, ", " 100%);\n          transition: none;\n        }\n      }\n      ", " {\n        background-color: ", ";\n        transition: none;\n      }\n      ", " {\n        color: ", ";\n        font-weight: 600;\n      }\n    "], ["\n      ", " {\n        &:before {\n          background: linear-gradient(to right, ", " 0, ", " 100%);\n          transition: none;\n        }\n      }\n      ", " {\n        background-color: ", ";\n        transition: none;\n      }\n      ", " {\n        color: ", ";\n        font-weight: 600;\n      }\n    "])), Step, props.theme.colors.green400, props.theme.colors.green400, StepperIcon, props.theme.colors.green400, StepperTitle, props.theme.colors.green400);
}, function (props) {
    return props.size === 'small' &&
        "\n    " + StepperTitle + " {\n        font-size: " + props.theme.fontSizes[0] + ";\n        padding-top: " + props.theme.global.gutterSpace / 4 + "px;\n    }\n    \n    " + StepperDot + " {\n        width: " + DotSmallSize + "px;\n        height: " + DotSmallSize + "px;\n    }\n    \n    " + StepperIcon + " > span, " + StepperCount + " { display: none; }\n    " + StepperIcon + " {\n        svg { max-width: " + DotSmallSize / 2 + "px; max-height: " + DotSmallSize / 2 + "px; }\n    }\n    \n    " + Step + ":not(:first-child):before{\n        height: 6px;\n        margin: 0 -" + DotSmallSize / 2 + "px;\n    }\n    ";
});
var templateObject_1$7, templateObject_2$6, templateObject_3$6, templateObject_4$4, templateObject_5$4, templateObject_6$4, templateObject_7$4, templateObject_8$4;

var IconCheck = "<svg width=\"14\" height=\"11\" viewBox=\"0 0 14 11\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.3938 0.93934C13.9796 1.52513 13.9796 2.47487 13.3938 3.06066L6.0605 10.394C5.47471 10.9798 4.52496 10.9798 3.93918 10.394L0.605844 7.06066C0.0200573 6.47487 0.0200573 5.52513 0.605844 4.93934C1.19163 4.35355 2.14138 4.35355 2.72716 4.93934L4.99984 7.21201L11.2725 0.93934C11.8583 0.353553 12.808 0.353553 13.3938 0.93934Z\" fill=\"white\"/>\n</svg>";

var IconClose = "<svg width=\"14\" height=\"14\" viewBox=\"0 0 14 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M13.0607 3.06066C13.6464 2.47487 13.6464 1.52513 13.0607 0.93934C12.4749 0.353553 11.5251 0.353553 10.9393 0.93934L7 4.87868L3.06066 0.93934C2.47487 0.353553 1.52513 0.353553 0.93934 0.93934C0.353553 1.52513 0.353553 2.47487 0.93934 3.06066L4.87868 7L0.93934 10.9393C0.353553 11.5251 0.353553 12.4749 0.93934 13.0607C1.52513 13.6464 2.47487 13.6464 3.06066 13.0607L7 9.12132L10.9393 13.0607C11.5251 13.6464 12.4749 13.6464 13.0607 13.0607C13.6464 12.4749 13.6464 11.5251 13.0607 10.9393L9.12132 7L13.0607 3.06066Z\" fill=\"white\"/>\n</svg>";

var IconAngleRight = "<svg width=\"10\" height=\"14\" viewBox=\"0 0 10 14\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M8.77326 6.05335L3.11992 0.400013C2.99597 0.275042 2.84851 0.175849 2.68603 0.108157C2.52355 0.0404659 2.34927 0.00561523 2.17326 0.00561523C1.99724 0.00561523 1.82297 0.0404659 1.66049 0.108157C1.49801 0.175849 1.35054 0.275042 1.22659 0.400013C0.978256 0.64983 0.838867 0.987765 0.838867 1.34001C0.838867 1.69226 0.978256 2.0302 1.22659 2.28001L5.94659 7.00001L1.22659 11.72C0.978256 11.9698 0.838867 12.3078 0.838867 12.66C0.838867 13.0123 0.978256 13.3502 1.22659 13.6C1.35118 13.7236 1.49893 13.8214 1.66138 13.8877C1.82383 13.9541 1.99778 13.9877 2.17326 13.9867C2.34873 13.9877 2.52268 13.9541 2.68513 13.8877C2.84758 13.8214 2.99534 13.7236 3.11992 13.6L8.77326 7.94668C8.89823 7.82273 8.99742 7.67526 9.06511 7.51278C9.1328 7.3503 9.16765 7.17603 9.16765 7.00001C9.16765 6.824 9.1328 6.64972 9.06511 6.48724C8.99742 6.32476 8.89823 6.1773 8.77326 6.05335Z\" fill=\"white\"/>\n</svg>";

var Stepper = function (props, ref) {
    var steps = props.steps, size = props.size;
    var _a = useState([]), stepsData = _a[0], setStepsData = _a[1];
    var _b = useState('inProgress'), stepperStatus = _b[0], setStepperStatus = _b[1];
    var _c = useState(false), isClearing = _c[0], setIsClearing = _c[1];
    useEffect(function () {
        if (steps) {
            setStepsData(steps);
            var hasMoreThanOneActiveStep = steps.filter(function (step) { return step.current; }).length > 1;
            if (hasMoreThanOneActiveStep) {
                return setStepperStatus('malformed');
            }
            var allStepsAreDone = Object.values(steps).every(function (step) { return step.status === 'done'; });
            if (!isEmpty(steps) && allStepsAreDone) {
                setStepperStatus('completed');
            }
        }
    }, [steps]);
    var handleClearSteps = function () {
        setIsClearing(true);
        setStepsData(steps);
        setStepperStatus('inProgress');
        setTimeout(function () {
            setIsClearing(false);
        }, 350);
    };
    var handleLastStepAsDone = function (lastStepAsDone, nextStepIsLastOne, step) {
        if (lastStepAsDone && nextStepIsLastOne) {
            setTimeout(function () {
                setStepperStatus('completed');
            }, 550);
            return __assign$2(__assign$2({}, step), { current: true, status: 'done' });
        }
        return __assign$2(__assign$2({}, step), { current: true });
    };
    var handleNextStep = function (stepStatus, lastStepAsDone) {
        if (stepperStatus === 'completed') {
            return null;
        }
        window === null || window === void 0 ? void 0 : window.scrollTo(0, 0);
        var nextStepIndex;
        var numberOfSteps = stepsData.length;
        var updatedStepsData = stepsData.map(function (step, currentStepIndex) {
            if (step.current) {
                nextStepIndex = currentStepIndex + 1;
                if (nextStepIndex >= numberOfSteps) {
                    setStepperStatus('completed');
                }
                return __assign$2(__assign$2({}, step), { current: false, status: stepStatus });
            }
            if (currentStepIndex === nextStepIndex) {
                var nextStepIsLastOne = nextStepIndex === numberOfSteps - 1;
                return handleLastStepAsDone(lastStepAsDone, nextStepIsLastOne, step);
            }
            return step;
        });
        setStepsData(updatedStepsData);
    };
    var handlePrevStep = function () {
        if (stepperStatus === 'completed') {
            return null;
        }
        window === null || window === void 0 ? void 0 : window.scrollTo(0, 0);
        var prevStepIndex;
        var updatedStepsData = stepsData.map(function (step, currentStepIndex) {
            if (step.current) {
                if (currentStepIndex <= 0) {
                    return step;
                }
                prevStepIndex = currentStepIndex - 1;
                return __assign$2(__assign$2({}, step), { current: false, status: undefined });
            }
            return step;
        });
        updatedStepsData[prevStepIndex] = __assign$2(__assign$2({}, updatedStepsData[prevStepIndex]), { current: true, status: undefined });
        setStepsData(updatedStepsData);
    };
    useImperativeHandle(ref, function () { return ({
        nextStep: handleNextStep,
        prevStep: handlePrevStep,
        clearSteps: handleClearSteps,
    }); });
    if (stepperStatus === 'malformed') {
        return null;
    }
    return (React__default.createElement(StepperList, { status: stepperStatus, size: size }, stepsData.map(function (step, index) { return (React__default.createElement(Step, { active: step.current, noTransition: isClearing, status: step.status, key: "stepper-" + index, "data-testid": "stepper-step", className: step.current ? 'active' : '' },
        React__default.createElement(StepperDot, null,
            React__default.createElement(StepperIcon, { active: step.current, noTransition: isClearing, status: step.status },
                step.status === 'done' && React__default.createElement(SvgIcon, { src: IconCheck, width: 16, height: 13, fill: "white" }),
                step.status === 'fail' && React__default.createElement(SvgIcon, { src: IconClose, width: 16, height: 16, fill: "white" }),
                step.status === 'incomplete' && React__default.createElement(SvgIcon, { src: IconAngleRight, width: 16, height: 16, fill: "white" }),
                React__default.createElement("span", null, index + 1)),
            React__default.createElement(StepperCount, null, index + 1),
            React__default.createElement(StepperTitle, { active: step.current, status: step.status }, step.title)))); })));
};
var Stepper$1 = forwardRef(Stepper);

var useStyles = makeStyles(function () {
    return createStyles({
        popper: {
            zIndex: 4,
            boxShadow: theme.global.defaultShadow,
            borderRadius: theme.forms.borderRadius + "px",
            marginTop: theme.global.gutterSpace / 2 + "px",
        },
        dropdownList: {
            margin: 0,
            padding: "0 0 " + theme.global.gutterSpace / 2 + "px",
            width: '100%',
            backgroundColor: theme.colors.white,
            color: theme.colors.grey700,
            fontSize: theme.forms.defaultFontSize,
            border: "1px solid " + theme.colors.grey100,
            borderRadius: theme.forms.borderRadius + "px",
            listStyle: 'none',
            zIndex: 4,
        },
    });
});
var FilterContainer = styled.div(templateObject_1$6 || (templateObject_1$6 = __makeTemplateObject(["\n  position: relative;\n"], ["\n  position: relative;\n"])));
var InputField = styled.div(templateObject_3$5 || (templateObject_3$5 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: ", "px;\n  padding: ", ";\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", "px;\n  cursor: pointer;\n\n  ", "\n\n  ", "\n\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  height: ", "px;\n  padding: ",
    ";\n  background-color: ", ";\n  border: 1px solid ", ";\n  border-radius: ", "px;\n  cursor: pointer;\n\n  ",
    "\n\n  ",
    "\n\n  ",
    "\n"])), function (props) { return props.theme.forms.defaultHeight; }, function (props) {
    return props.theme.global.gutterSpace + "px " + props.theme.global.gutterSpace / 2 + "px " + props.theme.global.gutterSpace + "px " + props.theme.global.gutterSpace + "px";
}, function (props) { return props.theme.colors.white; }, function (props) { return props.theme.colors.grey400; }, function (props) { return props.theme.forms.borderRadius; }, function (props) {
    return props.isOpen &&
        "\n    outline: none;\n    border: 1px solid " + rgba(props.theme.colors.purple400, 0.6) + ";\n    box-shadow: 0px 0px 7px " + props.theme.colors.purple400 + ";\n  ";
}, function (props) {
    return props.isLoading &&
        "\n    cursor: progress;\n  ";
}, function (props) {
    return props.disabled && css(templateObject_2$5 || (templateObject_2$5 = __makeTemplateObject(["\n      background-color: ", ";\n      border: 1px solid ", ";\n      color: ", ";\n      cursor: not-allowed;\n    "], ["\n      background-color: ", ";\n      border: 1px solid ", ";\n      color: ", ";\n      cursor: not-allowed;\n    "])), props.theme.colors.grey200, props.theme.colors.grey200, props.theme.colors.grey700);
});
var InputValue = styled.span(templateObject_4$3 || (templateObject_4$3 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  font-size: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  font-size: ", ";\n"])), function (props) { return props.theme.forms.defaultFontSize; });
var CheckboxArea = styled.label(templateObject_5$3 || (templateObject_5$3 = __makeTemplateObject(["\n  cursor: pointer;\n"], ["\n  cursor: pointer;\n"])));
var Option = styled.li(templateObject_6$3 || (templateObject_6$3 = __makeTemplateObject(["\n  padding: ", ";\n"], ["\n  padding: ", ";\n"])), function (props) { return props.theme.global.gutterSpace / 2 + "px 0 " + props.theme.global.gutterSpace / 2 + "px " + props.theme.global.gutterSpace + "px"; });
var SearchField = styled.div(templateObject_7$3 || (templateObject_7$3 = __makeTemplateObject(["\n  padding: ", "px;\n"], ["\n  padding: ", "px;\n"])), function (props) { return props.theme.global.gutterSpace; });
var GroupOption = styled.li(templateObject_8$3 || (templateObject_8$3 = __makeTemplateObject(["\n  padding: ", ";\n"], ["\n  padding: ", ";\n"])), function (props) { return props.theme.global.gutterSpace + "px 0 " + props.theme.global.gutterSpace / 4 + "px " + props.theme.global.gutterSpace + "px"; });
var templateObject_1$6, templateObject_2$5, templateObject_3$5, templateObject_4$3, templateObject_5$3, templateObject_6$3, templateObject_7$3, templateObject_8$3;

var Filter = function (props) {
    var options = props.options, selects = props.selects, onSelect = props.onSelect, loading = props.loading, className = props.className, testId = props.testId, isText = props.isText, disabled = props.disabled, hasSearchInput = props.hasSearchInput, placeholder = props.placeholder, transactionScreen = props.transactionScreen, styleWidth = props.styleWidth, bankingAccount = props.bankingAccount, onlyTitle = props.onlyTitle;
    var _a = useState(null), anchorEl = _a[0], setAnchorEl = _a[1];
    var _b = useState(false), localLoading = _b[0]; _b[1];
    var _c = useState([]), newOptions = _c[0], setNewOptions = _c[1];
    var _d = useState(''), searchValue = _d[0], setSearchValue = _d[1];
    var isPopperOpen = Boolean(anchorEl);
    var handleClickAway = function () {
        if (anchorEl) {
            setAnchorEl(null);
        }
    };
    var classes = useStyles();
    var openPopper = function (event) {
        event.preventDefault();
        if (!loading && !disabled) {
            if (anchorEl) {
                return setAnchorEl(null);
            }
            setAnchorEl(event.currentTarget);
        }
    };
    var onSelectFilter = function (clickedField) { return function () {
        if (selects.includes(clickedField)) {
            var updatedList = selects.filter(function (selection) { return selection !== clickedField; });
            return onSelect(updatedList);
        }
        onSelect(__spreadArrays(selects, [clickedField]));
    }; };
    var searchString = function (data) {
        var findOnArrayOptions = options.filter(function (item) { return item.label.toLowerCase().includes(data.toLowerCase()); });
        setNewOptions(findOnArrayOptions);
    };
    var generateOptions = function (optionsToGenerate) {
        var optionsView = [];
        var currentGroup;
        for (var i = 0; i < optionsToGenerate.length; i += 1) {
            var option = optionsToGenerate[i];
            if (option.groupedBy !== currentGroup) {
                currentGroup = option.groupedBy;
                optionsView.push(React__default.createElement(GroupOption, { key: currentGroup }, currentGroup));
            }
            if (bankingAccount) {
                optionsView.push(React__default.createElement(Option, { key: option.value },
                    React__default.createElement(CheckboxArea, { htmlFor: "checkbox-" + option.value },
                        React__default.createElement(Checkbox, { id: "checkbox-" + option.value, onChange: onSelectFilter(option.value), defaultChecked: selects.includes(option.value), disabled: disabled, label: {
                                text: (React__default.createElement("div", { style: { display: 'flex', alignItems: 'center', gap: 8 } },
                                    React__default.createElement("div", { style: { borderRadius: 12 } },
                                        React__default.createElement(SvgIcon, { width: 24, height: 24, src: option.icon, fill: "grey700" })),
                                    React__default.createElement("div", { style: { display: 'flex', flexDirection: 'column' } },
                                        React__default.createElement("span", { style: { fontFamily: 'Inter', fontWeight: 500, color: 'rgba(58, 54, 61, 1)', fontSize: 14 } }, option.label),
                                        option.accountType !== 'Carteira/Caixa' && (React__default.createElement("span", { style: { fontFamily: 'Inter', fontSize: 12, color: theme.colors.grey700 } },
                                            "Ag\u00EAncia: ", option === null || option === void 0 ? void 0 :
                                            option.branch,
                                            "-", option === null || option === void 0 ? void 0 :
                                            option.branchCode,
                                            " \u2022 Conta: ", option === null || option === void 0 ? void 0 :
                                            option.accountNumber,
                                            "-", option === null || option === void 0 ? void 0 :
                                            option.accountCode))))),
                            } }))));
            }
            if (!bankingAccount) {
                optionsView.push(React__default.createElement(Option, { key: option.value },
                    React__default.createElement(CheckboxArea, { htmlFor: "checkbox-" + option.value },
                        React__default.createElement(Checkbox, { id: "checkbox-" + option.value, onChange: onSelectFilter(option.value), defaultChecked: selects.includes(option.value), disabled: disabled, label: {
                                text: (React__default.createElement(React__default.Fragment, null, isText ? (option.label) : (React__default.createElement(Tag, { size: "medium", type: option.colorType || 'default' }, option.label)))),
                            } }))));
            }
        }
        return optionsView;
    };
    useEffect(function () {
        searchString(searchValue);
    }, [searchValue]);
    useEffect(function () {
        var hasGroupedBy = options.find(function (a) { return a.groupedBy; });
        if (hasGroupedBy) {
            return setNewOptions(options.sort(function (a, b) { return (a.groupedBy || '').localeCompare(b.groupedBy); }));
        }
        setNewOptions(options);
    }, [options]);
    var titleSelect = function () {
        if (onlyTitle) {
            return placeholder;
        }
        if (transactionScreen) {
            return placeholder;
        }
        return selects.length > 1 ? 'Selecionados' : 'Selecionado';
    };
    var widthOptions = function () {
        if (styleWidth) {
            return styleWidth;
        }
        return anchorEl ? anchorEl.clientWidth : null;
    };
    return (React__default.createElement(FilterContainer, null,
        React__default.createElement(InputField, { onClick: openPopper, isOpen: isPopperOpen, disabled: disabled, isLoading: loading, className: className, "data-testid": testId },
            React__default.createElement(InputValue, null, selects.length > 0 ? (React__default.createElement(React__default.Fragment, null,
                !transactionScreen && (React__default.createElement(Box, { mr: 1 },
                    React__default.createElement(Badge, { type: "information" }, selects.length))),
                titleSelect(),
                transactionScreen && (React__default.createElement(Box, { mr: 1, ml: "4px" },
                    React__default.createElement(Badge, { type: "information" }, selects.length))))) : (placeholder || 'Todos')),
            loading ? (React__default.createElement(InputLoading, { size: 16, thickness: 2 })) : (React__default.createElement(ArrowButton, { testId: "datalist-arrow", size: "small", isOpen: isPopperOpen, iconPath: IconArrowDown$1, disabledBackgroundColor: true, backgroundColor: theme.colors.grey100, iconWidth: 10, iconHeight: 10, disabled: disabled }))),
        React__default.createElement(Popper$1, { className: classes.popper, open: isPopperOpen, anchorEl: anchorEl, placement: "bottom-start", style: { width: widthOptions(), maxHeight: 300, overflow: 'auto' }, disablePortal: true },
            React__default.createElement(ClickAwayListener$1, { onClickAway: handleClickAway },
                React__default.createElement("ul", { className: classes.dropdownList },
                    hasSearchInput && (React__default.createElement(SearchField, null,
                        React__default.createElement(Input$1, { name: "search", type: "text", loading: localLoading, autoComplete: "off", "data-testid": "droplist-input-search", startIcon: React__default.createElement(SvgIcon, { src: IconSearch, fill: "grey700", width: 24, height: 24 }), onChange: function (e) { return setSearchValue(e.currentTarget.value); }, autoFocus: true }))),
                    newOptions.length > 0 ? generateOptions(newOptions) : React__default.createElement(Option, null, "Nenhum filtro existente"))))));
};

var CustomMenu = function (props) {
    var items = props.items, selectedItem = props.selectedItem, onClick = props.onClick, newLayout2024 = props.newLayout2024;
    var hasOnlyOption = items.length === 1;
    var handleClick = function (item) { return function () {
        if (item.id !== selectedItem.id) {
            onClick(item);
        }
    }; };
    var Options = function () {
        return (React__default.createElement(React__default.Fragment, null, items.map(function (item) {
            return (React__default.createElement(MenuItemHeader, { newLayout2024: newLayout2024, selected: selectedItem.id === item.id, as: "span", key: item.id, onClick: handleClick(item), hasPaddingLeft: !(item === null || item === void 0 ? void 0 : item.icon) },
                (item === null || item === void 0 ? void 0 : item.icon) && React__default.createElement(MenuItemIcon, null, item.icon),
                React__default.createElement(Box, null,
                    React__default.createElement(MenuLabel, { newLayout2024: newLayout2024 }, item.label),
                    (item === null || item === void 0 ? void 0 : item.description) && (React__default.createElement(Box, { fontSize: 1, color: "grey700", mt: "4px" }, item === null || item === void 0 ? void 0 : item.description)))));
        })));
    };
    if (hasOnlyOption) {
        return (React__default.createElement(CustomButton, { type: "button", variant: "text", "$hasOnlyOption": hasOnlyOption },
            React__default.createElement(CompanyContainer, null,
                (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.icon) && React__default.createElement(MenuItemIcon, null, selectedItem.icon),
                React__default.createElement(Title$5, null, selectedItem.label))));
    }
    return (React__default.createElement(CustomMenu$1, { options: React__default.createElement(Options, null), placement: "bottom-start", newLayout2024: newLayout2024 },
        React__default.createElement(CustomButton, { type: "button", variant: "text", "$hasHover": items.length > 1 },
            React__default.createElement(CompanyContainer, null,
                (selectedItem === null || selectedItem === void 0 ? void 0 : selectedItem.icon) && React__default.createElement(MenuItemIcon, null, selectedItem.icon),
                React__default.createElement(Title$5, { newLayout2024: newLayout2024 }, selectedItem.label)),
            React__default.createElement(Arrow, { src: IconArrowDown, fill: newLayout2024 ? '#65606B' : 'grey400', height: 7, width: 11 }))));
};

var ErrorBoundary = /** @class */ (function (_super) {
    __extends$1(ErrorBoundary, _super);
    function ErrorBoundary(props) {
        var _this = _super.call(this, props) || this;
        _this.state = { hasError: false };
        return _this;
    }
    ErrorBoundary.getDerivedStateFromError = function () {
        return { hasError: true };
    };
    ErrorBoundary.prototype.componentDidCatch = function (error, errorInfo) {
        var onError = this.props.onError;
        if (onError) {
            onError(error, errorInfo);
        }
    };
    ErrorBoundary.prototype.render = function () {
        var hasError = this.state.hasError;
        var _a = this.props, callbackComponent = _a.callbackComponent, children = _a.children;
        if (hasError) {
            return callbackComponent || React__default.createElement("p", null, "Algo deu errado!");
        }
        return children;
    };
    return ErrorBoundary;
}(React__default.Component));

var WidgedProgressContainer = styled.div(templateObject_1$5 || (templateObject_1$5 = __makeTemplateObject(["\n  width: 100%;\n  padding: ", "px;\n  background-color: ", ";\n  border-radius: ", "px;\n"], ["\n  width: 100%;\n  padding: ", "px;\n  background-color: ", ";\n  border-radius: ", "px;\n"])), function (props) { return props.theme.global.gutterSpace * 1.5; }, function (props) { return props.theme.colors.white; }, function (props) { return props.theme.forms.borderRadius; });
var ProgressContainer = styled.div(templateObject_2$4 || (templateObject_2$4 = __makeTemplateObject(["\n  display: flex;\n"], ["\n  display: flex;\n"])));
var ProgressBar = styled.div(templateObject_3$4 || (templateObject_3$4 = __makeTemplateObject(["\n  width: 100%;\n  background-color: ", ";\n  border-radius: ", "px;\n"], ["\n  width: 100%;\n  background-color: ", ";\n  border-radius: ", "px;\n"])), function (props) { return props.theme.colors.grey200; }, function (props) { return props.theme.forms.borderRadius * 2; });
var Percent = styled.div(templateObject_5$2 || (templateObject_5$2 = __makeTemplateObject(["\n  height: 16px;\n  border-radius: ", "px;\n\n  ", "\n"], ["\n  height: 16px;\n  border-radius: ", "px;\n\n  ",
    "\n"])), function (props) { return props.theme.forms.borderRadius; }, function (props) {
    return props.loadingProgress > 0 && css(templateObject_4$2 || (templateObject_4$2 = __makeTemplateObject(["\n      transition: width 300ms linear;\n    "], ["\n      transition: width 300ms linear;\n    "])));
});
var PercentValue = styled.div(templateObject_6$2 || (templateObject_6$2 = __makeTemplateObject(["\n  margin-left: ", "px;\n  font-size: ", ";\n  color: ", ";\n  line-height: 14px;\n"], ["\n  margin-left: ", "px;\n  font-size: ", ";\n  color: ", ";\n  line-height: 14px;\n"])), function (props) { return props.theme.global.gutterSpace * 0.75; }, function (props) { return props.theme.fontSizes[1]; }, function (props) { return props.theme.colors.grey400; });
var StyleTitle = css(templateObject_7$2 || (templateObject_7$2 = __makeTemplateObject(["\n  color: ", ";\n  font-weight: 600;\n  line-height: 19px;\n"], ["\n  color: ", ";\n  font-weight: 600;\n  line-height: 19px;\n"])), function (props) { return props.theme.colors.grey900; });
var ProgressTitle = styled.h1(templateObject_8$2 || (templateObject_8$2 = __makeTemplateObject(["\n  font-size: ", ";\n  margin-bottom: ", "px;\n  ", "\n"], ["\n  font-size: ", ";\n  margin-bottom: ", "px;\n  ", "\n"])), function (props) { return props.theme.fontSizes[3]; }, function (props) { return props.theme.global.gutterSpace * 0.75; }, StyleTitle);
var ProgressDescription = styled.h3(templateObject_9$2 || (templateObject_9$2 = __makeTemplateObject(["\n  margin: ", "px 0 0 0;\n  font-size: ", ";\n  font-weight: 400;\n  color: ", ";\n  line-height: 14px;\n"], ["\n  margin: ", "px 0 0 0;\n  font-size: ", ";\n  font-weight: 400;\n  color: ", ";\n  line-height: 14px;\n"])), function (props) { return props.theme.global.gutterSpace / 2; }, function (props) { return props.theme.fontSizes[1]; }, function (props) { return props.theme.colors.grey700; });
var SetpContainer = styled.div(templateObject_10$1 || (templateObject_10$1 = __makeTemplateObject(["\n  margin-top: ", "px;\n"], ["\n  margin-top: ", "px;\n"])), function (props) { return props.theme.global.gutterSpace * 2; });
var StepTitle = styled.h1(templateObject_11$1 || (templateObject_11$1 = __makeTemplateObject(["\n  margin: 0;\n  font-size: ", ";\n  ", ";\n"], ["\n  margin: 0;\n  font-size: ", ";\n  ", ";\n"])), function (props) { return props.theme.fontSizes[2]; }, StyleTitle);
var StepUl = styled.ul(templateObject_12$1 || (templateObject_12$1 = __makeTemplateObject(["\n  margin: 0;\n  list-style-type: none;\n"], ["\n  margin: 0;\n  list-style-type: none;\n"])));
var StepLi = styled.li(templateObject_17 || (templateObject_17 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  margin-top: ", "px;\n  font-size: ", ";\n  color: ", ";\n  line-height: 17px;\n  font-weight: 400;\n  cursor: pointer;\n  transition: font-weight 200ms ease, color 200ms ease-in-out;\n\n  svg:first-child {\n    margin-right: ", "px;\n    line-height: 0;\n    transition: fill 200ms ease-in-out;\n  }\n\n  ", "\n\n  ", "\n\n  ", "\n\n    ", "\n"], ["\n  display: flex;\n  align-items: center;\n  margin-top: ", "px;\n  font-size: ", ";\n  color: ", ";\n  line-height: 17px;\n  font-weight: 400;\n  cursor: pointer;\n  transition: font-weight 200ms ease, color 200ms ease-in-out;\n\n  svg:first-child {\n    margin-right: ", "px;\n    line-height: 0;\n    transition: fill 200ms ease-in-out;\n  }\n\n  ",
    "\n\n  ",
    "\n\n  ",
    "\n\n    ",
    "\n"])), function (props) { return props.theme.global.gutterSpace * 0.75; }, function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.colors.grey900; }, function (props) { return props.theme.global.gutterSpace / 2; }, function (props) {
    return !props.disabled && css(templateObject_13 || (templateObject_13 = __makeTemplateObject(["\n      &:hover {\n        color: ", ";\n        svg:first-child {\n          fill: ", ";\n        }\n      }\n\n      &:active {\n        color: ", ";\n        svg:first-child {\n          fill: ", ";\n        }\n      }\n    "], ["\n      &:hover {\n        color: ", ";\n        svg:first-child {\n          fill: ", ";\n        }\n      }\n\n      &:active {\n        color: ", ";\n        svg:first-child {\n          fill: ", ";\n        }\n      }\n    "])), curriedLighten$1(0.2, props.theme.colors.grey900), curriedLighten$1(0.2, props.theme.colors[props.fill]), curriedDarken$1(0.1, props.theme.colors.grey900), curriedDarken$1(0.1, props.theme.colors[props.fill]));
}, function (props) {
    return props.isActive && css(templateObject_14 || (templateObject_14 = __makeTemplateObject(["\n      font-weight: 600;\n    "], ["\n      font-weight: 600;\n    "])));
}, function (props) {
    return props.isDone && css(templateObject_15 || (templateObject_15 = __makeTemplateObject(["\n      text-decoration: line-through;\n    "], ["\n      text-decoration: line-through;\n    "])));
}, function (props) {
    return props.disabled && css(templateObject_16 || (templateObject_16 = __makeTemplateObject(["\n      color: ", ";\n      cursor: not-allowed;\n    "], ["\n      color: ", ";\n      cursor: not-allowed;\n    "])), props.theme.colors.grey400);
});
var templateObject_1$5, templateObject_2$4, templateObject_3$4, templateObject_4$2, templateObject_5$2, templateObject_6$2, templateObject_7$2, templateObject_8$2, templateObject_9$2, templateObject_10$1, templateObject_11$1, templateObject_12$1, templateObject_13, templateObject_14, templateObject_15, templateObject_16, templateObject_17;

var PendingIcon = "<svg id=\"Layer_1\" data-name=\"Layer 1\" xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\"><path  d=\"M15.09814,12.63379,13,11.42285V7a1,1,0,0,0-2,0v5a.99985.99985,0,0,0,.5.86621l2.59814,1.5a1.00016,1.00016,0,1,0,1-1.73242ZM12,2A10,10,0,1,0,22,12,10.01114,10.01114,0,0,0,12,2Zm0,18a8,8,0,1,1,8-8A8.00917,8.00917,0,0,1,12,20Z\"/></svg>";

// @ts-ignore
var WidgetIcons = {
    done: { icon: DoneIcon, color: 'green700' },
    warning: { icon: WaningIcon$1, color: 'yellow700' },
    pending: { icon: PendingIcon, color: 'purple600' },
};

var WidgetProgress = function (props) {
    var className = props.className, testId = props.testId, onClickStep = props.onClickStep, steps = props.steps, idStepActive = props.idStepActive, progressTitle = props.progressTitle, progressDescription = props.progressDescription, stepsTitle = props.stepsTitle, hasPercent = props.hasPercent, enableNavigationWhenActive = props.enableNavigationWhenActive;
    var _a = useState(0), loadingProgress = _a[0], setLoadingProgress = _a[1];
    useEffect(function () {
        var stepLenght = steps.length;
        var stepsDoneLengh = steps.filter(function (step) { return step.status === 'done'; }).length;
        var percent = Number(((stepsDoneLengh * 100) / stepLenght).toFixed(0));
        setLoadingProgress(percent);
    }, [steps]);
    var handleClickStep = function (step, disabled) { return function () {
        if (onClickStep && !disabled && (enableNavigationWhenActive || step.id !== idStepActive)) {
            onClickStep(step);
        }
    }; };
    return (React__default.createElement(WidgedProgressContainer, { className: className, "data-testid": testId },
        React__default.createElement(ProgressTitle, null, progressTitle),
        React__default.createElement(ProgressContainer, null,
            React__default.createElement(ProgressBar, null,
                React__default.createElement(Percent, { style: { width: loadingProgress + "%" || '0%', backgroundColor: loadingProgress === 100 ? theme.colors.green700 : theme.colors.green400 }, loadingProgress: loadingProgress })),
            hasPercent && React__default.createElement(PercentValue, null,
                loadingProgress,
                "%")),
        React__default.createElement(ProgressDescription, null, progressDescription),
        React__default.createElement(SetpContainer, null,
            React__default.createElement(StepTitle, null, stepsTitle),
            React__default.createElement(StepUl, null, steps.map(function (step) { return (React__default.createElement(StepLi, { key: step.id, isActive: idStepActive === step.id, isDone: step.status === 'done', onClick: handleClickStep(step, step.disabled), disabled: step.disabled, fill: WidgetIcons[step.status || 'pending'].color },
                React__default.createElement(SvgIcon, { src: WidgetIcons[step.status || 'pending'].icon, fill: WidgetIcons[step.status || 'pending'].color, width: 20, height: 20 }),
                step.title)); })))));
};

var StyledSwipeableDrawer = styled(SwipeableDrawer$1)(templateObject_1$4 || (templateObject_1$4 = __makeTemplateObject(["\n  .MuiDrawer-paper {\n    top: 54px;\n    padding-top: ", "px;\n    border-top-left-radius: ", "px;\n    border-top-right-radius: ", "px;\n  }\n"], ["\n  .MuiDrawer-paper {\n    top: 54px;\n    padding-top: ", "px;\n    border-top-left-radius: ", "px;\n    border-top-right-radius: ", "px;\n  }\n"])), function (props) { return props.theme.global.gutterSpace; }, function (props) { return props.theme.forms.borderRadius * 2; }, function (props) { return props.theme.forms.borderRadius * 2; });
var ScrollableBar = styled.div(templateObject_2$3 || (templateObject_2$3 = __makeTemplateObject(["\n  ", " {\n    display: none;\n  }\n  width: 100px;\n  height: 4px;\n  border-radius: ", "px;\n  background-color: ", ";\n  margin: 0 auto;\n  cursor: pointer;\n"], ["\n  ", " {\n    display: none;\n  }\n  width: 100px;\n  height: 4px;\n  border-radius: ", "px;\n  background-color: ", ";\n  margin: 0 auto;\n  cursor: pointer;\n"])), device.desktop, function (props) { return props.theme.forms.borderRadius; }, function (props) { return props.theme.colors.grey400; });
var DrawerContent = styled.div(templateObject_3$3 || (templateObject_3$3 = __makeTemplateObject(["\n  margin-top: ", "px;\n  padding: 0 ", "px;\n  flex: 1;\n  overflow: auto;\n"], ["\n  margin-top: ", "px;\n  padding: 0 ", "px;\n  flex: 1;\n  overflow: auto;\n"])), function (props) { return props.theme.global.gutterSpace; }, function (props) { return props.theme.global.gutterSpace; });
var templateObject_1$4, templateObject_2$3, templateObject_3$3;

var SwipeableDrawer = function (props) {
    var isOpen = props.isOpen, onClose = props.onClose, onOpen = props.onOpen, children = props.children, testId = props.testId, className = props.className;
    var handleOpen = function () {
        if (onOpen) {
            onOpen();
        }
    };
    return (React__default.createElement(StyledSwipeableDrawer, { "data-testid": testId, className: className, anchor: "bottom", open: isOpen, onClose: onClose, onOpen: handleOpen },
        React__default.createElement(ScrollableBar, null),
        React__default.createElement(DrawerContent, null, children)));
};

var ModalBackdrop = styled.div(templateObject_1$3 || (templateObject_1$3 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  outline: none;\n  padding: ", "px 0;\n  width: 100%;\n  min-height: 100vh;\n  z-index: -1;\n"], ["\n  position: relative;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  outline: none;\n  padding: ", "px 0;\n  width: 100%;\n  min-height: 100vh;\n  z-index: -1;\n"])), function (props) { return props.theme.global.gutterSpace * 1.5; });
var StyledBackdrop = styled(Backdrop)(templateObject_2$2 || (templateObject_2$2 = __makeTemplateObject(["\n  &&.MuiBackdrop-root {\n    background-color: ", ";\n  }\n"], ["\n  &&.MuiBackdrop-root {\n    background-color: ", ";\n  }\n"])), function (props) { return rgba(props.theme.colors.grey700, 0.25); });
var ModalContainer = styled.section(templateObject_3$2 || (templateObject_3$2 = __makeTemplateObject(["\n  position: relative;\n  display: flex;\n  flex-flow: column;\n  margin: auto;\n  background: ", ";\n  border-radius: ", "px;\n  width: ", ";\n  max-width: 90vw;\n  animation: ", " 100ms linear forwards;\n  box-shadow: 0px 2px 6px ", ";\n  outline: none;\n  transition: width 100ms ease-out;\n  z-index: 2;\n\n  &:active {\n    outline: none;\n  }\n"], ["\n  position: relative;\n  display: flex;\n  flex-flow: column;\n  margin: auto;\n  background: ", ";\n  border-radius: ", "px;\n  width: ", ";\n  max-width: 90vw;\n  animation: ", " 100ms linear forwards;\n  box-shadow: 0px 2px 6px ", ";\n  outline: none;\n  transition: width 100ms ease-out;\n  z-index: 2;\n\n  &:active {\n    outline: none;\n  }\n"])), function (props) { return props.theme.colors.white; }, function (props) { return props.theme.forms.borderRadius * 2; }, function (props) { return props.theme.modal.size[props.size] + "px"; }, animaFadeScaleIn(0.95), function (props) { return rgba(props.theme.colors.grey400, 0.25); });
var CloseButton = styled(FabButton)(templateObject_4$1 || (templateObject_4$1 = __makeTemplateObject(["\n  z-index: 1;\n  border: 1px solid ", ";\n"], ["\n  z-index: 1;\n  border: 1px solid ", ";\n"])), function (props) { return props.theme.colors.grey200; });
var ModalHeader = styled.header(templateObject_6$1 || (templateObject_6$1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 32px 40px;\n  width: 100%;\n  height: 85px;\n\n  ", "\n"], ["\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 32px 40px;\n  width: 100%;\n  height: 85px;\n\n  ",
    "\n"])), function (props) {
    return props.hasHeaderLine && css(templateObject_5$1 || (templateObject_5$1 = __makeTemplateObject(["\n      padding: ", "px;\n      border-bottom: 1px solid ", ";\n\n      ", " {\n        top: ", "px;\n        right: ", "px;\n      }\n    "], ["\n      padding: ", "px;\n      border-bottom: 1px solid ", ";\n\n      ", " {\n        top: ", "px;\n        right: ", "px;\n      }\n    "])), props.theme.global.gutterSpace * 1.5, props.theme.colors.grey100, CloseButton, props.theme.global.gutterSpace, props.theme.global.gutterSpace);
});
var Title = styled.h1(templateObject_7$1 || (templateObject_7$1 = __makeTemplateObject(["\n  display: flex;\n  align-items: center;\n  margin-bottom: 0;\n  font-weight: 600;\n  font-size: ", ";\n  color: ", ";\n"], ["\n  display: flex;\n  align-items: center;\n  margin-bottom: 0;\n  font-weight: 600;\n  font-size: ", ";\n  color: ", ";\n"])), function (props) { return props.theme.fontSizes[4]; }, function (props) { return props.theme.colors.grey900; });
var ModalContent = styled.div(templateObject_8$1 || (templateObject_8$1 = __makeTemplateObject(["\n  min-height: 336.5px;\n  opacity: 1;\n  transition: opacity 100ms linear;\n  background: ", ";\n  border-radius: 0 0 16px 16px;\n  ", ";\n"], ["\n  min-height: 336.5px;\n  opacity: 1;\n  transition: opacity 100ms linear;\n  background: ", ";\n  border-radius: 0 0 16px 16px;\n  ",
    ";\n"])), function (props) { return props.theme.colors.grey900; }, function (props) {
    return props.sizeIsChanging &&
        "\n    width: " + props.theme.modal.size[props.size] + "px;\n    max-width: 90vw;\n    transition: opacity 0ms linear;\n    opacity: 0;\n  ";
});
styled(Fade)(templateObject_9$1 || (templateObject_9$1 = __makeTemplateObject(["\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n"], ["\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n"])));
var Video = styled.video(templateObject_10 || (templateObject_10 = __makeTemplateObject(["\n  margin-bottom: -4px;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  box-shadow: none;\n  border-radius: 0 0 ", "px ", "px;\n"], ["\n  margin-bottom: -4px;\n  width: 100%;\n  height: 100%;\n  overflow: auto;\n  box-shadow: none;\n  border-radius: 0 0 ", "px ", "px;\n"])), function (props) { return props.theme.forms.borderRadius * 2; }, function (props) { return props.theme.forms.borderRadius * 2; });
var PlayButton = styled.div(templateObject_11 || (templateObject_11 = __makeTemplateObject(["\n  min-height: 336.5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  svg {\n    cursor: pointer;\n    transition: filter 0.2s ease-in-out;\n    &:hover {\n      filter: brightness(0.85);\n    }\n  }\n"], ["\n  min-height: 336.5px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n\n  svg {\n    cursor: pointer;\n    transition: filter 0.2s ease-in-out;\n    &:hover {\n      filter: brightness(0.85);\n    }\n  }\n"])));
var ModalSubTitle = styled.p(templateObject_12 || (templateObject_12 = __makeTemplateObject(["\n  padding: 0 40px;\n  padding-bottom: 8px;\n  font-size: 1.6rem;\n  color: ", ";\n"], ["\n  padding: 0 40px;\n  padding-bottom: 8px;\n  font-size: 1.6rem;\n  color: ", ";\n"])), function (props) { return props.theme.colors.grey700; });
var templateObject_1$3, templateObject_2$2, templateObject_3$2, templateObject_4$1, templateObject_5$1, templateObject_6$1, templateObject_7$1, templateObject_8$1, templateObject_9$1, templateObject_10, templateObject_11, templateObject_12;

var PlatButton = "<svg width=\"40\" height=\"44\" viewBox=\"0 0 40 44\" fill=\"none\" xmlns=\"http://www.w3.org/2000/svg\">\n<path d=\"M35.805 14.7498L12.46 1.36151C11.1968 0.632058 9.76302 0.249931 8.30431 0.253937C6.8456 0.257944 5.41394 0.647941 4.15474 1.38432C2.89553 2.12069 1.85365 3.17721 1.13491 4.44657C0.416175 5.71592 0.0461875 7.15288 0.0625306 8.61151V35.4848C0.0625306 37.6768 0.933305 39.7791 2.48329 41.3291C4.03328 42.8791 6.13552 43.7498 8.32753 43.7498C9.77859 43.7474 11.2036 43.364 12.46 42.6382L35.805 29.2498C37.0594 28.5238 38.1009 27.4808 38.8249 26.2252C39.5489 24.9697 39.93 23.5458 39.93 22.0965C39.93 20.6472 39.5489 19.2233 38.8249 17.9678C38.1009 16.7122 37.0594 15.6692 35.805 14.9432V14.7498ZM33.3884 24.8757L10.0434 38.4573C9.52012 38.7539 8.92896 38.9097 8.32753 38.9097C7.7261 38.9097 7.13494 38.7539 6.6117 38.4573C6.08993 38.1561 5.65667 37.7228 5.35547 37.201C5.05428 36.6792 4.89576 36.0873 4.89586 35.4848V8.51484C4.89576 7.91236 5.05428 7.32046 5.35547 6.79867C5.65667 6.27688 6.08993 5.84358 6.6117 5.54234C7.13709 5.2503 7.7265 5.09257 8.32753 5.08317C8.92815 5.0955 9.51686 5.25304 10.0434 5.54234L33.3884 19.0273C33.9103 19.3285 34.3438 19.7617 34.6452 20.2835C34.9465 20.8053 35.1052 21.3973 35.1052 21.9998C35.1052 22.6024 34.9465 23.1944 34.6452 23.7162C34.3438 24.238 33.9103 24.6712 33.3884 24.9723V24.8757Z\" fill=\"#F7F6F8\"/>\n</svg>";

/* eslint-disable jsx-a11y/media-has-caption */
var VideoModal = function (props) {
    var isOpen = props.isOpen, onClose = props.onClose, disableBackdropClick = props.disableBackdropClick, className = props.className, loading = props.loading, size = props.size, containerClassName = props.containerClassName, hasHeaderLine = props.hasHeaderLine, title = props.title, noCloseButton = props.noCloseButton, videoPath = props.videoPath, subtitle = props.subtitle;
    var titleAsString = typeof title === 'string';
    var _a = useState(false), sizeIsChanging = _a[0], setSizeIsChanging = _a[1];
    var _b = useState(false), isPlaying = _b[0], setIsPlaying = _b[1];
    var prevSizeRed = useRef();
    var handleClose = function () {
        if (!loading) {
            onClose();
        }
    };
    var handleBackdrop = function () {
        if (!disableBackdropClick) {
            handleClose();
        }
    };
    var handlePlayVideo = function () {
        setIsPlaying(!isPlaying);
    };
    useEffect(function () {
        if (prevSizeRed.current && size) {
            setSizeIsChanging(true);
            setTimeout(function () {
                setSizeIsChanging(false);
            }, 200);
        }
        prevSizeRed.current = size;
    }, [size]);
    return (React__default.createElement(MaterialModal, { className: className, open: isOpen, onClose: handleClose, closeAfterTransition: true, disableBackdropClick: disableBackdropClick, BackdropComponent: StyledBackdrop, BackdropProps: {
            timeout: 500,
        } },
        React__default.createElement(ModalBackdrop, { onClick: handleBackdrop },
            React__default.createElement(ModalContainer, { size: size || 'medium', onClick: function (e) {
                    if (!disableBackdropClick) {
                        e.stopPropagation();
                    }
                }, className: containerClassName },
                (title || !noCloseButton) && (React__default.createElement(React__default.Fragment, null,
                    React__default.createElement(ModalHeader, { hasHeaderLine: hasHeaderLine },
                        titleAsString ? React__default.createElement(Title, null, title) : title,
                        !noCloseButton && React__default.createElement(CloseButton, { disabledBackgroundColor: true, onClick: handleClose, iconPath: IconClose$1, disabled: loading })),
                    subtitle && React__default.createElement(ModalSubTitle, null, subtitle))),
                React__default.createElement(ModalContent, { sizeIsChanging: sizeIsChanging, size: size || 'medium' }, isPlaying ? (React__default.createElement(Video, { controls: true, src: videoPath, autoPlay: true, disablePictureInPicture: true, controlsList: "nodownload" })) : (React__default.createElement(PlayButton, { onClick: handlePlayVideo },
                    React__default.createElement(SvgIcon, { src: PlatButton, width: 40, height: 40 }))))))));
};

var StyledSection = styled.section(templateObject_1$2 || (templateObject_1$2 = __makeTemplateObject(["\n  width: 100%;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: ", ";\n  border-radius: ", "px;\n  ", "\n\n  ", " {\n    padding: ", ";\n  }\n"], ["\n  width: 100%;\n  position: relative;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  background-color: ", ";\n  border-radius: ", "px;\n  ",
    "\n\n  ", " {\n    padding: ", ";\n  }\n"])), function (props) { return props.theme.colors.white; }, function (props) { return props.theme.forms.borderRadius; }, function (props) {
    return !props.noGutter &&
        "\n    padding: " + props.theme.space[3] + "px;\n  ";
}, device.mobile, function (props) { return (props.noMobilePadding ? 0 : props.theme.space[2] + "px"); });
var templateObject_1$2;

var ErrorPageSection = styled(StyledSection)(templateObject_1$1 || (templateObject_1$1 = __makeTemplateObject(["\n  padding: ", ";\n  max-width: 920px;\n\n  ", " {\n    padding: ", ";\n    text-align: center;\n  }\n"], ["\n  padding: ", ";\n  max-width: 920px;\n\n  ", " {\n    padding: ", ";\n    text-align: center;\n  }\n"])), function (props) { return props.theme.space[5] + "px"; }, device.mobile, function (props) { return props.theme.space[2] + "px " + props.theme.space[3] + "px"; });
var Description404 = styled.div(templateObject_2$1 || (templateObject_2$1 = __makeTemplateObject(["\n  order: 1;\n\n  ", " {\n    order: 2;\n  }\n"], ["\n  order: 1;\n\n  ", " {\n    order: 2;\n  }\n"])), device.mobile);
var H1$1 = styled.h1(templateObject_3$1 || (templateObject_3$1 = __makeTemplateObject(["\n  font-size: 7.2rem;\n  line-height: 1;\n  color: ", ";\n  margin: 0;\n\n  ", " {\n    font-size: 5rem;\n  }\n"], ["\n  font-size: 7.2rem;\n  line-height: 1;\n  color: ", ";\n  margin: 0;\n\n  ", " {\n    font-size: 5rem;\n  }\n"])), function (props) { return props.theme.colors.purple600; }, device.mobile);
var H2$1 = styled.h2(templateObject_4 || (templateObject_4 = __makeTemplateObject(["\n  font-size: ", ";\n  line-height: 32px;\n  color: ", ";\n  font-weight: normal;\n  margin-bottom: ", "px;\n"], ["\n  font-size: ", ";\n  line-height: 32px;\n  color: ", ";\n  font-weight: normal;\n  margin-bottom: ", "px;\n"])), function (props) { return props.theme.fontSizes[4]; }, function (props) { return props.theme.colors.grey700; }, function (props) { return props.theme.global.gutterSpace * 1.5; });
styled.ul(templateObject_6 || (templateObject_6 = __makeTemplateObject(["\n  padding-left: 1rem;\n  font-size: ", ";\n  line-height: 25px;\n  color: ", ";\n\n  ", "\n\n  a {\n    font-size: ", ";\n    color: ", ";\n\n    &:hover {\n      color: ", ";\n      text-decoration: underline;\n    }\n  }\n"], ["\n  padding-left: 1rem;\n  font-size: ", ";\n  line-height: 25px;\n  color: ", ";\n\n  ",
    "\n\n  a {\n    font-size: ", ";\n    color: ", ";\n\n    &:hover {\n      color: ", ";\n      text-decoration: underline;\n    }\n  }\n"])), function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.colors.purple600; }, function (props) {
    return props.color && css(templateObject_5 || (templateObject_5 = __makeTemplateObject(["\n      color: ", ";\n    "], ["\n      color: ", ";\n    "])), props.color);
}, function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.colors.purple600; }, function (props) { return props.theme.colors.purple900; });
var P = styled.p(templateObject_7 || (templateObject_7 = __makeTemplateObject(["\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: 1.3;\n  color: ", ";\n  margin: 0 0 ", ";\n"], ["\n  font-weight: ", ";\n  font-size: ", ";\n  line-height: 1.3;\n  color: ", ";\n  margin: 0 0 ", ";\n"])), function (props) { return (props.fontWeight ? props.fontWeight : 'normal'); }, function (props) { return props.theme.fontSizes[2]; }, function (props) { return props.theme.colors.grey700; }, function (props) { return props.theme.global.gutterSpace + "px"; });
var DetectiveContainer = styled.div(templateObject_8 || (templateObject_8 = __makeTemplateObject(["\n  width: 100%;\n  max-width: 400px;\n  order: 2;\n\n  svg {\n    width: 100%;\n    height: auto;\n  }\n\n  ", " {\n    order: 1;\n    padding: ", ";\n    margin: 0 auto;\n    max-width: 250px;\n  }\n"], ["\n  width: 100%;\n  max-width: 400px;\n  order: 2;\n\n  svg {\n    width: 100%;\n    height: auto;\n  }\n\n  ", " {\n    order: 1;\n    padding: ", ";\n    margin: 0 auto;\n    max-width: 250px;\n  }\n"])), device.mobile, function (props) { return props.theme.global.gutterSpace + "px"; });
var ButtonsContainer = styled.div(templateObject_9 || (templateObject_9 = __makeTemplateObject(["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n\n  ", " {\n    align-items: center;\n  }\n"], ["\n  display: flex;\n  flex-direction: column;\n  align-items: flex-start;\n\n  ", " {\n    align-items: center;\n  }\n"])), device.mobile);
var templateObject_1$1, templateObject_2$1, templateObject_3$1, templateObject_4, templateObject_5, templateObject_6, templateObject_7, templateObject_8, templateObject_9;

var ErrorPage = function () { return (React__default.createElement(Box, { display: "flex", justifyContent: "center", alignItems: "center", width: "100%", minHeight: "100vh" },
    React__default.createElement(ErrorPageSection, null,
        React__default.createElement(Box, { display: "flex", flexDirection: ['column', 'row'], width: "100%" },
            React__default.createElement(Description404, null,
                React__default.createElement(H1$1, null, "Vixe..."),
                React__default.createElement(H2$1, null, "Parece que algo deu errado"),
                React__default.createElement(P, null, "Ocorreu um erro na aplica\u00E7\u00E3o, mas n\u00E3o se preocupe: nossa equipe j\u00E1 foi notificada e iremos resolver o mais r\u00E1pido poss\u00EDvel"),
                React__default.createElement(P, null, "Por favor, tente novamente ou volte para o dashboard"),
                React__default.createElement(ButtonsContainer, null,
                    React__default.createElement(Box, { mt: 3, mb: 2 },
                        React__default.createElement(Button$1, { onClick: function () { return document.location.reload(); }, type: "button" }, "Tentar novamente")),
                    React__default.createElement(Button$1, { onClick: function () {
                            document.location.href = '/';
                        }, type: "button", color: "secondary" }, "Voltar para o dashboard"))),
            React__default.createElement(DetectiveContainer, null,
                React__default.createElement(SvgIcon, { src: process.env.APP_PATH + "public/assets/icons/error-page-log.svg" })))))); };

var HeaderContent = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-flow: row wrap;\n  margin-top: ", "px;\n  margin-bottom: ", "px;\n\n  ", " {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    margin-top: 0;\n  }\n"], ["\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  flex-flow: row wrap;\n  margin-top: ", "px;\n  margin-bottom: ", "px;\n\n  ", " {\n    display: flex;\n    flex-direction: column;\n    align-items: flex-start;\n    margin-top: 0;\n  }\n"])), function (props) { return props.theme.global.gutterSpace; }, function (props) { return props.theme.global.gutterSpace * 0.75; }, device.mobile);
var H1 = styled.h1(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  font-size: 2.8rem;\n  line-height: 1;\n  font-weight: 800;\n  color: ", ";\n  display: flex;\n  align-items: center;\n  margin: 0;\n  min-height: ", "px;\n\n  ", " {\n    font-size: ", ";\n  }\n"], ["\n  font-size: 2.8rem;\n  line-height: 1;\n  font-weight: 800;\n  color: ", ";\n  display: flex;\n  align-items: center;\n  margin: 0;\n  min-height: ", "px;\n\n  ", " {\n    font-size: ", ";\n  }\n"])), function (props) { return props.theme.colors.grey900; }, function (props) { return props.theme.forms.defaultHeight; }, device.mobile, function (props) { return props.theme.fontSizes[5]; });
var H2 = styled.h2(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: ", "px 0 0 ", "px;\n  font-size: ", ";\n  font-weight: normal;\n  color: ", ";\n"], ["\n  margin: ", "px 0 0 ", "px;\n  font-size: ", ";\n  font-weight: normal;\n  color: ", ";\n"])), function (props) { return props.theme.global.gutterSpace / 2; }, function (props) { return props.theme.global.gutterSpace / 2; }, function (props) { return props.theme.fontSizes[3]; }, function (props) { return props.theme.colors.grey900; });
var templateObject_1, templateObject_2, templateObject_3;

var SectionHeader = function (props) {
    var title = props.title, description = props.description, inlineContent = props.inlineContent, icon = props.icon, iconColor = props.iconColor;
    return (React__default.createElement("header", null,
        React__default.createElement(HeaderContent, null,
            React__default.createElement(Box, { display: "flex", alignItems: "center" },
                typeof icon === 'string' ? (React__default.createElement(Box, { display: "flex", marginRight: 1 },
                    React__default.createElement(SvgIcon, { src: icon, width: 32, height: 32, fill: iconColor }))) : (icon),
                React__default.createElement(H1, null, title),
                description && React__default.createElement(H2, null, description)),
            inlineContent)));
};

export { Accordion, ActionsDropdown, Alert, CustomAvatar as Avatar, Badge, BasicLoading, Box, Button$1 as Button, Card, Checkbox, Col, Container$4 as Container, CustomMenu, DataList$1 as DataList, Datepicker$1 as DatePicker, DragAndDrop, Drawer, DrawerContainer, DrawerContent$1 as DrawerContent, DropList$1 as DropList, Error$1 as Error, ErrorBoundary, ErrorPage, FabButton, Field, Filter, FloatingMenu, Header, InlineAlert, InlineDialog, Input$1 as Input, InputFile, InputMask$1 as InputMask, Loading, Menu, MenuApps, MenuDropdown, Modal, MonthNavigation, Pagination, Radio$1 as Radio, RadioGroup, Row, SectionHeader, Select, SentryErrorBoundaryHandle, SentryInit, Skeleton, Slider$1 as Slider, Stepper$1 as Stepper, StyledHelperInput, StyledIconInputContainer, StyledLabel, StyledLabelContainer, StyledMenuItem$1 as StyledMenuItem, ReadOnlyValue as StyledReadOnlyValue, SvgIcon, SwipeableDrawer, Switch$1 as Switch, TBody, THead, TabLabel, TabPanel, Table, SimpleTabs as Tabs, Tag, Td, Textarea$1 as Textarea, Th, AgilizeTooltip as Tooltip, Tr, VendorStyles, VideoModal, WidgetProgress, YearNavigation, apiSentryError, theme, useFilter };
//# sourceMappingURL=index.es.js.map
